import { defineComponent as X, openBlock as k, createElementBlock as T, renderSlot as te, withAsyncContext as _l, ref as ae, onMounted as Dt, watch as Ie, normalizeClass as B, createElementVNode as E, createCommentVNode as V, nextTick as Vr, withKeys as Yn, toDisplayString as z, createVNode as A, unref as v, withCtx as N, createBlock as q, resolveDynamicComponent as qe, computed as Z, createTextVNode as W, Fragment as ce, renderList as $e, useCssVars as x4, resolveDirective as Yt, withDirectives as nt, mergeProps as Te, mergeModels as Ae, useModel as je, reactive as Qd, isRef as rs, shallowRef as _i, onBeforeUnmount as Mi, normalizeStyle as mt, onDeactivated as w4, useAttrs as $l, useId as Ai, withModifiers as Ht, vModelCheckbox as k4, Teleport as e1, Transition as $i, vShow as xl, normalizeProps as Fr, resolveComponent as C4, useSlots as R2, createSlots as vs, onBeforeMount as S4, useTemplateRef as so, watchEffect as t1, toRefs as wl, inject as zt, provide as sd, toHandlers as oo, guardReactiveProps as Yi, onUnmounted as P2, h as Ao, getCurrentInstance as E4, markRaw as T4, customRef as O4, vModelText as I2 } from "vue";
import * as M4 from "@cfgtech/icons";
import { ChevronDownIcon as xi, InfoCircleIcon as od, CheckCircleIcon as A4, DangerTriangleFillIcon as B2, ErrorOctagonIcon as N4, ChevronLeftIcon as ao, ChevronRightIcon as mn, LeftArrowIcon as D4, RightArrowIcon as L4, TickIcon as Ut, HomeIcon as R4, QuestionCircleIcon as Ps, CheckmarkIcon as n1, SearchIcon as P4, DangerTriangleIcon as I4, CalendarIcon as r1, TicketIcon as z2, WalletMoneyIcon as V2, UserGroupIcon as B4, ArrowLeftIcon as z4, MoreDotsIcon as V4, LockIcon as F4, BrifecaseTickIcon as j4, Bag2Icon as H4, HouseIcon as U4, SecurityUserIcon as W4, BuildingsIcon as q4, DocumentIcon as K4, GlobeIcon as G4, SaleIcon as Y4, House2Icon as J4, HeartIcon as Z4, PersonalcardIcon as X4, ChartBarsIcon as Q4, TasksIcon as e9, ShieldDoneIcon as t9, Buildings2Icon as n9, WalletCheckIcon as r9, RibbonIcon as i9, TickCircleIcon as F2, ChartSuccessIcon as s9, EyeIcon as j2, QuestionIcon as o9, MoneySendIcon as H2, CalendarTickIcon as a9 } from "@cfgtech/icons";
import { templateRef as Ca, watchDebounced as U2, useArrayMap as lo, useFocus as _s, unrefElement as l9, tryOnScopeDispose as u9, useEventListener as ad, useTextareaAutosize as d9, useElementSize as i1, onClickOutside as W2, useElementBounding as uo, useMouseInElement as V0, computedAsync as c9, useResizeObserver as f9, asyncComputed as p9, useTemplateRefsList as h9, computedEager as m9, useWindowSize as g9 } from "@vueuse/core";
import { translations as ld, asyncArrayFilter as b9, BankCodes as ru, bankTranslations as y9, validators as v9, getBirthDateFromBirthNumber as _9, useMoneyFormat as Ho, roundToNearest as $9 } from "@cfgtech/helpers";
import co from "dayjs";
import { ProgressRoot as x9, ProgressIndicator as w9, PinInputRoot as k9, PinInputInput as C9, PopoverRoot as S9, PopoverTrigger as E9, PopoverPortal as T9, PopoverContent as O9, TabsTrigger as M9, TabsContent as A9, TabsRoot as N9, TabsList as D9, TabsIndicator as L9, SliderRoot as R9, SliderTrack as P9, SliderRange as I9, SliderThumb as B9 } from "reka-ui";
import { useFloating as s1, autoUpdate as o1, flip as q2, shift as K2, offset as G2, autoPlacement as Y2 } from "@floating-ui/vue";
import { cloneDeep as Ji, isEqual as fr, pick as pr, isUndefined as ud, isEmpty as is, pickBy as z9, omit as kl } from "lodash-es";
import { SwitchGroup as V9, Switch as F9, SwitchLabel as j9, SwitchDescription as H9, TransitionRoot as a1, Dialog as l1, TransitionChild as ss, DialogPanel as u1, DialogTitle as U9, DialogDescription as W9, Listbox as q9, ListboxButton as K9, ListboxOptions as G9, ListboxOption as Y9 } from "@headlessui/vue";
import { createFocusTrap as J9 } from "focus-trap";
const wM = /* @__PURE__ */ X({
  __name: "CfgAccordion",
  props: {
    opened: {}
  },
  emits: ["update:opened"],
  setup(n, { emit: e }) {
    const t = n, r = e;
    function i(s) {
      r("update:opened", s !== t.opened ? s : -1);
    }
    return (s, o) => (k(), T("ul", null, [
      te(s.$slots, "default", {
        activeIdx: s.opened,
        on: { "click:header": i }
      })
    ]));
  }
}), J2 = /* @__PURE__ */ X({
  __name: "CfgCollapsable",
  props: {
    closedHeight: {
      type: Number,
      default: 0
    },
    opened: {
      type: Boolean,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:opened", "update:content-overflowed"],
  async setup(n, { emit: e }) {
    let t, r;
    const i = n, s = e, { default: o } = ([t, r] = _l(() => import("gsap")), t = await t, r(), t), a = Ca("contentController"), l = Ca("contentWrapper"), u = ae(i.opened), d = ae(i.opened ?? !0);
    Dt(() => {
      i.opened || p();
    }), U2([d, () => i.disabled], () => p(), {
      debounce: 50
    }), Ie(
      () => i.opened,
      (h) => {
        d.value = h ?? !1;
      }
    ), Ie(
      () => d.value,
      () => {
        d.value !== i.opened && s("update:opened", d.value);
      }
    );
    const c = ae(!1), f = ae([]);
    async function p(h = !0) {
      if (!l.value)
        return;
      if (c.value) {
        f.value.push(() => p(h));
        return;
      }
      await (async () => {
        c.value = !0;
        const m = d.value && !i.disabled, $ = h ? 0.4 : 0;
        l.value && (l.value.style.overflow = "hidden"), await Vr(async () => {
          m && (o.set(l.value, { height: 0 }), await Vr(() => {
            u.value = !0;
          })), await Vr(() => new Promise((w) => {
            o.to(l.value, {
              duration: m ? $ * 1.3 : $ * 0.7,
              ease: "expo.inOut",
              autoAlpha: m ? 1 : 0
            }), o.to(l.value, {
              duration: $,
              ease: "expo.inOut",
              height: m ? "auto" : 0,
              onComplete() {
                l.value && (l.value.style.overflow = "initial"), m || (u.value = !1), c.value = !1, w(!0);
              }
            });
          }));
        });
      })();
      const g = f.value;
      f.value = [];
      for await (const m of g)
        await m();
    }
    return (h, y) => (k(), T("div", {
      class: B(["collapsable_wrapper transform-all relative duration-300", {
        closed: !d.value && !n.disabled
      }])
    }, [
      E("div", {
        ref_key: "contentWrapper",
        ref: l,
        class: "relative"
      }, [
        E("div", {
          ref_key: "contentController",
          ref: a
        }, [
          u.value ? te(h.$slots, "default", { key: 0 }) : V("", !0)
        ], 512)
      ], 512)
    ], 2));
  }
}), Z9 = {
  key: 0,
  class: "shrink grow text-md font-highlighted"
}, kM = /* @__PURE__ */ X({
  __name: "CfgAccordionItem",
  props: {
    opened: { type: Boolean },
    headerText: { default: "" },
    index: {},
    headClass: { default: "" },
    bodyClass: { default: "" }
  },
  emits: ["click:header"],
  setup(n, { emit: e }) {
    const t = n, r = e;
    function i() {
      r("click:header", t.index);
    }
    return (s, o) => (k(), T("li", null, [
      te(s.$slots, "static"),
      E("header", {
        class: B(["flex cursor-pointer justify-between py-3", {
          "text-brand": s.opened,
          "text-dark-200": !s.opened,
          [s.headClass]: s.headClass
        }]),
        onClick: i,
        onKeydown: Yn(i, ["enter"])
      }, [
        te(s.$slots, "head", {}, () => [
          s.headerText ? (k(), T("span", Z9, z(s.headerText), 1)) : V("", !0)
        ]),
        E("span", {
          class: B(["shrink-0 transition-all duration-300", { "rotate-180": s.opened }])
        }, [
          A(v(xi))
        ], 2)
      ], 34),
      E("main", {
        class: B({ [s.bodyClass]: s.bodyClass })
      }, [
        A(J2, {
          "closed-height": 0,
          opened: s.opened
        }, {
          default: N(() => [
            te(s.$slots, "default")
          ]),
          _: 3
        }, 8, ["opened"])
      ], 2)
    ]));
  }
});
var Pt = /* @__PURE__ */ ((n) => (n.brand = "brand", n.success = "success", n.warning = "warning", n.info = "info", n.error = "error", n))(Pt || {}), G = /* @__PURE__ */ ((n) => (n.h1 = "h1", n.h2 = "h2", n.h3 = "h3", n.h4 = "h4", n.h5 = "h5", n.h6 = "h6", n.subtitle = "subtitle", n.md = "md", n.sm = "sm", n.xs = "xs", n["h1-large"] = "h1-large", n.label = "label", n.xl = "xl", n.lg = "lg", n.perex = "perex", n.small = "small", n.micro = "micro", n))(G || {});
const X9 = ["innerHTML"], Q9 = /* @__PURE__ */ X({
  __name: "CfgTypography",
  props: {
    size: {
      type: String,
      default: G.md
    },
    tagName: {
      type: String,
      default: "span"
    },
    html: {
      type: String,
      default: ""
    }
  },
  setup(n) {
    return (e, t) => e.$slots.default ? (k(), q(qe(n.tagName), {
      key: 0,
      class: B(["heading", {
        [`heading-${n.size}`]: !!n.size
      }])
    }, {
      default: N(() => [
        te(e.$slots, "default", {}, () => [
          n.html ? (k(), T("span", {
            key: 0,
            innerHTML: n.html
          }, null, 8, X9)) : V("", !0)
        ], !0)
      ]),
      _: 3
    }, 8, ["class"])) : n.html ? (k(), q(qe(n.tagName), {
      key: 1,
      class: B(["heading", {
        [`heading-${n.size}`]: !!n.size
      }]),
      innerHTML: n.html
    }, null, 8, ["class", "innerHTML"])) : V("", !0);
  }
}), Bn = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [r, i] of e)
    t[r] = i;
  return t;
}, K = /* @__PURE__ */ Bn(Q9, [["__scopeId", "data-v-78af6141"]]), e5 = { class: "flex gap-x-3" }, t5 = { class: "space-y-1" }, CM = /* @__PURE__ */ X({
  __name: "CfgAlert",
  props: {
    variant: {
      type: String,
      default: Pt.info
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    }
  },
  setup(n) {
    const e = n, t = Z(() => {
      if (e.variant === Pt.info)
        return od;
      if (e.variant === Pt.success)
        return A4;
      if (e.variant === Pt.warning)
        return B2;
      if (e.variant === Pt.error)
        return N4;
    });
    return (r, i) => (k(), T("div", {
      class: B(["mb-4 rounded-md px-3 py-4 text-black md:px-4", {
        "bg-brand/20": n.variant === v(Pt).brand,
        "bg-blue/20": n.variant === v(Pt).info,
        "bg-success-light": n.variant === v(Pt).success,
        "bg-warning-light": n.variant === v(Pt).warning,
        "bg-red-light": n.variant === v(Pt).error
      }])
    }, [
      E("div", e5, [
        t.value || r.$slots.icon ? (k(), T("div", {
          key: 0,
          class: B(["w-6 flex-none [&>*]:text-[24px]", {
            "text-brand": n.variant === v(Pt).brand,
            "text-blue": n.variant === v(Pt).info,
            "text-success": n.variant === v(Pt).success,
            "text-warning": n.variant === v(Pt).warning,
            "text-red": n.variant === v(Pt).error
          }])
        }, [
          te(r.$slots, "icon", {}, () => [
            (k(), q(qe(t.value), { "aria-hidden": "true" }))
          ])
        ], 2)) : V("", !0),
        E("div", t5, [
          n.title ? (k(), q(K, {
            key: 0,
            class: "text-start !font-highlighted",
            size: v(G).md,
            "tag-name": "h3"
          }, {
            default: N(() => [
              W(z(n.title), 1)
            ]),
            _: 1
          }, 8, ["size"])) : V("", !0),
          A(K, {
            size: v(G).md,
            "tag-name": "p"
          }, {
            default: N(() => [
              te(r.$slots, "text", {}, () => [
                W(z(n.text), 1)
              ])
            ]),
            _: 3
          }, 8, ["size"])
        ])
      ])
    ], 2));
  }
}), n5 = {}, r5 = { class: "lds-ring" };
function i5(n, e) {
  return k(), T("span", r5, [
    (k(), T(ce, null, $e(4, (t) => E("span", { key: t })), 64))
  ]);
}
const No = /* @__PURE__ */ Bn(n5, [["render", i5]]), Tt = {
  primary: "primary",
  primaryLight: "primary-light",
  secondary: "secondary",
  successLight: "success-light",
  success: "success",
  grey: "grey",
  light: "light",
  orangeLight: "orange-light",
  orange: "orange",
  dark: "dark",
  danger: "danger",
  dangerLight: "danger-light",
  black: "black",
  stroke: "stroke",
  white: "white"
}, s5 = { class: "relative block" }, o5 = {
  key: 0,
  class: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
}, hr = /* @__PURE__ */ X({
  __name: "CfgButton",
  props: {
    variant: { default: Tt.primary },
    label: { default: "" },
    flat: { type: Boolean },
    text: { type: Boolean },
    loading: { type: Boolean },
    small: { type: Boolean },
    stroke: { type: Boolean },
    as: { default: "button" },
    iconPlacement: { default: "right" },
    disabledClasses: {},
    rippleScale: { type: Boolean }
  },
  setup(n) {
    x4((o) => ({
      "5cf2609a": s.value.y,
      "5cf26099": s.value.x
    }));
    const e = n, t = Z(() => ({
      [Tt.primary]: {
        DEFAULT: "text-white bg-brand border-brand",
        stroke: "border-brand text-brand",
        text: "text-brand"
      },
      "primary-inverted": {
        DEFAULT: "text-brand bg-white border-white",
        stroke: "border-white text-white",
        text: "text-white"
      },
      [Tt.primaryLight]: {
        DEFAULT: "text-brand bg-brand-opacity border-brand-opacity",
        stroke: "border-brand-opacity text-brand-opacity",
        text: "text-brand-opacity"
      },
      [Tt.secondary]: {
        DEFAULT: "text-white bg-secondary border-secondary",
        stroke: "border-secondary text-secondary",
        text: "text-secondary"
      },
      [Tt.grey]: {
        DEFAULT: "text-white bg-grey-300 border-grey-300",
        stroke: "border-grey-300 text-grey-300",
        text: "text-grey-300"
      },
      [Tt.dark]: {
        DEFAULT: "text-white bg-secondary-dark border-secondary-dark",
        stroke: "border-secondary-dark text-secondary-dark",
        text: "text-secondary-dark"
      },
      [Tt.light]: {
        DEFAULT: "text-secondary-dark bg-grey-100 border-grey-100",
        stroke: "border-grey-100 text-grey-100",
        text: "text text-grey-100"
      },
      [Tt.orange]: {
        DEFAULT: "text-white bg-orange border-orange",
        stroke: "border-orange text-orange",
        text: "text-orange"
      },
      [Tt.orangeLight]: {
        DEFAULT: "text-orange bg-orange-light border-orange",
        stroke: "border-orange-light text-orange-light",
        text: "text-orange-light"
      },
      [Tt.danger]: {
        DEFAULT: "text-red-light bg-red border-red",
        stroke: "border-red text-red",
        text: "text-red"
      },
      [Tt.dangerLight]: {
        DEFAULT: "text-red bg-red-light border-red-light",
        stroke: "border-red-light text-red-light",
        text: "text-red-light"
      },
      [Tt.success]: {
        DEFAULT: "text-success-light bg-success border-success",
        stroke: "border-success text-success",
        text: "text-success"
      },
      [Tt.successLight]: {
        DEFAULT: "text-success bg-success-light border-success-light",
        stroke: "border-success-light text-success-light",
        text: "text-success-light"
      },
      [Tt.black]: {
        DEFAULT: "text-white bg-black border-black",
        stroke: "border-black text-black",
        text: "text-black"
      },
      [Tt.stroke]: {
        DEFAULT: "text-grey-100 bg-black border-grey-100",
        stroke: "border-grey-100 text-black",
        text: "text-black"
      },
      [Tt.white]: {
        DEFAULT: "text-black bg-white border-black",
        stroke: "border-white text-white",
        text: "text-white"
      }
    })), r = Z(() => {
      if (e.text && e.stroke)
        throw new Error("CfgButton cannot have both text and stroke properties");
      return e.stroke ? "stroke" : e.text ? "text" : "DEFAULT";
    }), i = Z(() => {
      const o = e.variant || Tt.primary;
      return t.value[o][r.value];
    }), s = Z(() => r.value === "text" ? { y: "0.4em", x: "1em" } : { y: "1.2em", x: "1.8em" });
    return (o, a) => {
      const l = Yt("ripple");
      return nt((k(), q(qe(o.as), Te({
        ...o.as === "button" && !o.$attrs.type ? { type: "button" } : {}
      }, {
        class: ["button focusable inline-block px-0 font-display font-highlighted", {
          [`button-variant__${o.variant}`]: !0,
          "button-flat": o.flat,
          "button-small": o.small,
          "button-text": o.text,
          "opacity-60": o.$attrs.disabled && !o.disabledClasses,
          [o.disabledClasses]: o.$attrs.disabled && o.disabledClasses,
          "cursor-not-allowed": o.$attrs.disabled,
          "button-stroke": o.stroke,
          [i.value]: !0
        }],
        disabled: o.$attrs.disabled || o.loading
      }), {
        default: N(() => [
          E("span", s5, [
            E("span", {
              class: B(["flex items-center justify-center", {
                "opacity-0": o.loading,
                "gap-x-3": !o.small,
                "gap-x-2": o.small
              }])
            }, [
              o.label || o.$slots.default ? (k(), T("span", {
                key: 0,
                class: B(["button_label block text-center first-letter:uppercase", { "order-2": o.iconPlacement === "left" }])
              }, [
                te(o.$slots, "default", {}, () => [
                  W(z(o.label), 1)
                ])
              ], 2)) : V("", !0),
              o.$slots.icon ? (k(), T("span", {
                key: 1,
                class: B({ "order-1": o.iconPlacement === "left" })
              }, [
                te(o.$slots, "icon")
              ], 2)) : V("", !0)
            ], 2),
            o.loading ? (k(), T("span", o5, [
              A(No, {
                class: B({
                  "text-[7px]": !o.small,
                  "text-[5px]": o.small
                })
              }, null, 8, ["class"])
            ])) : V("", !0)
          ])
        ]),
        _: 3
      }, 16, ["class", "disabled"])), [
        [l, { scale: o.rippleScale ? { x: 1.03, y: 1.09 } : {} }]
      ]);
    };
  }
});
var Z2 = 60, X2 = Z2 * 60, Q2 = X2 * 24, a5 = Q2 * 7, as = 1e3, iu = Z2 * as, F0 = X2 * as, l5 = Q2 * as, u5 = a5 * as, d1 = "millisecond", Hi = "second", Ui = "minute", Wi = "hour", Tr = "day", pa = "week", Nn = "month", ep = "quarter", Or = "year", qi = "date", d5 = "YYYY-MM-DDTHH:mm:ssZ", j0 = "Invalid Date", c5 = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, f5 = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
const p5 = {
  name: "en",
  weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
  months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
  ordinal: function(e) {
    var t = ["th", "st", "nd", "rd"], r = e % 100;
    return "[" + e + (t[(r - 20) % 10] || t[r] || t[0]) + "]";
  }
};
var dd = function(e, t, r) {
  var i = String(e);
  return !i || i.length >= t ? e : "" + Array(t + 1 - i.length).join(r) + e;
}, h5 = function(e) {
  var t = -e.utcOffset(), r = Math.abs(t), i = Math.floor(r / 60), s = r % 60;
  return (t <= 0 ? "+" : "-") + dd(i, 2, "0") + ":" + dd(s, 2, "0");
}, m5 = function n(e, t) {
  if (e.date() < t.date()) return -n(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), i = e.clone().add(r, Nn), s = t - i < 0, o = e.clone().add(r + (s ? -1 : 1), Nn);
  return +(-(r + (t - i) / (s ? i - o : o - i)) || 0);
}, g5 = function(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}, b5 = function(e) {
  var t = {
    M: Nn,
    y: Or,
    w: pa,
    d: Tr,
    D: qi,
    h: Wi,
    m: Ui,
    s: Hi,
    ms: d1,
    Q: ep
  };
  return t[e] || String(e || "").toLowerCase().replace(/s$/, "");
}, y5 = function(e) {
  return e === void 0;
};
const v5 = {
  s: dd,
  z: h5,
  m: m5,
  a: g5,
  p: b5,
  u: y5
};
var Us = "en", ci = {};
ci[Us] = p5;
var tp = "$isDayjsObject", c1 = function(e) {
  return e instanceof Cl || !!(e && e[tp]);
}, Sa = function n(e, t, r) {
  var i;
  if (!e) return Us;
  if (typeof e == "string") {
    var s = e.toLowerCase();
    ci[s] && (i = s), t && (ci[s] = t, i = s);
    var o = e.split("-");
    if (!i && o.length > 1)
      return n(o[0]);
  } else {
    var a = e.name;
    ci[a] = e, i = a;
  }
  return !r && i && (Us = i), i || !r && Us;
}, Ke = function(e, t) {
  if (c1(e))
    return e.clone();
  var r = typeof t == "object" ? t : {};
  return r.date = e, r.args = arguments, new Cl(r);
}, _5 = function(e, t) {
  return Ke(e, {
    locale: t.$L,
    utc: t.$u,
    x: t.$x,
    $offset: t.$offset
    // todo: refactor; do not use this.$offset in you code
  });
}, Ue = v5;
Ue.l = Sa;
Ue.i = c1;
Ue.w = _5;
var $5 = function(e) {
  var t = e.date, r = e.utc;
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  if (Ue.u(t)) return /* @__PURE__ */ new Date();
  if (t instanceof Date) return new Date(t);
  if (typeof t == "string" && !/Z$/i.test(t)) {
    var i = t.match(c5);
    if (i) {
      var s = i[2] - 1 || 0, o = (i[7] || "0").substring(0, 3);
      return r ? new Date(Date.UTC(i[1], s, i[3] || 1, i[4] || 0, i[5] || 0, i[6] || 0, o)) : new Date(i[1], s, i[3] || 1, i[4] || 0, i[5] || 0, i[6] || 0, o);
    }
  }
  return new Date(t);
}, Cl = /* @__PURE__ */ function() {
  function n(t) {
    this.$L = Sa(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[tp] = !0;
  }
  var e = n.prototype;
  return e.parse = function(r) {
    this.$d = $5(r), this.init();
  }, e.init = function() {
    var r = this.$d;
    this.$y = r.getFullYear(), this.$M = r.getMonth(), this.$D = r.getDate(), this.$W = r.getDay(), this.$H = r.getHours(), this.$m = r.getMinutes(), this.$s = r.getSeconds(), this.$ms = r.getMilliseconds();
  }, e.$utils = function() {
    return Ue;
  }, e.isValid = function() {
    return this.$d.toString() !== j0;
  }, e.isSame = function(r, i) {
    var s = Ke(r);
    return this.startOf(i) <= s && s <= this.endOf(i);
  }, e.isAfter = function(r, i) {
    return Ke(r) < this.startOf(i);
  }, e.isBefore = function(r, i) {
    return this.endOf(i) < Ke(r);
  }, e.$g = function(r, i, s) {
    return Ue.u(r) ? this[i] : this.set(s, r);
  }, e.unix = function() {
    return Math.floor(this.valueOf() / 1e3);
  }, e.valueOf = function() {
    return this.$d.getTime();
  }, e.startOf = function(r, i) {
    var s = this, o = Ue.u(i) ? !0 : i, a = Ue.p(r), l = function(m, $) {
      var w = Ue.w(s.$u ? Date.UTC(s.$y, $, m) : new Date(s.$y, $, m), s);
      return o ? w : w.endOf(Tr);
    }, u = function(m, $) {
      var w = [0, 0, 0, 0], _ = [23, 59, 59, 999];
      return Ue.w(s.toDate()[m].apply(
        // eslint-disable-line prefer-spread
        s.toDate("s"),
        (o ? w : _).slice($)
      ), s);
    }, d = this.$W, c = this.$M, f = this.$D, p = "set" + (this.$u ? "UTC" : "");
    switch (a) {
      case Or:
        return o ? l(1, 0) : l(31, 11);
      case Nn:
        return o ? l(1, c) : l(0, c + 1);
      case pa: {
        var h = this.$locale().weekStart || 0, y = (d < h ? d + 7 : d) - h;
        return l(o ? f - y : f + (6 - y), c);
      }
      case Tr:
      case qi:
        return u(p + "Hours", 0);
      case Wi:
        return u(p + "Minutes", 1);
      case Ui:
        return u(p + "Seconds", 2);
      case Hi:
        return u(p + "Milliseconds", 3);
      default:
        return this.clone();
    }
  }, e.endOf = function(r) {
    return this.startOf(r, !1);
  }, e.$set = function(r, i) {
    var s, o = Ue.p(r), a = "set" + (this.$u ? "UTC" : ""), l = (s = {}, s[Tr] = a + "Date", s[qi] = a + "Date", s[Nn] = a + "Month", s[Or] = a + "FullYear", s[Wi] = a + "Hours", s[Ui] = a + "Minutes", s[Hi] = a + "Seconds", s[d1] = a + "Milliseconds", s)[o], u = o === Tr ? this.$D + (i - this.$W) : i;
    if (o === Nn || o === Or) {
      var d = this.clone().set(qi, 1);
      d.$d[l](u), d.init(), this.$d = d.set(qi, Math.min(this.$D, d.daysInMonth())).$d;
    } else l && this.$d[l](u);
    return this.init(), this;
  }, e.set = function(r, i) {
    return this.clone().$set(r, i);
  }, e.get = function(r) {
    return this[Ue.p(r)]();
  }, e.add = function(r, i) {
    var s = this, o;
    r = Number(r);
    var a = Ue.p(i), l = function(f) {
      var p = Ke(s);
      return Ue.w(p.date(p.date() + Math.round(f * r)), s);
    };
    if (a === Nn)
      return this.set(Nn, this.$M + r);
    if (a === Or)
      return this.set(Or, this.$y + r);
    if (a === Tr)
      return l(1);
    if (a === pa)
      return l(7);
    var u = (o = {}, o[Ui] = iu, o[Wi] = F0, o[Hi] = as, o)[a] || 1, d = this.$d.getTime() + r * u;
    return Ue.w(d, this);
  }, e.subtract = function(r, i) {
    return this.add(r * -1, i);
  }, e.format = function(r) {
    var i = this, s = this.$locale();
    if (!this.isValid()) return s.invalidDate || j0;
    var o = r || d5, a = Ue.z(this), l = this.$H, u = this.$m, d = this.$M, c = s.weekdays, f = s.months, p = s.meridiem, h = function(w, _, L, S) {
      return w && (w[_] || w(i, o)) || L[_].slice(0, S);
    }, y = function(w) {
      return Ue.s(l % 12 || 12, w, "0");
    }, g = p || function($, w, _) {
      var L = $ < 12 ? "AM" : "PM";
      return _ ? L.toLowerCase() : L;
    }, m = function(w) {
      switch (w) {
        case "YY":
          return String(i.$y).slice(-2);
        case "YYYY":
          return Ue.s(i.$y, 4, "0");
        case "M":
          return d + 1;
        case "MM":
          return Ue.s(d + 1, 2, "0");
        case "MMM":
          return h(s.monthsShort, d, f, 3);
        case "MMMM":
          return h(f, d);
        case "D":
          return i.$D;
        case "DD":
          return Ue.s(i.$D, 2, "0");
        case "d":
          return String(i.$W);
        case "dd":
          return h(s.weekdaysMin, i.$W, c, 2);
        case "ddd":
          return h(s.weekdaysShort, i.$W, c, 3);
        case "dddd":
          return c[i.$W];
        case "H":
          return String(l);
        case "HH":
          return Ue.s(l, 2, "0");
        case "h":
          return y(1);
        case "hh":
          return y(2);
        case "a":
          return g(l, u, !0);
        case "A":
          return g(l, u, !1);
        case "m":
          return String(u);
        case "mm":
          return Ue.s(u, 2, "0");
        case "s":
          return String(i.$s);
        case "ss":
          return Ue.s(i.$s, 2, "0");
        case "SSS":
          return Ue.s(i.$ms, 3, "0");
        case "Z":
          return a;
      }
      return null;
    };
    return o.replace(f5, function($, w) {
      return w || m($) || a.replace(":", "");
    });
  }, e.utcOffset = function() {
    return -Math.round(this.$d.getTimezoneOffset() / 15) * 15;
  }, e.diff = function(r, i, s) {
    var o = this, a = Ue.p(i), l = Ke(r), u = (l.utcOffset() - this.utcOffset()) * iu, d = this - l, c = function() {
      return Ue.m(o, l);
    }, f;
    switch (a) {
      case Or:
        f = c() / 12;
        break;
      case Nn:
        f = c();
        break;
      case ep:
        f = c() / 3;
        break;
      case pa:
        f = (d - u) / u5;
        break;
      case Tr:
        f = (d - u) / l5;
        break;
      case Wi:
        f = d / F0;
        break;
      case Ui:
        f = d / iu;
        break;
      case Hi:
        f = d / as;
        break;
      default:
        f = d;
        break;
    }
    return s ? f : Ue.a(f);
  }, e.daysInMonth = function() {
    return this.endOf(Nn).$D;
  }, e.$locale = function() {
    return ci[this.$L];
  }, e.locale = function(r, i) {
    if (!r) return this.$L;
    var s = this.clone(), o = Sa(r, i, !0);
    return o && (s.$L = o), s;
  }, e.clone = function() {
    return Ue.w(this.$d, this);
  }, e.toDate = function() {
    return new Date(this.valueOf());
  }, e.toJSON = function() {
    return this.isValid() ? this.toISOString() : null;
  }, e.toISOString = function() {
    return this.$d.toISOString();
  }, e.toString = function() {
    return this.$d.toUTCString();
  }, n;
}(), np = Cl.prototype;
Ke.prototype = np;
[["$ms", d1], ["$s", Hi], ["$m", Ui], ["$H", Wi], ["$W", Tr], ["$M", Nn], ["$y", Or], ["$D", qi]].forEach(function(n) {
  np[n[1]] = function(e) {
    return this.$g(e, n[0], n[1]);
  };
});
Ke.extend = function(n, e) {
  return n.$i || (n(e, Cl, Ke), n.$i = !0), Ke;
};
Ke.locale = Sa;
Ke.isDayjs = c1;
Ke.unix = function(n) {
  return Ke(n * 1e3);
};
Ke.en = ci[Us];
Ke.Ls = ci;
Ke.p = {};
const ha = 7, x5 = 5;
function w5(n) {
  const e = new Date(n.getFullYear(), n.getMonth() + 1, 0), t = Array.from({ length: e.getDate() }, (s, o) => o + 1).map((s) => su(new Date(
    Date.UTC(n.getFullYear(), n.getMonth(), s)
  )));
  if (t[0].dayOfWeek !== 1) {
    const s = new Date(n.getFullYear(), n.getMonth(), 0), o = new Date(s.getFullYear(), s.getMonth() + 1, 0).getDate(), a = t[0].dayOfWeek - 1, l = [];
    let u = 0;
    for (; u < a; )
      l.unshift(
        su(
          new Date(s.getFullYear(), s.getMonth(), o - u),
          { isPast: !0 }
        )
      ), u++;
    t.unshift(...l);
  }
  if (t[t.length - 1].dayOfWeek !== 7) {
    const s = new Date(n.getFullYear(), n.getMonth() + 1, 1), o = ha * x5 + 1 - t.length;
    let a = 0;
    for (; a < o; )
      t.push(
        su(
          new Date(s.getFullYear(), s.getMonth(), a + 1),
          { isFuture: !0 }
        )
      ), a++;
  }
  const r = Array.from({ length: 6 }, (s, o) => o + 1).map((s) => t.slice((s - 1) * ha, s * ha)), i = r[r.length - 1];
  return (!i.length || i.every((s) => s.inNextMonth)) && r.pop(), r;
}
function su(n, e) {
  const t = /* @__PURE__ */ new Date(), r = n.getDay();
  return {
    day: n.getDate(),
    date: n.toISOString(),
    isToday: n.getDate() === t.getDate() && n.getMonth() === t.getMonth() && n.getFullYear() === t.getFullYear(),
    isWeekend: [6, 7].includes(n.getDay()),
    dayOfWeek: r === 0 ? ha : r,
    inPastMonth: e == null ? void 0 : e.isPast,
    inNextMonth: e == null ? void 0 : e.isFuture
  };
}
const rp = {
  disabledDates: {
    type: Array,
    default: () => []
  },
  minDate: {
    type: Date,
    default: null
  },
  maxDate: {
    type: Date,
    default: null
  },
  format: {
    type: String,
    default: "D. M. YYYY"
  }
}, k5 = { class: "mb-5" }, C5 = { class: "flex items-center justify-center gap-x-10 pb-5" }, S5 = ["disabled"], E5 = ["disabled"], T5 = {
  key: 0,
  class: "absolute left-0 top-10 z-10 size-full overflow-auto bg-white pb-10"
}, O5 = { class: "grid max-h-full grid-cols-3 gap-3" }, M5 = ["onClick"], A5 = { key: 1 }, N5 = { class: "grid auto-rows-fr grid-cols-3 gap-3 pb-10" }, D5 = ["disabled", "onClick"], L5 = /* @__PURE__ */ X({
  __name: "CfgMonthAndYearSelection",
  props: /* @__PURE__ */ Ae({
    minDate: {
      type: Date,
      default: () => new Date(1900, 0, 1)
    },
    maxDate: {
      type: Date,
      default: () => new Date((/* @__PURE__ */ new Date()).getFullYear() + 10, 0, 1)
    },
    openWindow: {
      type: String,
      default: "month"
    }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["close"], ["update:modelValue"]),
  setup(n, { emit: e }) {
    const t = n, r = e, i = [...ld.localeObjectCs.months], s = Z(() => {
      const w = [];
      for (let _ = new Date(t.minDate).getFullYear(); _ <= new Date(t.maxDate).getFullYear(); _ += 1)
        w.push(_);
      return w.sort((_, L) => L - _);
    }), o = je(n, "modelValue"), a = ae(o.value.year), l = ae(t.openWindow === "year"), u = lo(i, (w, _) => {
      const L = co(
        new Date(a.value, _, 1)
      );
      return {
        month: w,
        number: _,
        isSelected: _ === o.value.month,
        disabled: L.isBefore(t.minDate, "month") || L.isAfter(t.maxDate, "month")
      };
    }), d = lo(s, (w) => ({
      year: w,
      isSelected: w === a.value
    })), c = ae([]), f = Z(() => a.value > new Date(t.minDate).getFullYear()), p = Z(() => a.value < new Date(t.maxDate).getFullYear());
    Ie(() => t.modelValue, (w) => {
      a.value = w.year;
    }), Ie(() => t.openWindow, () => {
      l.value = t.openWindow === "year";
    }), Ie(l, (w) => {
      w && Vr(() => {
        var _, L;
        (L = (_ = c.value) == null ? void 0 : _[s.value.findIndex((S) => S === a.value)]) == null || L.focus();
      });
    });
    function h() {
      a.value += 1;
    }
    function y() {
      a.value -= 1;
    }
    function g(w) {
      o.value = {
        month: w,
        year: a.value
      };
    }
    function m(w) {
      a.value = w, l.value = !1;
    }
    function $() {
      l.value ? l.value = !1 : r("close");
    }
    return (w, _) => (k(), T("div", null, [
      E("div", k5, [
        A(v(hr), {
          "aria-label": l.value ? "Měsíc" : "Zavřít",
          class: "mb-5",
          "icon-placement": "left",
          text: "",
          onClick: $
        }, {
          icon: N(() => [
            A(v(ao), { class: "text-sm" })
          ]),
          default: N(() => [
            A(v(K), {
              size: v(G).sm
            }, {
              default: N(() => [
                W(z(l.value ? "Měsíc" : "Zpět"), 1)
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          _: 1
        }, 8, ["aria-label"])
      ]),
      E("div", C5, [
        E("button", {
          class: "focusable rounded-md border border-grey-stroke p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !f.value,
          type: "button",
          onClick: y
        }, [
          A(v(ao))
        ], 8, S5),
        A(v(K), {
          class: "flex min-w-[140px] shrink-0 grow justify-center text-center",
          size: v(G).sm
        }, {
          default: N(() => [
            E("button", {
              class: "flex items-center justify-center gap-x-2 capitalize lg:transition lg:duration-200 lg:hover:text-brand",
              type: "button",
              onClick: _[0] || (_[0] = (L) => l.value = !0)
            }, [
              E("span", null, z(a.value), 1),
              A(v(xi), { class: "text-[0.85em] text-grey-300" })
            ])
          ]),
          _: 1
        }, 8, ["size"]),
        E("button", {
          class: "focusable rounded-md border border-grey-stroke p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !p.value,
          type: "button",
          onClick: h
        }, [
          A(v(mn))
        ], 8, E5)
      ]),
      l.value ? (k(), T("div", T5, [
        E("ul", O5, [
          (k(!0), T(ce, null, $e(v(d), ({ year: L, isSelected: S }) => (k(), T("li", { key: L }, [
            E("button", {
              ref_for: !0,
              ref_key: "yearsButtonRefs",
              ref: c,
              class: B(["flex w-full flex-1 items-center justify-center rounded-xl border border-grey-stroke p-3 lg:transition lg:duration-200 lg:hover:border-brand", {
                "border-brand text-brand": S
              }]),
              type: "button",
              onClick: (R) => m(L)
            }, [
              A(v(K), {
                class: "capitalize",
                size: v(G).sm
              }, {
                default: N(() => [
                  W(z(L), 1)
                ]),
                _: 2
              }, 1032, ["size"])
            ], 10, M5)
          ]))), 128))
        ])
      ])) : (k(), T("div", A5, [
        E("ul", N5, [
          (k(!0), T(ce, null, $e(v(u), ({
            month: L,
            number: S,
            isSelected: R,
            disabled: O
          }) => (k(), T("li", {
            key: L,
            class: "col-span-1 flex"
          }, [
            E("button", {
              class: B(["focusable flex w-full flex-1 items-center justify-center rounded-xl border border-grey-stroke p-3 disabled:cursor-not-allowed disabled:line-through disabled:opacity-50 lg:transition lg:duration-200 lg:hover:border-brand", {
                "border-brand text-brand": R
              }]),
              disabled: O,
              type: "button",
              onClick: (I) => g(S)
            }, [
              A(v(K), {
                class: "capitalize",
                size: v(G).sm
              }, {
                default: N(() => [
                  W(z(L), 1)
                ]),
                _: 2
              }, 1032, ["size"])
            ], 10, D5)
          ]))), 128))
        ])
      ]))
    ]));
  }
}), R5 = { class: "relative" }, P5 = {
  key: 0,
  class: "absolute left-0 top-0 z-20 flex size-full bg-white"
}, I5 = { class: "flex items-center justify-center gap-x-5 px-1 pb-7" }, B5 = ["disabled"], z5 = {
  key: 1,
  class: "grid grid-cols-7"
}, V5 = { class: "mt-3 grid grid-cols-7" }, F5 = ["aria-label", "data-selected", "disabled", "onClick"], j5 = { class: "cfg-day-item__content" }, H5 = { class: "block w-full" }, U5 = /* @__PURE__ */ X({
  __name: "CfgCalendar",
  props: /* @__PURE__ */ Ae(rp, {
    modelValue: { default: null, type: Date },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["selectDate"], ["update:modelValue"]),
  setup(n, { emit: e }) {
    const t = n, r = e, i = [...ld.localeObjectCs.weekdaysShort];
    i.push(i.shift());
    const s = [...ld.localeObjectCs.months], o = je(n, "modelValue"), a = ae([]), l = ae(!1), u = ae("month"), d = Ke(o.value || /* @__PURE__ */ new Date()), c = Qd({
      year: d.year(),
      month: d.month()
    }), f = Z(() => s[c.month]), p = Z(() => new Date(c.year, c.month, 1)), h = Z(() => _(
      L(
        w5(p.value)
      )
    )), y = Z(() => new Date(t.minDate || "1900") < new Date(p.value)), g = Z(() => t.maxDate ? Ke(t.maxDate).isAfter(Ke(p.value), "month") : !0);
    Dt(() => {
      a.value.length && (a.value.find((I) => I.getAttribute("data-selected") === "true") || a.value[0]).focus();
    });
    function m() {
      c.month === 11 ? (c.month = 0, c.year += 1) : c.month += 1;
    }
    function $() {
      c.month === 0 ? (c.month = 11, c.year -= 1) : c.month -= 1;
    }
    function w(O) {
      o.value = new Date(O), r("selectDate", new Date(O));
    }
    function _(O) {
      return O.map((I) => I.map((x) => {
        var j;
        const M = Ke(x.date);
        let D = (j = t.disabledDates) == null ? void 0 : j.some((U) => {
          const J = Ke(U);
          return M.isSame(J, "day");
        });
        if (!D && t.minDate) {
          const U = Ke(t.minDate);
          D = M.isBefore(U, "day");
        }
        if (!D && t.maxDate) {
          const U = Ke(t.maxDate);
          D = M.isAfter(U, "day");
        }
        return { ...x, disabled: D };
      }));
    }
    function L(O) {
      return O.map((I) => I.map((x) => {
        const M = Ke(x.date), D = Ke(o.value);
        return { ...x, selected: M.isSame(D, "day") };
      }));
    }
    function S({ month: O, year: I }) {
      c.month = O, c.year = I, l.value = !1;
    }
    function R(O = "month") {
      u.value = O, l.value = !0;
    }
    return (O, I) => (k(), T("div", R5, [
      l.value ? (k(), T("div", P5, [
        A(L5, {
          class: "w-full flex-1",
          "max-date": O.maxDate || void 0,
          "min-date": O.minDate || void 0,
          "model-value": {
            year: c.year,
            month: c.month
          },
          "open-window": u.value,
          onClose: I[0] || (I[0] = (x) => l.value = !1),
          "onUpdate:modelValue": S
        }, null, 8, ["max-date", "min-date", "model-value", "open-window"])
      ])) : V("", !0),
      E("div", I5, [
        E("button", {
          class: "focusable rounded-md border border-grey-stroke p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !y.value,
          type: "button",
          onClick: $
        }, [
          A(v(ao))
        ], 8, B5),
        A(K, {
          class: "flex min-w-[140px] shrink-0 grow items-center justify-center gap-x-5 text-center",
          size: v(G).sm
        }, {
          default: N(() => [
            A(K, {
              class: "flex items-center gap-x-2 capitalize lg:transition lg:duration-200 lg:hover:text-brand",
              size: v(G).sm,
              "tag-name": "button",
              type: "button",
              onClick: I[1] || (I[1] = (x) => R("month"))
            }, {
              default: N(() => [
                W(z(f.value) + " ", 1),
                A(v(xi), { class: "text-[0.85em] text-grey-300" })
              ]),
              _: 1
            }, 8, ["size"]),
            A(K, {
              class: "flex items-center gap-x-2 capitalize lg:transition lg:duration-200 lg:hover:text-brand",
              size: v(G).sm,
              "tag-name": "button",
              type: "button",
              onClick: I[2] || (I[2] = (x) => R("year"))
            }, {
              default: N(() => [
                W(z(c.year) + " ", 1),
                A(v(xi), { class: "text-[0.85em] text-grey-300" })
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          _: 1
        }, 8, ["size"]),
        A(K, {
          class: "focusable rounded-md border border-grey-stroke p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !g.value,
          size: v(G).sm,
          "tag-name": "button",
          type: "button",
          onClick: m
        }, {
          default: N(() => [
            A(v(mn))
          ]),
          _: 1
        }, 8, ["disabled", "size"])
      ]),
      l.value ? V("", !0) : (k(), T("div", z5, [
        (k(), T(ce, null, $e(i, (x) => A(K, {
          key: x,
          class: "px-3 text-center text-grey-300",
          size: v(G).xs
        }, {
          default: N(() => [
            W(z(x), 1)
          ]),
          _: 2
        }, 1032, ["size"])), 64))
      ])),
      E("div", V5, [
        (k(!0), T(ce, null, $e(h.value, (x) => (k(), T(ce, null, [
          (k(!0), T(ce, null, $e(x, (M) => (k(), T("button", {
            key: M.day,
            ref_for: !0,
            ref_key: "dayRefs",
            ref: a,
            "aria-label": M.date,
            class: B(["focusable cfg-day-item disabled:cursor-not-allowed disabled:line-through disabled:opacity-50", {
              selected: M.selected
            }]),
            "data-selected": M.selected,
            disabled: M.disabled,
            type: "button",
            onClick: (D) => !M.disabled && w(M.date)
          }, [
            A(K, {
              class: B({
                "text-grey-200": (M.inPastMonth || M.inNextMonth) && !c,
                disabled: M.disabled
              }),
              disabled: M.disabled,
              size: v(G).sm,
              "tag-name": "span"
            }, {
              default: N(() => [
                E("span", j5, [
                  E("span", H5, z(M.day), 1),
                  M.isToday ? (k(), T("span", {
                    key: 0,
                    class: B(["absolute bottom-1.5 left-1/2 block size-1 -translate-x-1/2 rounded-full bg-brand", { "!bg-white": M.selected }])
                  }, null, 2)) : V("", !0)
                ])
              ]),
              _: 2
            }, 1032, ["class", "disabled", "size"])
          ], 10, F5))), 128))
        ], 64))), 256))
      ])
    ]));
  }
}), W5 = /* @__PURE__ */ Bn(U5, [["__scopeId", "data-v-3a16ba56"]]), q5 = {}, K5 = { class: "rounded-xl p-5" };
function G5(n, e) {
  return k(), T("div", K5, [
    te(n.$slots, "default")
  ]);
}
const SM = /* @__PURE__ */ Bn(q5, [["render", G5]]), Y5 = {
  active: !0,
  breakpoints: {},
  delay: 4e3,
  jump: !1,
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  stopOnLastSnap: !1,
  rootNode: null
};
function f1(n = {}) {
  let e, t, r, i = !1, s = !0, o = !1, a = 0;
  function l(_, L) {
    t = _;
    const {
      mergeOptions: S,
      optionsAtMedia: R
    } = L, O = S(Y5, f1.globalOptions), I = S(O, n);
    if (e = R(I), t.scrollSnapList().length <= 1) return;
    o = e.jump, r = !1;
    const {
      eventStore: x,
      ownerDocument: M
    } = t.internalEngine(), D = t.rootNode(), j = e.rootNode && e.rootNode(D) || D, U = t.containerNode();
    t.on("pointerDown", c), e.stopOnInteraction || t.on("pointerUp", d), e.stopOnMouseEnter && (x.add(j, "mouseenter", () => {
      s = !1, c();
    }), e.stopOnInteraction || x.add(j, "mouseleave", () => {
      s = !0, d();
    })), e.stopOnFocusIn && (t.on("slideFocusStart", c), e.stopOnInteraction || x.add(U, "focusout", d)), x.add(M, "visibilitychange", f), e.playOnInit && !p() && d();
  }
  function u() {
    t.off("pointerDown", c).off("pointerUp", d).off("slideFocusStart", c), c(), r = !0, i = !1;
  }
  function d() {
    if (r || !s) return;
    i || t.emit("autoplay:play");
    const {
      ownerWindow: _
    } = t.internalEngine();
    _.clearInterval(a), a = _.setInterval($, e.delay), i = !0;
  }
  function c() {
    if (r) return;
    i && t.emit("autoplay:stop");
    const {
      ownerWindow: _
    } = t.internalEngine();
    _.clearInterval(a), a = 0, i = !1;
  }
  function f() {
    if (p())
      return s = i, c();
    s && d();
  }
  function p() {
    const {
      ownerDocument: _
    } = t.internalEngine();
    return _.visibilityState === "hidden";
  }
  function h(_) {
    typeof _ < "u" && (o = _), s = !0, d();
  }
  function y() {
    i && c();
  }
  function g() {
    i && h();
  }
  function m() {
    return i;
  }
  function $() {
    const {
      index: _
    } = t.internalEngine(), L = _.clone().add(1).get(), S = t.scrollSnapList().length - 1;
    e.stopOnLastSnap && L === S && c(), t.canScrollNext() ? t.scrollNext(o) : t.scrollTo(0, o);
  }
  return {
    name: "autoplay",
    options: n,
    init: l,
    destroy: u,
    play: h,
    stop: y,
    reset: g,
    isPlaying: m
  };
}
f1.globalOptions = void 0;
function J5(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function H0(n) {
  return J5(n) || Array.isArray(n);
}
function Z5() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function p1(n, e) {
  const t = Object.keys(n), r = Object.keys(e);
  if (t.length !== r.length) return !1;
  const i = JSON.stringify(Object.keys(n.breakpoints || {})), s = JSON.stringify(Object.keys(e.breakpoints || {}));
  return i !== s ? !1 : t.every((o) => {
    const a = n[o], l = e[o];
    return typeof a == "function" ? `${a}` == `${l}` : !H0(a) || !H0(l) ? a === l : p1(a, l);
  });
}
function U0(n) {
  return n.concat().sort((e, t) => e.name > t.name ? 1 : -1).map((e) => e.options);
}
function X5(n, e) {
  if (n.length !== e.length) return !1;
  const t = U0(n), r = U0(e);
  return t.every((i, s) => {
    const o = r[s];
    return p1(i, o);
  });
}
function h1(n) {
  return typeof n == "number";
}
function cd(n) {
  return typeof n == "string";
}
function Sl(n) {
  return typeof n == "boolean";
}
function W0(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function tt(n) {
  return Math.abs(n);
}
function m1(n) {
  return Math.sign(n);
}
function Ws(n, e) {
  return tt(n - e);
}
function Q5(n, e) {
  if (n === 0 || e === 0 || tt(n) <= tt(e)) return 0;
  const t = Ws(tt(n), tt(e));
  return tt(t / n);
}
function fo(n) {
  return po(n).map(Number);
}
function Rn(n) {
  return n[Do(n)];
}
function Do(n) {
  return Math.max(0, n.length - 1);
}
function g1(n, e) {
  return e === Do(n);
}
function q0(n, e = 0) {
  return Array.from(Array(n), (t, r) => e + r);
}
function po(n) {
  return Object.keys(n);
}
function ip(n, e) {
  return [n, e].reduce((t, r) => (po(r).forEach((i) => {
    const s = t[i], o = r[i], a = W0(s) && W0(o);
    t[i] = a ? ip(s, o) : o;
  }), t), {});
}
function fd(n, e) {
  return typeof e.MouseEvent < "u" && n instanceof e.MouseEvent;
}
function e6(n, e) {
  const t = {
    start: r,
    center: i,
    end: s
  };
  function r() {
    return 0;
  }
  function i(l) {
    return s(l) / 2;
  }
  function s(l) {
    return e - l;
  }
  function o(l, u) {
    return cd(n) ? t[n](l) : n(e, l, u);
  }
  return {
    measure: o
  };
}
function ho() {
  let n = [];
  function e(i, s, o, a = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in i)
      i.addEventListener(s, o, a), l = () => i.removeEventListener(s, o, a);
    else {
      const u = i;
      u.addListener(o), l = () => u.removeListener(o);
    }
    return n.push(l), r;
  }
  function t() {
    n = n.filter((i) => i());
  }
  const r = {
    add: e,
    clear: t
  };
  return r;
}
function t6(n, e, t, r) {
  const i = ho(), s = 1e3 / 60;
  let o = null, a = 0, l = 0;
  function u() {
    i.add(n, "visibilitychange", () => {
      n.hidden && h();
    });
  }
  function d() {
    p(), i.clear();
  }
  function c(g) {
    if (!l) return;
    o || (o = g);
    const m = g - o;
    for (o = g, a += m; a >= s; )
      t(s), a -= s;
    const $ = a / s;
    r($), l && e.requestAnimationFrame(c);
  }
  function f() {
    l || (l = e.requestAnimationFrame(c));
  }
  function p() {
    e.cancelAnimationFrame(l), o = null, a = 0, l = 0;
  }
  function h() {
    o = null, a = 0;
  }
  return {
    init: u,
    destroy: d,
    start: f,
    stop: p,
    update: () => t(s),
    render: r
  };
}
function n6(n, e) {
  const t = e === "rtl", r = n === "y", i = r ? "y" : "x", s = r ? "x" : "y", o = !r && t ? -1 : 1, a = d(), l = c();
  function u(h) {
    const {
      height: y,
      width: g
    } = h;
    return r ? y : g;
  }
  function d() {
    return r ? "top" : t ? "right" : "left";
  }
  function c() {
    return r ? "bottom" : t ? "left" : "right";
  }
  function f(h) {
    return h * o;
  }
  return {
    scroll: i,
    cross: s,
    startEdge: a,
    endEdge: l,
    measureSize: u,
    direction: f
  };
}
function wi(n = 0, e = 0) {
  const t = tt(n - e);
  function r(u) {
    return u < n;
  }
  function i(u) {
    return u > e;
  }
  function s(u) {
    return r(u) || i(u);
  }
  function o(u) {
    return s(u) ? r(u) ? n : e : u;
  }
  function a(u) {
    return t ? u - t * Math.ceil((u - e) / t) : u;
  }
  return {
    length: t,
    max: e,
    min: n,
    constrain: o,
    reachedAny: s,
    reachedMax: i,
    reachedMin: r,
    removeOffset: a
  };
}
function sp(n, e, t) {
  const {
    constrain: r
  } = wi(0, n), i = n + 1;
  let s = o(e);
  function o(f) {
    return t ? tt((i + f) % i) : r(f);
  }
  function a() {
    return s;
  }
  function l(f) {
    return s = o(f), c;
  }
  function u(f) {
    return d().set(a() + f);
  }
  function d() {
    return sp(n, a(), t);
  }
  const c = {
    get: a,
    set: l,
    add: u,
    clone: d
  };
  return c;
}
function r6(n, e, t, r, i, s, o, a, l, u, d, c, f, p, h, y, g, m, $) {
  const {
    cross: w,
    direction: _
  } = n, L = ["INPUT", "SELECT", "TEXTAREA"], S = {
    passive: !1
  }, R = ho(), O = ho(), I = wi(50, 225).constrain(p.measure(20)), x = {
    mouse: 300,
    touch: 400
  }, M = {
    mouse: 500,
    touch: 600
  }, D = h ? 43 : 25;
  let j = !1, U = 0, J = 0, ne = !1, Y = !1, oe = !1, le = !1;
  function ge(fe) {
    if (!$) return;
    function we(Fe) {
      (Sl($) || $(fe, Fe)) && be(Fe);
    }
    const Be = e;
    R.add(Be, "dragstart", (Fe) => Fe.preventDefault(), S).add(Be, "touchmove", () => {
    }, S).add(Be, "touchend", () => {
    }).add(Be, "touchstart", we).add(Be, "mousedown", we).add(Be, "touchcancel", Re).add(Be, "contextmenu", Re).add(Be, "click", rt, !0);
  }
  function he() {
    R.clear(), O.clear();
  }
  function _e() {
    const fe = le ? t : e;
    O.add(fe, "touchmove", He, S).add(fe, "touchend", Re).add(fe, "mousemove", He, S).add(fe, "mouseup", Re);
  }
  function ue(fe) {
    const we = fe.nodeName || "";
    return L.includes(we);
  }
  function xe() {
    return (h ? M : x)[le ? "mouse" : "touch"];
  }
  function Le(fe, we) {
    const Be = c.add(m1(fe) * -1), Fe = d.byDistance(fe, !h).distance;
    return h || tt(fe) < I ? Fe : g && we ? Fe * 0.5 : d.byIndex(Be.get(), 0).distance;
  }
  function be(fe) {
    const we = fd(fe, r);
    le = we, oe = h && we && !fe.buttons && j, j = Ws(i.get(), o.get()) >= 2, !(we && fe.button !== 0) && (ue(fe.target) || (ne = !0, s.pointerDown(fe), u.useFriction(0).useDuration(0), i.set(o), _e(), U = s.readPoint(fe), J = s.readPoint(fe, w), f.emit("pointerDown")));
  }
  function He(fe) {
    if (!fd(fe, r) && fe.touches.length >= 2) return Re(fe);
    const Be = s.readPoint(fe), Fe = s.readPoint(fe, w), Xe = Ws(Be, U), ot = Ws(Fe, J);
    if (!Y && !le && (!fe.cancelable || (Y = Xe > ot, !Y)))
      return Re(fe);
    const ct = s.pointerMove(fe);
    Xe > y && (oe = !0), u.useFriction(0.3).useDuration(0.75), a.start(), i.add(_(ct)), fe.preventDefault();
  }
  function Re(fe) {
    const Be = d.byDistance(0, !1).index !== c.get(), Fe = s.pointerUp(fe) * xe(), Xe = Le(_(Fe), Be), ot = Q5(Fe, Xe), ct = D - 10 * ot, ft = m + ot / 50;
    Y = !1, ne = !1, O.clear(), u.useDuration(ct).useFriction(ft), l.distance(Xe, !h), le = !1, f.emit("pointerUp");
  }
  function rt(fe) {
    oe && (fe.stopPropagation(), fe.preventDefault(), oe = !1);
  }
  function ze() {
    return ne;
  }
  return {
    init: ge,
    destroy: he,
    pointerDown: ze
  };
}
function i6(n, e) {
  let r, i;
  function s(c) {
    return c.timeStamp;
  }
  function o(c, f) {
    const h = `client${(f || n.scroll) === "x" ? "X" : "Y"}`;
    return (fd(c, e) ? c : c.touches[0])[h];
  }
  function a(c) {
    return r = c, i = c, o(c);
  }
  function l(c) {
    const f = o(c) - o(i), p = s(c) - s(r) > 170;
    return i = c, p && (r = c), f;
  }
  function u(c) {
    if (!r || !i) return 0;
    const f = o(i) - o(r), p = s(c) - s(r), h = s(c) - s(i) > 170, y = f / p;
    return p && !h && tt(y) > 0.1 ? y : 0;
  }
  return {
    pointerDown: a,
    pointerMove: l,
    pointerUp: u,
    readPoint: o
  };
}
function s6() {
  function n(t) {
    const {
      offsetTop: r,
      offsetLeft: i,
      offsetWidth: s,
      offsetHeight: o
    } = t;
    return {
      top: r,
      right: i + s,
      bottom: r + o,
      left: i,
      width: s,
      height: o
    };
  }
  return {
    measure: n
  };
}
function o6(n) {
  function e(r) {
    return n * (r / 100);
  }
  return {
    measure: e
  };
}
function a6(n, e, t, r, i, s, o) {
  const a = [n].concat(r);
  let l, u, d = [], c = !1;
  function f(g) {
    return i.measureSize(o.measure(g));
  }
  function p(g) {
    if (!s) return;
    u = f(n), d = r.map(f);
    function m($) {
      for (const w of $) {
        if (c) return;
        const _ = w.target === n, L = r.indexOf(w.target), S = _ ? u : d[L], R = f(_ ? n : r[L]);
        if (tt(R - S) >= 0.5) {
          g.reInit(), e.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver(($) => {
      (Sl(s) || s(g, $)) && m($);
    }), t.requestAnimationFrame(() => {
      a.forEach(($) => l.observe($));
    });
  }
  function h() {
    c = !0, l && l.disconnect();
  }
  return {
    init: p,
    destroy: h
  };
}
function l6(n, e, t, r, i, s) {
  let o = 0, a = 0, l = i, u = s, d = n.get(), c = 0;
  function f(S) {
    const R = S / 1e3, O = l * R, I = r.get() - n.get(), x = !l;
    let M = 0;
    return x ? (o = 0, t.set(r), n.set(r), M = I) : (t.set(n), o += I / O, o *= u, d += o, n.add(o * R), M = d - c), a = m1(M), c = d, L;
  }
  function p() {
    const S = r.get() - e.get();
    return tt(S) < 1e-3;
  }
  function h() {
    return l;
  }
  function y() {
    return a;
  }
  function g() {
    return o;
  }
  function m() {
    return w(i);
  }
  function $() {
    return _(s);
  }
  function w(S) {
    return l = S, L;
  }
  function _(S) {
    return u = S, L;
  }
  const L = {
    direction: y,
    duration: h,
    velocity: g,
    seek: f,
    settled: p,
    useBaseFriction: $,
    useBaseDuration: m,
    useFriction: _,
    useDuration: w
  };
  return L;
}
function u6(n, e, t, r, i) {
  const s = i.measure(10), o = i.measure(50), a = wi(0.1, 0.99);
  let l = !1;
  function u() {
    return !(l || !n.reachedAny(t.get()) || !n.reachedAny(e.get()));
  }
  function d(p) {
    if (!u()) return;
    const h = n.reachedMin(e.get()) ? "min" : "max", y = tt(n[h] - e.get()), g = t.get() - e.get(), m = a.constrain(y / o);
    t.subtract(g * m), !p && tt(g) < s && (t.set(n.constrain(t.get())), r.useDuration(25).useBaseFriction());
  }
  function c(p) {
    l = !p;
  }
  return {
    shouldConstrain: u,
    constrain: d,
    toggleActive: c
  };
}
function d6(n, e, t, r, i) {
  const s = wi(-e + n, 0), o = c(), a = d(), l = f();
  function u(h, y) {
    return Ws(h, y) < 1;
  }
  function d() {
    const h = o[0], y = Rn(o), g = o.lastIndexOf(h), m = o.indexOf(y) + 1;
    return wi(g, m);
  }
  function c() {
    return t.map((h, y) => {
      const {
        min: g,
        max: m
      } = s, $ = s.constrain(h), w = !y, _ = g1(t, y);
      return w ? m : _ || u(g, $) ? g : u(m, $) ? m : $;
    }).map((h) => parseFloat(h.toFixed(3)));
  }
  function f() {
    if (e <= n + i) return [s.max];
    if (r === "keepSnaps") return o;
    const {
      min: h,
      max: y
    } = a;
    return o.slice(h, y);
  }
  return {
    snapsContained: l,
    scrollContainLimit: a
  };
}
function c6(n, e, t) {
  const r = e[0], i = t ? r - n : Rn(e);
  return {
    limit: wi(i, r)
  };
}
function f6(n, e, t, r) {
  const s = e.min + 0.1, o = e.max + 0.1, {
    reachedMin: a,
    reachedMax: l
  } = wi(s, o);
  function u(f) {
    return f === 1 ? l(t.get()) : f === -1 ? a(t.get()) : !1;
  }
  function d(f) {
    if (!u(f)) return;
    const p = n * (f * -1);
    r.forEach((h) => h.add(p));
  }
  return {
    loop: d
  };
}
function p6(n) {
  const {
    max: e,
    length: t
  } = n;
  function r(s) {
    const o = s - e;
    return t ? o / -t : 0;
  }
  return {
    get: r
  };
}
function h6(n, e, t, r, i) {
  const {
    startEdge: s,
    endEdge: o
  } = n, {
    groupSlides: a
  } = i, l = c().map(e.measure), u = f(), d = p();
  function c() {
    return a(r).map((y) => Rn(y)[o] - y[0][s]).map(tt);
  }
  function f() {
    return r.map((y) => t[s] - y[s]).map((y) => -tt(y));
  }
  function p() {
    return a(u).map((y) => y[0]).map((y, g) => y + l[g]);
  }
  return {
    snaps: u,
    snapsAligned: d
  };
}
function m6(n, e, t, r, i, s) {
  const {
    groupSlides: o
  } = i, {
    min: a,
    max: l
  } = r, u = d();
  function d() {
    const f = o(s), p = !n || e === "keepSnaps";
    return t.length === 1 ? [s] : p ? f : f.slice(a, l).map((h, y, g) => {
      const m = !y, $ = g1(g, y);
      if (m) {
        const w = Rn(g[0]) + 1;
        return q0(w);
      }
      if ($) {
        const w = Do(s) - Rn(g)[0] + 1;
        return q0(w, Rn(g)[0]);
      }
      return h;
    });
  }
  return {
    slideRegistry: u
  };
}
function g6(n, e, t, r, i) {
  const {
    reachedAny: s,
    removeOffset: o,
    constrain: a
  } = r;
  function l(h) {
    return h.concat().sort((y, g) => tt(y) - tt(g))[0];
  }
  function u(h) {
    const y = n ? o(h) : a(h), g = e.map(($, w) => ({
      diff: d($ - y, 0),
      index: w
    })).sort(($, w) => tt($.diff) - tt(w.diff)), {
      index: m
    } = g[0];
    return {
      index: m,
      distance: y
    };
  }
  function d(h, y) {
    const g = [h, h + t, h - t];
    if (!n) return h;
    if (!y) return l(g);
    const m = g.filter(($) => m1($) === y);
    return m.length ? l(m) : Rn(g) - t;
  }
  function c(h, y) {
    const g = e[h] - i.get(), m = d(g, y);
    return {
      index: h,
      distance: m
    };
  }
  function f(h, y) {
    const g = i.get() + h, {
      index: m,
      distance: $
    } = u(g), w = !n && s(g);
    if (!y || w) return {
      index: m,
      distance: h
    };
    const _ = e[m] - $, L = h + d(_, 0);
    return {
      index: m,
      distance: L
    };
  }
  return {
    byDistance: f,
    byIndex: c,
    shortcut: d
  };
}
function b6(n, e, t, r, i, s, o) {
  function a(c) {
    const f = c.distance, p = c.index !== e.get();
    s.add(f), f && (r.duration() ? n.start() : (n.update(), n.render(1), n.update())), p && (t.set(e.get()), e.set(c.index), o.emit("select"));
  }
  function l(c, f) {
    const p = i.byDistance(c, f);
    a(p);
  }
  function u(c, f) {
    const p = e.clone().set(c), h = i.byIndex(p.get(), f);
    a(h);
  }
  return {
    distance: l,
    index: u
  };
}
function y6(n, e, t, r, i, s, o, a) {
  const l = {
    passive: !0,
    capture: !0
  };
  let u = 0;
  function d(p) {
    if (!a) return;
    function h(y) {
      if ((/* @__PURE__ */ new Date()).getTime() - u > 10) return;
      o.emit("slideFocusStart"), n.scrollLeft = 0;
      const $ = t.findIndex((w) => w.includes(y));
      h1($) && (i.useDuration(0), r.index($, 0), o.emit("slideFocus"));
    }
    s.add(document, "keydown", c, !1), e.forEach((y, g) => {
      s.add(y, "focus", (m) => {
        (Sl(a) || a(p, m)) && h(g);
      }, l);
    });
  }
  function c(p) {
    p.code === "Tab" && (u = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: d
  };
}
function Is(n) {
  let e = n;
  function t() {
    return e;
  }
  function r(l) {
    e = o(l);
  }
  function i(l) {
    e += o(l);
  }
  function s(l) {
    e -= o(l);
  }
  function o(l) {
    return h1(l) ? l : l.get();
  }
  return {
    get: t,
    set: r,
    add: i,
    subtract: s
  };
}
function op(n, e) {
  const t = n.scroll === "x" ? s : o, r = e.style;
  let i = !1;
  function s(c) {
    return `translate3d(${c}px,0px,0px)`;
  }
  function o(c) {
    return `translate3d(0px,${c}px,0px)`;
  }
  function a(c) {
    i || (r.transform = t(n.direction(c)));
  }
  function l(c) {
    i = !c;
  }
  function u() {
    i || (r.transform = "", e.getAttribute("style") || e.removeAttribute("style"));
  }
  return {
    clear: u,
    to: a,
    toggleActive: l
  };
}
function v6(n, e, t, r, i, s, o, a, l) {
  const d = fo(i), c = fo(i).reverse(), f = m().concat($());
  function p(R, O) {
    return R.reduce((I, x) => I - i[x], O);
  }
  function h(R, O) {
    return R.reduce((I, x) => p(I, O) > 0 ? I.concat([x]) : I, []);
  }
  function y(R) {
    return s.map((O, I) => ({
      start: O - r[I] + 0.5 + R,
      end: O + e - 0.5 + R
    }));
  }
  function g(R, O, I) {
    const x = y(O);
    return R.map((M) => {
      const D = I ? 0 : -t, j = I ? t : 0, U = I ? "end" : "start", J = x[M][U];
      return {
        index: M,
        loopPoint: J,
        slideLocation: Is(-1),
        translate: op(n, l[M]),
        target: () => a.get() > J ? D : j
      };
    });
  }
  function m() {
    const R = o[0], O = h(c, R);
    return g(O, t, !1);
  }
  function $() {
    const R = e - o[0] - 1, O = h(d, R);
    return g(O, -t, !0);
  }
  function w() {
    return f.every(({
      index: R
    }) => {
      const O = d.filter((I) => I !== R);
      return p(O, e) <= 0.1;
    });
  }
  function _() {
    f.forEach((R) => {
      const {
        target: O,
        translate: I,
        slideLocation: x
      } = R, M = O();
      M !== x.get() && (I.to(M), x.set(M));
    });
  }
  function L() {
    f.forEach((R) => R.translate.clear());
  }
  return {
    canLoop: w,
    clear: L,
    loop: _,
    loopPoints: f
  };
}
function _6(n, e, t) {
  let r, i = !1;
  function s(l) {
    if (!t) return;
    function u(d) {
      for (const c of d)
        if (c.type === "childList") {
          l.reInit(), e.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((d) => {
      i || (Sl(t) || t(l, d)) && u(d);
    }), r.observe(n, {
      childList: !0
    });
  }
  function o() {
    r && r.disconnect(), i = !0;
  }
  return {
    init: s,
    destroy: o
  };
}
function $6(n, e, t, r) {
  const i = {};
  let s = null, o = null, a, l = !1;
  function u() {
    a = new IntersectionObserver((h) => {
      l || (h.forEach((y) => {
        const g = e.indexOf(y.target);
        i[g] = y;
      }), s = null, o = null, t.emit("slidesInView"));
    }, {
      root: n.parentElement,
      threshold: r
    }), e.forEach((h) => a.observe(h));
  }
  function d() {
    a && a.disconnect(), l = !0;
  }
  function c(h) {
    return po(i).reduce((y, g) => {
      const m = parseInt(g), {
        isIntersecting: $
      } = i[m];
      return (h && $ || !h && !$) && y.push(m), y;
    }, []);
  }
  function f(h = !0) {
    if (h && s) return s;
    if (!h && o) return o;
    const y = c(h);
    return h && (s = y), h || (o = y), y;
  }
  return {
    init: u,
    destroy: d,
    get: f
  };
}
function x6(n, e, t, r, i, s) {
  const {
    measureSize: o,
    startEdge: a,
    endEdge: l
  } = n, u = t[0] && i, d = h(), c = y(), f = t.map(o), p = g();
  function h() {
    if (!u) return 0;
    const $ = t[0];
    return tt(e[a] - $[a]);
  }
  function y() {
    if (!u) return 0;
    const $ = s.getComputedStyle(Rn(r));
    return parseFloat($.getPropertyValue(`margin-${l}`));
  }
  function g() {
    return t.map(($, w, _) => {
      const L = !w, S = g1(_, w);
      return L ? f[w] + d : S ? f[w] + c : _[w + 1][a] - $[a];
    }).map(tt);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: p,
    startGap: d,
    endGap: c
  };
}
function w6(n, e, t, r, i, s, o, a, l) {
  const {
    startEdge: u,
    endEdge: d,
    direction: c
  } = n, f = h1(t);
  function p(m, $) {
    return fo(m).filter((w) => w % $ === 0).map((w) => m.slice(w, w + $));
  }
  function h(m) {
    return m.length ? fo(m).reduce(($, w, _) => {
      const L = Rn($) || 0, S = L === 0, R = w === Do(m), O = i[u] - s[L][u], I = i[u] - s[w][d], x = !r && S ? c(o) : 0, M = !r && R ? c(a) : 0, D = tt(I - M - (O + x));
      return _ && D > e + l && $.push(w), R && $.push(m.length), $;
    }, []).map(($, w, _) => {
      const L = Math.max(_[w - 1] || 0);
      return m.slice(L, $);
    }) : [];
  }
  function y(m) {
    return f ? p(m, t) : h(m);
  }
  return {
    groupSlides: y
  };
}
function k6(n, e, t, r, i, s, o) {
  const {
    align: a,
    axis: l,
    direction: u,
    startIndex: d,
    loop: c,
    duration: f,
    dragFree: p,
    dragThreshold: h,
    inViewThreshold: y,
    slidesToScroll: g,
    skipSnaps: m,
    containScroll: $,
    watchResize: w,
    watchSlides: _,
    watchDrag: L,
    watchFocus: S
  } = s, R = 2, O = s6(), I = O.measure(e), x = t.map(O.measure), M = n6(l, u), D = M.measureSize(I), j = o6(D), U = e6(a, D), J = !c && !!$, ne = c || !!$, {
    slideSizes: Y,
    slideSizesWithGaps: oe,
    startGap: le,
    endGap: ge
  } = x6(M, I, x, t, ne, i), he = w6(M, D, g, c, I, x, le, ge, R), {
    snaps: _e,
    snapsAligned: ue
  } = h6(M, U, I, x, he), xe = -Rn(_e) + Rn(oe), {
    snapsContained: Le,
    scrollContainLimit: be
  } = d6(D, xe, ue, $, R), He = J ? Le : ue, {
    limit: Re
  } = c6(xe, He, c), rt = sp(Do(He), d, c), ze = rt.clone(), Pe = fo(t), fe = ({
    dragHandler: on,
    scrollBody: vr,
    scrollBounds: Qr,
    options: {
      loop: _r
    }
  }, Q) => {
    _r || Qr.constrain(on.pointerDown()), vr.seek(Q);
  }, we = ({
    scrollBody: on,
    translate: vr,
    location: Qr,
    offsetLocation: _r,
    scrollLooper: Q,
    slideLooper: pe,
    dragHandler: ye,
    animation: Ve,
    eventHandler: De,
    scrollBounds: pt,
    options: {
      loop: Et
    }
  }, Zt) => {
    const $r = on.settled(), Lt = !pt.shouldConstrain(), an = Et ? $r : $r && Lt;
    an && !ye.pointerDown() && (Ve.stop(), De.emit("settle")), an || De.emit("scroll");
    const xr = Qr.get() * Zt + ct.get() * (1 - Zt);
    _r.set(xr), Et && (Q.loop(on.direction()), pe.loop()), vr.to(_r.get());
  }, Be = t6(r, i, (on) => fe(bn, on), (on) => we(bn, on)), Fe = 0.68, Xe = He[rt.get()], ot = Is(Xe), ct = Is(Xe), ft = Is(Xe), lt = Is(Xe), ut = l6(ot, ft, ct, lt, f, Fe), gn = g6(c, He, xe, Re, lt), sn = b6(Be, rt, ze, ut, gn, lt, o), zn = p6(Re), Qn = ho(), br = $6(e, t, o, y), {
    slideRegistry: er
  } = m6(J, $, He, be, he, Pe), yr = y6(n, t, er, sn, ut, Qn, o, S), bn = {
    ownerDocument: r,
    ownerWindow: i,
    eventHandler: o,
    containerRect: I,
    slideRects: x,
    animation: Be,
    axis: M,
    dragHandler: r6(M, n, r, i, lt, i6(M, i), ot, Be, sn, ut, gn, rt, o, j, p, h, m, Fe, L),
    eventStore: Qn,
    percentOfView: j,
    index: rt,
    indexPrevious: ze,
    limit: Re,
    location: ot,
    offsetLocation: ft,
    previousLocation: ct,
    options: s,
    resizeHandler: a6(e, o, i, t, M, w, O),
    scrollBody: ut,
    scrollBounds: u6(Re, ft, lt, ut, j),
    scrollLooper: f6(xe, Re, ft, [ot, ft, ct, lt]),
    scrollProgress: zn,
    scrollSnapList: He.map(zn.get),
    scrollSnaps: He,
    scrollTarget: gn,
    scrollTo: sn,
    slideLooper: v6(M, D, xe, Y, oe, _e, He, ft, t),
    slideFocus: yr,
    slidesHandler: _6(e, o, _),
    slidesInView: br,
    slideIndexes: Pe,
    slideRegistry: er,
    slidesToScroll: he,
    target: lt,
    translate: op(M, e)
  };
  return bn;
}
function C6() {
  let n = {}, e;
  function t(u) {
    e = u;
  }
  function r(u) {
    return n[u] || [];
  }
  function i(u) {
    return r(u).forEach((d) => d(e, u)), l;
  }
  function s(u, d) {
    return n[u] = r(u).concat([d]), l;
  }
  function o(u, d) {
    return n[u] = r(u).filter((c) => c !== d), l;
  }
  function a() {
    n = {};
  }
  const l = {
    init: t,
    emit: i,
    off: o,
    on: s,
    clear: a
  };
  return l;
}
const S6 = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function E6(n) {
  function e(s, o) {
    return ip(s, o || {});
  }
  function t(s) {
    const o = s.breakpoints || {}, a = po(o).filter((l) => n.matchMedia(l).matches).map((l) => o[l]).reduce((l, u) => e(l, u), {});
    return e(s, a);
  }
  function r(s) {
    return s.map((o) => po(o.breakpoints || {})).reduce((o, a) => o.concat(a), []).map(n.matchMedia);
  }
  return {
    mergeOptions: e,
    optionsAtMedia: t,
    optionsMediaQueries: r
  };
}
function T6(n) {
  let e = [];
  function t(s, o) {
    return e = o.filter(({
      options: a
    }) => n.optionsAtMedia(a).active !== !1), e.forEach((a) => a.init(s, n)), o.reduce((a, l) => Object.assign(a, {
      [l.name]: l
    }), {});
  }
  function r() {
    e = e.filter((s) => s.destroy());
  }
  return {
    init: t,
    destroy: r
  };
}
function Ea(n, e, t) {
  const r = n.ownerDocument, i = r.defaultView, s = E6(i), o = T6(s), a = ho(), l = C6(), {
    mergeOptions: u,
    optionsAtMedia: d,
    optionsMediaQueries: c
  } = s, {
    on: f,
    off: p,
    emit: h
  } = l, y = M;
  let g = !1, m, $ = u(S6, Ea.globalOptions), w = u($), _ = [], L, S, R;
  function O() {
    const {
      container: Pe,
      slides: fe
    } = w;
    S = (cd(Pe) ? n.querySelector(Pe) : Pe) || n.children[0];
    const Be = cd(fe) ? S.querySelectorAll(fe) : fe;
    R = [].slice.call(Be || S.children);
  }
  function I(Pe) {
    const fe = k6(n, S, R, r, i, Pe, l);
    if (Pe.loop && !fe.slideLooper.canLoop()) {
      const we = Object.assign({}, Pe, {
        loop: !1
      });
      return I(we);
    }
    return fe;
  }
  function x(Pe, fe) {
    g || ($ = u($, Pe), w = d($), _ = fe || _, O(), m = I(w), c([$, ..._.map(({
      options: we
    }) => we)]).forEach((we) => a.add(we, "change", M)), w.active && (m.translate.to(m.location.get()), m.animation.init(), m.slidesInView.init(), m.slideFocus.init(ze), m.eventHandler.init(ze), m.resizeHandler.init(ze), m.slidesHandler.init(ze), m.options.loop && m.slideLooper.loop(), S.offsetParent && R.length && m.dragHandler.init(ze), L = o.init(ze, _)));
  }
  function M(Pe, fe) {
    const we = he();
    D(), x(u({
      startIndex: we
    }, Pe), fe), l.emit("reInit");
  }
  function D() {
    m.dragHandler.destroy(), m.eventStore.clear(), m.translate.clear(), m.slideLooper.clear(), m.resizeHandler.destroy(), m.slidesHandler.destroy(), m.slidesInView.destroy(), m.animation.destroy(), o.destroy(), a.clear();
  }
  function j() {
    g || (g = !0, a.clear(), D(), l.emit("destroy"), l.clear());
  }
  function U(Pe, fe, we) {
    !w.active || g || (m.scrollBody.useBaseFriction().useDuration(fe === !0 ? 0 : w.duration), m.scrollTo.index(Pe, we || 0));
  }
  function J(Pe) {
    const fe = m.index.add(1).get();
    U(fe, Pe, -1);
  }
  function ne(Pe) {
    const fe = m.index.add(-1).get();
    U(fe, Pe, 1);
  }
  function Y() {
    return m.index.add(1).get() !== he();
  }
  function oe() {
    return m.index.add(-1).get() !== he();
  }
  function le() {
    return m.scrollSnapList;
  }
  function ge() {
    return m.scrollProgress.get(m.location.get());
  }
  function he() {
    return m.index.get();
  }
  function _e() {
    return m.indexPrevious.get();
  }
  function ue() {
    return m.slidesInView.get();
  }
  function xe() {
    return m.slidesInView.get(!1);
  }
  function Le() {
    return L;
  }
  function be() {
    return m;
  }
  function He() {
    return n;
  }
  function Re() {
    return S;
  }
  function rt() {
    return R;
  }
  const ze = {
    canScrollNext: Y,
    canScrollPrev: oe,
    containerNode: Re,
    internalEngine: be,
    destroy: j,
    off: p,
    on: f,
    emit: h,
    plugins: Le,
    previousScrollSnap: _e,
    reInit: y,
    rootNode: He,
    scrollNext: J,
    scrollPrev: ne,
    scrollProgress: ge,
    scrollSnapList: le,
    scrollTo: U,
    selectedScrollSnap: he,
    slideNodes: rt,
    slidesInView: ue,
    slidesNotInView: xe
  };
  return x(e, t), setTimeout(() => l.emit("init"), 0), ze;
}
Ea.globalOptions = void 0;
function El(n = {}, e = []) {
  const t = rs(n), r = rs(e);
  let i = t ? n.value : n, s = r ? e.value : e;
  const o = _i(), a = _i();
  function l() {
    a.value && a.value.reInit(i, s);
  }
  return Dt(() => {
    !Z5() || !o.value || (Ea.globalOptions = El.globalOptions, a.value = Ea(o.value, i, s));
  }), Mi(() => {
    a.value && a.value.destroy();
  }), t && Ie(n, (u) => {
    p1(i, u) || (i = u, l());
  }), r && Ie(e, (u) => {
    X5(s, u) || (s = u, l());
  }), [o, a];
}
El.globalOptions = void 0;
function fi() {
  return fi = Object.assign || function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, fi.apply(this, arguments);
}
var O6 = 0.996, M6 = function(e, t) {
  return t === void 0 && (t = O6), e * t / (1 - t);
};
function A6(n) {
  return n[n.length - 1];
}
function N6(n) {
  return n.reduce(function(e, t) {
    return e + t;
  }) / n.length;
}
var D6 = function(e, t, r) {
  return Math.min(Math.max(t, e), r);
};
function ou(n, e) {
  if (n.length !== e.length)
    throw new Error("vectors must be same length");
  return n.map(function(t, r) {
    return t + e[r];
  });
}
function K0(n) {
  return Math.max.apply(Math, n.map(Math.abs));
}
function ls(n) {
  return Object.freeze(n), Object.values(n).forEach(function(e) {
    e !== null && typeof e == "object" && !Object.isFrozen(e) && ls(e);
  }), n;
}
function L6() {
  var n = {};
  function e(i, s) {
    return n[i] = (n[i] || []).concat(s), function() {
      return t(i, s);
    };
  }
  function t(i, s) {
    n[i] = (n[i] || []).filter(function(o) {
      return o !== s;
    });
  }
  function r(i, s) {
    i in n && n[i].forEach(function(o) {
      return o(s);
    });
  }
  return ls({
    on: e,
    off: t,
    dispatch: r
  });
}
function R6(n) {
  var e = [], t = function(o) {
    return o.addEventListener("wheel", n, {
      passive: !1
    }), e.push(o), function() {
      return r(o);
    };
  }, r = function(o) {
    o.removeEventListener("wheel", n), e = e.filter(function(a) {
      return a !== o;
    });
  }, i = function() {
    e.forEach(r);
  };
  return ls({
    observe: t,
    unobserve: r,
    disconnect: i
  });
}
var P6 = 16 * 1.125, I6 = typeof window < "u" && window.innerHeight || 800, au = [1, P6, I6];
function B6(n) {
  var e = n.deltaX * au[n.deltaMode], t = n.deltaY * au[n.deltaMode], r = (n.deltaZ || 0) * au[n.deltaMode];
  return {
    timeStamp: n.timeStamp,
    axisDelta: [e, t, r]
  };
}
var z6 = [-1, -1, -1];
function V6(n, e) {
  if (!e)
    return n;
  var t = e === !0 ? z6 : e.map(function(r) {
    return r ? -1 : 1;
  });
  return fi({}, n, {
    axisDelta: n.axisDelta.map(function(r, i) {
      return r * t[i];
    })
  });
}
var G0 = 700, F6 = function(e) {
  return fi({}, e, {
    axisDelta: e.axisDelta.map(function(t) {
      return D6(t, -G0, G0);
    })
  });
}, lu = process.env.NODE_ENV !== "production", j6 = 0.6, H6 = 0.96, U6 = 2, Y0 = 5, J0 = /* @__PURE__ */ ls({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), W6 = 400;
function Z0() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: W6
  };
}
function q6(n) {
  n === void 0 && (n = {});
  var e = L6(), t = e.on, r = e.off, i = e.dispatch, s = J0, o = Z0(), a, l = !1, u, d = function(U) {
    Array.isArray(U) ? U.forEach(function(J) {
      return h(J);
    }) : h(U);
  }, c = function(U) {
    return U === void 0 && (U = {}), Object.values(U).some(function(J) {
      return J == null;
    }) ? (lu && console.error("updateOptions ignored! undefined & null options not allowed"), s) : s = ls(fi({}, J0, s, U));
  }, f = function(U) {
    var J = fi({
      event: a,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: o.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: o.axisVelocity,
      axisMovement: o.axisMovement,
      get axisMovementProjection() {
        return ou(J.axisMovement, J.axisVelocity.map(function(ne) {
          return M6(ne);
        }));
      }
    }, U);
    i("wheel", fi({}, J, {
      previous: u
    })), u = J;
  }, p = function(U, J) {
    var ne = s, Y = ne.preventWheelAction, oe = J[0], le = J[1], ge = J[2];
    if (typeof Y == "boolean") return Y;
    switch (Y) {
      case "x":
        return Math.abs(oe) >= U;
      case "y":
        return Math.abs(le) >= U;
      case "z":
        return Math.abs(ge) >= U;
      default:
        return lu && console.warn("unsupported preventWheelAction value: " + Y, "warn"), !1;
    }
  }, h = function(U) {
    var J = F6(V6(B6(U), s.reverseSign)), ne = J.axisDelta, Y = J.timeStamp, oe = K0(ne);
    if (U.preventDefault && p(oe, ne) && U.preventDefault(), o.isStarted ? o.isMomentum && oe > Math.max(2, o.lastAbsDelta * 2) && (O(!0), S()) : S(), oe === 0 && Object.is && Object.is(U.deltaX, -0)) {
      l = !0;
      return;
    }
    a = U, o.axisMovement = ou(o.axisMovement, ne), o.lastAbsDelta = oe, o.scrollPointsToMerge.push({
      axisDelta: ne,
      timeStamp: Y
    }), y(), f({
      axisDelta: ne,
      isStart: !o.isStartPublished
    }), o.isStartPublished = !0, R();
  }, y = function() {
    o.scrollPointsToMerge.length === U6 ? (o.scrollPoints.unshift({
      axisDeltaSum: o.scrollPointsToMerge.map(function(U) {
        return U.axisDelta;
      }).reduce(ou),
      timeStamp: N6(o.scrollPointsToMerge.map(function(U) {
        return U.timeStamp;
      }))
    }), m(), o.scrollPointsToMerge.length = 0, o.scrollPoints.length = 1, o.isMomentum || _()) : o.isStartPublished || g();
  }, g = function() {
    o.axisVelocity = A6(o.scrollPointsToMerge).axisDelta.map(function(U) {
      return U / o.willEndTimeout;
    });
  }, m = function() {
    var U = o.scrollPoints, J = U[0], ne = U[1];
    if (!(!ne || !J)) {
      var Y = J.timeStamp - ne.timeStamp;
      if (Y <= 0) {
        lu && console.warn("invalid deltaTime");
        return;
      }
      var oe = J.axisDeltaSum.map(function(ge) {
        return ge / Y;
      }), le = oe.map(function(ge, he) {
        return ge / (o.axisVelocity[he] || 1);
      });
      o.axisVelocity = oe, o.accelerationFactors.push(le), $(Y);
    }
  }, $ = function(U) {
    var J = Math.ceil(U / 10) * 10 * 1.2;
    o.isMomentum || (J = Math.max(100, J * 2)), o.willEndTimeout = Math.min(1e3, Math.round(J));
  }, w = function(U) {
    return U === 0 ? !0 : U <= H6 && U >= j6;
  }, _ = function() {
    if (o.accelerationFactors.length >= Y0) {
      if (l && (l = !1, K0(o.axisVelocity) >= 0.2)) {
        L();
        return;
      }
      var U = o.accelerationFactors.slice(Y0 * -1), J = U.every(function(ne) {
        var Y = !!ne.reduce(function(le, ge) {
          return le && le < 1 && le === ge ? 1 : 0;
        }), oe = ne.filter(w).length === ne.length;
        return Y || oe;
      });
      J && L(), o.accelerationFactors = U;
    }
  }, L = function() {
    o.isMomentum = !0;
  }, S = function() {
    o = Z0(), o.isStarted = !0, o.startTime = Date.now(), u = void 0, l = !1;
  }, R = /* @__PURE__ */ function() {
    var j;
    return function() {
      clearTimeout(j), j = setTimeout(O, o.willEndTimeout);
    };
  }(), O = function(U) {
    U === void 0 && (U = !1), o.isStarted && (o.isMomentum && U ? f({
      isEnding: !0,
      isMomentumCancel: !0
    }) : f({
      isEnding: !0
    }), o.isMomentum = !1, o.isStarted = !1);
  }, I = R6(d), x = I.observe, M = I.unobserve, D = I.disconnect;
  return c(n), ls({
    on: t,
    off: r,
    observe: x,
    unobserve: M,
    disconnect: D,
    feedWheel: d,
    updateOptions: c
  });
}
var K6 = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
b1.globalOptions = void 0;
var G6 = process.env.NODE_ENV !== "production";
function b1(n) {
  n === void 0 && (n = {});
  var e, t = function() {
  };
  function r(s, o) {
    var a, l, u = o.mergeOptions, d = o.optionsAtMedia, c = u(K6, b1.globalOptions), f = u(c, n);
    e = d(f);
    var p = s.internalEngine(), h = (a = e.target) != null ? a : s.containerNode().parentNode, y = (l = e.forceWheelAxis) != null ? l : p.options.axis, g = q6({
      preventWheelAction: y,
      reverseSign: [!0, !0, !1]
    }), m = g.observe(h), $ = g.on("wheel", D), w = !1, _;
    function L(j) {
      try {
        _ = new MouseEvent("mousedown", j.event), M(_);
      } catch {
        return G6 && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), t();
      }
      w = !0, R(), e.wheelDraggingClass && h.classList.add(e.wheelDraggingClass);
    }
    function S(j) {
      w = !1, M(x("mouseup", j)), O(), e.wheelDraggingClass && h.classList.remove(e.wheelDraggingClass);
    }
    function R() {
      document.documentElement.addEventListener("mousemove", I, !0), document.documentElement.addEventListener("mouseup", I, !0), document.documentElement.addEventListener("mousedown", I, !0);
    }
    function O() {
      document.documentElement.removeEventListener("mousemove", I, !0), document.documentElement.removeEventListener("mouseup", I, !0), document.documentElement.removeEventListener("mousedown", I, !0);
    }
    function I(j) {
      w && j.isTrusted && j.stopImmediatePropagation();
    }
    function x(j, U) {
      var J, ne;
      if (y === p.options.axis) {
        var Y = U.axisMovement;
        J = Y[0], ne = Y[1];
      } else {
        var oe = U.axisMovement;
        ne = oe[0], J = oe[1];
      }
      if (!p.options.skipSnaps && !p.options.dragFree) {
        var le = p.containerRect.width, ge = p.containerRect.height;
        J = J < 0 ? Math.max(J, -le) : Math.min(J, le), ne = ne < 0 ? Math.max(ne, -ge) : Math.min(ne, ge);
      }
      return new MouseEvent(j, {
        clientX: _.clientX + J,
        clientY: _.clientY + ne,
        screenX: _.screenX + J,
        screenY: _.screenY + ne,
        movementX: J,
        movementY: ne,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function M(j) {
      s.containerNode().dispatchEvent(j);
    }
    function D(j) {
      var U = j.axisDelta, J = U[0], ne = U[1], Y = y === "x" ? J : ne, oe = y === "x" ? ne : J, le = j.isMomentum && j.previous && !j.previous.isMomentum, ge = j.isEnding && !j.isMomentum || le, he = Math.abs(Y) > Math.abs(oe);
      he && !w && !j.isMomentum && L(j), w && (ge ? S(j) : M(x("mousemove", j)));
    }
    t = function() {
      m(), $(), O();
    };
  }
  var i = {
    name: "wheelGestures",
    options: n,
    init: r,
    destroy: function() {
      return t();
    }
  };
  return i;
}
const Y6 = { class: "relative size-[4em]" }, J6 = {
  class: "size-full",
  viewBox: "0 0 100 100"
}, Z6 = ["d"], X6 = ["d"], X0 = 45, Q6 = /* @__PURE__ */ X({
  __name: "CfgCircularProgress",
  props: /* @__PURE__ */ Ae({
    circleClass: { default: "stroke-brand" },
    useBackground: { type: Boolean, default: !1 }
  }, {
    modelValue: { default: 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = 2 * Math.PI * X0, t = je(n, "modelValue"), r = Z(() => {
      const s = X0;
      return `
          M 50 50
          m 0 -${s}
          a ${s} ${s} 0 1 1 0 ${s * 2}
          a ${s} ${s} 0 1 1 0 -${s * 2}
          `;
    }), i = Z(() => t.value / 100 * e);
    return (s, o) => (k(), T("div", Y6, [
      A(v(x9), {
        modelValue: t.value,
        "onUpdate:modelValue": o[0] || (o[0] = (a) => t.value = a),
        "as-child": ""
      }, {
        default: N(() => [
          (k(), T("svg", J6, [
            s.useBackground ? (k(), T("path", {
              key: 0,
              class: "fill-none stroke-grey-50 stroke-[8px]",
              d: r.value
            }, null, 8, Z6)) : V("", !0),
            A(v(w9), { "as-child": "" }, {
              default: N(() => [
                E("path", {
                  class: B(["fill-none stroke-[8px] transition-[stroke-dasharray,opacity] duration-700 data-[value='0']:opacity-0", s.circleClass]),
                  d: r.value,
                  style: mt({
                    "stroke-linecap": "round",
                    "stroke-dasharray": `${i.value}px, ${e}px`,
                    "stroke-dashoffset": "0px"
                  })
                }, null, 14, X6)
              ]),
              _: 1
            })
          ]))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]));
  }
}), em = { class: "flex h-full" }, tm = { key: 0 }, nm = { class: "mt-5 flex items-center justify-center gap-x-3" }, rm = {
  key: 0,
  class: "absolute bottom-4 left-4"
}, im = {
  key: 1,
  class: "absolute right-4 top-4"
}, sm = {
  key: 2,
  class: "absolute bottom-4 right-4 flex items-center gap-6"
}, Q0 = 4e3, EM = /* @__PURE__ */ X({
  __name: "CfgCarousel",
  props: {
    autoplay: { type: [Boolean, Object], default: !1 },
    dots: { type: Boolean, default: !1 },
    items: {},
    options: { default: () => ({}) },
    wheelGestures: { type: Boolean, default: !1 },
    partialVisibility: { type: Boolean, default: !0 },
    arrows: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = Z(() => ({
      containScroll: n.partialVisibility ? "trimSnaps" : !1,
      ...n.options
    })), t = Z(() => {
      const w = [];
      if (n.wheelGestures && w.push(
        b1(
          typeof n.wheelGestures == "boolean" ? {} : n.wheelGestures
        )
      ), n.autoplay) {
        const _ = {
          stopOnInteraction: !1
        };
        w.push(
          f1(
            typeof n.autoplay == "boolean" ? _ : { ..._, ...n.autoplay }
          )
        );
      }
      return w;
    }), [r, i] = El(e.value, t.value), s = ae(!1), o = ae(!1), a = ae(0), l = ae([]), u = ae(100), d = ae(null), c = Z(
      () => {
        var w;
        return typeof n.autoplay == "boolean" ? Q0 : ((w = n.autoplay) == null ? void 0 : w.delay) || Q0;
      }
    );
    function f(w) {
      l.value = (w == null ? void 0 : w.scrollSnapList()) || [];
    }
    function p(w) {
      s.value = (w == null ? void 0 : w.canScrollNext()) || !1, o.value = (w == null ? void 0 : w.canScrollPrev()) || !1, a.value = (w == null ? void 0 : w.selectedScrollSnap()) || 0;
    }
    function h() {
      var w;
      (w = i.value) == null || w.scrollPrev();
    }
    function y() {
      var w;
      (w = i.value) == null || w.scrollNext();
    }
    function g(w) {
      var _;
      (_ = i.value) == null || _.scrollTo(w);
    }
    function m(w) {
      const _ = "ArrowLeft", L = "ArrowRight";
      if (w.key === _) {
        w.preventDefault(), h();
        return;
      }
      w.key === L && (w.preventDefault(), y());
    }
    Dt(() => {
      var w, _, L, S, R;
      i.value && ((w = i.value) == null || w.on("init", f), (_ = i.value) == null || _.on("init", p), (L = i.value) == null || L.on("reInit", f), (S = i.value) == null || S.on("reInit", p), (R = i.value) == null || R.on("select", p));
    }), w4(() => {
      clearInterval(d.value || 0);
    });
    function $() {
      clearInterval(d.value || 0), u.value = 0, d.value = setInterval(() => {
        const w = 1 / c.value * 1e5;
        u.value += w, u.value >= 100 && clearInterval(d.value || 0);
      }, 1e3);
    }
    return Ie(
      a,
      () => {
        !n.autoplay || !n.dots || $();
      },
      { immediate: !0 }
    ), (w, _) => (k(), T("section", {
      "aria-roledescription": "carousel",
      class: "relative",
      role: "region",
      tabindex: "0",
      onKeydown: m
    }, [
      E("div", {
        ref_key: "emblaRef",
        ref: r,
        class: "hide-scrollbar h-full overflow-hidden"
      }, [
        E("ul", em, [
          (k(!0), T(ce, null, $e(w.items, (L, S) => (k(), T("li", {
            key: S,
            "aria-roledescription": "slide",
            class: B(["shrink-0 grow-0", {
              "size-4/5": w.partialVisibility || w.wheelGestures,
              "size-full": !w.partialVisibility && !w.wheelGestures,
              "px-2": w.wheelGestures
            }]),
            role: "group"
          }, [
            te(w.$slots, "items", {
              index: S,
              item: L
            })
          ], 2))), 128))
        ]),
        w.dots ? (k(), T("div", tm, [
          te(w.$slots, "dot", {
            scrollTo: g,
            selectedIndex: a.value
          }, () => [
            E("ul", nm, [
              (k(!0), T(ce, null, $e(w.items, (L, S) => (k(), T("li", { key: S }, [
                A(Q6, {
                  class: B(["transition-all duration-200", {
                    "!size-[24px]": S === a.value,
                    "!size-[16px] opacity-50": S !== a.value
                  }]),
                  "model-value": S === a.value ? u.value : 100,
                  "use-background": "",
                  onClick: (R) => g(S)
                }, null, 8, ["class", "model-value", "onClick"])
              ]))), 128))
            ])
          ])
        ])) : V("", !0)
      ], 512),
      w.$slots.counter ? (k(), T("div", rm, [
        te(w.$slots, "counter", {
          current: a.value + 1,
          total: w.items.length
        })
      ])) : V("", !0),
      w.$slots["top-right"] ? (k(), T("div", im, [
        te(w.$slots, "top-right")
      ])) : V("", !0),
      w.arrows ? (k(), T("div", sm, [
        A(v(D4), {
          class: "!size-6 cursor-pointer text-white",
          onClick: h
        }),
        A(v(L4), {
          class: "!size-6 cursor-pointer text-white",
          onClick: y
        })
      ])) : V("", !0)
    ], 32));
  }
}), kt = {
  required: {
    type: Boolean,
    default: !1
  },
  /**
   * Placeholder text
   */
  placeholder: {
    type: String,
    default: ""
  },
  /**
   * Field error state (will show error message if provided and set to true)
   */
  error: {
    type: Boolean,
    default: !1
  },
  /**
   * Field error message
   */
  errorMessage: {
    type: String,
    default: ""
  },
  /**
   * Caption text. Will be shown below input. Recommended length is 2-3 words, like 'Enter your name'.
   * In case of error, will be replaced with error message
   */
  caption: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * Will set input focus on mount
   */
  initialFocused: {
    type: Boolean,
    default: !1
  },
  loading: {
    type: Boolean,
    default: !1
  }
}, Wt = {
  ...kt,
  /**
   * Input type like text, number, email, etc.
   */
  type: {
    type: String,
    default: "text"
  },
  /**
   * Will make input fluid (100% width)
   */
  fluid: {
    type: Boolean,
    default: !1
  },
  readonly: {
    type: Boolean,
    default: !1
  },
  /**
   * Input suffix. The Recommended length is 2-3 characters, like 'Let'
   */
  suffix: {
    type: String,
    default: ""
  },
  transformToCommaDelimiter: {
    type: Boolean,
    default: void 0
  }
}, om = { class: "flex items-start" }, am = { class: "cfg-checkbox__checkbox mt-[calc(var(--font-sm-leading)*1px)] flex size-[1.3em] items-center" }, lm = ["id", "disabled"], um = ["innerHTML"], dm = {
  key: 0,
  class: "text-red"
}, cm = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "CfgCheckbox",
  props: /* @__PURE__ */ Ae({
    ...kt,
    inputClasses: {
      type: String,
      default: ""
    },
    focused: {
      type: Boolean,
      default: !1
    },
    link: {
      type: String,
      default: ""
    }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["update:focused"], ["update:modelValue"]),
  setup(n, { emit: e }) {
    const t = n, r = e, { class: i, ...s } = $l(), o = Z(() => s.id || Ai()), a = Ca("inputRef"), l = je(n, "modelValue"), u = Z(() => ({
      root: {
        class: i || "",
        ...t.link ? { href: t.link } : {}
      },
      input: s
    })), { focused: d } = _s(a, {
      initialValue: t.initialFocused
    });
    return Ie(d, (c) => {
      r("update:focused", c);
    }), Ie(() => t.focused, (c) => {
      d.value = c;
    }), (c, f) => (k(), q(qe(n.link ? "a" : "span"), Te(u.value.root, {
      class: ["cfg-checkbox relative block", {
        focused: n.focused,
        disabled: c.disabled,
        "opacity-60": c.disabled,
        "cursor-pointer": !c.disabled,
        "cursor-not-allowed": c.disabled
      }],
      onClick: f[3] || (f[3] = Ht((p) => l.value = !l.value, ["prevent"]))
    }), {
      default: N(() => [
        E("span", om, [
          E("label", am, [
            nt(E("input", Te({
              id: String(o.value),
              ref_key: "inputRef",
              ref: a,
              "onUpdate:modelValue": f[0] || (f[0] = (p) => l.value = p)
            }, u.value.input, {
              class: ["relative z-10 size-[1.3em] rounded border-grey-stroke text-brand focus:ring-brand-200", n.inputClasses],
              disabled: c.disabled,
              type: "checkbox",
              onClick: f[1] || (f[1] = Ht(() => {
              }, ["stop"]))
            }), null, 16, lm), [
              [k4, l.value]
            ])
          ]),
          E("span", {
            class: B(["ml-3 block text-sm", {
              "text-red": c.error
            }])
          }, [
            A(K, {
              class: B(["block", {
                "cursor-pointer": !c.disabled,
                "cursor-not-allowed": c.disabled,
                "pt-1": !c.caption && !c.$slots.label && !c.placeholder,
                "text-grey-400": !c.error
              }]),
              for: String(o.value),
              size: v(G).sm,
              "tag-name": "label",
              onClick: f[2] || (f[2] = Ht(() => {
              }, ["stop"]))
            }, {
              default: N(() => [
                c.$slots.label || c.placeholder ? te(c.$slots, "label", {
                  key: 0,
                  checked: n.modelValue,
                  focused: n.focused
                }, () => [
                  E("span", {
                    class: "leading-6",
                    innerHTML: c.placeholder
                  }, null, 8, um),
                  c.required ? (k(), T("span", dm, "*")) : V("", !0)
                ], !0) : V("", !0)
              ]),
              _: 3
            }, 8, ["class", "for", "size"]),
            c.caption && c.placeholder ? (k(), q(K, {
              key: 0,
              class: B(["mt-1 block", {
                "text-grey-300": !c.error
              }]),
              size: v(G).xs
            }, {
              default: N(() => [
                W(z(c.caption), 1)
              ]),
              _: 1
            }, 8, ["class", "size"])) : V("", !0)
          ], 2)
        ]),
        c.error && c.errorMessage ? (k(), q(K, {
          key: 0,
          class: "mt-3 block text-red",
          size: v(G).xs
        }, {
          default: N(() => [
            W(z(c.errorMessage), 1)
          ]),
          _: 1
        }, 8, ["size"])) : c.caption && !c.placeholder ? (k(), q(K, {
          key: 1,
          class: "mt-3 block text-grey-300",
          size: v(G).xs
        }, {
          default: N(() => [
            W(z(c.caption), 1)
          ]),
          _: 1
        }, 8, ["size"])) : V("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), Ta = /* @__PURE__ */ Bn(cm, [["__scopeId", "data-v-dd7aa615"]]), fm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ta
}, Symbol.toStringTag, { value: "Module" })), un = {
  default: "brand",
  blue: "blue",
  success: "success",
  warning: "warning",
  danger: "danger",
  neutral: "neutral"
}, pm = { class: "cfg-assist-chip__content" }, y1 = /* @__PURE__ */ X({
  __name: "CfgChip",
  props: {
    label: {},
    color: { default: un.default }
  },
  setup(n) {
    const e = n, t = Z(() => ({
      background: {
        "bg-brand-light": e.color === un.default,
        "bg-blue/20": e.color === un.blue,
        "bg-success/20": e.color === un.success,
        "bg-warning/20": e.color === un.warning,
        "bg-red/20": e.color === un.danger,
        "bg-grey-100": e.color === un.neutral
      },
      text: {
        "text-brand": e.color === un.default,
        "text-blue": e.color === un.blue,
        "text-success": e.color === un.success,
        "text-warning": e.color === un.warning,
        "text-red": e.color === un.danger,
        "text-black": e.color === un.neutral
      }
    }));
    return (r, i) => (k(), T("span", {
      class: B(["cfg-assist-chip rounded-full", { ...t.value.background, ...t.value.text }])
    }, [
      E("span", pm, [
        r.$slots.leadingIcon ? te(r.$slots, "leadingIcon", { key: 0 }) : V("", !0),
        A(K, {
          size: v(G).xs
        }, {
          default: N(() => [
            r.$slots.default ? te(r.$slots, "default", { key: 0 }) : (k(), T(ce, { key: 1 }, [
              W(z(e.label), 1)
            ], 64))
          ]),
          _: 3
        }, 8, ["size"])
      ])
    ], 2));
  }
}), hm = { class: "relative block" }, mm = ["value"], gm = {
  inheritAttrs: !1
}, ec = /* @__PURE__ */ X({
  ...gm,
  __name: "CfgCompactInput",
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    /**
     * @param string
     * Suffix to be displayed after the input. Recommended length is 2-3 characters.
     */
    suffix: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "blur", "keydown:enter"],
  setup(n, { emit: e }) {
    const t = e;
    function r(o) {
      var a;
      t("update:modelValue", ((a = o == null ? void 0 : o.target) == null ? void 0 : a.value) || "");
    }
    function i(o) {
      var a;
      t("blur", ((a = o == null ? void 0 : o.target) == null ? void 0 : a.value) || "");
    }
    function s(o) {
      var a;
      t("keydown:enter", ((a = o == null ? void 0 : o.target) == null ? void 0 : a.value) || "");
    }
    return (o, a) => {
      var l;
      return k(), T("label", hm, [
        E("input", Te({
          class: ["cfg-slider__input focusable w-full rounded-md border border-grey-stroke px-3 py-2 text-xs !leading-none", {
            "!pr-11": !!((l = n.suffix) != null && l.trim())
          }],
          value: n.modelValue
        }, o.$attrs, {
          onBlur: i,
          onInput: r,
          onKeydown: Yn(s, ["enter"])
        }), null, 16, mm),
        n.suffix ? (k(), q(K, {
          key: 0,
          class: "absolute right-4 top-1/2 -translate-y-1/2 leading-none text-grey-300",
          size: v(G).xs
        }, {
          default: N(() => [
            W(z(n.suffix), 1)
          ]),
          _: 1
        }, 8, ["size"])) : V("", !0)
      ]);
    };
  }
});
function tc(n) {
  return typeof n == "function" ? n() : v(n);
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const bm = (n) => n != null;
function ym(n, e = {}) {
  let t;
  const { immediate: r, ...i } = e, s = ae(!1), o = ae(!1), a = (f) => t && t.activate(f), l = (f) => t && t.deactivate(f), u = () => {
    t && (t.pause(), o.value = !0);
  }, d = () => {
    t && (t.unpause(), o.value = !1);
  }, c = Z(() => {
    const f = tc(n);
    return (Array.isArray(f) ? f : [f]).map((p) => {
      const h = tc(p);
      return typeof h == "string" ? h : l9(h);
    }).filter(bm);
  });
  return Ie(
    c,
    (f) => {
      f.length && (t = J9(f, {
        ...i,
        onActivate() {
          s.value = !0, e.onActivate && e.onActivate();
        },
        onDeactivate() {
          s.value = !1, e.onDeactivate && e.onDeactivate();
        }
      }), r && a());
    },
    { flush: "post" }
  ), u9(() => l()), {
    hasFocus: s,
    isPaused: o,
    activate: a,
    deactivate: l,
    pause: u,
    unpause: d
  };
}
const vm = ["aria-expanded"], _m = {
  inheritAttrs: !1
}, $m = /* @__PURE__ */ X({
  ..._m,
  __name: "CfgDropdown",
  props: {
    /**
     * Controls the position of the menu;
     */
    originX: {
      type: String,
      default: "right"
    },
    /**
     * Controls showing overlay under other elements
     */
    overlay: {
      type: Boolean,
      default: !1
    },
    maxWidth: {
      type: String,
      default: "280px"
    },
    hideOnScroll: {
      type: Boolean,
      default: !1
    }
  },
  setup(n, { expose: e }) {
    const t = n, r = 50, i = ae(!1), s = ae(null), o = ae(null), a = ae(null), l = ae(i.value);
    let u = null;
    const { deactivate: d, activate: c } = ym(a, {
      immediate: !1,
      preventScroll: !0,
      clickOutsideDeactivates: !0
    });
    Dt(() => {
      if (ad(document.documentElement, "keydown", (w) => {
        w.key === "Escape" && $();
      }), t.hideOnScroll) {
        let w = 0;
        ad(window, "scroll", () => {
          w += 1, w > 3 && ($(), w = 0);
        });
      }
    });
    const { x: f, y: p, strategy: h } = s1(o, a, {
      placement: "bottom-end",
      whileElementsMounted: o1
    });
    Ie(i, (w) => {
      w || (u && (clearTimeout(u), u = null), u = setTimeout(() => {
        l.value = w;
      }, w ? 0 : r), g() && d()), l.value = w;
    });
    function y() {
      g() && c();
    }
    function g() {
      return a.value && a.value.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').length > 0;
    }
    function m() {
      i.value = !0;
    }
    function $() {
      i.value = !1;
    }
    return e({ open: m, close: $ }), (w, _) => (k(), T("div", {
      ref_key: "dropdownRoot",
      ref: s
    }, [
      E("div", Te(w.$attrs, {
        class: ["relative w-max", {
          "z-floating-overlay": i.value && n.overlay
        }]
      }), [
        E("div", {
          ref_key: "menuButton",
          ref: o
        }, [
          E("button", {
            "aria-expanded": i.value,
            class: B(["focusable flex cursor-pointer items-center justify-center", {
              "relative z-floating-trigger rounded-t-xl bg-white": i.value && n.overlay,
              "lg:hover:bor==der-brand rounded-xl hover:!text-brand": !i.value && n.overlay,
              "border-2 border-transparent !transition-all !duration-300": n.overlay
            }]),
            type: "button",
            onClick: _[0] || (_[0] = (L) => i.value ? $() : m())
          }, [
            te(w.$slots, "trigger", { opened: i.value })
          ], 10, vm)
        ], 512),
        (k(), q(e1, { to: "body" }, [
          E("div", {
            class: B(["fixed inset-0 z-floating-overlay", {
              "pointer-events-none opacity-0": !i.value,
              "bg-black/30": n.overlay
            }]),
            onClick: $,
            onKeydown: Yn(() => {
            }, ["enter"])
          }, null, 34),
          A($i, {
            "enter-active-class": "transition duration-200 ease-out",
            "enter-from-class": "transform scale-75 -translate-y-3 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
            "leave-active-class": "transition duration-200 ease-out",
            "leave-from-class": "transform scale-100 translate-y-0 opacity-100",
            "leave-to-class": "transform scale-75 -translate-y-3 opacity-0",
            onAfterEnter: y
          }, {
            default: N(() => [
              l.value ? nt((k(), T("div", {
                key: 0,
                ref_key: "dropdownContent",
                ref: a,
                class: B(["dropdown-content z-floating-content w-max bg-white focus:outline-none", {
                  "origin-top-right": n.originX === "right",
                  "left-0 origin-top-left": n.originX === "left",
                  "mt-2 rounded-xl shadow-extra": !n.overlay,
                  "rounded-b-xl rounded-tl-xl": n.overlay
                }]),
                style: mt({
                  top: `${v(p)}px`,
                  left: `${v(f)}px`,
                  position: v(h),
                  maxWidth: n.maxWidth
                })
              }, [
                te(w.$slots, "default", {
                  close: $,
                  opened: i.value
                })
              ], 6)), [
                [xl, i.value]
              ]) : V("", !0)
            ]),
            _: 3
          })
        ]))
      ], 16)
    ], 512));
  }
}), xm = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "CfgTransition",
  props: {
    from: {},
    to: {},
    rendered: { type: Boolean },
    as: { default: "span" }
  },
  async setup(n) {
    let e, t;
    const r = ([e, t] = _l(() => import("gsap")), e = await e, t(), e).default;
    return (i, s) => (k(), q($i, {
      css: !1,
      onBeforeEnter: s[0] || (s[0] = (o) => {
        v(r).set(o, i.from);
      }),
      onEnter: s[1] || (s[1] = (o, a) => {
        v(r).to(o, { ...i.to, onComplete: a });
      }),
      onLeave: s[2] || (s[2] = (o, a) => {
        v(r).to(o, {
          ...i.from,
          onComplete: a
        });
      })
    }, {
      default: N(() => [
        i.rendered ? (k(), T("span", Fr(Te({ key: 0 }, i.$attrs)), [
          te(i.$slots, "default")
        ], 16)) : V("", !0)
      ]),
      _: 3
    }));
  }
}), wm = ["aria-pressed"], km = { class: "filter-chip__content" }, Cm = {
  class: "filter-chip__close-icon",
  style: { "--stroke-width": "2px" }
}, TM = /* @__PURE__ */ X({
  __name: "CfgFilterChip",
  props: /* @__PURE__ */ Ae({
    label: {}
  }, {
    modelValue: { type: Boolean, type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = je(n, "modelValue");
    return (t, r) => (k(), T("button", {
      "aria-pressed": e.value,
      class: B(["filter-chip focusabl", {
        "filter-chip--selected !border-brand-light bg-brand-light focus:!border-brand-light": e.value,
        "!border-grey-300 focus:!border-grey-300": !e.value
      }]),
      type: "button",
      onClick: r[0] || (r[0] = () => {
        t.$attrs.disabled || (e.value = !e.value);
      })
    }, [
      E("span", km, [
        t.$slots.leadingIcon ? te(t.$slots, "leadingIcon", { key: 0 }) : V("", !0),
        A(K, {
          size: v(G).sm,
          "tag-name": "span"
        }, {
          default: N(() => [
            W(z(t.label), 1)
          ]),
          _: 1
        }, 8, ["size"])
      ]),
      A(xm, {
        from: {
          width: 0,
          autoAlpha: 0,
          duration: 0.25,
          ease: "power3.out"
        },
        rendered: e.value,
        to: {
          autoAlpha: 1,
          width: 20,
          duration: 0.25,
          ease: "power3.out"
        }
      }, {
        default: N(() => [
          E("span", Cm, [
            A(v(Ut), { class: "text-[12px] text-grey-400" })
          ])
        ]),
        _: 1
      }, 8, ["rendered"])
    ], 10, wm));
  }
}), Sm = {
  primary: "primary",
  secondary: "secondary",
  grey: "grey",
  light: "light",
  warning: "warning",
  dark: "dark"
}, Em = { class: "container mx-auto py-3" }, Tm = { class: "flex flex-wrap items-center justify-between" }, Om = { class: "flex w-0 flex-1 items-center" }, Mm = {
  key: 0,
  class: "cfg-header-banner--icon flex rounded-lg p-2"
}, Am = {
  key: 1,
  class: "cfg-header-banner--text ml-3"
}, Nm = {
  key: 0,
  class: "order-3 mt-2 w-full shrink-0 sm:order-2 sm:mt-0 sm:w-auto"
}, Dm = { class: "order-2 shrink-0 sm:order-3 sm:ml-3" }, OM = /* @__PURE__ */ X({
  __name: "CfgHeaderBanner",
  props: /* @__PURE__ */ Ae({
    variant: { default: Sm.primary },
    modelValue: { type: Boolean, default: !0 },
    text: { default: "" },
    buttonText: { default: "" },
    buttonLink: { default: "" }
  }, {
    modelValue: { type: Boolean, default: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = je(n, "modelValue");
    return (t, r) => {
      const i = C4("RouterLink");
      return nt((k(), T("div", {
        class: B(["cfg-header-banner", { [`cfg-header-banner--${t.variant}`]: !0 }])
      }, [
        E("div", Em, [
          E("div", Tm, [
            E("div", Om, [
              t.$slots.icon ? (k(), T("span", Mm, [
                te(t.$slots, "icon", {
                  ariaHidden: "true",
                  class: "size-6"
                })
              ])) : V("", !0),
              t.text || t.$slots.default ? (k(), T("p", Am, [
                te(t.$slots, "default", {}, () => [
                  W(z(t.text), 1)
                ])
              ])) : V("", !0)
            ]),
            t.buttonLink ? (k(), T("div", Nm, [
              A(i, {
                class: "cfg-header-banner--link flex items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm",
                to: t.buttonLink
              }, {
                default: N(() => [
                  W(z(t.buttonText || t.buttonLink), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])) : V("", !0),
            E("div", Dm, [
              E("button", {
                class: "cfg-header-banner--dismiss -mr-1 flex rounded-md p-2 focus:outline-none focus:ring-2 sm:-mr-2",
                type: "button",
                onClick: r[0] || (r[0] = (s) => e.value = !1)
              }, [
                r[1] || (r[1] = E("span", { class: "sr-only" }, "Dismiss", -1)),
                A(v(Ut), {
                  "aria-hidden": "true",
                  class: "size-6"
                })
              ])
            ])
          ])
        ])
      ], 2)), [
        [xl, e.value]
      ]);
    };
  }
}), Lm = {
  key: 0,
  class: "text-field-template__left top-4 !max-w-[30px]"
}, Rm = {
  key: 0,
  class: "text-red"
}, Pm = {
  key: 1,
  class: "text-field-template__right absolute top-1/2 flex -translate-y-1/2 items-center justify-center"
}, Im = /* @__PURE__ */ X({
  __name: "AbstractTextField",
  props: {
    required: { type: Boolean },
    placeholder: { default: "" },
    fluid: { type: Boolean },
    error: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    empty: { type: Boolean, default: !0 },
    focused: { type: Boolean },
    placeholderAs: { default: "span" },
    placeholderAttrs: { default: () => ({}) },
    loading: { type: Boolean },
    height: { default: void 0 },
    as: { default: "span" }
  },
  emits: ["update:focused"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = Z(() => ({
      "--height": t.height || "var(--input-height)"
    })), s = ae(), { focused: o } = _s(s), a = Z(() => t.focused || !t.empty);
    return Ie(o, (l) => {
      r("update:focused", l);
    }), (l, u) => {
      var d, c, f, p;
      return k(), q(qe(l.as), {
        ref_key: "textFieldRef",
        ref: s,
        class: B(["text-field-template relative block rounded-xl text-sm transition-all duration-200", {
          "w-full": l.fluid,
          "w-max": !l.fluid,
          "with-right-content": (c = (d = l.$slots).placeRight) == null ? void 0 : c.call(d),
          "with-left-content": (p = (f = l.$slots).placeLeft) == null ? void 0 : p.call(f),
          "opacity-50": l.disabled
        }]),
        style: mt(i.value),
        onClick: u[0] || (u[0] = () => {
          o.value = !0;
        }),
        onKeypress: u[1] || (u[1] = Yn(() => {
          o.value = !0;
        }, ["enter"]))
      }, {
        default: N(() => [
          l.$slots.placeLeft ? (k(), T("span", Lm, [
            te(l.$slots, "placeLeft", {}, void 0, !0)
          ])) : V("", !0),
          (k(), q(qe(l.placeholderAs), Te(l.placeholderAttrs, {
            class: ["text-field-template__placeholder absolute left-[var(--pl)] origin-top-left -translate-y-1/2 cursor-text leading-none text-grey-200 transition-all duration-200", {
              active: a.value,
              "text-red": l.error,
              "!text-brand": !l.error && a.value && l.focused
            }]
          }), {
            default: N(() => [
              W(z(l.placeholder) + " ", 1),
              l.required ? (k(), T("span", Rm, "*")) : V("", !0)
            ]),
            _: 1
          }, 16, ["class"])),
          E("span", {
            class: B(["text-field-template__wrapper block rounded-xl border transition duration-200", {
              "border-grey-stroke": !a.value || !l.focused,
              "border-brand": a.value && l.focused,
              "disabled:border-gray-200 disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-grey-500": l.disabled,
              "error border-red text-red": l.error
            }])
          }, [
            te(l.$slots, "default", {}, void 0, !0)
          ], 2),
          l.$slots.placeRight || l.loading ? (k(), T("span", Pm, [
            l.loading ? (k(), q(v(No), {
              key: 0,
              class: "text-[6px] text-brand"
            })) : te(l.$slots, "placeRight", { key: 1 }, void 0, !0)
          ])) : V("", !0)
        ]),
        _: 3
      }, 40, ["class", "style"]);
    };
  }
}), v1 = /* @__PURE__ */ Bn(Im, [["__scopeId", "data-v-491723f9"]]), Bm = { class: "absolute left-3 top-4 z-10" }, zm = { class: "block leading-none" }, Vm = ["id", "disabled", "readonly", "tabindex", "type", "value"], Fm = { class: "absolute inset-y-0 right-0 flex items-center" }, jm = {
  key: 0,
  class: "block max-w-full pt-1 text-red"
}, Hm = ["innerHTML"], pn = /* @__PURE__ */ X({
  __name: "CfgInput",
  props: /* @__PURE__ */ Ae({
    ...kt,
    ...Wt,
    fieldClass: {
      type: String,
      default: ""
    },
    /**
     * If false, icon slot will have pointer-events-none class
     * @default false
     */
    interactWithIcon: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["input", "focusout", "focusin", "blur", "keydown"], ["update:modelValue"]),
  setup(n, { expose: e, emit: t }) {
    const r = n, i = t, s = Ai(), o = je(n, "modelValue"), a = Z(() => r.transformToCommaDelimiter !== void 0 ? r.transformToCommaDelimiter : r.type === "number"), l = Z(() => a.value && a.value && r.type === "number" ? "tel" : r.type), u = Z(() => a.value ? String(o.value).replaceAll(".", ",") : o.value), d = R2(), c = Z(() => !String(o.value).trim().length), f = Z(() => !!(d.icon || r.suffix) || r.type === "search" && !c.value), p = ae(), { focused: h } = _s(p, {
      initialValue: r.initialFocused
    });
    e({
      focus() {
        h.value = !0;
      }
    }), Ie(h, (w) => {
      i(w ? "focusin" : "focusout");
    });
    function y(w) {
      w && (h.value = !0);
    }
    function g(w) {
      const { value: _ } = w.target;
      if (a.value) {
        o.value = m(
          _.replace(/[^0-9,.]/g, "").replaceAll(",", ".")
          // replace comma with dot
        );
        return;
      }
      o.value = _;
    }
    function m(w) {
      const _ = w.split(".");
      if (_.length > 1 && _[0] !== "") {
        const L = _[0], S = _.slice(1).join("");
        return `${L}.${S}`;
      }
      return w.replaceAll(".", "");
    }
    function $() {
      o.value = "", y(!0);
    }
    return (w, _) => (k(), T("div", {
      class: B({ "w-full": w.fluid, "w-72": !w.fluid })
    }, [
      E("div", Bm, [
        te(w.$slots, "placeLeft")
      ]),
      A(v(v1), {
        as: "label",
        class: B(["cursor-text bg-white", { [n.fieldClass]: n.fieldClass }]),
        disabled: w.disabled,
        empty: c.value,
        error: w.error,
        fluid: !0,
        focused: v(h),
        loading: w.loading,
        placeholder: w.placeholder,
        "placeholder-as": "span",
        "placeholder-attrs": { for: v(s) },
        readonly: w.readonly,
        required: w.required,
        "onUpdate:focused": y
      }, vs({
        default: N(() => [
          E("span", zm, [
            E("input", Te({
              id: v(s),
              ref_key: "inputRef",
              ref: p,
              class: "w-full border-none bg-transparent p-0 leading-none outline-none focus:border-none focus:outline-none focus:ring-0 focus-visible:outline-none",
              disabled: w.disabled,
              readonly: w.readonly,
              tabindex: w.readonly ? -1 : 0,
              type: l.value,
              value: u.value
            }, w.$attrs.autocomplete ? {
              autocomplete: w.$attrs.autocomplete
            } : {}, {
              onBlur: _[0] || (_[0] = (L) => i("blur")),
              onFocusin: _[1] || (_[1] = (L) => h.value = !0),
              onFocusout: _[2] || (_[2] = (L) => h.value = !1),
              onInput: g,
              onKeydown: _[3] || (_[3] = (L) => i("keydown", L))
            }), null, 16, Vm)
          ])
        ]),
        _: 2
      }, [
        w.$slots.placeLeft ? {
          name: "placeLeft",
          fn: N(() => []),
          key: "0"
        } : void 0,
        f.value ? {
          name: "placeRight",
          fn: N(() => [
            E("div", Fm, [
              w.suffix ? (k(), T("span", {
                key: 0,
                id: "price-currency",
                class: B(["text-grey-500 sm:text-sm", { "pointer-events-none": !n.interactWithIcon }])
              }, z(w.suffix), 3)) : V("", !0),
              w.type === "search" && String(o.value).length ? (k(), q(hr, {
                key: 1,
                flat: "",
                text: "",
                onClick: $
              }, {
                default: N(() => [
                  A(v(Ut))
                ]),
                _: 1
              })) : w.$slots.icon ? te(w.$slots, "icon", {
                key: 2,
                class: B({ "pointer-events-none": !n.interactWithIcon })
              }) : V("", !0)
            ])
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["class", "disabled", "empty", "error", "focused", "loading", "placeholder", "placeholder-attrs", "readonly", "required"]),
      w.error && w.errorMessage ? (k(), T("small", jm, z(w.errorMessage), 1)) : V("", !0),
      !(w.errorMessage && w.error) && w.caption ? (k(), T("small", {
        key: 1,
        class: "block max-w-full pt-1 text-grey-300",
        innerHTML: w.caption
      }, null, 8, Hm)) : V("", !0)
    ], 2));
  }
}), MM = /* @__PURE__ */ X({
  __name: "CfgOtpInput",
  props: /* @__PURE__ */ Ae({
    placeholder: {},
    disabled: { type: Boolean },
    size: { default: 6 },
    error: { type: Boolean, default: !1 },
    inputClass: { default: "" }
  }, {
    modelValue: { default: [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["complete"], ["update:modelValue"]),
  setup(n) {
    const e = je(n, "modelValue");
    return (t, r) => (k(), q(v(k9), {
      modelValue: e.value,
      "onUpdate:modelValue": r[0] || (r[0] = (i) => e.value = i),
      class: "flex items-center gap-x-4",
      otp: "",
      type: "number",
      onComplete: r[1] || (r[1] = (i) => t.$emit("complete", i))
    }, {
      default: N(() => [
        (k(!0), T(ce, null, $e(t.size, (i, s) => (k(), q(v(C9), {
          key: i,
          class: B(["size-14 rounded-lg border-[#e8e8f0] bg-white text-center focus:border-[#e8e8f0] focus:outline focus:outline-2 focus:outline-offset-0 focus:outline-brand", {
            [t.inputClass]: !0,
            "shadow-[0_2px_0_0_#D16363]": t.error
          }]),
          index: s
        }, null, 8, ["class", "index"]))), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), Um = { class: "flex items-center gap-x-4" }, Wm = { class: "-m-3 flex grow justify-center gap-x-1 overflow-auto p-3 transition-all md:gap-x-2.5" }, qm = /* @__PURE__ */ X({
  __name: "CfgPagination",
  props: {
    page: {},
    totalItems: {},
    itemsPerPage: {},
    goToPage: { type: Boolean, default: !1 }
  },
  emits: ["update:page"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = ae(t.page), s = Z(() => Array.from({
      length: Math.ceil(t.totalItems / t.itemsPerPage)
    })), o = Z(() => {
      const p = Math.ceil(t.totalItems / t.itemsPerPage), h = 1, y = [], g = 5 + h * 2;
      let m = p <= g ? 1 : t.page - h, $ = p <= g ? p : t.page + h;
      if ($ = $ > p ? p : $, m = m < 1 ? 1 : m, p > g) {
        const w = m - 1 < 3, _ = p - $ < 3;
        if (w) {
          $ = g - 2;
          for (let L = 1; L < m; L++)
            y.push(L);
        } else
          y.push(1), y.push(null);
        if (_) {
          m = p - (g - 3);
          for (let L = m; L <= p; L++)
            y.push(L);
        } else {
          for (let L = m; L <= $; L++)
            y.push(L);
          y.push(null), y.push(p);
        }
      } else
        for (let w = m; w <= $; w++)
          y.push(w);
      return y;
    }), a = Z(() => t.page > 1), l = Z(() => t.page < s.value.length);
    function u() {
      if (a.value) {
        const p = t.page - 1;
        i.value = p, r("update:page", p);
      }
    }
    function d() {
      if (l.value) {
        const p = t.page + 1;
        i.value = p, r("update:page", p);
      }
    }
    function c(p) {
      r("update:page", p);
    }
    function f() {
      const p = Number(i.value), h = t.page;
      p && p > 0 && p <= s.value.length && p !== h ? r("update:page", p) : p > s.value.length && r("update:page", s.value.length);
    }
    return (p, h) => (k(), T("nav", Um, [
      E("button", {
        "aria-label": "Předchozí stránka",
        class: B(["focusable hidden rounded-md px-2 text-lg text-brand md:block", {
          "cursor-not-allowed opacity-50": !a.value
        }]),
        type: "button",
        onClick: u
      }, [
        A(v(ao))
      ], 2),
      E("ul", Wm, [
        (k(!0), T(ce, null, $e(o.value, (y, g) => (k(), T("li", {
          key: y || g
        }, [
          (k(), q(qe(y ? "a" : "span"), {
            class: B(["rounded-md border py-[0.5em] text-sm font-highlighted leading-none transition-colors duration-200", {
              "text-brand": y === p.page,
              "border-[transparent] text-grey-300": y !== p.page,
              "lg:hover:border-grey-stroke lg:hover:text-grey-400": p.page && y !== p.page,
              "focusable px-3": p.page
            }]),
            href: `page=${y}`,
            onClick: Ht((m) => y && c(y), ["prevent"])
          }, {
            default: N(() => [
              E("span", null, z(y || "..."), 1)
            ]),
            _: 2
          }, 1032, ["class", "href", "onClick"]))
        ]))), 128))
      ]),
      E("button", {
        "aria-label": "Další stránka",
        class: B(["focusable hidden rounded-md px-2 text-lg text-brand md:block", {
          "cursor-not-allowed opacity-50": !l.value
        }]),
        type: "button",
        onClick: d
      }, [
        A(v(mn))
      ], 2),
      t.goToPage ? (k(), q(pn, {
        key: 0,
        modelValue: i.value,
        "onUpdate:modelValue": h[0] || (h[0] = (y) => i.value = y),
        class: "max-w-[130px]",
        placeholder: "Přejít na stránku:",
        "transform-to-comma-delimiter": !1,
        type: "number",
        onBlur: f,
        onKeyup: Yn(f, ["enter"])
      }, null, 8, ["modelValue"])) : V("", !0)
    ]));
  }
}), Km = { class: "cfg-radio flex gap-x-3" }, Gm = ["for"], Ym = ["id", "checked", "disabled"], Jm = ["for"], Zm = ["innerHTML"], Xm = {
  inheritAttrs: !1
}, Qm = /* @__PURE__ */ X({
  ...Xm,
  __name: "CfgRadio",
  props: {
    ...Wt,
    modelValue: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = $l(), s = Z(() => i.id || Ai()), o = ae();
    _s(o, {
      initialValue: t.initialFocused
    });
    function a(l) {
      var u;
      r("update:modelValue", ((u = l == null ? void 0 : l.target) == null ? void 0 : u.checked) ?? !t.modelValue);
    }
    return (l, u) => (k(), T("div", null, [
      E("div", Km, [
        E("label", {
          class: "block",
          for: s.value
        }, [
          E("input", Te({ id: s.value }, l.$attrs, {
            ref_key: "inputRef",
            ref: o,
            checked: n.modelValue,
            class: ["focusable size-5 border-grey-stroke text-brand", {
              "!border-red": l.error
            }],
            disabled: l.disabled,
            type: "radio",
            onChange: a
          }), null, 16, Ym)
        ], 8, Gm),
        l.$slots.default || n.placeholder ? (k(), T("label", {
          key: 0,
          class: B(["block grow", {
            "text-dark-100": n.modelValue,
            "text-grey-300": !n.modelValue,
            "!text-red": l.error
          }]),
          for: s.value
        }, [
          A(K, {
            class: B({
              "opacity-40": l.disabled,
              "cursor-pointer": !l.disabled,
              "cursor-not-allowed": l.disabled,
              "text-grey-400": !l.error
            }),
            size: v(G).sm
          }, {
            default: N(() => [
              te(l.$slots, "default", {}, () => [
                E("span", { innerHTML: n.placeholder }, null, 8, Zm)
              ])
            ]),
            _: 3
          }, 8, ["class", "size"]),
          l.caption ? (k(), q(K, {
            key: 0,
            class: B(["mt-1 block", {
              "text-grey-300": !l.error
            }]),
            size: v(G).xs
          }, {
            default: N(() => [
              W(z(l.caption), 1)
            ]),
            _: 1
          }, 8, ["class", "size"])) : V("", !0)
        ], 10, Jm)) : V("", !0)
      ]),
      l.error && l.errorMessage ? (k(), q(K, {
        key: 0,
        class: "mt-3 block text-red",
        size: v(G).xs
      }, {
        default: N(() => [
          W(z(l.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : l.caption && !n.placeholder ? (k(), q(K, {
        key: 1,
        class: "mt-3 block text-grey-300",
        size: v(G).xs
      }, {
        default: N(() => [
          W(z(l.caption), 1)
        ]),
        _: 1
      }, 8, ["size"])) : V("", !0)
    ]));
  }
}), e8 = /* @__PURE__ */ X({
  __name: "CfgScrollbarView",
  props: {
    as: { default: "div" }
  },
  setup(n, { expose: e }) {
    const t = ae(void 0), r = ae(0);
    Dt(() => {
      var s;
      (s = t.value) == null || s.addEventListener("scroll", i);
    }), Mi(() => {
      var s;
      (s = t.value) == null || s.removeEventListener("scroll", i);
    }), e({
      scrollPositionY: r
    });
    function i() {
      var s;
      r.value = ((s = t.value) == null ? void 0 : s.scrollTop) || 0;
    }
    return (s, o) => (k(), q(qe(s.as), {
      ref_key: "scrollbarView",
      ref: t,
      class: "cfg-scrollbar-view overflow-y-auto"
    }, {
      default: N(() => [
        te(s.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 512));
  }
}), t8 = /* @__PURE__ */ Bn(e8, [["__scopeId", "data-v-1c2ab057"]]), ap = /* @__PURE__ */ X({
  __name: "CfgSeparator",
  props: {
    negativeMargin: { type: Boolean, default: !0 },
    size: { default: 2 }
  },
  setup(n) {
    return (e, t) => (k(), T("hr", {
      class: B(["my-6 border-stroke-gray", {
        "max-md:-mx-5": e.negativeMargin,
        "border-t-2": e.size === 2,
        "border-t": e.size === 1
      }])
    }, null, 2));
  }
}), n8 = { class: "sr-only" }, r8 = { class: "absolute left-0 top-0 size-full rounded-[inherit] bg-[inherit]" }, i8 = ["innerHTML"], AM = /* @__PURE__ */ X({
  __name: "CfgSwitch",
  props: /* @__PURE__ */ Ae(kt, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = n, t = je(n, "modelValue"), r = ae();
    return _s(r, {
      initialValue: e.initialFocused
    }), (i, s) => (k(), q(v(V9), null, {
      default: N(() => [
        E("div", {
          class: B(["flex gap-x-4 gap-y-3", {
            "flex-col": !i.placeholder,
            "cursor-pointer": !i.disabled,
            "cursor-not-allowed": i.disabled
          }])
        }, [
          A(v(F9), {
            ref_key: "inputRef",
            ref: r,
            modelValue: t.value,
            "onUpdate:modelValue": s[0] || (s[0] = (o) => t.value = o),
            class: B(["cfg-switch relative inline-flex h-[27px] w-11 shrink-0 rounded-full border-[3px] border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2", {
              "cfg-switch--selected": t.value,
              "!bg-red/10": i.error
            }]),
            disabled: i.disabled
          }, {
            default: N(() => [
              E("span", n8, z(i.placeholder), 1),
              E("span", {
                "aria-hidden": "true",
                class: B(["cfg-switch__swiper pointer-events-none mx-0 inline-block size-[calc(27px-6px)] rounded-full ring-0 transition duration-200 ease-in-out", {
                  "translate-x-4 bg-brand text-white": t.value,
                  "translate-x-0 bg-white text-grey-300": !t.value,
                  "bg-red": i.error && t.value
                }])
              }, [
                E("span", r8, [
                  n.modelValue ? te(i.$slots, "enabled", { key: 0 }) : te(i.$slots, "disabled", { key: 1 })
                ])
              ], 2)
            ]),
            _: 3
          }, 8, ["modelValue", "class", "disabled"]),
          E("div", null, [
            i.placeholder ? (k(), q(v(j9), {
              key: 0,
              class: "flex items-center"
            }, {
              default: N(() => [
                A(K, {
                  class: B({
                    "opacity-40": i.disabled,
                    "cursor-pointer": !i.disabled,
                    "cursor-not-allowed": i.disabled,
                    "text-red": i.error,
                    "text-grey-400": !i.error
                  }),
                  size: v(G).sm
                }, {
                  default: N(() => [
                    W(z(i.placeholder), 1)
                  ]),
                  _: 1
                }, 8, ["class", "size"])
              ]),
              _: 1
            })) : V("", !0),
            i.caption || i.error && i.errorMessage ? (k(), q(v(H9), {
              key: 1,
              class: "cursor-text"
            }, {
              default: N(() => [
                i.caption && !(i.error && i.errorMessage) ? (k(), q(K, {
                  key: 0,
                  class: B(["mt-1 block cursor-text text-grey-300", { "mt-0": !i.placeholder }]),
                  size: v(G).xs
                }, {
                  default: N(() => [
                    E("span", { innerHTML: i.caption }, null, 8, i8)
                  ]),
                  _: 1
                }, 8, ["class", "size"])) : i.errorMessage && i.error ? (k(), q(K, {
                  key: 1,
                  class: B(["mt-1 block cursor-text text-red", { "mt-0": !i.placeholder }]),
                  size: v(G).xs
                }, {
                  default: N(() => [
                    W(z(i.errorMessage), 1)
                  ]),
                  _: 1
                }, 8, ["class", "size"])) : V("", !0)
              ]),
              _: 1
            })) : V("", !0)
          ])
        ], 2)
      ]),
      _: 3
    }));
  }
}), lp = {
  required: {
    type: Boolean,
    default: !1
  },
  /**
   * Placeholder text
   */
  placeholder: {
    type: String,
    default: ""
  },
  /**
   * Field error state (will show error message if provided and set to true)
   */
  error: {
    type: Boolean,
    default: !1
  },
  /**
   * Field error message
   */
  errorMessage: {
    type: String,
    default: ""
  },
  /**
   * Caption text. Will be shown below input. Recommended length is 2-3 words, like 'Enter your name'.
   * In case of error, will be replaced with error message
   */
  caption: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * Will set input focus on mount
   */
  initialFocused: {
    type: Boolean,
    default: !1
  },
  loading: {
    type: Boolean,
    default: !1
  }
}, s8 = {
  ...lp,
  /**
   * Will make input fluid (100% width)
   */
  fluid: {
    type: Boolean,
    default: !1
  },
  readonly: {
    type: Boolean,
    default: !1
  }
}, o8 = { class: "block leading-none" }, a8 = ["id", "disabled", "readonly", "tabindex", "value"], l8 = {
  key: 0,
  class: "block max-w-full pt-1 text-red"
}, u8 = ["innerHTML"], NM = /* @__PURE__ */ X({
  __name: "CfgTextarea",
  props: /* @__PURE__ */ Ae({
    ...lp,
    ...s8,
    fieldClass: {
      type: String,
      default: ""
    },
    minHeight: {
      type: Number,
      default: 100
    }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["input", "focusout", "focusin", "blur", "keydown"], ["update:modelValue"]),
  setup(n, { expose: e, emit: t }) {
    const r = n, i = t, s = Ai(), o = je(n, "modelValue"), a = Z(() => !String(o.value).trim().length), { textarea: l, input: u } = d9(), { focused: d } = _s(l, {
      initialValue: r.initialFocused
    }), { height: c } = i1(l);
    e({
      focus() {
        d.value = !0;
      }
    }), Ie(d, (h) => {
      i(h ? "focusin" : "focusout");
    });
    function f(h) {
      h && (d.value = !0);
    }
    function p(h) {
      const { value: y } = h.target;
      u.value = y, o.value = y;
    }
    return (h, y) => (k(), T("div", {
      class: B({ "w-full": h.fluid, "w-72": !h.fluid })
    }, [
      A(v(v1), {
        caption: h.caption,
        class: B(["cursor-text bg-white", { [n.fieldClass]: n.fieldClass }]),
        disabled: h.disabled,
        empty: a.value,
        error: h.error,
        fluid: !0,
        focused: v(d),
        height: `${v(c)}px`,
        loading: h.loading,
        placeholder: h.placeholder,
        "placeholder-as": "label",
        "placeholder-attrs": { for: v(s) },
        readonly: h.readonly,
        required: h.required,
        "onUpdate:focused": f
      }, {
        default: N(() => [
          E("label", o8, [
            E("textarea", {
              id: v(s),
              ref_key: "textareaRef",
              ref: l,
              class: "w-full resize-none border-none bg-transparent p-0 outline-none focus:border-none focus:outline-none focus:ring-0 focus-visible:outline-none",
              disabled: h.disabled,
              readonly: h.readonly,
              style: mt({ minHeight: `${n.minHeight}px` }),
              tabindex: h.readonly ? -1 : 0,
              value: o.value,
              onBlur: y[0] || (y[0] = (g) => i("blur")),
              onFocusin: y[1] || (y[1] = (g) => d.value = !0),
              onFocusout: y[2] || (y[2] = (g) => d.value = !1),
              onInput: p,
              onKeydown: y[3] || (y[3] = (g) => i("keydown", g))
            }, null, 44, a8)
          ])
        ]),
        _: 1
      }, 8, ["caption", "class", "disabled", "empty", "error", "focused", "height", "loading", "placeholder", "placeholder-attrs", "readonly", "required"]),
      h.error && h.errorMessage ? (k(), T("small", l8, z(h.errorMessage), 1)) : V("", !0),
      !(h.errorMessage && h.error) && h.caption ? (k(), T("small", {
        key: 1,
        class: "block max-w-full pt-1 text-grey-300",
        innerHTML: h.caption
      }, null, 8, u8)) : V("", !0)
    ], 2));
  }
}), d8 = { class: "mx-auto flex max-w-[310px] shrink-0 flex-col items-center text-center sm:max-w-[360px]" }, c8 = { class: "mx-auto flex max-w-[500px] grow flex-col items-center justify-center py-10 text-center" }, f8 = ["innerHTML"], DM = /* @__PURE__ */ X({
  __name: "CfgApplicationError",
  props: {
    header: {},
    headerClasses: {},
    statusCode: {},
    statusCodeClasses: {},
    title: {},
    titleClasses: {},
    description: {},
    descriptionClasses: {},
    buttonLabel: {},
    buttonClasses: {}
  },
  emits: ["error"],
  setup(n, { emit: e }) {
    const t = e;
    return (r, i) => (k(), T(ce, null, [
      E("header", d8, [
        te(r.$slots, "logo"),
        r.header ? (k(), q(K, {
          key: 0,
          class: B(["mt-5 text-grey-400 md:mt-7", r.headerClasses]),
          html: r.header,
          size: v(G).h4,
          "tag-name": "p"
        }, null, 8, ["class", "html", "size"])) : V("", !0)
      ]),
      E("main", c8, [
        E("span", {
          class: B(["text-[120px] font-highlighted leading-none text-grey-200 opacity-10 sm:text-[240px]", [r.statusCodeClasses]])
        }, z(r.statusCode), 3),
        te(r.$slots, "title", {}, () => [
          A(K, {
            class: B(["page-not-found__title -mt-[7%] sm:-mt-[12%]", [r.titleClasses]]),
            html: r.title,
            size: v(G).h1,
            "tag-name": "h1"
          }, null, 8, ["class", "html", "size"])
        ]),
        te(r.$slots, "description", {}, () => [
          A(K, {
            class: B(["mt-5 text-dark-200 md:mt-6", [r.descriptionClasses]]),
            size: v(G).md,
            "tag-name": "p"
          }, {
            default: N(() => [
              E("span", { innerHTML: r.description }, null, 8, f8)
            ]),
            _: 1
          }, 8, ["class", "size"])
        ]),
        r.buttonLabel ? (k(), q(v(hr), {
          key: 0,
          class: B(["mt-10", [r.buttonClasses]]),
          variant: "primary",
          onClick: i[0] || (i[0] = (s) => t("error"))
        }, {
          default: N(() => [
            W(z(r.buttonLabel), 1)
          ]),
          _: 1
        }, 8, ["class"])) : V("", !0)
      ])
    ], 64));
  }
});
var pi = /* @__PURE__ */ ((n) => (n.register = "register", n.unregister = "unregister", n.errorChanged = "error:changed", n))(pi || {});
const p8 = /* @__PURE__ */ X({
  __name: "CfgValidationObserver",
  emits: ["error:changed", "submit"],
  setup(n, { expose: e, emit: t }) {
    const r = t, i = ae([]), s = Z(() => i.value.some(({ error: y }) => y)), o = ae(!1), a = {
      [pi.register]: d,
      [pi.unregister]: c,
      [pi.errorChanged]: l
    };
    e({
      resetForm: p,
      async submit() {
        return u();
      }
    }), Ie(s, (y) => r("error:changed", y));
    function l(y) {
      const g = i.value.find((m) => m.name === y.name);
      g && (g.error = y.error);
    }
    async function u() {
      var g;
      return await f(), h() ? (r("submit"), !0) : ((g = i.value.find(({ error: m }) => m)) == null || g.focus(), !1);
    }
    function d(y) {
      i.value.find((g) => g.name === y.name) || i.value.push(y);
    }
    function c(y) {
      i.value = i.value.filter((g) => g.name !== y);
    }
    async function f() {
      o.value = !0, await Promise.all(i.value.map((y) => y.forceValidate())), o.value = !1;
    }
    function p() {
      i.value.forEach((y) => y.reset());
    }
    function h() {
      return !s.value;
    }
    return (y, g) => te(y.$slots, "default", {
      on: a,
      submit: u,
      validationLoading: o.value
    });
  }
}), _1 = {
  validators: {
    type: Array,
    default: () => []
  }
}, up = /* @__PURE__ */ X({
  __name: "CfgValidationProvider",
  props: /* @__PURE__ */ Ae(_1, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["error:changed", "register", "unregister"], ["update:modelValue"]),
  setup(n, { emit: e }) {
    const t = n, r = e, i = Ai(), s = je(n, "modelValue"), o = Ji(s.value), a = _i(!1), l = ae(!1), u = ae(!1), d = ae(""), c = Z(() => l.value && u.value);
    let f = null;
    const p = Ca("providerRef"), h = ae(null);
    S4(() => {
      r(pi.register, {
        name: i,
        error: u.value,
        reset: $,
        async forceValidate() {
          l.value = !0;
          const S = await L();
          return S || m();
        },
        focus() {
          f == null || f.focus();
        }
      });
    }), Dt(() => {
      Vr(() => {
        var S;
        f = (S = p.value) == null ? void 0 : S.querySelector("input");
      });
    }), Mi(() => r(pi.unregister, i)), Ie(() => s.value, m, { immediate: !0, deep: !0 }), Ie(u, (S) => r(pi.errorChanged, {
      name: i,
      error: S
    }));
    function y(S) {
      s.value = S;
    }
    function g() {
      l.value = !0;
    }
    async function m() {
      let S = !1, R = "";
      const O = l.value;
      a.value = !0;
      const I = t.validators.some((x) => x.constructor.name === "AsyncFunction");
      I && (l.value = !1);
      for await (const x of t.validators) {
        let M;
        if (x.constructor.name === "AsyncFunction" ? M = await x(s.value || "") : M = x(s.value || ""), typeof M == "string") {
          S = !0, R = M;
          break;
        }
      }
      return u.value = S, d.value = R, a.value = !1, I && (l.value = O), S;
    }
    function $() {
      l.value = !1, u.value = !1, d.value = "", s.value = Ji(o);
    }
    function w(S) {
      return typeof S == "object" && S !== null && "validate" in S && typeof S.validate == "function";
    }
    function _(S) {
      w(S) && (h.value = S);
    }
    async function L() {
      if (!h.value)
        return !1;
      const S = await h.value.validate();
      return typeof S == "string" ? (u.value = !0, d.value = S, !0) : (u.value = !S, d.value = u.value ? "Validation failed" : "", u.value);
    }
    return (S, R) => (k(), T("div", {
      ref_key: "providerRef",
      ref: p
    }, [
      te(S.$slots, "default", {
        attrs: {
          error: c.value,
          errorMessage: d.value,
          modelValue: s.value,
          loading: a.value
        },
        componentRef: _,
        on: {
          "update:modelValue": y,
          change: g
        }
      })
    ], 512));
  }
}), h8 = {
  "aria-label": "Breadcrumb",
  class: "flex text-grey-300"
}, m8 = { class: "flex items-center space-x-3 overflow-hidden" }, g8 = { class: "shrink-0" }, b8 = { key: 0 }, LM = /* @__PURE__ */ X({
  __name: "CfgBreadcrumbs",
  props: {
    pages: {
      type: Array,
      required: !0
    },
    /**
     * Text to display for the homepage link. If not provided, the home icon will be used.
     */
    homepageText: {
      type: [String, null],
      default: null
    }
  },
  emits: ["link:click"],
  setup(n, { emit: e }) {
    const t = e;
    function r(i) {
      t("link:click", i);
    }
    return (i, s) => (k(), T("nav", h8, [
      E("ol", m8, [
        E("li", g8, [
          A(K, {
            size: v(G).sm,
            "tag-name": "div"
          }, {
            default: N(() => [
              E("a", {
                class: "lg:transition lg:hover:text-brand",
                href: "/",
                onClick: s[0] || (s[0] = Ht((o) => r("/"), ["prevent"]))
              }, [
                n.homepageText ? (k(), T("span", b8, z(n.homepageText), 1)) : (k(), T(ce, { key: 1 }, [
                  A(v(R4), {
                    "aria-hidden": "true",
                    class: "shrink-0 text-[1.25em]"
                  }),
                  s[1] || (s[1] = E("span", { class: "sr-only" }, "Home", -1))
                ], 64))
              ])
            ]),
            _: 1
          }, 8, ["size"])
        ]),
        (k(!0), T(ce, null, $e(n.pages, (o) => (k(), T("li", {
          key: o.name,
          class: "min-w-0 max-w-[50%] shrink-0 last:max-w-full last:shrink last:grow"
        }, [
          A(K, {
            class: "flex items-center",
            size: v(G).xs,
            "tag-name": "div"
          }, {
            default: N(() => [
              A(v(mn), {
                "aria-hidden": "true",
                class: "shrink-0 text-[1.3em]"
              }),
              (k(), q(qe(o.current ? "span" : "a"), Te({ ref_for: !0 }, o.current ? {} : { href: o.path }, {
                "aria-current": o.current ? "page" : void 0,
                class: ["ml-2 truncate", {
                  "lg:transition lg:hover:text-brand": !o.current
                }],
                onClick: Ht((a) => !o.current && r(o.path), ["prevent"])
              }), {
                default: N(() => [
                  W(z(o.name), 1)
                ]),
                _: 2
              }, 1040, ["aria-current", "class", "onClick"]))
            ]),
            _: 2
          }, 1032, ["size"])
        ]))), 128))
      ])
    ]));
  }
}), y8 = { class: "hide-scrollbar mt-3 flex overflow-x-auto" }, v8 = ["onClick"], RM = /* @__PURE__ */ X({
  __name: "CfgButtonsGroup",
  props: {
    values: {}
  },
  emits: ["input"],
  setup(n, { emit: e }) {
    const t = e, r = ae("");
    function i(s) {
      t("input", s), r.value = s;
    }
    return (s, o) => (k(), T(ce, null, [
      te(s.$slots, "default", { value: r.value }),
      E("div", y8, [
        (k(!0), T(ce, null, $e(s.values, (a) => (k(), T("button", {
          key: a,
          class: "m-1 rounded-xl border border-grey-stroke px-3 py-2",
          type: "button",
          onClick: (l) => i(a)
        }, z(a), 9, v8))), 128))
      ])
    ], 64));
  }
}), _8 = { class: "space-y-3" }, PM = /* @__PURE__ */ X({
  __name: "CfgCheckboxGroup",
  props: /* @__PURE__ */ Ae({
    ...kt,
    /**
     * Name of the radio group (will be used as name attribute for all radio buttons)
     */
    name: {
      type: String,
      default: () => Ai()
    },
    /**
     * Radio group items
     */
    options: {
      type: Array,
      default: () => []
    },
    layout: {
      type: String,
      default: "row"
    }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = n, t = je(n, "modelValue"), r = Z(() => e.options.map((s) => ({
      ...s,
      checked: t.value.includes(s.value)
    })));
    function i(s, o) {
      if (!s) {
        t.value = t.value.filter((a) => a !== o);
        return;
      }
      t.value.push(o);
    }
    return (s, o) => (k(), T("div", _8, [
      E("div", null, [
        A(K, {
          class: B({
            "text-grey-200": !s.error,
            "text-red": s.error
          }),
          size: v(G).md
        }, {
          default: N(() => [
            W(z(s.placeholder), 1)
          ]),
          _: 1
        }, 8, ["class", "size"]),
        s.caption ? (k(), q(K, {
          key: 0,
          class: "mt-1 block pb-1 text-grey-300",
          size: v(G).xs
        }, {
          default: N(() => [
            W(z(s.caption), 1)
          ]),
          _: 1
        }, 8, ["size"])) : V("", !0)
      ]),
      E("div", {
        class: B({
          "flex flex-wrap gap-x-7 gap-y-4": n.layout === "row",
          "space-y-4": n.layout === "column"
        })
      }, [
        (k(!0), T(ce, null, $e(r.value, (a) => (k(), T("div", {
          key: a.value
        }, [
          A(Ta, {
            disabled: s.disabled || a.disabled,
            "model-value": a.checked,
            name: n.name,
            placeholder: a.label,
            value: a.value,
            "onUpdate:modelValue": (l) => i(l, a.value)
          }, null, 8, ["disabled", "model-value", "name", "placeholder", "value", "onUpdate:modelValue"])
        ]))), 128))
      ], 2),
      s.error && s.errorMessage ? (k(), q(K, {
        key: 0,
        class: "mt-3 block text-red",
        size: v(G).xs
      }, {
        default: N(() => [
          W(z(s.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : V("", !0)
    ]));
  }
}), $8 = { class: "flex flex-wrap gap-2" }, x8 = ["for"], w8 = ["id", "aria-label", "checked", "name", "type", "value", "onChange"], IM = /* @__PURE__ */ X({
  __name: "CfgChipsToggle",
  props: {
    id: {},
    options: {},
    isMultiple: {},
    modelValue: {},
    name: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = Z(() => t.id || `chips-toggle-${Math.random().toString(36).substr(2, 9)}`), s = Z(() => t.name || i.value), o = Z(() => t.options.map((l) => ({
      ...l,
      isSelected: l.value === t.modelValue
    }))), a = Z(() => t.isMultiple ? "checkbox" : "radio");
    if (t.isMultiple)
      throw new Error("Multiple chips toggle is not implemented yet");
    return (l, u) => (k(), T("div", $8, [
      (k(!0), T(ce, null, $e(o.value, ({ isSelected: d, label: c, value: f }, p) => (k(), T("label", {
        key: f,
        class: B(["relative block cursor-pointer overflow-hidden rounded-full border leading-none ring-offset-4 transition duration-200 focus-within:ring focus-within:ring-brand/30 hover:-translate-y-1", {
          "border-brand bg-brand text-white": d,
          "border-grey-stroke bg-white": !d
        }]),
        for: `${i.value}-${p}`
      }, [
        A(K, {
          class: "block px-[1em] py-[0.75em]",
          size: v(G).sm,
          "tag-name": "span"
        }, {
          default: N(() => [
            te(l.$slots, "default", { label: c }, () => [
              E("input", {
                id: `${i.value}-${p}`,
                "aria-label": c,
                checked: d,
                class: "absolute -top-5 opacity-0",
                name: s.value,
                type: a.value,
                value: c,
                onChange: (h) => r("update:modelValue", f)
              }, null, 40, w8),
              W(" " + z(c), 1)
            ])
          ]),
          _: 2
        }, 1032, ["size"])
      ], 10, x8))), 128))
    ]));
  }
});
var Bi = /* @__PURE__ */ ((n) => (n.Small = "small", n.Medium = "medium", n.Large = "large", n.XLarge = "xlarge", n))(Bi || {});
const k8 = { class: "fixed inset-0 z-10 overflow-y-auto" }, C8 = {
  key: 0,
  class: "absolute right-3 top-3 z-20 mb-2 md:right-5 md:top-5"
}, S8 = {
  key: 0,
  class: "mx-auto mb-5 flex size-[2em] items-center justify-center rounded-full bg-brand-opacity text-[1.5em] text-brand"
}, BM = /* @__PURE__ */ X({
  __name: "CfgDialog",
  props: {
    opened: {
      type: Boolean,
      required: !0
    },
    initialFocus: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    closable: {
      type: Boolean,
      default: !0
    },
    unmount: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: Bi.Small
    },
    /**
     * If true, the dialog will not have a
     * padding and the close button will be moved to the top right corner.
     */
    flat: {
      type: Boolean,
      default: !1
    },
    width: {
      type: String,
      default: void 0
    },
    isFullScreen: {
      type: Boolean,
      default: !1
    },
    minimalHeader: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:opened", "close-click:button", "close-click:backdrop", "after-close-animation"],
  setup(n, { emit: e }) {
    const t = n, r = e;
    function i(s) {
      if (t.closable) {
        switch (s) {
          case "button":
            r("close-click:button");
            break;
          case "backdrop":
            r("close-click:backdrop");
            break;
        }
        r("update:opened", !1);
      }
    }
    return (s, o) => (k(), q(v(a1), {
      as: "template",
      show: n.opened
    }, {
      default: N(() => [
        A(v(l1), {
          as: "div",
          class: "relative z-modal",
          unmount: !!n.unmount,
          onClose: o[3] || (o[3] = (a) => i("backdrop"))
        }, {
          default: N(() => [
            A(v(ss), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: N(() => o[4] || (o[4] = [
                E("div", { class: "fixed inset-0 bg-dark/60 transition-opacity sm:backdrop-blur" }, null, -1)
              ])),
              _: 1
            }),
            E("div", k8, [
              n.closable && n.flat ? (k(), T("div", C8, [
                E("button", {
                  class: "flex size-11 items-center justify-center rounded-full bg-grey-100 ring-brand focus-visible:outline-brand focus-visible:ring",
                  type: "button",
                  onClick: o[0] || (o[0] = (a) => i("button"))
                }, [
                  A(v(Ut))
                ])
              ])) : V("", !0),
              E("div", {
                class: B(["flex min-h-full items-center justify-center text-center sm:p-0", {
                  "p-4": !n.isFullScreen
                }])
              }, [
                A(v(ss), {
                  as: "template",
                  enter: "ease-out duration-[350ms]",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  onAfterLeave: o[2] || (o[2] = (a) => r("after-close-animation"))
                }, {
                  default: N(() => [
                    A(v(u1), {
                      class: B(["relative w-full overflow-hidden bg-white text-left shadow-base transition-all sm:my-8 sm:w-full", {
                        "sm:max-w-sm": !n.width && n.size === v(Bi).Small,
                        "sm:max-w-lg": !n.width && n.size === v(Bi).Medium,
                        "sm:max-w-3xl": !n.width && n.size === v(Bi).Large,
                        "sm:max-w-[calc(100%-40px-120px)]": !n.width && n.size === v(Bi).XLarge,
                        // 40px-120px is padding + close button width
                        "px-4 pb-4 pt-5 sm:p-6": !n.flat && !n.minimalHeader,
                        // Add padding for non-flat dialogs
                        "mt-14": n.flat && n.closable,
                        // Prevent layering window to close button,
                        "h-screen w-full": n.isFullScreen,
                        "rounded-xl": !n.isFullScreen
                      }]),
                      style: mt(n.width ? { width: n.width } : {})
                    }, {
                      default: N(() => [
                        E("header", {
                          class: B(["", {
                            "flex items-center justify-between": n.minimalHeader,
                            "space-y-3": !n.minimalHeader,
                            "border-b border-grey-100 px-5 py-4": n.minimalHeader
                          }])
                        }, [
                          n.closable && !n.flat ? (k(), T("div", {
                            key: 0,
                            class: B(["flex items-center justify-end", {
                              "mb-2": !n.minimalHeader
                            }])
                          }, [
                            E("button", {
                              class: B(["flex items-center justify-center ring-brand focus-visible:outline-brand focus-visible:ring", {
                                "size-11 rounded-full bg-grey-100": !n.minimalHeader
                              }]),
                              type: "button",
                              onClick: o[1] || (o[1] = (a) => i("button"))
                            }, [
                              A(v(Ut))
                            ], 2)
                          ], 2)) : V("", !0),
                          E("div", {
                            class: B({ "order-first flex w-full justify-between": n.minimalHeader })
                          }, [
                            te(s.$slots, "heading", {}, () => [
                              s.$slots.icon ? (k(), T("div", S8, [
                                te(s.$slots, "icon")
                              ])) : V("", !0),
                              n.title || s.$slots.title ? (k(), q(v(U9), {
                                key: 1,
                                as: "div",
                                class: "text-dark-100"
                              }, {
                                default: N(() => [
                                  te(s.$slots, "title", {}, () => [
                                    A(K, {
                                      class: "text-center",
                                      size: v(G).h3,
                                      "tag-name": "h3"
                                    }, {
                                      default: N(() => [
                                        W(z(n.title), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["size"])
                                  ])
                                ]),
                                _: 3
                              })) : V("", !0),
                              n.description || s.$slots.description ? (k(), q(v(W9), {
                                key: 2,
                                as: "div",
                                class: "mt-3"
                              }, {
                                default: N(() => [
                                  te(s.$slots, "description", {}, () => [
                                    A(K, {
                                      class: "text-center text-sm text-grey-300",
                                      size: v(G).md,
                                      "tag-name": "p"
                                    }, {
                                      default: N(() => [
                                        W(z(n.description), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["size"])
                                  ])
                                ]),
                                _: 3
                              })) : V("", !0)
                            ])
                          ], 2)
                        ], 2),
                        E("main", {
                          class: B({
                            "mt-5": !n.flat,
                            "px-4 pb-4 sm:px-6 sm:pb-6": n.minimalHeader
                          })
                        }, [
                          te(s.$slots, "default")
                        ], 2)
                      ]),
                      _: 3
                    }, 8, ["class", "style"])
                  ]),
                  _: 3
                })
              ], 2)
            ])
          ]),
          _: 3
        }, 8, ["unmount"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), $1 = {
  origin: {
    type: String,
    default: "left"
  },
  openOnTriggerClick: {
    type: Boolean,
    default: !0
  },
  useTriggerContentWidth: {
    type: Boolean,
    default: !1
  },
  minWidth: {
    type: Number,
    default: 0
  },
  allowedPlacements: {
    type: Array,
    default: () => ["top", "bottom"]
  }
}, E8 = { class: "relative" }, T8 = {
  key: 0,
  class: "fixed inset-0 z-floating-overlay bg-black/30"
}, dp = /* @__PURE__ */ X({
  __name: "CfgFloating",
  props: /* @__PURE__ */ Ae({
    ...$1,
    highlightTriggerElement: {
      type: Boolean,
      default: !1
    }
  }, {
    opened: { type: Boolean, default: !1 },
    openedModifiers: {}
  }),
  emits: ["update:opened"],
  setup(n) {
    const e = n, t = je(n, "opened"), r = ae(null), i = ae(null);
    W2(i, l);
    const { floatingStyles: s } = s1(r, i, {
      middleware: [q2(), K2(), G2(12), Y2({
        allowedPlacements: e.allowedPlacements
      })],
      whileElementsMounted: o1,
      transform: !1
    }), { width: o } = uo(r);
    Dt(() => {
      ad(document.documentElement, "keydown", (u) => {
        u.key === "Escape" && t.value && l();
      });
    });
    function a() {
      t.value = !0;
    }
    function l() {
      t.value = !1;
    }
    return (u, d) => (k(), T("div", E8, [
      E("div", {
        ref_key: "triggerButtonRef",
        ref: r,
        class: B(["focusable relative rounded-xl border-none bg-white p-0", {
          "z-floating-trigger": t.value && !n.highlightTriggerElement,
          "z-floating-trigger-highlighted": t.value && n.highlightTriggerElement
        }]),
        tabindex: "0",
        onClick: d[0] || (d[0] = (c) => u.openOnTriggerClick && a()),
        onKeydown: d[1] || (d[1] = Yn((c) => u.openOnTriggerClick && a(), ["enter"]))
      }, [
        te(u.$slots, "trigger", {
          close: l,
          opened: t.value
        })
      ], 34),
      A($i, {
        "enter-active-class": "transition-opacity duration-200 ease-out",
        "enter-from-class": "transition-opacity opacity-0",
        "enter-to-class": "transition-opacity opacity-100",
        "leave-active-class": "transition-opacity delay-100 duration-200 ease-out",
        "leave-from-class": "transition-opacity opacity-100",
        "leave-to-class": "transition-opacity opacity-0"
      }, {
        default: N(() => [
          t.value ? (k(), T("div", T8)) : V("", !0)
        ]),
        _: 1
      }),
      (k(), q(e1, { to: "body" }, [
        A($i, {
          "enter-active-class": "transition duration-200 ease-out",
          "enter-from-class": "transform scale-125 translate-y-5 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
          "leave-active-class": "transition duration-200 ease-out",
          "leave-from-class": "transform scale-100 translate-y-0 opacity-100",
          "leave-to-class": "transform scale-125 translate-y-5 opacity-0"
        }, {
          default: N(() => [
            nt(E("div", {
              ref_key: "bodyRef",
              ref: i,
              class: B(["absolute top-[calc(var(--input-height)+5px)] z-floating-content w-max min-w-[350px] divide-y divide-grey-stroke overflow-auto rounded-xl border border-grey-stroke bg-white shadow-light focus-visible:outline-none", {
                "border-brand": t.value,
                "left-0": u.origin === "left",
                "right-0": u.origin === "right"
              }]),
              style: mt({
                ...v(s),
                "max-width": u.useTriggerContentWidth ? "100%" : `${v(o)}px`
              })
            }, [
              te(u.$slots, "content", {
                close: l,
                opened: t.value
              })
            ], 6), [
              [xl, t.value]
            ])
          ]),
          _: 3
        })
      ]))
    ]));
  }
}), O8 = ["innerHTML"], Zi = /* @__PURE__ */ X({
  __name: "CfgHint",
  props: {
    content: { default: "" },
    hideIcon: { type: Boolean, default: !1 },
    iconPlacement: { default: "right" },
    tooltipPadding: { type: Boolean, default: !0 },
    disabled: { type: Boolean },
    offset: { default: 8 },
    contentWidth: { default: "" },
    interactive: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n, t = $l(), r = Z(() => {
      var l, u;
      return (u = (l = t.class) == null ? void 0 : l.includes) == null ? void 0 : u.call(l, "w-");
    }), i = ae(!1);
    function s() {
      i.value = !1;
    }
    function o() {
      e.disabled || (i.value = !0);
    }
    const a = Z(() => e.interactive ? 150 : 0);
    return Dt(() => {
      const l = so("contentRef"), u = so("triggerRef"), { isOutside: d } = V0(l), { isOutside: c } = V0(u), f = ae(!1);
      let p = null;
      t1(() => {
        d.value && c.value ? p = setTimeout(() => {
          f.value = !0, i.value = !1;
        }, a.value) : (p && (clearTimeout(p), p = null), f.value = !1);
      });
    }), (l, u) => (k(), T("div", {
      ref: "triggerRef",
      class: B(["flex h-max", { "w-max": !r.value }]),
      onMouseover: o
    }, [
      A(v(S9), {
        open: i.value,
        "onUpdate:open": o
      }, {
        default: N(() => [
          A(v(E9), {
            as: "div",
            class: B(["group inline-flex items-center gap-x-2", {
              "w-full": r.value,
              "flex-row-reverse": e.iconPlacement === "left",
              "cursor-help": !e.disabled
            }]),
            style: { "text-transform": "inherit" }
          }, {
            default: N(() => [
              te(l.$slots, "trigger"),
              !v(t).disabled && !e.hideIcon ? (k(), q(v(Ps), {
                key: 0,
                class: B(["text-[1.1em] text-grey-200", { "transition-colors duration-200 group-hover:text-brand": !e.disabled }])
              }, null, 8, ["class"])) : V("", !0)
            ]),
            _: 3
          }, 8, ["class"]),
          A(v(T9), { to: "body" }, {
            default: N(() => [
              A($i, { name: "cfg-hint" }, {
                default: N(() => [
                  A(v(O9), {
                    ref: "contentRef",
                    class: B(["z-toast rounded-xl bg-white text-dark-100 shadow-extra", {
                      "p-5": l.tooltipPadding,
                      "max-w-[330px]": !l.contentWidth,
                      [l.contentWidth]: l.contentWidth
                    }]),
                    "side-offset": e.offset
                  }, {
                    default: N(() => [
                      te(l.$slots, "content", { closeHint: s }, () => [
                        E("div", {
                          class: "block max-w-[200px] text-left text-sm",
                          innerHTML: e.content
                        }, null, 8, O8)
                      ])
                    ]),
                    _: 3
                  }, 8, ["class", "side-offset"])
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["open"])
    ], 34));
  }
}), M8 = { class: "space-y-3" }, A8 = ["innerHTML"], zM = /* @__PURE__ */ X({
  __name: "CfgRadioGroup",
  props: /* @__PURE__ */ Ae({
    ...kt,
    /**
     * Name of the radio group (will be used as name attribute for all radio buttons)
     */
    name: {
      type: String,
      default: () => Ai()
    },
    /**
     * Radio group items
     */
    options: {
      type: Array,
      default: () => []
    },
    layout: {
      type: String,
      default: "row"
    }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    var s;
    const e = n, t = je(n, "modelValue");
    t.value || (t.value = ((s = e.options[0]) == null ? void 0 : s.value) ?? "");
    const r = Z(() => e.options.map((o) => ({
      ...o,
      checked: o.value === t.value
    })));
    function i(o, a) {
      o && (t.value = a);
    }
    return (o, a) => (k(), T("div", M8, [
      E("div", null, [
        A(K, {
          class: B({
            "text-grey-200": !o.error,
            "text-red": o.error
          }),
          size: v(G).md
        }, {
          default: N(() => [
            W(z(o.placeholder), 1)
          ]),
          _: 1
        }, 8, ["class", "size"]),
        o.caption ? (k(), q(K, {
          key: 0,
          class: "mt-1 block pb-1 text-grey-300",
          size: v(G).xs
        }, {
          default: N(() => [
            E("span", { innerHTML: o.caption }, null, 8, A8)
          ]),
          _: 1
        }, 8, ["size"])) : V("", !0)
      ]),
      E("div", {
        class: B({
          "flex flex-wrap gap-x-7 gap-y-4": n.layout === "row",
          "space-y-4": n.layout === "column"
        })
      }, [
        (k(!0), T(ce, null, $e(r.value, (l) => (k(), T("div", {
          key: l.value
        }, [
          A(Qm, {
            disabled: o.disabled || l.disabled,
            "model-value": l.checked,
            name: n.name,
            placeholder: l.label,
            value: l.value,
            "onUpdate:modelValue": (u) => i(u, l.value)
          }, null, 8, ["disabled", "model-value", "name", "placeholder", "value", "onUpdate:modelValue"])
        ]))), 128))
      ], 2),
      o.error && o.errorMessage ? (k(), q(K, {
        key: 0,
        class: "mt-3 block text-red",
        size: v(G).xs
      }, {
        default: N(() => [
          W(z(o.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : V("", !0)
    ]));
  }
});
function cp(n, e) {
  const t = Z(() => Array.isArray(n.value)), r = lo(e, (l, u) => ({
    label: typeof l == "string" ? l : l.label,
    value: typeof l == "string" ? u.toString() : l.value,
    subtext: typeof l == "string" ? void 0 : l.subtext,
    appendSlot: typeof l == "string" ? void 0 : l.appendSlot,
    prependSlot: typeof l == "string" ? void 0 : l.prependSlot,
    original: l
  })), i = Z(() => {
    if (!n.value)
      return [];
    if (Array.isArray(n.value))
      return n.value.map((u) => {
        const d = o(u);
        return {
          ...d,
          label: typeof u == "string" ? u : (d == null ? void 0 : d.label) ?? ""
        };
      }).filter(Boolean);
    let l = o(n.value);
    return typeof n.value == "object" && l && (l = {
      ...l,
      label: n.value.label || ""
    }), l ? [l] : [];
  }), s = lo(r, (l) => ({
    ...l,
    selected: a(l)
  }));
  function o(l) {
    return typeof l == "string" ? r.value.find(({ label: u }) => u === l) : r.value.find(({ value: u }) => fr(u, l == null ? void 0 : l.value));
  }
  function a(l) {
    return !!i.value.find(({ value: u }) => l.value === u);
  }
  return {
    isMultiple: t,
    normalizedModelValue: i,
    statefullOptionsList: s,
    isOptionSelected: a,
    findOption: o
  };
}
const N8 = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-4 px-5 py-7"
}, D8 = {
  key: 1,
  class: "max-h-[400px] divide-y divide-grey-stroke overflow-auto"
}, L8 = ["onClick", "onKeydown"], R8 = { class: "grow" }, P8 = {
  key: 2,
  class: "flex flex-col items-center justify-center gap-4 px-5 py-7"
}, VM = /* @__PURE__ */ X({
  __name: "CfgCombobox",
  props: /* @__PURE__ */ Ae({
    ...kt,
    options: {
      type: Array,
      default: () => []
    },
    emptyMessage: {
      type: String,
      required: !0
    },
    initialSearch: {
      type: String,
      default: ""
    },
    openOptionsOnClick: {
      type: Boolean,
      default: !0
    },
    origin: {
      type: String,
      default: "left"
    },
    compareFn: {
      type: [Function, null],
      default: null
    },
    onSearch: {
      type: Function,
      default: null
    },
    ...pr($1, "allowedPlacements")
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    var g, m;
    const e = n, { options: t } = wl(e), r = je(n, "modelValue"), i = ae(null);
    W2(i, p);
    const { normalizedModelValue: s, statefullOptionsList: o } = cp(r, t), a = ae(e.initialSearch || (((m = (g = s.value) == null ? void 0 : g[0]) == null ? void 0 : m.label) ?? "")), l = ae(!1), u = ae(!1), d = ($, w) => w.label.toLowerCase().includes(a.value.toLowerCase()), c = c9(async () => {
      const $ = e.compareFn || d;
      l.value = !0;
      const w = await b9(
        o.value,
        async (_) => a.value ? $(a.value, _) : !0
      );
      return l.value = !1, w;
    }, o.value);
    function f() {
      u.value = !0;
    }
    function p() {
      u.value = !1;
    }
    function h($) {
      $ && (r.value = $.original, p());
    }
    function y($) {
      var O;
      if (["Escape", "Enter", "Tab", "Shift", "Control", "Alt"].includes($.key))
        return;
      const { value: _, label: L } = ((O = s.value) == null ? void 0 : O[0]) || {}, R = /^[a-z0-9\s]$/i.test($.key) ? $.key : "";
      R !== _ && R !== L && f();
    }
    return Ie(() => e.initialSearch, ($ = "") => {
      a.value = $;
    }), Ie(r, ($) => {
      Array.isArray($) ? a.value = $.map((w) => typeof w == "string" ? w : w.label).join(", ") : a.value = typeof $ == "string" ? $ : ($ == null ? void 0 : $.label) ?? "";
    }), Ie(a, ($) => {
      var w;
      $ !== e.initialSearch && ((w = e.onSearch) == null || w.call(e, $)), $ === "" && (r.value = null);
    }), ($, w) => (k(), q(dp, {
      opened: u.value,
      "onUpdate:opened": w[1] || (w[1] = (_) => u.value = _),
      "highlight-trigger-element": "",
      "open-on-trigger-click": n.openOptionsOnClick
    }, {
      trigger: N(() => [
        A(pn, {
          modelValue: a.value,
          "onUpdate:modelValue": w[0] || (w[0] = (_) => a.value = _),
          autocomplete: "off",
          error: $.error,
          "error-message": $.errorMessage,
          fluid: "",
          "initial-focused": u.value || $.initialFocused,
          "interect-with-icon": "",
          loading: l.value || $.loading,
          placeholder: $.placeholder,
          required: $.required,
          type: "search",
          onKeydown: y
        }, null, 8, ["modelValue", "error", "error-message", "initial-focused", "loading", "placeholder", "required"])
      ]),
      content: N(() => [
        l.value || $.loading ? (k(), T("div", N8, [
          A(No, { class: "text-[8px] text-brand" })
        ])) : v(c).length ? (k(), T("ul", D8, [
          (k(!0), T(ce, null, $e(v(c), (_) => (k(), T("li", {
            key: _.label,
            class: B(["flex cursor-pointer items-center gap-x-3 p-4 hover:bg-grey-100/50", {
              "text-brand": _.selected
            }]),
            onClick: (L) => h(_),
            onKeydown: Yn((L) => h(_), ["enter"])
          }, [
            te($.$slots, "option", Te({ ref_for: !0 }, { ..._ }), () => [
              _.selected ? (k(), q(v(n1), {
                key: 0,
                "aria-hidden": "true",
                class: "shrink-0 text-success"
              })) : V("", !0),
              E("span", R8, z(_.label), 1)
            ])
          ], 42, L8))), 128))
        ])) : (k(), T("div", P8, [
          A(v(P4), { class: "text-[1.3rem] text-grey-300" }),
          A(K, {
            class: "text-center",
            size: v(G).sm
          }, {
            default: N(() => [
              W(z(n.emptyMessage), 1)
            ]),
            _: 1
          }, 8, ["size"])
        ]))
      ]),
      _: 3
    }, 8, ["opened", "open-on-trigger-click"]));
  }
}), I8 = {
  class: "cfg-select__button focusable block w-full rounded-xl text-left focus:border-none focus:outline-0",
  type: "button"
}, B8 = {
  key: 1,
  class: "absolute right-0 text-grey-200"
}, z8 = { class: "flex items-center gap-2" }, V8 = {
  key: 0,
  class: "block max-w-full pt-1 text-red"
}, F8 = ["innerHTML"], j8 = {
  key: 0,
  class: "fixed inset-0 z-floating-overlay bg-black/30"
}, H8 = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-4 px-5 py-7"
}, U8 = { key: 1 }, W8 = { class: "flex justify-between" }, q8 = { class: "flex items-center" }, K8 = ["innerHTML"], G8 = { class: "flex w-full justify-between" }, Y8 = { class: "flex items-center" }, J8 = ["innerHTML"], x1 = /* @__PURE__ */ X({
  __name: "CfgSelect",
  props: /* @__PURE__ */ Ae({
    ...kt,
    modelValue: {
      type: [Object, Array, null],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    origin: {
      type: String,
      default: "left"
    },
    /**
     * Controls showing overlay under other elements
     */
    overlay: {
      type: Boolean,
      default: !0
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    contentMinWidth: {
      type: String,
      default: "350px"
    }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = n, t = je(n, "modelValue"), r = ae(), i = ae(), s = ae(), o = ae(), { width: a } = uo(i);
    f9(r, w);
    const { width: l } = uo(s), {
      floatingStyles: u
    } = s1(s, o, {
      whileElementsMounted: o1,
      transform: !1,
      middleware: [
        Y2({
          allowedPlacements: ["top", "bottom"]
        }),
        K2({ padding: 5 }),
        G2(12),
        q2()
      ]
    }), d = ae(0), { options: c } = wl(e), {
      isMultiple: f,
      normalizedModelValue: p,
      statefullOptionsList: h,
      isOptionSelected: y
    } = cp(t, c), g = Z(() => d.value > a.value), m = Z(() => {
      var O;
      return f.value ? p.value.map(({ value: I }) => I) : ((O = p.value[0]) == null ? void 0 : O.value) ?? "";
    }), $ = Z(() => ({
      label: p.value.map(({ label: O }) => O).join(", "),
      additionalLabel: g.value && p.value.length > 1 ? `(${p.value.length})` : ""
    }));
    function w() {
      var O;
      d.value = ((O = r.value) == null ? void 0 : O.getBoundingClientRect().width) ?? 0;
    }
    function _(O) {
      var x;
      let I = p.value;
      y(O) && f.value ? I = I.filter(({ value: M }) => M !== O.value) : f.value ? I.push(O) : I = [O], t.value = f.value ? I.map(({ original: M }) => M) : ((x = I[0]) == null ? void 0 : x.original) ?? null;
    }
    function L() {
      t.value = f.value ? [] : null;
    }
    const S = Z(() => t.value === null || Array.isArray(t.value) && !t.value.length);
    U2($, w, { immediate: !0, deep: !0, debounce: 50 });
    const R = p9(async () => {
      try {
        return f.value ? (await Promise.resolve().then(() => fm)).default : (await import("./CfgRadio-BvqcPDe1.js")).default;
      } catch {
        return null;
      }
    }, null);
    return (O, I) => (k(), q(v(q9), {
      as: "div",
      class: "cfg-select relative",
      disabled: O.disabled,
      "model-value": m.value,
      multiple: v(f)
    }, {
      default: N(({ open: x }) => [
        E("div", null, [
          E("div", null, [
            A(v(K9), {
              as: "template",
              type: "button"
            }, {
              default: N(() => [
                E("button", I8, [
                  E("span", {
                    ref_key: "triggerButtonRef",
                    ref: s,
                    class: "block"
                  }, [
                    te(O.$slots, "trigger", { isOpened: x }, () => [
                      A(v1, {
                        class: B(["bg-white", {
                          "cursor-pointer": !O.disabled,
                          "cursor-not-allowed": O.disabled,
                          "relative z-floating-trigger ": x
                        }]),
                        disabled: O.disabled,
                        empty: !v(p).length,
                        error: O.error,
                        fluid: "",
                        focused: x,
                        loading: O.loading,
                        placeholder: O.placeholder,
                        readonly: "",
                        required: O.required
                      }, {
                        placeRight: N(() => {
                          var M, D, j;
                          return [
                            E("div", z8, [
                              v(p).length > 0 && ((M = v(p)[0].appendSlot) != null && M.component) ? (k(), q(qe((j = (D = v(p)[0]) == null ? void 0 : D.appendSlot) == null ? void 0 : j.component), {
                                key: 0,
                                class: B(v(p)[0].appendSlot.class)
                              }, null, 8, ["class"])) : V("", !0),
                              n.clearable && !S.value ? (k(), q(v(Ut), {
                                key: 1,
                                class: B(["size-4 text-grey-400", {
                                  "!text-brand": x
                                }]),
                                onClick: Ht(L, ["prevent"])
                              }, null, 8, ["class"])) : (k(), q(v(xi), {
                                key: 2,
                                class: B(["size-4 text-grey-400 transition duration-200", {
                                  "rotate-180 !text-brand": x
                                }])
                              }, null, 8, ["class"]))
                            ])
                          ];
                        }),
                        default: N(() => {
                          var M, D, j, U, J, ne, Y;
                          return [
                            E("span", {
                              ref_key: "textWrapperRef",
                              ref: i,
                              class: B(["relative min-h-[1em] truncate", {
                                "pr-5": g.value && v(f),
                                "flex gap-2": (D = (M = v(p)[0]) == null ? void 0 : M.prependSlot) == null ? void 0 : D.component,
                                block: !((U = (j = v(p)[0]) == null ? void 0 : j.prependSlot) != null && U.component)
                              }])
                            }, [
                              v(p).length > 0 && ((J = v(p)[0].prependSlot) != null && J.component) ? (k(), q(qe((Y = (ne = v(p)[0]) == null ? void 0 : ne.prependSlot) == null ? void 0 : Y.component), {
                                key: 0,
                                class: B(v(p)[0].prependSlot.class)
                              }, null, 8, ["class"])) : V("", !0),
                              E("span", {
                                ref_key: "textRef",
                                ref: r,
                                class: "h-4"
                              }, z($.value.label), 513),
                              $.value.additionalLabel ? (k(), T("span", B8, z($.value.additionalLabel), 1)) : V("", !0)
                            ], 2)
                          ];
                        }),
                        _: 2
                      }, 1032, ["class", "disabled", "empty", "error", "focused", "loading", "placeholder", "required"])
                    ])
                  ], 512),
                  O.error && O.errorMessage ? (k(), T("small", V8, z(O.errorMessage), 1)) : V("", !0)
                ])
              ]),
              _: 2
            }, 1024),
            !(O.error && O.errorMessage) && O.caption ? (k(), T("small", {
              key: 0,
              class: "block max-w-full pt-1 text-grey-300",
              innerHTML: O.caption
            }, null, 8, F8)) : V("", !0)
          ]),
          (k(), q(e1, { to: "body" }, [
            n.overlay ? (k(), q($i, {
              key: 0,
              "enter-active-class": "transition-opacity duration-200 ease-out",
              "enter-from-class": "transition-opacity opacity-0",
              "enter-to-class": "transition-opacity opacity-100",
              "leave-active-class": "transition-opacity delay-100 duration-200 ease-out",
              "leave-from-class": "transition-opacity opacity-100",
              "leave-to-class": "transition-opacity opacity-0"
            }, {
              default: N(() => [
                x ? (k(), T("div", j8)) : V("", !0)
              ]),
              _: 2
            }, 1024)) : V("", !0),
            A(v(G9), {
              as: "template",
              static: ""
            }, {
              default: N((M) => [
                A($i, {
                  "enter-active-class": "transition duration-200 ease-out",
                  "enter-from-class": "transform scale-125 translate-y-5 opacity-0",
                  "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
                  "leave-active-class": "transition duration-200 ease-out",
                  "leave-from-class": "transform scale-100 translate-y-0 opacity-100",
                  "leave-to-class": "transform scale-125 translate-y-5 opacity-0"
                }, {
                  default: N(() => [
                    nt(E("div", {
                      ref_key: "dropdownContent",
                      ref: o,
                      class: "cfg-select__body z-floating-content w-full divide-y divide-grey-stroke overflow-auto rounded-xl bg-white shadow-light focus-visible:outline-none",
                      style: mt({
                        ...v(u),
                        width: `${v(l)}px`,
                        minWidth: n.contentMinWidth
                      })
                    }, [
                      M.open ? (k(), T(ce, { key: 0 }, [
                        O.loading ? (k(), T("div", H8, [
                          A(v(No), { class: "text-[8px] text-brand" })
                        ])) : (k(), T("ul", U8, [
                          (k(!0), T(ce, null, $e(v(h), (D) => (k(), q(v(Y9), {
                            key: D.value,
                            as: "li",
                            class: B(["cursor-pointer", {
                              "p-4": !O.$slots.item
                            }]),
                            value: D.label,
                            onClick: (j) => !v(f) && _(D),
                            onKeydown: [
                              Yn((j) => _(D), ["enter"]),
                              Yn((j) => _(D), ["space"])
                            ]
                          }, {
                            default: N(({ active: j }) => [
                              te(O.$slots, "item", {
                                focused: j,
                                isSelected: D.selected,
                                option: D,
                                toggle: _
                              }, () => [
                                (k(), q(qe(v(R)), {
                                  id: `cfgSelect-${D.value}`,
                                  focused: j,
                                  "initial-focused": D.selected,
                                  "model-value": !!D.selected,
                                  "onUpdate:modelValue": (U) => _(D)
                                }, vs({
                                  default: N(() => [
                                    v(f) ? V("", !0) : te(O.$slots, "label", {
                                      key: 0,
                                      value: D
                                    }, () => {
                                      var U, J;
                                      return [
                                        E("div", G8, [
                                          E("div", Y8, [
                                            (U = D.prependSlot) != null && U.component ? (k(), q(qe(D.prependSlot.component), {
                                              key: 0,
                                              class: B(["mr-2", D.prependSlot.class])
                                            }, null, 8, ["class"])) : V("", !0),
                                            E("div", null, [
                                              E("span", {
                                                class: B(["leading-6", { "text-brand": D.selected, "text-grey-500": !D.selected }]),
                                                innerHTML: D.label
                                              }, null, 10, J8),
                                              D.subtext ? (k(), q(v(K), {
                                                key: 0,
                                                class: "block text-grey-300",
                                                size: v(G).xs,
                                                "tag-name": "sm"
                                              }, {
                                                default: N(() => [
                                                  W(z(D.subtext), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["size"])) : V("", !0)
                                            ])
                                          ]),
                                          (J = D.appendSlot) != null && J.component ? (k(), q(qe(D.appendSlot.component), {
                                            key: 0,
                                            class: B(D.appendSlot.class)
                                          }, null, 8, ["class"])) : V("", !0)
                                        ])
                                      ];
                                    })
                                  ]),
                                  _: 2
                                }, [
                                  v(f) ? {
                                    name: "label",
                                    fn: N(() => [
                                      te(O.$slots, "label", { value: D }, () => {
                                        var U, J;
                                        return [
                                          E("div", W8, [
                                            E("div", q8, [
                                              (U = D.prependSlot) != null && U.component ? (k(), q(qe(D.prependSlot.component), {
                                                key: 0,
                                                class: B(["mr-2", D.prependSlot.class])
                                              }, null, 8, ["class"])) : V("", !0),
                                              E("div", null, [
                                                E("span", {
                                                  class: B(["leading-6", { "text-brand": D.selected, "text-grey-500": !D.selected }]),
                                                  innerHTML: D.label
                                                }, null, 10, K8),
                                                D.subtext ? (k(), q(v(K), {
                                                  key: 0,
                                                  class: "block text-grey-300",
                                                  size: v(G).xs,
                                                  "tag-name": "sm"
                                                }, {
                                                  default: N(() => [
                                                    W(z(D.subtext), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["size"])) : V("", !0)
                                              ])
                                            ]),
                                            (J = D.appendSlot) != null && J.component ? (k(), q(qe(D.appendSlot.component), {
                                              key: 0,
                                              class: B(D.appendSlot.class)
                                            }, null, 8, ["class"])) : V("", !0)
                                          ])
                                        ];
                                      })
                                    ]),
                                    key: "0"
                                  } : void 0
                                ]), 1032, ["id", "focused", "initial-focused", "model-value", "onUpdate:modelValue"]))
                              ])
                            ]),
                            _: 2
                          }, 1032, ["class", "value", "onClick", "onKeydown"]))), 128))
                        ]))
                      ], 64)) : V("", !0)
                    ], 4), [
                      [xl, M.open]
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]))
        ])
      ]),
      _: 3
    }, 8, ["disabled", "model-value", "multiple"]));
  }
}), Z8 = { class: "cfg-slider" }, X8 = {
  key: 1,
  class: "mx-[-12px] mt-6"
}, Q8 = { class: "inputs flex justify-between" }, e7 = {
  key: 2,
  class: "block max-w-full pt-3 text-warning"
}, t7 = {
  key: 3,
  class: "block max-w-full pt-3 text-grey-300"
}, FM = /* @__PURE__ */ X({
  __name: "CfgSlider",
  props: {
    ...kt,
    modelValue: {
      type: [Number, Array],
      required: !0
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      required: !0
    },
    max: {
      type: Number,
      required: !0
    },
    tipSuffix: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    coloredMode: {
      type: String,
      default: "default"
    },
    useInputs: {
      type: Boolean,
      default: !1
    },
    inputsWidth: {
      type: String,
      default: "80px"
    },
    tooltips: {
      type: Boolean,
      default: !0
    },
    snap: {
      type: Boolean,
      default: !1
    },
    lazy: {
      type: Boolean,
      default: !0
    },
    range: {
      type: Object,
      default: void 0
    },
    connect: {
      type: [String, Boolean],
      default: !0
    }
  },
  emits: ["update:modelValue", "apply", "drag:end"],
  async setup(n, { emit: e }) {
    let t, r;
    const i = n, s = e, o = ae(i.modelValue), { default: a } = ([t, r] = _l(() => import("@vueform/slider")), t = await t, r(), t), l = Z(() => {
      const c = {
        snap: i.snap,
        connect: i.connect,
        range: i.range || { min: i.min, max: i.max }
      };
      return i.lazy ? c : {};
    });
    Ie(
      () => i.modelValue,
      () => {
        fr(o.value, i.modelValue) || (o.value = i.modelValue);
      },
      { deep: !0, immediate: !0 }
    ), Ie(
      o,
      () => {
        i.lazy || fr(o.value, i.modelValue) || s("update:modelValue", o.value);
      },
      { deep: !0, immediate: !0 }
    );
    async function u(c, f) {
      const p = Array.isArray(o.value) && f === 1 ? o.value[0] : i.min;
      let h = Array.isArray(o.value) && f === 0 ? o.value[1] : i.max;
      f === 0 && Array.isArray(o.value) && (h = o.value[1]);
      let y = Number(c);
      y < p ? y = p : y > h && (y = h), y = Math.round(y / i.step) * i.step, Vr(() => {
        o.value[f] = y, o.value = [...o.value], d(o.value);
      });
    }
    function d(c) {
      s("update:modelValue", c), s("apply", c);
    }
    return (c, f) => (k(), T("div", Z8, [
      c.placeholder ? (k(), q(K, {
        key: 0,
        class: "mb-5 block text-grey-300",
        size: v(G).md
      }, {
        default: N(() => [
          W(z(c.placeholder), 1)
        ]),
        _: 1
      }, 8, ["size"])) : V("", !0),
      A(v(a), {
        modelValue: o.value,
        "onUpdate:modelValue": f[0] || (f[0] = (p) => o.value = p),
        class: B(["core-slider cfg-slider__slider w-full", { [`cfg-slider__slider--colored-mode__${n.coloredMode}`]: !0 }]),
        disabled: n.disabled || c.loading,
        lazy: n.lazy,
        max: n.max,
        min: n.min,
        options: l.value,
        "show-tooltip": "drag",
        step: n.step,
        tooltips: n.tooltips,
        onEnd: f[1] || (f[1] = (p) => c.$emit("drag:end")),
        onUpdate: d
      }, null, 8, ["modelValue", "class", "disabled", "lazy", "max", "min", "options", "step", "tooltips"]),
      n.useInputs ? (k(), T("div", X8, [
        E("div", Q8, [
          A(ec, {
            max: n.max,
            min: o.value[0],
            "model-value": String(o.value[0]),
            step: n.step,
            style: mt({
              width: n.inputsWidth
            }),
            suffix: n.tipSuffix,
            type: "number",
            onBlur: f[2] || (f[2] = (p) => u(p, 0))
          }, null, 8, ["max", "min", "model-value", "step", "style", "suffix"]),
          A(ec, {
            max: n.max,
            min: o.value[0],
            "model-value": String(o.value[1]),
            step: n.step,
            style: mt({
              width: n.inputsWidth
            }),
            suffix: n.tipSuffix,
            type: "number",
            onBlur: f[3] || (f[3] = (p) => u(p, 1))
          }, null, 8, ["max", "min", "model-value", "step", "style", "suffix"])
        ])
      ])) : V("", !0),
      c.error && c.errorMessage ? (k(), T("small", e7, z(c.errorMessage), 1)) : V("", !0),
      !(c.error && c.errorMessage) && c.caption ? (k(), T("small", t7, z(c.caption), 1)) : V("", !0)
    ]));
  }
}), jM = /* @__PURE__ */ X({
  __name: "CfgTab",
  props: {
    as: { default: "button" },
    disabled: { type: Boolean }
  },
  setup(n) {
    const t = zt("getTabsTabIndex", () => 0)();
    return (r, i) => (k(), q(v(M9), {
      as: r.as,
      class: "relative translate-y-px px-3 pb-4 leading-none transition duration-200 focus:outline-0 data-[disabled]:cursor-not-allowed data-[state=active]:text-brand",
      disabled: r.disabled,
      value: v(t)
    }, {
      default: N(() => [
        te(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "disabled", "value"]));
  }
}), HM = /* @__PURE__ */ X({
  __name: "CfgTabPanel",
  setup(n) {
    const t = zt("getTabsPanelIndex", () => 0)();
    return (r, i) => (k(), q(v(A9), { value: v(t) }, {
      default: N(() => [
        te(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), UM = /* @__PURE__ */ X({
  __name: "CfgTabs",
  props: /* @__PURE__ */ Ae({
    as: { default: "div" }
  }, {
    selectedTab: { default: 0 },
    selectedTabModifiers: {}
  }),
  emits: ["update:selectedTab"],
  setup(n) {
    const e = je(n, "selectedTab"), t = Qd({
      tab: 0,
      panel: 0
    });
    function r(i) {
      const s = t[i];
      return t[i] += 1, s;
    }
    return sd("getTabsTabIndex", () => r("tab")), sd("getTabsPanelIndex", () => r("panel")), (i, s) => (k(), q(v(N9), {
      modelValue: e.value,
      "onUpdate:modelValue": s[0] || (s[0] = (o) => e.value = o),
      as: i.as
    }, {
      default: N(() => [
        A(v(D9), { class: "relative flex shrink-0 border-b border-b-grey-stroke" }, {
          default: N(() => [
            A(v(L9), { class: "absolute bottom-0 left-0 h-px w-[--reka-tabs-indicator-size] translate-x-[--reka-tabs-indicator-position] translate-y-px rounded-full bg-brand px-8 transition-[width,transform] duration-300" }),
            te(i.$slots, "tabs")
          ]),
          _: 3
        }),
        te(i.$slots, "panels")
      ]),
      _: 3
    }, 8, ["modelValue", "as"]));
  }
}), at = {
  default: "brand",
  success: "success",
  warning: "warning",
  danger: "red",
  neutral: "neutral"
}, n7 = { class: "timeline-item relative z-0 grid grid-cols-[2.75rem_1fr] gap-4 before:absolute before:left-[1.375rem] before:top-1/2 before:-z-10 before:h-full before:w-px before:bg-grey-100" }, r7 = { class: "flex h-11 items-center justify-center" }, i7 = {
  key: 1,
  class: "size-3 rounded-full bg-grey-100"
}, s7 = { class: "flex flex-col items-start justify-center gap-y-0.5" }, o7 = /* @__PURE__ */ X({
  __name: "CfgTimelineItem",
  props: {
    color: { default: at.default },
    icon: { default: void 0 },
    title: { default: void 0 },
    text: { default: void 0 },
    hasPingAnimation: { type: Boolean, default: !1 },
    id: { default: void 0 },
    tooltip: { type: Boolean },
    meta: { default: void 0 }
  },
  setup(n) {
    const e = n, t = Z(() => ud(e.icon) ? void 0 : M4[e.icon]), r = Z(() => ({
      background: {
        "bg-brand": e.color === at.default,
        "bg-grey-300": e.color === at.neutral,
        "bg-success": e.color === at.success,
        "bg-warning": e.color === at.warning,
        "bg-red": e.color === at.danger
      },
      backgroundLight: {
        "bg-brand/30": e.color === at.default,
        "bg-grey-300/30": e.color === at.neutral,
        "bg-success/30": e.color === at.success,
        "bg-warning/30": e.color === at.warning,
        "bg-red/30": e.color === at.danger
      },
      ring: {
        "ring-brand/30": e.color === at.default,
        "ring-success/30": e.color === at.success,
        "ring-warning/30": e.color === at.warning,
        "ring-red/30": e.color === at.danger,
        "ring-grey-300/30": e.color === at.neutral
      },
      text: {
        "text-dark": e.color === at.success || e.color === at.neutral || e.color === at.default,
        "text-warning": e.color === at.warning,
        "text-red": e.color === at.danger
      }
    }));
    return (i, s) => (k(), T("div", n7, [
      E("div", r7, [
        !v(ud)(t.value) || i.$slots.icon ? (k(), T(ce, { key: 0 }, [
          E("span", {
            class: B(["flex size-[30px] items-center justify-center rounded-full text-white ring-[7px] [&>*]:size-4", { ...r.value.ring, ...r.value.background }])
          }, [
            te(i.$slots, "icon", {}, () => [
              (k(), q(qe(t.value)))
            ])
          ], 2),
          i.hasPingAnimation ? (k(), T("span", {
            key: 0,
            class: B(["absolute inline-flex size-[33px] animate-ping rounded-full", r.value.backgroundLight])
          }, null, 2)) : V("", !0)
        ], 64)) : (k(), T("span", i7))
      ]),
      E("div", s7, [
        te(i.$slots, "content", {
          text: i.text,
          title: i.title
        }, () => [
          v(is)(i.title) ? V("", !0) : (k(), q(v(K), {
            key: 0,
            class: B(r.value.text),
            size: v(G).sm
          }, {
            default: N(() => [
              te(i.$slots, "title", { title: i.title }, () => [
                W(z(i.title), 1)
              ])
            ]),
            _: 3
          }, 8, ["class", "size"])),
          v(is)(i.text) ? V("", !0) : (k(), q(v(K), {
            key: 1,
            class: "text-sm text-grey-300",
            size: v(G).sm
          }, {
            default: N(() => [
              te(i.$slots, "text", { text: i.text }, () => [
                W(z(i.text), 1)
              ])
            ]),
            _: 3
          }, 8, ["size"]))
        ])
      ])
    ]));
  }
}), WM = /* @__PURE__ */ X({
  __name: "CfgTimeline",
  props: {
    items: {}
  },
  setup(n) {
    return (e, t) => (k(), T("div", null, [
      te(e.$slots, "prependItems", { attrs: { class: "timeline-item-wrapper" } }),
      (k(!0), T(ce, null, $e(e.items, (r, i) => (k(), T("div", {
        key: i,
        class: "timeline-item-wrapper"
      }, [
        A(Zi, {
          class: "w-full max-w-full [&>*]:max-w-full",
          disabled: !r.tooltip,
          "hide-icon": ""
        }, {
          trigger: N(() => [
            A(o7, Te({ ref_for: !0 }, r), null, 16)
          ]),
          content: N(() => [
            te(e.$slots, "tooltip", { item: r })
          ]),
          _: 2
        }, 1032, ["disabled"])
      ]))), 128)),
      te(e.$slots, "appendItems", { attrs: { class: "timeline-item-wrapper" } })
    ]));
  }
});
var dn = /* @__PURE__ */ ((n) => (n.Success = "success", n.Error = "error", n.Warning = "warning", n.Info = "info", n))(dn || {});
const a7 = { class: "p-4" }, l7 = { class: "flex items-center" }, u7 = { class: "shrink-0" }, d7 = { class: "ml-4 w-0 flex-1 pt-0.5" }, c7 = ["innerHTML"], f7 = { class: "ml-5 flex shrink-0 self-center" }, qM = /* @__PURE__ */ X({
  __name: "CfgToastNotification",
  props: {
    type: {},
    title: {},
    message: {}
  },
  emits: ["close"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = Z(() => t.type === dn.Info ? od : t.type === dn.Success ? n1 : t.type === dn.Warning ? I4 : t.type === dn.Error ? Ut : od);
    return (s, o) => (k(), T("div", {
      class: B(["pointer-events-auto w-full max-w-sm overflow-hidden rounded-xl border-l-4 bg-white shadow-base ring-1 ring-dark-100/5", {
        "border-none": s.type === v(dn).Info,
        "border-success": s.type === v(dn).Success,
        "border-yellow": s.type === v(dn).Warning,
        "border-warning": s.type === v(dn).Error
      }])
    }, [
      E("div", a7, [
        E("div", l7, [
          E("div", u7, [
            te(s.$slots, "icon", {}, () => [
              E("div", {
                class: B(["mt-1 rounded-xl p-2", {
                  "bg-grey-100/50 text-grey-200": s.type === v(dn).Info,
                  "bg-success-light text-success": s.type === v(dn).Success,
                  "bg-yellow-light text-yellow": s.type === v(dn).Warning,
                  "bg-warning-light text-warning": s.type === v(dn).Error
                }])
              }, [
                (k(), q(qe(i.value), {
                  "aria-hidden": "true",
                  class: "text-lg"
                }))
              ], 2)
            ])
          ]),
          E("div", d7, [
            A(K, {
              class: "text-dark-300 text-[18px] leading-[1.15]",
              "tag-name": "h4"
            }, {
              default: N(() => [
                W(z(s.title), 1)
              ]),
              _: 1
            }),
            s.message ? (k(), T("p", {
              key: 0,
              class: "mt-2 text-sm text-grey-400",
              innerHTML: s.message
            }, null, 8, c7)) : V("", !0)
          ]),
          E("div", f7, [
            E("button", {
              class: "focusable inline-flex rounded-xl bg-white text-grey-300 hover:text-grey-500",
              type: "button",
              onClick: o[0] || (o[0] = (a) => r("close"))
            }, [
              o[1] || (o[1] = E("span", { class: "sr-only" }, "Close", -1)),
              A(v(Ut), {
                "aria-hidden": "true",
                class: "text-lg"
              })
            ])
          ])
        ])
      ])
    ], 2));
  }
}), p7 = { class: "flex flex-col gap-5" }, h7 = { class: "flex gap-x-2" }, m7 = { class: "grow" }, KM = /* @__PURE__ */ X({
  __name: "CfgAddressDetailsField",
  props: {
    ...kt,
    ...Wt,
    modelValue: {
      type: [Object, null],
      required: !0
    },
    translates: {
      type: Object,
      required: !0
    },
    zipLengthErrorMessage: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = Z({
      get() {
        const o = {
          firstLine: "",
          secondLine: "",
          zip: "",
          state: ""
        };
        return t.modelValue || o;
      },
      set(o) {
        r("update:modelValue", o);
      }
    }), s = Z(() => {
      const o = {
        firstLine: "",
        secondLine: "",
        zip: "",
        state: ""
      };
      return t.error && i.value && Object.entries(i.value).forEach(([a, l]) => {
        l || (o[a] = t.errorMessage);
      }), i.value.zip.length > 5 && (o.zip = t.zipLengthErrorMessage), o;
    });
    return (o, a) => {
      var l, u, d, c;
      return k(), T("div", p7, [
        A(pn, {
          caption: n.translates.captions.firstLine,
          error: !!s.value.firstLine,
          "error-message": s.value.firstLine,
          fluid: !0,
          "initial-focused": o.initialFocused,
          "model-value": (l = i.value) == null ? void 0 : l.firstLine,
          placeholder: n.translates.placeholders.firstLine,
          required: o.required,
          "onUpdate:modelValue": a[0] || (a[0] = (f) => {
            i.value = {
              ...i.value,
              firstLine: f.toString()
            };
          })
        }, null, 8, ["caption", "error", "error-message", "initial-focused", "model-value", "placeholder", "required"]),
        E("div", h7, [
          A(pn, {
            caption: n.translates.captions.secondLine,
            error: !!s.value.secondLine,
            "error-message": s.value.secondLine,
            fluid: !0,
            "model-value": (u = i.value) == null ? void 0 : u.secondLine,
            placeholder: n.translates.placeholders.secondLine,
            required: o.required,
            "onUpdate:modelValue": a[1] || (a[1] = (f) => {
              i.value = {
                ...i.value,
                secondLine: f.toString()
              };
            })
          }, null, 8, ["caption", "error", "error-message", "model-value", "placeholder", "required"]),
          E("div", m7, [
            A(pn, {
              caption: n.translates.captions.zip,
              class: "w-[100px]",
              error: !!s.value.zip,
              "error-message": s.value.zip,
              fluid: !0,
              "model-value": (d = i.value) == null ? void 0 : d.zip,
              placeholder: n.translates.placeholders.zip,
              required: o.required,
              "onUpdate:modelValue": a[2] || (a[2] = (f) => {
                i.value = {
                  ...i.value,
                  zip: f.toString()
                };
              })
            }, null, 8, ["caption", "error", "error-message", "model-value", "placeholder", "required"])
          ])
        ]),
        A(pn, {
          caption: n.translates.captions.state,
          error: !!s.value.state,
          "error-message": s.value.state,
          fluid: !0,
          "model-value": (c = i.value) == null ? void 0 : c.state,
          placeholder: n.translates.placeholders.state,
          required: o.required,
          "onUpdate:modelValue": a[3] || (a[3] = (f) => {
            i.value = {
              ...i.value,
              state: f.toString()
            };
          })
        }, null, 8, ["caption", "error", "error-message", "model-value", "placeholder", "required"])
      ]);
    };
  }
});
function g7(n, e) {
  const t = Object.entries(n).reduce((s, [o, a]) => {
    const {
      value: l,
      cols: u = 2,
      validators: d = [],
      classNames: c,
      show: f,
      ...p
    } = a;
    return s[o] = {
      component: a.control,
      props: p,
      modelValue: l,
      validators: d,
      cols: u,
      show: f,
      _visible: !0,
      attributes: {
        classNames: c
      }
    }, s;
  }, {}), r = Qd(
    Object.fromEntries(
      Object.entries(t).map((s) => {
        const [o, a] = s;
        return [o, {
          ...Ji(a),
          props: a.props
          // pass props separately to avoid loosing reactivity
        }];
      })
    )
  );
  Ie(() => e, () => {
    if (e) {
      let s = e;
      rs(e) && (s = e.value), Object.entries(s).forEach((o) => {
        const [a, l] = o;
        r[a].modelValue = Ji(l);
      });
    }
  }, { deep: !0, immediate: !0 });
  const i = Z(() => fp(r));
  return t1(() => {
    Object.entries(i.value).forEach((s) => {
      const [o] = s, a = r == null ? void 0 : r[o];
      a._visible = ud(a.show) ? !0 : a.show({ state: i.value });
    });
  }), {
    results: i,
    schema: r,
    resetData() {
      Object.entries(r).forEach((s) => {
        const [o] = s;
        r[o].modelValue = e ? (rs(e) ? e.value : e)[o] : Ji(n[o].value);
      });
    }
  };
}
function fp(n) {
  return Object.entries(n).reduce(
    (e, [t, r]) => ({
      ...e,
      [t]: r.modelValue
    }),
    {}
  );
}
var Qe = /* @__PURE__ */ ((n) => (n.Input = "input", n.Textarea = "textarea", n.DateField = "dateField", n.Select = "select", n.Multiselect = "multiselect", n.Combobox = "combobox", n.Radio = "radio", n.Switch = "switch", n.Checkbox = "checkbox", n.RadioGroup = "radioGroup", n.CheckboxGroup = "checkboxGroup", n.AccountNumber = "accountNumber", n.Slider = "slider", n.RangeSlider = "rangeSlider", n.BirthNumberField = "birthNumberField", n.AddressDetailsField = "addressDetailsField", n.PasswordField = "passwordField", n.PhoneNumberField = "phoneNumberField", n.RichEditor = "richEditor", n.ArrayField = "arrayField", n.FileInput = "fileInput", n))(Qe || {});
const b7 = {
  key: 0,
  class: "flex justify-center"
}, y7 = /* @__PURE__ */ X({
  __name: "CfgForm",
  props: {
    /**
     * The schema of the form. Can be generated useForm hook
     */
    schema: {
      type: Object,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * The label of the submit button. Default button will be replaced with slot name submit. Contains onSubmit event in slot props.
     * For example: v-slot={ onSubmit }
     */
    buttonLabel: {
      type: String,
      default: "DEFAULT_BUTTON_LABEL"
    },
    /**
     * Controls whether the submit button should be rendered or not
     */
    renderSubmitButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Controls whether the submit button should be hidden or not, but still rendered
     */
    hideSubmitButton: {
      type: Boolean,
      default: !1
    },
    /**
     * Shows elements placed horizontally - next to each other
     */
    horizontal: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["submit"],
  async setup(n, { expose: e, emit: t }) {
    let r, i;
    const s = n, o = t, { schema: a, loading: l } = wl(s), u = Z(() => z9(a.value, ($) => ($ == null ? void 0 : $._visible) !== !1)), d = ae(null), c = ae(null), { width: f } = uo(d), p = Z(() => f.value > 500), h = Object.fromEntries(Object.keys(a).map(($) => [$, null])), y = {
      [Qe.Input]: async () => (await import("./CfgInput-CsmcsAHG.js")).default,
      [Qe.Textarea]: async () => (await import("./CfgTextarea-BGzpI_Bi.js")).default,
      [Qe.DateField]: async () => (await import("./CfgDateField-BKOCPMZ4.js")).default,
      [Qe.Select]: async () => (await import("./index-8kizs_47.js")).CfgSelect,
      [Qe.Multiselect]: async () => (await import("./index-8kizs_47.js")).CfgSelect,
      [Qe.Combobox]: async () => (await import("./index-8kizs_47.js")).CfgCombobox,
      [Qe.Radio]: async () => (await import("./index-BmTN-MsV.js")).CfgRadio,
      [Qe.Switch]: async () => (await import("./index-BmTN-MsV.js")).CfgSwitch,
      [Qe.Checkbox]: async () => (await import("./index-BmTN-MsV.js")).CfgCheckbox,
      [Qe.RadioGroup]: async () => (await import("./index-8kizs_47.js")).CfgRadioGroup,
      [Qe.CheckboxGroup]: async () => (await import("./index-8kizs_47.js")).CfgCheckboxGroup,
      [Qe.AccountNumber]: async () => (await import("./CfgBankAccountField-okd5YA7v.js")).default,
      [Qe.Slider]: async () => (await import("./index-8kizs_47.js")).CfgSlider,
      [Qe.RangeSlider]: async () => (await import("./index-8kizs_47.js")).CfgSlider,
      [Qe.BirthNumberField]: async () => (await import("./CfgBirthNumberField-Ci4O3o0b.js")).default,
      [Qe.AddressDetailsField]: async () => (await import("./CfgAddressDetailsField-CIQOZq0m.js")).default,
      [Qe.PasswordField]: async () => (await import("./CfgPasswordField-CfRFSU4r.js")).default,
      [Qe.PhoneNumberField]: async () => (await import("./CfgPhoneNumberField-BGBoeBgL.js")).default,
      [Qe.RichEditor]: async () => (await import("./CfgRichEditor-CRqUfcSq.js")).default,
      [Qe.ArrayField]: async () => (await import("./CfgFormArrayField-Cbpt93qf.js")).default,
      [Qe.FileInput]: async () => (await import("./CfgFileInput-DOWlBoCI.js")).default
    };
    e({
      resetForm() {
        var $;
        ($ = c.value) == null || $.resetForm();
      },
      async submit() {
        return c.value ? c.value.submit() : !1;
      }
    }), [r, i] = _l(() => g()), await r, i();
    async function g() {
      (await Promise.all(
        Object.entries(a.value).map(async (w) => {
          const [_, L] = w, S = await y[L.component]();
          return [_, S];
        })
      )).forEach(([w, _]) => {
        h[w] = _;
      });
    }
    function m() {
      o("submit", fp(a.value));
    }
    return ($, w) => (k(), T("div", null, [
      A(p8, {
        ref_key: "validationObserverRef",
        ref: c,
        onSubmit: m
      }, {
        default: N((_) => [
          E("form", {
            ref_key: "formRoot",
            ref: d,
            class: "cfg-form space-y-4 pt-2",
            novalidate: "",
            onSubmit: w[0] || (w[0] = Ht(() => {
            }, ["prevent"]))
          }, [
            E("div", {
              class: B(["grid gap-5", n.horizontal ? "cfg-table-form-container-horizontal" : "grid-cols-2"])
            }, [
              (k(!0), T(ce, null, $e(u.value, (L, S) => (k(), T("div", {
                key: S,
                class: B({
                  "col-span-1": L.cols === 1 && p.value,
                  "col-span-2": L.cols === 2 || !p.value,
                  [`cfg-form__field--${L.component}`]: !0,
                  [L.attributes.classNames]: !!L.attributes.classNames
                })
              }, [
                te($.$slots, `before:${S}`, {}, void 0, !0),
                A(up, Te({
                  modelValue: L.modelValue,
                  "onUpdate:modelValue": (R) => L.modelValue = R,
                  validators: L.validators
                }, oo(_.on)), {
                  default: N(({ on: R, attrs: O, componentRef: I }) => [
                    (k(), q(qe(v(h)[S]), Te({ ref_for: !0 }, {
                      // User's passed props
                      ...v(kl)(L.props, "control"),
                      ...O,
                      loading: L.props.loading || O.loading
                    }, {
                      ref_for: !0,
                      ref: L.component === v(Qe).ArrayField ? I : void 0,
                      class: "w-full"
                    }, oo(R)), null, 16))
                  ]),
                  _: 2
                }, 1040, ["modelValue", "onUpdate:modelValue", "validators"]),
                te($.$slots, `after:${S}`, {}, void 0, !0)
              ], 2))), 128))
            ], 2),
            n.renderSubmitButton ? (k(), T("div", b7, [
              te($.$slots, "submit", {
                onSubmit: _.submit
              }, () => [
                A(hr, {
                  class: B(["mt-4 w-full", {
                    hidden: n.hideSubmitButton
                  }]),
                  fluid: "",
                  loading: v(l) || _.validationLoading,
                  "ripple-scale": "",
                  type: "submit",
                  onClick: _.submit
                }, {
                  default: N(() => [
                    W(z(n.buttonLabel), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "loading", "onClick"])
              ], !0)
            ])) : V("", !0)
          ], 544)
        ]),
        _: 3
      }, 512)
    ]));
  }
}), v7 = /* @__PURE__ */ Bn(y7, [["__scopeId", "data-v-384c2fde"]]), Ot = [];
for (let n = 0; n < 256; ++n)
  Ot.push((n + 256).toString(16).slice(1));
function _7(n, e = 0) {
  return (Ot[n[e + 0]] + Ot[n[e + 1]] + Ot[n[e + 2]] + Ot[n[e + 3]] + "-" + Ot[n[e + 4]] + Ot[n[e + 5]] + "-" + Ot[n[e + 6]] + Ot[n[e + 7]] + "-" + Ot[n[e + 8]] + Ot[n[e + 9]] + "-" + Ot[n[e + 10]] + Ot[n[e + 11]] + Ot[n[e + 12]] + Ot[n[e + 13]] + Ot[n[e + 14]] + Ot[n[e + 15]]).toLowerCase();
}
let uu;
const $7 = new Uint8Array(16);
function x7() {
  if (!uu) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    uu = crypto.getRandomValues.bind(crypto);
  }
  return uu($7);
}
const w7 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), nc = { randomUUID: w7 };
function rc(n, e, t) {
  var i;
  if (nc.randomUUID && !e && !n)
    return nc.randomUUID();
  n = n || {};
  const r = n.random ?? ((i = n.rng) == null ? void 0 : i.call(n)) ?? x7();
  if (r.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, _7(r);
}
const k7 = {
  key: 0,
  class: "mb-2 flex items-center text-sm font-highlighted"
}, C7 = {
  key: 0,
  class: "ml-1 text-red"
}, S7 = { class: "mt-2 flex items-center justify-between" }, E7 = { class: "font-medium" }, T7 = { class: "mt-3 space-x-2" }, GM = /* @__PURE__ */ X({
  __name: "CfgArrayField",
  props: /* @__PURE__ */ Ae({
    itemSchema: {},
    addButtonLabel: { default: "Add item" },
    removeButtonLabel: { default: "Remove" },
    itemLabel: { default: "Item" },
    error: { type: Boolean, default: !1 },
    errorMessage: { default: "" },
    caption: { default: "" },
    disabled: { type: Boolean, default: !1 },
    validateLabel: { default: "Validate" },
    label: { default: "" },
    required: { type: Boolean, default: !1 },
    itemClasses: { default: "" }
  }, {
    modelValue: {
      type: Array,
      default: () => []
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n, { expose: e }) {
    e({
      addItem: l,
      validate: d
    });
    const t = je(n, "modelValue"), r = h9(), i = ae({});
    function s(c, f) {
      return g7(c, f);
    }
    async function o() {
      var c;
      (c = t.value) == null || c.forEach((f) => {
        const p = rc();
        i.value[p] || (i.value[p] = s(n.itemSchema, f));
      });
    }
    async function a() {
      const c = {};
      for (const [f, p] of Object.entries(n.itemSchema))
        p && typeof p == "object" && "value" in p ? c[f] = Ji(p.value) : c[f] = null;
      return c;
    }
    async function l() {
      const c = await a(), f = t.value ? [...t.value, c] : [c];
      t.value = f;
      const p = rc();
      i.value[p] = s(n.itemSchema, c);
    }
    function u(c) {
      delete i.value[c];
      const f = Object.values(i.value).map((p) => p.results);
      t.value = f.map((p) => p.value);
    }
    async function d() {
      if (!r.value)
        return !1;
      let c = !0;
      for (const f of r.value) {
        const p = await f.submit();
        c && (c = p);
      }
      return c;
    }
    return Dt(async () => {
      await o();
    }), Ie(i, () => {
      const c = Object.values(i.value).map((f) => f.results);
      t.value = c;
    }, { deep: !0 }), (c, f) => (k(), T("div", null, [
      c.label ? (k(), T("div", k7, [
        W(z(c.label) + " ", 1),
        c.required ? (k(), T("span", C7, "*")) : V("", !0)
      ])) : V("", !0),
      te(c.$slots, "caption", Fr(Yi({ caption: c.caption })), () => [
        c.caption ? (k(), q(K, {
          key: 0,
          class: "text-gray-600 mb-2 text-sm",
          "tag-name": "div"
        }, {
          default: N(() => [
            W(z(c.caption), 1)
          ]),
          _: 1
        })) : V("", !0)
      ]),
      te(c.$slots, "error", Fr(Yi({ error: c.error, errorMessage: c.errorMessage })), () => [
        c.error && c.errorMessage ? (k(), q(K, {
          key: 0,
          class: "mb-2 text-sm text-red-500",
          "tag-name": "div"
        }, {
          default: N(() => [
            W(z(c.errorMessage), 1)
          ]),
          _: 1
        })) : V("", !0)
      ]),
      t.value && t.value.length > 0 ? (k(!0), T(ce, { key: 1 }, $e(i.value, (p, h) => (k(), T("div", {
        key: h,
        class: B(c.itemClasses)
      }, [
        te(c.$slots, "item", Te({ ref_for: !0 }, {
          instance: p,
          key: h,
          removeItem: () => u(h),
          itemLabel: c.itemLabel,
          disabled: c.disabled,
          removeButtonLabel: c.removeButtonLabel
        }), () => [
          te(c.$slots, "item-header", Te({ ref_for: !0 }, {
            removeItem: () => u(h),
            itemLabel: c.itemLabel,
            disabled: c.disabled,
            removeButtonLabel: c.removeButtonLabel
          }), () => [
            E("div", S7, [
              E("div", E7, z(c.itemLabel), 1),
              c.disabled ? V("", !0) : (k(), q(hr, {
                key: 0,
                size: "sm",
                text: "",
                onClick: (y) => u(h)
              }, {
                default: N(() => [
                  W(z(c.removeButtonLabel), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            ])
          ]),
          te(c.$slots, "item-form", Te({ ref_for: !0 }, { instance: p, formRefs: v(r) }), () => [
            A(v7, {
              ref_for: !0,
              ref: v(r).set,
              "render-submit-button": !1,
              schema: p.schema
            }, null, 8, ["schema"])
          ])
        ])
      ], 2))), 128)) : V("", !0),
      te(c.$slots, "footer", Fr(Yi({
        addButtonLabel: c.addButtonLabel,
        validateLabel: c.validateLabel,
        addItem: l,
        validate: d
      })), () => [
        E("div", T7, [
          A(hr, {
            disabled: c.disabled,
            size: "sm",
            small: "",
            variant: "secondary",
            onClick: l
          }, {
            default: N(() => [
              W(z(c.addButtonLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]));
  }
}), ic = 450, YM = /* @__PURE__ */ X({
  __name: "CfgBankAccountField",
  props: {
    ...kt,
    ...Wt,
    modelValue: {
      type: Object,
      default: () => ({
        accountNumber: "",
        bankCode: ""
      })
    },
    codePlaceholder: {
      type: String,
      required: !0
    },
    errorTranslations: {
      type: Object,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = ae(), { width: s } = i1(i), o = Z(() => pr(t, Object.keys(kl({ ...kt, ...Wt }, "modelValue")))), a = Object.entries(ru).map((f) => {
      const [p, h] = f;
      return {
        value: ru[p],
        label: `${h} - ${y9[`${ru[p]}`]}`
      };
    }), l = Z({
      get() {
        return t.modelValue || { accountNumber: "", bankCode: "" };
      },
      set(f) {
        r("update:modelValue", f);
      }
    }), u = Z({
      get() {
        var f, p;
        if ((f = l.value) != null && f.bankCode) {
          const h = (p = a.find((y) => y.value === l.value.bankCode)) == null ? void 0 : p.value;
          if (h)
            return {
              label: h,
              value: h
            };
        }
        return null;
      },
      set(f) {
        f && (l.value = {
          ...l.value || {},
          bankCode: f.value
        });
      }
    }), d = Z(() => {
      const f = {
        accountNumber: "",
        bankCode: ""
      };
      return t.error && (l.value.accountNumber || (f.accountNumber = t.errorTranslations.accountNumber.required), l.value.bankCode || (f.bankCode = t.errorTranslations.bankCode), l.value.accountNumber && !l.value.bankCode && (f.accountNumber = ""), l.value.accountNumber && l.value.bankCode && (f.accountNumber = t.errorTranslations.accountNumber.invalid)), f;
    });
    function c(f) {
      l.value = { ...l.value, accountNumber: f };
    }
    return (f, p) => {
      var h;
      return k(), T("div", {
        ref_key: "rootElRef",
        ref: i,
        class: B(["flex gap-2", {
          "flex-col": v(s) < ic
        }])
      }, [
        A(pn, Te({
          ...o.value,
          modelValue: ((h = l.value) == null ? void 0 : h.accountNumber) || ""
        }, {
          class: "relative grow cursor-pointer",
          error: !!d.value.accountNumber,
          "error-message": d.value.accountNumber,
          fluid: "",
          required: "",
          "onUpdate:modelValue": p[0] || (p[0] = (y) => c(String(y)))
        }), null, 16, ["error", "error-message"]),
        A(x1, {
          modelValue: u.value,
          "onUpdate:modelValue": p[1] || (p[1] = (y) => u.value = y),
          class: B(["w-1/4 min-w-[180px]", {
            "max-w-[300px]": v(s) >= ic
          }]),
          disabled: t.disabled,
          error: !!d.value.bankCode,
          "error-message": d.value.bankCode,
          options: v(a),
          origin: "right",
          placeholder: n.codePlaceholder,
          required: "",
          style: { "--max-height": "400px" }
        }, null, 8, ["modelValue", "class", "disabled", "error", "error-message", "options", "placeholder"])
      ], 2);
    };
  }
}), O7 = { class: "w-[340px] rounded-xl bg-white px-8 pb-6 pt-7 sm:w-[375px]" }, M7 = /* @__PURE__ */ X({
  __name: "CfgDateField",
  props: /* @__PURE__ */ Ae({
    ...kt,
    ...Wt,
    ...rp,
    allowedPlacements: {
      type: $1.allowedPlacements.type,
      default: () => ["bottom"]
    }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = n, t = Z(() => pr(e, Object.keys({ ...kt, ...Wt }))), r = je(n, "modelValue"), i = Z(() => r.value ? Ke(r.value).format("D. M. YYYY") : ""), s = ae(!1);
    function o() {
      Vr(() => {
        s.value = !1;
      });
    }
    return (a, l) => (k(), q(dp, {
      opened: s.value,
      "onUpdate:opened": l[1] || (l[1] = (u) => s.value = u),
      "allowed-placements": n.allowedPlacements,
      "min-width": 340,
      "use-trigger-content-width": !0
    }, {
      trigger: N(() => [
        A(pn, Te({
          ...t.value,
          modelValue: i.value,
          readonly: !0,
          fluid: !0
        }, {
          class: "relative cursor-pointer",
          "field-class": "!bg-white"
        }), {
          icon: N(() => [
            A(v(r1), {
              class: B(["text-[1.5rem] transition-colors duration-200", { "text-brand": s.value, "text-grey-300": !s.value }])
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 16)
      ]),
      content: N(() => [
        E("div", O7, [
          A(W5, {
            modelValue: r.value,
            "onUpdate:modelValue": l[0] || (l[0] = (u) => r.value = u),
            "max-date": a.maxDate,
            "min-date": a.minDate,
            onSelectDate: o
          }, null, 8, ["modelValue", "max-date", "min-date"])
        ])
      ]),
      _: 1
    }, 8, ["opened", "allowed-placements"]));
  }
}), A7 = { class: "grow" }, sc = 450, JM = /* @__PURE__ */ X({
  __name: "CfgBirthNumberField",
  props: /* @__PURE__ */ Ae({
    ...kt,
    ...Wt,
    translates: {
      type: Object,
      required: !0
    }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = n, t = Z(() => pr(e, Object.keys({ ...kt, ...Wt }))), r = je(n, "modelValue"), i = ae(), { width: s } = i1(i), o = Z({
      get() {
        var d;
        return ((d = r.value) == null ? void 0 : d.birthDate) || null;
      },
      set(d) {
        d && u({
          birthDate: d
        });
      }
    });
    function a(d) {
      u({ birthNumber: d });
    }
    function l() {
      var d;
      (d = r.value) != null && d.birthNumber && v9.validateBirthNumber(r.value.birthNumber) && u({
        birthDate: _9(r.value.birthNumber)
      });
    }
    function u(d) {
      r.value = {
        ...r.value || { birthDate: null, birthNumber: "" },
        ...d
      };
    }
    return (d, c) => {
      var f;
      return k(), T("div", {
        ref_key: "rootElRef",
        ref: i,
        class: B(["flex gap-2", { "flex-col": v(s) < sc }])
      }, [
        E("div", A7, [
          A(pn, Te({
            ...t.value,
            modelValue: ((f = r.value) == null ? void 0 : f.birthNumber) || "",
            placeholder: n.translates.birthNumberPlaceholder,
            fluid: !0
          }, {
            class: "relative cursor-pointer",
            required: "",
            onBlur: l,
            "onUpdate:modelValue": c[0] || (c[0] = (p) => a(p.toString()))
          }), null, 16)
        ]),
        A(M7, {
          modelValue: o.value,
          "onUpdate:modelValue": c[1] || (c[1] = (p) => o.value = p),
          class: B({ "w-[240px]": v(s) >= sc }),
          disabled: e.disabled,
          placeholder: n.translates.birthDatePlaceholder
        }, null, 8, ["modelValue", "class", "disabled", "placeholder"])
      ], 2);
    };
  }
}), N7 = { class: "relative flex h-6 items-center" }, D7 = { class: "flex h-full items-center gap-1" }, pp = /* @__PURE__ */ X({
  __name: "Collaterals",
  props: {
    label: {},
    description: {},
    moreLabel: {},
    slideOverTitle: {},
    slideOverSubtitle: {},
    collaterals: {},
    moreTypesLabel: {},
    tooltipButtonLabel: {},
    isMobile: { type: Boolean },
    isPublic: { type: Boolean },
    small: { type: Boolean },
    showDetailsButton: { type: Boolean }
  },
  emits: ["showDetails"],
  setup(n) {
    return (e, t) => {
      const r = Yt("ripple");
      return k(), T("div", N7, [
        E("div", D7, [
          (k(!0), T(ce, null, $e(e.collaterals.length, (i) => (k(), T("div", {
            key: i,
            class: "h-2 w-[10px] shrink-0 rounded-full bg-brand lg:h-[11px] lg:w-[14px]"
          }))), 128))
        ]),
        e.collaterals.length ? (k(), q(v(K), {
          key: 0,
          class: "ml-3 line-clamp-1 text-left !font-light",
          size: v(G).sm
        }, {
          default: N(() => [
            W(z(e.moreTypesLabel), 1)
          ]),
          _: 1
        }, 8, ["size"])) : V("", !0),
        e.showDetailsButton ? nt((k(), T("button", {
          key: 1,
          class: B(["ml-1 size-10 -translate-x-1.5 pl-1.5 hover:opacity-60", {
            "-translate-y-px": !e.small
          }]),
          onClick: t[0] || (t[0] = Ht((i) => e.$emit("showDetails"), ["prevent", "stop"]))
        }, [
          e.collaterals.length ? (k(), q(v(K), {
            key: 0,
            class: "line-clamp-1 text-left !font-medium text-orange underline",
            size: v(G).sm
          }, {
            default: N(() => t[1] || (t[1] = [
              W(" více ")
            ])),
            _: 1
          }, 8, ["size"])) : V("", !0)
        ], 2)), [
          [r]
        ]) : V("", !0)
      ]);
    };
  }
}), Xi = /* @__PURE__ */ X({
  __name: "RatingChip",
  props: {
    rating: {},
    big: { type: Boolean }
  },
  setup(n) {
    const e = Z(() => {
      switch (n.rating) {
        case "A++":
        case "A+":
        case "A":
          return "!bg-[#27AE60]";
        case "B++":
        case "B+":
        case "B":
          return "!bg-[#A2CC2D]";
        case "C":
          return "!bg-[#E9BB00]";
        case "D":
          return "!bg-[#F28500]";
        case "E":
          return "!bg-[#EB5757]";
        default:
          return "!bg-success-200 !text-success";
      }
    });
    return (t, r) => (k(), q(v(y1), {
      class: B([
        "w-10 !rounded-none !rounded-b-lg !rounded-tl-lg !rounded-tr-sm !p-[3px] !text-white [&_span]:!font-semibold",
        {
          [e.value]: !0,
          "[&_span]:!text-[15px]": t.big
        }
      ])
    }, {
      default: N(() => [
        W(z(t.rating), 1)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), L7 = { class: "relative flex h-[187px] w-full items-start justify-end gap-2 p-3 pb-0" }, R7 = ["src"], P7 = {
  key: 1,
  class: "absolute inset-0 size-full rounded-t-xl bg-grey"
}, I7 = /* @__PURE__ */ X({
  __name: "Header",
  props: {
    tags: {},
    imageUrl: {}
  },
  setup(n) {
    return (e, t) => (k(), T("div", L7, [
      e.imageUrl ? (k(), T("img", {
        key: 0,
        class: "absolute inset-0 size-full rounded-t-xl object-cover",
        draggable: "false",
        loading: "lazy",
        src: e.imageUrl
      }, null, 8, R7)) : (k(), T("div", P7)),
      (k(!0), T(ce, null, $e(e.tags, (r, i) => (k(), q(v(y1), {
        key: i,
        class: B(["relative !rounded-lg [&_span]:!font-medium", {
          "!bg-brand text-white": i === 0,
          "!bg-stroke-gray !text-black": i === 1
        }])
      }, {
        default: N(() => [
          W(z(r), 1)
        ]),
        _: 2
      }, 1032, ["class"]))), 128))
    ]));
  }
}), B7 = { class: "flex items-center" }, z7 = /* @__PURE__ */ X({
  __name: "Info",
  props: {
    minimumInvestmentLabel: {},
    minimumInvestmentValue: {},
    periodicityLabel: {},
    periodicityValue: {},
    maturityDateLabel: {},
    maturityDateValue: {},
    investorCountLabel: {},
    investorCountValue: {},
    desktop: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = so("targetRef"), t = ae(!1);
    if (typeof window < "u" && "IntersectionObserver" in window) {
      let d = function() {
        e.value && e.value instanceof HTMLElement && f.observe(e.value);
      }, c = function() {
        f.disconnect();
      };
      const f = new IntersectionObserver((p) => {
        p.forEach((h) => {
          t.value = h.isIntersecting;
        });
      }, { threshold: 1 });
      Dt(d), Mi(c);
    } else
      t.value = !0;
    const i = ae(0), s = ae("initial");
    function o(d, c = 10, f = 25, p = 1.6, h = 2) {
      const y = Math.log(d / f) / Math.log(c);
      return Math.min(h, Math.max(p, y));
    }
    async function a() {
      const d = (await import("gsap")).default, c = { val: 0 };
      return new Promise((f) => {
        d.to(c, {
          ease: "power1.inOut",
          val: n.investorCountValue,
          delay: 0.3,
          duration: o(n.investorCountValue),
          onStart() {
            i.value = 0, s.value = "running";
          },
          onComplete() {
            i.value = n.investorCountValue, s.value = "finished", f();
          },
          onUpdate() {
            i.value = Math.round(c.val);
          }
        });
      });
    }
    Ie(t, (d) => {
      d && s.value === "initial" && a();
    });
    const l = Z(() => ({
      minimumInvestment: {
        icon: z2,
        label: n.minimumInvestmentLabel,
        value: n.minimumInvestmentValue
      },
      periodicity: {
        icon: V2,
        label: n.periodicityLabel,
        value: n.periodicityValue
      },
      investorCount: {
        icon: B4,
        label: n.investorCountLabel,
        value: i.value
      }
    })), u = Z(
      () => n.desktop ? {
        wrapper: "grid-cols-3 divide-x",
        item: "flex-col items-start",
        icon: "",
        label: "lg:!text-grey",
        value: "!font-extrabold mt-1.5"
      } : {
        wrapper: "gap-3",
        item: "items-center",
        icon: "",
        label: "",
        value: "!font-semibold ml-auto"
      }
    );
    return (d, c) => (k(), T("div", {
      ref: "targetRef",
      class: B(["grid place-items-start divide-stroke-gray", u.value.wrapper])
    }, [
      (k(!0), T(ce, null, $e(l.value, (f, p, h) => (k(), T("div", {
        key: p,
        class: B(["flex w-full items-start justify-between", [u.value.item, d.desktop && h !== 0 && "pl-12"]])
      }, [
        E("div", B7, [
          d.desktop ? V("", !0) : (k(), q(qe(f.icon), {
            key: 0,
            class: B(["mr-3 inline-block shrink-0 text-[24px] text-grey", u.value.icon])
          }, null, 8, ["class"])),
          A(v(K), {
            class: B([u.value.label]),
            size: v(G).sm
          }, {
            default: N(() => [
              W(z(f.label), 1)
            ]),
            _: 2
          }, 1032, ["class", "size"])
        ]),
        A(v(K), {
          class: B(["transition-colors delay-300 duration-300", [
            u.value.value,
            p === "investorCount" && s.value !== "finished" && "text-brand"
          ]]),
          size: d.desktop ? v(G).h5 : v(G).sm
        }, {
          default: N(() => [
            W(z(f.value), 1)
          ]),
          _: 2
        }, 1032, ["class", "size"])
      ], 2))), 128))
    ], 2));
  }
}), V7 = ["href"], F7 = { class: "flex h-full flex-col rounded-xl bg-white p-0 shadow-card" }, j7 = { class: "flex w-full grow flex-col items-stretch p-5 pt-6" }, H7 = { class: "flex items-start justify-between gap-2" }, U7 = { class: "mt-3 flex gap-x-6" }, W7 = { class: "flex items-center gap-x-2" }, q7 = /* @__PURE__ */ X({
  __name: "Card",
  props: {
    name: {},
    interestRateFormatted: {},
    buttonLabel: {},
    rating: {},
    issueUrl: {},
    header: {},
    info: {},
    collaterals: {},
    progress: {},
    monthsUntilMaturity: {},
    maturityLabel: {}
  },
  emits: ["openIssue", "openIssueByButton"],
  setup(n) {
    const e = ae(!1);
    return (t, r) => {
      const i = Yt("ripple");
      return nt((k(), T("a", {
        class: "outline-primary focus-visible:outline-primary h-full rounded-xl outline-offset-4 focus:outline-none",
        href: t.issueUrl,
        onClick: r[2] || (r[2] = Ht((s) => t.$emit("openIssue"), ["prevent"]))
      }, [
        E("div", F7, [
          A(I7, Fr(Yi(t.header)), null, 16),
          E("div", j7, [
            E("div", H7, [
              A(v(K), {
                class: "relative line-clamp-2 text-balance text-left !font-extrabold",
                size: v(G).h5
              }, {
                default: N(() => [
                  W(z(t.name), 1)
                ]),
                _: 1
              }, 8, ["size"]),
              t.interestRateFormatted ? (k(), q(v(K), {
                key: 0,
                class: "shrink-0 !font-extrabold text-brand",
                size: v(G).h3
              }, {
                default: N(() => [
                  W(z(t.interestRateFormatted) + " ", 1),
                  r[3] || (r[3] = E("span", { class: "text-[13px] !font-medium text-brand" }, " p.a. ", -1))
                ]),
                _: 1
              }, 8, ["size"])) : V("", !0)
            ]),
            E("div", U7, [
              E("div", W7, [
                A(Xi, { rating: t.rating }, null, 8, ["rating"]),
                A(v(K), {
                  class: "!font-medium",
                  size: v(G).xs
                }, {
                  default: N(() => r[4] || (r[4] = [
                    W("Rating")
                  ])),
                  _: 1
                }, 8, ["size"])
              ]),
              A(pp, Te(t.collaterals, {
                small: "",
                onShowDetails: r[0] || (r[0] = (s) => e.value = !0)
              }), null, 16)
            ]),
            A(z7, Te({
              class: "mt-5",
              small: ""
            }, t.info), null, 16),
            r[5] || (r[5] = E("div", { class: "grow" }, null, -1)),
            A(v(hr), {
              class: "issue-card-button relative z-0 mt-7 w-full rounded-full",
              stroke: "",
              variant: "orange",
              onClick: r[1] || (r[1] = Ht((s) => t.$emit("openIssueByButton"), ["stop"]))
            }, {
              icon: N(() => [
                A(v(mn), { class: "text-[24px]" })
              ]),
              default: N(() => [
                A(v(K), {
                  class: "!font-semibold",
                  size: v(G).md
                }, {
                  default: N(() => [
                    W(z(t.buttonLabel), 1)
                  ]),
                  _: 1
                }, 8, ["size"])
              ]),
              _: 1
            }),
            A(v(K), {
              class: "mt-4 text-center !text-[13px] !font-medium text-secondary",
              "tag-name": "div"
            }, {
              default: N(() => [
                W(z(t.maturityLabel) + " " + z(t.monthsUntilMaturity), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 8, V7)), [
        [i]
      ]);
    };
  }
}), ZM = /* @__PURE__ */ Bn(q7, [["__scopeId", "data-v-ed8c48f6"]]);
/*!
  * PhotoSwipe Lightbox 5.4.4 - https://photoswipe.com
  * (c) 2024 Dmytro Semenov
  */
function Bs(n, e, t) {
  const r = document.createElement(e);
  return n && (r.className = n), t && t.appendChild(r), r;
}
function K7(n, e, t) {
  let r = `translate3d(${n}px,0px,0)`;
  return t !== void 0 && (r += ` scale3d(${t},${t},1)`), r;
}
function pd(n, e, t) {
  n.style.width = typeof e == "number" ? `${e}px` : e, n.style.height = typeof t == "number" ? `${t}px` : t;
}
const yn = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  ERROR: "error"
};
function G7(n) {
  return "button" in n && n.button === 1 || n.ctrlKey || n.metaKey || n.altKey || n.shiftKey;
}
function zs(n, e, t = document) {
  let r = [];
  if (n instanceof Element)
    r = [n];
  else if (n instanceof NodeList || Array.isArray(n))
    r = Array.from(n);
  else {
    const i = typeof n == "string" ? n : e;
    i && (r = Array.from(t.querySelectorAll(i)));
  }
  return r;
}
function Y7(n) {
  return typeof n == "function" && n.prototype && n.prototype.goTo;
}
function oc() {
  return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}
class J7 {
  /**
   * @param {T} type
   * @param {PhotoSwipeEventsMap[T]} [details]
   */
  constructor(e, t) {
    this.type = e, this.defaultPrevented = !1, t && Object.assign(this, t);
  }
  preventDefault() {
    this.defaultPrevented = !0;
  }
}
class Z7 {
  constructor() {
    this._listeners = {}, this._filters = {}, this.pswp = void 0, this.options = void 0;
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */
  addFilter(e, t, r = 100) {
    var i, s, o;
    this._filters[e] || (this._filters[e] = []), (i = this._filters[e]) === null || i === void 0 || i.push({
      fn: t,
      priority: r
    }), (s = this._filters[e]) === null || s === void 0 || s.sort((a, l) => a.priority - l.priority), (o = this.pswp) === null || o === void 0 || o.addFilter(e, t, r);
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   */
  removeFilter(e, t) {
    this._filters[e] && (this._filters[e] = this._filters[e].filter((r) => r.fn !== t)), this.pswp && this.pswp.removeFilter(e, t);
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
   */
  applyFilters(e, ...t) {
    var r;
    return (r = this._filters[e]) === null || r === void 0 || r.forEach((i) => {
      t[0] = i.fn.apply(this, t);
    }), t[0];
  }
  /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */
  on(e, t) {
    var r, i;
    this._listeners[e] || (this._listeners[e] = []), (r = this._listeners[e]) === null || r === void 0 || r.push(t), (i = this.pswp) === null || i === void 0 || i.on(e, t);
  }
  /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */
  off(e, t) {
    var r;
    this._listeners[e] && (this._listeners[e] = this._listeners[e].filter((i) => t !== i)), (r = this.pswp) === null || r === void 0 || r.off(e, t);
  }
  /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {PhotoSwipeEventsMap[T]} [details]
   * @returns {AugmentedEvent<T>}
   */
  dispatch(e, t) {
    var r;
    if (this.pswp)
      return this.pswp.dispatch(e, t);
    const i = (
      /** @type {AugmentedEvent<T>} */
      new J7(e, t)
    );
    return (r = this._listeners[e]) === null || r === void 0 || r.forEach((s) => {
      s.call(this, i);
    }), i;
  }
}
class X7 {
  /**
   * @param {string | false} imageSrc
   * @param {HTMLElement} container
   */
  constructor(e, t) {
    if (this.element = Bs("pswp__img pswp__img--placeholder", e ? "img" : "div", t), e) {
      const r = (
        /** @type {HTMLImageElement} */
        this.element
      );
      r.decoding = "async", r.alt = "", r.src = e, r.setAttribute("role", "presentation");
    }
    this.element.setAttribute("aria-hidden", "true");
  }
  /**
   * @param {number} width
   * @param {number} height
   */
  setDisplayedSize(e, t) {
    this.element && (this.element.tagName === "IMG" ? (pd(this.element, 250, "auto"), this.element.style.transformOrigin = "0 0", this.element.style.transform = K7(0, 0, e / 250)) : pd(this.element, e, t));
  }
  destroy() {
    var e;
    (e = this.element) !== null && e !== void 0 && e.parentNode && this.element.remove(), this.element = null;
  }
}
class Q7 {
  /**
   * @param {SlideData} itemData Slide data
   * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
   * @param {number} index
   */
  constructor(e, t, r) {
    this.instance = t, this.data = e, this.index = r, this.element = void 0, this.placeholder = void 0, this.slide = void 0, this.displayedImageWidth = 0, this.displayedImageHeight = 0, this.width = Number(this.data.w) || Number(this.data.width) || 0, this.height = Number(this.data.h) || Number(this.data.height) || 0, this.isAttached = !1, this.hasSlide = !1, this.isDecoding = !1, this.state = yn.IDLE, this.data.type ? this.type = this.data.type : this.data.src ? this.type = "image" : this.type = "html", this.instance.dispatch("contentInit", {
      content: this
    });
  }
  removePlaceholder() {
    this.placeholder && !this.keepPlaceholder() && setTimeout(() => {
      this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0);
    }, 1e3);
  }
  /**
   * Preload content
   *
   * @param {boolean} isLazy
   * @param {boolean} [reload]
   */
  load(e, t) {
    if (this.slide && this.usePlaceholder())
      if (this.placeholder) {
        const r = this.placeholder.element;
        r && !r.parentElement && this.slide.container.prepend(r);
      } else {
        const r = this.instance.applyFilters(
          "placeholderSrc",
          // use  image-based placeholder only for the first slide,
          // as rendering (even small stretched thumbnail) is an expensive operation
          this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : !1,
          this
        );
        this.placeholder = new X7(r, this.slide.container);
      }
    this.element && !t || this.instance.dispatch("contentLoad", {
      content: this,
      isLazy: e
    }).defaultPrevented || (this.isImageContent() ? (this.element = Bs("pswp__img", "img"), this.displayedImageWidth && this.loadImage(e)) : (this.element = Bs("pswp__content", "div"), this.element.innerHTML = this.data.html || ""), t && this.slide && this.slide.updateContentSize(!0));
  }
  /**
   * Preload image
   *
   * @param {boolean} isLazy
   */
  loadImage(e) {
    var t, r;
    if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", {
      content: this,
      isLazy: e
    }).defaultPrevented)
      return;
    const i = (
      /** @type HTMLImageElement */
      this.element
    );
    this.updateSrcsetSizes(), this.data.srcset && (i.srcset = this.data.srcset), i.src = (t = this.data.src) !== null && t !== void 0 ? t : "", i.alt = (r = this.data.alt) !== null && r !== void 0 ? r : "", this.state = yn.LOADING, i.complete ? this.onLoaded() : (i.onload = () => {
      this.onLoaded();
    }, i.onerror = () => {
      this.onError();
    });
  }
  /**
   * Assign slide to content
   *
   * @param {Slide} slide
   */
  setSlide(e) {
    this.slide = e, this.hasSlide = !0, this.instance = e.pswp;
  }
  /**
   * Content load success handler
   */
  onLoaded() {
    this.state = yn.LOADED, this.slide && this.element && (this.instance.dispatch("loadComplete", {
      slide: this.slide,
      content: this
    }), this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode && (this.append(), this.slide.updateContentSize(!0)), (this.state === yn.LOADED || this.state === yn.ERROR) && this.removePlaceholder());
  }
  /**
   * Content load error handler
   */
  onError() {
    this.state = yn.ERROR, this.slide && (this.displayError(), this.instance.dispatch("loadComplete", {
      slide: this.slide,
      isError: !0,
      content: this
    }), this.instance.dispatch("loadError", {
      slide: this.slide,
      content: this
    }));
  }
  /**
   * @returns {Boolean} If the content is currently loading
   */
  isLoading() {
    return this.instance.applyFilters("isContentLoading", this.state === yn.LOADING, this);
  }
  /**
   * @returns {Boolean} If the content is in error state
   */
  isError() {
    return this.state === yn.ERROR;
  }
  /**
   * @returns {boolean} If the content is image
   */
  isImageContent() {
    return this.type === "image";
  }
  /**
   * Update content size
   *
   * @param {Number} width
   * @param {Number} height
   */
  setDisplayedSize(e, t) {
    if (this.element && (this.placeholder && this.placeholder.setDisplayedSize(e, t), !this.instance.dispatch("contentResize", {
      content: this,
      width: e,
      height: t
    }).defaultPrevented && (pd(this.element, e, t), this.isImageContent() && !this.isError()))) {
      const r = !this.displayedImageWidth && e;
      this.displayedImageWidth = e, this.displayedImageHeight = t, r ? this.loadImage(!1) : this.updateSrcsetSizes(), this.slide && this.instance.dispatch("imageSizeChange", {
        slide: this.slide,
        width: e,
        height: t,
        content: this
      });
    }
  }
  /**
   * @returns {boolean} If the content can be zoomed
   */
  isZoomable() {
    return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== yn.ERROR, this);
  }
  /**
   * Update image srcset sizes attribute based on width and height
   */
  updateSrcsetSizes() {
    if (!this.isImageContent() || !this.element || !this.data.srcset)
      return;
    const e = (
      /** @type HTMLImageElement */
      this.element
    ), t = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
    (!e.dataset.largestUsedSize || t > parseInt(e.dataset.largestUsedSize, 10)) && (e.sizes = t + "px", e.dataset.largestUsedSize = String(t));
  }
  /**
   * @returns {boolean} If content should use a placeholder (from msrc by default)
   */
  usePlaceholder() {
    return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this);
  }
  /**
   * Preload content with lazy-loading param
   */
  lazyLoad() {
    this.instance.dispatch("contentLazyLoad", {
      content: this
    }).defaultPrevented || this.load(!0);
  }
  /**
   * @returns {boolean} If placeholder should be kept after content is loaded
   */
  keepPlaceholder() {
    return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this);
  }
  /**
   * Destroy the content
   */
  destroy() {
    this.hasSlide = !1, this.slide = void 0, !this.instance.dispatch("contentDestroy", {
      content: this
    }).defaultPrevented && (this.remove(), this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0), this.isImageContent() && this.element && (this.element.onload = null, this.element.onerror = null, this.element = void 0));
  }
  /**
   * Display error message
   */
  displayError() {
    if (this.slide) {
      var e, t;
      let r = Bs("pswp__error-msg", "div");
      r.innerText = (e = (t = this.instance.options) === null || t === void 0 ? void 0 : t.errorMsg) !== null && e !== void 0 ? e : "", r = /** @type {HTMLDivElement} */
      this.instance.applyFilters("contentErrorElement", r, this), this.element = Bs("pswp__content pswp__error-msg-container", "div"), this.element.appendChild(r), this.slide.container.innerText = "", this.slide.container.appendChild(this.element), this.slide.updateContentSize(!0), this.removePlaceholder();
    }
  }
  /**
   * Append the content
   */
  append() {
    if (this.isAttached || !this.element)
      return;
    if (this.isAttached = !0, this.state === yn.ERROR) {
      this.displayError();
      return;
    }
    if (this.instance.dispatch("contentAppend", {
      content: this
    }).defaultPrevented)
      return;
    const e = "decode" in this.element;
    this.isImageContent() ? e && this.slide && (!this.slide.isActive || oc()) ? (this.isDecoding = !0, this.element.decode().catch(() => {
    }).finally(() => {
      this.isDecoding = !1, this.appendImage();
    })) : this.appendImage() : this.slide && !this.element.parentNode && this.slide.container.appendChild(this.element);
  }
  /**
   * Activate the slide,
   * active slide is generally the current one,
   * meaning the user can see it.
   */
  activate() {
    this.instance.dispatch("contentActivate", {
      content: this
    }).defaultPrevented || !this.slide || (this.isImageContent() && this.isDecoding && !oc() ? this.appendImage() : this.isError() && this.load(!1, !0), this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "false"));
  }
  /**
   * Deactivate the content
   */
  deactivate() {
    this.instance.dispatch("contentDeactivate", {
      content: this
    }), this.slide && this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "true");
  }
  /**
   * Remove the content from DOM
   */
  remove() {
    this.isAttached = !1, !this.instance.dispatch("contentRemove", {
      content: this
    }).defaultPrevented && (this.element && this.element.parentNode && this.element.remove(), this.placeholder && this.placeholder.element && this.placeholder.element.remove());
  }
  /**
   * Append the image content to slide container
   */
  appendImage() {
    this.isAttached && (this.instance.dispatch("contentAppendImage", {
      content: this
    }).defaultPrevented || (this.slide && this.element && !this.element.parentNode && this.slide.container.appendChild(this.element), (this.state === yn.LOADED || this.state === yn.ERROR) && this.removePlaceholder()));
  }
}
function eg(n, e) {
  if (n.getViewportSizeFn) {
    const t = n.getViewportSizeFn(n, e);
    if (t)
      return t;
  }
  return {
    x: document.documentElement.clientWidth,
    // TODO: height on mobile is very incosistent due to toolbar
    // find a way to improve this
    //
    // document.documentElement.clientHeight - doesn't seem to work well
    y: window.innerHeight
  };
}
function Uo(n, e, t, r, i) {
  let s = 0;
  if (e.paddingFn)
    s = e.paddingFn(t, r, i)[n];
  else if (e.padding)
    s = e.padding[n];
  else {
    const o = "padding" + n[0].toUpperCase() + n.slice(1);
    e[o] && (s = e[o]);
  }
  return Number(s) || 0;
}
function tg(n, e, t, r) {
  return {
    x: e.x - Uo("left", n, e, t, r) - Uo("right", n, e, t, r),
    y: e.y - Uo("top", n, e, t, r) - Uo("bottom", n, e, t, r)
  };
}
const ac = 4e3;
class ng {
  /**
   * @param {PhotoSwipeOptions} options PhotoSwipe options
   * @param {SlideData} itemData Slide data
   * @param {number} index Slide index
   * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
   */
  constructor(e, t, r, i) {
    this.pswp = i, this.options = e, this.itemData = t, this.index = r, this.panAreaSize = null, this.elementSize = null, this.fit = 1, this.fill = 1, this.vFill = 1, this.initial = 1, this.secondary = 1, this.max = 1, this.min = 1;
  }
  /**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */
  update(e, t, r) {
    const i = {
      x: e,
      y: t
    };
    this.elementSize = i, this.panAreaSize = r;
    const s = r.x / i.x, o = r.y / i.y;
    this.fit = Math.min(1, s < o ? s : o), this.fill = Math.min(1, s > o ? s : o), this.vFill = Math.min(1, o), this.initial = this._getInitial(), this.secondary = this._getSecondary(), this.max = Math.max(this.initial, this.secondary, this._getMax()), this.min = Math.min(this.fit, this.initial, this.secondary), this.pswp && this.pswp.dispatch("zoomLevelsUpdate", {
      zoomLevels: this,
      slideData: this.itemData
    });
  }
  /**
   * Parses user-defined zoom option.
   *
   * @private
   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
   * @returns { number | undefined }
   */
  _parseZoomLevelOption(e) {
    const t = (
      /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */
      e + "ZoomLevel"
    ), r = this.options[t];
    if (r)
      return typeof r == "function" ? r(this) : r === "fill" ? this.fill : r === "fit" ? this.fit : Number(r);
  }
  /**
   * Get zoom level to which image will be zoomed after double-tap gesture,
   * or when user clicks on zoom icon,
   * or mouse-click on image itself.
   * If you return 1 image will be zoomed to its original size.
   *
   * @private
   * @return {number}
   */
  _getSecondary() {
    let e = this._parseZoomLevelOption("secondary");
    return e || (e = Math.min(1, this.fit * 3), this.elementSize && e * this.elementSize.x > ac && (e = ac / this.elementSize.x), e);
  }
  /**
   * Get initial image zoom level.
   *
   * @private
   * @return {number}
   */
  _getInitial() {
    return this._parseZoomLevelOption("initial") || this.fit;
  }
  /**
   * Maximum zoom level when user zooms
   * via zoom/pinch gesture,
   * via cmd/ctrl-wheel or via trackpad.
   *
   * @private
   * @return {number}
   */
  _getMax() {
    return this._parseZoomLevelOption("max") || Math.max(1, this.fit * 4);
  }
}
function hp(n, e, t) {
  const r = e.createContentFromData(n, t);
  let i;
  const {
    options: s
  } = e;
  if (s) {
    i = new ng(s, n, -1);
    let o;
    e.pswp ? o = e.pswp.viewportSize : o = eg(s, e);
    const a = tg(s, o, n, t);
    i.update(r.width, r.height, a);
  }
  return r.lazyLoad(), i && r.setDisplayedSize(Math.ceil(r.width * i.initial), Math.ceil(r.height * i.initial)), r;
}
function rg(n, e) {
  const t = e.getItemData(n);
  if (!e.dispatch("lazyLoadSlide", {
    index: n,
    itemData: t
  }).defaultPrevented)
    return hp(t, e, n);
}
class ig extends Z7 {
  /**
   * Get total number of slides
   *
   * @returns {number}
   */
  getNumItems() {
    var e;
    let t = 0;
    const r = (e = this.options) === null || e === void 0 ? void 0 : e.dataSource;
    r && "length" in r ? t = r.length : r && "gallery" in r && (r.items || (r.items = this._getGalleryDOMElements(r.gallery)), r.items && (t = r.items.length));
    const i = this.dispatch("numItems", {
      dataSource: r,
      numItems: t
    });
    return this.applyFilters("numItems", i.numItems, r);
  }
  /**
   * @param {SlideData} slideData
   * @param {number} index
   * @returns {Content}
   */
  createContentFromData(e, t) {
    return new Q7(e, this, t);
  }
  /**
   * Get item data by index.
   *
   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
   * For example, it may contain properties like
   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
   *
   * @param {number} index
   * @returns {SlideData}
   */
  getItemData(e) {
    var t;
    const r = (t = this.options) === null || t === void 0 ? void 0 : t.dataSource;
    let i = {};
    Array.isArray(r) ? i = r[e] : r && "gallery" in r && (r.items || (r.items = this._getGalleryDOMElements(r.gallery)), i = r.items[e]);
    let s = i;
    s instanceof Element && (s = this._domElementToItemData(s));
    const o = this.dispatch("itemData", {
      itemData: s || {},
      index: e
    });
    return this.applyFilters("itemData", o.itemData, e);
  }
  /**
   * Get array of gallery DOM elements,
   * based on childSelector and gallery element.
   *
   * @param {HTMLElement} galleryElement
   * @returns {HTMLElement[]}
   */
  _getGalleryDOMElements(e) {
    var t, r;
    return (t = this.options) !== null && t !== void 0 && t.children || (r = this.options) !== null && r !== void 0 && r.childSelector ? zs(this.options.children, this.options.childSelector, e) || [] : [e];
  }
  /**
   * Converts DOM element to item data object.
   *
   * @param {HTMLElement} element DOM element
   * @returns {SlideData}
   */
  _domElementToItemData(e) {
    const t = {
      element: e
    }, r = (
      /** @type {HTMLAnchorElement} */
      e.tagName === "A" ? e : e.querySelector("a")
    );
    if (r) {
      t.src = r.dataset.pswpSrc || r.href, r.dataset.pswpSrcset && (t.srcset = r.dataset.pswpSrcset), t.width = r.dataset.pswpWidth ? parseInt(r.dataset.pswpWidth, 10) : 0, t.height = r.dataset.pswpHeight ? parseInt(r.dataset.pswpHeight, 10) : 0, t.w = t.width, t.h = t.height, r.dataset.pswpType && (t.type = r.dataset.pswpType);
      const s = e.querySelector("img");
      if (s) {
        var i;
        t.msrc = s.currentSrc || s.src, t.alt = (i = s.getAttribute("alt")) !== null && i !== void 0 ? i : "";
      }
      (r.dataset.pswpCropped || r.dataset.cropped) && (t.thumbCropped = !0);
    }
    return this.applyFilters("domItemData", t, e, r);
  }
  /**
   * Lazy-load by slide data
   *
   * @param {SlideData} itemData Data about the slide
   * @param {number} index
   * @returns {Content} Image that is being decoded or false.
   */
  lazyLoadData(e, t) {
    return hp(e, this, t);
  }
}
class mp extends ig {
  /**
   * @param {PhotoSwipeOptions} [options]
   */
  constructor(e) {
    super(), this.options = e || {}, this._uid = 0, this.shouldOpen = !1, this._preloadedContent = void 0, this.onThumbnailsClick = this.onThumbnailsClick.bind(this);
  }
  /**
   * Initialize lightbox, should be called only once.
   * It's not included in the main constructor, so you may bind events before it.
   */
  init() {
    zs(this.options.gallery, this.options.gallerySelector).forEach((e) => {
      e.addEventListener("click", this.onThumbnailsClick, !1);
    });
  }
  /**
   * @param {MouseEvent} e
   */
  onThumbnailsClick(e) {
    if (G7(e) || window.pswp)
      return;
    let t = {
      x: e.clientX,
      y: e.clientY
    };
    !t.x && !t.y && (t = null);
    let r = this.getClickedIndex(e);
    r = this.applyFilters("clickedIndex", r, e, this);
    const i = {
      gallery: (
        /** @type {HTMLElement} */
        e.currentTarget
      )
    };
    r >= 0 && (e.preventDefault(), this.loadAndOpen(r, i, t));
  }
  /**
   * Get index of gallery item that was clicked.
   *
   * @param {MouseEvent} e click event
   * @returns {number}
   */
  getClickedIndex(e) {
    if (this.options.getClickedIndexFn)
      return this.options.getClickedIndexFn.call(this, e);
    const t = (
      /** @type {HTMLElement} */
      e.target
    ), i = zs(
      this.options.children,
      this.options.childSelector,
      /** @type {HTMLElement} */
      e.currentTarget
    ).findIndex((s) => s === t || s.contains(t));
    return i !== -1 ? i : this.options.children || this.options.childSelector ? -1 : 0;
  }
  /**
   * Load and open PhotoSwipe
   *
   * @param {number} index
   * @param {DataSource} [dataSource]
   * @param {Point | null} [initialPoint]
   * @returns {boolean}
   */
  loadAndOpen(e, t, r) {
    if (window.pswp || !this.options)
      return !1;
    if (!t && this.options.gallery && this.options.children) {
      const i = zs(this.options.gallery);
      i[0] && (t = {
        gallery: i[0]
      });
    }
    return this.options.index = e, this.options.initialPointerPos = r, this.shouldOpen = !0, this.preload(e, t), !0;
  }
  /**
   * Load the main module and the slide content by index
   *
   * @param {number} index
   * @param {DataSource} [dataSource]
   */
  preload(e, t) {
    const {
      options: r
    } = this;
    t && (r.dataSource = t);
    const i = [], s = typeof r.pswpModule;
    if (Y7(r.pswpModule))
      i.push(Promise.resolve(
        /** @type {Type<PhotoSwipe>} */
        r.pswpModule
      ));
    else {
      if (s === "string")
        throw new Error("pswpModule as string is no longer supported");
      if (s === "function")
        i.push(
          /** @type {() => Promise<Type<PhotoSwipe>>} */
          r.pswpModule()
        );
      else
        throw new Error("pswpModule is not valid");
    }
    typeof r.openPromise == "function" && i.push(r.openPromise()), r.preloadFirstSlide !== !1 && e >= 0 && (this._preloadedContent = rg(e, this));
    const o = ++this._uid;
    Promise.all(i).then((a) => {
      if (this.shouldOpen) {
        const l = a[0];
        this._openPhotoswipe(l, o);
      }
    });
  }
  /**
   * @private
   * @param {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} module
   * @param {number} uid
   */
  _openPhotoswipe(e, t) {
    if (t !== this._uid && this.shouldOpen || (this.shouldOpen = !1, window.pswp))
      return;
    const r = typeof e == "object" ? new e.default(this.options) : new e(this.options);
    this.pswp = r, window.pswp = r, Object.keys(this._listeners).forEach((i) => {
      var s;
      (s = this._listeners[i]) === null || s === void 0 || s.forEach((o) => {
        r.on(
          i,
          /** @type {EventCallback<typeof name>} */
          o
        );
      });
    }), Object.keys(this._filters).forEach((i) => {
      var s;
      (s = this._filters[i]) === null || s === void 0 || s.forEach((o) => {
        r.addFilter(i, o.fn, o.priority);
      });
    }), this._preloadedContent && (r.contentLoader.addToCache(this._preloadedContent), this._preloadedContent = void 0), r.on("destroy", () => {
      this.pswp = void 0, delete window.pswp;
    }), r.init();
  }
  /**
   * Unbinds all events, closes PhotoSwipe if it's open.
   */
  destroy() {
    var e;
    (e = this.pswp) === null || e === void 0 || e.destroy(), this.shouldOpen = !1, this._listeners = {}, zs(this.options.gallery, this.options.gallerySelector).forEach((t) => {
      t.removeEventListener("click", this.onThumbnailsClick, !1);
    });
  }
}
const sg = {
  captionContent: ".pswp-caption-content",
  type: "auto",
  horizontalEdgeThreshold: 20,
  mobileCaptionOverlapRatio: 0.3,
  mobileLayoutBreakpoint: 600,
  verticallyCenterImage: !1
};
class gp {
  constructor(e, t) {
    this.options = {
      ...sg,
      ...t
    }, this.lightbox = e, this.lightbox.on("init", () => {
      this.pswp = this.lightbox.pswp, this.initCaption();
    });
  }
  initCaption() {
    const { pswp: e } = this;
    e.on("change", () => {
      this.showCaption(this.pswp.currSlide);
    }), e.on("calcSlideSize", (t) => this.onCalcSlideSize(t)), e.on("slideDestroy", (t) => {
      t.slide.dynamicCaption && (t.slide.dynamicCaption.element && t.slide.dynamicCaption.element.remove(), delete t.slide.dynamicCaption);
    }), e.on("zoomPanUpdate", ({ slide: t }) => {
      if (e.opener.isOpen && t.dynamicCaption) {
        if (t.currZoomLevel > t.zoomLevels.initial ? this.hideCaption(t) : this.showCaption(t), t.dynamicCaption.element) {
          let r = 0;
          if (t.currZoomLevel <= t.zoomLevels.initial) {
            const i = t.pan.y - t.bounds.center.y;
            Math.abs(i) > 1 && (r = i);
          }
          this.setCaptionYOffset(t.dynamicCaption.element, r);
        }
        this.adjustPanArea(t, t.currZoomLevel);
      }
    }), e.on("beforeZoomTo", (t) => {
      this.adjustPanArea(e.currSlide, t.destZoomLevel);
    }), e.on("tapAction", (t) => {
      t.originalEvent.target.closest(".pswp__dynamic-caption") && t.preventDefault();
    });
  }
  adjustPanArea(e, t) {
    e.dynamicCaption && e.dynamicCaption.adjustedPanAreaSize && (t > e.zoomLevels.initial ? (e.panAreaSize.x = e.dynamicCaption.originalPanAreaSize.x, e.panAreaSize.y = e.dynamicCaption.originalPanAreaSize.y) : (e.panAreaSize.x = e.dynamicCaption.adjustedPanAreaSize.x, e.panAreaSize.y = e.dynamicCaption.adjustedPanAreaSize.y));
  }
  useMobileLayout() {
    const { mobileLayoutBreakpoint: e } = this.options;
    return typeof e == "function" ? e.call(this) : typeof e == "number" && window.innerWidth < e;
  }
  hideCaption(e) {
    if (e.dynamicCaption && !e.dynamicCaption.hidden) {
      const t = e.dynamicCaption.element;
      if (!t)
        return;
      e.dynamicCaption.hidden = !0, t.classList.add("pswp__dynamic-caption--faded"), e.captionFadeTimeout && clearTimeout(e.captionFadeTimeout), e.captionFadeTimeout = setTimeout(() => {
        t.style.visibility = "hidden", delete e.captionFadeTimeout;
      }, 400);
    }
  }
  setCaptionYOffset(e, t) {
    e.style.transform = `translateY(${t}px)`;
  }
  showCaption(e) {
    if (e.dynamicCaption && e.dynamicCaption.hidden) {
      const t = e.dynamicCaption.element;
      if (!t)
        return;
      e.dynamicCaption.hidden = !1, t.style.visibility = "visible", clearTimeout(e.captionFadeTimeout), e.captionFadeTimeout = setTimeout(() => {
        t.classList.remove("pswp__dynamic-caption--faded"), delete e.captionFadeTimeout;
      }, 50);
    }
  }
  setCaptionPosition(e, t, r) {
    const i = t <= this.options.horizontalEdgeThreshold;
    e.classList[i ? "add" : "remove"]("pswp__dynamic-caption--on-hor-edge"), e.style.left = t + "px", e.style.top = r + "px";
  }
  setCaptionWidth(e, t) {
    t ? e.style.width = t + "px" : e.style.removeProperty("width");
  }
  setCaptionType(e, t) {
    const r = e.dataset.pswpCaptionType;
    t !== r && (e.classList.add("pswp__dynamic-caption--" + t), e.classList.remove("pswp__dynamic-caption--" + r), e.dataset.pswpCaptionType = t);
  }
  updateCaptionPosition(e) {
    if (!e.dynamicCaption || !e.dynamicCaption.type || !e.dynamicCaption.element)
      return;
    if (e.dynamicCaption.type === "mobile") {
      this.setCaptionType(
        e.dynamicCaption.element,
        e.dynamicCaption.type
      ), e.dynamicCaption.element.style.removeProperty("left"), e.dynamicCaption.element.style.removeProperty("top"), this.setCaptionWidth(e.dynamicCaption.element, !1);
      return;
    }
    const t = e.zoomLevels.initial, r = Math.ceil(e.width * t), i = Math.ceil(e.height * t);
    this.setCaptionType(e.dynamicCaption.element, e.dynamicCaption.type), e.dynamicCaption.type === "aside" ? (this.setCaptionPosition(
      e.dynamicCaption.element,
      e.bounds.center.x + r,
      e.bounds.center.y
    ), this.setCaptionWidth(e.dynamicCaption.element, !1)) : e.dynamicCaption.type === "below" && (this.setCaptionPosition(
      e.dynamicCaption.element,
      e.bounds.center.x,
      e.bounds.center.y + i
    ), this.setCaptionWidth(e.dynamicCaption.element, r));
  }
  onCalcSlideSize(e) {
    const { slide: t } = e;
    let r, i;
    if (!t.dynamicCaption) {
      t.dynamicCaption = {
        element: void 0,
        type: !1,
        hidden: !1
      };
      const a = this.getCaptionHTML(t);
      if (!a)
        return;
      t.dynamicCaption.element = document.createElement("div"), t.dynamicCaption.element.className = "pswp__dynamic-caption pswp__hide-on-close", t.dynamicCaption.element.innerHTML = a, this.pswp.dispatch("dynamicCaptionUpdateHTML", {
        captionElement: t.dynamicCaption.element,
        slide: t
      }), t.holderElement.appendChild(t.dynamicCaption.element);
    }
    if (!t.dynamicCaption.element)
      return;
    this.storeOriginalPanAreaSize(t), t.bounds.update(t.zoomLevels.initial), this.useMobileLayout() ? (t.dynamicCaption.type = "mobile", i = !0) : this.options.type === "auto" ? t.bounds.center.x > t.bounds.center.y ? t.dynamicCaption.type = "aside" : t.dynamicCaption.type = "below" : t.dynamicCaption.type = this.options.type;
    const s = Math.ceil(t.width * t.zoomLevels.initial), o = Math.ceil(t.height * t.zoomLevels.initial);
    if (this.setCaptionType(
      t.dynamicCaption.element,
      t.dynamicCaption.type
    ), t.dynamicCaption.type === "aside") {
      this.setCaptionWidth(t.dynamicCaption.element, !1), r = this.measureCaptionSize(t.dynamicCaption.element, e.slide);
      const a = r.x, l = s + t.bounds.center.x;
      t.panAreaSize.x - l <= a && (t.panAreaSize.x -= a, this.recalculateZoomLevelAndBounds(t));
    } else if (t.dynamicCaption.type === "below" || i) {
      this.setCaptionWidth(
        t.dynamicCaption.element,
        i ? this.pswp.viewportSize.x : s
      ), r = this.measureCaptionSize(t.dynamicCaption.element, e.slide);
      const a = r.y;
      if (this.options.verticallyCenterImage)
        t.panAreaSize.y -= a, this.recalculateZoomLevelAndBounds(t);
      else {
        const l = o + t.bounds.center.y, u = t.panAreaSize.y - l, d = t.panAreaSize.y;
        if (u <= a) {
          t.panAreaSize.y -= Math.min((a - u) * 2, a), this.recalculateZoomLevelAndBounds(t);
          const c = t.panAreaSize.x * this.options.mobileCaptionOverlapRatio / 2;
          i && t.bounds.center.x > c && (t.panAreaSize.y = d, this.recalculateZoomLevelAndBounds(t));
        }
      }
    }
    this.storeAdjustedPanAreaSize(t), this.updateCaptionPosition(t);
  }
  measureCaptionSize(e, t) {
    const r = e.getBoundingClientRect();
    return this.pswp.dispatch("dynamicCaptionMeasureSize", {
      captionEl: e,
      slide: t,
      captionSize: {
        x: r.width,
        y: r.height
      }
    }).captionSize;
  }
  recalculateZoomLevelAndBounds(e) {
    e.zoomLevels.update(e.width, e.height, e.panAreaSize), e.bounds.update(e.zoomLevels.initial);
  }
  storeAdjustedPanAreaSize(e) {
    e.dynamicCaption && (e.dynamicCaption.adjustedPanAreaSize || (e.dynamicCaption.adjustedPanAreaSize = {}), e.dynamicCaption.adjustedPanAreaSize.x = e.panAreaSize.x, e.dynamicCaption.adjustedPanAreaSize.y = e.panAreaSize.y);
  }
  storeOriginalPanAreaSize(e) {
    e.dynamicCaption && (e.dynamicCaption.originalPanAreaSize || (e.dynamicCaption.originalPanAreaSize = {}), e.dynamicCaption.originalPanAreaSize.x = e.panAreaSize.x, e.dynamicCaption.originalPanAreaSize.y = e.panAreaSize.y);
  }
  getCaptionHTML(e) {
    if (typeof this.options.captionContent == "function")
      return this.options.captionContent.call(this, e);
    const t = e.data.element;
    let r = "";
    if (t) {
      const i = t.querySelector(this.options.captionContent);
      if (i)
        r = i.innerHTML;
      else {
        const s = t.querySelector("img");
        s && (r = s.getAttribute("alt"));
      }
    }
    return r;
  }
}
const og = { class: "relative" }, ag = { class: "flex gap-2" }, lg = ["onClick"], ug = ["alt", "src"], dg = ["src"], cg = {
  key: 2,
  class: "absolute inset-0 flex items-center justify-center bg-black/20"
}, fg = {
  key: 0,
  class: "pointer-events-none absolute inset-x-0 top-1/2 flex -translate-y-1/2 justify-between px-2"
}, pg = ["disabled"], hg = ["disabled"], mg = {
  key: 1,
  class: "absolute bottom-12 left-1/2 -translate-x-1/2"
}, gg = { class: "rounded-full bg-white/80 px-2.5 py-px text-[12px] font-medium text-black backdrop-blur-md" }, bg = {
  key: 0,
  class: "mt-4 flex justify-center gap-1.5"
}, yg = ["onClick"], vg = ["data-pswp-height", "data-pswp-type", "data-pswp-width", "data-video-src", "href"], _g = {
  key: 0,
  class: "pswp-caption-content"
}, XM = /* @__PURE__ */ X({
  __name: "CarouselGallery",
  props: {
    images: {},
    lightboxOptions: {},
    wrapperClass: {},
    showPreviewCaptions: { type: Boolean },
    carouselOptions: {},
    thumbnailHeight: {},
    arrows: { type: Boolean },
    dots: { type: Boolean },
    slidesPerView: {},
    showCounter: { type: Boolean }
  },
  setup(n) {
    const e = n, t = Z(() => e.slidesPerView ?? 1), r = Z(() => t.value === 1 ? "100%" : `calc((100% - ${8 * (t.value - 1) / 100}%) / ${t.value})`), i = Z(() => ({
      containScroll: "trimSnaps",
      align: "start",
      slidesToScroll: 1,
      ...e.carouselOptions
    })), [s, o] = El(i.value), a = ae(0), l = ae(!1), u = ae(!1), d = _i(null), c = _i(null), f = so("galleryRef");
    function p() {
      var w;
      (w = o.value) == null || w.scrollPrev();
    }
    function h() {
      var w;
      (w = o.value) == null || w.scrollNext();
    }
    function y(w) {
      var _;
      (_ = o.value) == null || _.scrollTo(w);
    }
    function g(w) {
      l.value = (w == null ? void 0 : w.canScrollNext()) || !1, u.value = (w == null ? void 0 : w.canScrollPrev()) || !1, a.value = (w == null ? void 0 : w.selectedScrollSnap()) || 0;
    }
    function m() {
      f.value && (d.value && (d.value.destroy(), d.value = null), d.value = new mp({
        gallery: f.value,
        children: ".pswp-trigger",
        showHideAnimationType: "fade",
        pswpModule: () => import("./photoswipe.esm-CSQI2Ds4.js"),
        paddingFn: (w) => ({
          top: 20,
          bottom: 30,
          left: 0,
          right: 0
        }),
        ...e.lightboxOptions
      }), c.value = new gp(d.value, {
        captionContent: ".pswp-caption-content",
        type: "below"
      }), d.value.on("contentLoad", (w) => {
        const { content: _ } = w;
        if (_.data.type === "video") {
          w.preventDefault();
          const L = document.createElement("video");
          L.controls = !0, L.autoplay = !0, L.style.maxWidth = "100%", L.style.maxHeight = "100%", L.src = _.data.videoSrc || _.data.element.dataset.videoSrc, _.element = L;
        }
      }), d.value.on("change", () => {
        var _;
        const w = (_ = d.value) == null ? void 0 : _.pswp;
        w && y(w.currIndex);
      }), d.value.init());
    }
    function $(w) {
      var _;
      (_ = d.value) == null || _.loadAndOpen(w);
    }
    return Dt(() => {
      o.value && (o.value.on("select", g), o.value.on("init", g), o.value.on("reInit", g)), m();
    }), P2(() => {
      d.value && (d.value.destroy(), d.value = null);
    }), Ie(
      () => e.lightboxOptions,
      (w, _) => {
        fr(w, _) || m();
      }
    ), (w, _) => w.images.length > 0 ? (k(), T("div", {
      key: 0,
      class: B(w.wrapperClass || "relative")
    }, [
      E("div", og, [
        E("div", {
          ref_key: "emblaRef",
          ref: s,
          class: "overflow-hidden"
        }, [
          E("div", ag, [
            (k(!0), T(ce, null, $e(w.images, (L, S) => (k(), T("div", {
              key: S,
              class: "relative cursor-pointer",
              style: mt({ flex: `0 0 ${r.value}` }),
              onClick: (R) => $(S)
            }, [
              te(w.$slots, "thumbnail", {
                image: L,
                index: S
              }, () => [
                E("div", {
                  class: "relative overflow-hidden",
                  style: mt({ height: w.thumbnailHeight || "100px" })
                }, [
                  L.type !== "video" ? (k(), T("img", {
                    key: 0,
                    alt: L.alt || "",
                    class: "size-full object-cover object-center",
                    src: L.thumbnail || L.url
                  }, null, 8, ug)) : V("", !0),
                  L.type === "video" ? (k(), T("video", {
                    key: 1,
                    class: "pointer-events-none size-full object-cover object-center",
                    src: L.url
                  }, null, 8, dg)) : V("", !0),
                  L.type === "video" ? (k(), T("div", cg, _[0] || (_[0] = [
                    E("div", { class: "rounded-full bg-orange p-3" }, [
                      E("svg", {
                        class: "size-6 text-white",
                        fill: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        E("path", { d: "M8 5v14l11-7z" })
                      ])
                    ], -1)
                  ]))) : V("", !0)
                ], 4)
              ])
            ], 12, lg))), 128))
          ])
        ], 512),
        w.arrows && w.images.length > 1 ? (k(), T("div", fg, [
          E("button", {
            class: "shadow-md pointer-events-auto rounded-full bg-white/80 p-2 transition-opacity hover:bg-white disabled:opacity-50",
            disabled: !u.value,
            onClick: p
          }, [
            A(v(ao), { class: "text-[20px]" })
          ], 8, pg),
          E("button", {
            class: "shadow-md pointer-events-auto rounded-full bg-white/80 p-2 transition-opacity hover:bg-white disabled:opacity-50",
            disabled: !l.value,
            onClick: h
          }, [
            A(v(mn), { class: "text-[20px]" })
          ], 8, hg)
        ])) : V("", !0),
        w.showCounter && w.images.length > 1 ? (k(), T("div", mg, [
          E("div", gg, z(a.value + 1) + " z " + z(w.images.length), 1)
        ])) : V("", !0)
      ]),
      w.dots && !w.showCounter && w.images.length > 1 ? (k(), T("div", bg, [
        (k(!0), T(ce, null, $e(w.images, (L, S) => (k(), T("button", {
          key: S,
          class: B(["size-2 rounded-full bg-grey-stroke transition-all", [
            S === a.value ? "bg-gray-800 w-6" : "bg-gray-300 hover:bg-gray-400"
          ]]),
          onClick: (R) => y(S)
        }, null, 10, yg))), 128))
      ])) : V("", !0),
      E("div", {
        ref_key: "galleryRef",
        ref: f,
        class: "hidden"
      }, [
        (k(!0), T(ce, null, $e(w.images, (L, S) => (k(), T("a", {
          key: S,
          class: "pswp-trigger",
          "data-pswp-height": L.height,
          "data-pswp-type": L.type ?? "image",
          "data-pswp-width": L.width,
          "data-video-src": L.type === "video" ? L.url : void 0,
          href: L.url
        }, [
          L.caption ? (k(), T("div", _g, z(L.caption), 1)) : V("", !0)
        ], 8, vg))), 128))
      ], 512)
    ], 2)) : V("", !0);
  }
}), $g = { class: "flex grow items-start justify-between" }, xg = { class: "flex shrink-0 justify-between" }, wg = {
  key: 1,
  class: "relative size-6 items-center"
}, bp = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "CfgOverlayPanelContent",
  props: {
    title: {},
    description: {},
    flat: { type: Boolean },
    closable: { type: Boolean, default: !0 },
    isBackAllowed: { type: Boolean },
    renderClose: { type: Boolean, default: !0 },
    disableBottomPadding: { type: Boolean },
    closeButtonClasses: {},
    fullHeight: { type: Boolean },
    minimalHeader: { type: Boolean },
    headerClasses: {},
    disableMainPadding: { type: Boolean }
  },
  emits: ["close", "back"],
  setup(n) {
    const e = n, t = ["px-", "pr-", "pl"], r = $l(), i = ae(null), s = Z(() => r.class ?? ""), o = Z(() => e.closeButtonClasses), a = Z(() => e.flat ? !1 : !t.some((u) => s.value.includes(u))), l = Z(
      () => e.minimalHeader ? "w-8 h-7" : "bg-grey-100 rounded-full size-11"
    );
    return (u, d) => {
      const c = Yt("ripple");
      return k(), q(v(t8), {
        ref_key: "scrollbarView",
        ref: i,
        class: B(["shadow-xl flex h-full flex-col rounded-t-xl bg-white", {
          [s.value]: !0,
          "pb-6 ": !u.disableBottomPadding
        }])
      }, {
        default: N(() => {
          var f;
          return [
            u.title || u.description || u.$slots.head ? (k(), T("header", {
              key: 0,
              class: B(["z-sticky flex border-b border-b-grey-100 bg-white transition-shadow duration-200", {
                "px-5 sm:px-9": a.value && !u.minimalHeader,
                "shadow-light": (((f = i.value) == null ? void 0 : f.scrollPositionY) || 0) > 0 && (u.title || u.description),
                "sticky top-0": u.title || u.description,
                "px-5 py-4": u.minimalHeader,
                "py-5": !u.minimalHeader
              }]),
              name: "head"
            }, [
              E("div", $g, [
                E("div", {
                  class: B(["w-full", {
                    "flex flex-col max-lg:ml-8 max-lg:items-center": u.minimalHeader,
                    [u.headerClasses]: !0
                  }])
                }, [
                  te(u.$slots, "head", {}, () => [
                    u.title ? (k(), q(v(K), {
                      key: 0,
                      size: v(G).h2,
                      "tag-name": "h3"
                    }, {
                      default: N(() => [
                        W(z(u.title), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])) : V("", !0),
                    u.description ? (k(), q(v(K), {
                      key: 1,
                      class: "mt-2 text-grey-300",
                      size: v(G).sm,
                      "tag-name": "p"
                    }, {
                      default: N(() => [
                        W(z(u.description), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])) : V("", !0)
                  ])
                ], 2)
              ]),
              E("div", xg, [
                u.isBackAllowed ? (k(), T("button", {
                  key: 0,
                  class: B(["flex items-center justify-center ring-brand focus-visible:outline-brand focus-visible:ring", {
                    "size-10": u.minimalHeader,
                    "size-11 rounded-full bg-grey-100": !u.minimalHeader
                  }]),
                  type: "button",
                  onClick: d[0] || (d[0] = (p) => u.$emit("back"))
                }, [
                  A(v(z4))
                ], 2)) : V("", !0),
                u.closable && u.renderClose ? (k(), T("div", wg, [
                  nt((k(), T("button", {
                    class: B(["flex -translate-x-4 -translate-y-1 items-center justify-center ring-brand focus-visible:outline-brand focus-visible:ring", o.value ?? l.value]),
                    type: "button",
                    onClick: d[1] || (d[1] = (p) => u.$emit("close"))
                  }, [
                    A(v(Ut), {
                      class: B({ "text-[19px] lg:text-[24px]": u.minimalHeader })
                    }, null, 8, ["class"])
                  ], 2)), [
                    [c]
                  ])
                ])) : V("", !0)
              ])
            ], 2)) : V("", !0),
            E("main", {
              class: B(["relative flex flex-1 [&>*]:flex-1", {
                "px-5 first-of-type:mt-5 sm:px-9 lg:first-of-type:mt-8 ": a.value && !u.disableMainPadding
              }])
            }, [
              te(u.$slots, "default")
            ], 2)
          ];
        }),
        _: 3
      }, 8, ["class"]);
    };
  }
}), kg = { class: "fixed inset-0 overflow-hidden" }, Cg = { class: "pointer-events-none fixed inset-x-0 bottom-0 flex size-full" }, Sg = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "CfgBottomSheet",
  props: {
    opened: { type: Boolean },
    unmount: { type: Boolean },
    onBack: { type: Function, default: void 0 },
    dialogClasses: {},
    panelClasses: {},
    title: { default: "" },
    description: { default: "" },
    flat: { type: Boolean },
    closable: { type: Boolean, default: !0 },
    renderClose: { type: Boolean, default: !0 },
    disableBottomPadding: { type: Boolean },
    closeButtonClasses: {},
    fullHeight: { type: Boolean },
    minimalHeader: { type: Boolean },
    headerClasses: {},
    disableMainPadding: { type: Boolean }
  },
  emits: ["update:opened"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = Z(() => kl(t, ["opened", "unmount", "onBack"]));
    function s() {
      !t.closable && t.onBack && t.onBack(), t.closable && r("update:opened", !1);
    }
    return (o, a) => (k(), q(v(a1), {
      as: "template",
      show: o.opened
    }, {
      default: N(() => [
        A(v(l1), {
          as: "div",
          class: B(["relative z-modal", o.dialogClasses]),
          unmount: o.unmount ?? !1,
          onClose: s
        }, {
          default: N(() => [
            A(v(ss), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: N(() => a[0] || (a[0] = [
                E("div", { class: "fixed inset-0 bg-dark/30 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            E("div", kg, [
              E("div", {
                class: "absolute inset-0",
                onClose: s
              }, [
                E("div", Cg, [
                  A(v(ss), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": "translate-y-full",
                    "enter-to": "translate-y-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-y-0",
                    "leave-to": "translate-y-full"
                  }, {
                    default: N(() => [
                      A(v(u1), {
                        class: B(["pointer-events-auto h-[calc(100%-70px)] w-full self-end", o.panelClasses])
                      }, {
                        default: N(() => [
                          A(bp, Te({ ...i.value, ...o.$attrs }, {
                            "is-back-allowed": !!t.onBack,
                            onBack: t.onBack,
                            onClose: s
                          }), vs({
                            default: N(() => [
                              te(o.$slots, "default")
                            ]),
                            _: 2
                          }, [
                            o.$slots.head ? {
                              name: "head",
                              fn: N(() => [
                                te(o.$slots, "head")
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1040, ["is-back-allowed", "onBack"])
                        ]),
                        _: 3
                      }, 8, ["class"])
                    ]),
                    _: 3
                  })
                ])
              ], 32)
            ])
          ]),
          _: 3
        }, 8, ["class", "unmount"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), Eg = { class: "rounded-md" }, Tg = { class: "flex w-full flex-row items-center justify-between space-y-2 lg:flex-col lg:items-start lg:justify-start" }, Og = { class: "!mt-0 flex flex-row gap-x-2 lg:!mt-2" }, Mg = ["innerHTML"], Ag = ["innerHTML"], Ng = ["innerHTML"], Dg = { class: "mt-4" }, Lg = { class: "flex items-center justify-between pb-8" }, Rg = { class: "mt-7 flex flex-wrap justify-start gap-4 lg:gap-x-20" }, Pg = { key: 0 }, Ig = { class: "space-y-1" }, Bg = ["innerHTML"], zg = { class: "space-y-2" }, Vg = { class: "space-y-1" }, Fg = ["innerHTML"], QM = /* @__PURE__ */ X({
  __name: "CfgInvestCalculator",
  props: /* @__PURE__ */ Ae({
    /**
     * Main parameters on the top of the calculator
     */
    mainParameters: {
      type: Object,
      default: () => ({})
    },
    /**
     * Translations for calculator
     */
    translations: {
      type: Object,
      required: !0
    },
    /**
     * Minimum investment amount
     */
    minInvestment: {
      type: Number,
      required: !0
    },
    /**
     * Max investment amount
     */
    maxInvestment: {
      type: Number,
      required: !0
    },
    /**
     * Show periodic result under slider, should not show on ReturnsPeriodicityEnum.OneTime
     */
    showPeriodicResult: {
      type: Boolean,
      required: !0
    },
    /**
     * Show periodic result and whole period result
     */
    result: {
      type: [Object, null],
      default: null
    },
    /**
     * Each change on slider will increment and decrement by this value
     */
    stepValue: {
      type: Number,
      required: !0
    }
  }, {
    modelValue: { required: !0, type: Number },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["slider:dragEnd"], ["update:modelValue"]),
  setup(n) {
    const e = n, t = je(n, "modelValue"), r = ae(Ho(t.value, !0)), i = Z(() => e.stepValue ?? 0);
    function s(o) {
      const a = (o ?? r.value).replace(/\s/g, ""), l = $9(Number(a), {
        min: e.minInvestment,
        max: e.maxInvestment,
        step: i.value
      });
      t.value = l, r.value = Ho(l, !0);
    }
    return Ie(t, (o) => {
      const a = Ho(o, !0);
      r.value !== a && (r.value = Ho(o, !0));
    }, { deep: !0 }), (o, a) => {
      var l, u;
      return k(), T("div", Eg, [
        te(o.$slots, "searchInput"),
        Object.keys(n.mainParameters).length ? (k(), T("ul", {
          key: 0,
          class: B(["mb-10 flex flex-col flex-wrap gap-y-2 lg:flex-row lg:justify-between", {
            "gap-x-5": Object.keys(n.mainParameters).length > 2,
            "gap-x-10": Object.keys(n.mainParameters).length <= 2
          }])
        }, [
          (k(!0), T(ce, null, $e(n.mainParameters, ({ label: d, tooltip: c, description: f, value: p }, h) => (k(), T("li", { key: h }, [
            A(v(Zi), {
              class: "w-full",
              disabled: !c,
              "hide-icon": "",
              interactive: ""
            }, {
              trigger: N(() => [
                E("div", Tg, [
                  te(o.$slots, `${h}:label`, { label: d }, () => [
                    A(v(K), {
                      class: "flex items-center gap-x-1.5 text-grey-300",
                      size: v(G).xs
                    }, {
                      default: N(() => [
                        W(z(d) + " ", 1),
                        c ? (k(), q(v(Ps), {
                          key: 0,
                          class: "hidden text-[20px] lg:block"
                        })) : V("", !0)
                      ]),
                      _: 2
                    }, 1032, ["size"])
                  ]),
                  E("div", Og, [
                    A(v(K), {
                      class: "flex flex-col items-end !font-highlighted lg:items-start",
                      size: v(G).md,
                      "tag-name": "strong"
                    }, {
                      default: N(() => [
                        te(o.$slots, `${h}:value`, { value: p }, () => [
                          E("span", {
                            class: "block w-max",
                            innerHTML: p
                          }, null, 8, Mg)
                        ]),
                        te(o.$slots, `${h}:description`, { description: f }, () => [
                          f ? (k(), T("small", {
                            key: 0,
                            class: "block text-xs font-normal text-grey-300",
                            innerHTML: f
                          }, null, 8, Ag)) : V("", !0)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["size"]),
                    c ? (k(), q(v(Ps), {
                      key: 0,
                      class: "text-[20px] text-grey-500 lg:hidden"
                    })) : V("", !0)
                  ])
                ])
              ]),
              content: N(() => [
                te(o.$slots, `${h}:tooltip`, { tooltip: c }, () => [
                  A(v(K), {
                    size: v(G).sm
                  }, {
                    default: N(() => [
                      E("span", { innerHTML: c }, null, 8, Ng)
                    ]),
                    _: 2
                  }, 1032, ["size"])
                ])
              ]),
              _: 2
            }, 1032, ["disabled"])
          ]))), 128))
        ], 2)) : V("", !0),
        n.result ? (k(), T(ce, { key: 1 }, [
          A(v(K), {
            size: v(G).h3,
            "tag-name": "h2"
          }, {
            default: N(() => [
              W(z(n.translations.title), 1)
            ]),
            _: 1
          }, 8, ["size"]),
          E("div", Dg, [
            E("div", Lg, [
              A(v(K), {
                class: "grow text-grey-500",
                size: v(G).h4
              }, {
                default: N(() => [
                  W(z(n.translations.label), 1)
                ]),
                _: 1
              }, 8, ["size"]),
              E("div", null, [
                A(pn, {
                  modelValue: r.value,
                  "onUpdate:modelValue": a[0] || (a[0] = (d) => r.value = d),
                  class: "!w-44 font-highlighted",
                  "field-class": "[&>span]:!py-0 [&>span]:flex [&>span]:items-center",
                  max: n.maxInvestment,
                  min: n.minInvestment,
                  step: i.value,
                  suffix: n.translations.currency,
                  type: "text",
                  onBlur: s,
                  "onKeydown:enter": s
                }, null, 8, ["modelValue", "max", "min", "step", "suffix"])
              ])
            ]),
            A(v(R9), {
              class: "relative flex h-5 w-full touch-none select-none items-center",
              max: n.maxInvestment,
              min: n.minInvestment,
              "model-value": [t.value],
              step: i.value,
              "onUpdate:modelValue": a[1] || (a[1] = ([d] = []) => t.value = d),
              onValueCommit: a[2] || (a[2] = (d) => o.$emit("slider:dragEnd"))
            }, {
              default: N(() => [
                A(v(P9), { class: "relative h-2 grow rounded-full bg-grey-100" }, {
                  default: N(() => [
                    A(v(I9), { class: "absolute h-full rounded-full bg-brand" })
                  ]),
                  _: 1
                }),
                A(v(B9), {
                  "aria-label": "Volume",
                  class: "block size-8 cursor-pointer rounded-full bg-brand transition-colors hover:bg-brand-dark"
                })
              ]),
              _: 1
            }, 8, ["max", "min", "model-value", "step"])
          ]),
          E("div", Rg, [
            n.showPeriodicResult ? (k(), T("div", Pg, [
              A(v(Zi), {
                disabled: !((l = n.translations.result.periodic) != null && l.tooltip),
                "hide-icon": "",
                interactive: ""
              }, {
                trigger: N(() => [
                  E("div", Ig, [
                    A(v(K), {
                      class: "flex items-center gap-x-1.5 text-center font-highlighted text-grey-300 sm:text-left",
                      size: v(G).sm
                    }, {
                      default: N(() => [
                        W(z(n.translations.result.periodic.label) + " ", 1),
                        n.translations.result.periodic.tooltip ? (k(), q(v(Ps), {
                          key: 0,
                          class: "hidden text-[20px] sm:block"
                        })) : V("", !0)
                      ]),
                      _: 1
                    }, 8, ["size"]),
                    A(v(K), {
                      class: "block",
                      size: v(G).h3
                    }, {
                      default: N(() => [
                        W(z(n.result.periodic), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])
                  ])
                ]),
                content: N(({ closeHint: d }) => [
                  te(o.$slots, "periodicResultTooltip", { closeHint: d }, () => [
                    E("span", {
                      innerHTML: n.translations.result.periodic.tooltip
                    }, null, 8, Bg)
                  ])
                ]),
                _: 3
              }, 8, ["disabled"])
            ])) : V("", !0),
            E("div", zg, [
              A(v(Zi), {
                disabled: !((u = n.translations.result.wholePeriod) != null && u.tooltip),
                "hide-icon": "",
                interactive: ""
              }, {
                trigger: N(() => [
                  E("div", Vg, [
                    A(v(K), {
                      class: "flex items-center gap-x-1.5 text-center font-highlighted text-grey-300 sm:text-left",
                      size: v(G).sm
                    }, {
                      default: N(() => [
                        W(z(n.translations.result.wholePeriod.label) + " ", 1),
                        n.translations.result.wholePeriod.tooltip ? (k(), q(v(Ps), {
                          key: 0,
                          class: "hidden text-[20px] sm:block"
                        })) : V("", !0)
                      ]),
                      _: 1
                    }, 8, ["size"]),
                    A(v(K), {
                      class: "block !font-extrabold text-brand",
                      size: v(G).h3
                    }, {
                      default: N(() => [
                        W(z(n.result.wholePeriod), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])
                  ])
                ]),
                content: N(({ closeHint: d }) => [
                  te(o.$slots, "wholePeriodTooltip", { closeHint: d }, () => [
                    E("span", {
                      innerHTML: n.translations.result.wholePeriod.tooltip
                    }, null, 8, Fg)
                  ])
                ]),
                _: 3
              }, 8, ["disabled"])
            ])
          ])
        ], 64)) : V("", !0)
      ]);
    };
  }
}), jg = { class: "fixed inset-0 overflow-hidden" }, Hg = {
  key: 1,
  class: "flex max-h-full w-full items-center justify-center"
}, Lo = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "CfgSlideOver",
  props: {
    opened: { type: Boolean },
    unmount: { type: Boolean },
    onBack: { type: Function, default: void 0 },
    renderHead: { type: Boolean, default: !0 },
    size: { default: "md" },
    renderClose: { type: Boolean, default: !0 },
    width: { default: void 0 },
    disableBottomPadding: { type: Boolean, default: !1 },
    closeButtonClass: { default: "" },
    fullHeight: { type: Boolean, default: !1 },
    bottom: { type: Boolean, default: !1 },
    topPadding: { default: void 0 },
    headerClasses: {},
    title: {},
    description: {},
    flat: { type: Boolean },
    closable: { type: Boolean, default: !0 },
    closeButtonClasses: {},
    minimalHeader: { type: Boolean },
    disableMainPadding: { type: Boolean }
  },
  emits: ["update:opened"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = ae(!1), s = Z(() => kl(t, ["opened", "unmount", "onBack"]));
    function o() {
      !t.closable && t.onBack && t.onBack(), t.closable && r("update:opened", !1);
    }
    return (a, l) => (k(), q(v(a1), {
      as: "template",
      show: a.opened
    }, {
      default: N(() => [
        A(v(l1), {
          as: "div",
          class: "relative z-modal",
          unmount: a.unmount ?? !1,
          onClose: o
        }, {
          default: N(() => [
            A(v(ss), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: N(() => l[2] || (l[2] = [
                E("div", { class: "fixed inset-0 bg-dark/30 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            E("div", jg, [
              E("div", {
                class: "absolute inset-0 overflow-hidden",
                onClose: o
              }, [
                E("div", {
                  class: B(["pointer-events-none fixed flex max-w-full", {
                    "bottom-0": a.fullHeight || !a.bottom,
                    "right-0": !a.bottom,
                    "bottom-0 w-full": a.bottom
                  }]),
                  style: mt({
                    height: a.fullHeight ? a.topPadding ? `calc(100% - ${a.topPadding})` : "100%" : "auto"
                  })
                }, [
                  A(v(ss), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": a.bottom ? "translate-y-full" : "translate-x-full",
                    "enter-to": a.bottom ? "translate-y-0" : "translate-x-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": a.bottom ? "translate-y-0" : "translate-x-0",
                    "leave-to": a.bottom ? "translate-y-full" : "translate-x-full",
                    onAfterEnter: l[0] || (l[0] = (u) => i.value = !0),
                    onAfterLeave: l[1] || (l[1] = (u) => i.value = !1)
                  }, {
                    default: N(() => [
                      A(v(u1), {
                        class: B(["pointer-events-auto w-screen", {
                          "max-w-sm": !a.width && a.size === "sm",
                          "max-w-xl": !a.width && a.size === "md",
                          "max-w-[700px]": !a.width && a.size === "lg",
                          "h-auto": !a.fullHeight
                        }]),
                        style: mt(a.width ? { width: a.width } : {})
                      }, {
                        default: N(() => [
                          A(bp, Te({ ...s.value, ...a.$attrs }, {
                            "is-back-allowed": !!t.onBack,
                            onBack: t.onBack,
                            onClose: o
                          }), vs({
                            default: N(() => [
                              i.value ? te(a.$slots, "default", { key: 0 }) : V("", !0),
                              i.value ? V("", !0) : (k(), T("div", Hg, [
                                A(v(No), { class: "text-brand" })
                              ]))
                            ]),
                            _: 2
                          }, [
                            a.$slots.head ? {
                              name: "head",
                              fn: N(() => [
                                te(a.$slots, "head")
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1040, ["is-back-allowed", "onBack"])
                        ]),
                        _: 3
                      }, 8, ["class", "style"])
                    ]),
                    _: 3
                  }, 8, ["enter-from", "enter-to", "leave-from", "leave-to"])
                ], 6)
              ], 32)
            ])
          ]),
          _: 3
        }, 8, ["unmount"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
});
function Ug(n, e, t) {
  if (!e)
    return {};
  const r = Z(() => n.value.reduce((l, { rows: u }) => l + u.length, 0)), i = Z(() => (e.value || []).length === r.value);
  function s(l) {
    if (!(e != null && e.value))
      return;
    if (!l) {
      t([]);
      return;
    }
    const u = [];
    n.value.forEach(({ rows: d }) => {
      d.forEach((c) => {
        var f;
        u.push({
          index: c.originalIndex,
          id: (f = c.meta) == null ? void 0 : f.id
        });
      });
    }), t(u);
  }
  function o(l, u) {
    t(
      a(l, u)
    );
  }
  function a(l, u) {
    return e != null && e.value ? u ? [...e.value, l] : e.value.filter((d) => !fr(l, d)) : [];
  }
  return {
    toggleAllRowsSelected: s,
    toggleRowSelected: o,
    areAllRowsSelected: i
  };
}
function Wg(n, e) {
  return e ? !!e.find((t) => fr(n, t)) : !1;
}
function qg(n, e) {
  return {
    rowGroups: Z(() => n.value.data.reduce((t, r, i) => {
      var l;
      let s = {
        ...r,
        originalIndex: i,
        original: r,
        isSelected: !1,
        isExpended: !1,
        cells: n.value.headers.map(({ keyName: u }) => ({
          keyName: u,
          value: r[u]
        }))
      };
      e.mapEachRow && (s = e.mapEachRow(s));
      const o = (l = n.value.groups) == null ? void 0 : l.find((u) => u.value === s.group);
      if (!o)
        return t.length ? t[0].rows.push(s) : t.push({ value: "", label: "", rows: [s] }), t;
      const a = t.find((u) => u.value === o.value);
      return a ? a.rows.push(s) : t.push({ ...o, rows: [s] }), t;
    }, []))
  };
}
var Qt = /* @__PURE__ */ ((n) => (n.left = "left", n.right = "right", n.center = "center", n))(Qt || {});
const Wo = /* @__PURE__ */ X({
  __name: "CfgTableCell",
  props: {
    flat: { type: Boolean },
    align: {},
    bgColor: {},
    cellIndex: {},
    lastIndex: { type: Boolean },
    expended: { type: Boolean },
    selected: { type: Boolean },
    compact: { type: Boolean },
    expendable: { type: Boolean },
    bulk: {},
    disableStickyHead: { type: Boolean }
  },
  setup(n) {
    return (e, t) => (k(), q(v(K), {
      class: B({
        "pr-5": !e.lastIndex,
        "pl-5 sm:pl-5": !e.flat && !e.lastIndex,
        "lg:pl-8": !e.flat && !e.lastIndex && (e.bulk ? e.cellIndex + 1 : e.cellIndex) === 0,
        "!p-2": e.compact,
        "md:py-3.5": !e.compact,
        "text-center": e.align === v(Qt).center,
        "text-right": e.align === v(Qt).right,
        [e.bgColor ?? ""]: e.bgColor
      }),
      size: v(G).sm,
      "tag-name": "td"
    }, {
      default: N(() => [
        te(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "size"]));
  }
}), qo = /* @__PURE__ */ X({
  __name: "CfgTableHeadCell",
  props: {
    flat: { type: Boolean },
    align: {},
    bgColor: {},
    cellIndex: {},
    lastIndex: { type: Boolean },
    expended: { type: Boolean },
    selected: { type: Boolean },
    compact: { type: Boolean },
    expendable: { type: Boolean },
    bulk: {},
    disableStickyHead: { type: Boolean },
    sort: {},
    width: {},
    text: {}
  },
  emits: ["sort", "update:pagination", "click:row"],
  setup(n, { emit: e }) {
    const t = e;
    function r(i) {
      t("sort", i);
    }
    return (i, s) => (k(), T("th", {
      class: B(["text-left", {
        "px-5 sm:px-5": !i.flat && !i.lastIndex,
        "lg:px-8": !i.flat && !i.lastIndex && (i.bulk ? i.cellIndex + 1 : i.cellIndex) === 0,
        "!p-2": i.compact,
        "md:py-3.5": !i.compact,
        "text-center": i.align === v(Qt).center,
        "text-right": i.align === v(Qt).right,
        "sticky top-0 z-sticky": !i.disableStickyHead,
        [i.bgColor ?? ""]: i.bgColor,
        "bg-white/30": !i.bgColor
      }]),
      scope: "col",
      style: mt({
        ...i.width ? { width: i.width } : {}
      })
    }, [
      (k(), q(qe(i.sort ? "button" : "span"), Te(i.sort ? { type: "button" } : {}, oo(i.sort ? {
        click: () => r({
          ...i.sort,
          order: i.sort.order === "asc" ? "desc" : "asc"
        })
      } : {})), {
        default: N(() => {
          var o;
          return [
            E("span", {
              class: B(["flex items-center gap-x-2", {
                "justify-center": i.align === v(Qt).center,
                "justify-end": i.align === v(Qt).right
              }])
            }, [
              E("span", null, [
                A(v(K), {
                  class: B(["!font-highlighted uppercase", [(o = i.sort) != null && o.active ? "text-brand" : "text-grey-200"]]),
                  size: v(G).xs,
                  "tag-name": "span"
                }, {
                  default: N(() => [
                    te(i.$slots, "head", { text: i.text }, () => [
                      W(z(i.text), 1)
                    ])
                  ]),
                  _: 3
                }, 8, ["class", "size"])
              ]),
              i.sort ? (k(), q(v(xi), {
                key: 0,
                class: B(["shrink-0", {
                  "rotate-180": i.sort.order === "desc"
                }])
              }, null, 8, ["class"])) : V("", !0)
            ], 2)
          ];
        }),
        _: 3
      }, 16))
    ], 6));
  }
});
function Kg(n) {
  if (!(n != null && n.value))
    return {};
  const e = ae(null);
  function t(r) {
    e.value = e.value === r ? null : r;
  }
  return { expendedIndex: e, toggleRowExpendedHandler: t };
}
function Gg(n, e) {
  if (!n)
    return {};
  const t = Z({
    get() {
      var o;
      return ((o = n.value) == null ? void 0 : o.page) ?? 1;
    },
    set(o) {
      n.value && e({ ...n.value, page: o });
    }
  }), r = m9(() => {
    if (!n.value)
      return "";
    const o = n.value.page * n.value.perPage - n.value.perPage + 1, a = n.value.page * n.value.perPage;
    return `${o} - ${a > n.value.total ? n.value.total : a} / ${n.value.total}`;
  }), i = [10, 20, 50, 100].map((o) => ({ value: o, label: String(o) })), s = Z({
    get() {
      var a;
      const o = ((a = n == null ? void 0 : n.value) == null ? void 0 : a.perPage) || 0;
      return { value: o, label: String(o) };
    },
    set({ value: o }) {
      n.value && e({ ...n.value, perPage: o });
    }
  });
  return {
    paginationPage: t,
    paginationSubtext: r,
    paginationPerPageOptions: i,
    selectedPerPage: s
  };
}
const Yg = { class: "max-w-full overflow-y-hidden" }, Jg = { class: "inline-block min-w-full" }, Zg = { class: "w-max" }, Xg = { class: "block text-md" }, Qg = { class: "w-max" }, eb = ["colspan"], tb = ["onClick"], nb = { class: "ml-auto block px-3 py-2" }, rb = ["onClick", "onKeypress"], ib = { class: "overlow-hidden" }, sb = {
  class: "focusable -my-2 min-w-max p-4",
  type: "button"
}, ob = { key: 0 }, ab = ["colspan"], lb = {
  key: 0,
  class: "border-t border-grey-stroke/50"
}, ub = { class: "flex items-center gap-x-3" }, db = { class: "flex w-full justify-center lg:grow" }, cb = { class: "min-w-[200px] shrink-0" }, w1 = /* @__PURE__ */ X({
  __name: "CfgTable",
  props: {
    actionColumnTitle: {},
    dataSources: {},
    allowSelectPerPage: { type: Boolean, default: !0 },
    pagination: {},
    bulk: {},
    expendable: { type: Boolean },
    interactive: { type: Boolean },
    fixed: { type: Boolean },
    flatFirtsCell: { type: Boolean },
    compact: { type: Boolean },
    hideHeader: { type: Boolean },
    goToPage: { type: Boolean, default: !1 },
    disableStickyHead: { type: Boolean, default: !1 },
    bgColor: {}
  },
  emits: ["sort", "update:pagination", "update:bulk", "click:row"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = R2(), {
      pagination: s,
      bulk: o,
      expendable: a,
      dataSources: l
    } = wl(t), u = Z(() => pr(t, ["compact", "expendable", "bulk", "disableStickyHead", "bgColor"])), d = lo(l.value.headers, (Y) => {
      var le;
      const oe = (le = t.dataSources.sort) == null ? void 0 : le.find((ge) => ge.key === Y.keyName);
      return {
        ...Y,
        sort: oe,
        keyName: String(Y.keyName)
      };
    }), c = Z(() => d.value.every((Y) => {
      var oe, le;
      return !((le = (oe = Y.text) == null ? void 0 : oe.trim()) != null && le.length);
    })), f = Z(() => Object.keys(i).some((Y) => Y.startsWith("head:"))), p = Z(() => !t.hideHeader && (!c.value || !!(o != null && o.value) || f.value)), h = ae(null), { height: y } = uo(h), { expendedIndex: g, toggleRowExpendedHandler: m } = Kg(a), {
      paginationPage: $,
      selectedPerPage: w,
      paginationSubtext: _,
      paginationPerPageOptions: L
    } = Gg(
      s,
      (Y) => r("update:pagination", Y)
    ), { rowGroups: S } = qg(l, {
      mapEachRow(Y) {
        var oe;
        return {
          ...Y,
          isSelected: Wg({ index: Y.originalIndex, id: (oe = Y.meta) == null ? void 0 : oe.id }, (o == null ? void 0 : o.value) || []),
          isExpended: ((g == null ? void 0 : g.value) ?? -1) === Y.originalIndex
        };
      }
    }), { areAllRowsSelected: R, toggleAllRowsSelected: O, toggleRowSelected: I } = Ug(S, o, (Y) => r("update:bulk", Y)), x = Z(() => t.dataSources.headers.map(({ footerValue: Y, align: oe, keyName: le }) => ({
      value: Y,
      align: oe,
      keyName: String(le)
    }))), M = Z(() => x.value.some(({ value: Y }) => Y)), D = Z(() => !!i["body:actions"]), j = [
      o,
      a,
      D
    ], U = Z(() => j.map((Y) => Y == null ? void 0 : Y.value).filter(Boolean).length);
    function J(Y) {
      r("sort", Y);
    }
    function ne(Y, oe, le) {
      m && m(le), t.interactive && r("click:row", { item: Y, e: oe });
    }
    return (Y, oe) => (k(), T("div", Yg, [
      E("div", {
        class: B(["-mt-5 max-w-full pt-5", { "overflow-x-auto": !Y.fixed }])
      }, [
        E("div", Jg, [
          E("table", {
            class: B(["min-w-full max-w-full border-spacing-0", {
              "w-max": !Y.fixed,
              "w-full table-fixed": Y.fixed
            }]),
            style: mt({
              // Hide head if all headers are hidden.
              // Display none doesn't work because table cells will wrong calculate width without rendered table head
              ...p.value ? {} : { marginTop: `-${v(y)}px` }
            })
          }, [
            E("thead", {
              ref_key: "headRef",
              ref: h,
              class: B(["shadow-none", {
                invisible: !p.value
              }])
            }, [
              E("tr", Zg, [
                v(o) ? (k(), q(qo, Te({
                  key: 0,
                  "cell-index": 0,
                  "key-name": "bulk",
                  text: ""
                }, u.value, { width: "80px" }), {
                  head: N(() => [
                    E("span", Xg, [
                      A(v(Ta), {
                        class: "text-md",
                        "model-value": v(R),
                        "onUpdate:modelValue": v(O)
                      }, null, 8, ["model-value", "onUpdate:modelValue"])
                    ])
                  ]),
                  _: 1
                }, 16)) : V("", !0),
                (k(!0), T(ce, null, $e(v(d), ({
                  keyName: le,
                  text: ge,
                  sort: he,
                  align: _e,
                  width: ue
                }, xe) => (k(), q(qo, Te({
                  key: `head-${le}`,
                  ref_for: !0
                }, u.value, {
                  align: _e,
                  "cell-index": v(o) ? xe + 1 : xe,
                  compact: Y.compact,
                  "key-name": le,
                  "last-index": xe === v(d).length - 1,
                  sort: he,
                  text: ge,
                  width: ue,
                  onSort: J
                }), {
                  head: N(() => [
                    te(Y.$slots, `head:${le}`, {
                      keyName: le,
                      text: ge
                    }, () => [
                      W(z(ge), 1)
                    ])
                  ]),
                  _: 2
                }, 1040, ["align", "cell-index", "compact", "key-name", "last-index", "sort", "text", "width"]))), 128)),
                Y.$slots["body:actions"] ? (k(), q(qo, {
                  key: "action",
                  align: v(Qt).center,
                  "cell-index": v(d).length + 1,
                  class: B(["text-end", {
                    "pr-10": !v(a)
                  }]),
                  compact: Y.compact,
                  "key-name": "action",
                  text: Y.actionColumnTitle || "",
                  width: "70px"
                }, null, 8, ["align", "cell-index", "class", "compact", "text"])) : V("", !0),
                v(a) ? (k(), q(qo, Te({
                  key: 2,
                  "cell-index": v(d).length + (D.value ? 2 : 1)
                }, u.value, {
                  class: "pr-10",
                  width: "70px"
                }), null, 16, ["cell-index"])) : V("", !0)
              ])
            ], 2),
            E("tbody", Qg, [
              (k(!0), T(ce, null, $e(v(S), ({ rows: le, value: ge, label: he }, _e) => (k(), T(ce, null, [
                he || ge ? (k(), T("tr", {
                  key: `group-${_e}`
                }, [
                  E("th", {
                    class: B(["px-5 pb-2 text-left text-grey-300 lg:px-8", { "pt-2": Y.compact, "pt-5": !Y.compact }]),
                    colspan: le[0].cells.length || 0,
                    scope: "colgroup"
                  }, [
                    te(Y.$slots, "group", {
                      group: { rows: le, value: ge, label: he }
                    }, () => [
                      A(v(K), {
                        class: "font-highlighted",
                        size: v(G).sm
                      }, {
                        default: N(() => [
                          W(z(he || ge), 1)
                        ]),
                        _: 2
                      }, 1032, ["size"])
                    ])
                  ], 10, eb)
                ])) : V("", !0),
                (k(!0), T(ce, null, $e(le, (ue, xe) => (k(), T(ce, {
                  key: `row-${xe}-${_e}`
                }, [
                  E("tr", {
                    class: B(["row last-child:!border-b-none", {
                      "cursor-pointer transition-colors duration-200": Y.interactive || v(a),
                      "hover:bg-grey-100/50": Y.interactive,
                      "border-b border-b-grey-stroke": !ue.isExpended && !ue.isSelected && xe !== le.length - 1,
                      "border-b border-b-brand/20": !ue.isExpended && ue.isSelected && xe !== le.length - 1,
                      "border-b border-b-white": ue.isExpended && xe !== le.length - 1,
                      "hover:bg-brand/10": v(a),
                      "expended-row bg-brand/10": ue.isExpended || ue.isSelected
                    }]),
                    onClick: (Le) => ne(ue.original, Le, ue.originalIndex)
                  }, [
                    v(o) ? (k(), q(Wo, Te({
                      key: 0,
                      "cell-index": 0,
                      expended: ue.isExpended,
                      ref_for: !0
                    }, u.value, {
                      "row-index": xe,
                      selected: ue.isSelected
                    }), {
                      default: N(() => [
                        A(v(Ta), {
                          class: "text-md",
                          "model-value": ue.isSelected,
                          onClick: oe[0] || (oe[0] = Ht(() => {
                          }, ["stop"])),
                          "onUpdate:modelValue": (Le) => {
                            var be;
                            v(I) && v(I)({
                              index: ue.originalIndex,
                              id: (be = ue.meta) == null ? void 0 : be.id
                            }, Le);
                          }
                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1040, ["expended", "row-index", "selected"])) : V("", !0),
                    (k(!0), T(ce, null, $e(ue.cells, (Le, be) => (k(), q(Wo, Te({
                      key: `cell-${Le.keyName}-${xe}-${_e}`,
                      ref_for: !0
                    }, u.value, {
                      align: v(l).headers[be].align,
                      "cell-index": v(o) ? be + 1 : be,
                      expended: ue.isExpended,
                      flat: Y.flatFirtsCell && be === 0 && !v(o),
                      "last-index": be === Object.values(ue.cells).length - 1,
                      "row-index": xe,
                      selected: ue.isSelected
                    }), {
                      default: N(() => [
                        Y.$slots[`body:${Le.keyName}`] ? te(Y.$slots, `body:${Le.keyName}`, {
                          key: 0,
                          item: v(l).data[xe],
                          value: Le.value
                        }) : te(Y.$slots, "body:item", {
                          key: 1,
                          item: v(l).data[xe],
                          keyName: Le.keyName,
                          value: Le.value
                        }, () => [
                          W(z(Le.value || "-"), 1)
                        ])
                      ]),
                      _: 2
                    }, 1040, ["align", "cell-index", "expended", "flat", "last-index", "row-index", "selected"]))), 128)),
                    D.value ? (k(), q(Wo, Te({
                      key: 1,
                      "cell-index": ue.cells.length + 1,
                      expended: ue.isExpended,
                      "row-index": xe,
                      selected: ue.isSelected,
                      ref_for: !0
                    }, u.value, {
                      onClick: oe[1] || (oe[1] = Ht(() => {
                      }, ["stop"]))
                    }), {
                      default: N(() => [
                        A($m, {
                          class: "mx-auto",
                          "origin-x": "right",
                          overlay: ""
                        }, {
                          trigger: N(() => [
                            E("span", nb, [
                              A(v(V4), { class: "text-grey-300" })
                            ])
                          ]),
                          default: N(({ close: Le }) => {
                            var be, He;
                            return [
                              E("span", {
                                class: "block min-w-max px-6 py-4",
                                onClick: Le,
                                onKeypress: Yn(Le, ["enter"])
                              }, [
                                te(Y.$slots, "body:actions", {
                                  index: xe,
                                  row: (He = (be = v(S)[_e]) == null ? void 0 : be.rows) == null ? void 0 : He[xe]
                                })
                              ], 40, rb)
                            ];
                          }),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1040, ["cell-index", "expended", "row-index", "selected"])) : V("", !0),
                    v(a) ? (k(), q(Wo, Te({
                      key: 2,
                      "cell-index": ue.cells.length + (D.value ? 2 : 1),
                      expended: ue.isExpended,
                      "row-index": xe,
                      selected: ue.isSelected,
                      ref_for: !0
                    }, u.value), {
                      default: N(() => [
                        E("div", ib, [
                          E("button", sb, [
                            A(v(xi), {
                              class: B(["size-5 transition duration-200", {
                                "rotate-180 text-brand": ue.isExpended
                              }])
                            }, null, 8, ["class"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1040, ["cell-index", "expended", "row-index", "selected"])) : V("", !0)
                  ], 10, tb),
                  v(a) ? (k(), T("tr", ob, [
                    E("td", {
                      class: B(["p-0", {
                        "pt-px": ue.isExpended
                      }]),
                      colspan: ue.cells.length + U.value
                    }, [
                      A(J2, {
                        class: "border-transparent bg-brand/10",
                        opened: ue.isExpended
                      }, {
                        default: N(() => [
                          E("div", null, [
                            E("div", {
                              class: B(["lg:px-8", { "p-3": Y.compact, "p-5": !Y.compact }])
                            }, [
                              te(Y.$slots, "row:expended", {
                                index: ue.originalIndex,
                                row: ue.original
                              })
                            ], 2)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["opened"])
                    ], 10, ab)
                  ])) : V("", !0)
                ], 64))), 128))
              ], 64))), 256))
            ]),
            M.value ? (k(), T("tfoot", lb, [
              E("tr", null, [
                v(o) ? (k(), T("td", {
                  key: 0,
                  class: B(["py-3 pl-5 pr-7 text-center text-xs sm:pl-6 lg:pl-8 xl:text-[15px]", {
                    "md:py-5": !Y.compact,
                    "md:py-3": Y.compact
                  }]),
                  onClick: oe[2] || (oe[2] = Ht(() => {
                  }, ["stop"]))
                }, null, 2)) : V("", !0),
                (k(!0), T(ce, null, $e(x.value, ({ value: le, align: ge, keyName: he }, _e) => (k(), T("td", {
                  key: `footer-${_e}`
                }, [
                  E("span", {
                    class: B(["flex w-full py-3 pr-5", {
                      "justify-center text-center": ge === v(Qt).center,
                      "justify-end text-right": ge === v(Qt).right,
                      "pl-5 sm:pl-5": !Y.flatFirtsCell
                    }])
                  }, [
                    le ? te(Y.$slots, `footer:${he}`, {
                      key: 0,
                      item: v(l).data[_e],
                      value: le
                    }, () => [
                      A(v(K), {
                        class: "font-highlighted",
                        html: String(le),
                        size: v(G).md
                      }, null, 8, ["html", "size"])
                    ]) : V("", !0)
                  ], 2)
                ]))), 128))
              ])
            ])) : V("", !0)
          ], 6)
        ])
      ], 2),
      v(s) && v($) ? (k(), T("div", {
        key: 0,
        class: B(["mt-0 block w-full border-t border-grey-stroke/50 p-5 lg:px-8", {
          "pt-10": !Y.allowSelectPerPage
        }]),
        style: { "--cfg-select-min-width": "150px" }
      }, [
        E("div", ub, [
          A(v(K), {
            class: "shrink-0 text-grey-300",
            size: v(G).sm
          }, {
            default: N(() => [
              W(z(v(_)), 1)
            ]),
            _: 1
          }, 8, ["size"]),
          E("div", db, [
            A(qm, {
              page: v($),
              "onUpdate:page": oe[3] || (oe[3] = (le) => rs($) ? $.value = le : null),
              class: "w-full lg:w-max",
              "go-to-page": t.goToPage,
              "items-per-page": v(s).perPage,
              "total-items": v(s).total
            }, null, 8, ["page", "go-to-page", "items-per-page", "total-items"])
          ]),
          E("div", cb, [
            Y.allowSelectPerPage ? (k(), q(x1, {
              key: 0,
              modelValue: v(w),
              "onUpdate:modelValue": oe[4] || (oe[4] = (le) => rs(w) ? w.value = le : null),
              "content-min-width": "150px",
              options: v(L),
              placeholder: "Řádků na stránku:"
            }, null, 8, ["modelValue", "options"])) : V("", !0)
          ])
        ])
      ], 2)) : V("", !0)
    ]));
  }
}), fb = {
  key: 0,
  class: "flex items-center text-[1.2em]"
}, eA = /* @__PURE__ */ X({
  __name: "CfgTableMenuItem",
  props: {
    as: {
      type: String,
      default: "button"
    }
  },
  setup(n) {
    return (e, t) => (k(), q(v(K), {
      class: "flex items-center gap-x-3 px-3 py-2 transition duration-200 hover:opacity-70",
      size: v(G).md,
      "tag-name": n.as
    }, {
      default: N(() => [
        e.$slots.icon ? (k(), T("div", fb, [
          te(e.$slots, "icon")
        ])) : V("", !0),
        E("div", null, [
          te(e.$slots, "body")
        ])
      ]),
      _: 3
    }, 8, ["size", "tag-name"]));
  }
}), pb = { class: "mb-4 flex flex-col gap-y-5" }, hb = {
  key: 1,
  class: "size-[24px] shrink-0"
}, mb = { class: "flex w-[calc(100%-36px)] flex-col gap-y-1" }, gb = { key: 0 }, bb = {
  key: 2,
  class: "my-4 flex flex-col gap-y-2"
}, yb = ["href"], vb = { class: "truncate whitespace-pre underline" }, _b = /* @__PURE__ */ X({
  __name: "CollateralsSheetGroup",
  props: {
    title: {},
    group: {},
    isMobile: { type: Boolean },
    isPublic: { type: Boolean, default: !1 }
  },
  setup(n) {
    function e(t) {
      var r;
      if (t.customFilename)
        return t.customFilename;
      if (t.filename)
        return t.filename;
      if (!n.isPublic && ((r = t.file) != null && r.url))
        return t.file.url.replace("https://static.dluhopisomat.cz/files/", "");
    }
    return (t, r) => (k(), T("div", pb, [
      A(v(K), {
        class: "!font-extrabold",
        size: v(G).h5
      }, {
        default: N(() => [
          W(z(t.title), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      (k(!0), T(ce, null, $e(t.group, (i) => (k(), T("div", {
        key: i.type,
        class: B(["flex items-start", {
          "gap-3": !t.isMobile,
          "gap-2": t.isMobile
        }])
      }, [
        i.icon ? (k(), q(qe(i.icon), {
          key: 0,
          class: "shrink-0 text-[24px] text-grey"
        })) : (k(), T("div", hb)),
        E("div", mb, [
          A(v(K), {
            class: "mr-auto !font-semibold",
            "tag-name": "div"
          }, {
            default: N(() => [
              W(z((i == null ? void 0 : i.possessiveLabel) || i.type) + " ", 1),
              i.amountFormatted ? (k(), T("span", gb, z(i.amountFormatted), 1)) : V("", !0)
            ]),
            _: 2
          }, 1024),
          i.info ? (k(), q(v(K), {
            key: 0,
            html: i.info
          }, null, 8, ["html"])) : V("", !0),
          i.description ? (k(), q(v(K), {
            key: 1,
            html: i.description
          }, null, 8, ["html"])) : V("", !0),
          i.files && i.files.length ? (k(), T("div", bb, [
            (k(!0), T(ce, null, $e(i.files, (s, o) => {
              var a;
              return k(), T(ce, { key: o }, [
                (a = s.file) != null && a.url ? (k(), T("a", {
                  key: 0,
                  class: B(["flex items-center justify-start", {
                    "font-highlighted text-orange": !t.isPublic,
                    "cursor-not-allowed font-light text-grey": t.isPublic
                  }]),
                  href: t.isPublic ? void 0 : s.file.url,
                  target: "_blank"
                }, [
                  t.isPublic ? (k(), q(v(F4), {
                    key: 0,
                    class: "mr-2 shrink-0 text-[24px]"
                  })) : V("", !0),
                  E("span", vb, z(e(s)) + " " + z(s.year), 1)
                ], 10, yb)) : V("", !0)
              ], 64);
            }), 128))
          ])) : V("", !0)
        ])
      ], 2))), 128))
    ]));
  }
}), tA = {
  "Agent pro zajištění": j4,
  Movitosti: H4,
  Nemovitosti: U4,
  "Ručitelské prohlášení majitele": W4,
  "Ručitelské prohlášení právnické osoby": q4,
  "Notářský zápis": K4,
  Žádná: void 0
};
var ri = /* @__PURE__ */ ((n) => (n.enhancements = "enhancements", n.collaterals = "collaterals", n))(ri || {});
const Di = {
  "Agent pro zajištění": "enhancements",
  "Notářský zápis": "enhancements",
  Movitosti: "collaterals",
  Nemovitosti: "collaterals",
  "Ručitelské prohlášení majitele": "collaterals",
  "Ručitelské prohlášení právnické osoby": "collaterals",
  Žádná: void 0
};
var $b = /* @__PURE__ */ ((n) => (n.Globe = "globe", n.Sale = "sale", n.House = "house", n.Heart = "heart", n.IdCard = "id-card", n.BarGraph = "bar-graph", n.Checklist = "checklist", n.ShieldCheck = "shield-check", n.Buildings = "buildings", n.BriefcaseCheck = "briefcase-check", n.Ribbon = "ribbon", n))($b || {});
const xb = {
  globe: G4,
  sale: Y4,
  house: J4,
  heart: Z4,
  "id-card": X4,
  "bar-graph": Q4,
  checklist: e9,
  "shield-check": t9,
  buildings: n9,
  "briefcase-check": r9,
  ribbon: i9
}, wb = { class: "relative flex w-full items-center justify-between" }, kb = { class: "item-stretch flex w-full max-w-[765px] flex-col lg:-mt-2" }, Cb = { class: "mb-6 flex w-full flex-col gap-5" }, Sb = {
  key: 0,
  class: "sticky inset-x-0 bottom-0 z-10 transition-all"
}, Eb = {
  key: 1,
  class: "sticky inset-x-0 bottom-0 z-10"
}, Tb = "Investovat", Ob = /* @__PURE__ */ X({
  __name: "CollateralsSheet",
  props: /* @__PURE__ */ Ae({
    label: {},
    description: {},
    moreLabel: {},
    slideOverTitle: {},
    slideOverSubtitle: {},
    collaterals: {},
    moreTypesLabel: {},
    tooltipButtonLabel: {},
    isMobile: { type: Boolean },
    isPublic: { type: Boolean }
  }, {
    isOpened: { type: Boolean, type: Boolean, default: !1 },
    isOpenedModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["openCalculator"], ["update:isOpened"]),
  setup(n, { emit: e }) {
    const t = e, r = je(n, "isOpened"), i = Z(
      () => n.collaterals.filter(({ type: d }) => d)
    ), s = Z(
      () => i.value.filter(({ type: d }) => (Di == null ? void 0 : Di[d]) === ri.enhancements)
    ), o = Z(
      () => i.value.filter(({ type: d }) => (Di == null ? void 0 : Di[d]) === ri.collaterals)
    ), a = Z(() => ({
      [ri.collaterals]: o.value,
      [ri.enhancements]: s.value
    })), l = {
      [ri.collaterals]: "Položky zajištění",
      [ri.enhancements]: "Prvky posilující zajištění"
    };
    function u() {
      r.value = !1, t("openCalculator");
    }
    return (d, c) => {
      const f = Yt("ripple");
      return k(), q(v(Lo), {
        opened: r.value,
        "onUpdate:opened": c[1] || (c[1] = (p) => r.value = p),
        bottom: d.isMobile,
        class: B(["relative [&_header]:!py-4", {
          "!rounded-none": !d.isMobile
        }]),
        closable: "",
        "full-height": "",
        "render-close": !1,
        size: "lg"
      }, {
        head: N(() => [
          E("div", wb, [
            E("div", {
              class: B(["flex flex-col", {
                "gap-2": !d.isMobile,
                "gap-1": d.isMobile
              }])
            }, [
              A(v(K), {
                class: "!font-extrabold",
                size: v(G).h3
              }, {
                default: N(() => [
                  W(z(d.slideOverTitle), 1)
                ]),
                _: 1
              }, 8, ["size"]),
              A(v(K), { class: "!text-[13px] !font-medium text-secondary" }, {
                default: N(() => [
                  W(z(d.slideOverSubtitle), 1)
                ]),
                _: 1
              })
            ], 2),
            nt((k(), T("button", {
              class: B(["flex items-center justify-center ring-brand focus-visible:outline-brand focus-visible:ring", {
                "size-[70px]": !d.isMobile,
                "size-[40px] -translate-y-3 translate-x-4 self-start": d.isMobile
              }]),
              type: "button",
              onClick: c[0] || (c[0] = (p) => r.value = !1)
            }, [
              A(v(Ut), {
                class: B({
                  "text-[33px]": !d.isMobile,
                  "text-[19px]": d.isMobile
                })
              }, null, 8, ["class"])
            ], 2)), [
              [f]
            ])
          ])
        ]),
        default: N(() => [
          E("div", kb, [
            E("div", Cb, [
              (k(!0), T(ce, null, $e(a.value, (p, h) => (k(), T(ce, {
                key: `group-${h}`
              }, [
                p.length ? (k(), q(_b, {
                  key: 0,
                  group: p,
                  "is-mobile": d.isMobile,
                  "is-public": d.isPublic,
                  title: l[h]
                }, null, 8, ["group", "is-mobile", "is-public", "title"])) : V("", !0)
              ], 64))), 128))
            ]),
            c[3] || (c[3] = E("div", { class: "grow" }, null, -1)),
            d.isPublic ? d.isPublic ? (k(), T("div", Eb, [
              te(d.$slots, "collateralsCta", {}, void 0, !0)
            ])) : V("", !0) : (k(), T("div", Sb, [
              c[2] || (c[2] = E("div", { class: "button-background pointer-events-none absolute inset-0" }, null, -1)),
              A(v(hr), {
                class: "w-full rounded-full",
                small: "",
                variant: "orange",
                onClick: u
              }, {
                icon: N(() => [
                  A(v(mn), { class: "text-[24px]" })
                ]),
                default: N(() => [
                  A(v(K), {
                    class: "!font-extrabold",
                    size: v(G).md
                  }, {
                    default: N(() => [
                      W(z(Tb))
                    ]),
                    _: 1
                  }, 8, ["size"])
                ]),
                _: 1
              })
            ]))
          ])
        ]),
        _: 3
      }, 8, ["opened", "bottom", "class"]);
    };
  }
}), nA = /* @__PURE__ */ Bn(Ob, [["__scopeId", "data-v-7d4c3ea3"]]);
function mo(n) {
  return n == null ? !0 : typeof n == "string" ? n === "" : Array.isArray(n) ? n.every((e) => mo(e)) : n.content ? n.content.every((e) => !e.content) : !0;
}
const Mb = { class: "flex flex-col gap-3 lg:gap-6" }, Ab = { class: "mb-2 mt-3 md:my-0" }, Nb = /* @__PURE__ */ X({
  __name: "Info",
  props: {
    label: {},
    establishedLabel: {},
    establishedValue: {},
    legalFormLabel: {},
    legalFormValue: {},
    icoLabel: {},
    icoValue: {},
    businessTypeLabel: {},
    businessTypeValue: {}
  },
  setup(n) {
    const e = Z(() => ({
      headers: [
        { keyName: "key", text: "", width: "50%" },
        { keyName: "value", text: "", width: "50%", align: Qt.right }
      ],
      data: [
        {
          key: n.establishedLabel,
          value: n.establishedValue
        },
        {
          key: n.legalFormLabel,
          value: n.legalFormValue
        },
        {
          key: n.icoLabel,
          value: n.icoValue
        },
        {
          key: n.businessTypeLabel,
          value: n.businessTypeValue
        }
      ]
    }));
    return (t, r) => (k(), T("div", Mb, [
      A(v(K), {
        class: "!font-extrabold",
        size: v(G).h3
      }, {
        default: N(() => [
          W(z(t.label), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      A(v(w1), {
        class: "[&_tr]:border-stroke-gray",
        "data-sources": e.value,
        "disable-sticky-head": "",
        fixed: "",
        "flat-firts-cell": "",
        "hide-header": ""
      }, {
        "body:key": N(({ item: { key: i } }) => [
          E("div", Ab, [
            A(v(K), {
              class: "max-w-full",
              size: v(G).sm
            }, {
              default: N(() => [
                W(z(i), 1)
              ]),
              _: 2
            }, 1032, ["size"])
          ])
        ]),
        "body:value": N(({ item: { value: i } }) => [
          A(v(K), {
            class: "!font-semibold",
            size: v(G).sm
          }, {
            default: N(() => [
              W(z(i), 1)
            ]),
            _: 2
          }, 1032, ["size"])
        ]),
        _: 1
      }, 8, ["data-sources"])
    ]));
  }
}), Db = { class: "flex flex-col gap-11" }, Lb = { class: "flex gap-4" }, Rb = ["src"], Pb = {
  key: 1,
  class: "flex size-16 items-center justify-center rounded-full bg-brand-light"
}, Ib = { class: "flex flex-col justify-center gap-y-1" }, Bb = /* @__PURE__ */ X({
  __name: "People",
  props: {
    people: {}
  },
  setup(n) {
    function e(t) {
      if (!t)
        return "UK";
      const [r, i] = t.split(" ");
      return `${(r == null ? void 0 : r[0]) || ""}${(i == null ? void 0 : i[0]) || ""}`;
    }
    return (t, r) => (k(), T("div", Db, [
      (k(!0), T(ce, null, $e(t.people, (i, s) => (k(), T("div", { key: s }, [
        E("div", Lb, [
          i.pictureUrl ? (k(), T("img", {
            key: 0,
            alt: "Person",
            class: "aspect-square h-16 rounded-full object-cover object-center",
            src: i.pictureUrl
          }, null, 8, Rb)) : (k(), T("div", Pb, [
            A(v(K), {
              class: "font-nunito !font-bold text-brand-dark",
              size: v(G).subtitle
            }, {
              default: N(() => [
                W(z(e(i == null ? void 0 : i.name)), 1)
              ]),
              _: 2
            }, 1032, ["size"])
          ])),
          E("div", Ib, [
            A(v(K), {
              class: "font-nunito !font-extrabold",
              size: v(G).subtitle
            }, {
              default: N(() => [
                W(z(i.name), 1)
              ]),
              _: 2
            }, 1032, ["size"]),
            A(v(K), {
              class: "!font-light text-secondary",
              size: v(G).sm
            }, {
              default: N(() => [
                W(z(i.position), 1)
              ]),
              _: 2
            }, 1032, ["size"])
          ])
        ]),
        i.description ? (k(), q(v(K), {
          key: 0,
          class: "prose !mt-4 !font-light",
          html: i.description,
          size: v(G).md,
          "tag-name": "div"
        }, null, 8, ["html", "size"])) : V("", !0)
      ]))), 128))
    ]));
  }
}), zb = { class: "flex flex-col gap-3 lg:gap-6" }, Vb = { class: "normal-case" }, Fb = { class: "mb-2 mt-3 md:my-0" }, jb = { key: 0 }, Hb = {
  key: 1,
  class: "text-red"
}, Ub = {
  key: 2,
  class: "text-brand"
}, Wb = /* @__PURE__ */ X({
  __name: "Results",
  props: {
    label: {},
    statements: {},
    statementPropertyLabels: {},
    shortDescription: {},
    formatNumberFn: { type: Function },
    formatPercentFn: { type: Function }
  },
  setup(n) {
    const e = Z(
      () => n.statements.filter(({ year: s }) => s).toSorted(({ year: s }, { year: o }) => s - o).slice(0, 3)
    );
    function t(s, o) {
      const [a, l] = s.map((u) => Number(u[o])).slice(-2);
      return !l || !a ? null : String((l - a) / a);
    }
    function r(s) {
      const o = t(e.value, s);
      return {
        key: n.statementPropertyLabels[s],
        ...Object.fromEntries(e.value.map(
          (a, l) => [
            `year${l + 1}`,
            a[s] ? n.formatNumberFn(Number(a[s])) : "-"
          ]
        )),
        yearOnYear: o !== null ? o : "-"
      };
    }
    const i = Z(() => ({
      headers: [
        { keyName: "key", text: "", width: "50%" },
        ...e.value.map(({ year: s }, o) => ({
          keyName: `year${o + 1}`,
          text: s.toString(),
          width: "30%",
          align: Qt.right
        })),
        { keyName: "yearOnYear", text: n.statementPropertyLabels.yearOnYear, width: "30%", align: Qt.right }
      ],
      data: [
        r("revenues"),
        r("incomeTradingBeforeTax"),
        r("assets"),
        r("equity")
      ]
    }));
    return (s, o) => (k(), T("div", zb, [
      A(v(K), {
        class: "!font-extrabold",
        size: v(G).h3
      }, {
        default: N(() => [
          W(z(s.label), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      A(v(w1), {
        class: "mb-2 lg:mb-0 [&_tr>td:first-child]:pl-0 [&_tr]:border-stroke-gray",
        compact: "",
        "data-sources": i.value,
        "disable-sticky-head": "",
        fixed: "",
        flat: "",
        "flat-firts-cell": ""
      }, {
        "head:yearOnYear": N(({ text: a }) => [
          E("span", Vb, z(a), 1)
        ]),
        "body:key": N(({ item: { key: a } }) => [
          E("div", Fb, [
            A(v(K), {
              class: "max-w-full text-grey",
              html: a,
              size: v(G).sm
            }, null, 8, ["html", "size"])
          ])
        ]),
        "body:yearOnYear": N(({ item: { yearOnYear: a } }) => [
          a === "-" ? (k(), T("span", jb, z(a), 1)) : Number(a) < 0 ? (k(), T("span", Hb, z(s.formatPercentFn(Number(a))), 1)) : (k(), T("span", Ub, z(s.formatPercentFn(Number(a))), 1))
        ]),
        _: 1
      }, 8, ["data-sources"]),
      s.shortDescription ? (k(), q(v(K), {
        key: 0,
        class: "mt-5",
        html: s.shortDescription,
        size: v(G).md,
        "tag-name": "div"
      }, null, 8, ["html", "size"])) : V("", !0)
    ]));
  }
}), qb = { class: "flex flex-col gap-y-11" }, Kb = { class: "flex flex-col gap-2" }, Gb = { key: 1 }, rA = /* @__PURE__ */ X({
  __name: "Company",
  props: {
    about: {},
    people: {},
    info: {},
    results: {}
  },
  emits: ["openCompanyDetail"],
  setup(n) {
    return (e, t) => {
      const r = Yt("ripple");
      return k(), T("div", qb, [
        E("div", Kb, [
          A(v(K), {
            class: "mb-5 !font-extrabold",
            size: v(G).h2
          }, {
            default: N(() => [
              W(z(e.about.title), 1)
            ]),
            _: 1
          }, 8, ["size"]),
          v(is)(e.about.aboutCompanyShort) ? V("", !0) : (k(), q(v(Ln), {
            key: 0,
            content: e.about.aboutCompanyShort
          }, null, 8, ["content"]))
        ]),
        e.people && e.people.people.length ? (k(), q(Bb, Fr(Te({ key: 0 }, e.people)), null, 16)) : V("", !0),
        A(Nb, Fr(Yi(e.info)), null, 16),
        A(Wb, Fr(Yi(e.results)), null, 16),
        v(mo)(e.about.aboutCompanyLong) ? V("", !0) : (k(), T("div", Gb, [
          nt((k(), T("button", {
            class: "font-semibold text-orange underline hover:cursor-pointer",
            onClick: t[0] || (t[0] = (i) => e.$emit("openCompanyDetail"))
          }, [
            W(z(e.about.moreLabel) + " ", 1),
            A(v(mn), { class: "inline-block text-[20px]" })
          ])), [
            [r]
          ])
        ]))
      ]);
    };
  }
}), Yb = { class: "relative flex w-full items-center justify-between" }, iA = /* @__PURE__ */ X({
  __name: "Sheet",
  props: /* @__PURE__ */ Ae({
    title: {},
    description: {},
    descriptionRichText: {},
    aboutCompanyShort: {},
    aboutCompanyLong: {},
    moreLabel: {},
    slideOverTitle: {},
    isMobile: { type: Boolean }
  }, {
    isOpened: { type: Boolean, type: Boolean, default: !1 },
    isOpenedModifiers: {}
  }),
  emits: ["update:isOpened"],
  setup(n) {
    const e = je(n, "isOpened");
    return (t, r) => {
      const i = Yt("ripple");
      return k(), q(v(Lo), {
        opened: e.value,
        "onUpdate:opened": r[1] || (r[1] = (s) => e.value = s),
        bottom: t.isMobile,
        class: B(["relative [&_header]:!py-4", {
          "!rounded-none": !t.isMobile
        }]),
        closable: "",
        "full-height": "",
        "render-close": !1,
        size: "lg"
      }, {
        head: N(() => [
          E("div", Yb, [
            E("div", {
              class: B(["flex flex-col", {
                "gap-2": !t.isMobile,
                "gap-1": t.isMobile
              }])
            }, [
              A(v(K), {
                class: "!font-extrabold",
                size: v(G).h3
              }, {
                default: N(() => [
                  W(z(t.slideOverTitle), 1)
                ]),
                _: 1
              }, 8, ["size"])
            ], 2),
            nt((k(), T("button", {
              class: B(["flex items-center justify-center ring-brand focus-visible:outline-brand focus-visible:ring", {
                "size-[70px]": !t.isMobile,
                "size-[40px] -translate-y-3 translate-x-4 self-start": t.isMobile
              }]),
              type: "button",
              onClick: r[0] || (r[0] = (s) => e.value = !1)
            }, [
              A(v(Ut), {
                class: B({
                  "text-[33px]": !t.isMobile,
                  "text-[19px]": t.isMobile
                })
              }, null, 8, ["class"])
            ], 2)), [
              [i]
            ])
          ])
        ]),
        default: N(() => [
          v(is)(t.aboutCompanyLong) ? V("", !0) : (k(), q(v(Ln), {
            key: 0,
            content: t.aboutCompanyLong
          }, null, 8, ["content"]))
        ]),
        _: 1
      }, 8, ["opened", "bottom", "class"]);
    };
  }
}), Jb = {
  key: 0,
  class: "grid grid-cols-11 gap-3 lg:gap-4"
}, Zb = {
  key: 1,
  class: "grid grid-cols-3 gap-3 lg:grid-cols-5 lg:gap-4"
}, yp = /* @__PURE__ */ X({
  __name: "GalleryLayout",
  props: {
    itemCount: {},
    wrapperClass: {}
  },
  setup(n) {
    const e = Z(() => Math.min(n.itemCount, 2)), t = Z(
      () => n.itemCount <= 2 ? 0 : Math.min(n.itemCount - 2, 5)
    );
    function r(s) {
      return {
        "h-48 lg:h-64": !0,
        "col-span-11 lg:col-span-6": s === 0,
        "col-span-3 lg:col-span-5": s === 1
      };
    }
    function i(s) {
      return {
        "col-span-1 h-14 lg:h-18": !0,
        "max-lg:hidden": s > 2
      };
    }
    return (s, o) => s.itemCount > 0 ? (k(), T("div", {
      key: 0,
      class: B(s.wrapperClass || "space-y-3 lg:space-y-4")
    }, [
      e.value > 0 ? (k(), T("div", Jb, [
        (k(!0), T(ce, null, $e(e.value, (a) => te(s.$slots, "item", {
          key: a - 1,
          gridClasses: r(a - 1),
          index: a - 1
        })), 128))
      ])) : V("", !0),
      t.value > 0 ? (k(), T("div", Zb, [
        (k(!0), T(ce, null, $e(t.value, (a) => te(s.$slots, "item", {
          key: a + 1,
          gridClasses: i(a - 1),
          index: a + 1
        })), 128))
      ])) : V("", !0),
      te(s.$slots, "hidden")
    ], 2)) : V("", !0);
  }
}), lc = /* @__PURE__ */ X({
  __name: "GalleryMoreItemsOverlay",
  props: {
    remainingCount: {},
    isMobile: { type: Boolean, default: !1 }
  },
  setup(n) {
    function e(t) {
      return `+${t} ${t >= 4 ? "fotografií" : "fotografie"}`;
    }
    return (t, r) => (k(), T("div", {
      class: B(["absolute inset-0 flex items-center justify-center rounded-xl bg-black/40 p-3 text-white", { "lg:hidden": t.isMobile }])
    }, [
      A(v(K), {
        class: "text-center !font-medium",
        size: v(G).xs
      }, {
        default: N(() => [
          W(z(e(t.remainingCount)), 1)
        ]),
        _: 1
      }, 8, ["size"])
    ], 2));
  }
}), Xb = ["data-pswp-height", "data-pswp-type", "data-pswp-width", "data-video-src", "href"], Qb = ["alt", "height", "src", "width"], ey = ["height", "src", "width"], ty = {
  key: 2,
  class: "absolute inset-0 flex items-center justify-center rounded-xl bg-black/20"
}, ny = {
  key: 4,
  class: "pswp-caption-content"
}, ry = { class: "hidden" }, iy = ["data-pswp-height", "data-pswp-type", "data-pswp-width", "data-video-src", "href"], sy = {
  key: 0,
  class: "pswp-caption-content"
}, sA = /* @__PURE__ */ X({
  __name: "Gallery",
  props: {
    images: {},
    lightboxOptions: {},
    wrapperClass: {},
    showPreviewCaptions: { type: Boolean, default: !1 }
  },
  setup(n) {
    function e(l) {
      return {
        "max-lg:hidden": l > 0,
        "lg:hidden": l > 1
      };
    }
    function t(l) {
      return l === 4 && n.images.length > 5;
    }
    function r(l) {
      return l === 6 && n.images.length > 7;
    }
    const i = _i(null), s = _i(null), o = so("galleryLayout");
    function a() {
      var l;
      (l = o.value) != null && l.$el && (i.value && (i.value.destroy(), i.value = null), i.value = new mp({
        gallery: o.value.$el,
        children: "a",
        showHideAnimationType: "fade",
        pswpModule: () => import("./photoswipe.esm-CSQI2Ds4.js"),
        paddingFn: (u) => ({
          top: 20,
          bottom: 30,
          left: 0,
          right: 0
        }),
        ...n.lightboxOptions
      }), s.value = new gp(i.value, {
        captionContent: ".pswp-caption-content",
        type: "below"
      }), i.value.on("contentLoad", (u) => {
        const { content: d } = u;
        if (d.data.type === "video") {
          u.preventDefault();
          const c = document.createElement("video");
          c.controls = !0, c.autoplay = !1, c.style.maxWidth = "100%", c.style.maxHeight = "100%", c.src = d.data.videoSrc || d.data.element.dataset.videoSrc, d.element = c;
        }
      }), i.value.init());
    }
    return Dt(() => {
      a();
    }), P2(() => {
      i.value && (i.value.destroy(), i.value = null);
    }), Ie(
      () => n.lightboxOptions,
      (l, u) => {
        fr(l, u) || a();
      }
    ), (l, u) => l.images.length > 0 ? (k(), q(yp, {
      key: 0,
      ref_key: "galleryLayout",
      ref: o,
      "item-count": l.images.length,
      "wrapper-class": l.wrapperClass
    }, vs({
      item: N(({ index: d, gridClasses: c }) => [
        te(l.$slots, "thumbnail", {
          image: l.images[d],
          index: d
        }, () => [
          E("a", {
            class: B(["relative", c]),
            "data-pswp-height": l.images[d].height,
            "data-pswp-type": l.images[d].type ?? "image",
            "data-pswp-width": l.images[d].width,
            "data-video-src": l.images[d].type === "video" ? l.images[d].url : void 0,
            href: l.images[d].url,
            rel: "noreferrer",
            target: "_blank"
          }, [
            l.images[d].type !== "video" ? (k(), T("img", {
              key: 0,
              alt: l.images[d].alt || "",
              class: "size-full rounded-xl object-cover object-center",
              height: l.images[d].height,
              loading: "lazy",
              src: l.images[d].thumbnail || l.images[d].url,
              width: l.images[d].width
            }, null, 8, Qb)) : V("", !0),
            l.images[d].type === "video" ? (k(), T("video", {
              key: 1,
              class: "pointer-events-none size-full rounded-xl object-cover object-center",
              height: l.images[d].height,
              src: l.images[d].url,
              width: l.images[d].width
            }, null, 8, ey)) : V("", !0),
            l.images[d].type === "video" ? (k(), T("div", ty, u[0] || (u[0] = [
              E("div", { class: "rounded-full bg-orange p-3" }, [
                E("svg", {
                  class: "size-6 text-white",
                  fill: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  E("path", { d: "M8 5v14l11-7z" })
                ])
              ], -1)
            ]))) : V("", !0),
            l.images[d].caption && l.showPreviewCaptions ? (k(), T("div", {
              key: 3,
              class: B(["absolute inset-x-0 bottom-0 rounded-b-xl bg-image-caption-gradient p-4 pb-3 pt-8 text-white", e(d)])
            }, [
              A(v(K), {
                class: "text-balance !font-medium",
                size: v(G).sm
              }, {
                default: N(() => [
                  W(z(l.images[d].caption), 1)
                ]),
                _: 2
              }, 1032, ["size"])
            ], 2)) : V("", !0),
            l.images[d].caption ? (k(), T("div", ny, [
              A(v(K), {
                class: "text-balance !font-medium",
                size: v(G).sm
              }, {
                default: N(() => [
                  W(z(l.images[d].caption), 1)
                ]),
                _: 2
              }, 1032, ["size"])
            ])) : V("", !0),
            t(d) ? (k(), q(lc, {
              key: 5,
              "is-mobile": "",
              "remaining-count": l.images.length - 5
            }, null, 8, ["remaining-count"])) : V("", !0),
            r(d) ? (k(), q(lc, {
              key: 6,
              "remaining-count": l.images.length - 7
            }, null, 8, ["remaining-count"])) : V("", !0)
          ], 10, Xb)
        ])
      ]),
      _: 2
    }, [
      l.images.length > 7 ? {
        name: "hidden",
        fn: N(() => [
          E("div", ry, [
            (k(!0), T(ce, null, $e(l.images.slice(7), (d, c) => (k(), T("a", {
              key: `hidden-${c + 7}`,
              "data-pswp-height": d.height,
              "data-pswp-type": d.type ?? "image",
              "data-pswp-width": d.width,
              "data-video-src": d.type === "video" ? d.url : void 0,
              href: d.url,
              rel: "noreferrer",
              target: "_blank"
            }, [
              d.caption ? (k(), T("div", sy, [
                A(v(K), {
                  class: "text-balance !font-medium",
                  size: v(G).sm
                }, {
                  default: N(() => [
                    W(z(d.caption), 1)
                  ]),
                  _: 2
                }, 1032, ["size"])
              ])) : V("", !0)
            ], 8, iy))), 128))
          ])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["item-count", "wrapper-class"])) : V("", !0);
  }
}), oA = /* @__PURE__ */ X({
  __name: "GalleryLoader",
  props: {
    count: {},
    wrapperClass: {}
  },
  setup(n) {
    return (e, t) => e.count && e.count > 0 ? (k(), q(yp, {
      key: 0,
      "item-count": e.count,
      "wrapper-class": e.wrapperClass
    }, {
      item: N(({ gridClasses: r }) => [
        E("div", {
          class: B(["relative", r])
        }, t[0] || (t[0] = [
          E("div", { class: "size-full rounded-xl bg-stroke-gray object-cover object-center" }, null, -1)
        ]), 2)
      ]),
      _: 1
    }, 8, ["item-count", "wrapper-class"])) : V("", !0);
  }
}), oy = { class: "space-y-3 text-[13px]" }, ay = { class: "flex items-center gap-x-3" }, ly = { class: "flex gap-x-3" }, uy = { class: "flex gap-x-3" }, uc = /* @__PURE__ */ X({
  __name: "Clarification",
  props: {
    rating: {}
  },
  setup(n) {
    return (e, t) => (k(), T("div", oy, [
      E("div", ay, [
        A(Xi, {
          big: "",
          class: "h-[33px] w-[46px]",
          rating: e.rating
        }, null, 8, ["rating"]),
        A(K, null, {
          default: N(() => t[0] || (t[0] = [
            W(" Rating ")
          ])),
          _: 1
        })
      ]),
      A(K, {
        class: "flex flex-col gap-y-3",
        size: v(G).sm,
        "tag-name": "div"
      }, {
        default: N(() => [
          t[3] || (t[3] = E("div", null, [
            E("span", { class: "font-semibold" }, "Rating vyjadřuje míru rizika projektu"),
            W(" na základě komplexní analýzy emitenta, jeho finanční situace a minulých výsledků, podnikatelské historie a reputace a zajištění projektu. ")
          ], -1)),
          t[4] || (t[4] = E("div", null, [
            W(" Uděluje se na škále "),
            E("span", { class: "font-semibold" }, "od A++ do E"),
            W(", kde ")
          ], -1)),
          E("div", ly, [
            A(Xi, { rating: "A++" }),
            t[1] || (t[1] = E("span", { class: "block" }, [
              W(" značí "),
              E("span", { class: "font-semibold" }, "nejnižší míru rizika")
            ], -1))
          ]),
          E("div", uy, [
            A(Xi, { rating: "E" }),
            t[2] || (t[2] = E("span", { class: "block" }, [
              W(" značí "),
              E("span", { class: "font-semibold" }, "nejvyšší míru rizika")
            ], -1))
          ])
        ]),
        _: 1
      }, 8, ["size"])
    ]));
  }
}), dy = { key: 0 }, cy = { class: "mt-5 flex gap-x-4" }, fy = ["src"], dc = /* @__PURE__ */ X({
  __name: "Comment",
  props: {
    commentText: {},
    expertImageSrc: {},
    hintText: {}
  },
  setup(n) {
    return (e, t) => e.commentText ? (k(), T("div", dy, [
      A(ap, { class: "!mx-0 !my-5" }),
      A(K, {
        class: "!font-semibold",
        size: v(G).sm
      }, {
        default: N(() => t[0] || (t[0] = [
          W(" Co říká náš expert ")
        ])),
        _: 1
      }, 8, ["size"]),
      A(K, {
        size: v(G).sm,
        "tag-name": "p"
      }, {
        default: N(() => [
          W(z(e.commentText), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      E("div", cy, [
        E("img", {
          class: "size-[46px] shrink-0 rounded-full object-cover",
          src: e.expertImageSrc
        }, null, 8, fy),
        A(K, {
          class: "flex flex-col",
          size: v(G).sm
        }, {
          default: N(() => t[1] || (t[1] = [
            E("span", { class: "font-semibold" }, "Martin Měřička", -1),
            E("span", { class: "text-[13px] font-medium text-secondary" }, "Senior finanční analytik", -1)
          ])),
          _: 1
        }, 8, ["size"])
      ])
    ])) : V("", !0);
  }
}), py = { class: "flex cursor-help items-center gap-x-3" }, hy = { class: "flex flex-col gap-y-2" }, my = { class: "relative flex h-full flex-col px-5" }, gy = { class: "sticky bottom-0 w-full py-5" }, by = /* @__PURE__ */ X({
  __name: "RatingChip",
  props: {
    buttonLabel: {},
    bottomSheetLabel: {},
    rating: {},
    commentText: {},
    expertImageSrc: {},
    hintText: {},
    issueName: {}
  },
  emits: ["ratingButtonClick"],
  setup(n) {
    const e = ae(!1);
    Dt(() => {
      const { width: r } = g9();
      e.value = r.value <= 1024;
    });
    const t = ae(!1);
    return (r, i) => e.value ? (k(), T(ce, { key: 1 }, [
      E("div", {
        class: "flex cursor-help items-center gap-x-3",
        onClick: i[0] || (i[0] = (s) => t.value = !t.value)
      }, [
        A(Xi, { rating: r.rating }, null, 8, ["rating"]),
        A(K, {
          class: "!font-normal underline decoration-dotted underline-offset-4",
          size: v(G).sm
        }, {
          default: N(() => i[4] || (i[4] = [
            W(" Rating ")
          ])),
          _: 1
        }, 8, ["size"])
      ]),
      A(Sg, {
        opened: t.value,
        "onUpdate:opened": i[2] || (i[2] = (s) => t.value = s),
        "close-button-classes": "rounded-full size-11",
        "disable-bottom-padding": "",
        "disable-main-padding": ""
      }, {
        head: N(() => [
          E("div", hy, [
            A(K, {
              class: "!font-extrabold",
              size: v(G).h3
            }, {
              default: N(() => [
                W(z(r.bottomSheetLabel), 1)
              ]),
              _: 1
            }, 8, ["size"]),
            A(K, {
              class: "!text-[13px] !font-medium text-secondary",
              size: v(G).xs
            }, {
              default: N(() => [
                W(z(r.issueName), 1)
              ]),
              _: 1
            }, 8, ["size"])
          ])
        ]),
        default: N(() => [
          E("div", my, [
            A(uc, {
              class: "pt-5",
              rating: r.rating
            }, null, 8, ["rating"]),
            A(dc, {
              "comment-text": r.commentText,
              "expert-image-src": r.expertImageSrc,
              "hint-text": r.hintText
            }, null, 8, ["comment-text", "expert-image-src", "hint-text"]),
            E("div", gy, [
              A(hr, {
                class: "w-full",
                small: "",
                variant: "orange",
                onClick: i[1] || (i[1] = (s) => {
                  r.$emit("ratingButtonClick"), t.value = !1;
                })
              }, {
                icon: N(() => [
                  A(v(mn), { class: "text-[24px] text-white" })
                ]),
                default: N(() => [
                  W(" " + z(r.buttonLabel), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["opened"])
    ], 64)) : (k(), q(Zi, {
      key: 0,
      "content-width": "max-w-[400px]",
      "hide-icon": ""
    }, {
      trigger: N(() => [
        E("div", py, [
          A(Xi, { rating: r.rating }, null, 8, ["rating"]),
          A(K, {
            class: "!font-normal underline decoration-dotted underline-offset-4",
            size: v(G).sm
          }, {
            default: N(() => i[3] || (i[3] = [
              W(" Rating ")
            ])),
            _: 1
          }, 8, ["size"])
        ])
      ]),
      content: N(() => [
        A(uc, { rating: r.rating }, null, 8, ["rating"]),
        A(dc, {
          "comment-text": r.commentText,
          "expert-image-src": r.expertImageSrc,
          "hint-text": r.hintText
        }, null, 8, ["comment-text", "expert-image-src", "hint-text"])
      ]),
      _: 1
    }));
  }
}), yy = { class: "relative col-span-6" }, vy = { class: "flex items-start justify-between gap-2 lg:mt-4 lg:gap-6" }, _y = { class: "flex shrink-0 flex-col items-end justify-end" }, $y = { class: "mt-5 flex items-center gap-5 overflow-hidden max-lg:justify-between lg:gap-7" }, aA = /* @__PURE__ */ X({
  __name: "Header",
  props: {
    collaterals: {},
    issuesInfo: {},
    progress: {},
    newProjectChip: {},
    name: {},
    tagline: {},
    interestRateFormatted: {},
    isMobile: { type: Boolean },
    tags: {},
    rating: {}
  },
  emits: ["back", "showDetails", "ratingButtonClick"],
  setup(n, { emit: e }) {
    const t = e;
    return (r, i) => (k(), T("div", yy, [
      E("div", vy, [
        A(v(K), {
          class: "relative !font-extrabold",
          size: v(G).h1
        }, {
          default: N(() => [
            W(z(r.name), 1)
          ]),
          _: 1
        }, 8, ["size"]),
        E("div", _y, [
          A(v(K), {
            class: "!font-nunito !font-extrabold text-brand",
            size: v(G).h1
          }, {
            default: N(() => [
              W(z(r.interestRateFormatted) + " ", 1),
              i[2] || (i[2] = E("span", { class: "text-[15px] font-semibold" }, "%", -1))
            ]),
            _: 1
          }, 8, ["size"]),
          i[3] || (i[3] = E("div", { class: "font-poppins text-[12px] text-grey lg:text-[13px]" }, " roční úrok ", -1))
        ])
      ]),
      E("div", $y, [
        A(by, Te(r.rating, {
          "issue-name": r.name,
          onRatingButtonClick: i[0] || (i[0] = (s) => t("ratingButtonClick"))
        }), null, 16, ["issue-name"]),
        A(pp, Te(r.collaterals, {
          "show-details-button": "",
          small: "",
          onShowDetails: i[1] || (i[1] = (s) => r.$emit("showDetails"))
        }), null, 16)
      ]),
      r.tagline ? (k(), q(v(Ln), {
        key: 0,
        class: "mt-5",
        content: r.tagline
      }, null, 8, ["content"])) : V("", !0)
    ]));
  }
}), xy = { class: "relative isolate grid gap-y-2 lg:grid-cols-12 lg:gap-y-16" }, wy = { class: "col-span-7 max-lg:px-5 lg:pt-8" }, ky = { class: "relative z-10 col-span-5 row-span-2 pl-10 max-lg:hidden" }, Cy = { class: "relative isolate col-span-7 pb-8 pt-12 max-lg:px-5 lg:pb-40 lg:pt-14" }, lA = /* @__PURE__ */ X({
  __name: "Layout",
  props: {
    offsetTop: {},
    offsetBottom: {}
  },
  setup(n) {
    return (e, t) => (k(), T("div", xy, [
      E("div", wy, [
        te(e.$slots, "header")
      ]),
      E("div", ky, [
        E("div", {
          class: B(["sticky pt-8", {
            "top-0": !e.offsetTop,
            [e.offsetTop]: e.offsetTop,
            "lg:bottom-40": !e.offsetBottom,
            [e.offsetBottom]: e.offsetBottom
          }])
        }, [
          te(e.$slots, "sidebar")
        ], 2)
      ]),
      E("div", Cy, [
        t[0] || (t[0] = E("div", { class: "absolute inset-0 left-1/2 -z-10 w-screen -translate-x-1/2 bg-white max-lg:hidden lg:left-[calc(85.71428571%)]" }, null, -1)),
        te(e.$slots, "content")
      ])
    ]));
  }
}), uA = /* @__PURE__ */ X({
  __name: "NewProjectChip",
  props: {
    collaterals: {},
    issuesInfo: {},
    progress: {},
    newProjectChip: {},
    name: {},
    tagline: {},
    interestRateFormatted: {},
    isMobile: { type: Boolean },
    tags: {},
    rating: {},
    background: { default: "white" }
  },
  setup(n) {
    return (e, t) => (k(), T("div", {
      class: B(["flex items-center justify-center gap-5 rounded-xl p-3", {
        "border border-grey-50 bg-white": e.background === "white",
        "bg-brand-light": e.background === "brand-light"
      }])
    }, [
      A(v(y1), { class: "relative shrink-0 !rounded !bg-brand text-[13px] text-white [&_span]:!font-medium" }, {
        default: N(() => [
          W(z(e.newProjectChip), 1)
        ]),
        _: 1
      }),
      A(v(K), {
        class: "!font-semibold",
        size: v(G).sm
      }, {
        default: N(() => [
          W(z(e.progress.investorsCountLabel), 1)
        ]),
        _: 1
      }, 8, ["size"])
    ], 2));
  }
}), Sy = { class: "relative flex w-full items-center justify-between" }, dA = /* @__PURE__ */ X({
  __name: "OwnerSheet",
  props: /* @__PURE__ */ Ae({
    desktop: { type: Boolean },
    name: {},
    imageSrc: {},
    ownerData: {},
    ownerDescriptionShort: {},
    ownerDescriptionLong: {},
    moreLabel: {},
    slideOverTitle: {},
    isMobile: { type: Boolean }
  }, {
    isOpened: { type: Boolean, type: Boolean, default: !1 },
    isOpenedModifiers: {}
  }),
  emits: ["update:isOpened"],
  setup(n) {
    const e = je(n, "isOpened");
    return (t, r) => {
      const i = Yt("ripple");
      return k(), q(v(Lo), {
        opened: e.value,
        "onUpdate:opened": r[1] || (r[1] = (s) => e.value = s),
        bottom: t.isMobile,
        class: B(["relative [&_header]:!py-4", {
          "!rounded-none": !t.isMobile
        }]),
        closable: "",
        "full-height": "",
        "render-close": !1,
        size: "lg"
      }, {
        head: N(() => [
          E("div", Sy, [
            E("div", {
              class: B(["flex flex-col", {
                "gap-2": !t.isMobile,
                "gap-1": t.isMobile
              }])
            }, [
              A(v(K), {
                class: "!font-extrabold",
                size: v(G).h3
              }, {
                default: N(() => [
                  W(z(t.slideOverTitle), 1)
                ]),
                _: 1
              }, 8, ["size"])
            ], 2),
            nt((k(), T("button", {
              class: B(["flex items-center justify-center ring-brand focus-visible:outline-brand focus-visible:ring", {
                "size-[70px]": !t.isMobile,
                "size-[40px] -translate-y-3 translate-x-4 self-start": t.isMobile
              }]),
              type: "button",
              onClick: r[0] || (r[0] = (s) => e.value = !1)
            }, [
              A(v(Ut), {
                class: B({
                  "text-[33px]": !t.isMobile,
                  "text-[19px]": t.isMobile
                })
              }, null, 8, ["class"])
            ], 2)), [
              [i]
            ])
          ])
        ]),
        default: N(() => [
          v(is)(t.ownerDescriptionLong) ? V("", !0) : (k(), q(v(Ln), {
            key: 0,
            content: t.ownerDescriptionLong
          }, null, 8, ["content"]))
        ]),
        _: 1
      }, 8, ["opened", "bottom", "class"]);
    };
  }
}), Ey = { class: "flex flex-col gap-y-9 lg:gap-y-12" }, Ty = { class: "flex flex-col" }, Oy = { class: "flex flex-col" }, My = { key: 0 }, Ay = /* @__PURE__ */ X({
  __name: "About",
  props: {
    aboutProjectShort: {},
    aboutProjectLong: {},
    keyStrengths: {},
    moneyUsagePlan: {},
    moneyUsageDetails: {},
    moneyUsagePlanLabel: {},
    moreLabel: {}
  },
  emits: ["openProjectDetail"],
  setup(n) {
    return (e, t) => {
      const r = Yt("ripple");
      return k(), T("div", Ey, [
        E("div", Ty, [
          A(v(K), {
            class: "!font-extrabold",
            size: v(G).h2,
            "tag-name": "h2"
          }, {
            default: N(() => t[1] || (t[1] = [
              W(" O projektu ")
            ])),
            _: 1
          }, 8, ["size"]),
          e.aboutProjectShort ? (k(), q(v(Ln), {
            key: 0,
            class: "mt-4 lg:mt-5",
            content: e.aboutProjectShort
          }, null, 8, ["content"])) : V("", !0),
          e.keyStrengths ? (k(), q(v(Ln), {
            key: 1,
            class: "mt-5 lg:mt-7",
            content: e.keyStrengths
          }, null, 8, ["content"])) : V("", !0)
        ]),
        E("section", Oy, [
          A(v(K), {
            class: "!font-extrabold",
            size: v(G).h3,
            "tag-name": "h3"
          }, {
            default: N(() => [
              W(z(e.moneyUsagePlanLabel), 1)
            ]),
            _: 1
          }, 8, ["size"]),
          e.moneyUsagePlan ? (k(), q(v(Ln), {
            key: 0,
            class: "mt-4 lg:mt-5",
            content: e.moneyUsagePlan
          }, null, 8, ["content"])) : V("", !0),
          e.moneyUsageDetails ? (k(), q(v(Ln), {
            key: 1,
            class: "mt-5 lg:mt-7",
            content: e.moneyUsageDetails
          }, null, 8, ["content"])) : V("", !0)
        ]),
        v(mo)(e.aboutProjectLong) ? V("", !0) : (k(), T("div", My, [
          nt((k(), T("button", {
            class: "font-semibold text-orange underline hover:cursor-pointer",
            onClick: t[0] || (t[0] = (i) => e.$emit("openProjectDetail"))
          }, [
            W(z(e.moreLabel) + " ", 1),
            A(v(mn), { class: "inline-block text-[20px]" })
          ])), [
            [r]
          ])
        ]))
      ]);
    };
  }
}), Ny = { class: "mb-7 flex flex-col gap-y-3" }, Dy = { class: "mb-10 flex w-full flex-col gap-4" }, Ly = { class: "flex items-center gap-4 lg:gap-6" }, Ry = {
  key: 1,
  class: "size-[30px] shrink-0"
}, Py = /* @__PURE__ */ X({
  __name: "Collaterals",
  props: {
    label: {},
    description: {},
    moreLabel: {},
    slideOverTitle: {},
    slideOverSubtitle: {},
    collaterals: {},
    moreTypesLabel: {},
    tooltipButtonLabel: {},
    isMobile: { type: Boolean },
    isPublic: { type: Boolean }
  },
  emits: ["openCalculator", "openCollateralsDetail"],
  setup(n) {
    const e = Z(
      () => n.collaterals.filter(({ type: t }) => t)
    );
    return (t, r) => {
      const i = Yt("ripple");
      return k(), T(ce, null, [
        E("div", Ny, [
          A(v(K), {
            class: "!font-extrabold",
            size: v(G).h2
          }, {
            default: N(() => [
              W(z(t.label), 1)
            ]),
            _: 1
          }, 8, ["size"]),
          A(v(K), {
            class: "text-grey",
            size: v(G).sm
          }, {
            default: N(() => [
              W(z(t.description), 1)
            ]),
            _: 1
          }, 8, ["size"])
        ]),
        E("div", Dy, [
          (k(!0), T(ce, null, $e(e.value, (s) => (k(), T("ul", {
            key: s.type,
            class: "flex items-center gap-5 marker:text-grey-100 lg:gap-7"
          }, [
            E("li", Ly, [
              s.icon ? (k(), q(qe(s.icon), {
                key: 0,
                class: "shrink-0 text-[30px] text-black"
              })) : (k(), T("div", Ry)),
              A(v(K), { class: "!font-semibold" }, {
                default: N(() => [
                  W(z(s.type), 1)
                ]),
                _: 2
              }, 1024)
            ])
          ]))), 128))
        ]),
        E("div", null, [
          nt((k(), T("button", {
            class: "font-semibold text-orange underline hover:cursor-pointer",
            onClick: r[0] || (r[0] = (s) => t.$emit("openCollateralsDetail"))
          }, [
            W(z(t.moreLabel) + " ", 1),
            A(v(mn), { class: "inline-block text-[20px]" })
          ])), [
            [i]
          ])
        ])
      ], 64);
    };
  }
}), Iy = { class: "font-semibold" }, By = { class: "font-semibold" }, zy = { class: "font-semibold" }, Vy = { class: "font-semibold" }, Fy = { class: "font-semibold" }, jy = { class: "font-semibold" }, Hy = { class: "font-semibold" }, Uy = { class: "font-semibold" }, Wy = { class: "font-semibold" }, qy = { class: "font-semibold" }, cA = /* @__PURE__ */ X({
  __name: "Example",
  props: {
    maturityYears: {},
    label: {},
    purchaseIntro: {},
    purchaseBonds: {},
    purchaseTotalValue: {},
    purchaseMaturity: {},
    purchaseYears: {},
    paymentsPeriod: {},
    paymentsToYourAccount: {},
    paymentsAutomatic: {},
    paymentsTaxNote: {},
    maturityAfter: {},
    maturityRepayment: {},
    maturityAutomatic: {},
    profitIntro: {},
    profitYears: {},
    profitTaxNote: {},
    calculateIntro: {},
    calculateRest: {},
    totalInvestmentFormatted: {},
    periodPayoutFormatted: {},
    totalProfitFormatted: {}
  },
  setup(n) {
    return (e, t) => (k(), T(ce, null, [
      A(v(K), {
        class: "!font-extrabold",
        size: v(G).h3
      }, {
        default: N(() => [
          W(z(e.label), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      A(v(K), {
        class: "my-4 text-pretty",
        "tag-name": "div"
      }, {
        default: N(() => [
          E("p", null, [
            W(z(e.purchaseIntro) + " ", 1),
            E("span", Iy, z(e.purchaseBonds), 1),
            W(" " + z(e.purchaseTotalValue) + " ", 1),
            E("span", By, z(e.totalInvestmentFormatted), 1),
            W(" " + z(e.purchaseMaturity) + " ", 1),
            E("span", zy, z(e.maturityYears) + " " + z(e.purchaseYears), 1),
            t[0] || (t[0] = W(". "))
          ]),
          E("p", null, [
            E("span", Vy, z(e.paymentsPeriod), 1),
            W(" " + z(e.paymentsToYourAccount) + " ", 1),
            E("span", Fy, z(e.paymentsAutomatic) + " " + z(e.periodPayoutFormatted), 1),
            W(" " + z(e.paymentsTaxNote), 1)
          ]),
          E("p", null, [
            W(z(e.maturityAfter) + " ", 1),
            E("span", jy, z(e.maturityYears) + " " + z(e.purchaseYears), 1),
            W(" " + z(e.maturityRepayment) + " ", 1),
            E("span", Hy, z(e.maturityAutomatic) + " " + z(e.totalInvestmentFormatted), 1),
            t[1] || (t[1] = W(". "))
          ]),
          E("p", null, [
            E("span", Uy, z(e.profitIntro), 1),
            W(" " + z(e.profitYears) + " ", 1),
            E("span", Wy, z(e.totalProfitFormatted), 1),
            W(" " + z(e.profitTaxNote), 1)
          ]),
          E("p", null, [
            E("span", qy, z(e.calculateIntro), 1),
            W(" " + z(e.calculateRest), 1)
          ])
        ]),
        _: 1
      })
    ], 64));
  }
}), Ky = { class: "mb-2 mt-3 md:my-0" }, fA = /* @__PURE__ */ X({
  __name: "InfoTable",
  props: {
    label: {},
    issuerLabel: {},
    issuerValue: {},
    nameLabel: {},
    nameValue: {},
    issueDateLabel: {},
    issueDateValue: {},
    maturityDateLabel: {},
    maturityDateValue: {},
    nominalValueLabel: {},
    nominalValueValue: {},
    interestRateLabel: {},
    interestRateValue: {},
    returnsPeriodicityLabel: {},
    returnsPeriodicityValue: {},
    bondResemblanceLabel: {},
    bondResemblanceValue: {},
    bondFormLabel: {},
    bondFormValue: {},
    totalAmountLabel: {},
    totalAmountValue: {},
    investedAmountLabel: {},
    investedAmountValue: {},
    isinLabel: {},
    isinValue: {}
  },
  setup(n) {
    const e = Z(() => [
      { keyName: "key", text: "", width: "50%" },
      // Headers are not displayed
      { keyName: "value", text: "", width: "50%", align: Qt.right }
      // Headers are not displayed
    ]), t = Z(() => ({
      headers: e.value,
      data: [
        {
          key: n.issuerLabel,
          value: n.issuerValue || "-"
        },
        {
          key: n.nameLabel,
          value: n.nameValue || "-"
        },
        {
          key: n.issueDateLabel,
          value: n.issueDateValue || "-"
        },
        {
          key: n.maturityDateLabel,
          value: n.maturityDateValue || "-"
        },
        {
          key: n.nominalValueLabel,
          value: n.nominalValueValue || "-"
        },
        {
          key: n.interestRateLabel,
          value: n.interestRateValue || "-"
        },
        {
          key: n.returnsPeriodicityLabel,
          value: n.returnsPeriodicityValue || "-"
        },
        {
          key: n.bondResemblanceLabel,
          value: n.bondResemblanceValue || "-"
        },
        {
          key: n.bondFormLabel,
          value: n.bondFormValue || "-"
        },
        {
          key: n.totalAmountLabel,
          value: n.totalAmountValue || "-"
        },
        {
          key: n.investedAmountLabel,
          value: n.investedAmountValue || "-"
        },
        {
          key: n.isinLabel,
          value: n.isinValue || "-"
        }
      ]
    }));
    return (r, i) => (k(), T(ce, null, [
      A(v(K), {
        class: "!font-extrabold",
        size: v(G).h3
      }, {
        default: N(() => [
          W(z(r.label), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      A(v(w1), {
        class: "mb-2 lg:mb-0 [&_tr]:border-stroke-gray",
        "data-sources": t.value,
        "disable-sticky-head": "",
        fixed: "",
        "flat-firts-cell": "",
        "hide-header": ""
      }, {
        "body:key": N(({ item: { key: s } }) => [
          E("div", Ky, [
            A(v(K), {
              class: "max-w-full",
              size: v(G).sm
            }, {
              default: N(() => [
                W(z(s), 1)
              ]),
              _: 2
            }, 1032, ["size"])
          ])
        ]),
        "body:value": N(({ item: { value: s } }) => [
          A(v(K), {
            class: "!font-semibold",
            size: v(G).sm
          }, {
            default: N(() => [
              W(z(s), 1)
            ]),
            _: 2
          }, 1032, ["size"])
        ]),
        _: 1
      }, 8, ["data-sources"])
    ], 64));
  }
}), Gy = ["src"], pA = /* @__PURE__ */ X({
  __name: "Motivation",
  props: {
    label: {},
    reasonsToInvest: {},
    reasonsToInvestRichText: {}
  },
  setup(n) {
    return (e, t) => (k(), T("div", null, [
      A(v(K), {
        class: "!font-extrabold",
        size: v(G).h3
      }, {
        default: N(() => [
          W(z(e.label), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      E("ul", null, [
        e.reasonsToInvestRichText ? (k(!0), T(ce, { key: 0 }, $e(e.reasonsToInvestRichText, (r, i) => (k(), T("li", {
          key: i,
          class: "mt-4 flex gap-3 first:mt-6"
        }, [
          r.iconName ? (k(), q(qe(v(xb)[r.iconName]), {
            key: 0,
            class: "text-2xl aspect-square h-6 object-cover object-center"
          })) : V("", !0),
          E("div", {
            class: B({ "ml-9": !r.iconName })
          }, [
            A(v(K), {
              class: "!font-semibold",
              size: v(G).md
            }, {
              default: N(() => [
                W(z(r.title), 1)
              ]),
              _: 2
            }, 1032, ["size"]),
            r.description ? (k(), q(v(Ln), {
              key: 0,
              class: "mt-1",
              content: r.description
            }, null, 8, ["content"])) : V("", !0)
          ], 2)
        ]))), 128)) : e.reasonsToInvest ? (k(!0), T(ce, { key: 1 }, $e(e.reasonsToInvest, (r, i) => (k(), T("li", {
          key: i,
          class: "mt-4 flex gap-3 first:mt-6"
        }, [
          r.iconUrl ? (k(), T("img", {
            key: 0,
            class: "aspect-square h-6 object-cover object-center",
            src: r.iconUrl
          }, null, 8, Gy)) : V("", !0),
          E("div", {
            class: B({ "ml-9": !r.iconUrl })
          }, [
            A(v(K), {
              class: "!font-semibold",
              size: v(G).md
            }, {
              default: N(() => [
                W(z(r.title), 1)
              ]),
              _: 2
            }, 1032, ["size"]),
            r.description ? (k(), q(v(K), {
              key: 0,
              class: "prose mt-1 !font-light",
              html: r.description,
              size: v(G).md,
              "tag-name": "div"
            }, null, 8, ["html", "size"])) : V("", !0)
          ], 2)
        ]))), 128)) : V("", !0)
      ])
    ]));
  }
}), hA = /* @__PURE__ */ X({
  __name: "Project",
  props: {
    video: {},
    motivation: {},
    infoTable: {},
    example: {},
    collaterals: {},
    about: {},
    periodicityFraction: {},
    hideExample: { type: Boolean }
  },
  emits: ["openCalculator", "openCollateralsDetail", "openProjectDetail"],
  setup(n) {
    return (e, t) => (k(), T(ce, null, [
      A(Ay, Te(e.about, {
        onOpenProjectDetail: t[0] || (t[0] = (r) => e.$emit("openProjectDetail"))
      }), null, 16),
      A(v(ap), {
        class: "!my-10 lg:!my-16",
        "negative-margin": !1,
        size: 1
      }),
      A(Py, Te(e.collaterals, {
        onOpenCalculator: t[1] || (t[1] = (r) => e.$emit("openCalculator")),
        onOpenCollateralsDetail: t[2] || (t[2] = (r) => e.$emit("openCollateralsDetail"))
      }), null, 16)
    ], 64));
  }
}), Yy = { class: "relative flex w-full items-center justify-between" }, mA = /* @__PURE__ */ X({
  __name: "Sheet",
  props: /* @__PURE__ */ Ae({
    aboutProjectShort: {},
    aboutProjectLong: {},
    keyStrengths: {},
    moneyUsagePlan: {},
    moneyUsageDetails: {},
    moneyUsagePlanLabel: {},
    moreLabel: {},
    slideOverTitle: {},
    isMobile: { type: Boolean }
  }, {
    isOpened: { type: Boolean, type: Boolean, default: !1 },
    isOpenedModifiers: {}
  }),
  emits: ["update:isOpened"],
  setup(n) {
    const e = je(n, "isOpened");
    return (t, r) => {
      const i = Yt("ripple");
      return k(), q(v(Lo), {
        opened: e.value,
        "onUpdate:opened": r[1] || (r[1] = (s) => e.value = s),
        bottom: t.isMobile,
        class: B(["relative [&_header]:!py-4", {
          "!rounded-none": !t.isMobile
        }]),
        closable: "",
        "full-height": "",
        "render-close": !1,
        size: "lg"
      }, {
        head: N(() => [
          E("div", Yy, [
            E("div", {
              class: B(["flex flex-col", {
                "gap-2": !t.isMobile,
                "gap-1": t.isMobile
              }])
            }, [
              A(v(K), {
                class: "!font-extrabold",
                size: v(G).h3
              }, {
                default: N(() => [
                  W(z(t.slideOverTitle), 1)
                ]),
                _: 1
              }, 8, ["size"])
            ], 2),
            nt((k(), T("button", {
              class: B(["flex items-center justify-center ring-brand focus-visible:outline-brand focus-visible:ring", {
                "size-[70px]": !t.isMobile,
                "size-[40px] -translate-y-3 translate-x-4 self-start": t.isMobile
              }]),
              type: "button",
              onClick: r[0] || (r[0] = (s) => e.value = !1)
            }, [
              A(v(Ut), {
                class: B({
                  "text-[33px]": !t.isMobile,
                  "text-[19px]": t.isMobile
                })
              }, null, 8, ["class"])
            ], 2)), [
              [i]
            ])
          ])
        ]),
        default: N(() => [
          v(is)(t.aboutProjectLong) ? V("", !0) : (k(), q(v(Ln), {
            key: 0,
            content: t.aboutProjectLong
          }, null, 8, ["content"]))
        ]),
        _: 1
      }, 8, ["opened", "bottom", "class"]);
    };
  }
}), Jy = { class: "mx-[-20px] pt-5 lg:mx-0 lg:pt-7" }, Zy = { class: "hide-scrollbar flex w-full snap-x snap-mandatory scroll-pl-5 items-stretch gap-4 overflow-x-auto lg:snap-none" }, gA = /* @__PURE__ */ X({
  __name: "VerifiedCards",
  setup(n) {
    const e = [
      {
        title: "Ověřujeme",
        icon: F2,
        description: "Projekt prošel důkladnou analýzou rizik podle metodiky schválené ČNB."
      },
      {
        title: "Vybíráme",
        icon: s9,
        description: "Na platformu se dostanou jen projekty, které splňují přísná kritéria."
      },
      {
        title: "Kontrolujeme",
        icon: j2,
        description: "Kontrolujeme plnění závazků po celou dobu investice."
      }
    ];
    return (t, r) => (k(), T("div", null, [
      A(v(K), {
        class: "!font-extrabold",
        size: v(G).h3
      }, {
        default: N(() => r[0] || (r[0] = [
          W(" Ověřený projekt od Dluhopisomatu ")
        ])),
        _: 1
      }, 8, ["size"]),
      E("div", Jy, [
        E("div", Zy, [
          r[1] || (r[1] = E("div", { class: "shrink-0 snap-start lg:hidden" }, [
            E("div", { class: "w-1 shrink-0" })
          ], -1)),
          (k(), T(ce, null, $e(e, (i, s) => E("div", {
            key: s,
            class: B(["flex w-[210px] shrink-0 snap-center flex-col rounded-3xl bg-[#F0F6F5] p-5", {
              "max-md:rounded-tr": s === e.length - 1,
              "max-md:rounded-tl": s === 0
            }])
          }, [
            (k(), q(qe(i.icon), { class: "shrink-0 text-[24px] text-brand" })),
            A(v(K), {
              class: "font-poppins mt-3 !font-semibold",
              size: v(G).subtitle
            }, {
              default: N(() => [
                W(z(i.title), 1)
              ]),
              _: 2
            }, 1032, ["size"]),
            A(v(K), {
              class: "mt-1",
              size: v(G).sm
            }, {
              default: N(() => [
                W(z(i.description), 1)
              ]),
              _: 2
            }, 1032, ["size"])
          ], 2)), 64)),
          r[2] || (r[2] = E("div", { class: "shrink-0 snap-start lg:hidden" }, [
            E("div", { class: "w-6 shrink-0" })
          ], -1))
        ])
      ])
    ]));
  }
}), Xy = {
  key: 0,
  class: "flex flex-col items-center gap-4"
}, Qy = ["src"], ev = ["src"], bA = /* @__PURE__ */ X({
  __name: "Video",
  props: {
    youtubeUrl: {},
    videoUrl: {},
    videoCaptionLabel: {}
  },
  setup(n) {
    return (e, t) => {
      const r = Yt("ripple");
      return e.youtubeUrl || e.videoUrl ? (k(), T("div", Xy, [
        e.videoUrl ? nt((k(), T("video", {
          key: 0,
          class: "w-full rounded-xl",
          controls: "",
          playsinline: "",
          preload: "metadata",
          src: e.videoUrl
        }, null, 8, Qy)), [
          [r]
        ]) : e.youtubeUrl ? nt((k(), T("iframe", {
          key: 1,
          allow: "accelerometer; autoplay; encrypted-media; picture-in-picture",
          class: "aspect-video w-full rounded-xl",
          loading: "lazy",
          referrerpolicy: "no-referrer-when-downgrade",
          sandbox: "allow-same-origin allow-scripts",
          src: e.youtubeUrl
        }, null, 8, ev)), [
          [r]
        ]) : V("", !0),
        A(v(K), {
          class: "text-grey",
          size: v(G).sm
        }, {
          default: N(() => [
            W(z(e.videoCaptionLabel), 1)
          ]),
          _: 1
        }, 8, ["size"])
      ])) : V("", !0);
    };
  }
});
function vp(n) {
  var e, t, r = "";
  if (typeof n == "string" || typeof n == "number") r += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var i = n.length;
    for (e = 0; e < i; e++) n[e] && (t = vp(n[e])) && (r && (r += " "), r += t);
  } else for (t in n) n[t] && (r && (r += " "), r += t);
  return r;
}
function _p() {
  for (var n, e, t = 0, r = "", i = arguments.length; t < i; t++) (n = arguments[t]) && (e = vp(n)) && (r && (r += " "), r += e);
  return r;
}
var tv = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function $p(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var xp = { exports: {} };
(function(n, e) {
  (function(t, r) {
    n.exports = r();
  })(tv, function() {
    var t = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, i = /\d/, s = /\d\d/, o = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, l = {}, u = function(g) {
      return (g = +g) + (g > 68 ? 1900 : 2e3);
    }, d = function(g) {
      return function(m) {
        this[g] = +m;
      };
    }, c = [/[+-]\d\d:?(\d\d)?|Z/, function(g) {
      (this.zone || (this.zone = {})).offset = function(m) {
        if (!m || m === "Z") return 0;
        var $ = m.match(/([+-]|\d\d)/g), w = 60 * $[1] + (+$[2] || 0);
        return w === 0 ? 0 : $[0] === "+" ? -w : w;
      }(g);
    }], f = function(g) {
      var m = l[g];
      return m && (m.indexOf ? m : m.s.concat(m.f));
    }, p = function(g, m) {
      var $, w = l.meridiem;
      if (w) {
        for (var _ = 1; _ <= 24; _ += 1) if (g.indexOf(w(_, 0, m)) > -1) {
          $ = _ > 12;
          break;
        }
      } else $ = g === (m ? "pm" : "PM");
      return $;
    }, h = { A: [a, function(g) {
      this.afternoon = p(g, !1);
    }], a: [a, function(g) {
      this.afternoon = p(g, !0);
    }], Q: [i, function(g) {
      this.month = 3 * (g - 1) + 1;
    }], S: [i, function(g) {
      this.milliseconds = 100 * +g;
    }], SS: [s, function(g) {
      this.milliseconds = 10 * +g;
    }], SSS: [/\d{3}/, function(g) {
      this.milliseconds = +g;
    }], s: [o, d("seconds")], ss: [o, d("seconds")], m: [o, d("minutes")], mm: [o, d("minutes")], H: [o, d("hours")], h: [o, d("hours")], HH: [o, d("hours")], hh: [o, d("hours")], D: [o, d("day")], DD: [s, d("day")], Do: [a, function(g) {
      var m = l.ordinal, $ = g.match(/\d+/);
      if (this.day = $[0], m) for (var w = 1; w <= 31; w += 1) m(w).replace(/\[|\]/g, "") === g && (this.day = w);
    }], w: [o, d("week")], ww: [s, d("week")], M: [o, d("month")], MM: [s, d("month")], MMM: [a, function(g) {
      var m = f("months"), $ = (f("monthsShort") || m.map(function(w) {
        return w.slice(0, 3);
      })).indexOf(g) + 1;
      if ($ < 1) throw new Error();
      this.month = $ % 12 || $;
    }], MMMM: [a, function(g) {
      var m = f("months").indexOf(g) + 1;
      if (m < 1) throw new Error();
      this.month = m % 12 || m;
    }], Y: [/[+-]?\d+/, d("year")], YY: [s, function(g) {
      this.year = u(g);
    }], YYYY: [/\d{4}/, d("year")], Z: c, ZZ: c };
    function y(g) {
      var m, $;
      m = g, $ = l && l.formats;
      for (var w = (g = m.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(x, M, D) {
        var j = D && D.toUpperCase();
        return M || $[D] || t[D] || $[j].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(U, J, ne) {
          return J || ne.slice(1);
        });
      })).match(r), _ = w.length, L = 0; L < _; L += 1) {
        var S = w[L], R = h[S], O = R && R[0], I = R && R[1];
        w[L] = I ? { regex: O, parser: I } : S.replace(/^\[|\]$/g, "");
      }
      return function(x) {
        for (var M = {}, D = 0, j = 0; D < _; D += 1) {
          var U = w[D];
          if (typeof U == "string") j += U.length;
          else {
            var J = U.regex, ne = U.parser, Y = x.slice(j), oe = J.exec(Y)[0];
            ne.call(M, oe), x = x.replace(oe, "");
          }
        }
        return function(le) {
          var ge = le.afternoon;
          if (ge !== void 0) {
            var he = le.hours;
            ge ? he < 12 && (le.hours += 12) : he === 12 && (le.hours = 0), delete le.afternoon;
          }
        }(M), M;
      };
    }
    return function(g, m, $) {
      $.p.customParseFormat = !0, g && g.parseTwoDigitYear && (u = g.parseTwoDigitYear);
      var w = m.prototype, _ = w.parse;
      w.parse = function(L) {
        var S = L.date, R = L.utc, O = L.args;
        this.$u = R;
        var I = O[1];
        if (typeof I == "string") {
          var x = O[2] === !0, M = O[3] === !0, D = x || M, j = O[2];
          M && (j = O[2]), l = this.$locale(), !x && j && (l = $.Ls[j]), this.$d = function(Y, oe, le, ge) {
            try {
              if (["x", "X"].indexOf(oe) > -1) return new Date((oe === "X" ? 1e3 : 1) * Y);
              var he = y(oe)(Y), _e = he.year, ue = he.month, xe = he.day, Le = he.hours, be = he.minutes, He = he.seconds, Re = he.milliseconds, rt = he.zone, ze = he.week, Pe = /* @__PURE__ */ new Date(), fe = xe || (_e || ue ? 1 : Pe.getDate()), we = _e || Pe.getFullYear(), Be = 0;
              _e && !ue || (Be = ue > 0 ? ue - 1 : Pe.getMonth());
              var Fe, Xe = Le || 0, ot = be || 0, ct = He || 0, ft = Re || 0;
              return rt ? new Date(Date.UTC(we, Be, fe, Xe, ot, ct, ft + 60 * rt.offset * 1e3)) : le ? new Date(Date.UTC(we, Be, fe, Xe, ot, ct, ft)) : (Fe = new Date(we, Be, fe, Xe, ot, ct, ft), ze && (Fe = ge(Fe).week(ze).toDate()), Fe);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(S, I, R, $), this.init(), j && j !== !0 && (this.$L = this.locale(j).$L), D && S != this.format(I) && (this.$d = /* @__PURE__ */ new Date("")), l = {};
        } else if (I instanceof Array) for (var U = I.length, J = 1; J <= U; J += 1) {
          O[1] = I[J - 1];
          var ne = $.apply(this, O);
          if (ne.isValid()) {
            this.$d = ne.$d, this.$L = ne.$L, this.init();
            break;
          }
          J === U && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else _.call(this, L);
      };
    };
  });
})(xp);
var nv = xp.exports;
const rv = /* @__PURE__ */ $p(nv), k1 = "-", iv = (n) => {
  const e = ov(n), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: r
  } = n;
  return {
    getClassGroupId: (o) => {
      const a = o.split(k1);
      return a[0] === "" && a.length !== 1 && a.shift(), wp(a, e) || sv(o);
    },
    getConflictingClassGroupIds: (o, a) => {
      const l = t[o] || [];
      return a && r[o] ? [...l, ...r[o]] : l;
    }
  };
}, wp = (n, e) => {
  var o;
  if (n.length === 0)
    return e.classGroupId;
  const t = n[0], r = e.nextPart.get(t), i = r ? wp(n.slice(1), r) : void 0;
  if (i)
    return i;
  if (e.validators.length === 0)
    return;
  const s = n.join(k1);
  return (o = e.validators.find(({
    validator: a
  }) => a(s))) == null ? void 0 : o.classGroupId;
}, cc = /^\[(.+)\]$/, sv = (n) => {
  if (cc.test(n)) {
    const e = cc.exec(n)[1], t = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}, ov = (n) => {
  const {
    theme: e,
    prefix: t
  } = n, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return lv(Object.entries(n.classGroups), t).forEach(([s, o]) => {
    hd(o, r, s, e);
  }), r;
}, hd = (n, e, t, r) => {
  n.forEach((i) => {
    if (typeof i == "string") {
      const s = i === "" ? e : fc(e, i);
      s.classGroupId = t;
      return;
    }
    if (typeof i == "function") {
      if (av(i)) {
        hd(i(r), e, t, r);
        return;
      }
      e.validators.push({
        validator: i,
        classGroupId: t
      });
      return;
    }
    Object.entries(i).forEach(([s, o]) => {
      hd(o, fc(e, s), t, r);
    });
  });
}, fc = (n, e) => {
  let t = n;
  return e.split(k1).forEach((r) => {
    t.nextPart.has(r) || t.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(r);
  }), t;
}, av = (n) => n.isThemeGetter, lv = (n, e) => e ? n.map(([t, r]) => {
  const i = r.map((s) => typeof s == "string" ? e + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(([o, a]) => [e + o, a])) : s);
  return [t, i];
}) : n, uv = (n) => {
  if (n < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const i = (s, o) => {
    t.set(s, o), e++, e > n && (e = 0, r = t, t = /* @__PURE__ */ new Map());
  };
  return {
    get(s) {
      let o = t.get(s);
      if (o !== void 0)
        return o;
      if ((o = r.get(s)) !== void 0)
        return i(s, o), o;
    },
    set(s, o) {
      t.has(s) ? t.set(s, o) : i(s, o);
    }
  };
}, kp = "!", dv = (n) => {
  const {
    separator: e,
    experimentalParseClassName: t
  } = n, r = e.length === 1, i = e[0], s = e.length, o = (a) => {
    const l = [];
    let u = 0, d = 0, c;
    for (let g = 0; g < a.length; g++) {
      let m = a[g];
      if (u === 0) {
        if (m === i && (r || a.slice(g, g + s) === e)) {
          l.push(a.slice(d, g)), d = g + s;
          continue;
        }
        if (m === "/") {
          c = g;
          continue;
        }
      }
      m === "[" ? u++ : m === "]" && u--;
    }
    const f = l.length === 0 ? a : a.substring(d), p = f.startsWith(kp), h = p ? f.substring(1) : f, y = c && c > d ? c - d : void 0;
    return {
      modifiers: l,
      hasImportantModifier: p,
      baseClassName: h,
      maybePostfixModifierPosition: y
    };
  };
  return t ? (a) => t({
    className: a,
    parseClassName: o
  }) : o;
}, cv = (n) => {
  if (n.length <= 1)
    return n;
  const e = [];
  let t = [];
  return n.forEach((r) => {
    r[0] === "[" ? (e.push(...t.sort(), r), t = []) : t.push(r);
  }), e.push(...t.sort()), e;
}, fv = (n) => ({
  cache: uv(n.cacheSize),
  parseClassName: dv(n),
  ...iv(n)
}), pv = /\s+/, hv = (n, e) => {
  const {
    parseClassName: t,
    getClassGroupId: r,
    getConflictingClassGroupIds: i
  } = e, s = [], o = n.trim().split(pv);
  let a = "";
  for (let l = o.length - 1; l >= 0; l -= 1) {
    const u = o[l], {
      modifiers: d,
      hasImportantModifier: c,
      baseClassName: f,
      maybePostfixModifierPosition: p
    } = t(u);
    let h = !!p, y = r(h ? f.substring(0, p) : f);
    if (!y) {
      if (!h) {
        a = u + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (y = r(f), !y) {
        a = u + (a.length > 0 ? " " + a : a);
        continue;
      }
      h = !1;
    }
    const g = cv(d).join(":"), m = c ? g + kp : g, $ = m + y;
    if (s.includes($))
      continue;
    s.push($);
    const w = i(y, h);
    for (let _ = 0; _ < w.length; ++_) {
      const L = w[_];
      s.push(m + L);
    }
    a = u + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function mv() {
  let n = 0, e, t, r = "";
  for (; n < arguments.length; )
    (e = arguments[n++]) && (t = Cp(e)) && (r && (r += " "), r += t);
  return r;
}
const Cp = (n) => {
  if (typeof n == "string")
    return n;
  let e, t = "";
  for (let r = 0; r < n.length; r++)
    n[r] && (e = Cp(n[r])) && (t && (t += " "), t += e);
  return t;
};
function gv(n, ...e) {
  let t, r, i, s = o;
  function o(l) {
    const u = e.reduce((d, c) => c(d), n());
    return t = fv(u), r = t.cache.get, i = t.cache.set, s = a, a(l);
  }
  function a(l) {
    const u = r(l);
    if (u)
      return u;
    const d = hv(l, t);
    return i(l, d), d;
  }
  return function() {
    return s(mv.apply(null, arguments));
  };
}
const Je = (n) => {
  const e = (t) => t[n] || [];
  return e.isThemeGetter = !0, e;
}, Sp = /^\[(?:([a-z-]+):)?(.+)\]$/i, bv = /^\d+\/\d+$/, yv = /* @__PURE__ */ new Set(["px", "full", "screen"]), vv = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, _v = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, $v = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, xv = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, wv = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, nr = (n) => Qi(n) || yv.has(n) || bv.test(n), kr = (n) => $s(n, "length", Av), Qi = (n) => !!n && !Number.isNaN(Number(n)), du = (n) => $s(n, "number", Qi), Ts = (n) => !!n && Number.isInteger(Number(n)), kv = (n) => n.endsWith("%") && Qi(n.slice(0, -1)), Ee = (n) => Sp.test(n), Cr = (n) => vv.test(n), Cv = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Sv = (n) => $s(n, Cv, Ep), Ev = (n) => $s(n, "position", Ep), Tv = /* @__PURE__ */ new Set(["image", "url"]), Ov = (n) => $s(n, Tv, Dv), Mv = (n) => $s(n, "", Nv), Os = () => !0, $s = (n, e, t) => {
  const r = Sp.exec(n);
  return r ? r[1] ? typeof e == "string" ? r[1] === e : e.has(r[1]) : t(r[2]) : !1;
}, Av = (n) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  _v.test(n) && !$v.test(n)
), Ep = () => !1, Nv = (n) => xv.test(n), Dv = (n) => wv.test(n), Lv = () => {
  const n = Je("colors"), e = Je("spacing"), t = Je("blur"), r = Je("brightness"), i = Je("borderColor"), s = Je("borderRadius"), o = Je("borderSpacing"), a = Je("borderWidth"), l = Je("contrast"), u = Je("grayscale"), d = Je("hueRotate"), c = Je("invert"), f = Je("gap"), p = Je("gradientColorStops"), h = Je("gradientColorStopPositions"), y = Je("inset"), g = Je("margin"), m = Je("opacity"), $ = Je("padding"), w = Je("saturate"), _ = Je("scale"), L = Je("sepia"), S = Je("skew"), R = Je("space"), O = Je("translate"), I = () => ["auto", "contain", "none"], x = () => ["auto", "hidden", "clip", "visible", "scroll"], M = () => ["auto", Ee, e], D = () => [Ee, e], j = () => ["", nr, kr], U = () => ["auto", Qi, Ee], J = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], ne = () => ["solid", "dashed", "dotted", "double", "none"], Y = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], oe = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], le = () => ["", "0", Ee], ge = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], he = () => [Qi, Ee];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Os],
      spacing: [nr, kr],
      blur: ["none", "", Cr, Ee],
      brightness: he(),
      borderColor: [n],
      borderRadius: ["none", "", "full", Cr, Ee],
      borderSpacing: D(),
      borderWidth: j(),
      contrast: he(),
      grayscale: le(),
      hueRotate: he(),
      invert: le(),
      gap: D(),
      gradientColorStops: [n],
      gradientColorStopPositions: [kv, kr],
      inset: M(),
      margin: M(),
      opacity: he(),
      padding: D(),
      saturate: he(),
      scale: he(),
      sepia: le(),
      skew: he(),
      space: D(),
      translate: D()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Ee]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Cr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": ge()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": ge()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...J(), Ee]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: x()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": x()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": x()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: I()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": I()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": I()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [y]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [y]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [y]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [y]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [y]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [y]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [y]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [y]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [y]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Ts, Ee]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: M()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Ee]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: le()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: le()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Ts, Ee]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Os]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Ts, Ee]
        }, Ee]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": U()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": U()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Os]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Ts, Ee]
        }, Ee]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": U()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": U()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Ee]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Ee]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...oe()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...oe(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...oe(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [$]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [$]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [$]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [$]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [$]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [$]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [$]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [$]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [$]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [R]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [R]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Ee, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Ee, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Ee, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [Cr]
        }, Cr]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Ee, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Ee, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Ee, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Ee, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Cr, kr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", du]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Os]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Ee]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Qi, du]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", nr, Ee]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Ee]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Ee]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [n]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [m]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [n]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [m]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...ne(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", nr, kr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", nr, Ee]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [n]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: D()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Ee]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Ee]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [m]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...J(), Ev]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Sv]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Ov]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [n]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [h]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [m]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...ne(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [m]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: ne()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [i]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...ne()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [nr, Ee]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [nr, kr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [n]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: j()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [n]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [m]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [nr, kr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [n]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Cr, Mv]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Os]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [m]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Y(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Y()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [t]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Cr, Ee]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [c]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [L]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [t]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [c]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [m]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [L]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Ee]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: he()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Ee]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: he()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Ee]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [_]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [_]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [_]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Ts, Ee]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [O]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [O]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [S]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [S]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Ee]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", n]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Ee]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [n]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": D()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": D()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": D()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": D()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": D()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": D()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": D()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": D()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": D()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": D()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": D()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": D()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": D()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": D()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": D()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": D()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": D()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": D()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Ee]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [n, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [nr, kr, du]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [n, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Tp = /* @__PURE__ */ gv(Lv);
var We = /* @__PURE__ */ ((n) => (n.Future = "FUTURE", n.Next = "NEXT", n.Overdue = "OVERDUE", n.Paid = "PAID", n))(We || {});
const md = /* @__PURE__ */ X({
  __name: "ItemIcon",
  props: {
    returnState: {},
    iconSize: {}
  },
  setup(n) {
    const e = n;
    function t(...o) {
      return Tp(_p(o));
    }
    const r = Z(() => {
      switch (e.returnState) {
        case We.Paid:
          return {
            component: n1,
            isFilled: !0
          };
        case We.Overdue:
          return {
            component: Ut,
            isFilled: !0
          };
        case We.Future:
          return {
            component: r1,
            isFilled: !1
          };
        case We.Next:
          return {
            component: H2,
            isFilled: !1,
            class: "text-brand"
          };
        default:
          return {
            component: o9,
            isFilled: !0
          };
      }
    }), i = Z(() => {
      switch (e.returnState) {
        case We.Paid:
          return "bg-success";
        case We.Overdue:
          return "bg-red-200";
        default:
          return "bg-grey-500";
      }
    }), s = Z(() => `${r.value.isFilled ? Number(e.iconSize) - 11 : Number(e.iconSize)}px`);
    return (o, a) => r.value.isFilled ? (k(), T("span", {
      key: 0,
      class: B(t(
        "icon-size p-1.5 flex rounded-full h-min w-fit justify-center ",
        i.value
      ))
    }, [
      (k(), q(qe(r.value.component), {
        class: B(t("text-white", r.value.class)),
        style: mt({
          "--stroke-width": 3,
          fontSize: s.value
        })
      }, null, 8, ["class", "style"]))
    ], 2)) : (k(), q(qe(r.value.component), {
      key: 1,
      class: B(t("icon-size text-secondary", r.value.class)),
      style: mt({
        fontSize: s.value
      })
    }, null, 8, ["class", "style"]));
  }
}), Rv = { class: "flex size-[70px] flex-col items-center justify-center" }, Pv = { class: "flex flex-col gap-y-1" }, Iv = { class: "flex items-start gap-2" }, Op = /* @__PURE__ */ X({
  __name: "Item",
  props: {
    returnPeriod: {},
    returnsPeriodicity: {}
  },
  setup(n) {
    const e = n;
    function t(...o) {
      return Tp(_p(o));
    }
    co.extend(rv);
    function r(o) {
      switch (o) {
        case We.Paid:
          return "text-success";
        case We.Overdue:
          return "text-red";
        case We.Future:
          return "text-grey";
        case We.Next:
          return "text-black";
        default:
          return "text-grey-500";
      }
    }
    function i(o) {
      switch (o) {
        case We.Paid:
          return "bg-success-200 border-success";
        case We.Overdue:
          return "bg-red-light border-red";
        case We.Future:
          return "bg-white border-grey-stroke border-dotted";
        case We.Next:
          return "border-brand bg-brand-light";
        default:
          return "bg-grey-100 border-gray";
      }
    }
    const s = Z(
      () => {
        var o;
        return (o = e.returnPeriod) != null && o.issuePeriod.payoutDate ? co(e.returnPeriod.issuePeriod.payoutDate).format("M/YYYY") : "-";
      }
    );
    return (o, a) => {
      var l;
      return k(), q(v(Zi), {
        class: B(t("py-2 px-1 rounded-xl border", i((l = o.returnPeriod) == null ? void 0 : l.state))),
        "hide-icon": ""
      }, {
        trigger: N(() => {
          var u, d;
          return [
            E("div", Rv, [
              A(md, {
                class: "mb-2",
                "icon-size": 24,
                "return-state": (u = o.returnPeriod) == null ? void 0 : u.state
              }, null, 8, ["return-state"]),
              A(v(K), {
                class: B(t("flex flex-col items-center text-center", r((d = o.returnPeriod) == null ? void 0 : d.state))),
                size: v(G).sm
              }, {
                default: N(() => [
                  W(z(s.value), 1)
                ]),
                _: 1
              }, 8, ["class", "size"])
            ])
          ];
        }),
        content: N(() => {
          var u, d, c, f, p, h;
          return [
            E("div", Pv, [
              E("div", Iv, [
                A(md, {
                  class: "shrink-0",
                  "icon-size": 24,
                  "return-state": (u = o.returnPeriod) == null ? void 0 : u.state
                }, null, 8, ["return-state"]),
                A(v(K), {
                  class: B(t("block !font-highlighted", r((d = o.returnPeriod) == null ? void 0 : d.state)))
                }, {
                  default: N(() => {
                    var y, g;
                    return [
                      W(z((g = (y = o.returnPeriod) == null ? void 0 : y.translations) == null ? void 0 : g.title), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["class"])
              ]),
              A(v(K), {
                class: "block text-grey-400",
                html: (f = (c = o.returnPeriod) == null ? void 0 : c.translations) == null ? void 0 : f.description,
                size: v(G).sm
              }, null, 8, ["html", "size"]),
              A(v(K), {
                class: "block text-grey-400",
                html: (h = (p = o.returnPeriod) == null ? void 0 : p.translations) == null ? void 0 : h.maturityDate,
                size: v(G).sm
              }, null, 8, ["html", "size"])
            ])
          ];
        }),
        _: 1
      }, 8, ["class"]);
    };
  }
}), Bv = { class: "my-4 flex flex-wrap gap-x-4 gap-y-2" }, zv = { key: 0 }, Mp = /* @__PURE__ */ X({
  __name: "Legend",
  props: {
    legends: {},
    items: { default: () => [] }
  },
  setup(n) {
    const e = n, t = Z(() => {
      const i = {
        [We.Paid]: 0,
        [We.Overdue]: 0,
        [We.Next]: 0,
        [We.Future]: 0
      };
      return e.items.forEach((s) => {
        s.state && i[s.state]++;
      }), i;
    }), r = Z(() => {
      var i, s, o, a;
      return [
        {
          label: `${((i = e.legends) == null ? void 0 : i.paid) ?? ""}`,
          icon: F2,
          color: "text-success",
          state: We.Paid,
          count: t.value[We.Paid]
        },
        {
          label: `${((s = e.legends) == null ? void 0 : s.unpaid) ?? ""}`,
          icon: B2,
          color: "text-red-500",
          state: We.Overdue,
          count: t.value[We.Overdue]
        },
        {
          label: `${((o = e.legends) == null ? void 0 : o.pending) ?? ""}`,
          icon: H2,
          color: "text-brand-dark",
          state: We.Next,
          count: t.value[We.Next]
        },
        {
          label: `${((a = e.legends) == null ? void 0 : a.future) ?? ""}`,
          icon: r1,
          color: "text-secondary",
          state: We.Future,
          count: t.value[We.Future]
        }
      ];
    });
    return (i, s) => (k(), T("div", Bv, [
      (k(!0), T(ce, null, $e(r.value, (o, a) => (k(), T("div", {
        key: a,
        class: "inline-flex items-center gap-x-2 text-secondary"
      }, [
        o.label ? (k(), q(md, {
          key: 0,
          class: "flex-initial",
          "icon-size": 20,
          "return-state": o.state
        }, null, 8, ["return-state"])) : V("", !0),
        o.label ? (k(), q(v(K), {
          key: 1,
          class: "whitespace-nowrap",
          size: v(G).xs
        }, {
          default: N(() => [
            W(z(o.label) + " ", 1),
            o.state !== v(We).Next ? (k(), T("span", zv, "(" + z(o.count) + ")", 1)) : V("", !0)
          ]),
          _: 2
        }, 1032, ["size"])) : V("", !0)
      ]))), 128))
    ]));
  }
});
function Ap({ count: n = 0, pastItems: e = 5, futureItems: t = 5, items: r }) {
  const i = Z(() => co());
  return Z(() => {
    const o = r.findIndex(
      ($) => co($.issuePeriod.startDate).isAfter(i.value)
    );
    if (o === -1)
      return [];
    const a = e + t, l = e / a, u = n > 0 ? n : a, d = Math.round(u * l), c = u - d, f = o, p = r.length - o;
    let h = Math.min(f, d), y = Math.min(p, c);
    if (h < d && p > c) {
      const $ = Math.min(
        p - c,
        d - h
      );
      y += $;
    } else if (y < c && f > d) {
      const $ = Math.min(
        f - d,
        c - y
      );
      h += $;
    }
    const g = Math.max(0, o - h), m = Math.min(r.length, o + y);
    return r.slice(g, m);
  });
}
const Vv = { class: "mb-7 flex flex-col gap-y-3 lg:mb-10" }, Fv = { class: "mb-10 flex flex-wrap gap-2" }, yA = /* @__PURE__ */ X({
  name: "CfgIssuesDetailReturns",
  __name: "index",
  props: {
    count: {},
    pastItems: {},
    futureItems: {},
    returnsPeriodicity: {},
    items: {},
    legends: {},
    label: {},
    description: {},
    moreLabel: {},
    isMobile: { type: Boolean },
    slideOverTitle: {},
    slideOverSubtitle: {}
  },
  emits: ["openReturnsDetail"],
  setup(n) {
    const t = Ap(n);
    return (r, i) => {
      const s = Yt("ripple");
      return k(), T(ce, null, [
        E("div", Vv, [
          A(v(K), {
            class: "!font-extrabold",
            size: v(G).h2
          }, {
            default: N(() => [
              W(z(r.label), 1)
            ]),
            _: 1
          }, 8, ["size"]),
          A(v(K), {
            class: "text-grey",
            size: v(G).sm
          }, {
            default: N(() => [
              W(z(r.description), 1)
            ]),
            _: 1
          }, 8, ["size"])
        ]),
        A(Mp, {
          items: r.items,
          legends: r.legends
        }, null, 8, ["items", "legends"]),
        E("div", Fv, [
          (k(!0), T(ce, null, $e(v(t), (o) => (k(), T("div", {
            key: o.issuePeriod.startDate.toISOString(),
            class: "max-w-[77px] flex-none"
          }, [
            A(Op, {
              "return-period": o,
              "returns-periodicity": r.returnsPeriodicity
            }, null, 8, ["return-period", "returns-periodicity"])
          ]))), 128))
        ]),
        E("div", null, [
          nt((k(), T("button", {
            class: "font-semibold text-orange underline hover:cursor-pointer",
            onClick: i[0] || (i[0] = (o) => r.$emit("openReturnsDetail"))
          }, [
            W(z(r.moreLabel) + " ", 1),
            A(v(mn), { class: "inline-block text-[20px]" })
          ])), [
            [s]
          ])
        ])
      ], 64);
    };
  }
}), jv = { class: "relative flex w-full items-center justify-between" }, Hv = { class: "item-stretch flex w-full max-w-[765px] flex-col lg:-mt-2" }, Uv = { class: "flex flex-wrap gap-2" }, vA = /* @__PURE__ */ X({
  name: "CfgIssuesDetailReturnsSheet",
  __name: "Sheet",
  props: /* @__PURE__ */ Ae({
    count: {},
    pastItems: {},
    futureItems: {},
    returnsPeriodicity: {},
    items: {},
    legends: {},
    label: {},
    description: {},
    moreLabel: {},
    isMobile: { type: Boolean },
    slideOverTitle: {},
    slideOverSubtitle: {}
  }, {
    isOpened: { type: Boolean, type: Boolean, default: !1 },
    isOpenedModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["openReturnsDetail"], ["update:isOpened"]),
  setup(n) {
    const t = Ap(n), r = je(n, "isOpened");
    return (i, s) => {
      const o = Yt("ripple");
      return k(), q(v(Lo), {
        opened: r.value,
        "onUpdate:opened": s[1] || (s[1] = (a) => r.value = a),
        bottom: i.isMobile,
        class: B(["relative [&_header]:!py-4", {
          "!rounded-none": !i.isMobile
        }]),
        closable: "",
        "full-height": "",
        "render-close": !1,
        size: "lg"
      }, {
        head: N(() => [
          E("div", jv, [
            E("div", {
              class: B(["flex flex-col", {
                "gap-2": !i.isMobile,
                "gap-1": i.isMobile
              }])
            }, [
              A(v(K), {
                class: "!font-extrabold",
                size: v(G).h3
              }, {
                default: N(() => [
                  W(z(i.slideOverTitle), 1)
                ]),
                _: 1
              }, 8, ["size"]),
              A(v(K), { class: "!text-[13px] !font-medium text-secondary" }, {
                default: N(() => [
                  W(z(i.slideOverSubtitle), 1)
                ]),
                _: 1
              })
            ], 2),
            nt((k(), T("button", {
              class: B(["flex items-center justify-center ring-brand focus-visible:outline-brand focus-visible:ring", {
                "size-[70px]": !i.isMobile,
                "size-[40px] -translate-y-3 translate-x-4 self-start": i.isMobile
              }]),
              type: "button",
              onClick: s[0] || (s[0] = (a) => r.value = !1)
            }, [
              A(v(Ut), {
                class: B({
                  "text-[33px]": !i.isMobile,
                  "text-[19px]": i.isMobile
                })
              }, null, 8, ["class"])
            ], 2)), [
              [o]
            ])
          ])
        ]),
        default: N(() => [
          E("div", Hv, [
            A(Mp, {
              items: i.items,
              legends: i.legends
            }, null, 8, ["items", "legends"]),
            E("div", Uv, [
              (k(!0), T(ce, null, $e(v(t), (a) => (k(), T("div", {
                key: a.issuePeriod.startDate.toISOString(),
                class: "max-w-[77px] flex-none"
              }, [
                A(Op, {
                  "return-period": a,
                  "returns-periodicity": i.returnsPeriodicity
                }, null, 8, ["return-period", "returns-periodicity"])
              ]))), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["opened", "bottom", "class"]);
    };
  }
}), Wv = { class: "flex items-center" }, _A = /* @__PURE__ */ X({
  __name: "Info",
  props: {
    minimumInvestmentLabel: {},
    minimumInvestmentValue: {},
    periodicityLabel: {},
    periodicityValue: {},
    maturityDateLabel: {},
    maturityDateValue: {},
    investorCountLabel: {},
    investorCountValue: {},
    desktop: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = Z(() => ({
      minimumInvestment: {
        icon: z2,
        label: n.minimumInvestmentLabel,
        value: n.minimumInvestmentValue
      },
      periodicity: {
        icon: V2,
        label: n.periodicityLabel,
        value: n.periodicityValue
      },
      maturityDate: {
        icon: a9,
        label: n.maturityDateLabel,
        value: n.maturityDateValue
      }
    })), t = Z(
      () => n.desktop ? {
        wrapper: "grid-cols-3 divide-x",
        item: "flex-col items-start",
        icon: "",
        label: "lg:!text-grey",
        value: "!font-semibold mt-1.5"
      } : {
        wrapper: "gap-3",
        item: "items-center",
        icon: "",
        label: "",
        value: "!font-semibold ml-auto"
      }
    );
    return (r, i) => (k(), T("div", {
      class: B(["grid place-items-start divide-stroke-gray", t.value.wrapper])
    }, [
      (k(!0), T(ce, null, $e(e.value, (s, o, a) => (k(), T("div", {
        key: o,
        class: B(["flex w-full items-start justify-between", [t.value.item, r.desktop && a !== 0 && "pl-12"]])
      }, [
        E("div", Wv, [
          A(v(K), {
            class: B(t.value.label),
            size: v(G).sm
          }, {
            default: N(() => [
              W(z(s.label), 1)
            ]),
            _: 2
          }, 1032, ["class", "size"])
        ]),
        A(v(K), {
          class: B(t.value.value),
          size: v(G).subtitle
        }, {
          default: N(() => [
            W(z(s.value), 1)
          ]),
          _: 2
        }, 1032, ["class", "size"])
      ], 2))), 128))
    ], 2));
  }
}), qv = ["alt", "src"], Kv = { class: "flex grow flex-col" }, Gv = { class: "flex gap-4" }, Yv = ["alt", "src"], Jv = {
  key: 1,
  class: "mt-7"
}, $A = /* @__PURE__ */ X({
  __name: "OwnerWidget",
  props: {
    desktop: { type: Boolean },
    name: {},
    imageSrc: {},
    ownerData: {},
    ownerDescriptionShort: {},
    ownerDescriptionLong: {},
    moreLabel: {}
  },
  emits: ["openOwnerDetail"],
  setup(n) {
    return (e, t) => {
      const r = Yt("ripple");
      return k(), T("div", {
        class: B(["flex", {
          "gap-5": e.desktop,
          "gap-4": !e.desktop
        }])
      }, [
        e.desktop ? (k(), T("img", {
          key: 0,
          alt: e.name,
          class: "size-[98px] shrink-0 grow-0 rounded-full object-cover",
          loading: "lazy",
          src: e.imageSrc
        }, null, 8, qv)) : V("", !0),
        E("div", Kv, [
          E("div", Gv, [
            e.desktop ? V("", !0) : (k(), T("img", {
              key: 0,
              alt: e.name,
              class: "size-[53px] shrink-0 grow-0 rounded-full object-cover",
              loading: "lazy",
              src: e.imageSrc
            }, null, 8, Yv)),
            A(K, {
              class: "!font-nunito !font-extrabold",
              size: v(G).h3
            }, {
              default: N(() => [
                W(z(e.name), 1)
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          v(mo)(e.ownerDescriptionShort) ? V("", !0) : (k(), q(v(Ln), {
            key: 0,
            class: "mt-4 [&_li+li]:!mt-3 [&_ul]:!mt-3",
            content: e.ownerDescriptionShort
          }, null, 8, ["content"])),
          v(mo)(e.ownerDescriptionLong) ? V("", !0) : (k(), T("div", Jv, [
            nt((k(), T("button", {
              class: "font-semibold text-orange underline hover:cursor-pointer",
              onClick: t[0] || (t[0] = (i) => e.$emit("openOwnerDetail"))
            }, [
              W(z(e.moreLabel) + " ", 1),
              A(v(mn), { class: "inline-block text-[20px]" })
            ])), [
              [r]
            ])
          ]))
        ])
      ], 2);
    };
  }
}), Zv = { class: "flex flex-col gap-5 lg:gap-6" }, Xv = { class: "flex justify-between" }, Qv = { class: "font-semibold text-brand" }, e_ = { class: "font-semibold" }, t_ = { class: "-my-2 h-[10px] w-full overflow-hidden rounded-full bg-brand-light lg:bg-[#dcdcdc]" }, n_ = { class: "font-semibold" }, xA = /* @__PURE__ */ X({
  __name: "Progress",
  props: {
    amountLabel: {},
    amountValue: {},
    amountValueFormatted: {},
    investorsCountValue: {},
    investorsCountLabel: {},
    remainingAmountValue: {},
    remainingAmountLabel: {},
    remainingAmountFormatted: {},
    desktop: { type: Boolean }
  },
  setup(n) {
    const e = Z(() => n.amountValue + n.remainingAmountValue), t = Z(() => {
      if (e.value === 0)
        return "100%";
      const i = n.amountValue / e.value * 100;
      return i >= 95 && i < 100 ? `${i.toFixed(1)}%` : `${Math.min(Math.ceil(i / 5) * 5, 100)}%`;
    }), r = Z(() => n.desktop ? G.md : G.sm);
    return (i, s) => (k(), T("div", Zv, [
      E("div", Xv, [
        A(v(K), { size: r.value }, {
          default: N(() => [
            W(z(i.amountLabel) + ": ", 1),
            E("span", Qv, z(i.amountValueFormatted), 1)
          ]),
          _: 1
        }, 8, ["size"]),
        A(v(K), { size: r.value }, {
          default: N(() => [
            E("span", e_, z(i.investorsCountValue), 1),
            W(" " + z(i.investorsCountLabel), 1)
          ]),
          _: 1
        }, 8, ["size"])
      ]),
      E("div", t_, [
        E("div", {
          class: "h-full rounded-r-full bg-brand transition-all duration-300 ease-in-out",
          style: mt({ width: t.value })
        }, null, 4)
      ]),
      A(v(K), {
        class: "text-left",
        size: r.value
      }, {
        default: N(() => [
          W(z(i.remainingAmountLabel) + ": ", 1),
          E("span", n_, z(i.remainingAmountFormatted), 1)
        ]),
        _: 1
      }, 8, ["size"])
    ]));
  }
}), wA = /* @__PURE__ */ X({
  __name: "CfgPasswordField",
  props: /* @__PURE__ */ Ae({
    ...kt,
    ...Wt
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = n, t = Z(() => pr(e, Object.keys({ ...kt, ...Wt }))), r = je(n, "modelValue"), i = ae(!1);
    function s() {
      i.value = !i.value;
    }
    function o(a) {
      r.value = a;
    }
    return (a, l) => (k(), T("div", null, [
      A(pn, Te({
        ...t.value,
        fluid: !0
      }, {
        "interact-with-icon": "",
        "model-value": r.value,
        type: i.value ? "text" : "password",
        "onUpdate:modelValue": o
      }), {
        icon: N(() => [
          A(v(j2), {
            class: B(["text-[1.5rem] hover:cursor-pointer", {
              "text-grey-300": !i.value,
              "text-brand": i.value
            }]),
            onClick: Ht(s, ["prevent"])
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 16, ["model-value", "type"])
    ]));
  }
});
var Oa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function r_(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var ma = { exports: {} }, ga = { exports: {} }, i_ = ga.exports, pc;
function s_() {
  return pc || (pc = 1, function(n) {
    (function() {
      var e = this || self;
      function t(b) {
        b.ra = void 0, b.pa = function() {
          return b.ra ? b.ra : b.ra = new b();
        };
      }
      function r(b, C) {
        function P() {
        }
        P.prototype = C.prototype, b.Da = C.prototype, b.prototype = new P(), b.prototype.constructor = b, b.Ja = function(F, H, ee) {
          for (var se = Array(arguments.length - 2), Se = 2; Se < arguments.length; Se++) se[Se - 2] = arguments[Se];
          return C.prototype[H].apply(F, se);
        };
      }
      var i = class {
        constructor(b) {
          if (s !== s) throw Error("SafeUrl is not meant to be built directly");
          this.g = b;
        }
        toString() {
          return this.g.toString();
        }
      }, s = {};
      new i("about:invalid#zClosurez"), new i("about:blank");
      var o = {};
      class a {
        constructor() {
          if (o !== o) throw Error("SafeStyle is not meant to be built directly");
        }
        toString() {
          return "";
        }
      }
      new a();
      function l(b) {
        var C = [];
        let P = 0;
        for (var F in b) C[P++] = b[F];
        return C;
      }
      var u = {};
      class d {
        constructor() {
          if (u !== u) throw Error("SafeStyleSheet is not meant to be built directly");
        }
        toString() {
          return "";
        }
      }
      new d();
      var c = {};
      class f {
        constructor() {
          var C = e.trustedTypes && e.trustedTypes.emptyHTML || "";
          if (c !== c) throw Error("SafeHtml is not meant to be built directly");
          this.g = C;
        }
        toString() {
          return this.g.toString();
        }
      }
      new f();
      function p(b, C) {
        for (this.h = b, this.g = {}, b = 0; b < C.length; b++) {
          var P = C[b];
          this.g[P.g] = P;
        }
      }
      function h(b) {
        return b = l(b.g), b.sort(function(C, P) {
          return C.g - P.g;
        }), b;
      }
      function y(b, C) {
        switch (this.g = b, this.m = !!C.ga, this.h = C.i, this.u = C.type, this.s = !1, this.h) {
          case $:
          case w:
          case _:
          case L:
          case S:
          case m:
          case g:
            this.s = !0;
        }
        this.j = C.defaultValue;
      }
      var g = 1, m = 2, $ = 3, w = 4, _ = 6, L = 16, S = 18;
      function R() {
        this.h = {}, this.j = this.o().g, this.g = this.m = null;
      }
      R.prototype.has = function(b) {
        return I(this, b.g);
      }, R.prototype.get = function(b, C) {
        return M(this, b.g, C);
      }, R.prototype.set = function(b, C) {
        J(this, b.g, C);
      }, R.prototype.add = function(b, C) {
        ne(this, b.g, C);
      };
      function O(b, C) {
        for (var P = h(b.o()), F = 0; F < P.length; F++) {
          var H = P[F], ee = H.g;
          if (I(C, ee)) {
            b.g && delete b.g[H.g];
            var se = H.h == 11 || H.h == 10;
            if (H.m) {
              H = j(C, ee);
              for (var Se = 0; Se < H.length; Se++) ne(b, ee, se ? H[Se].clone() : H[Se]);
            } else H = x(C, ee), se ? (se = x(b, ee)) ? O(se, H) : J(b, ee, H.clone()) : J(b, ee, H);
          }
        }
      }
      R.prototype.clone = function() {
        var b = new this.constructor();
        return b != this && (b.h = {}, b.g && (b.g = {}), O(b, this)), b;
      };
      function I(b, C) {
        return b.h[C] != null;
      }
      function x(b, C) {
        var P = b.h[C];
        if (P == null) return null;
        if (b.m) {
          if (!(C in b.g)) {
            var F = b.m, H = b.j[C];
            if (P != null) if (H.m) {
              for (var ee = [], se = 0; se < P.length; se++) ee[se] = F.h(H, P[se]);
              P = ee;
            } else P = F.h(H, P);
            return b.g[C] = P;
          }
          return b.g[C];
        }
        return P;
      }
      function M(b, C, P) {
        var F = x(b, C);
        return b.j[C].m ? F[P || 0] : F;
      }
      function D(b, C) {
        if (I(b, C)) b = M(b, C);
        else e: {
          if (b = b.j[C], b.j === void 0) if (C = b.u, C === Boolean) b.j = !1;
          else if (C === Number) b.j = 0;
          else if (C === String) b.j = b.s ? "0" : "";
          else {
            b = new C();
            break e;
          }
          b = b.j;
        }
        return b;
      }
      function j(b, C) {
        return x(b, C) || [];
      }
      function U(b, C) {
        return b.j[C].m ? I(b, C) ? b.h[C].length : 0 : I(b, C) ? 1 : 0;
      }
      function J(b, C, P) {
        b.h[C] = P, b.g && (b.g[C] = P);
      }
      function ne(b, C, P) {
        b.h[C] || (b.h[C] = []), b.h[C].push(P), b.g && delete b.g[C];
      }
      function Y(b, C) {
        var P = [], F;
        for (F in C) F != 0 && P.push(new y(F, C[F]));
        return new p(b, P);
      }
      function oe() {
      }
      oe.prototype.g = function(b) {
        throw new b.h(), Error("Unimplemented");
      }, oe.prototype.h = function(b, C) {
        if (b.h == 11 || b.h == 10) return C instanceof R ? C : this.g(b.u.prototype.o(), C);
        if (b.h == 14) return typeof C == "string" && le.test(C) && (b = Number(C), 0 < b) ? b : C;
        if (!b.s) return C;
        if (b = b.u, b === String) {
          if (typeof C == "number") return String(C);
        } else if (b === Number && typeof C == "string" && (C === "Infinity" || C === "-Infinity" || C === "NaN" || le.test(C))) return Number(C);
        return C;
      };
      var le = /^-?[0-9]+$/;
      function ge() {
      }
      r(ge, oe), ge.prototype.g = function(b, C) {
        return b = new b.h(), b.m = this, b.h = C, b.g = {}, b;
      };
      function he() {
      }
      r(he, ge), he.prototype.h = function(b, C) {
        return b.h == 8 ? !!C : oe.prototype.h.apply(this, arguments);
      }, he.prototype.g = function(b, C) {
        return he.Da.g.call(this, b, C);
      };
      function _e(b, C) {
        b != null && this.g.apply(this, arguments);
      }
      _e.prototype.h = "", _e.prototype.set = function(b) {
        this.h = "" + b;
      }, _e.prototype.g = function(b, C, P) {
        if (this.h += String(b), C != null) for (let F = 1; F < arguments.length; F++) this.h += arguments[F];
        return this;
      };
      function ue(b) {
        b.h = "";
      }
      _e.prototype.toString = function() {
        return this.h;
      };
      function xe() {
        R.call(this);
      }
      r(xe, R);
      var Le = null;
      function be() {
        R.call(this);
      }
      r(be, R);
      var He = null;
      function Re() {
        R.call(this);
      }
      r(Re, R);
      var rt = null;
      Re.prototype.ia = function() {
        return M(this, 10);
      }, xe.prototype.o = function() {
        var b = Le;
        return b || (Le = b = Y(xe, { 0: { name: "NumberFormat", na: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: !0, i: 9, type: String }, 2: { name: "format", required: !0, i: 9, type: String }, 3: { name: "leading_digits_pattern", ga: !0, i: 9, type: String }, 4: { name: "national_prefix_formatting_rule", i: 9, type: String }, 6: { name: "national_prefix_optional_when_formatting", i: 8, defaultValue: !1, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", i: 9, type: String } })), b;
      }, xe.o = xe.prototype.o, be.prototype.o = function() {
        var b = He;
        return b || (He = b = Y(be, { 0: { name: "PhoneNumberDesc", na: "i18n.phonenumbers.PhoneNumberDesc" }, 2: { name: "national_number_pattern", i: 9, type: String }, 9: { name: "possible_length", ga: !0, i: 5, type: Number }, 10: { name: "possible_length_local_only", ga: !0, i: 5, type: Number }, 6: { name: "example_number", i: 9, type: String } })), b;
      }, be.o = be.prototype.o, Re.prototype.o = function() {
        var b = rt;
        return b || (rt = b = Y(Re, {
          0: { name: "PhoneMetadata", na: "i18n.phonenumbers.PhoneMetadata" },
          1: { name: "general_desc", i: 11, type: be },
          2: { name: "fixed_line", i: 11, type: be },
          3: { name: "mobile", i: 11, type: be },
          4: { name: "toll_free", i: 11, type: be },
          5: { name: "premium_rate", i: 11, type: be },
          6: { name: "shared_cost", i: 11, type: be },
          7: { name: "personal_number", i: 11, type: be },
          8: { name: "voip", i: 11, type: be },
          21: { name: "pager", i: 11, type: be },
          25: { name: "uan", i: 11, type: be },
          27: { name: "emergency", i: 11, type: be },
          28: { name: "voicemail", i: 11, type: be },
          29: { name: "short_code", i: 11, type: be },
          30: { name: "standard_rate", i: 11, type: be },
          31: { name: "carrier_specific", i: 11, type: be },
          33: { name: "sms_services", i: 11, type: be },
          24: { name: "no_international_dialling", i: 11, type: be },
          9: { name: "id", required: !0, i: 9, type: String },
          10: { name: "country_code", i: 5, type: Number },
          11: { name: "international_prefix", i: 9, type: String },
          17: { name: "preferred_international_prefix", i: 9, type: String },
          12: { name: "national_prefix", i: 9, type: String },
          13: { name: "preferred_extn_prefix", i: 9, type: String },
          15: {
            name: "national_prefix_for_parsing",
            i: 9,
            type: String
          },
          16: { name: "national_prefix_transform_rule", i: 9, type: String },
          18: { name: "same_mobile_and_fixed_line_pattern", i: 8, defaultValue: !1, type: Boolean },
          19: { name: "number_format", ga: !0, i: 11, type: xe },
          20: { name: "intl_number_format", ga: !0, i: 11, type: xe },
          22: { name: "main_country_for_code", i: 8, defaultValue: !1, type: Boolean },
          23: { name: "leading_digits", i: 9, type: String }
        })), b;
      }, Re.o = Re.prototype.o;
      function ze() {
        R.call(this);
      }
      r(ze, R);
      var Pe = null;
      ze.prototype.ia = function() {
        return M(this, 1);
      };
      var fe = { Ia: 0, Ha: 1, Ga: 5, Fa: 10, Ea: 20 };
      ze.prototype.o = function() {
        var b = Pe;
        return b || (Pe = b = Y(ze, { 0: { name: "PhoneNumber", na: "i18n.phonenumbers.PhoneNumber" }, 1: { name: "country_code", required: !0, i: 5, type: Number }, 2: { name: "national_number", required: !0, i: 4, type: Number }, 3: { name: "extension", i: 9, type: String }, 4: { name: "italian_leading_zero", i: 8, type: Boolean }, 8: { name: "number_of_leading_zeros", i: 5, defaultValue: 1, type: Number }, 5: { name: "raw_input", i: 9, type: String }, 6: { name: "country_code_source", i: 14, defaultValue: 0, type: fe }, 7: {
          name: "preferred_domestic_carrier_code",
          i: 9,
          type: String
        } })), b;
      }, ze.ctor = ze, ze.ctor.o = ze.prototype.o;
      var we = {
        1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
        7: ["RU", "KZ"],
        20: ["EG"],
        27: ["ZA"],
        30: ["GR"],
        31: ["NL"],
        32: ["BE"],
        33: ["FR"],
        34: ["ES"],
        36: ["HU"],
        39: ["IT", "VA"],
        40: ["RO"],
        41: ["CH"],
        43: ["AT"],
        44: ["GB", "GG", "IM", "JE"],
        45: ["DK"],
        46: ["SE"],
        47: ["NO", "SJ"],
        48: ["PL"],
        49: ["DE"],
        51: ["PE"],
        52: ["MX"],
        53: ["CU"],
        54: ["AR"],
        55: ["BR"],
        56: ["CL"],
        57: ["CO"],
        58: ["VE"],
        60: ["MY"],
        61: ["AU", "CC", "CX"],
        62: ["ID"],
        63: ["PH"],
        64: ["NZ"],
        65: ["SG"],
        66: ["TH"],
        81: ["JP"],
        82: ["KR"],
        84: ["VN"],
        86: ["CN"],
        90: ["TR"],
        91: ["IN"],
        92: ["PK"],
        93: ["AF"],
        94: ["LK"],
        95: ["MM"],
        98: ["IR"],
        211: ["SS"],
        212: ["MA", "EH"],
        213: ["DZ"],
        216: ["TN"],
        218: ["LY"],
        220: ["GM"],
        221: ["SN"],
        222: ["MR"],
        223: ["ML"],
        224: ["GN"],
        225: ["CI"],
        226: ["BF"],
        227: ["NE"],
        228: ["TG"],
        229: ["BJ"],
        230: ["MU"],
        231: ["LR"],
        232: ["SL"],
        233: ["GH"],
        234: ["NG"],
        235: ["TD"],
        236: ["CF"],
        237: ["CM"],
        238: ["CV"],
        239: ["ST"],
        240: ["GQ"],
        241: ["GA"],
        242: ["CG"],
        243: ["CD"],
        244: ["AO"],
        245: ["GW"],
        246: ["IO"],
        247: ["AC"],
        248: ["SC"],
        249: ["SD"],
        250: ["RW"],
        251: ["ET"],
        252: ["SO"],
        253: ["DJ"],
        254: ["KE"],
        255: ["TZ"],
        256: ["UG"],
        257: ["BI"],
        258: ["MZ"],
        260: ["ZM"],
        261: ["MG"],
        262: ["RE", "YT"],
        263: ["ZW"],
        264: ["NA"],
        265: ["MW"],
        266: ["LS"],
        267: ["BW"],
        268: ["SZ"],
        269: ["KM"],
        290: ["SH", "TA"],
        291: ["ER"],
        297: ["AW"],
        298: ["FO"],
        299: ["GL"],
        350: ["GI"],
        351: ["PT"],
        352: ["LU"],
        353: ["IE"],
        354: ["IS"],
        355: ["AL"],
        356: ["MT"],
        357: ["CY"],
        358: ["FI", "AX"],
        359: ["BG"],
        370: ["LT"],
        371: ["LV"],
        372: ["EE"],
        373: ["MD"],
        374: ["AM"],
        375: ["BY"],
        376: ["AD"],
        377: ["MC"],
        378: ["SM"],
        380: ["UA"],
        381: ["RS"],
        382: ["ME"],
        383: ["XK"],
        385: ["HR"],
        386: ["SI"],
        387: ["BA"],
        389: ["MK"],
        420: ["CZ"],
        421: ["SK"],
        423: ["LI"],
        500: ["FK"],
        501: ["BZ"],
        502: ["GT"],
        503: ["SV"],
        504: ["HN"],
        505: ["NI"],
        506: ["CR"],
        507: ["PA"],
        508: ["PM"],
        509: ["HT"],
        590: ["GP", "BL", "MF"],
        591: ["BO"],
        592: ["GY"],
        593: ["EC"],
        594: ["GF"],
        595: ["PY"],
        596: ["MQ"],
        597: ["SR"],
        598: ["UY"],
        599: ["CW", "BQ"],
        670: ["TL"],
        672: ["NF"],
        673: ["BN"],
        674: ["NR"],
        675: ["PG"],
        676: ["TO"],
        677: ["SB"],
        678: ["VU"],
        679: ["FJ"],
        680: ["PW"],
        681: ["WF"],
        682: ["CK"],
        683: ["NU"],
        685: ["WS"],
        686: ["KI"],
        687: ["NC"],
        688: ["TV"],
        689: ["PF"],
        690: ["TK"],
        691: ["FM"],
        692: ["MH"],
        800: ["001"],
        808: ["001"],
        850: ["KP"],
        852: ["HK"],
        853: ["MO"],
        855: ["KH"],
        856: ["LA"],
        870: ["001"],
        878: ["001"],
        880: ["BD"],
        881: ["001"],
        882: ["001"],
        883: ["001"],
        886: ["TW"],
        888: ["001"],
        960: ["MV"],
        961: ["LB"],
        962: ["JO"],
        963: ["SY"],
        964: ["IQ"],
        965: ["KW"],
        966: ["SA"],
        967: ["YE"],
        968: ["OM"],
        970: ["PS"],
        971: ["AE"],
        972: ["IL"],
        973: ["BH"],
        974: ["QA"],
        975: ["BT"],
        976: ["MN"],
        977: ["NP"],
        979: ["001"],
        992: ["TJ"],
        993: ["TM"],
        994: ["AZ"],
        995: ["GE"],
        996: ["KG"],
        998: ["UZ"]
      }, Be = {
        AC: [, [
          ,
          ,
          "(?:[01589]\\d|[46])\\d{4}",
          ,
          ,
          ,
          ,
          ,
          ,
          [5, 6]
        ], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:0[1-9]|[1589]\\d)\\d{4}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]],
        AD: [
          ,
          [, , "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", , , , , , , [6, 8, 9]],
          [, , "[78]\\d{5}", , , , "712345", , , [6]],
          [, , "690\\d{6}|[356]\\d{5}", , , , "312345", , , [6, 9]],
          [, , "180[02]\\d{4}", , , , "18001234", , , [8]],
          [, , "[19]\\d{5}", , , , "912345", , , [6]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "AD",
          376,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , "1800\\d{4}", , , , , , , [8]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        AE: [
          ,
          [, , "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
          [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]],
          [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]],
          [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"],
          [, , "900[02]\\d{5}", , , , "900234567", , , [9]],
          [, , "700[05]\\d{5}", , , , "700012345", , , [9]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "AE",
          971,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "600[25]\\d{5}", , , , "600212345", , , [9]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        AF: [, [, , "[2-7]\\d{8}", , , , , , , [9], [7]], [
          ,
          ,
          "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
          ,
          ,
          ,
          "234567890",
          ,
          ,
          ,
          [7]
        ], [, , "7\\d{8}", , , , "701234567", , , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AG: [
          ,
          [, , "(?:268|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
          [
            ,
            ,
            "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
            ,
            ,
            ,
            "2684601234",
            ,
            ,
            ,
            [7]
          ],
          [, , "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}", , , , "2684641234", , , , [7]],
          [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
          [, , "900[2-9]\\d{6}", , , , "9002123456"],
          [, , , , , , , , , [-1]],
          [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
          [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]],
          "AG",
          1,
          "011",
          "1",
          ,
          ,
          "([457]\\d{6})$|1",
          "268$1",
          ,
          ,
          ,
          ,
          [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]],
          ,
          "268",
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        AI: [, [, , "(?:264|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "264(?:292|4(?:6[12]|9[78]))\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "([2457]\\d{6})$|1", "264$1", , , , , [, , "264724\\d{4}", , , , "2647241234", , , , [7]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AL: [, [, , "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", , , , , , , [6, 7, 8, 9], [5]], [, , "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", , , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[78][2-9]|9\\d)\\d{6}", , , , "672123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [
          ,
          ,
          "900[1-9]\\d\\d",
          ,
          ,
          ,
          "900123",
          ,
          ,
          [6]
        ], [, , "808[1-9]\\d\\d", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AM: [, [
          ,
          ,
          "(?:[1-489]\\d|55|60|77)\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8],
          [5, 6]
        ], [, , "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}", , , , "10123456", , , , [5, 6]], [, , "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}", , , , "77123456"], [, , "800\\d{5}", , , , "80012345"], [, , "90[016]\\d{5}", , , , "90012345"], [, , "80[1-4]\\d{5}", , , , "80112345"], [, , , , , , , , , [-1]], [, , "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}", , , , "60271234"], "AM", 374, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], [
          ,
          "(\\d{3})(\\d{5})",
          "$1 $2",
          ["2|3[12]"],
          "(0$1)"
        ], [, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AO: [
          ,
          [, , "[29]\\d{8}", , , , , , , [9]],
          [, , "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}", , , , "222123456"],
          [, , "9[1-79]\\d{7}", , , , "923123456"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "AO",
          244,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        AR: [
          ,
          [, , "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", , , , , , , [10, 11], [6, 7, 8]],
          [
            ,
            ,
            "3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|5[3-6]|8[3-68])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
            ,
            ,
            ,
            "1123456789",
            ,
            ,
            [10],
            [6, 7, 8]
          ],
          [
            ,
            ,
            "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|5[3-6]|8[3-68]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
            ,
            ,
            ,
            "91123456789",
            ,
            ,
            ,
            [6, 7, 8]
          ],
          [, , "800\\d{7,8}", , , , "8001234567"],
          [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "AR",
          54,
          "00",
          "0",
          ,
          ,
          "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
          "9$1",
          ,
          ,
          [[, "(\\d{3})", "$1", ["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]], [, "(\\d{2})(\\d{4})", "$1-$2", ["[1-9]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[1-8]"]], [
            ,
            "(\\d{4})(\\d{2})(\\d{4})",
            "$1 $2-$3",
            [
              "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
              "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
            ],
            "0$1",
            ,
            1
          ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [
            ,
            "(\\d)(\\d{4})(\\d{2})(\\d{4})",
            "$2 15-$3-$4",
            [
              "9(?:2[2-469]|3[3-578])",
              "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
              "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
              "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
              "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
            ],
            "0$1"
          ], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1"]],
          [
            [
              ,
              "(\\d{4})(\\d{2})(\\d{4})",
              "$1 $2-$3",
              [
                "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
              ],
              "0$1",
              ,
              1
            ],
            [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1],
            [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
            [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1],
            [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", [
              "9(?:2[2-469]|3[3-578])",
              "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
              "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
              "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
              "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
            ]],
            [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["91"]],
            [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"],
            [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9"]]
          ],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , "810\\d{7}", , , , , , , [10]],
          [, , "810\\d{7}", , , , "8101234567", , , [10]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        AS: [, [, , "(?:[58]\\d\\d|684|900)\\d{7}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}", , , , "6847331234", , , , [7]], [
          ,
          ,
          "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "8002123456"
        ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "([267]\\d{6})$|1", "684$1", , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AT: [, [
          ,
          ,
          "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
          ,
          ,
          ,
          ,
          ,
          ,
          [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
          [3]
        ], [, , "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}", , , , "1234567890", , , , [3]], [, , "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", , , , "664123456", , , [7, 8, 9, 10, 11, 12, 13]], [
          ,
          ,
          "800\\d{6,10}",
          ,
          ,
          ,
          "800123456",
          ,
          ,
          [9, 10, 11, 12, 13]
        ], [, , "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10|2[018])\\d{6,10}|828\\d{5}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", , , , "780123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , [
          [, "(\\d{4})", "$1", ["14"]],
          [, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"],
          [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"],
          [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
          [, "(\\d{6})", "$1", ["[18]"]],
          [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"],
          [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"],
          [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"],
          [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]
        ], [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [
          ,
          "(\\d{3})(\\d{3,10})",
          "$1 $2",
          ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
          "0$1"
        ], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AU: [
          ,
          [, , "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", , , , , , , [5, 6, 7, 8, 9, 10, 12]],
          [
            ,
            ,
            "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
            ,
            ,
            ,
            "212345678",
            ,
            ,
            [9],
            [8]
          ],
          [, , "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]],
          [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
          [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
          [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
          [, , , , , , , , , [-1]],
          [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
          "AU",
          61,
          "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
          "0",
          ,
          ,
          "(183[12])|0",
          ,
          "0011",
          ,
          [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["19"]], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]], [
            ,
            "(\\d{4})(\\d{4})(\\d{4})",
            "$1 $2 $3",
            ["130"]
          ]],
          [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]],
          [, , "163\\d{2,6}", , , , "1631234", , , [5, 6, 7, 8, 9]],
          1,
          ,
          [, , "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}", , , , , , , [6, 7, 8, 10, 12]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        AW: [, [
          ,
          ,
          "(?:[25-79]\\d\\d|800)\\d{4}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7]
        ], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:28\\d|501)\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        AX: [, [
          ,
          ,
          "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [5, 6, 7, 8, 9, 10, 11, 12]
        ], [, , "18[1-8]\\d{3,6}", , , , "181234567", , , [6, 7, 8, 9]], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , "18", [, , , , , , , , , [-1]], [
          ,
          ,
          "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
          ,
          ,
          ,
          "10112345"
        ], , , [, , , , , , , , , [-1]]],
        AZ: [, [, , "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", , , , , , , [9], [7]], [, , "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}", , , , "123123456", , , , [7]], [, , "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[1-9]"]], [
          ,
          "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["90"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [
          ,
          "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["[13-9]"],
          "0$1"
        ]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BA: [
          ,
          [, , "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", , , , , , , [8, 9], [6]],
          [, , "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", , , , "30212345", , , [8], [6]],
          [, , "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}", , , , "61123456"],
          [, , "8[08]\\d{6}", , , , "80123456", , , [8]],
          [, , "9[0246]\\d{6}", , , , "90123456", , , [8]],
          [, , "8[12]\\d{6}", , , , "82123456", , , [8]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "BA",
          387,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
          [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", , , , "70341234", , , [8]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        BB: [, [, , "(?:246|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}", , , , "2462501234", , , , [7]], [
          ,
          ,
          "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "8002123456"
        ], [, , "(?:246976|900[2-9]\\d\\d)\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "([2-9]\\d{6})$|1", "246$1", , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [
          ,
          ,
          "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
          ,
          ,
          ,
          "2464301234",
          ,
          ,
          ,
          [7]
        ], , , [, , , , , , , , , [-1]]],
        BD: [, [, , "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [
          ,
          ,
          "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
          ,
          ,
          ,
          "27111234"
        ], [, , "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], [
          ,
          "(\\d{3})(\\d{3,7})",
          "$1-$2",
          ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
          "0$1"
        ], [, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], [, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BE: [, [, , "4\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9]], [, , "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", , , , "12345678", , , [8]], [, , "4[5-9]\\d{7}", , , , "470123456", , , [9]], [, , "800[1-9]\\d{4}", , , , "80012345", , , [8]], [, , "(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}", , , , "90012345", , , [8]], [
          ,
          ,
          "7879\\d{4}",
          ,
          ,
          ,
          "78791234",
          ,
          ,
          [8]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", , , , "78102345", , , [8]], , , [, , , , , , , , , [-1]]],
        BF: [, [
          ,
          ,
          "[025-7]\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8]
        ], [, , "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}", , , , "70123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BG: [
          ,
          [, , "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", , , , , , , [6, 7, 8, 9, 12], [4, 5]],
          [, , "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", , , , "2123456", , , [6, 7, 8], [4, 5]],
          [, , "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", , , , "43012345", , , [8, 9]],
          [, , "(?:00800\\d\\d|800)\\d{5}", , , , "80012345", , , [8, 12]],
          [, , "90\\d{6}", , , , "90123456", , , [8]],
          [, , "700\\d{5}", , , , "70012345", , , [8]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "BG",
          359,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{6})", "$1", ["1"]], [, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
            ,
            "(\\d{3})(\\d{4})",
            "$1 $2",
            ["43[1-6]|70[1-9]"],
            "0$1"
          ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
          [[, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
            ,
            "(\\d{3})(\\d{4})",
            "$1 $2",
            ["43[1-6]|70[1-9]"],
            "0$1"
          ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        BH: [, [, , "[136-9]\\d{7}", , , , , , , [8]], [
          ,
          ,
          "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
          ,
          ,
          ,
          "17001234"
        ], [, , "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}", , , , "36001234"], [, , "8[02369]\\d{6}", , , , "80123456"], [, , "(?:87|9[0-8])\\d{6}", , , , "90123456"], [, , "84\\d{6}", , , , "84123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BH", 973, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BI: [, [, , "(?:[267]\\d|31)\\d{6}", , , , , , , [8]], [, , "(?:22|31)\\d{6}", , , , "22201234"], [
          ,
          ,
          "(?:29|[67][125-9])\\d{6}",
          ,
          ,
          ,
          "79561234"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BJ: [
          ,
          [, , "[24-689]\\d{7}", , , , , , , [8]],
          [, , "2090\\d{4}|2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}", , , , "20211234"],
          [, , "(?:4[0-8]|[56]\\d|9[013-9])\\d{6}", , , , "90011234"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "857[58]\\d{4}", , , , "85751234"],
          "BJ",
          229,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "81\\d{6}", , , , "81123456"],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        BL: [, [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [, , "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}", , , , "590271234"], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}",
          ,
          ,
          ,
          "976012345"
        ], "BL", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BM: [, [, , "(?:441|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}", , , , "4414123456", , , , [7]], [, , "441(?:[2378]\\d|5[0-39]|9[02])\\d{5}", , , , "4413701234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "BM", 1, "011", "1", , , "([2-9]\\d{6})$|1", "441$1", , , , , [, , , , , , , , , [-1]], , "441", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BN: [
          ,
          [, , "[2-578]\\d{6}", , , , , , , [7]],
          [, , "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}", , , , "2345678"],
          [, , "(?:22[89]|[78]\\d\\d)\\d{4}", , , , "7123456"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "5[34]\\d{5}", , , , "5345678"],
          "BN",
          673,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        BO: [, [, , "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", , , , , , , [8, 9], [7]], [, , "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", , , , "22123456", , , [8], [7]], [, , "[67]\\d{7}", , , , "71234567", , , [8]], [, , "8001[07]\\d{4}", , , , "800171234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "50\\d{6}",
          ,
          ,
          ,
          "50123456",
          ,
          ,
          [8],
          [7]
        ], "BO", 591, "00(?:1\\d)?", "0", , , "0(1\\d)?", , , , [[, "(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"], , "0$CC $1"], [, "(\\d{8})", "$1", ["[67]"], , "0$CC $1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"], , "0$CC $1"]], , [, , , , , , , , , [-1]], , , [, , "8001[07]\\d{4}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BQ: [, [, , "(?:[34]1|7\\d)\\d{5}", , , , , , , [7]], [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}", , , , "7151234"], [, , "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BQ", 599, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "[347]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BR: [, [, , "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", , , , "11961234567", , , [10, 11], [8, 9]], [
          ,
          ,
          "800\\d{6,7}",
          ,
          ,
          ,
          "800123456",
          ,
          ,
          [9, 10]
        ], [, , "300\\d{6}|[59]00\\d{6,7}", , , , "300123456", , , [9, 10]], [, , "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", , , , "40041234", , , [8, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [
          [, "(\\d{3,6})", "$1", ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]],
          [, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]],
          [, "(\\d{4})(\\d{4})", "$1-$2", ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]],
          [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"],
          [, "(\\d{5})(\\d{4})", "$1-$2", ["9"]],
          [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"],
          [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]
        ], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
          ,
          "(\\d{3})(\\d{2,3})(\\d{4})",
          "$1 $2 $3",
          ["(?:[358]|90)0"],
          "0$1"
        ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}", , , , , , , [8, 9, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BS: [, [, , "(?:242|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
          ,
          ,
          "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
          ,
          ,
          ,
          "2423456789",
          ,
          ,
          ,
          [7]
        ], [, , "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}", , , , "2423591234", , , , [7]], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "BS", 1, "011", "1", , , "([3-8]\\d{6})$|1", "242$1", , , , , [, , , , , , , , , [-1]], , "242", [, , , , , , , , , [-1]], [, , "242225\\d{4}", , , , "2422250123"], , , [, , , , , , , , , [-1]]],
        BT: [, [, , "[17]\\d{7}|[2-8]\\d{6}", , , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|77)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[2-7]"]], [
          ,
          "(\\d)(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["[2-68]|7[246]"]
        ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BW: [, [, , "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [
          ,
          ,
          "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}",
          ,
          ,
          ,
          "2401234",
          ,
          ,
          [7]
        ], [, , "(?:321|7[1-8]\\d)\\d{5}", , , , "71123456", , , [8]], [, , "(?:0800|800\\d)\\d{6}", , , , "0800012345", , , [10]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], [
          ,
          "(\\d{3})(\\d{4})(\\d{3})",
          "$1 $2 $3",
          ["8"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BY: [, [, , "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", , , , "152450911", , , [9], [5, 6, 7]], [
          ,
          ,
          "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
          ,
          ,
          ,
          "294911911",
          ,
          ,
          [9]
        ], [, , "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}", , , , "8011234567"], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "0|80?", , "8~10", , [[, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [
          ,
          "(\\d{4})(\\d{2})(\\d{3})",
          "$1 $2-$3",
          ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
          "8 0$1"
        ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        BZ: [, [, , "(?:0800\\d|[2-8])\\d{6}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", , , , "2221234", , , [7]], [
          ,
          ,
          "6[0-35-7]\\d{5}",
          ,
          ,
          ,
          "6221234",
          ,
          ,
          [7]
        ], [, , "0800\\d{7}", , , , "08001234123", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CA: [, [, , "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", , , , , , , [7, 10]], [
          ,
          ,
          "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}",
          ,
          ,
          ,
          "5062345678",
          ,
          ,
          [10],
          [7]
        ], [, , "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}", , , , "5062345678", , , [10], [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , [10]], [, , "900[2-9]\\d{6}", , , , "9002123456", , , [10]], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678",
          ,
          ,
          [10]
        ], [, , "600[2-9]\\d{6}", , , , "6002012345", , , [10]], "CA", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "310\\d{4}", , , , "3101234", , , [7]], , , [, , , , , , , , , [-1]]],
        CC: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", , , , "891621234", , , [9], [8]], [
          ,
          ,
          "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
          ,
          ,
          ,
          "412345678",
          ,
          ,
          [9]
        ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CD: [, [
          ,
          ,
          "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 8, 9, 10]
        ], [, , "(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}", , , , "1234567"], [, , "88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", , , , "991234567", , , [7, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["[89]"],
          "0$1"
        ], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CF: [, [, , "(?:[27]\\d{3}|8776)\\d{4}", , , , , , , [8]], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[024-7]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CG: [, [, , "222\\d{6}|(?:0\\d|80)\\d{7}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [, , "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}", , , , "061234567"], [, , , , , , , , , [-1]], [, , "80[0-2]\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CH: [, [
          ,
          ,
          "8\\d{11}|[2-9]\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [9, 12]
        ], [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]], [, , "(?:6[89]|7[235-9])\\d{7}", , , , "781234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[016]\\d{6}", , , , "900123456", , , [9]], [, , "84[0248]\\d{6}", , , , "840123456", , , [9]], [, , "878\\d{6}", , , , "878123456", , , [9]], [, , , , , , , , , [-1]], "CH", 41, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], [
          ,
          "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4 $5",
          ["8"],
          "0$1"
        ]], , [, , "74[0248]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "5[18]\\d{7}", , , , "581234567", , , [9]], , , [, , "860\\d{9}", , , , "860123456789", , , [12]]],
        CI: [, [, , "[02]\\d{9}", , , , , , , [10]], [, , "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}", , , , "2123456789"], [, , "0[157]\\d{8}", , , , "0123456789"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , , [[
          ,
          "(\\d{2})(\\d{2})(\\d)(\\d{5})",
          "$1 $2 $3 $4",
          ["2"]
        ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CK: [, [, , "[2-578]\\d{4}", , , , , , , [5]], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[578]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CL: [, [
          ,
          ,
          "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [9, 10, 11]
        ], [, , "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", , , , "221234567", , , [9]], [
          ,
          ,
          "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
          ,
          ,
          ,
          "221234567",
          ,
          ,
          [9]
        ], [, , "(?:123|8)00\\d{6}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [, , "600\\d{7,8}", , , , "6001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", , , , , , , 1, [
          [, "(\\d{4})", "$1", ["1(?:[03-589]|21)|[29]0|78"]],
          [, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"],
          [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]],
          [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"],
          [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]],
          [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"],
          [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]],
          [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]],
          [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]
        ], [[, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],
          "($1)"
        ], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , , , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CM: [
          ,
          [, , "[26]\\d{8}|88\\d{6,7}", , , , , , , [8, 9]],
          [, , "2(?:22|33)\\d{6}", , , , "222123456", , , [9]],
          [, , "(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", , , , "671234567", , , [9]],
          [, , "88\\d{6,7}", , , , "88012345"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "CM",
          237,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        CN: [, [, , "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [
          ,
          ,
          "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
          ,
          ,
          ,
          "1012345678",
          ,
          ,
          [7, 8, 9, 10, 11],
          [5, 6]
        ], [, , "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", , , , "13123456789", , , [11]], [, , "(?:(?:10|21)8|8)00\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [
          ,
          ,
          "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
          ,
          ,
          ,
          "4001234567",
          ,
          ,
          [7, 8, 9, 10, 11],
          [5, 6]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "00|1(?:[12]\\d|79)\\d\\d00", "0", , , "(1(?:[12]\\d|79)\\d\\d)|0", , "00", , [
          [, "(\\d{5,6})", "$1", ["1(?:00|2[13])|9[56]", "1(?:00|2(?:1|39))|9[56]", "1(?:00|2(?:1|395))|9[56]"]],
          [, "(\\d{5,6})", "$1", ["1(?:0|23)|781|[1-9]12", "1(?:0|23)|7812|[1-9]123", "1(?:0|23(?:[0-8]|9[0-46-9]))|78123|[1-9]123"]],
          [
            ,
            "(\\d{2})(\\d{5,6})",
            "$1 $2",
            [
              "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
              "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
              "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
              "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
              "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
            ],
            "0$1",
            "$CC $1"
          ],
          [, "(\\d{3})(\\d{4})", "$1 $2", [
            "[1-9]",
            "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])",
            "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|[3-9]",
            "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))",
            "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:0(?:[0-689]|7[0-79])|1[01459]|2[0-489]|[46]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))"
          ]],
          [, "(\\d{4})(\\d{4})", "$1 $2", ["16[08]"]],
          [
            ,
            "(\\d{3})(\\d{5,6})",
            "$1 $2",
            [
              "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
              "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
              "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
              "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
            ],
            "0$1",
            "$CC $1"
          ],
          [, "(\\d{4})(\\d{4})", "$1 $2", [
            "[1-9]",
            "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
            "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
            "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
          ]],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
          [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
          [
            ,
            "(\\d{3})(\\d{7,8})",
            "$1 $2",
            ["9"]
          ],
          [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
          [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
          [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
          [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
        ], [[
          ,
          "(\\d{2})(\\d{5,6})",
          "$1 $2",
          [
            "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
            "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
          ],
          "0$1",
          "$CC $1"
        ], [
          ,
          "(\\d{3})(\\d{5,6})",
          "$1 $2",
          [
            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
          ],
          "0$1",
          "$CC $1"
        ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1], [
          ,
          "(\\d{3})(\\d{7,8})",
          "$1 $2",
          ["9"]
        ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}", , , , , , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CO: [, [, , "60\\d{8}|(?:1\\d|[39])\\d{9}", , , , , , , [10, 11], [7]], [
          ,
          ,
          "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60(?:[124-7][2-9]|8[1-9])\\d{6}",
          ,
          ,
          ,
          "6012345678",
          ,
          ,
          [10],
          [7]
        ], [, , "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", , , , "3211234567", , , [10]], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "(?:19(?:0[01]|4[78])|901)\\d{7}", , , , "19001234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0([3579]|4(?:[14]4|56))?", , , , [[, "(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)", "0$CC $1"], [
          ,
          "(\\d{3})(\\d{7})",
          "$1 $2",
          ["3[0-357]|91"],
          ,
          "0$CC $1"
        ], [, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1"]], [[, "(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CR: [, [, , "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", , , , , , , [8, 10]], [, , "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", , , , "22123456", , , [8]], [
          ,
          ,
          "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
          ,
          ,
          ,
          "83123456",
          ,
          ,
          [8]
        ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:210[0-6]|4\\d{3}|5100)\\d{4}", , , , "40001234", , , [8]], "CR", 506, "00", , , , "(19(?:0[0-2468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CU: [, [
          ,
          ,
          "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [6, 7, 8, 10],
          [4, 5]
        ], [, , "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}", , , , "71234567", , , , [4, 5]], [, , "(?:5\\d|6[2-4])\\d{6}", , , , "51234567", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , "807\\d{7}", , , , "8071234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], [, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], [
          ,
          "(\\d{3})(\\d{7})",
          "$1 $2",
          ["8"],
          "0$1"
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CV: [, [, , "(?:[2-59]\\d\\d|800)\\d{4}", , , , , , , [7]], [, , "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}", , , , "2211234"], [, , "(?:36|5[1-389]|9\\d)\\d{5}", , , , "9911234"], [, , "800\\d{4}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[3-5]|4[356])\\d{5}", , , , "3401234"], "CV", 238, "0", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]]],
        CW: [, [, , "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", , , , , , , [7, 8]], [, , "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}", , , , "94351234"], [, , "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}", , , , "95181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], , [
          ,
          ,
          "955\\d{5}",
          ,
          ,
          ,
          "95581234",
          ,
          ,
          [8]
        ], 1, "[69]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CX: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", , , , "891641234", , , [9], [8]], [
          ,
          ,
          "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
          ,
          ,
          ,
          "412345678",
          ,
          ,
          [9]
        ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CX", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        CY: [, [, , "(?:[279]\\d|[58]0)\\d{6}", , , , , , , [8]], [
          ,
          ,
          "2[2-6]\\d{6}",
          ,
          ,
          ,
          "22345678"
        ], [, , "9(?:10|[4-79]\\d)\\d{5}", , , , "96123456"], [, , "800\\d{5}", , , , "80001234"], [, , "90[09]\\d{5}", , , , "90012345"], [, , "80[1-9]\\d{5}", , , , "80112345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "CY", 357, "00", , , , , , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:50|77)\\d{6}", , , , "77123456"], , , [, , , , , , , , , [-1]]],
        CZ: [
          ,
          [, , "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]],
          [, , "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", , , , "212345678", , , [9]],
          [
            ,
            ,
            "(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[01]|[2379]\\d\\d))\\d{5}",
            ,
            ,
            ,
            "601123456",
            ,
            ,
            [9]
          ],
          [, , "800\\d{6}", , , , "800123456", , , [9]],
          [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]],
          [, , "8[134]\\d{7}", , , , "811234567", , , [9]],
          [, , "70[01]\\d{6}", , , , "700123456", , , [9]],
          [, , "9[17]0\\d{6}", , , , "910123456", , , [9]],
          "CZ",
          420,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "9(?:5\\d|7[2-4])\\d{6}", , , , "972123456", , , [9]],
          ,
          ,
          [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]
        ],
        DE: [, [, , "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [2, 3]], [
          ,
          ,
          "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
          ,
          ,
          ,
          "30123456",
          ,
          ,
          [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
          [2, 3, 4]
        ], [, , "15310\\d{6}|1(?:6[023]|7[0-57-9])\\d{7,8}|1(?:5[0-25-9]|76)\\d{8}", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", , , , "9001234567", , , [10, 11]], [, , "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], "DE", 49, "00", "0", , , "0", , , , [
          [
            ,
            "(\\d{2})(\\d{3,13})",
            "$1 $2",
            ["3[02]|40|[68]9"],
            "0$1"
          ],
          [, "(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"],
          [
            ,
            "(\\d{4})(\\d{2,11})",
            "$1 $2",
            ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
            "0$1"
          ],
          [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
          [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
          [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
          [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
          [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
          [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
          [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
          [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
          [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
          [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
          [, "(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"],
          [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
          [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
          [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
          [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
        ], , [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [
          ,
          ,
          "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
          ,
          ,
          ,
          "177991234567",
          ,
          ,
          [12, 13]
        ]],
        DJ: [, [, , "(?:2\\d|77)\\d{6}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        DK: [, [, , "[2-9]\\d{7}", , , , , , , [8]], [
          ,
          ,
          "(?:(?:2\\d|9[1-46-9])\\d|3(?:[0-37]\\d|4[013]|5[0-58]|6[01347-9]|8[0-8]|9[0-79])|4(?:[0-25]\\d|[34][02-9]|6[013-579]|7[013579]|8[0-47]|9[0-27])|5(?:[0-36]\\d|4[0146-9]|5[03-57-9]|7[0568]|8[0-358]|9[0-69])|6(?:[013578]\\d|2[0-68]|4[02-8]|6[01689]|9[015689])|7(?:[0-69]\\d|7[03-9]|8[0147])|8(?:[16-9]\\d|2[0-58]))\\d{5}",
          ,
          ,
          ,
          "32123456"
        ], [, , "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}", , , , "34412345"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        DM: [, [, , "(?:[58]\\d\\d|767|900)\\d{7}", , , , , , , [10], [7]], [, , "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}", , , , "7674201234", , , , [7]], [
          ,
          ,
          "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",
          ,
          ,
          ,
          "7672251234",
          ,
          ,
          ,
          [7]
        ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DM", 1, "011", "1", , , "([2-7]\\d{6})$|1", "767$1", , , , , [, , , , , , , , , [-1]], , "767", [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]]],
        DO: [
          ,
          [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
          [, , "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}", , , , "8092345678", , , , [7]],
          [
            ,
            ,
            "8[024]9[2-9]\\d{6}",
            ,
            ,
            ,
            "8092345678",
            ,
            ,
            ,
            [7]
          ],
          [, , "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}", , , , "8002123456"],
          [, , "900[2-9]\\d{6}", , , , "9002123456"],
          [, , , , , , , , , [-1]],
          [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
          [, , , , , , , , , [-1]],
          "DO",
          1,
          "011",
          "1",
          ,
          ,
          "1",
          ,
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          "8001|8[024]9",
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        DZ: [, [, , "(?:[1-4]|[5-79]\\d|80)\\d{7}", , , , , , , [8, 9]], [, , "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}", , , , "12345678"], [, , "(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", , , , "551234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]], [, , "80[12]1\\d{5}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , "98[23]\\d{6}", , , , "983123456", , , [9]], "DZ", 213, "00", "0", , , "0", , , , [[
          ,
          "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["[1-4]"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        EC: [, [, , "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", , , , , , , [8, 9, 10, 11], [7]], [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]], [, , "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", , , , "991234567", , , [9]], [, , "1800\\d{7}|1[78]00\\d{6}", , , , "18001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]], "EC", 593, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        EE: [
          ,
          [, , "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", , , , , , , [7, 8, 10]],
          [, , "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", , , , "3212345", , , [7]],
          [, , "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", , , , "51234567", , , [7, 8]],
          [
            ,
            ,
            "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",
            ,
            ,
            ,
            "80012345"
          ],
          [, , "(?:40\\d\\d|900)\\d{4}", , , , "9001234", , , [7, 8]],
          [, , , , , , , , , [-1]],
          [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]],
          [, , , , , , , , , [-1]],
          "EE",
          372,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],
          ,
          [
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [-1]
          ],
          ,
          ,
          [, , "800[2-9]\\d{3}", , , , , , , [7]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        EG: [, [, , "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [, , "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", , , , "234567890", , , [8, 9], [6, 7]], [, , "1[0-25]\\d{8}", , , , "1001234567", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "EG", 20, "00", "0", , , "0", , , , [[
          ,
          "(\\d)(\\d{7,8})",
          "$1 $2",
          ["[23]"],
          "0$1"
        ], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        EH: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "528[89]\\d{5}", , , , "528812345"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}", , , , "650123456"], [, , "80[0-7]\\d{6}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}", , , , "592401234"], "EH", 212, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , "528[89]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        ER: [, [, , "[178]\\d{6}", , , , , , , [7], [6]], [, , "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}", , , , "8370362", , , , [6]], [, , "(?:17[1-3]|7\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        ES: [
          ,
          [, , "[5-9]\\d{8}", , , , , , , [9]],
          [, , "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}", , , , "810123456"],
          [, , "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}", , , , "612345678"],
          [, , "[89]00\\d{6}", , , , "800123456"],
          [, , "80[367]\\d{6}", , , , "803123456"],
          [, , "90[12]\\d{6}", , , , "901123456"],
          [, , "70\\d{7}", , , , "701234567"],
          [, , , , , , , , , [-1]],
          "ES",
          34,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{4})", "$1", ["905"]], [, "(\\d{6})", "$1", ["[79]9"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]],
          [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "51\\d{7}", , , , "511234567"],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        ET: [, [, , "(?:11|[2-579]\\d)\\d{7}", , , , , , , [9], [7]], [
          ,
          ,
          "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
          ,
          ,
          ,
          "111112345",
          ,
          ,
          ,
          [7]
        ], [, , "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        FI: [, [, , "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [
          ,
          ,
          "1[35-7][1-8]\\d{3,6}|(?:1[49][1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
          ,
          ,
          ,
          "131234567",
          ,
          ,
          [5, 6, 7, 8, 9]
        ], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FI", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , [[, "(\\d{5})", "$1", ["75[12]"], "0$1"], [, "(\\d{5})", "$1", ["20[2-59]"], "0$1"], [, "(\\d{6})", "$1", ["11"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], [
          ,
          "(\\d{2})(\\d{4,8})",
          "$1 $2",
          ["[14]|2[09]|50|7[135]"],
          "0$1"
        ], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], [[, "(\\d{5})", "$1", ["20[2-59]"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], [, , , , , , , , , [-1]], 1, "1[03-79]|[2-9]", [
          ,
          ,
          "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"
        ], [, , "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}", , , , "10112345"], , , [, , , , , , , , , [-1]]],
        FJ: [, [, , "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", , , , , , , [7, 11]], [, , "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]], [
          ,
          ,
          "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
          ,
          ,
          ,
          "7012345",
          ,
          ,
          [7]
        ], [, , "0800\\d{7}", , , , "08001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FJ", 679, "0(?:0|52)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        FK: [
          ,
          [, , "[2-7]\\d{4}", , , , , , , [5]],
          [, , "[2-47]\\d{4}", , , , "31234"],
          [, , "[56]\\d{4}", , , , "51234"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "FK",
          500,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        FM: [, [, , "(?:[39]\\d\\d|820)\\d{4}", , , , , , , [7]], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}", , , , "3201234"], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], , [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        FO: [, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[34]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d|9[16])\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [, , "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d", , , , "901123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", , , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", ["[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        FR: [, [
          ,
          ,
          "[1-9]\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [9]
        ], [, , "(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}", , , , "123456789"], [, , "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [, , "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}", , , , "891123456"], [, , "8(?:1[01]|2[0156]|4[024]|84)\\d{6}", , , , "884012345"], [, , , , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["10"]], [
          ,
          "(\\d{3})(\\d{3})",
          "$1 $2",
          ["1"]
        ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]],
        GA: [, [, , "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", , , , , , , [7, 8]], [, , "[01]1\\d{6}", , , , "01441234", , , [8]], [
          ,
          ,
          "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",
          ,
          ,
          ,
          "06031234"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GB: [, [
          ,
          ,
          "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 9, 10],
          [4, 5, 6, 8]
        ], [
          ,
          ,
          "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
          ,
          ,
          ,
          "1212345678",
          ,
          ,
          [9, 10],
          [4, 5, 6, 7, 8]
        ], [, , "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", , , , "7400123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [
          ,
          ,
          "56\\d{8}",
          ,
          ,
          ,
          "5612345678",
          ,
          ,
          [10]
        ], "GB", 44, "00", "0", " x", , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", [
          "[25]|7(?:0|6[02-9])",
          "[25]|7(?:0|6(?:[03-9]|2[356]))"
        ], "0$1"], [, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
        GD: [, [, , "(?:473|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
          ,
          ,
          "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[579]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
          ,
          ,
          ,
          "4732691234",
          ,
          ,
          ,
          [7]
        ], [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[68])|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], "GD", 1, "011", "1", , , "([2-9]\\d{6})$|1", "473$1", , , , , [, , , , , , , , , [-1]], , "473", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GE: [, [, , "(?:[3-57]\\d\\d|800)\\d{6}", , , , , , , [9], [6, 7]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", , , , [6, 7]], [
          ,
          ,
          "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|111|22[02]|77\\d)|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}",
          ,
          ,
          ,
          "555123456"
        ], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70[67]\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "70[67]\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GF: [, [
          ,
          ,
          "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [9]
        ], [, , "594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}", , , , "594101234"], [, , "694(?:[0-249]\\d|3[0-8])\\d{4}", , , , "694201234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}", , , , "976012345"], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        GG: [, [, , "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", , , , , , , [7, 9, 10], [6]], [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]], [, , "7(?:(?:781|839)\\d|911[17])\\d{5}", , , , "7781123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GG", 44, "00", "0", , , "([25-9]\\d{5})$|0", "1481$1", , , , , [
          ,
          ,
          "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
          ,
          ,
          ,
          "7640123456",
          ,
          ,
          [10]
        ], , , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
        GH: [, [, , "(?:[235]\\d{3}|800)\\d{5}", , , , , , , [8, 9], [7]], [, , "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", , , , "302345678", , , [9], [7]], [, , "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", , , , "231234567", , , [9]], [
          ,
          ,
          "800\\d{5}",
          ,
          ,
          ,
          "80012345",
          ,
          ,
          [8]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|8[0-2]"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GI: [, [, , "(?:[25]\\d|60)\\d{6}", , , , , , , [8]], [
          ,
          ,
          "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
          ,
          ,
          ,
          "20012345"
        ], [, , "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GL: [
          ,
          [, , "(?:19|[2-689]\\d|70)\\d{4}", , , , , , , [6]],
          [, , "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}", , , , "321000"],
          [, , "[245]\\d{5}", , , , "221234"],
          [, , "80\\d{4}", , , , "801234"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "3[89]\\d{4}", , , , "381234"],
          "GL",
          299,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        GM: [
          ,
          [, , "[2-9]\\d{6}", , , , , , , [7]],
          [, , "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}", , , , "5661234"],
          [, , "(?:[23679]\\d|4[015]|5[0-489])\\d{5}", , , , "3012345"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "GM",
          220,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        GN: [, [, , "722\\d{6}|(?:3|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", , , , "30241234", , , [8]], [, , "6[0-356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "722\\d{6}", , , , "722123456", , , [9]], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [
          ,
          "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["[67]"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GP: [
          ,
          [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
          [, , "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}", , , , "590201234"],
          [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}", , , , "690001234"],
          [, , "80[0-5]\\d{6}", , , , "800012345"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"],
          "GP",
          590,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          1,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        GQ: [, [, , "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", , , , , , , [9]], [, , "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}", , , , "333091234"], [, , "(?:222|55\\d)\\d{6}", , , , "222123456"], [, , "80\\d[1-9]\\d{5}", , , , "800123456"], [, , "90\\d[1-9]\\d{5}", , , , "900123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], "GQ", 240, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GR: [, [, , "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", , , , , , , [10, 11, 12]], [
          ,
          ,
          "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
          ,
          ,
          ,
          "2123456789",
          ,
          ,
          [10]
        ], [, , "68[57-9]\\d{7}|(?:69|94)\\d{8}", , , , "6912345678", , , [10]], [, , "800\\d{7,9}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567", , , [10]], [, , "8(?:0[16]|12|[27]5|50)\\d{7}", , , , "8011234567", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], [
          ,
          "(\\d{3})(\\d{3,4})(\\d{5})",
          "$1 $2 $3",
          ["8"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5005000\\d{3}", , , , "5005000123", , , [10]], , , [, , , , , , , , , [-1]]],
        GT: [, [, , "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", , , , , , , [8, 11]], [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]], [, , "(?:[3-5]\\d\\d|80[0-4])\\d{5}", , , , "51234567", , , [8]], [, , "18[01]\\d{8}", , , , "18001112222", , , [11]], [, , "19\\d{9}", , , , "19001112222", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GT", 502, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], [
          ,
          "(\\d{4})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["1"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GU: [, [, , "(?:[58]\\d\\d|671|900)\\d{7}", , , , , , , [10], [7]], [, , "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [
          ,
          ,
          "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
          ,
          ,
          ,
          "6713001234",
          ,
          ,
          ,
          [7]
        ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "([2-9]\\d{6})$|1", "671$1", , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]]],
        GW: [, [, , "[49]\\d{8}|4\\d{6}", , , , , , , [7, 9]], [, , "443\\d{6}", , , , "443201234", , , [9]], [, , "9(?:5\\d|6[569]|77)\\d{6}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        GY: [, [, , "(?:[2-8]\\d{3}|9008)\\d{3}", , , , , , , [7]], [
          ,
          ,
          "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
          ,
          ,
          ,
          "2201234"
        ], [, , "510\\d{4}|(?:6\\d|7[0-5])\\d{5}", , , , "6091234"], [, , "(?:289|8(?:00|6[28]|88|99))\\d{4}", , , , "2891234"], [, , "9008\\d{3}", , , , "9008123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "515\\d{4}", , , , "5151234"], "GY", 592, "001", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        HK: [, [, , "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", , , , , , , [5, 6, 7, 8, 9, 11]], [
          ,
          ,
          "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}",
          ,
          ,
          ,
          "21234567",
          ,
          ,
          [8]
        ], [, , "(?:4(?:44[0-25-9]|6(?:1[0-7]|4[0-57-9]|6[0-4])|74[0-2])|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[01]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[05])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-49]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", , , , "51234567", , , [8]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
          ,
          ,
          "900(?:[0-24-9]\\d{7}|3\\d{1,4})",
          ,
          ,
          ,
          "90012345678",
          ,
          ,
          [5, 6, 7, 8, 11]
        ], [, , , , , , , , , [-1]], [, , "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", , , , "81123456", , , [8]], [, , , , , , , , , [-1]], "HK", 852, "00(?:30|5[09]|[126-9]?)", , , , , , "00", , [[, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], , [
          ,
          ,
          "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
          ,
          ,
          ,
          "71123456",
          ,
          ,
          [8]
        ], , , [, , , , , , , , , [-1]], [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]], , , [, , , , , , , , , [-1]]],
        HN: [, [, , "8\\d{10}|[237-9]\\d{7}", , , , , , , [8, 11]], [
          ,
          ,
          "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
          ,
          ,
          ,
          "22123456",
          ,
          ,
          [8]
        ], [, , "[37-9]\\d{7}", , , , "91234567", , , [8]], [, , "8002\\d{7}", , , , "80021234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], [, , , , , , , , , [-1]], , , [, , "8002\\d{7}", , , , , , , [11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        HR: [, [, , "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", , , , , , , [6, 7, 8, 9]], [
          ,
          ,
          "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
          ,
          ,
          ,
          "12345678",
          ,
          ,
          [8, 9],
          [6, 7]
        ], [, , "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-7])))\\d{4}|98\\d{6}", , , , "921234567", , , [8, 9]], [, , "80\\d{5,7}", , , , "800123456", , , [7, 8, 9]], [, , "6[01459]\\d{6}|6[01]\\d{4,5}", , , , "611234", , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [
          ,
          "(\\d)(\\d{4})(\\d{3})",
          "$1 $2 $3",
          ["1"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "62\\d{6,7}|72\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]],
        HT: [, [, , "(?:[2-489]\\d|55)\\d{6}", , , , , , , [8]], [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"], [, , "(?:[34]\\d|55)\\d{6}", , , , "34101234"], [
          ,
          ,
          "8\\d{7}",
          ,
          ,
          ,
          "80012345"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}", , , , "98901234"], "HT", 509, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        HU: [, [, , "[235-7]\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6, 7]], [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]], [
          ,
          ,
          "(?:[48]0\\d|680[29])\\d{5}",
          ,
          ,
          ,
          "80123456"
        ], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "21\\d{7}", , , , "211234567", , , [9]], "HU", 36, "00", "06", , , "06", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], , [, , , , , , , , , [-1]], , , [, , "(?:[48]0\\d|680[29])\\d{5}"], [, , "38\\d{7}", , , , "381234567", , , [9]], , , [, , , , , , , , , [-1]]],
        ID: [, [
          ,
          ,
          "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
          [5, 6]
        ], [
          ,
          ,
          "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
          ,
          ,
          ,
          "218350123",
          ,
          ,
          [7, 8, 9, 10, 11],
          [5, 6]
        ], [, , "8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", , , , "8001234567", , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "00[89]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [
          ,
          "(\\d{3})(\\d{5,8})",
          "$1 $2",
          ["[2-79]"],
          "(0$1)"
        ], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3 $4", ["001"]], [, "(\\d{2})(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [
          ,
          "(\\d{2})(\\d{5,9})",
          "$1 $2",
          ["2[124]|[36]1"],
          "(0$1)"
        ], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "001803\\d{5,11}|(?:007803\\d|8071)\\d{6}", , , , , , , [10, 11, 12, 13, 14, 15, 16, 17]], [
          ,
          ,
          "(?:1500|8071\\d{3})\\d{3}",
          ,
          ,
          ,
          "8071123456",
          ,
          ,
          [7, 10]
        ], , , [, , , , , , , , , [-1]]],
        IE: [, [, , "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", , , , , , , [7, 8, 9, 10], [5, 6]], [, , "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}", , , , "2212345", , , , [5, 6]], [, , "8(?:22|[35-9]\\d)\\d{6}", , , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [
          ,
          ,
          "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",
          ,
          ,
          ,
          "1520123456",
          ,
          ,
          [10]
        ], [, , "18[59]0\\d{6}", , , , "1850123456", , , [10]], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["81"],
          "(0$1)"
        ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], [, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", , , , , , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", , , , "8551234567", , , [10]]],
        IL: [, [, , "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", , , , , , , [
          7,
          8,
          9,
          10,
          11,
          12
        ]], [, , "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", , , , "21234567", , , [8, 11, 12], [7]], [, , "55(?:410|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", , , , "502345678", , , [9]], [, , "1(?:255|80[019]\\d{3})\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", , , , "1919123456", , , [8, 10]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [
          ,
          ,
          "7(?:38(?:0\\d|5[0-2569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
          ,
          ,
          ,
          "771234567",
          ,
          ,
          [9]
        ], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "(\\d{4})(\\d{3})", "$1-$2", ["125"]], [, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], [, "(\\d{4})(\\d{6})", "$1-$2", ["159"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], [, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], , [, , , , , , , , , [-1]], , , [
          ,
          ,
          "1700\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [10]
        ], [, , "1599\\d{6}", , , , "1599123456", , , [10]], , , [, , "151\\d{8,9}", , , , "15112340000", , , [11, 12]]],
        IM: [
          ,
          [, , "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]],
          [, , "1624(?:230|[5-8]\\d\\d)\\d{3}", , , , "1624756789", , , , [6]],
          [, , "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"],
          [, , "808162\\d{4}", , , , "8081624567"],
          [, , "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}", , , , "9016247890"],
          [, , , , , , , , , [-1]],
          [, , "70\\d{8}", , , , "7012345678"],
          [, , "56\\d{8}", , , , "5612345678"],
          "IM",
          44,
          "00",
          "0",
          ,
          ,
          "([25-8]\\d{5})$|0",
          "1624$1",
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          "74576|(?:16|7[56])24",
          [, , , , , , , , , [-1]],
          [, , "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}", , , , "5512345678"],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        IN: [, [, , "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [
          ,
          ,
          "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
          ,
          ,
          ,
          "7410410123",
          ,
          ,
          [10],
          [6, 7, 8]
        ], [
          ,
          ,
          "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
          ,
          ,
          ,
          "8123456789",
          ,
          ,
          [10]
        ], [, , "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{7})", "$1", ["575"]], [, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [
          ,
          "(\\d{3})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["140"],
          ,
          ,
          1
        ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", , 1], [
          ,
          "(\\d{3})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          [
            "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
          ],
          "0$1",
          ,
          1
        ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
          "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
          "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
          "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
        ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
          "$1 $2 $3 $4",
          ["0"]
        ], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [[, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], , , 1], [
          ,
          "(\\d{2})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
          "0$1",
          ,
          1
        ], [
          ,
          "(\\d{3})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          [
            "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
          ],
          "0$1",
          ,
          1
        ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
          "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
          "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
          "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
        ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
          ,
          "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3 $4",
          ["18"],
          ,
          ,
          1
        ]], [, , , , , , , , , [-1]], , , [, , "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]],
        IO: [, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, , "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        IQ: [, [
          ,
          ,
          "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8, 9, 10],
          [6, 7]
        ], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        IR: [
          ,
          [, , "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", , , , , , , [4, 5, 6, 7, 10], [8]],
          [, , "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", , , , "2123456789", , , [6, 7, 10], [4, 5, 8]],
          [, , "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", , , , "9123456789", , , [10]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "IR",
          98,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))", , , , , , , [4, 5, 10]],
          [
            ,
            ,
            "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
            ,
            ,
            ,
            "9601",
            ,
            ,
            [4, 5]
          ],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        IS: [, [, , "(?:38\\d|[4-9])\\d{6}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", , , , "4101234", , , [7]], [, , "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}", , , , "6111234"], [, , "80[0-8]\\d{4}", , , , "8001234", , , [7]], [
          ,
          ,
          "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
          ,
          ,
          ,
          "9001234",
          ,
          ,
          [7]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49[0-24-79]\\d{4}", , , , "4921234", , , [7]], "IS", 354, "00|1(?:0(?:01|[12]0)|100)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:689|8(?:7[18]|80)|95[48])\\d{4}", , , , "6891234", , , [7]]],
        IT: [, [, , "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [
          ,
          ,
          "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
          ,
          ,
          ,
          "0212345678",
          ,
          ,
          [6, 7, 8, 9, 10, 11]
        ], [, , "3[2-9]\\d{7,8}|(?:31|43)\\d{8}", , , , "3123456789", , , [9, 10]], [, , "80(?:0\\d{3}|3)\\d{3}", , , , "800123456", , , [6, 9]], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "IT", 39, "00", , , , , , , , [
          [, "(\\d{4,5})", "$1", ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]],
          [, "(\\d{6})", "$1", ["1(?:1|92)"]],
          [, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
          [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],
          [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
          [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]],
          [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
          [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]],
          [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]],
          [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]],
          [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
          [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]
        ], [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [
          ,
          "(\\d{3})(\\d{3})(\\d{3,4})",
          "$1 $2 $3",
          ["1(?:44|[679])|[378]|43"]
        ], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
        JE: [, [, , "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [
          ,
          ,
          "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}",
          ,
          ,
          ,
          "7797712345"
        ], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , , , , , , , , [-1]], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "([0-24-8]\\d{5})$|0", "1534$1", , , , , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [
          ,
          ,
          "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
          ,
          ,
          ,
          "5512345678"
        ], , , [, , , , , , , , , [-1]]],
        JM: [, [, , "(?:[58]\\d\\d|658|900)\\d{7}", , , , , , , [10], [7]], [, , "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", , , , "8765230123", , , , [7]], [
          ,
          ,
          "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
          ,
          ,
          ,
          "8762101234",
          ,
          ,
          ,
          [7]
        ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "658|876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        JO: [, [, , "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", , , , , , , [8, 9]], [
          ,
          ,
          "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
          ,
          ,
          ,
          "62001234",
          ,
          ,
          [8]
        ], [, , "7(?:[78][0-25-9]|9\\d)\\d{6}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "9\\d{7}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [
          ,
          ,
          "74(?:66|77)\\d{5}",
          ,
          ,
          ,
          "746612345",
          ,
          ,
          [9]
        ], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]],
        JP: [, [, , "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", , , , "312345678", , , [9]], [
          ,
          ,
          "[7-9]0[1-9]\\d{7}",
          ,
          ,
          ,
          "9012345678",
          ,
          ,
          [10]
        ], [, , "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}", , , , "120123456"], [, , "990\\d{6}", , , , "990123456", , , [9]], [, , , , , , , , , [-1]], [, , "60\\d{7}", , , , "601234567", , , [9]], [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]], "JP", 81, "010", "0", , , "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077", "00777", "00777[01]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
          ,
          "(\\d{4})(\\d)(\\d{4})",
          "$1-$2-$3",
          ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
          "0$1"
        ], [
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1-$2-$3",
          ["60"],
          "0$1"
        ], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1-$2-$3",
          [
            "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
          ],
          "0$1"
        ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [
          ,
          "(\\d{4})(\\d{6})(\\d{6,7})",
          "$1-$2-$3",
          ["0"]
        ]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
          ,
          "(\\d{4})(\\d)(\\d{4})",
          "$1-$2-$3",
          ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1-$2-$3",
          [
            "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
          ],
          "0$1"
        ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], [, , "20\\d{8}", , , , "2012345678", , , [10]], , , [, , "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"], [, , "570\\d{6}", , , , "570123456", , , [9]], , , [, , , , , , , , , [-1]]],
        KE: [, [, , "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", , , , , , , [7, 8, 9, 10]], [
          ,
          ,
          "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
          ,
          ,
          ,
          "202012345",
          ,
          ,
          [7, 8, 9]
        ], [, , "(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", , , , "712123456", , , [9]], [, , "800[02-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KG: [, [
          ,
          ,
          "8\\d{9}|[235-9]\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [9, 10],
          [5, 6]
        ], [, , "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", , , , "312123456", , , [9], [5, 6]], [, , "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KH: [
          ,
          [, , "1\\d{9}|[1-9]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]],
          [
            ,
            ,
            "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
            ,
            ,
            ,
            "23756789",
            ,
            ,
            [8, 9],
            [6, 7]
          ],
          [, , "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", , , , "91234567", , , [8, 9]],
          [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]],
          [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "KH",
          855,
          "00[14-9]",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        KI: [, [, , "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}", , , , "31234"], [
          ,
          ,
          "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
          ,
          ,
          ,
          "72001234",
          ,
          ,
          [8]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", , , , "30010000", , , [8]], "KI", 686, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KM: [, [, , "[3478]\\d{6}", , , , , , , [7], [4]], [, , "7[4-7]\\d{5}", , , , "7712345", , , , [4]], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[
          ,
          "(\\d{3})(\\d{2})(\\d{2})",
          "$1 $2 $3",
          ["[3478]"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KN: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "([2-7]\\d{6})$|1", "869$1", , , , , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KP: [, [, , "85\\d{6}|(?:19\\d|[2-7])\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}", , , , "21234567", , , , [6, 7]], [, , "19[1-3]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[
          ,
          "(\\d{2})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["8"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KR: [, [, , "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [
          ,
          ,
          "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
          ,
          ,
          ,
          "22123456",
          ,
          ,
          [5, 6, 8, 9, 10],
          [3, 4, 7]
        ], [, , "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", , , , "1020000000", , , [9, 10]], [, , "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8,9}", , , , "5012345678", , , [10, 11]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "0", , , "0(8(?:[1-46-8]|5\\d\\d))?", , , , [[
          ,
          "(\\d{5})",
          "$1",
          ["1[016-9]1", "1[016-9]11", "1[016-9]114"],
          "0$1"
        ], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030"]], [
          ,
          "(\\d{2})(\\d{5})(\\d{4})",
          "$1-$2-$3",
          ["5"],
          "0$1",
          "0$CC-$1"
        ], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [
          [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"],
          [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]],
          [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"],
          [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1", "0$CC-$1"],
          [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"],
          [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"],
          [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"]
        ], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})", , , , , , , [11, 12, 13, 14]], [, , "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]],
        KW: [, [, , "18\\d{5}|(?:[2569]\\d|41)\\d{6}", , , , , , , [7, 8]], [, , "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", , , , "22345678", , , [8]], [
          ,
          ,
          "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
          ,
          ,
          ,
          "50012345",
          ,
          ,
          [8]
        ], [, , "18\\d{5}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KY: [, [, , "(?:345|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
          ,
          ,
          "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",
          ,
          ,
          ,
          "3452221234",
          ,
          ,
          ,
          [7]
        ], [, , "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "(?:345976|900[2-9]\\d\\d)\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "([2-9]\\d{6})$|1", "345$1", , , , , [, , "345849\\d{4}", , , , "3458491234"], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        KZ: [, [, , "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", , , , , , , [10, 14], [5, 6, 7]], [
          ,
          ,
          "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
          ,
          ,
          ,
          "7123456789",
          ,
          ,
          [10],
          [5, 6, 7]
        ], [, , "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", , , , "7710009998", , , [10]], [, , "8(?:00|108\\d{3})\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , "751\\d{7}", , , , "7511234567", , , [10]], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , "33|7", [, , "751\\d{7}", , , , , , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        LA: [, [, , "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", , , , , , , [8, 9, 10], [6]], [
          ,
          ,
          "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
          ,
          ,
          ,
          "21212862",
          ,
          ,
          [8],
          [6]
        ], [, , "208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}", , , , "2023123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "30[0135-9]\\d{6}", , , , "301234567", , , [9]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        LB: [, [, , "[27-9]\\d{7}|[13-9]\\d{6}", , , , , , , [7, 8]], [, , "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}", , , , "1123456"], [, , "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[
          ,
          "(\\d)(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        LC: [
          ,
          [, , "(?:[58]\\d\\d|758|900)\\d{7}", , , , , , , [10], [7]],
          [, , "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}", , , , "7584305678", , , , [7]],
          [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}", , , , "7582845678", , , , [7]],
          [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
          [, , "900[2-9]\\d{6}", , , , "9002123456"],
          [, , , , , , , , , [-1]],
          [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
          [, , , , , , , , , [-1]],
          "LC",
          1,
          "011",
          "1",
          ,
          ,
          "([2-8]\\d{6})$|1",
          "758$1",
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          "758",
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        LI: [, [, , "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", , , , , , , [7, 9]], [
          ,
          ,
          "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
          ,
          ,
          ,
          "2345678",
          ,
          ,
          [7]
        ], [, , "(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}", , , , "660234567"], [, , "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}", , , , "8002222"], [, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", , , , "9002222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "(1001)|0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["69"],
          ,
          "$CC $1"
        ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d\\d", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]],
        LK: [, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}", , , , "112345678", , , , [7]], [, , "7(?:[0-25-8]\\d|4[0-4])\\d{6}", , , , "712345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], "LK", 94, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "1973\\d{5}", , , , "197312345"], , , [, , , , , , , , , [-1]]],
        LR: [, [, , "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", , , , , , , [7, 8, 9]], [, , "2\\d{7}", , , , "21234567", , , [8]], [, , "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [
          ,
          ,
          "332(?:02|[34]\\d)\\d{4}",
          ,
          ,
          ,
          "332021234",
          ,
          ,
          [9]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        LS: [, [, , "(?:[256]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[1256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        LT: [
          ,
          [, , "(?:[3469]\\d|52|[78]0)\\d{6}", , , , , , , [8]],
          [, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"],
          [, , "6\\d{7}", , , , "61234567"],
          [, , "80[02]\\d{5}", , , , "80012345"],
          [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"],
          [, , "808\\d{5}", , , , "80812345"],
          [, , "70[05]\\d{5}", , , , "70012345"],
          [, , "[89]01\\d{5}", , , , "80123456"],
          "LT",
          370,
          "00",
          "0",
          ,
          ,
          "[08]",
          ,
          ,
          ,
          [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", , 1], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", , 1], [, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", , 1], [, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", , 1]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "70[67]\\d{5}", , , , "70712345"],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        LU: [, [, , "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11]], [
          ,
          ,
          "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
          ,
          ,
          ,
          "27123456"
        ], [, , "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [, , "20(?:1\\d{5}|[2-689]\\d{1,7})", , , , "20201234", , , [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [
          ,
          "(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3",
          ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
          ,
          "$CC $1"
        ], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [
          ,
          "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
          "$1 $2 $3 $4",
          ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],
          ,
          "$CC $1"
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        LV: [, [, , "(?:[268]\\d|90)\\d{6}", , , , , , , [8]], [, , "6\\d{7}", , , , "63123456"], [, , "23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[
          ,
          "(\\d{2})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["[269]|8[01]"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        LY: [
          ,
          [, , "[2-9]\\d{8}", , , , , , , [9], [7]],
          [, , "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}", , , , "212345678", , , , [7]],
          [, , "9[1-6]\\d{7}", , , , "912345678"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "LY",
          218,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        MA: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}", , , , "520123456"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}", , , , "650123456"], [, , "80[0-7]\\d{6}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
          ,
          ,
          ,
          "592401234"
        ], "MA", 212, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], [, "(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], [, "(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MC: [
          ,
          [, , "(?:[3489]|6\\d)\\d{7}", , , , , , , [8, 9]],
          [, , "(?:870|9[2-47-9]\\d)\\d{5}", , , , "99123456", , , [8]],
          [, , "4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}", , , , "612345678"],
          [, , "(?:800|90\\d)\\d{5}", , , , "90123456", , , [8]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "MC",
          377,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["87"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]],
          [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [
            ,
            "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
            "$1 $2 $3 $4 $5",
            ["6"],
            "0$1"
          ]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , "8[07]0\\d{5}", , , , , , , [8]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        MD: [, [, , "(?:[235-7]\\d|[89]0)\\d{6}", , , , , , , [8]], [, , "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"], [, , "562\\d{5}|(?:6\\d|7[16-9])\\d{6}", , , , "62112345"], [, , "800\\d{5}", , , , "80012345"], [, , "90[056]\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , , , , , , , , [-1]], [, , "3[08]\\d{6}", , , , "30123456"], "MD", 373, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [
          ,
          "(\\d{2})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["22|3"],
          "0$1"
        ], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "803\\d{5}", , , , "80312345"], , , [, , , , , , , , , [-1]]],
        ME: [, [, , "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", , , , , , , [8, 9], [6]], [, , "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", , , , "30234567", , , [8], [6]], [, , "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", , , , "67622901", , , [8]], [, , "80(?:[0-2578]|9\\d)\\d{5}", , , , "80080002"], [
          ,
          ,
          "9(?:4[1568]|5[178])\\d{5}",
          ,
          ,
          ,
          "94515151",
          ,
          ,
          [8]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780", , , [8]], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012", , , [8]], , , [, , , , , , , , , [-1]]],
        MF: [
          ,
          [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
          [, , "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}", , , , "590271234"],
          [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}", , , , "690001234"],
          [, , "80[0-5]\\d{6}", , , , "800012345"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"],
          "MF",
          590,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        MG: [, [, , "[23]\\d{8}", , , , , , , [9], [7]], [, , "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[245])\\d{5}", , , , "202123456", , , , [7]], [, , "3[2-47-9]\\d{7}", , , , "321234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "22\\d{7}",
          ,
          ,
          ,
          "221234567"
        ], "MG", 261, "00", "0", , , "([24-9]\\d{6})$|0", "20$1", , , [[, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MH: [
          ,
          [, , "329\\d{4}|(?:[256]\\d|45)\\d{5}", , , , , , , [7]],
          [, , "(?:247|528|625)\\d{4}", , , , "2471234"],
          [, , "(?:(?:23|54)5|329|45[35-8])\\d{4}", , , , "2351234"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "635\\d{4}", , , , "6351234"],
          "MH",
          692,
          "011",
          "1",
          ,
          ,
          "1",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        MK: [, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", , , , "22012345", , , , [6, 7]], [, , "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}", , , , "72345678"], [
          ,
          ,
          "800\\d{5}",
          ,
          ,
          ,
          "80012345"
        ], [, , "5\\d{7}", , , , "50012345"], [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MK", 389, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        ML: [, [, , "[24-9]\\d{7}", , , , , , , [8]], [
          ,
          ,
          "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
          ,
          ,
          ,
          "20212345"
        ], [, , "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}", , , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MM: [
          ,
          [, , "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", , , , , , , [6, 7, 8, 9, 10], [5]],
          [
            ,
            ,
            "(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
            ,
            ,
            ,
            "1234567",
            ,
            ,
            [6, 7, 8, 9],
            [5]
          ],
          [, , "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", , , , "92123456", , , [7, 8, 9, 10]],
          [, , "80080(?:0[1-9]|2\\d)\\d{3}", , , , "8008001234", , , [10]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "1333\\d{4}|[12]468\\d{4}", , , , "13331234", , , [8]],
          "MM",
          95,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [
            ,
            "(\\d{2})(\\d{2})(\\d{3})",
            "$1 $2 $3",
            ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"],
            "0$1"
          ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [, "(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [
            ,
            "(\\d)(\\d{5})(\\d{4})",
            "$1 $2 $3",
            ["9"],
            "0$1"
          ]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        MN: [, [, , "[12]\\d{7,9}|[5-9]\\d{7}", , , , , , , [8, 9, 10], [4, 5, 6]], [, , "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}", , , , "53123456", , , , [4, 5, 6]], [, , "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}", , , , "88123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}",
          ,
          ,
          ,
          "75123456",
          ,
          ,
          [8]
        ], "MN", 976, "001", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MO: [, [
          ,
          ,
          "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 8]
        ], [, , "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", , , , "28212345", , , [8]], [, , "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", , , , "66123456", , , [8]], [, , "0800\\d{3}", , , , "0800501", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , [[, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MP: [, [
          ,
          ,
          "[58]\\d{9}|(?:67|90)0\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [10],
          [7]
        ], [, , "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "([2-9]\\d{6})$|1", "670$1", , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MQ: [
          ,
          [, , "596\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
          [, , "596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])\\d{4}", , , , "596301234"],
          [, , "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}", , , , "696201234"],
          [, , "80[0-5]\\d{6}", , , , "800012345"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}", , , , "976612345"],
          "MQ",
          596,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        MR: [, [, , "(?:[2-4]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "(?:25[08]|35\\d|45[1-7])\\d{5}", , , , "35123456"], [, , "[2-4][0-46-9]\\d{6}", , , , "22123456"], [, , "800\\d{5}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MR", 222, "00", , , , , , , , [[
          ,
          "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["[2-48]"]
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MS: [, [, , "(?:[58]\\d\\d|664|900)\\d{7}", , , , , , , [10], [7]], [, , "6644(?:1[0-3]|91)\\d{4}", , , , "6644912345", , , , [7]], [, , "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "([34]\\d{6})$|1", "664$1", , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MT: [, [, , "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}", , , , "96961234"], [, , "800(?:02|[3467]\\d)\\d{3}", , , , "80071234"], [
          ,
          ,
          "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
          ,
          ,
          ,
          "50037123"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], , [, , "7117\\d{4}", , , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]],
        MU: [, [, , "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", , , , , , , [7, 8, 10]], [, , "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", , , , "54480123", , , [7, 8]], [
          ,
          ,
          "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}",
          ,
          ,
          ,
          "52512345",
          ,
          ,
          [8]
        ], [, , "802\\d{7}|80[0-2]\\d{4}", , , , "8001234", , , [7, 10]], [, , "30\\d{5}", , , , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[24-7]0|3[03])", , , , , , "020", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], [, "(\\d{5})(\\d{5})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MV: [, [, , "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", , , , , , , [7, 10]], [
          ,
          ,
          "(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
          ,
          ,
          ,
          "6701234",
          ,
          ,
          [7]
        ], [, , "(?:46[46]|[79]\\d\\d)\\d{4}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "4(?:0[01]|50)\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]],
        MW: [, [, , "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", , , , , , , [7, 9]], [
          ,
          ,
          "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
          ,
          ,
          ,
          "1234567"
        ], [, , "111\\d{6}|(?:31|77|[89][89])\\d{7}", , , , "991234567", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MW", 265, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MX: [, [, , "[2-9]\\d{9}", , , , , , , [10], [7, 8]], [
          ,
          ,
          "657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
          ,
          ,
          ,
          "2001234567",
          ,
          ,
          ,
          [7, 8]
        ], [, , "657[12]\\d{6}|(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}", , , , "2221234567", , , , [7, 8]], [
          ,
          ,
          "8(?:00|88)\\d{7}",
          ,
          ,
          ,
          "8001234567"
        ], [, , "900\\d{7}", , , , "9001234567"], [, , "300\\d{7}", , , , "3001234567"], [, , "500\\d{7}", , , , "5001234567"], [, , , , , , , , , [-1]], "MX", 52, "0[09]", , , , , , "00", , [[, "(\\d{5})", "$1", ["53"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MY: [, [
          ,
          ,
          "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8, 9, 10],
          [6, 7]
        ], [, , "4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", , , , "323856789", , , [8, 9], [6, 7]], [
          ,
          ,
          "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
          ,
          ,
          ,
          "123456789",
          ,
          ,
          [9, 10]
        ], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", , , , "1546012345", , , [10]], "MY", 60, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], [
          ,
          "(\\d)(\\d{4})(\\d{4})",
          "$1-$2 $3",
          ["3"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        MZ: [
          ,
          [, , "(?:2|8\\d)\\d{7}", , , , , , , [8, 9]],
          [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]],
          [, , "8[2-79]\\d{7}", , , , "821234567", , , [9]],
          [, , "800\\d{6}", , , , "800123456", , , [9]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "MZ",
          258,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        NA: [, [, , "[68]\\d{7,8}", , , , , , , [8, 9]], [
          ,
          ,
          "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
          ,
          ,
          ,
          "61221234"
        ], [, , "(?:60|8[1245])\\d{7}", , , , "811234567", , , [9]], [, , "80\\d{7}", , , , "800123456", , , [9]], [, , "8701\\d{5}", , , , "870123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d\\d|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]]],
        NC: [, [, , "(?:050|[2-57-9]\\d\\d)\\d{3}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [, , "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}", , , , "751234"], [, , "050\\d{3}", , , , "050012"], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{3})", "$1", ["5[6-8]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        NE: [
          ,
          [, , "[027-9]\\d{7}", , , , , , , [8]],
          [, , "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}", , , , "20201234"],
          [, , "(?:23|7[0467]|[89]\\d)\\d{6}", , , , "93123456"],
          [, , "08\\d{6}", , , , "08123456"],
          [, , "09\\d{6}", , , , "09123456"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "NE",
          227,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        NF: [, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}", , , , "106609", , , , [5]], [, , "(?:14|3[58])\\d{4}", , , , "381234", , , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , "([0-258]\\d{4})$", "3$1", , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], [, "(\\d)(\\d{5})", "$1 $2", ["[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        NG: [, [
          ,
          ,
          "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8, 10, 11, 12, 13, 14],
          [6, 7]
        ], [, , "(?:20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])|38)\\d{6}", , , , "2033123456", , , [8, 10], [6, 7]], [, , "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", , , , "8021234567", , , [10]], [, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NG", 234, "009", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], [
          ,
          "(\\d{3})(\\d{3})(\\d{3,4})",
          "$1 $2 $3",
          ["[7-9]"],
          "0$1"
        ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "700\\d{7,11}", , , , "7001234567", , , [10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]]],
        NI: [, [, , "(?:1800|[25-8]\\d{3})\\d{4}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [
          ,
          ,
          "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",
          ,
          ,
          ,
          "81234567"
        ], [, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        NL: [, [, , "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", , , , , , , [5, 6, 7, 8, 9, 10, 11]], [
          ,
          ,
          "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
          ,
          ,
          ,
          "101234567",
          ,
          ,
          [9]
        ], [, , "(?:6[1-58]|970\\d)\\d{7}", , , , "612345678", , , [9, 11]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:85|91)\\d{7}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["1[238]|[34]"]], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [
          ,
          "(\\d{3})(\\d{3})(\\d{5})",
          "$1 $2 $3",
          ["9"],
          "0$1"
        ]], [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d", , , , , , , [5, 6]], [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", , , , "14020", , , [5, 6, 9]], , , [, , , , , , , , , [-1]]],
        NO: [, [, , "(?:0|[2-9]\\d{3})\\d{4}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [
          ,
          ,
          "(?:4[015-8]|9\\d)\\d{6}",
          ,
          ,
          ,
          "40612345",
          ,
          ,
          [8]
        ], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], , [, , , , , , , , , [-1]], 1, "[02-689]|7[0-8]", [, , , , , , , , , [-1]], [, , "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
          ,
          ,
          "81[23]\\d{5}",
          ,
          ,
          ,
          "81212345",
          ,
          ,
          [8]
        ]],
        NP: [, [, , "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", , , , , , , [8, 10, 11], [6, 7]], [, , "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", , , , "14567890", , , [8], [6, 7]], [, , "9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}", , , , "9841234567", , , [10]], [, , "1(?:66001|800\\d\\d)\\d{5}", , , , "16600101234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [
          ,
          "(\\d{2})(\\d{6})",
          "$1-$2",
          ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],
          "0$1"
        ], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]], [, "(\\d{4})(\\d{2})(\\d{5})", "$1-$2-$3", ["1"]]], [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        NR: [, [, , "(?:444|(?:55|8\\d)\\d|666)\\d{4}", , , , , , , [7]], [, , "444\\d{4}", , , , "4441234"], [, , "(?:55[3-9]|666|8\\d\\d)\\d{4}", , , , "5551234"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NR", 674, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        NU: [
          ,
          [, , "(?:[4-7]|888\\d)\\d{3}", , , , , , , [4, 7]],
          [, , "[47]\\d{3}", , , , "7012", , , [4]],
          [, , "(?:[56]|888[1-9])\\d{3}", , , , "8884012"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "NU",
          683,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        NZ: [
          ,
          [, , "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", , , , , , , [5, 6, 7, 8, 9, 10]],
          [, , "240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", , , , "32345678", , , [8], [7]],
          [, , "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", , , , "211234567", , , [8, 9, 10]],
          [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456", , , [8, 9, 10]],
          [, , "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", , , , "900123456", , , [7, 8, 9, 10]],
          [, , , , , , , , , [-1]],
          [
            ,
            ,
            "70\\d{7}",
            ,
            ,
            ,
            "701234567",
            ,
            ,
            [9]
          ],
          [, , , , , , , , , [-1]],
          "NZ",
          64,
          "0(?:0|161)",
          "0",
          ,
          ,
          "0",
          ,
          "00",
          ,
          [[, "(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}", , , , "83012378"],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        OM: [, [, , "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", , , , , , , [7, 8, 9]], [, , "2[1-6]\\d{6}", , , , "23123456", , , [8]], [, , "(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}", , , , "92123456", , , [8]], [, , "8007\\d{4,5}|(?:500|800[05])\\d{4}", , , , "80071234"], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "OM", 968, "00", , , , , , , , [[
          ,
          "(\\d{3})(\\d{4,6})",
          "$1 $2",
          ["[58]"]
        ], [, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PA: [, [, , "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", , , , , , , [7, 8, 10, 11]], [
          ,
          ,
          "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
          ,
          ,
          ,
          "2001234",
          ,
          ,
          [7]
        ], [, , "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", , , , "61234567", , , [7, 8]], [, , "800\\d{4,5}|(?:00800|800\\d)\\d{6}", , , , "8001234"], [, , "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PE: [, [
          ,
          ,
          "(?:[14-8]|9\\d)\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8, 9],
          [6, 7]
        ], [, , "(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "00|19(?:1[124]|77|90)00", "0", " Anexo ", , "0", , "00", , [[
          ,
          "(\\d{3})(\\d{5})",
          "$1 $2",
          ["80"],
          "(0$1)"
        ], [, "(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PF: [
          ,
          [, , "4\\d{5}(?:\\d{2})?|8\\d{7,8}", , , , , , , [6, 8, 9]],
          [, , "4(?:0[4-689]|9[4-68])\\d{5}", , , , "40412345", , , [8]],
          [, , "8[7-9]\\d{6}", , , , "87123456", , , [8]],
          [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "499\\d{5}", , , , "49901234", , , [8]],
          "PF",
          689,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , "44\\d{4}", , , , , , , [6]],
          [, , "44\\d{4}", , , , "440123", , , [6]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        PG: [, [, , "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", , , , , , , [7, 8]], [, , "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", , , , "3123456", , , [7]], [, , "(?:7\\d|8[1-38])\\d{6}", , , , "70123456", , , [8]], [
          ,
          ,
          "180\\d{4}",
          ,
          ,
          ,
          "1801234",
          ,
          ,
          [7]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-57]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "00|140[1-3]", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], , [, , "27[01]\\d{4}", , , , "2700123", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PH: [, [, , "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [
          ,
          ,
          "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
          ,
          ,
          ,
          "232345678",
          ,
          ,
          [6, 8, 9, 10],
          [4, 5, 7]
        ], [, , "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [
          ,
          "(\\d{4})(\\d{4,6})",
          "$1 $2",
          ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
          "(0$1)"
        ], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PK: [, [
          ,
          ,
          "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8, 9, 10, 11, 12],
          [5, 6, 7]
        ], [, , "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", , , , "2123456789", , , [9, 10], [5, 6, 7, 8]], [, , "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}(?:\\d{3})?", , , , "80012345", , , [8, 11]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [
          ,
          ,
          "122\\d{6}",
          ,
          ,
          ,
          "122044444",
          ,
          ,
          [9]
        ], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [
          ,
          "(\\d{3})(\\d{6,7})",
          "$1 $2",
          ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
          "(0$1)"
        ], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
          ,
          ,
          "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
          ,
          ,
          ,
          "21111825888",
          ,
          ,
          [11, 12]
        ], , , [, , , , , , , , , [-1]]],
        PL: [, [, , "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [, , "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", , , , "123456789", , , [7, 9]], [, , "21(?:1[013-5]|2\\d)\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [
          ,
          ,
          "801\\d{6}",
          ,
          ,
          ,
          "801234567",
          ,
          ,
          [9]
        ], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [[, "(\\d{5})", "$1", ["19"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], [
          ,
          "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["1[2-8]|[2-7]|8[1-79]|9[145]"]
        ], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], , [, , "64\\d{4,7}", , , , "641234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]],
        PM: [
          ,
          [, , "[45]\\d{5}|(?:708|80\\d)\\d{6}", , , , , , , [6, 9]],
          [, , "(?:4[1-35-7]|5[01])\\d{4}", , , , "430123", , , [6]],
          [, , "(?:4[02-4]|5[056]|708[45][0-5])\\d{4}", , , , "551234"],
          [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "PM",
          508,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        PR: [, [, , "(?:[589]\\d\\d|787)\\d{7}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PS: [, [, , "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", , , , , , , [8, 9, 10], [7]], [
          ,
          ,
          "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
          ,
          ,
          ,
          "22234567",
          ,
          ,
          [8],
          [7]
        ], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        PT: [
          ,
          [, , "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", , , , , , , [9]],
          [, , "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}", , , , "212345678"],
          [, , "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}", , , , "912345678"],
          [, , "80[02]\\d{6}", , , , "800123456"],
          [, , "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}", , , , "760123456"],
          [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"],
          [, , "884[0-4689]\\d{5}", , , , "884123456"],
          [, , "30\\d{7}", , , , "301234567"],
          "PT",
          351,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[
            ,
            "(\\d{2})(\\d{3})(\\d{4})",
            "$1 $2 $3",
            ["2[12]"]
          ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]],
          ,
          [, , "6(?:222\\d|8988)\\d{4}", , , , "622212345"],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}", , , , "707123456"],
          ,
          ,
          [, , "600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}", , , , "600110000"]
        ],
        PW: [
          ,
          [, , "(?:[24-8]\\d\\d|345|900)\\d{4}", , , , , , , [7]],
          [, , "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}", , , , "2771234"],
          [, , "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}", , , , "6201234"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "PW",
          680,
          "01[12]",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        PY: [, [, , "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [
          ,
          ,
          "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
          ,
          ,
          ,
          "212345678",
          ,
          ,
          [7, 8, 9],
          [5, 6]
        ], [, , "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , "9800\\d{5,7}", , , , "98000123456", , , [9, 10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], [
          ,
          "(\\d{2})(\\d{3})(\\d{3,4})",
          "$1 $2 $3",
          ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
          "(0$1)"
        ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]]],
        QA: [, [, , "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", , , , , , , [7, 8, 9, 11]], [
          ,
          ,
          "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
          ,
          ,
          ,
          "44123456",
          ,
          ,
          [8]
        ], [, , "[35-7]\\d{7}", , , , "33123456", , , [8]], [, , "800\\d{4}|(?:0080[01]|800)\\d{6}", , , , "8001234", , , [7, 9, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], , [, , "2[16]\\d{5}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        RE: [, [, , "(?:26|[689]\\d)\\d{7}", , , , , , , [9]], [, , "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}", , , , "262161234"], [
          ,
          ,
          "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}",
          ,
          ,
          ,
          "692123456"
        ], [, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}", , , , "939901234"], "RE", 262, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        RO: [, [, , "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", , , , , , , [6, 9]], [
          ,
          ,
          "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
          ,
          ,
          ,
          "211234567"
        ], [, , "(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", , , , "712034567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[0136]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["[236-9]"],
          "0$1"
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:37\\d|80[578])\\d{6}", , , , "372123456", , , [9]], , , [, , , , , , , , , [-1]]],
        RS: [, [, , "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", , , , , , , [6, 7, 8, 9, 10, 11, 12], [4, 5]], [, , "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", , , , "10234567", , , [7, 8, 9, 10, 11, 12], [4, 5, 6]], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [
          ,
          ,
          "800\\d{3,9}",
          ,
          ,
          ,
          "80012345"
        ], [, , "(?:78\\d|90[0169])\\d{3,7}", , , , "90012345", , , [6, 7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RS", 381, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], [, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]],
        RU: [, [, , "8\\d{13}|[347-9]\\d{9}", , , , , , , [10, 14], [7]], [
          ,
          ,
          "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
          ,
          ,
          ,
          "3011234567",
          ,
          ,
          [10],
          [7]
        ], [, , "9\\d{9}", , , , "9123456789", , , [10]], [, , "8(?:0[04]|108\\d{3})\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[0-79]"]], [
          ,
          "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],
          "8 ($1)",
          ,
          1
        ], [, "(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [
          ,
          "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
          "$1 $2-$3-$4",
          ["[349]|8(?:[02-7]|1[1-8])"],
          "8 ($1)",
          ,
          1
        ], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [[, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [
          ,
          "(\\d{5})(\\d)(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
          "8 ($1)",
          ,
          1
        ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [, , , , , , , , , [-1]], 1, "3[04-689]|[489]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        RW: [, [, , "(?:06|[27]\\d\\d|[89]00)\\d{6}", , , , , , , [8, 9]], [, , "(?:06|2[23568]\\d)\\d{6}", , , , "250123456"], [, , "7[237-9]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
          ,
          ,
          "900\\d{6}",
          ,
          ,
          ,
          "900123456",
          ,
          ,
          [9]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SA: [, [, , "92\\d{7}|(?:[15]|8\\d)\\d{8}", , , , , , , [9, 10], [7]], [, , "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", , , , "112345678", , , [9], [7]], [
          ,
          ,
          "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
          ,
          ,
          ,
          "512345678",
          ,
          ,
          [9]
        ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "925\\d{6}", , , , "925012345", , , [9]], [, , "920\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["9"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
          ,
          ,
          "811\\d{7}",
          ,
          ,
          ,
          "8110123456",
          ,
          ,
          [10]
        ], , , [, , , , , , , , , [-1]]],
        SB: [, [, , "[6-9]\\d{6}|[1-6]\\d{4}", , , , , , , [5, 7]], [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]], [, , "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}", , , , "7421234"], [, , "1[38]\\d{3}", , , , "18123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[12]\\d{3}", , , , "51123", , , [5]], "SB", 677, "0[01]", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SC: [, [, , "(?:[2489]\\d|64)\\d{5}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[125-8]\\d{5}", , , , "2510123"], [, , "800[08]\\d{3}", , , , "8000000"], [, , "85\\d{5}", , , , "8512345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "971\\d{4}|(?:64|95)\\d{5}", , , , "6412345"], "SC", 248, "010|0[0-2]", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SD: [, [, , "[19]\\d{8}", , , , , , , [9]], [
          ,
          ,
          "1(?:5\\d|8[35-7])\\d{6}",
          ,
          ,
          ,
          "153123456"
        ], [, , "(?:1[0-2]|9[0-3569])\\d{7}", , , , "911231234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SE: [, [, , "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", , , , , , , [6, 7, 8, 9, 10, 12]], [
          ,
          ,
          "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
          ,
          ,
          ,
          "8123456",
          ,
          ,
          [7, 8, 9]
        ], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77[0-7]\\d{6}", , , , "771234567", , , [9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1"], [
          ,
          "(\\d{2})(\\d{3})(\\d{2})",
          "$1-$2 $3",
          ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
          "0$1"
        ], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1"], [
          ,
          "(\\d)(\\d{3})(\\d{3})(\\d{2})",
          "$1-$2 $3 $4",
          ["8"],
          "0$1"
        ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1"]], [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["9(?:00|39|44|9)"]], [, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [
          ,
          "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["8"]
        ], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["10|7"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [
          ,
          "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]
        ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "10[1-8]\\d{6}", , , , "102345678", , , [9]], , , [, , "(?:25[245]|67[3-68])\\d{9}", , , , "254123456789", , , [12]]],
        SG: [, [, , "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", , , , , , , [8, 10, 11]], [
          ,
          ,
          "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
          ,
          ,
          ,
          "61234567",
          ,
          ,
          [8]
        ], [, , "(?:8(?:0(?:[1-8]\\d|9[0-689])|[1-8]\\d\\d|9(?:[0-4]\\d|5[0-3]|62))|9[0-8]\\d\\d)\\d{4}", , , , "81234567", , , [8]], [, , "(?:18|8)00\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[12]\\d|666)\\d{5}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [[, "(\\d{4,5})", "$1", ["1[013-9]|77", "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], [
          ,
          "(\\d{3})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["8"]
        ], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [[, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]],
        SH: [, [, , "(?:[256]\\d|8)\\d{3}", , , , , , , [4, 5]], [, , "2(?:[0-57-9]\\d|6[4-9])\\d\\d", , , , "22158"], [
          ,
          ,
          "[56]\\d{4}",
          ,
          ,
          ,
          "51234",
          ,
          ,
          [5]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "262\\d\\d", , , , "26212", , , [5]], "SH", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], 1, "[256]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SI: [, [, , "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", , , , , , , [5, 6, 7, 8]], [, , "(?:[1-357][2-8]|4[24-8])\\d{6}", , , , "12345678", , , [8], [7]], [, , "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", , , , "31234567", , , [8]], [, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 8]], [
          ,
          ,
          "89[1-3]\\d{2,5}|90\\d{4,6}",
          ,
          ,
          ,
          "90123456"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", , , , "59012345", , , [8]], "SI", 386, "00|10(?:22|66|88|99)", "0", , , "0", , "00", , [[, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        SJ: [, [, , "0\\d{4}|(?:[489]\\d|79)\\d{6}", , , , , , , [5, 8]], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "79", [, , , , , , , , , [-1]], [, , "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
          ,
          ,
          "81[23]\\d{5}",
          ,
          ,
          ,
          "81212345",
          ,
          ,
          [8]
        ]],
        SK: [, [, , "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", , , , , , , [6, 7, 9]], [, , "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d", , , , "221234567"], [, , "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", , , , "912123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:00|[78]\\d)\\d{6}", , , , "900123456", , , [9]], [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]], [, , , , , , , , , [-1]], [
          ,
          ,
          "6(?:02|5[0-4]|9[0-6])\\d{6}",
          ,
          ,
          ,
          "690123456",
          ,
          ,
          [9]
        ], "SK", 421, "00", "0", , , "0", , , , [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [
          ,
          "(\\d{2})(\\d{2})(\\d{2,3})",
          "$1 $2 $3",
          ["[3-5][1-8]1", "[3-5][1-8]1[67]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], [, , "9090\\d{3}", , , , "9090123", , , [7]], , , [, , "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}", , , , , , , [7, 9]], [, , "96\\d{7}", , , , "961234567", , , [9]], , , [, , , , , , , , , [-1]]],
        SL: [, [, , "(?:[237-9]\\d|66)\\d{6}", , , , , , , [8], [6]], [, , "22[2-4][2-9]\\d{4}", , , , "22221234", , , , [6]], [
          ,
          ,
          "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",
          ,
          ,
          ,
          "25123456"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SM: [, [, , "(?:0549|[5-7]\\d)\\d{6}", , , , , , , [8, 10], [6]], [, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]], [, , "6[16]\\d{6}", , , , "66661212", , , [8]], [, , , , , , , , , [-1]], [, , "7[178]\\d{6}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "5[158]\\d{6}",
          ,
          ,
          ,
          "58001110",
          ,
          ,
          [8]
        ], "SM", 378, "00", , , , "([89]\\d{5})$", "0549$1", , , [[, "(\\d{6})", "$1", ["[89]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SN: [, [, , "(?:[378]\\d|93)\\d{7}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [
          ,
          ,
          "7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|[38]3|[4-7]\\d))\\d{5}",
          ,
          ,
          ,
          "701234567"
        ], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", , , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SO: [, [, , "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", , , , , , , [6, 7, 8, 9]], [
          ,
          ,
          "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
          ,
          ,
          ,
          "4012345",
          ,
          ,
          [6, 7]
        ], [, , "(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], [
          ,
          "(\\d)(\\d{7})",
          "$1 $2",
          ["(?:2|90)4|[67]"]
        ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SR: [, [, , "(?:[2-5]|68|[78]\\d)\\d{5}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}", , , , "211234"], [, , "(?:7[124-7]|8[124-9])\\d{5}", , , , "7412345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "56\\d{4}", , , , "561234", , , [6]], "SR", 597, "00", , , , , , , , [[
          ,
          "(\\d{2})(\\d{2})(\\d{2})",
          "$1-$2-$3",
          ["56"]
        ], [, "(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SS: [, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1[89]\\d{7}", , , , "181234567"], [, , "(?:12|9[1257-9])\\d{7}", , , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        ST: [, [, , "(?:22|9\\d)\\d{5}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}", , , , "9812345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SV: [, [, , "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", , , , , , , [7, 8, 11]], [
          ,
          ,
          "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
          ,
          ,
          ,
          "21234567",
          ,
          ,
          [8]
        ], [, , "[67]\\d{7}", , , , "70123456", , , [8]], [, , "800\\d{8}|80[01]\\d{4}", , , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SX: [
          ,
          [, , "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
          [
            ,
            ,
            "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
            ,
            ,
            ,
            "7215425678",
            ,
            ,
            ,
            [7]
          ],
          [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]],
          [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
          [, , "900[2-9]\\d{6}", , , , "9002123456"],
          [, , , , , , , , , [-1]],
          [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
          [, , , , , , , , , [-1]],
          "SX",
          1,
          "011",
          "1",
          ,
          ,
          "(5\\d{6})$|1",
          "721$1",
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          "721",
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        SY: [, [, , "[1-39]\\d{8}|[1-5]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}", , , , "112345678", , , , [6, 7]], [, , "9[1-689]\\d{7}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", , 1], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["9"],
          "0$1",
          ,
          1
        ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        SZ: [, [, , "0800\\d{4}|(?:[237]\\d|900)\\d{6}", , , , , , , [8, 9]], [, , "[23][2-5]\\d{6}", , , , "22171234", , , [8]], [, , "7[6-9]\\d{6}", , , , "76123456", , , [8]], [, , "0800\\d{4}", , , , "08001234", , , [8]], [, , "900\\d{6}", , , , "900012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70\\d{6}", , , , "70012345", , , [8]], "SZ", 268, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["9"]]], , [, , , , , , , , , [-1]], , , [
          ,
          ,
          "0800\\d{4}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8]
        ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TA: [, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TC: [, [, , "(?:[58]\\d\\d|649|900)\\d{7}", , , , , , , [10], [7]], [, , "649(?:266|712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]], [, , "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}", , , , "6492311234", , , , [7]], [
          ,
          ,
          "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "8002345678"
        ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "649(?:71[01]|966)\\d{4}", , , , "6497101234", , , , [7]], "TC", 1, "011", "1", , , "([2-479]\\d{6})$|1", "649$1", , , , , [, , , , , , , , , [-1]], , "649", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TD: [, [, , "(?:22|[689]\\d|77)\\d{6}", , , , , , , [8]], [, , "22(?:[37-9]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:[69]\\d|77|8[56])\\d{6}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", , , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TG: [, [, , "[279]\\d{7}", , , , , , , [8]], [, , "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}", , , , "22212345"], [
          ,
          ,
          "(?:7[019]|9[0-36-9])\\d{6}",
          ,
          ,
          ,
          "90112345"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TH: [, [, , "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", , , , , , , [8, 9, 10, 13]], [, , "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [, , "67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", , , , "812345678", , , [9]], [
          ,
          ,
          "(?:001800\\d|1800)\\d{6}",
          ,
          ,
          ,
          "1800123456",
          ,
          ,
          [10, 13]
        ], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00[1-9]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TJ: [, [, , "[0-57-9]\\d{8}", , , , , , , [9], [3, 5, 6, 7]], [
          ,
          ,
          "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
          ,
          ,
          ,
          "372123456",
          ,
          ,
          ,
          [3, 5, 6, 7]
        ], [, , "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[017]|2[02]|[34]0|5[05]|7[01578]|8[078])\\d{7}", , , , "917123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TJ", 992, "810", , , , , , "8~10", , [[, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TK: [, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TL: [
          ,
          [, , "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", , , , , , , [7, 8]],
          [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]],
          [, , "7[2-8]\\d{6}", , , , "77212345", , , [8]],
          [, , "80\\d{5}", , , , "8012345", , , [7]],
          [, , "90\\d{5}", , , , "9012345", , , [7]],
          [, , , , , , , , , [-1]],
          [, , "70\\d{5}", , , , "7012345", , , [7]],
          [, , , , , , , , , [-1]],
          "TL",
          670,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        TM: [, [, , "(?:[1-6]\\d|71)\\d{6}", , , , , , , [8]], [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"], [
          ,
          ,
          "(?:6\\d|71)\\d{6}",
          ,
          ,
          ,
          "66123456"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TM", 993, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TN: [, [, , "[2-57-9]\\d{7}", , , , , , , [8]], [, , "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}", , , , "30010123"], [
          ,
          ,
          "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
          ,
          ,
          ,
          "20123456"
        ], [, , "8010\\d{4}", , , , "80101234"], [, , "88\\d{6}", , , , "88123456"], [, , "8[12]10\\d{4}", , , , "81101234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TN", 216, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TO: [, [, , "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", , , , , , , [5, 7]], [, , "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", , , , "20123", , , [5]], [
          ,
          ,
          "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
          ,
          ,
          ,
          "7715123",
          ,
          ,
          [7]
        ], [, , "0800\\d{3}", , , , "0800222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "55[0-37-9]\\d{4}", , , , "5510123", , , [7]], "TO", 676, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TR: [, [, , "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", , , , , , , [7, 10, 12, 13]], [
          ,
          ,
          "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
          ,
          ,
          ,
          "2123456789",
          ,
          ,
          [10]
        ], [, , "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", , , , "5012345678", , , [10]], [, , "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", , , , "8001234567", , , [10, 12, 13]], [, , "(?:8[89]8|900)\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , "592(?:21[12]|461)\\d{4}", , , , "5922121234", , , [10]], [, , "850\\d{7}", , , , "8500123456", , , [10]], "TR", 90, "00", "0", , , "0", , , , [
          [, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"], , , 1],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1],
          [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", , 1],
          [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1],
          [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]
        ], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", , 1], [
          ,
          "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4",
          ["[24][1-8]|3[1-9]"],
          "(0$1)",
          ,
          1
        ], [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]], [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "(?:444|811\\d{3})\\d{4}", , , , , , , [7, 10]], [, , "444\\d{4}", , , , "4441444", , , [7]], , , [, , , , , , , , , [-1]]],
        TT: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [
          ,
          ,
          "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
          ,
          ,
          ,
          "8682911234",
          ,
          ,
          ,
          [7]
        ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "([2-46-8]\\d{6})$|1", "868$1", , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]],
        TV: [, [, , "(?:2|7\\d\\d|90)\\d{4}", , , , , , , [5, 6, 7]], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:7[01]\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2"]], [, "(\\d{2})(\\d{4})", "$1 $2", ["90"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        TW: [, [
          ,
          ,
          "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 8, 9, 10, 11]
        ], [
          ,
          ,
          "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
          ,
          ,
          ,
          "221234567",
          ,
          ,
          [8, 9]
        ], [, , "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}|800\\d{5}", , , , "800123456", , , [8, 9]], [, , "20(?:[013-9]\\d\\d|2)\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", , , , "7012345678", , , [10, 11]], "TW", 886, "0(?:0[25-79]|19)", "0", "#", , "0", , , , [[, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], [
          ,
          "(\\d)(\\d{3,4})(\\d{4})",
          "$1 $2 $3",
          ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],
          "0$1"
        ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]],
        TZ: [
          ,
          [, , "(?:[25-8]\\d|41|90)\\d{7}", , , , , , , [9]],
          [, , "2[2-8]\\d{7}", , , , "222345678"],
          [, , "(?:6[125-9]|7[13-9])\\d{7}", , , , "621234567"],
          [, , "80[08]\\d{6}", , , , "800123456"],
          [, , "90\\d{7}", , , , "900123456"],
          [, , "8(?:40|6[01])\\d{6}", , , , "840123456"],
          [, , , , , , , , , [-1]],
          [, , "41\\d{7}", , , , "412345678"],
          "TZ",
          255,
          "00[056]",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["5"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        UA: [, [, , "[89]\\d{9}|[3-9]\\d{8}", , , , , , , [9, 10], [5, 6, 7]], [
          ,
          ,
          "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
          ,
          ,
          ,
          "311234567",
          ,
          ,
          [9],
          [5, 6, 7]
        ], [, , "790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", , , , "501234567", , , [9]], [, , "800[1-8]\\d{5,6}", , , , "800123456"], [, , "900[239]\\d{5,6}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567", , , [9]], "UA", 380, "00", "0", , , "0", , "0~0", , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], [
          ,
          "(\\d{4})(\\d{5})",
          "$1 $2",
          ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],
          "0$1"
        ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        UG: [, [, , "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", , , , , , , [9], [5, 6, 7]], [
          ,
          ,
          "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
          ,
          ,
          ,
          "312345678",
          ,
          ,
          ,
          [5, 6, 7]
        ], [, , "72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-5]|9[89])\\d{6}", , , , "712345678"], [, , "800[1-3]\\d{5}", , , , "800123456"], [, , "90[1-3]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        US: [, [
          ,
          ,
          "[2-9]\\d{9}|3\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [10],
          [7]
        ], [
          ,
          ,
          "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
          ,
          ,
          ,
          "2015550123",
          ,
          ,
          ,
          [7]
        ], [
          ,
          ,
          "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
          ,
          ,
          ,
          "2015550123",
          ,
          ,
          ,
          [7]
        ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "305209\\d{4}", , , , "3052090123", , , , [7]], "US", 1, "011", "1", , , "1", , , 1, [
          [, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1],
          [, "(\\d{3})(\\d{4})", "$1-$2", ["[24-9]|3(?:[02-9]|1[1-9])"]],
          [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], , , 1]
        ], [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        UY: [, [, , "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11, 12, 13]], [, , "(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [
          ,
          ,
          "0004\\d{2,9}|(?:405|80[05])\\d{4}",
          ,
          ,
          ,
          "8001234"
        ], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ", , "0", , "00", , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], [, "(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        UZ: [, [, , "(?:20|33|[5-79]\\d|88)\\d{7}", , , , , , , [9]], [, , "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}", , , , "669050123"], [
          ,
          ,
          "(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
          ,
          ,
          ,
          "912345678"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        VA: [, [, , "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , "06698\\d{1,6}", , , , "0669812345", , , [6, 7, 8, 9, 10, 11]], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [
          ,
          ,
          "80(?:0\\d{3}|3)\\d{3}",
          ,
          ,
          ,
          "800123456",
          ,
          ,
          [6, 9]
        ], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "06698", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
        VC: [
          ,
          [, , "(?:[58]\\d\\d|784|900)\\d{7}", , , , , , , [10], [7]],
          [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]],
          [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}", , , , "7844301234", , , , [7]],
          [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
          [, , "900[2-9]\\d{6}", , , , "9002345678"],
          [, , , , , , , , , [-1]],
          [
            ,
            ,
            "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
            ,
            ,
            ,
            "5002345678"
          ],
          [, , "78451[0-2]\\d{4}", , , , "7845101234", , , , [7]],
          "VC",
          1,
          "011",
          "1",
          ,
          ,
          "([2-7]\\d{6})$|1",
          "784$1",
          ,
          ,
          ,
          ,
          [, , , , , , , , , [-1]],
          ,
          "784",
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        VE: [
          ,
          [, , "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", , , , , , , [10], [7]],
          [, , "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}", , , , "2121234567", , , , [7]],
          [, , "4(?:1[24-8]|2[46])\\d{7}", , , , "4121234567"],
          [, , "800\\d{7}", , , , "8001234567"],
          [, , "90[01]\\d{7}", , , , "9001234567"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "VE",
          58,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1", "$CC $1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "501\\d{7}", , , , "5010123456", , , , [7]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        VG: [, [, , "(?:284|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}", , , , "2842291234", , , , [7]], [, , "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
          ,
          ,
          "900[2-9]\\d{6}",
          ,
          ,
          ,
          "9002345678"
        ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "([2-578]\\d{6})$|1", "284$1", , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        VI: [, [, , "[58]\\d{9}|(?:34|90)0\\d{7}", , , , , , , [10], [7]], [
          ,
          ,
          "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
          ,
          ,
          ,
          "3406421234",
          ,
          ,
          ,
          [7]
        ], [, , "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "([2-9]\\d{6})$|1", "340$1", , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        VN: [, [, , "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", , , , , , , [7, 8, 9, 10]], [, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", , , , "2101234567", , , [10]], [, , "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", , , , "912345678", , , [9]], [
          ,
          ,
          "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
          ,
          ,
          ,
          "1800123456",
          ,
          ,
          [8, 9, 10]
        ], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "672\\d{6}", , , , "672012345", , , [9]], "VN", 84, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [
          ,
          "(\\d{2})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["2[48]"],
          "0$1",
          ,
          1
        ], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [[, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , , , , [7, 8]], [
          ,
          ,
          "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
          ,
          ,
          ,
          "1992000",
          ,
          ,
          [7, 8]
        ], , , [, , , , , , , , , [-1]]],
        VU: [
          ,
          [, , "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", , , , , , , [5, 7]],
          [, , "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", , , , "22123", , , [5]],
          [, , "(?:[58]\\d|7[013-7])\\d{5}", , , , "5912345", , , [7]],
          [, , "81[18]\\d\\d", , , , "81123", , , [5]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "9(?:0[1-9]|1[01])\\d{4}", , , , "9010123", , , [7]],
          "VU",
          678,
          "00",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , "(?:3[03]|900\\d)\\d{3}", , , , "30123"],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        WF: [, [, , "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", , , , , , , [6, 9]], [, , "72\\d{4}", , , , "721234", , , [6]], [, , "(?:72|8[23])\\d{4}", , , , "821234", , , [6]], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234", , , [6]]],
        WS: [, [
          ,
          ,
          "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [5, 6, 7, 10]
        ], [, , "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", , , , "22123", , , [5, 6]], [, , "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", , , , "7212345", , , [7, 10]], [, , "800\\d{3}", , , , "800123", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WS", 685, "0", , , , , , , , [[, "(\\d{5})", "$1", ["[2-5]|6[1-9]"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        XK: [
          ,
          [
            ,
            ,
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            ,
            ,
            ,
            ,
            ,
            ,
            [8, 9, 10, 11, 12]
          ],
          [, , "38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})", , , , "28012345"],
          [, , "4[3-9]\\d{6}", , , , "43201234", , , [8]],
          [, , "800\\d{5}", , , , "80001234", , , [8]],
          [, , "900\\d{5}", , , , "90001234", , , [8]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "XK",
          383,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], [, "(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        YE: [
          ,
          [, , "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", , , , , , , [7, 8, 9], [6]],
          [, , "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", , , , "1234567", , , [7, 8], [6]],
          [, , "7[01378]\\d{7}", , , , "712345678", , , [9]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "YE",
          967,
          "00",
          "0",
          ,
          ,
          "0",
          ,
          ,
          ,
          [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        YT: [, [, , "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", , , , , , , [9]], [, , "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}", , , , "269601234"], [, , "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}", , , , "639012345"], [, , "80\\d{7}", , , , "801234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:39|47)8[01]|769\\d)\\d{4}", , , , "939801234"], "YT", 262, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        ZA: [, [, , "[1-79]\\d{8}|8\\d{4,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", , , , "101234567", , , [9]], [, , "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", , , , "711234567", , , [5, 6, 7, 8, 9]], [
          ,
          ,
          "80\\d{7}",
          ,
          ,
          ,
          "801234567",
          ,
          ,
          [9]
        ], [, , "(?:86[2-9]|9[0-2]\\d)\\d{6}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [, , "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", , , , "871234567", , , [9]], "ZA", 27, "00", "0", , , "0", , , , [
          [, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"],
          [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"],
          [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"],
          [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]
        ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6,7}", , , , "861123456", , , [9, 10]], , , [, , , , , , , , , [-1]]],
        ZM: [, [, , "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", , , , , , , [9], [6]], [, , "21[1-8]\\d{6}", , , , "211234567", , , , [6]], [, , "(?:7[5-79]|9[5-8])\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "63\\d{7}", , , , "630123456"], "ZM", 260, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[1-9]"]], [
          ,
          "(\\d{3})(\\d{3})(\\d{3})",
          "$1 $2 $3",
          ["[28]"],
          "0$1"
        ], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        ZW: [, [, , "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [
          ,
          ,
          "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
          ,
          ,
          ,
          "1312345",
          ,
          ,
          ,
          [3, 4]
        ], [, , "7(?:[1278]\\d|3[1-9])\\d{6}", , , , "712345678", , , [9]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [
          [, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"],
          [, "(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"],
          [, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
          [, "(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"],
          [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
          [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"],
          [, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"],
          [
            ,
            "(\\d{2})(\\d{3,5})",
            "$1 $2",
            ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
            "0$1"
          ],
          [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"],
          [, "(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]
        ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        800: [
          ,
          [, , "(?:00|[1-9]\\d)\\d{6}", , , , , , , [8]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , "(?:00|[1-9]\\d)\\d{6}", , , , "12345678"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "001",
          800,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          1,
          [[, "(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        808: [, [, , "[1-9]\\d{7}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1-9]\\d{7}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        870: [, [, , "7\\d{11}|[35-7]\\d{8}", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        878: [, [, , "10\\d{10}", , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        881: [
          ,
          [, , "6\\d{9}|[0-36-9]\\d{8}", , , , , , , [9, 10]],
          [, , , , , , , , , [-1]],
          [, , "6\\d{9}|[0-36-9]\\d{8}", , , , "612345678"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          "001",
          881,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], [, "(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]],
          ,
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          ,
          [, , , , , , , , , [-1]]
        ],
        882: [, [, , "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [
          ,
          ,
          "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
          ,
          ,
          ,
          "3421234",
          ,
          ,
          [7, 8, 9, 10, 12]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["49"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], [, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [
          ,
          "(\\d{2})(\\d{3,4})(\\d{4})",
          "$1 $2 $3",
          ["16"]
        ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]],
        883: [, [, , "(?:[1-4]\\d|51)\\d{6,10}", , , , , , , [8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
          ,
          ,
          ,
          "510012345"
        ], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
        888: [, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], , , [, , , , , , , , , [-1]]],
        979: [, [, , "[1359]\\d{8}", , , , , , , [9], [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1359]\\d{8}", , , , "123456789", , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]
      };
      function Fe() {
        this.g = {};
      }
      t(Fe);
      var Xe = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "０": "0", "１": "1", "２": "2", "３": "3", "４": "4", "５": "5", "６": "6", "７": "7", "８": "8", "９": "9", "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4", "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9", "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4", "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9" }, ot = {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        "+": "+",
        "*": "*",
        "#": "#"
      }, ct = {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        "０": "0",
        "１": "1",
        "２": "2",
        "３": "3",
        "４": "4",
        "５": "5",
        "６": "6",
        "７": "7",
        "８": "8",
        "９": "9",
        "٠": "0",
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        "۰": "0",
        "۱": "1",
        "۲": "2",
        "۳": "3",
        "۴": "4",
        "۵": "5",
        "۶": "6",
        "۷": "7",
        "۸": "8",
        "۹": "9",
        A: "2",
        B: "2",
        C: "2",
        D: "3",
        E: "3",
        F: "3",
        G: "4",
        H: "4",
        I: "4",
        J: "5",
        K: "5",
        L: "5",
        M: "6",
        N: "6",
        O: "6",
        P: "7",
        Q: "7",
        R: "7",
        S: "7",
        T: "8",
        U: "8",
        V: "8",
        W: "9",
        X: "9",
        Y: "9",
        Z: "9"
      }, ft = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/, lt = RegExp("[+＋]+"), ut = RegExp("^[+＋]+"), gn = RegExp("([0-9０-９٠-٩۰-۹])"), sn = RegExp("[+＋0-9０-９٠-٩۰-۹]"), zn = /[\\\/] *x/, Qn = RegExp("[^0-9０-９٠-٩۰-۹A-Za-z#]+$"), br = /(?:.*?[A-Za-z]){3}.*/, er = RegExp("^\\+([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*[0-9０-９٠-٩۰-۹]([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*$"), yr = RegExp("^([A-Za-z0-9０-９٠-٩۰-۹]+((\\-)*[A-Za-z0-9０-９٠-٩۰-۹])*\\.)*[A-Za-z]+((\\-)*[A-Za-z0-9０-９٠-٩۰-۹])*\\.?$");
      function bn(b) {
        return "([0-9０-９٠-٩۰-۹]{1," + b + "})";
      }
      function on() {
        return ";ext=" + bn("20") + "|[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*" + (bn("20") + "#?|[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*") + (bn("9") + "#?|[- ]+") + (bn("6") + "#|[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*") + (bn("15") + "#?|[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*") + (bn("9") + "#?");
      }
      var vr = new RegExp("(?:" + on() + ")$", "i"), Qr = new RegExp("^[0-9０-９٠-٩۰-۹]{2}$|^[+＋]*(?:[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～*]*[0-9０-９٠-٩۰-۹]){3,}[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～*A-Za-z0-9０-９٠-٩۰-۹]*(?:" + on() + ")?$", "i"), _r = /(\$\d)/, Q = /^\(?\$1\)?$/;
      function pe(b) {
        return 2 > b.length ? !1 : Mn(Qr, b);
      }
      function ye(b) {
        return Mn(br, b) ? Zt(b, ct) : Zt(b, Xe);
      }
      function Ve(b) {
        var C = ye(b.toString());
        ue(b), b.g(C);
      }
      function De() {
        return Object.keys(Be).filter(function(b) {
          return isNaN(b);
        });
      }
      function pt() {
        return Object.keys(Be).filter(function(b) {
          return !isNaN(b);
        }).map(function(b) {
          return parseInt(b, 10);
        });
      }
      function Et() {
        var b = Object.keys(we);
        return [...pt(), ...b.map(function(C) {
          return parseInt(C, 10);
        })];
      }
      function Zt(b, C) {
        for (var P = new _e(), F, H = b.length, ee = 0; ee < H; ++ee) F = b.charAt(ee), F = C[F.toUpperCase()], F != null && P.g(F);
        return P.toString();
      }
      function $r(b) {
        return b.length == 0 || Q.test(b);
      }
      function Lt(b) {
        return b != null && isNaN(b) && b.toUpperCase() in Be;
      }
      Fe.prototype.format = function(b, C) {
        if (M(b, 2) == 0 && I(b, 5)) {
          var P = D(b, 5);
          if (0 < P.length) return P;
        }
        P = D(b, 1);
        var F = Ft(b);
        if (C == 0) return ks(P, 0, F, "");
        if (!(P in we)) return F;
        var H = an(this, P, wr(P));
        return b = y0(b, H, C), F = Ni(F, H, C), ks(P, C, F, b);
      };
      function an(b, C, P) {
        return P == "001" ? Vn(b, "" + C) : Vn(b, P);
      }
      function xr(b, C) {
        var P = jt;
        if (!Lt(C)) return P.format(b, 1);
        var F = D(b, 1), H = Ft(b);
        if (!(F in we)) return H;
        if (F == 1) {
          if (C != null && we[1].includes(C.toUpperCase())) return F + " " + P.format(b, 2);
        } else if (F == Cs(P, C)) return P.format(b, 2);
        var ee = Vn(P, C), se = D(ee, 11);
        return C = "", I(ee, 17) ? C = D(ee, 17) : Mn(ft, se) && (C = se), P = an(P, F, wr(F)), H = Ni(H, P, 1), b = y0(b, P, 1), 0 < C.length ? C + " " + F + " " + H + b : ks(F, 1, H, b);
      }
      function Ft(b) {
        if (!I(b, 2)) return "";
        var C = "" + M(b, 2);
        return I(b, 4) && M(b, 4) && 0 < D(b, 8) ? Array(D(b, 8) + 1).join("0") + C : C;
      }
      function ks(b, C, P, F) {
        switch (C) {
          case 0:
            return "+" + b + P + F;
          case 1:
            return "+" + b + " " + P + F;
          case 3:
            return "tel:+" + b + "-" + P + F;
          default:
            return P + F;
        }
      }
      function Ni(b, C, P) {
        C = j(C, 20).length == 0 || P == 2 ? j(C, 19) : j(C, 20);
        e: {
          for (var F, H = C.length, ee = 0; ee < H; ++ee) {
            F = C[ee];
            var se = U(F, 3);
            if ((se == 0 || b.search(M(F, 3, se - 1)) == 0) && (se = new RegExp(M(F, 1)), Mn(se, b))) {
              C = F;
              break e;
            }
          }
          C = null;
        }
        return C == null || (H = C, C = D(H, 2), F = new RegExp(M(H, 1)), D(H, 5), H = D(H, 4), b = P == 2 && H != null && 0 < H.length ? b.replace(F, C.replace(_r, H)) : b.replace(F, C), P == 3 && (b = b.replace(RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]+"), ""), b = b.replace(RegExp("[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]+", "g"), "-"))), P = b, P;
      }
      function ei(b, C) {
        var P = jt;
        if (!Lt(b)) return null;
        C = v0(Vn(P, b), C);
        try {
          if (I(C, 6)) {
            var F = M(C, 6);
            return Gl(P, F, b);
          }
        } catch {
        }
        return null;
      }
      function y0(b, C, P) {
        return I(b, 3) && M(b, 3).length != 0 ? P == 3 ? ";ext=" + M(b, 3) : I(C, 13) ? M(C, 13) + D(b, 3) : " ext. " + D(b, 3) : "";
      }
      function v0(b, C) {
        switch (C) {
          case 4:
            return M(b, 5);
          case 3:
            return M(b, 4);
          case 1:
            return M(b, 3);
          case 0:
          case 2:
            return M(b, 2);
          case 5:
            return M(b, 6);
          case 6:
            return M(b, 8);
          case 7:
            return M(b, 7);
          case 8:
            return M(b, 21);
          case 9:
            return M(b, 25);
          case 10:
            return M(b, 28);
          default:
            return M(b, 1);
        }
      }
      function ql(b, C) {
        return ln(b, M(C, 1)) ? ln(b, M(C, 5)) ? 4 : ln(b, M(C, 4)) ? 3 : ln(b, M(C, 6)) ? 5 : ln(b, M(C, 8)) ? 6 : ln(b, M(C, 7)) ? 7 : ln(b, M(C, 21)) ? 8 : ln(b, M(C, 25)) ? 9 : ln(b, M(C, 28)) ? 10 : ln(b, M(C, 2)) ? M(C, 18) || ln(b, M(C, 3)) ? 2 : 0 : !M(C, 18) && ln(b, M(C, 3)) ? 1 : -1 : -1;
      }
      function Vn(b, C) {
        if (C == null) return null;
        C = C.toUpperCase();
        var P = b.g[C];
        if (P == null) {
          if (P = Be[C], P == null) return null;
          P = new he().g(Re.o(), P), b.g[C] = P;
        }
        return P;
      }
      function ln(b, C) {
        var P = b.length;
        return 0 < U(C, 9) && j(C, 9).indexOf(P) == -1 ? !1 : Mn(D(C, 2), b);
      }
      function _0(b) {
        var C = jt, P = Vo(C, b), F = D(b, 1), H = an(C, F, P);
        return H == null || P != "001" && F != Cs(C, P) ? H = !1 : (b = Ft(b), H = ql(b, H) != -1), H;
      }
      function Vo(b, C) {
        if (C == null) return null;
        var P = D(C, 1);
        if (P = we[P], P == null) b = null;
        else if (P.length == 1) b = P[0];
        else e: {
          C = Ft(C);
          for (var F, H = P.length, ee = 0; ee < H; ee++) {
            F = P[ee];
            var se = Vn(b, F);
            if (I(se, 23)) {
              if (C.search(M(se, 23)) == 0) {
                b = F;
                break e;
              }
            } else if (ql(C, se) != -1) {
              b = F;
              break e;
            }
          }
          b = null;
        }
        return b;
      }
      function wr(b) {
        return b = we[b], b == null ? "ZZ" : b[0];
      }
      function Cs(b, C) {
        if (b = Vn(b, C), b == null) throw Error("Invalid region code: " + C);
        return D(b, 10);
      }
      function $0(b) {
        return b = x0(b), b == 0 || b == 4;
      }
      function Kl(b, C, P, F) {
        var H = v0(P, F), ee = U(H, 9) == 0 ? j(M(P, 1), 9) : j(H, 9);
        return H = j(H, 10), ee[0] == -1 ? 5 : (C = C.length, -1 < H.indexOf(C) ? 4 : (P = ee[0], P == C ? 0 : P > C ? 2 : ee[ee.length - 1] < C ? 3 : -1 < ee.indexOf(C, 1) ? 0 : 5));
      }
      function x0(b) {
        var C = jt, P = Ft(b);
        return b = D(b, 1), b in we ? (b = an(C, b, wr(b)), Kl(C, P, b, -1)) : 1;
      }
      function w0(b, C) {
        if (b = b.toString(), b.length == 0 || b.charAt(0) == "0") return 0;
        for (var P, F = b.length, H = 1; 3 >= H && H <= F; ++H) if (P = parseInt(b.substring(0, H), 10), P in we) return C.g(b.substring(H)), P;
        return 0;
      }
      function k0(b, C, P, F, H) {
        if (C.length == 0) return 0;
        C = new _e(C);
        var ee;
        P != null && (ee = M(P, 11)), ee == null && (ee = "NonMatch");
        var se = C.toString();
        if (se.length == 0) ee = 20;
        else if (ut.test(se)) se = se.replace(ut, ""), ue(C), C.g(ye(se)), ee = 1;
        else {
          if (se = new RegExp(ee), Ve(C), ee = C.toString(), ee.search(se) == 0) {
            se = ee.match(se)[0].length;
            var Se = ee.substring(se).match(gn);
            Se && Se[1] != null && 0 < Se[1].length && Zt(Se[1], Xe) == "0" ? ee = !1 : (ue(C), C.g(ee.substring(se)), ee = !0);
          } else ee = !1;
          ee = ee ? 5 : 20;
        }
        if (ee != 20) {
          if (2 >= C.h.length) throw Error("Phone number too short after IDD");
          if (b = w0(
            C,
            F
          ), b != 0) return J(H, 1, b), b;
          throw Error("Invalid country calling code");
        }
        return P != null && (ee = D(P, 10), se = "" + ee, Se = C.toString(), Se.lastIndexOf(se, 0) == 0 && (se = new _e(Se.substring(se.length)), Se = M(P, 1), Se = new RegExp(D(Se, 2)), C0(se, P, null), se = se.toString(), !Mn(Se, C.toString()) && Mn(Se, se) || Kl(b, C.toString(), P, -1) == 3)) ? (F.g(se), J(H, 1, ee), ee) : (J(H, 1, 0), 0);
      }
      function C0(b, C, P) {
        var F = b.toString(), H = F.length, ee = M(C, 15);
        if (H != 0 && ee != null && ee.length != 0) {
          var se = new RegExp("^(?:" + ee + ")");
          if (H = se.exec(F)) {
            ee = new RegExp(D(M(C, 1), 2));
            var Se = Mn(ee, F), Ye = H.length - 1;
            C = M(C, 16), C == null || C.length == 0 || H[Ye] == null || H[Ye].length == 0 ? (!Se || Mn(ee, F.substring(H[0].length))) && (P != null && 0 < Ye && H[Ye] != null && P.g(H[1]), b.set(F.substring(H[0].length))) : (F = F.replace(se, C), (!Se || Mn(ee, F)) && (P != null && 0 < Ye && P.g(H[1]), b.set(F)));
          }
        }
      }
      function Gl(b, C, P) {
        if (C == null) throw Error("The string supplied did not seem to be a phone number");
        if (250 < C.length) throw Error("The string supplied is too long to be a phone number");
        var F = new _e(), H = C.indexOf(";phone-context=");
        if (H === -1) H = null;
        else if (H += 15, H >= C.length) H = "";
        else {
          var ee = C.indexOf(";", H);
          H = ee !== -1 ? C.substring(H, ee) : C.substring(H);
        }
        var se = H;
        if (se == null ? ee = !0 : se.length === 0 ? ee = !1 : (ee = er.exec(se), se = yr.exec(se), ee = ee !== null || se !== null), !ee || (H != null ? (H.charAt(0) === "+" && F.g(H), H = C.indexOf("tel:"), F.g(C.substring(0 <= H ? H + 4 : 0, C.indexOf(";phone-context=")))) : (H = F.g, C = C ?? "", ee = C.search(sn), 0 <= ee ? (C = C.substring(ee), C = C.replace(Qn, ""), ee = C.search(zn), 0 <= ee && (C = C.substring(0, ee))) : C = "", H.call(F, C)), C = F.toString(), H = C.indexOf(";isub="), 0 < H && (ue(F), F.g(C.substring(0, H))), !pe(F.toString()))) throw Error("The string supplied did not seem to be a phone number");
        if (C = F.toString(), !(Lt(P) || C != null && 0 < C.length && ut.test(C))) throw Error("Invalid country calling code");
        C = new ze();
        e: {
          if (H = F.toString(), ee = H.search(vr), 0 <= ee && pe(H.substring(0, ee))) {
            se = H.match(vr);
            for (var Se = se.length, Ye = 1; Ye < Se; ++Ye) if (se[Ye] != null && 0 < se[Ye].length) {
              ue(F), F.g(H.substring(0, ee)), H = se[Ye];
              break e;
            }
          }
          H = "";
        }
        0 < H.length && J(C, 3, H), ee = Vn(b, P), H = new _e(), se = 0, Se = F.toString();
        try {
          se = k0(b, Se, ee, H, C);
        } catch (tr) {
          if (tr.message == "Invalid country calling code" && ut.test(Se)) {
            if (Se = Se.replace(ut, ""), se = k0(b, Se, ee, H, C), se == 0) throw tr;
          } else throw tr;
        }
        if (se != 0 ? (F = wr(se), F != P && (ee = an(b, se, F))) : (Ve(F), H.g(F.toString()), P != null && (se = D(ee, 10), J(C, 1, se))), 2 > H.h.length || (ee != null && (P = new _e(H.toString()), C0(P, ee, new _e()), b = Kl(b, P.toString(), ee, -1), b != 2 && b != 4 && b != 5 && (H = P)), b = H.toString(), P = b.length, 2 > P)) throw Error("The string supplied is too short to be a phone number");
        if (17 < P) throw Error("The string supplied is too long to be a phone number");
        if (1 < b.length && b.charAt(0) == "0") {
          for (J(C, 4, !0), P = 1; P < b.length - 1 && b.charAt(P) == "0"; ) P++;
          P != 1 && J(C, 8, P);
        }
        return J(C, 2, parseInt(b, 10)), C;
      }
      Fe.prototype.ja = function(b) {
        var C = Vn(this, Vo(this, b));
        return C == null ? !0 : (b = Ft(b), !ln(b, M(C, 24)));
      };
      function Mn(b, C) {
        return !!((b = typeof b == "string" ? C.match("^(?:" + b + ")$") : C.match(b)) && b[0].length == C.length);
      }
      function h4(b) {
        this.ka = RegExp(" "), this.la = "", this.$ = new _e(), this.da = "", this.u = new _e(), this.ba = new _e(), this.v = !0, this.ea = this.ca = this.oa = !1, this.qa = Fe.pa(), this.aa = 0, this.h = new _e(), this.ha = !1, this.s = "", this.g = new _e(), this.j = [], this.ma = b, this.Aa = this.m = Yl(this, this.ma);
      }
      var S0 = new Re();
      J(S0, 11, "NA");
      var m4 = RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*\\$1[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*(\\$\\d[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*)*$"), E0 = /[- ]/;
      function Yl(b, C) {
        return C = Lt(C) ? Cs(b.qa, C) : 0, b = Vn(b.qa, wr(C)), b ?? S0;
      }
      function T0(b) {
        for (var C = b.j.length, P = 0; P < C; ++P) {
          var F = b.j[P], H = D(F, 1);
          if (b.da == H) return !1;
          var ee = b, se = F, Se = D(se, 1);
          ue(ee.$);
          var Ye = ee;
          se = D(se, 2);
          var tr = "999999999999999".match(Se)[0];
          if (tr.length < Ye.g.h.length ? Ye = "" : (Ye = tr.replace(new RegExp(Se, "g"), se), Ye = Ye.replace(RegExp("9", "g"), " ")), 0 < Ye.length ? (ee.$.g(Ye), ee = !0) : ee = !1, ee) return b.da = H, b.ha = E0.test(M(F, 4)), b.aa = 0, !0;
        }
        return b.v = !1;
      }
      function O0(b, C) {
        for (var P = [], F = C.length - 3, H = b.j.length, ee = 0; ee < H; ++ee) {
          var se = b.j[ee];
          U(se, 3) == 0 ? P.push(b.j[ee]) : (se = M(se, 3, Math.min(F, U(se, 3) - 1)), C.search(se) == 0 && P.push(b.j[ee]));
        }
        b.j = P;
      }
      function g4(b, C) {
        b.u.g(C);
        var P = C;
        if (gn.test(P) || b.u.h.length == 1 && lt.test(P) ? (C == "+" ? (P = C, b.ba.g(C)) : (P = Xe[C], b.ba.g(P), b.g.g(P)), C = P) : (b.v = !1, b.oa = !0), !b.v) {
          if (!b.oa) {
            if (L0(b)) {
              if (R0(b)) return M0(b);
            } else if (0 < b.s.length && (C = b.g.toString(), ue(b.g), b.g.g(b.s), b.g.g(C), C = b.h.toString(), P = C.lastIndexOf(b.s), ue(b.h), b.h.g(C.substring(0, P))), b.s != D0(b)) return b.h.g(" "), M0(b);
          }
          return b.u.toString();
        }
        switch (b.ba.h.length) {
          case 0:
          case 1:
          case 2:
            return b.u.toString();
          case 3:
            if (L0(b)) b.ea = !0;
            else return b.s = D0(b), Jl(b);
          default:
            return b.ea ? (R0(b) && (b.ea = !1), b.h.toString() + b.g.toString()) : 0 < b.j.length ? (C = P0(b, C), P = A0(b), 0 < P.length ? P : (O0(b, b.g.toString()), T0(b) ? N0(b) : b.v ? Fo(b, C) : b.u.toString())) : Jl(b);
        }
      }
      function M0(b) {
        return b.v = !0, b.ea = !1, b.j = [], b.aa = 0, ue(b.$), b.da = "", Jl(b);
      }
      function A0(b) {
        for (var C = b.g.toString(), P = b.j.length, F = 0; F < P; ++F) {
          var H = b.j[F], ee = D(H, 1);
          if (new RegExp("^(?:" + ee + ")$").test(C) && (b.ha = E0.test(M(H, 4)), H = C.replace(new RegExp(ee, "g"), M(H, 2)), H = Fo(b, H), Zt(H, ot) == b.ba)) return H;
        }
        return "";
      }
      function Fo(b, C) {
        var P = b.h.h.length;
        return b.ha && 0 < P && b.h.toString().charAt(P - 1) != " " ? b.h + " " + C : b.h + C;
      }
      function Jl(b) {
        var C = b.g.toString();
        if (3 <= C.length) {
          for (var P = b.ca && b.s.length == 0 && 0 < U(b.m, 20) ? j(b.m, 20) : j(b.m, 19), F = P.length, H = 0; H < F; ++H) {
            var ee = P[H];
            0 < b.s.length && $r(D(ee, 4)) && !M(ee, 6) && !I(ee, 5) || (b.s.length != 0 || b.ca || $r(D(ee, 4)) || M(ee, 6)) && m4.test(D(ee, 2)) && b.j.push(ee);
          }
          return O0(b, C), C = A0(b), 0 < C.length ? C : T0(b) ? N0(b) : b.u.toString();
        }
        return Fo(b, C);
      }
      function N0(b) {
        var C = b.g.toString(), P = C.length;
        if (0 < P) {
          for (var F = "", H = 0; H < P; H++) F = P0(b, C.charAt(H));
          return b.v ? Fo(b, F) : b.u.toString();
        }
        return b.h.toString();
      }
      function D0(b) {
        var C = b.g.toString(), P = 0;
        if (b.m.ia() != 1) var F = !1;
        else F = b.g.toString(), F = F.charAt(0) == "1" && F.charAt(1) != "0" && F.charAt(1) != "1";
        return F ? (P = 1, b.h.g("1").g(" "), b.ca = !0) : I(b.m, 15) && (F = new RegExp("^(?:" + M(b.m, 15) + ")"), F = C.match(F), F != null && F[0] != null && 0 < F[0].length && (b.ca = !0, P = F[0].length, b.h.g(C.substring(0, P)))), ue(b.g), b.g.g(C.substring(P)), C.substring(0, P);
      }
      function L0(b) {
        var C = b.ba.toString(), P = new RegExp("^(?:\\+|" + M(b.m, 11) + ")");
        return P = C.match(P), P != null && P[0] != null && 0 < P[0].length ? (b.ca = !0, P = P[0].length, ue(b.g), b.g.g(C.substring(P)), ue(b.h), b.h.g(C.substring(0, P)), C.charAt(0) != "+" && b.h.g(" "), !0) : !1;
      }
      function R0(b) {
        if (b.g.h.length == 0) return !1;
        var C = new _e(), P = w0(b.g, C);
        return P == 0 ? !1 : (ue(b.g), b.g.g(C.toString()), C = wr(P), C == "001" ? b.m = Vn(b.qa, "" + P) : C != b.ma && (b.m = Yl(b, C)), b.h.g("" + P).g(" "), b.s = "", !0);
      }
      function P0(b, C) {
        var P = b.$.toString();
        if (0 <= P.substring(b.aa).search(b.ka)) {
          var F = P.search(b.ka);
          return C = P.replace(b.ka, C), ue(b.$), b.$.g(C), b.aa = F, C.substring(0, b.aa + 1);
        }
        return b.j.length == 1 && (b.v = !1), b.da = "", b.u.toString();
      }
      var b4 = {
        AC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "AC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        AD: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[0268]", , , , "110"], [, , , , , , , , , [-1]], , , , "AD", , , , , , , , , , , , , , , , , , [, , "11[0268]", , , , "110"], , [, , "11[0268]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        AE: [
          ,
          [, , "[149]\\d{2,3}", , , , , , , [3, 4]],
          ,
          ,
          [, , "112|99[7-9]", , , , "112", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "AE",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "112|99[7-9]", , , , "112", , , [3]],
          ,
          [, , "112|445[16]|99[7-9]", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , "445\\d", , , , "4450", , , [4]]
        ],
        AF: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:0[02]|19)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "AF", , , , , , , , , , , , , , , , , , [, , "1(?:0[02]|19)", , , , "100", , , [3]], , [, , "1(?:0[02]|19)|40404", , , , "100"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        AG: [
          ,
          [, , "[19]\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "9(?:11|88|99)", , , , "911"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "AG",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "9(?:11|99)", , , , "911"],
          ,
          [, , "176|9(?:11|88|99)", , , , "176"],
          [, , , , , , , , , [-1]],
          [, , "176", , , , "176"],
          ,
          [, , "176", , , , "176"]
        ],
        AI: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "AI", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|9(?:11|88)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        AL: [
          ,
          [, , "[15]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
          ,
          ,
          [, , "1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)", , , , "112", , , [3, 6]],
          [, , "5\\d{4}", , , , "50000", , , [5]],
          ,
          ,
          ,
          "AL",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:12|2[7-9])", , , , "112", , , [3]],
          ,
          [, , "1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])", , , , "110"],
          [, , , , , , , , , [-1]],
          [, , "123", , , , "123", , , [3]],
          ,
          [, , "131|5\\d{4}", , , , "131", , , [3, 5]]
        ],
        AM: [, [, , "[148]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10[1-3]", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "AM", , , , , , , , , , , , , , , , , , [, , "10[1-3]", , , , "101", , , [3]], , [, , "(?:1|8[1-7])\\d\\d|40404", , , , "100"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        AO: [, [
          ,
          ,
          "1\\d\\d",
          ,
          ,
          ,
          ,
          ,
          ,
          [3]
        ], , , [, , "11[235]", , , , "112"], [, , , , , , , , , [-1]], , , , "AO", , , , , , , , , , , , , , , , , , [, , "11[235]", , , , "112"], , [, , "11[235]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        AR: [, [, , "[01389]\\d{1,4}", , , , , , , [2, 3, 4, 5]], , , [, , "000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911", , , , "19", , , [2, 3]], [, , , , , , , , , [-1]], , , , "AR", , , , , , , , , , , , , , , , , , [, , "10[017]|911", , , , "100", , , [3]], , [, , "000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911", , , , "19"], [, , , , , , , , , [-1]], [, , "893\\d\\d", , , , "89300", , , [5]], , [
          ,
          ,
          "(?:337|893\\d)\\d",
          ,
          ,
          ,
          "3370",
          ,
          ,
          [4, 5]
        ]],
        AS: [, [, , "[49]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "9(?:11|88)", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "AS", , , , , , , , , , , , , , , , , , [, , "911", , , , "911", , , [3]], , [, , "40404|9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        AT: [, [, , "[1268]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "1(?:12|2[0238]|3[03]|4[0-247])|1(?:16\\d\\d|4[58])\\d", , , , "112"], [, , , , , , , , , [-1]], , , , "AT", , , , , , , , , , , , , , , , , , [, , "1(?:[12]2|33|44)", , , , "112", , , [3]], , [
          ,
          ,
          "1(?:1(?:2|6(?:00[06]|1(?:17|23)))|2[0238]|3[03]|4(?:[0-247]|5[05]|84))|(?:220|61|8108[1-3])0",
          ,
          ,
          ,
          "112"
        ], [, , , , , , , , , [-1]], [, , "(?:220|810\\d\\d)\\d|610", , , , "610"], , [, , , , , , , , , [-1]]],
        AU: [, [, , "[0-27]\\d{2,7}", , , , , , , [3, 4, 5, 6, 7, 8]], , , [, , "000|1(?:06|12|258885|55\\d)|733", , , , "000", , , [3, 4, 7]], [, , "1(?:2(?:34|456)|9\\d{4,6})", , , , "1234", , , [4, 5, 6, 7, 8]], , , , "AU", , , , , , , , , , , , , , , , , , [, , "000|1(?:06|12)", , , , "000", , , [3]], , [, , "000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)", , , , "000"], [
          ,
          ,
          "1(?:1[09]\\d|24733)|225|767",
          ,
          ,
          ,
          "225",
          ,
          ,
          [3, 4, 6]
        ], [, , "1(?:258885|55\\d)", , , , "1550", , , [4, 7]], , [, , "19\\d{4,6}", , , , "190000", , , [6, 7, 8]]],
        AW: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "100|911", , , , "100"], [, , , , , , , , , [-1]], , , , "AW", , , , , , , , , , , , , , , , , , [, , "100|911", , , , "100"], , [, , "1(?:00|18|76)|91[13]", , , , "100"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        AX: [, [, , "[17]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "AX", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "112|75[12]\\d\\d", , , , "112"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , , , , , , , , [-1]]],
        AZ: [, [, , "[148]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "AZ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], , [, , "1(?:0[1-3]|12)|(?:404|880)0", , , , "101"], [, , , , , , , , , [-1]], [, , "(?:404|880)\\d", , , , "4040", , , [4]], , [, , "(?:404|880)\\d", , , , "4040", , , [4]]],
        BA: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:16\\d{3}|2[2-4])", , , , "122", , , [3, 6]], [, , , , , , , , , [-1]], , , , "BA", , , , , , , , , , , , , , , , , , [, , "12[2-4]", , , , "122", , , [3]], , [
          ,
          ,
          "1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?",
          ,
          ,
          ,
          "122"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        BB: [, [, , "[2-689]\\d\\d", , , , , , , [3]], , , [, , "988|[2359]11", , , , "211"], [, , , , , , , , , [-1]], , , , "BB", , , , , , , , , , , , , , , , , , [, , "[2359]11", , , , "211"], , [, , "988|[2-689]11", , , , "211"], [, , , , , , , , , [-1]], [, , "[468]11", , , , "411"], , [, , , , , , , , , [-1]]],
        BD: [, [, , "[1579]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10[0-26]|[19]99", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "BD", , , , , , , , , , , , , , , , , , [, , "10[0-2]|[19]99", , , , "100", , , [3]], , [
          ,
          ,
          "1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d",
          ,
          ,
          ,
          "100"
        ], [, , , , , , , , , [-1]], [, , "1(?:11|2[13])|(?:501|959)\\d|786", , , , "111", , , [3, 4]], , [, , "959\\d", , , , "9590", , , [4]]],
        BE: [, [, , "[1-9]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "1(?:0[0-35-8]|1[0269]|7(?:12|77)|813)|(?:116|8)\\d{3}", , , , "100"], [, , "1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d", , , , "1204", , , [4]], , , , "BE", , , , , , , , , , , , , , , , , , [, , "1(?:0[01]|12)", , , , "100", , , [3]], , [
          ,
          ,
          "1(?:0[0-8]|16117|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|11[02679]|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]",
          ,
          ,
          ,
          "100"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "[2-9]\\d{3}", , , , "2000", , , [4]]],
        BF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "BF", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        BG: [, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "1(?:1(?:2|6\\d{3})|50|6[06])", , , , "112"], [, , , , , , , , , [-1]], , , , "BG", , , , , , , , , , , , , , , , , , [, , "1(?:12|50|6[06])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111))|50|6[06])", , , , "112"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , , , , , , , , [-1]]],
        BH: [, [, , "[0189]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "(?:0[167]|81)\\d{3}|[19]99", , , , "199"], [, , "9[148]\\d{3}", , , , "91000", , , [5]], , , , "BH", , , , , , , , , , , , , , , , , , [, , "[19]99", , , , "199", , , [3]], , [, , "1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}", , , , "100"], [, , , , , , , , , [-1]], [, , "0[67]\\d{3}|88000|98555", , , , "06000", , , [5]], , [, , "88000|98555", , , , "88000", , , [5]]],
        BI: [
          ,
          [, , "[16-9]\\d{2,3}", , , , , , , [3, 4]],
          ,
          ,
          [, , "11[237]|611", , , , "112", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "BI",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "11[237]", , , , "112", , , [3]],
          ,
          [, , "1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900", , , , "110"],
          [, , , , , , , , , [-1]],
          [, , "611|7(?:10|77)|888|900", , , , "611", , , [3]],
          ,
          [, , "(?:71|90)0", , , , "710", , , [3]]
        ],
        BJ: [, [, , "[17]\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[78]|7[3-5]\\d\\d", , , , "117"], [, , , , , , , , , [-1]], , , , "BJ", , , , , , , , , , , , , , , , , , [, , "11[78]", , , , "117", , , [3]], , [, , "1(?:1[78]|2[02-5]|60)|7[0-5]\\d\\d", , , , "117"], [, , , , , , , , , [-1]], [, , "12[02-5]", , , , "120", , , [3]], , [, , , , , , , , , [-1]]],
        BL: [, [, , "1\\d", , , , , , , [2]], , , [
          ,
          ,
          "18",
          ,
          ,
          ,
          "18"
        ], [, , , , , , , , , [-1]], , , , "BL", , , , , , , , , , , , , , , , , , [, , "18", , , , "18"], , [, , "18", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        BM: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "BM", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|9(?:11|88)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        BN: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "99[135]", , , , "991"], [, , , , , , , , , [-1]], , , , "BN", , , , , , , , , , , , , , , , , , [, , "99[135]", , , , "991"], , [, , "99[135]", , , , "991"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , , , , , , , , [-1]]],
        BO: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[089]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "BO", , , , , , , , , , , , , , , , , , [, , "11[089]", , , , "110", , , [3]], , [, , "11[089]|40404", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        BQ: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|911", , , , "112"], [, , , , , , , , , [-1]], , , , "BQ", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "1(?:12|76)|911", , , , "112"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        BR: [, [
          ,
          ,
          "[1-69]\\d{2,5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 4, 5, 6]
        ], , , [, , "1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911", , , , "100", , , [3, 4]], [, , , , , , , , , [-1]], , , , "BR", , , , , , , , , , , , , , , , , , [, , "1(?:12|28|9[023])|911", , , , "112", , , [3]], , [
          ,
          ,
          "1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]",
          ,
          ,
          ,
          "100"
        ], [, , "102|273\\d\\d|321", , , , "102", , , [3, 5]], [, , "151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)", , , , "151", , , [3, 4, 5]], , [, , "285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}", , , , "321"]],
        BS: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:1[19]|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "BS", , , , , , , , , , , , , , , , , , [, , "91[19]", , , , "911"], , [, , "9(?:1[19]|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        BT: [
          ,
          [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]],
          ,
          ,
          [, , "11[023]", , , , "110", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "BT",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "11[023]", , , , "110", , , [3]],
          ,
          [, , "11[0-6]|40404", , , , "110"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , "404\\d\\d", , , , "40400", , , [5]]
        ],
        BW: [, [, , "[19]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "9(?:11|9[7-9])", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "BW", , , , , , , , , , , , , , , , , , [, , "9(?:11|9[7-9])", , , , "911", , , [3]], , [, , "1(?:1[26]|3123)|9(?:1[14]|9[1-57-9])", , , , "112"], [, , , , , , , , , [-1]], [, , "131\\d\\d", , , , "13100", , , [5]], , [, , "131\\d\\d", , , , "13100", , , [5]]],
        BY: [
          ,
          [, , "1\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "1(?:0[1-3]|12)", , , , "101"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "BY",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:0[1-3]|12)", , , , "101"],
          ,
          [, , "1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])", , , , "101"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        BZ: [, [, , "9\\d\\d?", , , , , , , [2, 3]], , , [, , "9(?:0|11|22|66|77|9[09])", , , , "90"], [, , , , , , , , , [-1]], , , , "BZ", , , , , , , , , , , , , , , , , , [, , "9(?:0|11|90)", , , , "90"], , [, , "9(?:0|11|22|66|77|9[09])", , , , "90"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CA: [, [, , "[1-9]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [
          ,
          ,
          "112|988|[29]11",
          ,
          ,
          ,
          "112",
          ,
          ,
          [3]
        ], [, , , , , , , , , [-1]], , , , "CA", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", , , [3]], , [, , "[1-35-9]\\d{4,5}|112|[2-8]11|9(?:11|88)", , , , "112"], [, , , , , , , , , [-1]], [, , "[235-7]11", , , , "211", , , [3]], , [, , "[1-35-9]\\d{4,5}", , , , "10000", , , [5, 6]]],
        CC: [, [, , "[01]\\d\\d", , , , , , , [3]], , , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], , , , "CC", , , , , , , , , , , , , , , , , , [, , "000|112", , , , "000"], , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CD: [
          ,
          [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]],
          ,
          ,
          [, , "1(?:1[348]|77|88)", , , , "113", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "CD",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:1[348]|77|88)", , , , "113", , , [3]],
          ,
          [, , "1(?:1[348]|23|77|88)|40404", , , , "113"],
          [, , , , , , , , , [-1]],
          [, , "404\\d\\d", , , , "40400", , , [5]],
          ,
          [, , "404\\d\\d", , , , "40400", , , [5]]
        ],
        CF: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[78]|22\\d)", , , , "117"], [, , , , , , , , , [-1]], , , , "CF", , , , , , , , , , , , , , , , , , [, , "1(?:1[78]|220)", , , , "117"], , [, , "1(?:1[478]|220)", , , , "114"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CG: [
          ,
          [, , "1\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "11[178]", , , , "111"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "CG",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "11[78]", , , , "117"],
          ,
          [, , "11[126-8]", , , , "111"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        CH: [, [, , "[1-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:[278]|6\\d{3})|4[47])|5200", , , , "112", , , [3, 4, 6]], [, , "1(?:14|8[0-2589])\\d|543|83111", , , , "543", , , [3, 4, 5]], , , , "CH", , , , , , , , , , , , , , , , , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], , [, , "1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[0145])|6(?:00|[1-46])|8(?:02|1[189]|[25]0|7|8[08]|99))|[2-9]\\d{2,4}", , , , "112"], [
          ,
          ,
          "1(?:4[035]|6[1-46])|1(?:41|60)\\d",
          ,
          ,
          ,
          "140",
          ,
          ,
          [3, 4]
        ], [, , "5(?:200|35)", , , , "535", , , [3, 4]], , [, , "[2-9]\\d{2,4}", , , , "200", , , [3, 4, 5]]],
        CI: [, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[01]|[78]0)", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "CI", , , , , , , , , , , , , , , , , , [, , "1(?:1[01]|[78]0)", , , , "110", , , [3]], , [, , "1(?:1[01]|[78]0)|4443", , , , "110"], [, , , , , , , , , [-1]], [, , "444\\d", , , , "4440", , , [4]], , [, , "444\\d", , , , "4440", , , [4]]],
        CK: [
          ,
          [, , "9\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "99[689]", , , , "996"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "CK",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "99[689]", , , , "996"],
          ,
          [, , "99[689]", , , , "996"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        CL: [, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:213|3[1-3])|434\\d|911", , , , "131", , , [3, 4]], [, , "1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d", , , , "1060", , , [4, 5]], , , , "CL", , , , , , , , , , , , , , , , , , [, , "13[1-3]|911", , , , "131", , , [3]], , [
          ,
          ,
          "1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0",
          ,
          ,
          ,
          "100"
        ], [, , "(?:200|333)\\d", , , , "2000", , , [4]], [, , , , , , , , , [-1]], , [, , "13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d", , , , "1060", , , [4, 5]]],
        CM: [, [, , "[18]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:1[37]|[37])", , , , "13", , , [2, 3]], [, , , , , , , , , [-1]], , , , "CM", , , , , , , , , , , , , , , , , , [, , "1(?:1[37]|[37])", , , , "13", , , [2, 3]], , [
          ,
          ,
          "1(?:1[37]|[37])|8711",
          ,
          ,
          ,
          "13"
        ], [, , , , , , , , , [-1]], [, , "871\\d", , , , "8710", , , [4]], , [, , "871\\d", , , , "8710", , , [4]]],
        CN: [, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1[09]|2(?:[02]|1\\d\\d|395))", , , , "110", , , [3, 5]], [, , , , , , , , , [-1]], , , , "CN", , , , , , , , , , , , , , , , , , [, , "1(?:1[09]|20)", , , , "110", , , [3]], , [, , "1(?:00|1[0249]|2395|6[08])|9[56]\\d{3,4}|12[023]|1(?:0(?:[0-26]\\d|8)|21\\d)\\d", , , , "100"], [, , "1(?:0(?:[0-26]\\d|8)\\d|1[24]|23|6[08])|9[56]\\d{3,4}|100", , , , "100"], [, , , , , , , , , [-1]], , [, , "12110", , , , "12110", , , [5]]],
        CO: [, [
          ,
          ,
          "[1-589]\\d\\d(?:\\d{2,3})?",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 5, 6]
        ], , , [, , "1(?:1[29]|23|32|56)", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "CO", , , , , , , , , , , , , , , , , , [, , "1(?:1[29]|23|32|56)", , , , "112", , , [3]], , [, , "1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|(?:29002|39003)9|40404|5930\\d\\d|85432|(?:[2359][57]|8(?:7|9\\d))\\d{3}", , , , "106"], [, , , , , , , , , [-1]], [, , "(?:40|85)4\\d\\d", , , , "40400", , , [5]], , [, , "(?:40|85)4\\d\\d", , , , "40400", , , [5]]],
        CR: [, [, , "[1359]\\d{2,3}", , , , , , , [3, 4]], , , [, , "112|911", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "CR", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "112|911",
          ,
          ,
          ,
          "112",
          ,
          ,
          [3]
        ], , [, , "1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "(?:385|5(?:0[34]|51))\\d", , , , "3850", , , [4]]],
        CU: [, [, , "[12]\\d\\d(?:\\d{3,4})?", , , , , , , [3, 6, 7]], , , [, , "10[4-7]|(?:116|204\\d)\\d{3}", , , , "104"], [, , , , , , , , , [-1]], , , , "CU", , , , , , , , , , , , , , , , , , [, , "10[4-6]", , , , "104", , , [3]], , [
          ,
          ,
          "1(?:0[4-7]|1(?:6111|8)|40)|2045252",
          ,
          ,
          ,
          "104"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CV: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "13[0-2]", , , , "130"], [, , , , , , , , , [-1]], , , , "CV", , , , , , , , , , , , , , , , , , [, , "13[0-2]", , , , "130"], , [, , "13[0-2]", , , , "130"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CW: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|911", , , , "112"], [, , , , , , , , , [-1]], , , , "CW", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "1(?:12|76)|911", , , , "112"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        CX: [, [, , "[01]\\d\\d", , , , , , , [3]], , , [
          ,
          ,
          "000|112",
          ,
          ,
          ,
          "000"
        ], [, , , , , , , , , [-1]], , , , "CX", , , , , , , , , , , , , , , , , , [, , "000|112", , , , "000"], , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CY: [, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "1(?:1(?:2|6\\d{3})|99)", , , , "112"], [, , , , , , , , , [-1]], , , , "CY", , , , , , , , , , , , , , , , , , [, , "1(?:12|99)", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111))|99)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        CZ: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5\\d)", , , , "112", , , [3, 6]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , , "CZ", , , , , , , , , , , , , , , , , , [, , "1(?:12|5\\d)", , , , "112", , , [3]], , [, , "1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5\\d|99)|1(?:16|4)\\d{3}", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        DE: [, [, , "[13]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[02]|6\\d{3})", , , , "110", , , [3, 6]], [, , , , , , , , , [-1]], , , , "DE", , , , , , , , , , , , , , , , , , [, , "11[02]", , , , "110", , , [3]], , [, , "11(?:[025]|6(?:00[06]|1(?:1[167]|23))|800\\d)|3311|118\\d\\d", , , , "110"], [, , , , , , , , , [-1]], [, , "331\\d", , , , "3310", , , [4]], , [, , , , , , , , , [-1]]],
        DJ: [, [
          ,
          ,
          "1\\d",
          ,
          ,
          ,
          ,
          ,
          ,
          [2]
        ], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "DJ", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        DK: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[24]|6\\d{3})", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "DK", , , , , , , , , , , , , , , , , , [, , "11[24]", , , , "112", , , [3]], , [, , "1(?:1(?:[2-48]|6(?:00[06]|111))|619[0-2]|8(?:01|1[0238]|28|30|5[13]|8[18]))", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        DM: [, [, , "[39]\\d\\d", , , , , , , [3]], , , [
          ,
          ,
          "333|9(?:11|88|99)",
          ,
          ,
          ,
          "333"
        ], [, , , , , , , , , [-1]], , , , "DM", , , , , , , , , , , , , , , , , , [, , "333|9(?:11|99)", , , , "333"], , [, , "333|9(?:11|88|99)", , , , "333"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        DO: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|9(?:11|88)", , , , "112"], [, , , , , , , , , [-1]], , , , "DO", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "112|9(?:11|88)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        DZ: [, [, , "[17]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:12|[47]|54\\d)", , , , "14"], [, , , , , , , , , [-1]], , , , "DZ", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "1(?:12|[47])",
          ,
          ,
          ,
          "14",
          ,
          ,
          [2, 3]
        ], , [, , "1(?:055|12|[47]|548)|730", , , , "14"], [, , , , , , , , , [-1]], [, , "730", , , , "730", , , [3]], , [, , "730", , , , "730", , , [3]]],
        EC: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "1(?:0[12]|12)|911", , , , "101"], [, , , , , , , , , [-1]], , , , "EC", , , , , , , , , , , , , , , , , , [, , "1(?:0[12]|12)|911", , , , "101"], , [, , "1(?:0[12]|12)|911", , , , "101"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        EE: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [
          ,
          ,
          "1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))",
          ,
          ,
          ,
          "110"
        ], [
          ,
          ,
          "1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))",
          ,
          ,
          ,
          "123",
          ,
          ,
          [3, 4, 5]
        ], , , , "EE", , , , , , , , , , , , , , , , , , [, , "11[02]", , , , "110", , , [3]], , [, , "1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
          ,
          ,
          "1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))",
          ,
          ,
          ,
          "126",
          ,
          ,
          [3, 4, 5]
        ]],
        EG: [, [, , "[13]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:2[23]|80)", , , , "122", , , [3]], [, , , , , , , , , [-1]], , , , "EG", , , , , , , , , , , , , , , , , , [, , "1(?:2[23]|80)", , , , "122", , , [3]], , [, , "1(?:2[23]|[679]\\d{3}|80)|34400", , , , "122"], [, , , , , , , , , [-1]], [, , "344\\d\\d", , , , "34400", , , [5]], , [, , "344\\d\\d", , , , "34400", , , [5]]],
        EH: [
          ,
          [, , "1\\d\\d?", , , , , , , [2, 3]],
          ,
          ,
          [, , "1(?:[59]|77)", , , , "15"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "EH",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:[59]|77)", , , , "15"],
          ,
          [, , "1(?:[59]|77)", , , , "15"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        ER: [, [, , "[12]\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "11[2-46]|(?:12[47]|20[12])\\d{3}", , , , "112"], [, , , , , , , , , [-1]], , , , "ER", , , , , , , , , , , , , , , , , , [, , "1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99", , , , "112"], , [, , "1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        ES: [, [, , "[0-379]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "0(?:16|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}", , , , "016", , , [3, 4, 6]], [
          ,
          ,
          "[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}",
          ,
          ,
          ,
          "120"
        ], , , , "ES", , , , , , , , , , , , , , , , , , [, , "08[58]|112", , , , "085", , , [3]], , [, , "0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}", , , , "010"], [, , "0(?:[16][0-2]|80|9[12])|21\\d{4}", , , , "010", , , [3, 6]], [, , "1(?:3[34]|77)|[12]2\\d{1,4}", , , , "120"], , [, , "(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d", , , , "22000", , , [5, 6]]],
        ET: [, [
          ,
          ,
          "9\\d\\d?",
          ,
          ,
          ,
          ,
          ,
          ,
          [2, 3]
        ], , , [, , "9(?:07|11?|2|39?|9[17])", , , , "91"], [, , , , , , , , , [-1]], , , , "ET", , , , , , , , , , , , , , , , , , [, , "9(?:11?|2|39?|9[17])", , , , "91"], , [, , "9(?:07|11?|2|39?|45|9[17])", , , , "91"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        FI: [
          ,
          [, , "[17]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]],
          ,
          ,
          [, , "11(?:2|6\\d{3})", , , , "112", , , [3, 6]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "FI",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "112", , , , "112", , , [3]],
          ,
          [, , "11(?:2|6(?:00[06]|1(?:1[17]|23)))|(?:1[235-8]\\d|75[12])\\d\\d", , , , "112"],
          [, , "1[235-8]\\d{3}", , , , "12000", , , [5]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        FJ: [, [, , "[0-579]\\d(?:\\d(?:\\d{2})?)?", , , , , , , [2, 3, 5]], , , [, , "91[17]", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "FJ", , , , , , , , , , , , , , , , , , [, , "91[17]", , , , "911", , , [3]], , [, , "0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75", , , , "22"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        FK: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "FK", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "1\\d\\d|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        FM: [, [, , "[39]\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "320\\d{3}|911", , , , "911"], [, , , , , , , , , [-1]], , , , "FM", , , , , , , , , , , , , , , , , , [, , "(?:32022|91)1", , , , "911"], , [, , "(?:32022|91)1", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        FO: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[24]|81\\d)", , , , "112"], [, , , , , , , , , [-1]], , , , "FO", , , , , , , , , , , , , , , , , , [, , "11[24]", , , , "112", , , [3]], , [, , "1(?:1[248]|819)|1(?:4[124]|71|8[7-9])\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        FR: [, [
          ,
          ,
          "[1-8]\\d{1,5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [2, 3, 4, 5, 6]
        ], , , [, , "1(?:1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d", , , , "15"], [, , "(?:1(?:0|18\\d)|366|[4-8]\\d\\d)\\d\\d|3[2-9]\\d\\d", , , , "1000", , , [4, 5, 6]], , , , "FR", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15", , , [2, 3]], , [, , "1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)", , , , "15"], [, , "202\\d|6(?:1[14]|34)|70[06]", , , , "611", , , [3, 4]], [
          ,
          ,
          "118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d",
          ,
          ,
          ,
          "224",
          ,
          ,
          [3, 4, 5, 6]
        ], , [, , "114|[3-8]\\d{4}", , , , "114", , , [3, 5]]],
        GA: [, [, , "1\\d(?:\\d{2})?", , , , , , , [2, 4]], , , [, , "18|1(?:3\\d|73)\\d", , , , "18"], [, , , , , , , , , [-1]], , , , "GA", , , , , , , , , , , , , , , , , , [, , "1(?:3\\d\\d|730|8)", , , , "18"], , [, , "1(?:3\\d\\d|730|8)", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GB: [, [, , "[1-46-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999", , , , "105"], [, , , , , , , , , [-1]], , , , "GB", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [
          ,
          ,
          "1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)",
          ,
          ,
          ,
          "100"
        ], [, , , , , , , , , [-1]], [, , "1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901", , , , "202", , , [3, 4, 5]], , [, , "(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d", , , , "1250", , , [4, 5]]],
        GD: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "GD", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|9(?:11|88)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        GE: [, [, , "[014]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "0(?:11|33)|11[1-3]|[01]22", , , , "011", , , [3]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , , "GE", , , , , , , , , , , , , , , , , , [, , "0(?:11|33)|11[1-3]|[01]22", , , , "011", , , [3]], , [, , "0(?:11|33)|11[1-3]|40404|[01]22", , , , "011"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        GF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "GF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GG: [
          ,
          [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
          ,
          ,
          [, , "112|999", , , , "112", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "GG",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "112|999", , , , "112", , , [3]],
          ,
          [, , "1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d", , , , "100"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        GH: [, [, , "[14589]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "19[1-3]|999", , , , "191", , , [3]], [, , , , , , , , , [-1]], , , , "GH", , , , , , , , , , , , , , , , , , [, , "19[1-3]|999", , , , "191", , , [3]], , [, , "19[1-3]|40404|(?:54|83)00|999", , , , "191"], [, , , , , , , , , [-1]], [, , "404\\d\\d|(?:54|83)0\\d", , , , "5400", , , [4, 5]], , [, , "404\\d\\d|(?:54|83)0\\d", , , , "5400", , , [4, 5]]],
        GI: [, [
          ,
          ,
          "[158]\\d{2,5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 4, 5, 6]
        ], , , [, , "1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d", , , , "100", , , [3, 4, 6]], [, , "8[1-69]\\d\\d", , , , "8100", , , [4]], , , , "GI", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[09])", , , , "112", , , [3]], , [, , "1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])", , , , "100"], [, , "150|87\\d\\d", , , , "150", , , [3, 4]], [, , "1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])", , , , "100", , , [3, 5]], , [, , , , , , , , , [-1]]],
        GL: [, [
          ,
          ,
          "1\\d\\d",
          ,
          ,
          ,
          ,
          ,
          ,
          [3]
        ], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "GL", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , "1[1-8]\\d", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GM: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:1[6-8]|[6-8])", , , , "16"], [, , , , , , , , , [-1]], , , , "GM", , , , , , , , , , , , , , , , , , [, , "1(?:1[6-8]|[6-8])", , , , "16"], , [, , "1(?:1[6-8]|[6-8])", , , , "16"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GN: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GN", , , , , , , , , , , , , , , , , , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , "12\\d|40404", , , , "120"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        GP: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "GP", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GR: [, [, , "1\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "1(?:0[089]|1(?:2|6\\d{3})|66|99)", , , , "100", , , [3, 6]], [, , , , , , , , , [-1]], , , , "GR", , , , , , , , , , , , , , , , , , [, , "1(?:00|12|66|99)", , , , "100", , , [3]], , [
          ,
          ,
          "1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)",
          ,
          ,
          ,
          "100"
        ], [, , "113\\d\\d", , , , "11300", , , [5]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GT: [, [, , "[14]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:10|2[03])", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "GT", , , , , , , , , , , , , , , , , , [, , "1(?:10|2[03])", , , , "110", , , [3]], , [, , "110|40404|1(?:2|[57]\\d)\\d", , , , "110"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        GU: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "GU", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GW: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[378]", , , , "113"], [, , , , , , , , , [-1]], , , , "GW", , , , , , , , , , , , , , , , , , [, , "11[378]", , , , "113"], , [, , "11[378]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        GY: [, [, , "[019]\\d{2,3}", , , , , , , [3, 4]], , , [, , "91[1-3]", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "GY", , , , , , , , , , , , , , , , , , [, , "91[1-3]", , , , "911", , , [3]], , [, , "0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]", , , , "002"], [, , , , , , , , , [-1]], [
          ,
          ,
          "144\\d",
          ,
          ,
          ,
          "1440",
          ,
          ,
          [4]
        ], , [, , "144\\d", , , , "1440", , , [4]]],
        HK: [
          ,
          [, , "[19]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]],
          ,
          ,
          [, , "112|99[29]", , , , "112", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "HK",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "112|99[29]", , , , "112", , , [3]],
          ,
          [, , "1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]", , , , "100"],
          [, , , , , , , , , [-1]],
          [, , "109|1(?:08|85\\d)\\d", , , , "109", , , [3, 4, 5]],
          ,
          [, , "992", , , , "992", , , [3]]
        ],
        HN: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "199", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "HN", , , , , , , , , , , , , , , , , , [, , "199", , , , "199", , , [3]], , [, , "199|40404", , , , "199"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        HR: [
          ,
          [, , "[19]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]],
          ,
          ,
          [, , "1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d", , , , "93", , , [2, 3, 5, 6]],
          [, , "118\\d\\d", , , , "11800", , , [5]],
          ,
          ,
          ,
          "HR",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:12|9[2-4])|9[34]", , , , "93", , , [2, 3]],
          ,
          [, , "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]", , , , "93"],
          [, , , , , , , , , [-1]],
          [, , "139\\d\\d", , , , "13900", , , [5]],
          ,
          [, , "139\\d\\d", , , , "13900", , , [5]]
        ],
        HT: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[48]", , , , "114", , , [3]], [, , , , , , , , , [-1]], , , , "HT", , , , , , , , , , , , , , , , , , [, , "11[48]", , , , "114", , , [3]], , [, , "11[48]|40404", , , , "114"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        HU: [, [
          ,
          ,
          "1\\d{2,5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 4, 5, 6]
        ], , , [, , "1(?:0[457]|12|4[0-4]\\d)|1(?:16\\d|37|45)\\d\\d", , , , "104"], [, , , , , , , , , [-1]], , , , "HU", , , , , , , , , , , , , , , , , , [, , "1(?:0[457]|12)", , , , "104", , , [3]], , [, , "1(?:0[457]|1(?:2|6(?:000|1(?:11|23))|800)|2(?:0[0-4]|1[013489]|2[0-5]|3[0-46]|4[0-24-68]|5[0-2568]|6[06]|7[0-25-7]|8[028]|9[08])|37(?:00|37|7[07])|4(?:0[0-5]|1[013-8]|2[034]|3[23]|4[02-9]|5(?:00|41|67))|777|8(?:1[27-9]|2[04]|40|[589]))", , , , "104"], [, , , , , , , , , [-1]], [, , "1(?:4[0-4]|77)\\d|1(?:18|2|45)\\d\\d", , , , "1200", , , [4, 5]], , [
          ,
          ,
          "184\\d",
          ,
          ,
          ,
          "1840",
          ,
          ,
          [4]
        ]],
        ID: [, [, , "[178]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "11[02389]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "ID", , , , , , , , , , , , , , , , , , [, , "11[02389]", , , , "110", , , [3]], , [, , "1(?:1[02389]|40\\d\\d|50264)|71400|89887", , , , "110"], [, , , , , , , , , [-1]], [, , "(?:714|898)\\d\\d", , , , "71400", , , [5]], , [, , "714\\d\\d", , , , "71400", , , [5]]],
        IE: [, [, , "[159]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6\\d{3})|999", , , , "112", , , [3, 6]], [, , "5[37]\\d{3}", , , , "53000", , , [5]], , , , "IE", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [
          ,
          ,
          "11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d",
          ,
          ,
          ,
          "112"
        ], [, , "51\\d{3}", , , , "51000", , , [5]], [, , "51210", , , , "51210", , , [5]], , [, , "51210|(?:118|5[037]\\d)\\d\\d", , , , "11800", , , [5]]],
        IL: [, [, , "[12]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[0-2]|12)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "IL", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-2]|12)", , , , "100", , , [3]], , [, , "1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00", , , , "100"], [, , , , , , , , , [-1]], [, , "104\\d\\d", , , , "10400", , , [5]], , [, , "104\\d\\d", , , , "10400", , , [5]]],
        IM: [, [, , "[189]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [
          ,
          ,
          "999",
          ,
          ,
          ,
          "999",
          ,
          ,
          [3]
        ], [, , , , , , , , , [-1]], , , , "IM", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , [, , "1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "8(?:64|98)\\d\\d", , , , "86400", , , [5]]],
        IN: [
          ,
          [, , "[12578]\\d{2,8}", , , , , , , [3, 4, 5, 6, 7, 8, 9]],
          ,
          ,
          [, , "1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d", , , , "100", , , [3, 4, 5, 6]],
          [, , "11[67]\\d{4}|56161561", , , , "1160000", , , [7, 8]],
          ,
          ,
          ,
          "IN",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:0[0-28]|12|298)|2611", , , , "100", , , [3, 4]],
          ,
          [
            ,
            ,
            "1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d",
            ,
            ,
            ,
            "100"
          ],
          [, , "5(?:14(?:2[5-9]|[34]\\d)|757555)", , , , "51425", , , [5, 7]],
          [, , "1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])", , , , "118", , , [3, 4, 5, 6, 7, 8]],
          ,
          [, , "1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)", , , , "139", , , [3, 4, 5, 7, 8]]
        ],
        IQ: [, [, , "[1479]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[04]|15|22)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "IQ", , , , , , , , , , , , , , , , , , [, , "1(?:0[04]|15|22)", , , , "100", , , [3]], , [, , "1(?:0[04]|15|22)|4432|71117|9988", , , , "100"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], [, , "(?:443|711\\d|998)\\d", , , , "4430", , , [4, 5]], , [, , "(?:443|711\\d|998)\\d", , , , "4430", , , [4, 5]]],
        IR: [, [, , "[129]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1[0-68]|2[0-59]|9[0-579])|911", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "IR", , , , , , , , , , , , , , , , , , [, , "1(?:1[025]|25)|911", , , , "110", , , [3]], , [
          ,
          ,
          "1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))",
          ,
          ,
          ,
          "110"
        ], [, , "1(?:5[0-469]|8[0-489])\\d", , , , "1500", , , [4]], [, , "(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d", , , , "1500", , , [4, 6]], , [, , "990\\d{3}", , , , "990000", , , [6]]],
        IS: [, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "1(?:12|71\\d)", , , , "112", , , [3, 4]], [, , , , , , , , , [-1]], , , , "IS", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)", , , , "112"], [, , , , , , , , , [-1]], [, , "14(?:0\\d|41)", , , , "1400", , , [4]], , [
          ,
          ,
          "1(?:415|90\\d)",
          ,
          ,
          ,
          "1415",
          ,
          ,
          [4]
        ]],
        IT: [
          ,
          [, , "[14]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]],
          ,
          ,
          [, , "1(?:1(?:[2358]|6\\d{3})|87)", , , , "112", , , [3, 6]],
          [, , "(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d", , , , "1200", , , [4, 5, 7]],
          ,
          ,
          ,
          "IT",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "11[2358]", , , , "112", , , [3]],
          ,
          [, , "1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , "4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d", , , , "43000", , , [5, 7]]
        ],
        JE: [, [, , "[129]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "112|999", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "JE", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [, , "1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        JM: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "11[029]|9(?:11|88)", , , , "110"], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , , , "JM", , , , , , , , , , , , , , , , , , [, , "11[029]|911", , , , "110"], , [, , "1(?:1[029]|76)|9(?:11|88)", , , , "110"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
        JO: [, [, , "[19]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:0[235]|1[2-6]|9[127])|911", , , , "102", , , [3]], [, , "9[0-4689]\\d{3}", , , , "90000", , , [5]], , , , "JO", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[127])|911", , , , "112", , , [3]], , [, , "1(?:0[2359]|1[0-68]|9[0-24-79])|9[0-4689]\\d{3}|911", , , , "102"], [, , , , , , , , , [-1]], [, , "9[0-4689]\\d{3}", , , , "90000", , , [5]], , [
          ,
          ,
          "9[0-4689]\\d{3}",
          ,
          ,
          ,
          "90000",
          ,
          ,
          [5]
        ]],
        JP: [, [, , "[01]\\d\\d(?:\\d{7})?", , , , , , , [3, 10]], , , [, , "11[089]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "JP", , , , , , , , , , , , , , , , , , [, , "11[09]", , , , "110", , , [3]], , [, , "000[259]\\d{6}|1(?:0[24]|1[089]|44|89)", , , , "102"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "000[259]\\d{6}", , , , "0002000000", , , [10]]],
        KE: [, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999", , , , "112"], [, , "909\\d\\d", , , , "90900", , , [5]], , , , "KE", , , , , , , , , , , , , , , , , , [, , "11[24]|999", , , , "112", , , [3]], , [
          ,
          ,
          "1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988",
          ,
          ,
          ,
          "100"
        ], [, , , , , , , , , [-1]], [, , "1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d", , , , "130"], , [, , "1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d", , , , "141"]],
        KG: [, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "10[1-3]", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "KG", , , , , , , , , , , , , , , , , , [, , "10[1-3]", , , , "101", , , [3]], , [, , "10[1-3]|4040", , , , "101"], [, , , , , , , , , [-1]], [, , "404\\d", , , , "4040", , , [4]], , [
          ,
          ,
          "404\\d",
          ,
          ,
          ,
          "4040",
          ,
          ,
          [4]
        ]],
        KH: [, [, , "[146]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[7-9]|666", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "KH", , , , , , , , , , , , , , , , , , [, , "11[7-9]|666", , , , "117", , , [3]], , [, , "11[7-9]|40404|666", , , , "117"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        KI: [, [, , "[179]\\d{2,3}", , , , , , , [3, 4]], , , [, , "19[2-5]|99[2-4]", , , , "192", , , [3]], [, , , , , , , , , [-1]], , , , "KI", , , , , , , , , , , , , , , , , , [, , "19[2-5]|99[2-4]", , , , "192", , , [3]], , [, , "1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]", , , , "100"], [
          ,
          ,
          "103",
          ,
          ,
          ,
          "103",
          ,
          ,
          [3]
        ], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        KM: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "KM", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        KN: [, [, , "[39]\\d\\d", , , , , , , [3]], , , [, , "333|9(?:11|88|99)", , , , "333"], [, , , , , , , , , [-1]], , , , "KN", , , , , , , , , , , , , , , , , , [, , "333|9(?:11|99)", , , , "333"], , [, , "333|9(?:11|88|99)", , , , "333"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        KP: [, [, , "[18]\\d\\d", , , , , , , [3]], , , [
          ,
          ,
          "11[29]|819",
          ,
          ,
          ,
          "112"
        ], [, , , , , , , , , [-1]], , , , "KP", , , , , , , , , , , , , , , , , , [, , "11[29]|819", , , , "112"], , [, , "11[29]|819", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        KR: [, [, , "1\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1[27-9]|28|330|82)", , , , "112", , , [3, 4]], [, , , , , , , , , [-1]], , , , "KR", , , , , , , , , , , , , , , , , , [, , "11[29]", , , , "112", , , [3]], , [, , "1(?:[016-9]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189]))|1(?:0[015]|1\\d|2[01357-9]|41|8[28])", , , , "100"], [, , , , , , , , , [-1]], [
          ,
          ,
          "1(?:0[01]|1[4-6]|41)|1(?:[06-9]1\\d|111)\\d",
          ,
          ,
          ,
          "100",
          ,
          ,
          [3, 5]
        ], , [, , , , , , , , , [-1]]],
        KW: [, [, , "[18]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "KW", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1[0-7]\\d|89887", , , , "100"], [, , , , , , , , , [-1]], [, , "898\\d\\d", , , , "89800", , , [5]], , [, , , , , , , , , [-1]]],
        KY: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "KY", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        KZ: [, [, , "[1-4]\\d{2,4}", , , , , , , [
          3,
          4,
          5
        ]], , , [, , "1(?:0[1-3]|12)|212\\d", , , , "101", , , [3, 4]], [, , , , , , , , , [-1]], , , , "KZ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], , [, , "1(?:0[1-4]|12)|2121|(?:3040|404)0", , , , "101"], [, , , , , , , , , [-1]], [, , "(?:304\\d|404)\\d", , , , "4040", , , [4, 5]], , [, , "(?:304\\d|404)\\d", , , , "4040", , , [4, 5]]],
        LA: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[015]", , , , "190"], [, , , , , , , , , [-1]], , , , "LA", , , , , , , , , , , , , , , , , , [, , "19[015]", , , , "190"], , [, , "19[015]", , , , "190"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        LB: [
          ,
          [, , "[19]\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "1(?:12|40|75)|999", , , , "112"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "LB",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:12|40|75)|999", , , , "112"],
          ,
          [, , "1(?:12|40|75)|999", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        LC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "LC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        LI: [
          ,
          [, , "1\\d{2,3}", , , , , , , [3, 4]],
          ,
          ,
          [, , "1(?:1[278]|44)", , , , "112", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "LI",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:1[278]|44)", , , , "112", , , [3]],
          ,
          [, , "1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        LK: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[02689]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "LK", , , , , , , , , , , , , , , , , , [, , "11[02689]", , , , "110", , , [3]], , [, , "1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))", , , , "110"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , , , , , , , , [-1]]],
        LR: [, [, , "[3489]\\d{2,3}", , , , , , , [3, 4]], , , [, , "355|911", , , , "355", , , [3]], [, , , , , , , , , [-1]], , , , "LR", , , , , , , , , , , , , , , , , , [, , "355|911", , , , "355", , , [3]], , [, , "355|4040|8(?:400|933)|911", , , , "355"], [, , , , , , , , , [-1]], [, , "(?:404|8(?:40|93))\\d", , , , "4040", , , [4]], , [, , "(?:404|8(?:40|93))\\d", , , , "4040", , , [4]]],
        LS: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[257]", , , , "112"], [, , , , , , , , , [-1]], , , , "LS", , , , , , , , , , , , , , , , , , [, , "11[257]", , , , "112"], , [, , "11[257]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        LT: [, [, , "[01]\\d(?:\\d(?:\\d{3})?)?", , , , , , , [2, 3, 6]], , , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d", , , , "01"], [, , , , , , , , , [-1]], , , , "LT", , , , , , , , , , , , , , , , , , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|12)", , , , "01", , , [2, 3]], , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))", , , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        LU: [
          ,
          [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]],
          ,
          ,
          [, , "11(?:[23]|6\\d{3})", , , , "112", , , [3, 6]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "LU",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "11[23]", , , , "112", , , [3]],
          ,
          [, , "11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        LV: [, [, , "[018]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "0[1-3]|11(?:[023]|6\\d{3})", , , , "01", , , [2, 3, 6]], [, , "1180|821\\d\\d", , , , "1180", , , [4, 5]], , , , "LV", , , , , , , , , , , , , , , , , , [, , "0[1-3]|11[023]", , , , "01", , , [2, 3]], , [, , "0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4", , , , "01"], [, , "1181", , , , "1181", , , [4]], [, , "165\\d", , , , "1650", , , [4]], , [, , , , , , , , , [-1]]],
        LY: [, [, , "1\\d\\d", , , , , , , [3]], , , [
          ,
          ,
          "19[013]",
          ,
          ,
          ,
          "190"
        ], [, , , , , , , , , [-1]], , , , "LY", , , , , , , , , , , , , , , , , , [, , "19[013]", , , , "190"], , [, , "19[013]", , , , "190"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MA: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:[59]|77)", , , , "15"], [, , , , , , , , , [-1]], , , , "MA", , , , , , , , , , , , , , , , , , [, , "1(?:[59]|77)", , , , "15"], , [, , "1(?:[59]|77)", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MC: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "MC", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15"], , [
          ,
          ,
          "1(?:12|41|[578])",
          ,
          ,
          ,
          "15"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MD: [, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "MD", , , , , , , , , , , , , , , , , , [, , "112|90[1-3]", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        ME: [
          ,
          [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]],
          ,
          ,
          [, , "1(?:12|2[2-4])", , , , "112", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "ME",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:12|2[2-4])", , , , "112", , , [3]],
          ,
          [, , "1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        MF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "MF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MG: [
          ,
          [, , "1\\d\\d?", , , , , , , [2, 3]],
          ,
          ,
          [, , "1(?:1[78]|[78])", , , , "17"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "MG",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:1[78]|[78])", , , , "17"],
          ,
          [, , "1(?:1[78]|[78])", , , , "17"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        MH: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "MH", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MK: [, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "1(?:1(?:2|6\\d{3})|9[2-4])", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "MK", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])", , , , "112", , , [3]], , [
          ,
          ,
          "1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}",
          ,
          ,
          ,
          "112"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        ML: [, [, , "[136-8]\\d{1,4}", , , , , , , [2, 3, 4, 5]], , , [, , "1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d", , , , "15", , , [2, 4, 5]], [, , "(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)", , , , "1220", , , [4, 5]], , , , "ML", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15", , , [2]], , [, , "1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d", , , , "15"], [
          ,
          ,
          "37(?:433|575)|7400|8001\\d",
          ,
          ,
          ,
          "7400",
          ,
          ,
          [4, 5]
        ], [, , "3503\\d|(?:3[67]\\d|800)\\d\\d", , , , "35030", , , [5]], , [, , "374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d", , , , "7400", , , [4, 5]]],
        MM: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "199", , , , "199"], [, , , , , , , , , [-1]], , , , "MM", , , , , , , , , , , , , , , , , , [, , "199", , , , "199"], , [, , "199", , , , "199"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MN: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "10[0-35]", , , , "100"], [, , , , , , , , , [-1]], , , , "MN", , , , , , , , , , , , , , , , , , [, , "10[0-35]", , , , "100"], , [, , "10[0-35]", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        MO: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "MO", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MP: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "MP", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MQ: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "MQ", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "1(?:12|[578])",
          ,
          ,
          ,
          "15"
        ], , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MR: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "MR", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MS: [, [, , "[29]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "MS", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "211|9(?:11|88|99)", , , , "211"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MT: [, [
          ,
          ,
          "1\\d\\d(?:\\d{3})?",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 6]
        ], , , [, , "11(?:2|6\\d{3})", , , , "112"], [, , , , , , , , , [-1]], , , , "MT", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "11(?:2|6(?:000|1(?:11|23)))", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MU: [, [, , "[189]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "11[45]|99[59]", , , , "114", , , [3]], [, , , , , , , , , [-1]], , , , "MU", , , , , , , , , , , , , , , , , , [, , "11[45]|99[59]", , , , "114", , , [3]], , [, , "1\\d{2,4}|(?:8\\d\\d|99)\\d", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        MV: [, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [
          ,
          ,
          "1(?:02|1[89])",
          ,
          ,
          ,
          "102",
          ,
          ,
          [3]
        ], [, , , , , , , , , [-1]], , , , "MV", , , , , , , , , , , , , , , , , , [, , "1(?:02|1[89])", , , , "102", , , [3]], , [, , "1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1", , , , "100"], [, , , , , , , , , [-1]], [, , "1[45]1", , , , "141", , , [3]], , [, , , , , , , , , [-1]]],
        MW: [, [, , "[189]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "199|99[7-9]", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "MW", , , , , , , , , , , , , , , , , , [, , "199|99[7-9]", , , , "199", , , [3]], , [, , "199|80400|99[7-9]", , , , "199"], [, , , , , , , , , [-1]], [, , "804\\d\\d", , , , "80400", , , [5]], , [, , "804\\d\\d", , , , "80400", , , [5]]],
        MX: [, [
          ,
          ,
          "[0579]\\d{2,4}",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 4, 5]
        ], , , [, , "0(?:6[0568]|80)|911", , , , "060", , , [3]], [, , "(?:530\\d|776)\\d", , , , "7760", , , [4, 5]], , , , "MX", , , , , , , , , , , , , , , , , , [, , "0(?:6[0568]|80)|911", , , , "060", , , [3]], , [, , "0[1-9]\\d|53053|7766|911", , , , "010"], [, , , , , , , , , [-1]], [, , "0(?:[249]0|[35][01])", , , , "020", , , [3]], , [, , , , , , , , , [-1]]],
        MY: [, [, , "[1369]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "112|999", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "MY", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [
          ,
          ,
          "1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d",
          ,
          ,
          ,
          "100"
        ], [, , "666\\d\\d", , , , "66600", , , [5]], [, , , , , , , , , [-1]], , [, , "(?:3[23679]\\d|666)\\d\\d", , , , "32000", , , [5]]],
        MZ: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[79]|9[78])", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "MZ", , , , , , , , , , , , , , , , , , [, , "1(?:1[79]|9[78])", , , , "117", , , [3]], , [, , "1(?:[02-5]\\d\\d|1[79]|9[78])", , , , "117"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        NA: [, [, , "[19]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10111", , , , "10111", , , [5]], [, , , , , , , , , [-1]], , , , "NA", , , , , , , , , , , , , , , , , , [, , "10111", , , , "10111", , , [5]], , [
          ,
          ,
          "(?:10|93)111|(?:1\\d|9)\\d\\d",
          ,
          ,
          ,
          "900"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        NC: [, [, , "[135]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577", , , , "15"], [, , , , , , , , , [-1]], , , , "NC", , , , , , , , , , , , , , , , , , [, , "1[5-8]", , , , "15", , , [2]], , [, , "1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d", , , , "15"], [, , "5(?:67|88)", , , , "567", , , [3]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        NE: [, [, , "[1-3578]\\d(?:\\d(?:\\d{3})?)?", , , , , , , [2, 3, 6]], , , [
          ,
          ,
          "1(?:18|[578])|723\\d{3}",
          ,
          ,
          ,
          "15"
        ], [, , , , , , , , , [-1]], , , , "NE", , , , , , , , , , , , , , , , , , [, , "1(?:18|[578])|723141", , , , "15"], , [, , "1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888", , , , "15"], [, , , , , , , , , [-1]], [, , "1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888", , , , "100", , , [3]], , [, , , , , , , , , [-1]]],
        NF: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|55|77)", , , , "911"], [, , , , , , , , , [-1]], , , , "NF", , , , , , , , , , , , , , , , , , [, , "9(?:11|55|77)", , , , "911"], , [, , "9(?:11|55|77)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        NG: [, [
          ,
          ,
          "[14]\\d\\d(?:\\d{2})?",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 5]
        ], , , [, , "199", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "NG", , , , , , , , , , , , , , , , , , [, , "199", , , , "199", , , [3]], , [, , "199|40700", , , , "199"], [, , , , , , , , , [-1]], [, , "407\\d\\d", , , , "40700", , , [5]], , [, , "407\\d\\d", , , , "40700", , , [5]]],
        NI: [, [, , "[12467]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[58]|2[08])|737\\d", , , , "115"], [, , , , , , , , , [-1]], , , , "NI", , , , , , , , , , , , , , , , , , [, , "1(?:1[58]|2[08])", , , , "115", , , [3]], , [, , "1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00", , , , "115"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        NL: [
          ,
          [, , "[1349]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]],
          ,
          ,
          [, , "11(?:2|6\\d{3})|911", , , , "112", , , [3, 6]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "NL",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "112|911", , , , "112", , , [3]],
          ,
          [, , "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , "120\\d", , , , "1200", , , [4]],
          ,
          [, , "[34]00\\d", , , , "3000", , , [4]]
        ],
        NO: [, [, , "[01]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[023]|6\\d{3})", , , , "110", , , [3, 6]], [, , , , , , , , , [-1]], , , , "NO", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "11[023]",
          ,
          ,
          ,
          "110",
          ,
          ,
          [3]
        ], , [, , "04\\d{3}|1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8[5-9]\\d|90)", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "04\\d{3}", , , , "04000", , , [5]]],
        NP: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:0[0-36]|12)|1(?:09|11)\\d", , , , "100"], [, , , , , , , , , [-1]], , , , "NP", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-3]|12)", , , , "100", , , [3]], , [, , "1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        NR: [
          ,
          [, , "1\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "11[0-2]", , , , "110"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "NR",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "11[0-2]", , , , "110"],
          ,
          [, , "1(?:1[0-2]|23|92)", , , , "110"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        NU: [, [, , "[019]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "NU", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "01[05]|101|999", , , , "010"], [, , , , , , , , , [-1]], [, , "010", , , , "010"], , [, , , , , , , , , [-1]]],
        NZ: [, [, , "\\d{3,4}", , , , , , , [3, 4]], , , [, , "111", , , , "111", , , [3]], [, , "018", , , , "018", , , [3]], , , , "NZ", , , , , , , , , , , , , , , , , , [, , "111", , , , "111", , , [3]], , [
          ,
          ,
          "018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)",
          ,
          ,
          ,
          "018"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}", , , , "018"]],
        OM: [, [, , "[19]\\d{3}", , , , , , , [4]], , , [, , "1444|999\\d", , , , "1444"], [, , , , , , , , , [-1]], , , , "OM", , , , , , , , , , , , , , , , , , [, , "1444|9999", , , , "1444"], , [, , "1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d", , , , "1111"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PA: [
          ,
          [, , "[19]\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "911", , , , "911"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "PA",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "911", , , , "911"],
          ,
          [, , "10[2-4]|911", , , , "102"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        PE: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:05|1[67])", , , , "105"], [, , , , , , , , , [-1]], , , , "PE", , , , , , , , , , , , , , , , , , [, , "1(?:05|1[67])", , , , "105"], , [, , "1(?:05|1[67])", , , , "105"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "PF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PG: [, [, , "[01]\\d{2,6}", , , , , , , [
          3,
          4,
          5,
          6,
          7
        ]], , , [, , "000|11[01]", , , , "000", , , [3]], [, , , , , , , , , [-1]], , , , "PG", , , , , , , , , , , , , , , , , , [, , "000|11[01]", , , , "000", , , [3]], , [, , "000|1(?:1[01]|5\\d\\d|6\\d{2,5})", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "16\\d{2,5}", , , , "1600", , , [4, 5, 6, 7]]],
        PH: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "11[27]|911", , , , "112"], [, , , , , , , , , [-1]], , , , "PH", , , , , , , , , , , , , , , , , , [, , "11[27]|911", , , , "112"], , [, , "11[27]|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PK: [, [, , "1\\d{1,3}", , , , , , , [2, 3, 4]], , , [
          ,
          ,
          "1(?:1(?:2\\d?|5)|[56])",
          ,
          ,
          ,
          "15"
        ], [, , , , , , , , , [-1]], , , , "PK", , , , , , , , , , , , , , , , , , [, , "1(?:1(?:22?|5)|[56])", , , , "15"], , [, , "1(?:122|3[014]|[56])|11[2457-9]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PL: [, [, , "[19]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "11(?:2|6\\d{3})|99[7-9]", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "PL", , , , , , , , , , , , , , , , , , [, , "112|99[7-9]", , , , "112", , , [3]], , [, , "1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PM: [, [
          ,
          ,
          "[13]\\d(?:\\d{2})?",
          ,
          ,
          ,
          ,
          ,
          ,
          [2, 4]
        ], , , [, , "1[578]", , , , "15", , , [2]], [, , , , , , , , , [-1]], , , , "PM", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15", , , [2]], , [, , "1[578]|3103", , , , "15"], [, , , , , , , , , [-1]], [, , "310\\d", , , , "3100", , , [4]], , [, , , , , , , , , [-1]]],
        PR: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "PR", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PS: [
          ,
          [, , "1\\d{2,3}", , , , , , , [3, 4]],
          ,
          ,
          [, , "1(?:0[0-2]|66)", , , , "100", , , [3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "PS",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "10[0-2]", , , , "100", , , [3]],
          ,
          [, , "1(?:0[0-2]|122|44|66|99)", , , , "100"],
          [, , , , , , , , , [-1]],
          [, , "112\\d", , , , "1120", , , [4]],
          ,
          [, , , , , , , , , [-1]]
        ],
        PT: [, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "11[257]|1(?:16\\d\\d|5[1589]|8[279])\\d", , , , "112"], [, , , , , , , , , [-1]], , , , "PT", , , , , , , , , , , , , , , , , , [, , "11[25]", , , , "112", , , [3]], , [, , "1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0", , , , "112"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , , , , , , , , [-1]]],
        PW: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "PW", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        PY: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "128|911", , , , "128"], [, , , , , , , , , [-1]], , , , "PY", , , , , , , , , , , , , , , , , , [, , "128|911", , , , "128"], , [, , "1[1-9]\\d|911", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        QA: [
          ,
          [, , "[129]\\d{2,4}", , , , , , , [3, 4, 5]],
          ,
          ,
          [, , "99\\d", , , , "990", , , [3]],
          [, , "900", , , , "900", , , [3]],
          ,
          ,
          ,
          "QA",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "999", , , , "999", , , [3]],
          ,
          [, , "9(?:00|[19]\\d)|(?:1|20|9[27]\\d)\\d\\d", , , , "100"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        RE: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "RE", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15"], , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        RO: [
          ,
          [, , "[18]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
          ,
          ,
          [, , "11(?:2|6\\d{3})", , , , "112", , , [3, 6]],
          [, , "(?:1(?:18[39]|[24])|8[48])\\d\\d", , , , "1200", , , [4, 6]],
          ,
          ,
          ,
          "RO",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "112", , , , "112", , , [3]],
          ,
          [, , "1(?:1(?:2|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d", , , , "112"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , "(?:1[24]|8[48])\\d\\d", , , , "1200", , , [4]]
        ],
        RS: [, [, , "[19]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "112|9[2-4]", , , , "92", , , [2, 3]], [, , , , , , , , , [-1]], , , , "RS", , , , , , , , , , , , , , , , , , [, , "112|9[2-4]", , , , "92", , , [2, 3]], , [, , "1[189]\\d{1,4}|9[2-4]", , , , "92"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        RU: [, [, , "[01]\\d\\d?", , , , , , , [2, 3]], , , [, , "112|(?:0|10)[1-3]", , , , "01"], [, , , , , , , , , [-1]], , , , "RU", , , , , , , , , , , , , , , , , , [, , "112|(?:0|10)[1-3]", , , , "01"], , [, , "112|(?:0|10)[1-4]", , , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        RW: [, [, , "[14]\\d\\d", , , , , , , [3]], , , [, , "11[1245]", , , , "111"], [, , , , , , , , , [-1]], , , , "RW", , , , , , , , , , , , , , , , , , [, , "11[12]", , , , "111"], , [, , "1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SA: [, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [
          ,
          ,
          "11(?:2|6\\d{3})|9(?:11|37|9[7-9])",
          ,
          ,
          ,
          "112",
          ,
          ,
          [3, 6]
        ], [, , , , , , , , , [-1]], , , , "SA", , , , , , , , , , , , , , , , , , [, , "112|9(?:11|9[79])", , , , "112", , , [3]], , [, , "1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])", , , , "112"], [, , "141\\d", , , , "1410", , , [4]], [, , "1(?:10|41)\\d|90[24679]", , , , "902", , , [3, 4]], , [, , , , , , , , , [-1]]],
        SB: [, [, , "[127-9]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SB", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [
          ,
          ,
          "1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)",
          ,
          ,
          ,
          "100"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SC: [, [, , "[19]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[1468]|60)|999", , , , "111", , , [3]], [, , , , , , , , , [-1]], , , , "SC", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , [, , "1(?:[06]\\d|1[0-246-8]|2[0-8]|3[13]|4[0-2]|5[15]|7[124-6]|8[158]|9[015])|9(?:6\\d\\d|99)", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SD: [
          ,
          [, , "9\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "999", , , , "999"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "SD",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "999", , , , "999"],
          ,
          [, , "999", , , , "999"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        SE: [, [, , "[1-37-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|(?:3|6\\d)\\d\\d|414|77)|900\\d\\d", , , , "112"], [, , "11811[89]|72\\d{3}", , , , "72000", , , [5, 6]], , , , "SE", , , , , , , , , , , , , , , , , , [, , "112|90000", , , , "112", , , [3, 5]], , [, , "11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])", , , , "112"], [, , , , , , , , , [-1]], [
          ,
          ,
          "2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912",
          ,
          ,
          ,
          "220",
          ,
          ,
          [3]
        ], , [, , "7\\d{4}", , , , "70000", , , [5]]],
        SG: [, [, , "[179]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "99[359]", , , , "993", , , [3]], [, , , , , , , , , [-1]], , , , "SG", , , , , , , , , , , , , , , , , , [, , "99[359]", , , , "993", , , [3]], , [, , "1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "772\\d\\d", , , , "77200", , , [5]]],
        SH: [, [, , "[129]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "9(?:11|99)", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "SH", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911", , , [3]], , [
          ,
          ,
          "1\\d{2,3}|26[01]\\d\\d|9(?:11|99)",
          ,
          ,
          ,
          "100"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SI: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)", , , , "112"], [, , , , , , , , , [-1]], , , , "SI", , , , , , , , , , , , , , , , , , [, , "11[23]", , , , "112", , , [3]], , [, , "1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SJ: [, [, , "[01]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [
          ,
          ,
          "11[023]",
          ,
          ,
          ,
          "110",
          ,
          ,
          [3]
        ], [, , , , , , , , , [-1]], , , , "SJ", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "110", , , [3]], , [, , "04\\d{3}|11[023]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "04\\d{3}", , , , "04000", , , [5]]],
        SK: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6\\d{3})|5[058])", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "SK", , , , , , , , , , , , , , , , , , [, , "1(?:12|5[058])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SL: [, [
          ,
          ,
          "[069]\\d\\d(?:\\d{2})?",
          ,
          ,
          ,
          ,
          ,
          ,
          [3, 5]
        ], , , [, , "(?:01|99)9", , , , "019", , , [3]], [, , , , , , , , , [-1]], , , , "SL", , , , , , , , , , , , , , , , , , [, , "(?:01|99)9", , , , "019", , , [3]], , [, , "(?:01|99)9|60400", , , , "019"], [, , , , , , , , , [-1]], [, , "604\\d\\d", , , , "60400", , , [5]], , [, , "604\\d\\d", , , , "60400", , , [5]]],
        SM: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[358]", , , , "113"], [, , , , , , , , , [-1]], , , , "SM", , , , , , , , , , , , , , , , , , [, , "11[358]", , , , "113"], , [, , "11[358]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SN: [, [, , "[12]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [
          ,
          ,
          "1(?:515|[78])|2(?:00|1)\\d{3}",
          ,
          ,
          ,
          "17",
          ,
          ,
          [2, 4, 5, 6]
        ], [, , "2(?:0[246]|[468])\\d{3}", , , , "24000", , , [5, 6]], , , , "SN", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17", , , [2]], , [, , "1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]", , , , "12"], [, , "2(?:01|2)\\d{3}", , , , "22000", , , [5, 6]], [, , "1[46]\\d\\d", , , , "1400", , , [4]], , [, , "2[468]\\d{3}", , , , "24000", , , [5]]],
        SO: [, [, , "[57-9]\\d\\d", , , , , , , [3]], , , [, , "555|888|999", , , , "555"], [, , , , , , , , , [-1]], , , , "SO", , , , , , , , , , , , , , , , , , [, , "555|888|999", , , , "555"], , [, , "555|777|888|999", , , , "555"], [, , , , , , , , , [-1]], [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ], , [, , , , , , , , , [-1]]],
        SR: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "115", , , , "115", , , [3]], [, , , , , , , , , [-1]], , , , "SR", , , , , , , , , , , , , , , , , , [, , "115", , , , "115", , , [3]], , [, , "1\\d{2,3}", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SS: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SS", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        ST: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "ST", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "112",
          ,
          ,
          ,
          "112"
        ], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SV: [, [, , "[149]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "116\\d{3}|911", , , , "911", , , [3, 6]], [, , , , , , , , , [-1]], , , , "SV", , , , , , , , , , , , , , , , , , [, , "91[13]", , , , "911", , , [3]], , [, , "1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)", , , , "112"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
        SX: [
          ,
          [, , "9\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "9(?:19|88)", , , , "919"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "SX",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "919", , , , "919"],
          ,
          [, , "9(?:19|88)", , , , "919"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        SY: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[023]", , , , "110"], [, , , , , , , , , [-1]], , , , "SY", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "110"], , [, , "11[023]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        SZ: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SZ", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TC: [, [, , "9\\d\\d", , , , , , , [3]], , , [
          ,
          ,
          "9(?:11|88|99)",
          ,
          ,
          ,
          "911"
        ], [, , , , , , , , , [-1]], , , , "TC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TD: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "TD", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TG: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[78]|7[127])", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "TG", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "1(?:1[78]|7[127])",
          ,
          ,
          ,
          "117",
          ,
          ,
          [3]
        ], , [, , "1(?:011|1[078]|7[127])", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TH: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55", , , , "191"], [, , "1(?:113|2[23]\\d|5(?:09|56))", , , , "1113", , , [4]], , , , "TH", , , , , , , , , , , , , , , , , , [, , "1(?:669|9[19])", , , , "191"], , [
          ,
          ,
          "1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])",
          ,
          ,
          ,
          "100"
        ], [, , "1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d", , , , "1103", , , [4]], [, , "114[89]", , , , "1148", , , [4]], , [, , , , , , , , , [-1]]],
        TJ: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:0[1-3]|12)", , , , "101"], [, , , , , , , , , [-1]], , , , "TJ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101"], , [, , "1(?:0[1-3]|12)", , , , "101"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TL: [, [
          ,
          ,
          "1\\d\\d",
          ,
          ,
          ,
          ,
          ,
          ,
          [3]
        ], , , [, , "11[25]", , , , "112"], [, , , , , , , , , [-1]], , , , "TL", , , , , , , , , , , , , , , , , , [, , "11[25]", , , , "112"], , [, , "1(?:0[02]|1[25]|2[0138]|72|9[07])", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TM: [, [, , "0\\d", , , , , , , [2]], , , [, , "0[1-49]", , , , "01"], [, , , , , , , , , [-1]], , , , "TM", , , , , , , , , , , , , , , , , , [, , "0[1-3]", , , , "01"], , [, , "0[1-49]", , , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TN: [
          ,
          [, , "1\\d\\d", , , , , , , [3]],
          ,
          ,
          [, , "19[078]", , , , "190"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "TN",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "19[078]", , , , "190"],
          ,
          [, , "19[078]", , , , "190"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        TO: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|22|33|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "TO", , , , , , , , , , , , , , , , , , [, , "9(?:11|22|33|99)", , , , "911"], , [, , "9(?:11|22|33|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TR: [, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "TR", , , , , , , , , , , , , , , , , , [, , "1(?:1[02]|55)", , , , "110", , , [3]], , [
          ,
          ,
          "1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d",
          ,
          ,
          ,
          "110"
        ], [, , "(?:285|542)0", , , , "2850", , , [4]], [, , , , , , , , , [-1]], , [, , "1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d", , , , "144", , , [3, 4]]],
        TT: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:88|9[09])", , , , "988"], [, , , , , , , , , [-1]], , , , "TT", , , , , , , , , , , , , , , , , , [, , "99[09]", , , , "990"], , [
          ,
          ,
          "9(?:88|9[09])",
          ,
          ,
          ,
          "988"
        ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TV: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "TV", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "1\\d\\d|911", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TW: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[0289]|1(?:81|92)\\d", , , , "110"], [, , "10[56]", , , , "105", , , [3]], , , , "TW", , , , , , , , , , , , , , , , , , [, , "11[029]", , , , "110", , , [3]], , [
          ,
          ,
          "1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))",
          ,
          ,
          ,
          "100"
        ], [, , "1(?:65|9(?:1\\d|50|85|98))", , , , "165"], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        TZ: [, [, , "[149]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:1[0-79]|9[09])|999", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "TZ", , , , , , , , , , , , , , , , , , [, , "11[0-245]|999", , , , "110", , , [3]], , [, , "1(?:1\\d|9[09])|46400|999", , , , "110"], [, , , , , , , , , [-1]], [, , "464\\d\\d", , , , "46400", , , [5]], , [, , "464\\d\\d", , , , "46400", , , [5]]],
        UA: [
          ,
          [, , "[189]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
          ,
          ,
          [, , "1(?:0[1-3]|1(?:2|6\\d{3}))", , , , "101", , , [3, 6]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "UA",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:0[1-3]|12)", , , , "101", , , [3]],
          ,
          [, , "1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d", , , , "101"],
          [, , , , , , , , , [-1]],
          [, , "(?:118|[89]00)\\d\\d?", , , , "1180", , , [4, 5]],
          ,
          [, , , , , , , , , [-1]]
        ],
        UG: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "UG", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        US: [, [, , "[1-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [
          ,
          ,
          "112|611|9(?:11|33|88)",
          ,
          ,
          ,
          "112",
          ,
          ,
          [3]
        ], [, , "24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7", , , , "24280", , , [5]], , , , "US", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", , , [3]], , [, , "11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-8]11|9(?:11|33|88)", , , , "112"], [
          ,
          ,
          "2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099",
          ,
          ,
          ,
          "23333",
          ,
          ,
          [5, 6]
        ], [, , "336\\d\\d|[2-9]\\d{3}|[2356]11", , , , "211", , , [3, 4, 5]], , [, , "[2-9]\\d{4,5}", , , , "20000", , , [5, 6]]],
        UY: [, [, , "[129]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "128|911", , , , "128", , , [3]], [, , , , , , , , , [-1]], , , , "UY", , , , , , , , , , , , , , , , , , [, , "128|911", , , , "128", , , [3]], , [, , "1(?:0[4-9]|1[2368]|2[0-3568]|787|997\\d?)|21997|911", , , , "104"], [, , "178\\d", , , , "1780", , , [4]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        UZ: [
          ,
          [, , "[04]\\d(?:\\d(?:\\d{2})?)?", , , , , , , [2, 3, 5]],
          ,
          ,
          [, , "0(?:0[1-3]|[1-3]|50)", , , , "01", , , [2, 3]],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "UZ",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "0(?:0[1-3]|[1-3]|50)", , , , "01", , , [2, 3]],
          ,
          [, , "0(?:0[1-3]|[1-3]|50)|45400", , , , "01"],
          [, , , , , , , , , [-1]],
          [, , "454\\d\\d", , , , "45400", , , [5]],
          ,
          [, , "454\\d\\d", , , , "45400", , , [5]]
        ],
        VA: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[2358]", , , , "112"], [, , , , , , , , , [-1]], , , , "VA", , , , , , , , , , , , , , , , , , [, , "11[2358]", , , , "112"], , [, , "11[2358]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        VC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "VC", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "9(?:11|99)",
          ,
          ,
          ,
          "911"
        ], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        VE: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "1(?:12|71)|911", , , , "112"], [, , , , , , , , , [-1]], , , , "VE", , , , , , , , , , , , , , , , , , [, , "1(?:12|71)|911", , , , "112"], , [, , "1(?:12|71)|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        VG: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "VG", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        VI: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "VI", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        VN: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[3-5]", , , , "113"], [, , , , , , , , , [-1]], , , , "VN", , , , , , , , , , , , , , , , , , [, , "11[3-5]", , , , "113"], , [, , "11[3-5]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        VU: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "VU", , , , , , , , , , , , , , , , , , [
          ,
          ,
          "112",
          ,
          ,
          ,
          "112"
        ], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        WF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "WF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        WS: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|9[4-69])", , , , "911"], [, , , , , , , , , [-1]], , , , "WS", , , , , , , , , , , , , , , , , , [, , "9(?:11|9[4-69])", , , , "911"], , [, , "1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])", , , , "111"], [, , , , , , , , , [-1]], [, , "12[0-6]", , , , "120"], , [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ]],
        XK: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , [-1]], , , , "XK", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])", , , , "112"], , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        YE: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[1459]", , , , "191"], [, , , , , , , , , [-1]], , , , "YE", , , , , , , , , , , , , , , , , , [, , "19[1459]", , , , "191"], , [, , "19[1459]", , , , "191"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        YT: [
          ,
          [, , "1\\d\\d?", , , , , , , [2, 3]],
          ,
          ,
          [, , "1(?:12|5)", , , , "15"],
          [, , , , , , , , , [-1]],
          ,
          ,
          ,
          "YT",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:12|5)", , , , "15"],
          ,
          [, , "1(?:12|5)", , , , "15"],
          [, , , , , , , , , [-1]],
          [, , , , , , , , , [-1]],
          ,
          [, , , , , , , , , [-1]]
        ],
        ZA: [
          ,
          [, , "[134]\\d{2,4}", , , , , , , [3, 4, 5]],
          ,
          ,
          [, , "1(?:01\\d\\d|12)", , , , "112", , , [3, 5]],
          [, , "41(?:348|851)", , , , "41348", , , [5]],
          ,
          ,
          ,
          "ZA",
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [, , "1(?:01(?:11|77)|12)", , , , "112", , , [3, 5]],
          ,
          [, , "1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}", , , , "107"],
          [, , "3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699", , , , "30782", , , [5]],
          [, , "111", , , , "111", , , [3]],
          ,
          [, , "[34]\\d{4}", , , , "30000", , , [5]]
        ],
        ZM: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|99[139]", , , , "112"], [, , , , , , , , , [-1]], , , , "ZM", , , , , , , , , , , , , , , , , , [, , "112|99[139]", , , , "112"], , [, , "112|99[139]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
        ZW: [, [, , "[139]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112|9(?:5[023]|61|9[3-59])", , , , "112", , , [3]], [, , "3[013-57-9]\\d{3}", , , , "30000", , , [5]], , , , "ZW", , , , , , , , , , , , , , , , , , [, , "112|99[3-59]", , , , "112", , , [3]], , [
          ,
          ,
          "11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])",
          ,
          ,
          ,
          "112"
        ], [, , , , , , , , , [-1]], [, , "114|9(?:5[023]|6[0-25])", , , , "114", , , [3]], , [, , , , , , , , , [-1]]]
      };
      function I0() {
        this.g = {};
      }
      t(I0);
      function Zl(b) {
        return (b = we[b]) ? b : [];
      }
      function Xl(b) {
        var C = y4;
        if (!b) return null;
        b = b.toUpperCase();
        var P = C.g[b];
        if (P == null) {
          if (P = b4[b], P == null) return null;
          P = new he().g(Re.o(), P), C.g[b] = P;
        }
        return P;
      }
      function Ql(b) {
        if (!I(b, 2)) return "";
        var C = "" + M(b, 2);
        return I(b, 4) && M(b, 4) && 0 < D(b, 8) ? Array(D(b, 8) + 1).join("0") + C : C;
      }
      function eu(b, C) {
        return 0 < j(C, 9).length && !j(C, 9).includes(b.length) ? !1 : Mn(D(C, 2), b.toString());
      }
      var jt = Fe.pa(), y4 = I0.pa();
      function v4(b) {
        var C = jt, P = Vo(C, b);
        switch (C = an(C, D(b, 1), P), C == null ? b = -1 : (b = Ft(b), b = ql(b, C)), b) {
          case 0:
            return "fixed-line";
          case 2:
            return "fixed-line-or-mobile";
          case 1:
            return "mobile";
          case 8:
            return "pager";
          case 7:
            return "personal-number";
          case 4:
            return "premium-rate";
          case 5:
            return "shared-cost";
          case 3:
            return "toll-free";
          case 9:
            return "uan";
          case 6:
            return "voip";
          default:
          case -1:
            return "unknown";
        }
      }
      function _4(b) {
        switch (b) {
          case "fixed-line":
            return 0;
          case "fixed-line-or-mobile":
            return 2;
          case "mobile":
            return 1;
          case "pager":
            return 8;
          case "personal-number":
            return 7;
          case "premium-rate":
            return 4;
          case "shared-cost":
            return 5;
          case "toll-free":
            return 3;
          case "uan":
            return 9;
          case "voip":
            return 6;
          default:
          case "unknown":
            return -1;
        }
      }
      function B0(b) {
        try {
          switch (x0(b)) {
            case 0:
              return "is-possible";
            case 1:
              return "invalid-country-code";
            case 3:
              return "too-long";
            case 2:
              return "too-short";
          }
          if ($0(b)) return "is-possible";
        } catch {
        }
        return "unknown";
      }
      function $4(b, C) {
        if (b.charAt(0) !== "+" && b.slice(0, 2) !== "00") return { parsed: P, fa: F };
        try {
          var P = Gl(jt, b, C);
        } catch {
        }
        if (P) {
          var F = Vo(jt, P);
          if (F != null && F !== "ZZ") return { parsed: P, fa: F };
        }
        for (C = 1; 4 > C; ++C) {
          if (F = void 0, b.length < C + 1) return { parsed: P, fa: F };
          if (F = wr(b.substring(1, C + 1)), F !== "ZZ") return { fa: F };
        }
        return { parsed: P, fa: void 0 };
      }
      var tu;
      e: {
        try {
          tu = /* @__PURE__ */ new WeakMap();
          break e;
        } catch {
        }
        tu = void 0;
      }
      var jo = tu;
      function ke(b, C) {
        if (!(this instanceof ke)) return new ke(b, C);
        var P = C == null ? void 0 : C.regionCode;
        if (typeof b == "string") var F = !1;
        else try {
          _0(b), F = !0;
        } catch {
          F = !1;
        }
        if (!F && typeof b != "string") throw Error("Invalid phone number, expected a string");
        if (!F && typeof C != "object" && typeof C < "u") throw Error(`Invalid options, expected object, got ${typeof C}. This may be because of not yet upgraded code.`);
        if (!F && P != null && typeof P != "string") throw Error(`Invalid region code, expected a string, got ${typeof P} ${P}`);
        if (F || (b = b.trim(), P && b.charAt(0) === "+" && (P = null), P && b.charAt(0) !== "+" && b.slice(0, 2) !== "00" || ({ fa: P = null, parsed: H } = $4(b, P))), this.g = { number: {}, regionCode: P, valid: !1, possible: !1, shortPossible: !1, shortValid: !1 }, jo && jo.set(this.g, this), F) this.l = b;
        else {
          if (this.l = null, this.g.number.input = b, !P) {
            this.g.possibility = "invalid-country-code";
            return;
          }
          if (nu(P) === 0) {
            this.g.possibility = "invalid-country-code";
            return;
          }
          try {
            this.l = H || Gl(jt, b, P);
          } catch {
            this.g.possibility = B0(b);
            return;
          }
        }
        this.g.number.international = jt.format(this.l, 1), this.g.number.national = jt.format(this.l, 2), this.g.number.e164 = jt.format(this.l, 0), this.g.number.rfc3966 = jt.format(this.l, 3), this.g.number.significant = Ft(this.l), this.g.canBeInternationallyDialled = jt.ja(this.l), this.g.valid = _0(this.l), this.g.possible = $0(this.l), this.g.possibility = B0(this.l), b = this.g, C = this.l;
        var H = Zl(D(C, 1));
        e: if (H.length === 0) F = null;
        else if (H.length === 1) F = H[0];
        else {
          F = Ql(C);
          for (var ee = 0; ee < H.length; ee++) {
            var se = H[ee], Se = Xl(se);
            if (Se && eu(F, M(Se, 29))) {
              F = se;
              break e;
            }
          }
          F = null;
        }
        1 < H.length && F != null ? C = !0 : (H = F, F = Zl(D(C, 1)), H != null && F.includes(H) && (H = Xl(H)) ? (C = Ql(C), F = M(H, 1), eu(C, F) ? (H = M(H, 29), C = eu(C, H)) : C = !1) : C = !1), b.shortValid = C, b = this.g;
        e: {
          for (H = this.l, C = Zl(D(H, 1)), H = Ql(H).length, F = 0; F < C.length; F++) if ((ee = Xl(C[F])) && j(M(ee, 1), 9).includes(H)) {
            C = !0;
            break e;
          }
          C = !1;
        }
        b.shortPossible = C, this.g.type = v4(this.l), this.g.typeIsMobile = this.ua(), this.g.typeIsFixedLine = this.ta(), this.g.countryCode = Lt(P) ? Cs(jt, P) : 0;
      }
      var Ss = ["PhoneNumber$$module$src$index"], Fn = e;
      Ss[0] in Fn || typeof Fn.execScript > "u" || Fn.execScript("var " + Ss[0]);
      for (var ti; Ss.length && (ti = Ss.shift()); ) Ss.length || ke === void 0 ? Fn[ti] && Fn[ti] !== Object.prototype[ti] ? Fn = Fn[ti] : Fn = Fn[ti] = {} : Fn[ti] = ke;
      function nu(b) {
        return Lt(b) ? Cs(jt, b) : 0;
      }
      ke.getCountryCodeForRegionCode = nu, ke.getRegionCodeForCountryCode = function(b) {
        return wr(b);
      }, ke.findNumbers = function(b, C) {
        var P = C == null ? void 0 : C.defaultRegionCode, F, H = (F = C == null ? void 0 : C.leniency) != null ? F : "valid", ee;
        C = (ee = C == null ? void 0 : C.maxTries) != null ? ee : Number.MAX_SAFE_INTEGER, ee = /([0-9]+(?: [0-9]+)*)/g, F = [];
        for (let tr = 0; tr < C; ++tr) {
          var se = ee.exec(b);
          if (!se) break;
          let Es = se.index;
          se = se.index + se[1].length, 0 < Es && b.charAt(Es - 1) === "+" && --Es;
          var Se = b.slice(Es, se), Ye = new ke(Se, { regionCode: P });
          (Ye.wa() || H === "possible" && Ye.va()) && F.push({ text: Se, phoneNumber: Ye.toJSON(), start: Es, end: se });
        }
        return F;
      };
      function z0(b) {
        var C = {};
        return b.filter((P) => C.hasOwnProperty(P) ? !1 : (C[P] = 1, !0));
      }
      ke.getSupportedRegionCodes = function() {
        return z0(De());
      }, ke.getSupportedCallingCodes = function() {
        return z0(Et());
      }, ke.getExample = function(b, C) {
        var P;
        return C ? P = ei(b, _4(C)) : P = ei(b, 0), new ke(P, b).toJSON();
      }, ke.getAsYouType = function(b) {
        return new Rt(b);
      }, ke.getNumberFrom = function(b, C) {
        try {
          e: {
            if (jo) {
              var P = jo.get(b);
              if (P) {
                var F = P;
                break e;
              }
            }
            let H;
            F = new ke(b == null || (H = b.number) == null ? void 0 : H.e164, {});
          }
          return { valid: !0, number: xr(F.l, C) };
        } catch (H) {
          return { valid: !1, error: H };
        }
      }, ke.prototype.toJSON = function() {
        return this.g;
      }, ke.prototype.toJSON = ke.prototype.toJSON, ke.prototype.ja = function() {
        return this.g.canBeInternationallyDialled;
      }, ke.prototype.canBeInternationallyDialled = ke.prototype.ja, ke.prototype.wa = function() {
        return this.g.valid;
      }, ke.prototype.isValid = ke.prototype.wa, ke.prototype.va = function() {
        return this.g.possible;
      }, ke.prototype.isPossible = ke.prototype.va, ke.prototype.getType = function() {
        return this.g.type;
      }, ke.prototype.getType = ke.prototype.getType, ke.prototype.ua = function() {
        return this.g.type === "mobile" || this.g.type === "fixed-line-or-mobile";
      }, ke.prototype.isMobile = ke.prototype.ua, ke.prototype.ta = function() {
        return this.g.type === "fixed-line" || this.g.type === "fixed-line-or-mobile";
      }, ke.prototype.isFixedLine = ke.prototype.ta, ke.prototype.xa = function(b) {
        return this.g.number[b ?? "e164"];
      }, ke.prototype.getNumber = ke.prototype.xa, ke.prototype.za = function() {
        return this.g.regionCode;
      }, ke.prototype.getRegionCode = ke.prototype.za, ke.prototype.ia = function() {
        return nu(this.g.regionCode);
      }, ke.prototype.getCountryCode = ke.prototype.ia;
      function Rt(b) {
        this.j = b, this.h = new h4(b), this.l = this.g = "";
      }
      Rt.prototype.sa = function(b) {
        this.g += b;
        var C = this.h;
        return C.la = g4(C, b), this.l = C.la;
      }, Rt.prototype.addChar = Rt.prototype.sa, Rt.prototype.Ba = function() {
        return this.l;
      }, Rt.prototype.number = Rt.prototype.Ba, Rt.prototype.Ca = function() {
        return this.g === "" ? this.l : this.reset(this.g.slice(0, this.g.length - 1));
      }, Rt.prototype.removeChar = Rt.prototype.Ca, Rt.prototype.reset = function(b) {
        var C = this.h;
        if (C.la = "", ue(C.u), ue(C.ba), ue(C.$), C.aa = 0, C.da = "", ue(C.h), C.s = "", ue(C.g), C.v = !0, C.oa = !1, C.ca = !1, C.ea = !1, C.j = [], C.ha = !1, C.m != C.Aa && (C.m = Yl(C, C.ma)), this.l = this.g = "", b) {
          C = 0;
          for (var P = b.length; C < P; ++C) this.sa(b.charAt(C));
        }
        return this.l;
      }, Rt.prototype.reset = Rt.prototype.reset, Rt.prototype.ya = function() {
        return new ke(this.l, { regionCode: this.j }).toJSON();
      }, Rt.prototype.getPhoneNumber = Rt.prototype.ya;
    }).call(
      n.exports || typeof globalThis < "u" && globalThis || typeof Oa < "u" && Oa || typeof window < "u" && window || typeof self < "u" && self || i_
    );
  }(ga)), ga.exports;
}
var o_ = ma.exports, hc;
function a_() {
  return hc || (hc = 1, function(n) {
    const e = "PhoneNumber$$module$src$index";
    n.exports = s_()[e] || (typeof globalThis < "u" && globalThis || typeof Oa < "u" && Oa || typeof window < "u" && window || typeof self < "u" && self || o_)[e], Object.defineProperty(
      n.exports,
      "__esModule",
      {
        value: !0
      }
    ), n.exports.parsePhoneNumber = (...t) => {
      try {
        const r = n.exports(...t).toJSON();
        return !r.valid && !r.possible && (r.possible = !1, r.possibility || (r.possibility = "invalid")), r;
      } catch (r) {
        return {
          valid: !1,
          possible: !1,
          possibility: "invalid",
          error: r
        };
      }
    }, n.exports.getCountryCodeForRegionCode = n.exports.getCountryCodeForRegionCode, n.exports.getRegionCodeForCountryCode = n.exports.getRegionCodeForCountryCode, n.exports.getSupportedCallingCodes = n.exports.getSupportedCallingCodes, n.exports.getSupportedRegionCodes = n.exports.getSupportedRegionCodes, n.exports.getExample = n.exports.getExample, n.exports.getAsYouType = n.exports.getAsYouType, n.exports.getNumberFrom = n.exports.getNumberFrom, n.exports.findNumbers = n.exports.findNumbers;
  }(ma)), ma.exports;
}
var l_ = a_(), Np = /* @__PURE__ */ r_(l_);
const {
  PhoneNumber: kA,
  AsYouType: CA,
  getCountryCodeForRegionCode: Ko,
  getRegionCodeForCountryCode: SA,
  getSupportedCallingCodes: EA,
  getSupportedRegionCodes: u_,
  findNumbers: TA,
  getExample: d_,
  getAsYouType: OA,
  getNumberFrom: MA
} = Np, mc = (...n) => {
  try {
    const e = Np(...n).toJSON();
    return !e.valid && !e.possible && (e.possible = !1, e.possibility || (e.possibility = "invalid")), e;
  } catch (e) {
    return {
      valid: !1,
      possible: !1,
      possibility: "invalid",
      error: e
    };
  }
}, c_ = { class: "flex flex-row" }, f_ = { key: 0 }, p_ = { class: "p-2 hover:bg-grey-50" }, h_ = ["innerHTML"], AA = /* @__PURE__ */ X({
  __name: "CfgPhoneNumberField",
  props: /* @__PURE__ */ Ae({
    ...Wt,
    countries: {
      type: Array,
      default: () => ["CZ", "SK"]
    },
    showCountries: {
      type: Boolean,
      default: !0
    },
    selectedCountry: {
      type: String,
      default: "CZ"
    }
  }, {
    modelValue: {
      required: !0,
      default: {
        phoneNumber: "",
        parsedPhoneNumber: ""
      }
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n, { expose: e }) {
    const t = n, r = Z(() => pr(t, Object.keys({ ...Wt }))), i = je(n, "modelValue");
    Dt(() => {
      i.value = { phoneNumber: `+${Ko(t.selectedCountry)}` || "", parsedPhoneNumber: "" };
    });
    const s = ae([]);
    u_().forEach((h) => {
      t.countries.includes(h) && s.value.push({
        value: h.toLowerCase(),
        label: `+${Ko(h)}`
      });
    });
    const o = ae({
      value: t.selectedCountry.toLowerCase(),
      label: `+${Ko(t.selectedCountry)}`
    }), a = Z(() => `+${Ko(o.value.value.toUpperCase())}`);
    e({ getExamplePhone: c, getPhoneNumber: f });
    const l = Z({
      get() {
        var h;
        return ((h = i.value) == null ? void 0 : h.phoneNumber) || "";
      },
      set(h) {
        var g;
        const y = mc(h);
        i.value = {
          phoneNumber: h,
          parsedPhoneNumber: ((g = y.number) == null ? void 0 : g.e164) ?? ""
        };
      }
    }), u = Z(() => l.value === a.value), d = Z(() => {
      var h;
      return !((h = i.value) != null && h.phoneNumber) || u.value ? !0 : mc(i.value.phoneNumber).valid;
    });
    function c(h = t.selectedCountry) {
      return d_(h);
    }
    function f() {
      var h;
      return ((h = i.value) == null ? void 0 : h.parsedPhoneNumber) ?? "";
    }
    const p = Z(() => t.errorMessage ? t.errorMessage : "Telefonní číslo není validní");
    return Ie(l, () => {
      const h = s.value.find((y) => y.label === l.value);
      h && (o.value = h);
    }), Ie(o, () => {
      var h;
      i.value = {
        phoneNumber: (h = o.value) == null ? void 0 : h.label,
        parsedPhoneNumber: ""
      };
    }), (h, y) => (k(), T("div", c_, [
      A(pn, Te({
        ...r.value,
        fluid: !0
      }, {
        modelValue: l.value,
        "onUpdate:modelValue": y[1] || (y[1] = (g) => l.value = g),
        autocomplete: "tel",
        class: "relative cursor-pointer",
        error: !d.value,
        "error-message": p.value,
        type: "tel"
      }), vs({ _: 2 }, [
        s.value && n.showCountries ? {
          name: "placeLeft",
          fn: N(() => [
            A(x1, {
              modelValue: o.value,
              "onUpdate:modelValue": y[0] || (y[0] = (g) => o.value = g),
              class: "flex max-w-[20px]",
              "content-min-width": "100px",
              options: s.value
            }, {
              trigger: N(() => [
                o.value ? (k(), T("div", f_, [
                  E("span", {
                    class: B(`fi fi-${o.value.value}`)
                  }, null, 2)
                ])) : V("", !0)
              ]),
              item: N(({ option: g }) => [
                E("div", p_, [
                  E("span", {
                    class: B(`fi fi-${g.value} mr-2`)
                  }, null, 2),
                  E("span", {
                    class: B(["leading-6 text-grey-500", { "text-brand": g.selected, "text-grey-500": !g.selected }]),
                    innerHTML: g == null ? void 0 : g.label
                  }, null, 10, h_)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["modelValue", "error", "error-message"])
    ]));
  }
});
function Mt(n) {
  this.content = n;
}
Mt.prototype = {
  constructor: Mt,
  find: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === n) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(n) {
    var e = this.find(n);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(n, e, t) {
    var r = t && t != n ? this.remove(t) : this, i = r.find(n), s = r.content.slice();
    return i == -1 ? s.push(t || n, e) : (s[i + 1] = e, t && (s[i] = t)), new Mt(s);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(n) {
    var e = this.find(n);
    if (e == -1) return this;
    var t = this.content.slice();
    return t.splice(e, 2), new Mt(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(n, e) {
    return new Mt([n, e].concat(this.remove(n).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(n, e) {
    var t = this.remove(n).content.slice();
    return t.push(n, e), new Mt(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(n, e, t) {
    var r = this.remove(e), i = r.content.slice(), s = r.find(n);
    return i.splice(s == -1 ? i.length : s, 0, e, t), new Mt(i);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      n(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(n) {
    return n = Mt.from(n), n.size ? new Mt(n.content.concat(this.subtract(n).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(n) {
    return n = Mt.from(n), n.size ? new Mt(this.subtract(n).content.concat(n.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(n) {
    var e = this;
    n = Mt.from(n);
    for (var t = 0; t < n.content.length; t += 2)
      e = e.remove(n.content[t]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var n = {};
    return this.forEach(function(e, t) {
      n[e] = t;
    }), n;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Mt.from = function(n) {
  if (n instanceof Mt) return n;
  var e = [];
  if (n) for (var t in n) e.push(t, n[t]);
  return new Mt(e);
};
function Dp(n, e, t) {
  for (let r = 0; ; r++) {
    if (r == n.childCount || r == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let i = n.child(r), s = e.child(r);
    if (i == s) {
      t += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(s))
      return t;
    if (i.isText && i.text != s.text) {
      for (let o = 0; i.text[o] == s.text[o]; o++)
        t++;
      return t;
    }
    if (i.content.size || s.content.size) {
      let o = Dp(i.content, s.content, t + 1);
      if (o != null)
        return o;
    }
    t += i.nodeSize;
  }
}
function Lp(n, e, t, r) {
  for (let i = n.childCount, s = e.childCount; ; ) {
    if (i == 0 || s == 0)
      return i == s ? null : { a: t, b: r };
    let o = n.child(--i), a = e.child(--s), l = o.nodeSize;
    if (o == a) {
      t -= l, r -= l;
      continue;
    }
    if (!o.sameMarkup(a))
      return { a: t, b: r };
    if (o.isText && o.text != a.text) {
      let u = 0, d = Math.min(o.text.length, a.text.length);
      for (; u < d && o.text[o.text.length - u - 1] == a.text[a.text.length - u - 1]; )
        u++, t--, r--;
      return { a: t, b: r };
    }
    if (o.content.size || a.content.size) {
      let u = Lp(o.content, a.content, t - 1, r - 1);
      if (u)
        return u;
    }
    t -= l, r -= l;
  }
}
class re {
  /**
  @internal
  */
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, t, r, i = 0, s) {
    for (let o = 0, a = 0; a < t; o++) {
      let l = this.content[o], u = a + l.nodeSize;
      if (u > e && r(l, i + a, s || null, o) !== !1 && l.content.size) {
        let d = a + 1;
        l.nodesBetween(Math.max(0, e - d), Math.min(l.content.size, t - d), r, i + d);
      }
      a = u;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, t, r, i) {
    let s = "", o = !0;
    return this.nodesBetween(e, t, (a, l) => {
      let u = a.isText ? a.text.slice(Math.max(e, l) - l, t - l) : a.isLeaf ? i ? typeof i == "function" ? i(a) : i : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && u || a.isTextblock) && r && (o ? o = !1 : s += r), s += u;
    }, 0), s;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, r = e.firstChild, i = this.content.slice(), s = 0;
    for (t.isText && t.sameMarkup(r) && (i[i.length - 1] = t.withText(t.text + r.text), s = 1); s < e.content.length; s++)
      i.push(e.content[s]);
    return new re(i, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let r = [], i = 0;
    if (t > e)
      for (let s = 0, o = 0; o < t; s++) {
        let a = this.content[s], l = o + a.nodeSize;
        l > e && ((o < e || l > t) && (a.isText ? a = a.cut(Math.max(0, e - o), Math.min(a.text.length, t - o)) : a = a.cut(Math.max(0, e - o - 1), Math.min(a.content.size, t - o - 1))), r.push(a), i += a.nodeSize), o = l;
      }
    return new re(r, i);
  }
  /**
  @internal
  */
  cutByIndex(e, t) {
    return e == t ? re.empty : e == 0 && t == this.content.length ? this : new re(this.content.slice(e, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, t) {
    let r = this.content[e];
    if (r == t)
      return this;
    let i = this.content.slice(), s = this.size + t.nodeSize - r.nodeSize;
    return i[e] = t, new re(i, s);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new re([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new re(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let t = 0, r = 0; t < this.content.length; t++) {
      let i = this.content[t];
      e(i, r, t), r += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, t = 0) {
    return Dp(this, e, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, t = this.size, r = e.size) {
    return Lp(this, e, t, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e, t = -1) {
    if (e == 0)
      return Go(0, e);
    if (e == this.size)
      return Go(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let r = 0, i = 0; ; r++) {
      let s = this.child(r), o = i + s.nodeSize;
      if (o >= e)
        return o == e || t > 0 ? Go(r + 1, o) : Go(r, i);
      i = o;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return re.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new re(t.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return re.empty;
    let t, r = 0;
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      r += s.nodeSize, i && s.isText && e[i - 1].sameMarkup(s) ? (t || (t = e.slice(0, i)), t[t.length - 1] = s.withText(t[t.length - 1].text + s.text)) : t && t.push(s);
    }
    return new re(t || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return re.empty;
    if (e instanceof re)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new re([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
re.empty = new re([], 0);
const cu = { index: 0, offset: 0 };
function Go(n, e) {
  return cu.index = n, cu.offset = e, cu;
}
function Ma(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let r = 0; r < n.length; r++)
      if (!Ma(n[r], e[r]))
        return !1;
  } else {
    for (let r in n)
      if (!(r in e) || !Ma(n[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in n))
        return !1;
  }
  return !0;
}
let Ge = class gd {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let t, r = !1;
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      if (this.eq(s))
        return e;
      if (this.type.excludes(s.type))
        t || (t = e.slice(0, i));
      else {
        if (s.type.excludes(this.type))
          return e;
        !r && s.type.rank > this.type.rank && (t || (t = e.slice(0, i)), t.push(this), r = !0), t && t.push(s);
      }
    }
    return t || (t = e.slice()), r || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Ma(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[t.type];
    if (!r)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let i = r.create(t.attrs);
    return r.checkAttrs(i.attrs), i;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(t[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return gd.none;
    if (e instanceof gd)
      return [e];
    let t = e.slice();
    return t.sort((r, i) => r.type.rank - i.type.rank), t;
  }
};
Ge.none = [];
class Aa extends Error {
}
class de {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, t, r) {
    this.content = e, this.openStart = t, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, t) {
    let r = Pp(this.content, e + this.openStart, t);
    return r && new de(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, t) {
    return new de(Rp(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return de.empty;
    let r = t.openStart || 0, i = t.openEnd || 0;
    if (typeof r != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new de(re.fromJSON(e, t.content), r, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, t = !0) {
    let r = 0, i = 0;
    for (let s = e.firstChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.firstChild)
      r++;
    for (let s = e.lastChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.lastChild)
      i++;
    return new de(e, r, i);
  }
}
de.empty = new de(re.empty, 0, 0);
function Rp(n, e, t) {
  let { index: r, offset: i } = n.findIndex(e), s = n.maybeChild(r), { index: o, offset: a } = n.findIndex(t);
  if (i == e || s.isText) {
    if (a != t && !n.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (r != o)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(r, s.copy(Rp(s.content, e - i - 1, t - i - 1)));
}
function Pp(n, e, t, r) {
  let { index: i, offset: s } = n.findIndex(e), o = n.maybeChild(i);
  if (s == e || o.isText)
    return n.cut(0, e).append(t).append(n.cut(e));
  let a = Pp(o.content, e - s - 1, t);
  return a && n.replaceChild(i, o.copy(a));
}
function m_(n, e, t) {
  if (t.openStart > n.depth)
    throw new Aa("Inserted content deeper than insertion position");
  if (n.depth - t.openStart != e.depth - t.openEnd)
    throw new Aa("Inconsistent open depths");
  return Ip(n, e, t, 0);
}
function Ip(n, e, t, r) {
  let i = n.index(r), s = n.node(r);
  if (i == e.index(r) && r < n.depth - t.openStart) {
    let o = Ip(n, e, t, r + 1);
    return s.copy(s.content.replaceChild(i, o));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && n.depth == r && e.depth == r) {
      let o = n.parent, a = o.content;
      return mi(o, a.cut(0, n.parentOffset).append(t.content).append(a.cut(e.parentOffset)));
    } else {
      let { start: o, end: a } = g_(t, n);
      return mi(s, zp(n, o, a, e, r));
    }
  else return mi(s, Na(n, e, r));
}
function Bp(n, e) {
  if (!e.type.compatibleContent(n.type))
    throw new Aa("Cannot join " + e.type.name + " onto " + n.type.name);
}
function bd(n, e, t) {
  let r = n.node(t);
  return Bp(r, e.node(t)), r;
}
function hi(n, e) {
  let t = e.length - 1;
  t >= 0 && n.isText && n.sameMarkup(e[t]) ? e[t] = n.withText(e[t].text + n.text) : e.push(n);
}
function qs(n, e, t, r) {
  let i = (e || n).node(t), s = 0, o = e ? e.index(t) : i.childCount;
  n && (s = n.index(t), n.depth > t ? s++ : n.textOffset && (hi(n.nodeAfter, r), s++));
  for (let a = s; a < o; a++)
    hi(i.child(a), r);
  e && e.depth == t && e.textOffset && hi(e.nodeBefore, r);
}
function mi(n, e) {
  return n.type.checkContent(e), n.copy(e);
}
function zp(n, e, t, r, i) {
  let s = n.depth > i && bd(n, e, i + 1), o = r.depth > i && bd(t, r, i + 1), a = [];
  return qs(null, n, i, a), s && o && e.index(i) == t.index(i) ? (Bp(s, o), hi(mi(s, zp(n, e, t, r, i + 1)), a)) : (s && hi(mi(s, Na(n, e, i + 1)), a), qs(e, t, i, a), o && hi(mi(o, Na(t, r, i + 1)), a)), qs(r, null, i, a), new re(a);
}
function Na(n, e, t) {
  let r = [];
  if (qs(null, n, t, r), n.depth > t) {
    let i = bd(n, e, t + 1);
    hi(mi(i, Na(n, e, t + 1)), r);
  }
  return qs(e, null, t, r), new re(r);
}
function g_(n, e) {
  let t = e.depth - n.openStart, i = e.node(t).copy(n.content);
  for (let s = t - 1; s >= 0; s--)
    i = e.node(s).copy(re.from(i));
  return {
    start: i.resolveNoCache(n.openStart + t),
    end: i.resolveNoCache(i.content.size - n.openEnd - t)
  };
}
class go {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.path = t, this.parentOffset = r, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], i = e.child(t);
    return r ? e.child(t).cut(r) : i;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let r = this.path[t * 3], i = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let s = 0; s < e; s++)
      i += r.child(s).nodeSize;
    return i;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return Ge.none;
    if (this.textOffset)
      return e.child(t).marks;
    let r = e.maybeChild(t - 1), i = e.maybeChild(t);
    if (!r) {
      let a = r;
      r = i, i = a;
    }
    let s = r.marks;
    for (var o = 0; o < s.length; o++)
      s[o].type.spec.inclusive === !1 && (!i || !s[o].isInSet(i.marks)) && (s = s[o--].removeFromSet(s));
    return s;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let r = t.marks, i = e.parent.maybeChild(e.index());
    for (var s = 0; s < r.length; s++)
      r[s].type.spec.inclusive === !1 && (!i || !r[s].isInSet(i.marks)) && (r = r[s--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!t || t(this.node(r))))
        return new Da(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let r = [], i = 0, s = t;
    for (let o = e; ; ) {
      let { index: a, offset: l } = o.content.findIndex(s), u = s - l;
      if (r.push(o, a, i + l), !u || (o = o.child(a), o.isText))
        break;
      s = u - 1, i += l + 1;
    }
    return new go(t, r, s);
  }
  /**
  @internal
  */
  static resolveCached(e, t) {
    let r = gc.get(e);
    if (r)
      for (let s = 0; s < r.elts.length; s++) {
        let o = r.elts[s];
        if (o.pos == t)
          return o;
      }
    else
      gc.set(e, r = new b_());
    let i = r.elts[r.i] = go.resolve(e, t);
    return r.i = (r.i + 1) % y_, i;
  }
}
class b_ {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const y_ = 12, gc = /* @__PURE__ */ new WeakMap();
class Da {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const v_ = /* @__PURE__ */ Object.create(null);
let Kn = class yd {
  /**
  @internal
  */
  constructor(e, t, r, i = Ge.none) {
    this.type = e, this.attrs = t, this.marks = i, this.content = r || re.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, t, r, i = 0) {
    this.content.nodesBetween(e, t, r, i, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, t, r, i) {
    return this.content.textBetween(e, t, r, i);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, t, r) {
    return this.type == e && Ma(this.attrs, t || e.defaultAttrs || v_) && Ge.sameSet(this.marks, r || Ge.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new yd(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new yd(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, t = this.content.size, r = !1) {
    if (e == t)
      return de.empty;
    let i = this.resolve(e), s = this.resolve(t), o = r ? 0 : i.sharedDepth(t), a = i.start(o), u = i.node(o).content.cut(i.pos - a, s.pos - a);
    return new de(u, i.depth - o, s.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, t, r) {
    return m_(this.resolve(e), this.resolve(t), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: r, offset: i } = t.content.findIndex(e);
      if (t = t.maybeChild(r), !t)
        return null;
      if (i == e || t.isText)
        return t;
      e -= i + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: t, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(t), index: t, offset: r };
    let i = this.content.child(t - 1);
    return { node: i, index: t - 1, offset: r - i.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return go.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return go.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, t, r) {
    let i = !1;
    return t > e && this.nodesBetween(e, t, (s) => (r.isInSet(s.marks) && (i = !0), !i)), i;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), Vp(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, t, r = re.empty, i = 0, s = r.childCount) {
    let o = this.contentMatchAt(e).matchFragment(r, i, s), a = o && o.matchFragment(this.content, t);
    if (!a || !a.validEnd)
      return !1;
    for (let l = i; l < s; l++)
      if (!this.type.allowsMarks(r.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, t, r, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let s = this.contentMatchAt(e).matchType(r), o = s && s.matchFragment(this.content, t);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = Ge.none;
    for (let t = 0; t < this.marks.length; t++) {
      let r = this.marks[t];
      r.type.checkAttrs(r.attrs), e = r.addToSet(e);
    }
    if (!Ge.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, r);
    }
    let i = re.fromJSON(e, t.content), s = e.nodeType(t.type).create(t.attrs, i, r);
    return s.type.checkAttrs(s.attrs), s;
  }
};
Kn.prototype.text = void 0;
class La extends Kn {
  /**
  @internal
  */
  constructor(e, t, r, i) {
    if (super(e, t, null, i), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Vp(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new La(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new La(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function Vp(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    e = n[t].type.name + "(" + e + ")";
  return e;
}
class ki {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, t) {
    let r = new __(e, t);
    if (r.next == null)
      return ki.empty;
    let i = Fp(r);
    r.next && r.err("Unexpected trailing text");
    let s = E_(S_(i));
    return T_(s, r), s;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, t = 0, r = e.childCount) {
    let i = this;
    for (let s = t; i && s < r; s++)
      i = i.matchType(e.child(s).type);
    return i;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[t].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, t = !1, r = 0) {
    let i = [this];
    function s(o, a) {
      let l = o.matchFragment(e, r);
      if (l && (!t || l.validEnd))
        return re.from(a.map((u) => u.createAndFill()));
      for (let u = 0; u < o.next.length; u++) {
        let { type: d, next: c } = o.next[u];
        if (!(d.isText || d.hasRequiredAttrs()) && i.indexOf(c) == -1) {
          i.push(c);
          let f = s(c, a.concat(d));
          if (f)
            return f;
        }
      }
      return null;
    }
    return s(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let i = r.shift(), s = i.match;
      if (s.matchType(e)) {
        let o = [];
        for (let a = i; a.type; a = a.via)
          o.push(a.type);
        return o.reverse();
      }
      for (let o = 0; o < s.next.length; o++) {
        let { type: a, next: l } = s.next[o];
        !a.isLeaf && !a.hasRequiredAttrs() && !(a.name in t) && (!i.type || l.validEnd) && (r.push({ match: a.contentMatch, type: a, via: i }), t[a.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function t(r) {
      e.push(r);
      for (let i = 0; i < r.next.length; i++)
        e.indexOf(r.next[i].next) == -1 && t(r.next[i].next);
    }
    return t(this), e.map((r, i) => {
      let s = i + (r.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < r.next.length; o++)
        s += (o ? ", " : "") + r.next[o].type.name + "->" + e.indexOf(r.next[o].next);
      return s;
    }).join(`
`);
  }
}
ki.empty = new ki(!0);
class __ {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function Fp(n) {
  let e = [];
  do
    e.push($_(n));
  while (n.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function $_(n) {
  let e = [];
  do
    e.push(x_(n));
  while (n.next && n.next != ")" && n.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function x_(n) {
  let e = C_(n);
  for (; ; )
    if (n.eat("+"))
      e = { type: "plus", expr: e };
    else if (n.eat("*"))
      e = { type: "star", expr: e };
    else if (n.eat("?"))
      e = { type: "opt", expr: e };
    else if (n.eat("{"))
      e = w_(n, e);
    else
      break;
  return e;
}
function bc(n) {
  /\D/.test(n.next) && n.err("Expected number, got '" + n.next + "'");
  let e = Number(n.next);
  return n.pos++, e;
}
function w_(n, e) {
  let t = bc(n), r = t;
  return n.eat(",") && (n.next != "}" ? r = bc(n) : r = -1), n.eat("}") || n.err("Unclosed braced range"), { type: "range", min: t, max: r, expr: e };
}
function k_(n, e) {
  let t = n.nodeTypes, r = t[e];
  if (r)
    return [r];
  let i = [];
  for (let s in t) {
    let o = t[s];
    o.isInGroup(e) && i.push(o);
  }
  return i.length == 0 && n.err("No node type or group '" + e + "' found"), i;
}
function C_(n) {
  if (n.eat("(")) {
    let e = Fp(n);
    return n.eat(")") || n.err("Missing closing paren"), e;
  } else if (/\W/.test(n.next))
    n.err("Unexpected token '" + n.next + "'");
  else {
    let e = k_(n, n.next).map((t) => (n.inline == null ? n.inline = t.isInline : n.inline != t.isInline && n.err("Mixing inline and block content"), { type: "name", value: t }));
    return n.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function S_(n) {
  let e = [[]];
  return i(s(n, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function r(o, a, l) {
    let u = { term: l, to: a };
    return e[o].push(u), u;
  }
  function i(o, a) {
    o.forEach((l) => l.to = a);
  }
  function s(o, a) {
    if (o.type == "choice")
      return o.exprs.reduce((l, u) => l.concat(s(u, a)), []);
    if (o.type == "seq")
      for (let l = 0; ; l++) {
        let u = s(o.exprs[l], a);
        if (l == o.exprs.length - 1)
          return u;
        i(u, a = t());
      }
    else if (o.type == "star") {
      let l = t();
      return r(a, l), i(s(o.expr, l), l), [r(l)];
    } else if (o.type == "plus") {
      let l = t();
      return i(s(o.expr, a), l), i(s(o.expr, l), l), [r(l)];
    } else {
      if (o.type == "opt")
        return [r(a)].concat(s(o.expr, a));
      if (o.type == "range") {
        let l = a;
        for (let u = 0; u < o.min; u++) {
          let d = t();
          i(s(o.expr, l), d), l = d;
        }
        if (o.max == -1)
          i(s(o.expr, l), l);
        else
          for (let u = o.min; u < o.max; u++) {
            let d = t();
            r(l, d), i(s(o.expr, l), d), l = d;
          }
        return [r(l)];
      } else {
        if (o.type == "name")
          return [r(a, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function jp(n, e) {
  return e - n;
}
function yc(n, e) {
  let t = [];
  return r(e), t.sort(jp);
  function r(i) {
    let s = n[i];
    if (s.length == 1 && !s[0].term)
      return r(s[0].to);
    t.push(i);
    for (let o = 0; o < s.length; o++) {
      let { term: a, to: l } = s[o];
      !a && t.indexOf(l) == -1 && r(l);
    }
  }
}
function E_(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(yc(n, 0));
  function t(r) {
    let i = [];
    r.forEach((o) => {
      n[o].forEach(({ term: a, to: l }) => {
        if (!a)
          return;
        let u;
        for (let d = 0; d < i.length; d++)
          i[d][0] == a && (u = i[d][1]);
        yc(n, l).forEach((d) => {
          u || i.push([a, u = []]), u.indexOf(d) == -1 && u.push(d);
        });
      });
    });
    let s = e[r.join(",")] = new ki(r.indexOf(n.length - 1) > -1);
    for (let o = 0; o < i.length; o++) {
      let a = i[o][1].sort(jp);
      s.next.push({ type: i[o][0], next: e[a.join(",")] || t(a) });
    }
    return s;
  }
}
function T_(n, e) {
  for (let t = 0, r = [n]; t < r.length; t++) {
    let i = r[t], s = !i.validEnd, o = [];
    for (let a = 0; a < i.next.length; a++) {
      let { type: l, next: u } = i.next[a];
      o.push(l.name), s && !(l.isText || l.hasRequiredAttrs()) && (s = !1), r.indexOf(u) == -1 && r.push(u);
    }
    s && e.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Hp(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let r = n[t];
    if (!r.hasDefault)
      return null;
    e[t] = r.default;
  }
  return e;
}
function Up(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let r in n) {
    let i = e && e[r];
    if (i === void 0) {
      let s = n[r];
      if (s.hasDefault)
        i = s.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    t[r] = i;
  }
  return t;
}
function Wp(n, e, t, r) {
  for (let i in e)
    if (!(i in n))
      throw new RangeError(`Unsupported attribute ${i} for ${t} of type ${i}`);
  for (let i in n) {
    let s = n[i];
    s.validate && s.validate(e[i]);
  }
}
function qp(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      t[r] = new M_(n, r, e[r]);
  return t;
}
let vc = class Kp {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.name = e, this.schema = t, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = qp(e, r.attrs), this.defaultAttrs = Hp(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == ki.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : Up(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, t, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Kn(this, this.computeAttrs(e), re.from(t), Ge.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, t, r) {
    return t = re.from(t), this.checkContent(t), new Kn(this, this.computeAttrs(e), t, Ge.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, t, r) {
    if (e = this.computeAttrs(e), t = re.from(t), t.size) {
      let o = this.contentMatch.fillBefore(t);
      if (!o)
        return null;
      t = o.append(t);
    }
    let i = this.contentMatch.matchFragment(t), s = i && i.fillBefore(re.empty, !0);
    return s ? new Kn(this, e, t.append(s), Ge.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Wp(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? t && t.push(e[r]) : t || (t = e.slice(0, r));
    return t ? t.length ? t : Ge.none : e;
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((s, o) => r[s] = new Kp(s, t, o));
    let i = t.spec.topNode || "doc";
    if (!r[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let s in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function O_(n, e, t) {
  let r = t.split("|");
  return (i) => {
    let s = i === null ? "null" : typeof i;
    if (r.indexOf(s) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${e} on type ${n}, got ${s}`);
  };
}
class M_ {
  constructor(e, t, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? O_(e, t, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Tl {
  /**
  @internal
  */
  constructor(e, t, r, i) {
    this.name = e, this.rank = t, this.schema = r, this.spec = i, this.attrs = qp(e, i.attrs), this.excluded = null;
    let s = Hp(this.attrs);
    this.instance = s ? new Ge(this, s) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new Ge(this, Up(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null), i = 0;
    return e.forEach((s, o) => r[s] = new Tl(s, i++, t, o)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Wp(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class Gp {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let i in e)
      t[i] = e[i];
    t.nodes = Mt.from(e.nodes), t.marks = Mt.from(e.marks || {}), this.nodes = vc.compile(this.spec.nodes, this), this.marks = Tl.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let s = this.nodes[i], o = s.spec.content || "", a = s.spec.marks;
      if (s.contentMatch = r[o] || (r[o] = ki.parse(o, this.nodes)), s.inlineContent = s.contentMatch.inlineContent, s.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!s.isInline || !s.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = s;
      }
      s.markSet = a == "_" ? null : a ? _c(this, a.split(" ")) : a == "" || !s.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let s = this.marks[i], o = s.spec.excludes;
      s.excluded = o == null ? [s] : o == "" ? [] : _c(this, o.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, t = null, r, i) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof vc) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, r, i);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, t) {
    let r = this.nodes.text;
    return new La(r, r.defaultAttrs, e, Ge.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return Kn.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return Ge.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function _c(n, e) {
  let t = [];
  for (let r = 0; r < e.length; r++) {
    let i = e[r], s = n.marks[i], o = s;
    if (s)
      t.push(s);
    else
      for (let a in n.marks) {
        let l = n.marks[a];
        (i == "_" || l.spec.group && l.spec.group.split(" ").indexOf(i) > -1) && t.push(o = l);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return t;
}
function A_(n) {
  return n.tag != null;
}
function N_(n) {
  return n.style != null;
}
class jr {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    t.forEach((i) => {
      if (A_(i))
        this.tags.push(i);
      else if (N_(i)) {
        let s = /[^=]*/.exec(i.style)[0];
        r.indexOf(s) < 0 && r.push(s), this.styles.push(i);
      }
    }), this.normalizeLists = !this.tags.some((i) => {
      if (!/^(ul|ol)\b/.test(i.tag) || !i.node)
        return !1;
      let s = e.nodes[i.node];
      return s.contentMatch.matchType(s);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, t = {}) {
    let r = new xc(this, t, !1);
    return r.addAll(e, Ge.none, t.from, t.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, t = {}) {
    let r = new xc(this, t, !0);
    return r.addAll(e, Ge.none, t.from, t.to), de.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, t, r) {
    for (let i = r ? this.tags.indexOf(r) + 1 : 0; i < this.tags.length; i++) {
      let s = this.tags[i];
      if (R_(e, s.tag) && (s.namespace === void 0 || e.namespaceURI == s.namespace) && (!s.context || t.matchesContext(s.context))) {
        if (s.getAttrs) {
          let o = s.getAttrs(e);
          if (o === !1)
            continue;
          s.attrs = o || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, t, r, i) {
    for (let s = i ? this.styles.indexOf(i) + 1 : 0; s < this.styles.length; s++) {
      let o = this.styles[s], a = o.style;
      if (!(a.indexOf(e) != 0 || o.context && !r.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      a.length > e.length && (a.charCodeAt(e.length) != 61 || a.slice(e.length + 1) != t))) {
        if (o.getAttrs) {
          let l = o.getAttrs(t);
          if (l === !1)
            continue;
          o.attrs = l || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let t = [];
    function r(i) {
      let s = i.priority == null ? 50 : i.priority, o = 0;
      for (; o < t.length; o++) {
        let a = t[o];
        if ((a.priority == null ? 50 : a.priority) < s)
          break;
      }
      t.splice(o, 0, i);
    }
    for (let i in e.marks) {
      let s = e.marks[i].spec.parseDOM;
      s && s.forEach((o) => {
        r(o = wc(o)), o.mark || o.ignore || o.clearMark || (o.mark = i);
      });
    }
    for (let i in e.nodes) {
      let s = e.nodes[i].spec.parseDOM;
      s && s.forEach((o) => {
        r(o = wc(o)), o.node || o.ignore || o.mark || (o.node = i);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new jr(e, jr.schemaRules(e)));
  }
}
const Yp = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, D_ = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, Jp = { ol: !0, ul: !0 }, bo = 1, vd = 2, Ks = 4;
function $c(n, e, t) {
  return e != null ? (e ? bo : 0) | (e === "full" ? vd : 0) : n && n.whitespace == "pre" ? bo | vd : t & ~Ks;
}
class Yo {
  constructor(e, t, r, i, s, o) {
    this.type = e, this.attrs = t, this.marks = r, this.solid = i, this.options = o, this.content = [], this.activeMarks = Ge.none, this.match = s || (o & Ks ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(re.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let r = this.type.contentMatch, i;
        return (i = r.findWrapping(e.type)) ? (this.match = r, i) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & bo)) {
      let r = this.content[this.content.length - 1], i;
      if (r && r.isText && (i = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let s = r;
        r.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = s.withText(s.text.slice(0, s.text.length - i[0].length));
      }
    }
    let t = re.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(re.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !Yp.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class xc {
  constructor(e, t, r) {
    this.parser = e, this.options = t, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let i = t.topNode, s, o = $c(null, t.preserveWhitespace, 0) | (r ? Ks : 0);
    i ? s = new Yo(i.type, i.attrs, Ge.none, !0, t.topMatch || i.type.contentMatch, o) : r ? s = new Yo(null, null, Ge.none, !0, null, o) : s = new Yo(e.schema.topNodeType, null, Ge.none, !0, null, o), this.nodes = [s], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, t) {
    e.nodeType == 3 ? this.addTextNode(e, t) : e.nodeType == 1 && this.addElement(e, t);
  }
  addTextNode(e, t) {
    let r = e.nodeValue, i = this.top, s = i.options & vd ? "full" : this.localPreserveWS || (i.options & bo) > 0;
    if (s === "full" || i.inlineContext(e) || /[^ \t\r\n\u000c]/.test(r)) {
      if (s)
        s !== "full" ? r = r.replace(/\r?\n|\r/g, " ") : r = r.replace(/\r\n?/g, `
`);
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let o = i.content[i.content.length - 1], a = e.previousSibling;
        (!o || a && a.nodeName == "BR" || o.isText && /[ \t\r\n\u000c]$/.test(o.text)) && (r = r.slice(1));
      }
      r && this.insertNode(this.parser.schema.text(r), t, !/\S/.test(r)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, t, r) {
    let i = this.localPreserveWS, s = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = e.nodeName.toLowerCase(), a;
    Jp.hasOwnProperty(o) && this.parser.normalizeLists && L_(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (a = this.parser.matchTag(e, this, r));
    e: if (l ? l.ignore : D_.hasOwnProperty(o))
      this.findInside(e), this.ignoreFallback(e, t);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let u, d = this.needsBlock;
      if (Yp.hasOwnProperty(o))
        s.content.length && s.content[0].isInline && this.open && (this.open--, s = this.top), u = !0, s.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, t);
        break e;
      }
      let c = l && l.skip ? t : this.readStyles(e, t);
      c && this.addAll(e, c), u && this.sync(s), this.needsBlock = d;
    } else {
      let u = this.readStyles(e, t);
      u && this.addElementByRule(e, l, u, l.consuming === !1 ? a : void 0);
    }
    this.localPreserveWS = i;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, t) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(e, t) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, t) {
    let r = e.style;
    if (r && r.length)
      for (let i = 0; i < this.parser.matchedStyles.length; i++) {
        let s = this.parser.matchedStyles[i], o = r.getPropertyValue(s);
        if (o)
          for (let a = void 0; ; ) {
            let l = this.parser.matchStyle(s, o, this, a);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? t = t.filter((u) => !l.clearMark(u)) : t = t.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              a = l;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, t, r, i) {
    let s, o;
    if (t.node)
      if (o = this.parser.schema.nodes[t.node], o.isLeaf)
        this.insertNode(o.create(t.attrs), r, e.nodeName == "BR") || this.leafFallback(e, r);
      else {
        let l = this.enter(o, t.attrs || null, r, t.preserveWhitespace);
        l && (s = !0, r = l);
      }
    else {
      let l = this.parser.schema.marks[t.mark];
      r = r.concat(l.create(t.attrs));
    }
    let a = this.top;
    if (o && o.isLeaf)
      this.findInside(e);
    else if (i)
      this.addElement(e, r, i);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, r, !1));
    else {
      let l = e;
      typeof t.contentElement == "string" ? l = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? l = t.contentElement(e) : t.contentElement && (l = t.contentElement), this.findAround(e, l, !0), this.addAll(l, r), this.findAround(e, l, !1);
    }
    s && this.sync(a) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, t, r, i) {
    let s = r || 0;
    for (let o = r ? e.childNodes[r] : e.firstChild, a = i == null ? null : e.childNodes[i]; o != a; o = o.nextSibling, ++s)
      this.findAtPoint(e, s), this.addDOM(o, t);
    this.findAtPoint(e, s);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, t, r) {
    let i, s;
    for (let o = this.open, a = 0; o >= 0; o--) {
      let l = this.nodes[o], u = l.findWrapping(e);
      if (u && (!i || i.length > u.length + a) && (i = u, s = l, !u.length))
        break;
      if (l.solid) {
        if (r)
          break;
        a += 2;
      }
    }
    if (!i)
      return null;
    this.sync(s);
    for (let o = 0; o < i.length; o++)
      t = this.enterInner(i[o], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, t, r) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let s = this.textblockFromContext();
      s && (t = this.enterInner(s, null, t));
    }
    let i = this.findPlace(e, t, r);
    if (i) {
      this.closeExtra();
      let s = this.top;
      s.match && (s.match = s.match.matchType(e.type));
      let o = Ge.none;
      for (let a of i.concat(e.marks))
        (s.type ? s.type.allowsMarkType(a.type) : kc(a.type, e.type)) && (o = a.addToSet(o));
      return s.content.push(e.mark(o)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, t, r, i) {
    let s = this.findPlace(e.create(t), r, !1);
    return s && (s = this.enterInner(e, t, r, !0, i)), s;
  }
  // Open a node of the given type
  enterInner(e, t, r, i = !1, s) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(e);
    let a = $c(e, s, o.options);
    o.options & Ks && o.content.length == 0 && (a |= Ks);
    let l = Ge.none;
    return r = r.filter((u) => (o.type ? o.type.allowsMarkType(u.type) : kc(u.type, e)) ? (l = u.addToSet(l), !1) : !0), this.nodes.push(new Yo(e, t, l, i, null, a)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == e)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= bo);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let r = this.nodes[t].content;
      for (let i = r.length - 1; i >= 0; i--)
        e += r[i].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == t && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, r) {
    if (e != t && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && e.nodeType == 1 && e.contains(this.find[i].node) && t.compareDocumentPosition(this.find[i].node) & (r ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), r = this.options.context, i = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), s = -(r ? r.depth + 1 : 0) + (i ? 0 : 1), o = (a, l) => {
      for (; a >= 0; a--) {
        let u = t[a];
        if (u == "") {
          if (a == t.length - 1 || a == 0)
            continue;
          for (; l >= s; l--)
            if (o(a - 1, l))
              return !0;
          return !1;
        } else {
          let d = l > 0 || l == 0 && i ? this.nodes[l].type : r && l >= s ? r.node(l - s).type : null;
          if (!d || d.name != u && !d.isInGroup(u))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return o(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let r = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let t in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[t];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function L_(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && Jp.hasOwnProperty(r) && t ? (t.appendChild(e), e = t) : r == "li" ? t = e : r && (t = null);
  }
}
function R_(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function wc(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function kc(n, e) {
  let t = e.schema.nodes;
  for (let r in t) {
    let i = t[r];
    if (!i.allowsMarkType(n))
      continue;
    let s = [], o = (a) => {
      s.push(a);
      for (let l = 0; l < a.edgeCount; l++) {
        let { type: u, next: d } = a.edge(l);
        if (u == e || s.indexOf(d) < 0 && o(d))
          return !0;
      }
    };
    if (o(i.contentMatch))
      return !0;
  }
}
class Gr {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, t = {}, r) {
    r || (r = fu(t).createDocumentFragment());
    let i = r, s = [];
    return e.forEach((o) => {
      if (s.length || o.marks.length) {
        let a = 0, l = 0;
        for (; a < s.length && l < o.marks.length; ) {
          let u = o.marks[l];
          if (!this.marks[u.type.name]) {
            l++;
            continue;
          }
          if (!u.eq(s[a][0]) || u.type.spec.spanning === !1)
            break;
          a++, l++;
        }
        for (; a < s.length; )
          i = s.pop()[1];
        for (; l < o.marks.length; ) {
          let u = o.marks[l++], d = this.serializeMark(u, o.isInline, t);
          d && (s.push([u, i]), i.appendChild(d.dom), i = d.contentDOM || d.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(o, t));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, t) {
    let { dom: r, contentDOM: i } = ba(fu(t), this.nodes[e.type.name](e), null, e.attrs);
    if (i) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, i);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, t = {}) {
    let r = this.serializeNodeInner(e, t);
    for (let i = e.marks.length - 1; i >= 0; i--) {
      let s = this.serializeMark(e.marks[i], e.isInline, t);
      s && ((s.contentDOM || s.dom).appendChild(r), r = s.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, t, r = {}) {
    let i = this.marks[e.type.name];
    return i && ba(fu(r), i(e, t), null, e.attrs);
  }
  static renderSpec(e, t, r = null, i) {
    return ba(e, t, r, i);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new Gr(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let t = Cc(e.nodes);
    return t.text || (t.text = (r) => r.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return Cc(e.marks);
  }
}
function Cc(n) {
  let e = {};
  for (let t in n) {
    let r = n[t].spec.toDOM;
    r && (e[t] = r);
  }
  return e;
}
function fu(n) {
  return n.document || window.document;
}
const Sc = /* @__PURE__ */ new WeakMap();
function P_(n) {
  let e = Sc.get(n);
  return e === void 0 && Sc.set(n, e = I_(n)), e;
}
function I_(n) {
  let e = null;
  function t(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          e || (e = []), e.push(r);
        else
          for (let i = 0; i < r.length; i++)
            t(r[i]);
      else
        for (let i in r)
          t(r[i]);
  }
  return t(n), e;
}
function ba(n, e, t, r) {
  if (typeof e == "string")
    return { dom: n.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let i = e[0], s;
  if (typeof i != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (s = P_(r)) && s.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = i.indexOf(" ");
  o > 0 && (t = i.slice(0, o), i = i.slice(o + 1));
  let a, l = t ? n.createElementNS(t, i) : n.createElement(i), u = e[1], d = 1;
  if (u && typeof u == "object" && u.nodeType == null && !Array.isArray(u)) {
    d = 2;
    for (let c in u)
      if (u[c] != null) {
        let f = c.indexOf(" ");
        f > 0 ? l.setAttributeNS(c.slice(0, f), c.slice(f + 1), u[c]) : l.setAttribute(c, u[c]);
      }
  }
  for (let c = d; c < e.length; c++) {
    let f = e[c];
    if (f === 0) {
      if (c < e.length - 1 || c > d)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: p, contentDOM: h } = ba(n, f, t, r);
      if (l.appendChild(p), h) {
        if (a)
          throw new RangeError("Multiple content holes");
        a = h;
      }
    }
  }
  return { dom: l, contentDOM: a };
}
const Zp = 65535, Xp = Math.pow(2, 16);
function B_(n, e) {
  return n + e * Xp;
}
function Ec(n) {
  return n & Zp;
}
function z_(n) {
  return (n - (n & Zp)) / Xp;
}
const Qp = 1, eh = 2, ya = 4, th = 8;
class _d {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.delInfo = t, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & th) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (Qp | ya)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (eh | ya)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & ya) > 0;
  }
}
class cn {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && cn.empty)
      return cn.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, r = Ec(e);
    if (!this.inverted)
      for (let i = 0; i < r; i++)
        t += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[r * 3] + t + z_(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let i = 0, s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? i : 0);
      if (l > e)
        break;
      let u = this.ranges[a + s], d = this.ranges[a + o], c = l + u;
      if (e <= c) {
        let f = u ? e == l ? -1 : e == c ? 1 : t : t, p = l + i + (f < 0 ? 0 : d);
        if (r)
          return p;
        let h = e == (t < 0 ? l : c) ? null : B_(a / 3, e - l), y = e == l ? eh : e == c ? Qp : ya;
        return (t < 0 ? e != l : e != c) && (y |= th), new _d(p, y, h);
      }
      i += d - u;
    }
    return r ? e + i : new _d(e + i, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let r = 0, i = Ec(t), s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let u = this.ranges[a + s], d = l + u;
      if (e <= d && a == i * 3)
        return !0;
      r += this.ranges[a + o] - u;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0, s = 0; i < this.ranges.length; i += 3) {
      let o = this.ranges[i], a = o - (this.inverted ? s : 0), l = o + (this.inverted ? 0 : s), u = this.ranges[i + t], d = this.ranges[i + r];
      e(a, a + u, l, l + d), s += d - u;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new cn(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? cn.empty : new cn(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
cn.empty = new cn([]);
class yo {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, t, r = 0, i = e ? e.length : 0) {
    this.mirror = t, this.from = r, this.to = i, this._maps = e || [], this.ownData = !(e || t);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new yo(this._maps, this.mirror, e, t);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), t != null && this.setMirror(this._maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, r = this._maps.length; t < e._maps.length; t++) {
      let i = e.getMirror(t);
      this.appendMap(e._maps[t], i != null && i < t ? r + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, r = this._maps.length + e._maps.length; t >= 0; t--) {
      let i = e.getMirror(t);
      this.appendMap(e._maps[t].invert(), i != null && i > t ? r - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new yo();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let r = this.from; r < this.to; r++)
      e = this._maps[r].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let i = 0;
    for (let s = this.from; s < this.to; s++) {
      let o = this._maps[s], a = o.mapResult(e, t);
      if (a.recover != null) {
        let l = this.getMirror(s);
        if (l != null && l > s && l < this.to) {
          s = l, e = this._maps[l].recover(a.recover);
          continue;
        }
      }
      i |= a.delInfo, e = a.pos;
    }
    return r ? e : new _d(e, i, null);
  }
}
const pu = /* @__PURE__ */ Object.create(null);
class Vt {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return cn.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = pu[t.stepType];
    if (!r)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in pu)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return pu[e] = t, t.prototype.jsonID = e, t;
  }
}
class dt {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new dt(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new dt(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, r, i) {
    try {
      return dt.ok(e.replace(t, r, i));
    } catch (s) {
      if (s instanceof Aa)
        return dt.fail(s.message);
      throw s;
    }
  }
}
function C1(n, e, t) {
  let r = [];
  for (let i = 0; i < n.childCount; i++) {
    let s = n.child(i);
    s.content.size && (s = s.copy(C1(s.content, e, s))), s.isInline && (s = e(s, t, i)), r.push(s);
  }
  return re.fromArray(r);
}
class Pr extends Vt {
  /**
  Create a mark step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = e.resolve(this.from), i = r.node(r.sharedDepth(this.to)), s = new de(C1(t.content, (o, a) => !o.isAtom || !a.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), i), t.openStart, t.openEnd);
    return dt.fromReplace(e, this.from, this.to, s);
  }
  invert() {
    return new qn(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new Pr(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Pr && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Pr(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Pr(t.from, t.to, e.markFromJSON(t.mark));
  }
}
Vt.jsonID("addMark", Pr);
class qn extends Vt {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = new de(C1(t.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), e), t.openStart, t.openEnd);
    return dt.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new Pr(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new qn(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof qn && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new qn(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new qn(t.from, t.to, e.markFromJSON(t.mark));
  }
}
Vt.jsonID("removeMark", qn);
class Ir extends Vt {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return dt.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return dt.fromReplace(e, this.pos, this.pos + 1, new de(re.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let r = this.mark.addToSet(t.marks);
      if (r.length == t.marks.length) {
        for (let i = 0; i < t.marks.length; i++)
          if (!t.marks[i].isInSet(r))
            return new Ir(this.pos, t.marks[i]);
        return new Ir(this.pos, this.mark);
      }
    }
    return new Ci(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Ir(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Ir(t.pos, e.markFromJSON(t.mark));
  }
}
Vt.jsonID("addNodeMark", Ir);
class Ci extends Vt {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return dt.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return dt.fromReplace(e, this.pos, this.pos + 1, new de(re.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new Ir(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Ci(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Ci(t.pos, e.markFromJSON(t.mark));
  }
}
Vt.jsonID("removeNodeMark", Ci);
class vt extends Vt {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, r, i = !1) {
    super(), this.from = e, this.to = t, this.slice = r, this.structure = i;
  }
  apply(e) {
    return this.structure && $d(e, this.from, this.to) ? dt.fail("Structure replace would overwrite content") : dt.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new cn([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new vt(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deletedAcross && r.deletedAcross ? null : new vt(t.pos, Math.max(t.pos, r.pos), this.slice, this.structure);
  }
  merge(e) {
    if (!(e instanceof vt) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? de.empty : new de(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new vt(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? de.empty : new de(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new vt(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new vt(t.from, t.to, de.fromJSON(e, t.slice), !!t.structure);
  }
}
Vt.jsonID("replace", vt);
class $t extends Vt {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, r, i, s, o, a = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = r, this.gapTo = i, this.slice = s, this.insert = o, this.structure = a;
  }
  apply(e) {
    if (this.structure && ($d(e, this.from, this.gapFrom) || $d(e, this.gapTo, this.to)))
      return dt.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return dt.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, t.content);
    return r ? dt.fromReplace(e, this.from, this.to, r) : dt.fail("Content does not fit in gap");
  }
  getMap() {
    return new cn([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new $t(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), i = this.from == this.gapFrom ? t.pos : e.map(this.gapFrom, -1), s = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return t.deletedAcross && r.deletedAcross || i < t.pos || s > r.pos ? null : new $t(t.pos, r.pos, i, s, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new $t(t.from, t.to, t.gapFrom, t.gapTo, de.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
Vt.jsonID("replaceAround", $t);
function $d(n, e, t) {
  let r = n.resolve(e), i = t - e, s = r.depth;
  for (; i > 0 && s > 0 && r.indexAfter(s) == r.node(s).childCount; )
    s--, i--;
  if (i > 0) {
    let o = r.node(s).maybeChild(r.indexAfter(s));
    for (; i > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, i--;
    }
  }
  return !1;
}
function V_(n, e, t, r) {
  let i = [], s = [], o, a;
  n.doc.nodesBetween(e, t, (l, u, d) => {
    if (!l.isInline)
      return;
    let c = l.marks;
    if (!r.isInSet(c) && d.type.allowsMarkType(r.type)) {
      let f = Math.max(u, e), p = Math.min(u + l.nodeSize, t), h = r.addToSet(c);
      for (let y = 0; y < c.length; y++)
        c[y].isInSet(h) || (o && o.to == f && o.mark.eq(c[y]) ? o.to = p : i.push(o = new qn(f, p, c[y])));
      a && a.to == f ? a.to = p : s.push(a = new Pr(f, p, r));
    }
  }), i.forEach((l) => n.step(l)), s.forEach((l) => n.step(l));
}
function F_(n, e, t, r) {
  let i = [], s = 0;
  n.doc.nodesBetween(e, t, (o, a) => {
    if (!o.isInline)
      return;
    s++;
    let l = null;
    if (r instanceof Tl) {
      let u = o.marks, d;
      for (; d = r.isInSet(u); )
        (l || (l = [])).push(d), u = d.removeFromSet(u);
    } else r ? r.isInSet(o.marks) && (l = [r]) : l = o.marks;
    if (l && l.length) {
      let u = Math.min(a + o.nodeSize, t);
      for (let d = 0; d < l.length; d++) {
        let c = l[d], f;
        for (let p = 0; p < i.length; p++) {
          let h = i[p];
          h.step == s - 1 && c.eq(i[p].style) && (f = h);
        }
        f ? (f.to = u, f.step = s) : i.push({ style: c, from: Math.max(a, e), to: u, step: s });
      }
    }
  }), i.forEach((o) => n.step(new qn(o.from, o.to, o.style)));
}
function S1(n, e, t, r = t.contentMatch, i = !0) {
  let s = n.doc.nodeAt(e), o = [], a = e + 1;
  for (let l = 0; l < s.childCount; l++) {
    let u = s.child(l), d = a + u.nodeSize, c = r.matchType(u.type);
    if (!c)
      o.push(new vt(a, d, de.empty));
    else {
      r = c;
      for (let f = 0; f < u.marks.length; f++)
        t.allowsMarkType(u.marks[f].type) || n.step(new qn(a, d, u.marks[f]));
      if (i && u.isText && t.whitespace != "pre") {
        let f, p = /\r?\n|\r/g, h;
        for (; f = p.exec(u.text); )
          h || (h = new de(re.from(t.schema.text(" ", t.allowedMarks(u.marks))), 0, 0)), o.push(new vt(a + f.index, a + f.index + f[0].length, h));
      }
    }
    a = d;
  }
  if (!r.validEnd) {
    let l = r.fillBefore(re.empty, !0);
    n.replace(a, a, new de(l, 0, 0));
  }
  for (let l = o.length - 1; l >= 0; l--)
    n.step(o[l]);
}
function j_(n, e, t) {
  return (e == 0 || n.canReplace(e, n.childCount)) && (t == n.childCount || n.canReplace(0, t));
}
function xs(n) {
  let t = n.parent.content.cutByIndex(n.startIndex, n.endIndex);
  for (let r = n.depth; ; --r) {
    let i = n.$from.node(r), s = n.$from.index(r), o = n.$to.indexAfter(r);
    if (r < n.depth && i.canReplace(s, o, t))
      return r;
    if (r == 0 || i.type.spec.isolating || !j_(i, s, o))
      break;
  }
  return null;
}
function H_(n, e, t) {
  let { $from: r, $to: i, depth: s } = e, o = r.before(s + 1), a = i.after(s + 1), l = o, u = a, d = re.empty, c = 0;
  for (let h = s, y = !1; h > t; h--)
    y || r.index(h) > 0 ? (y = !0, d = re.from(r.node(h).copy(d)), c++) : l--;
  let f = re.empty, p = 0;
  for (let h = s, y = !1; h > t; h--)
    y || i.after(h + 1) < i.end(h) ? (y = !0, f = re.from(i.node(h).copy(f)), p++) : u++;
  n.step(new $t(l, u, o, a, new de(d.append(f), c, p), d.size - c, !0));
}
function E1(n, e, t = null, r = n) {
  let i = U_(n, e), s = i && W_(r, e);
  return s ? i.map(Tc).concat({ type: e, attrs: t }).concat(s.map(Tc)) : null;
}
function Tc(n) {
  return { type: n, attrs: null };
}
function U_(n, e) {
  let { parent: t, startIndex: r, endIndex: i } = n, s = t.contentMatchAt(r).findWrapping(e);
  if (!s)
    return null;
  let o = s.length ? s[0] : e;
  return t.canReplaceWith(r, i, o) ? s : null;
}
function W_(n, e) {
  let { parent: t, startIndex: r, endIndex: i } = n, s = t.child(r), o = e.contentMatch.findWrapping(s.type);
  if (!o)
    return null;
  let l = (o.length ? o[o.length - 1] : e).contentMatch;
  for (let u = r; l && u < i; u++)
    l = l.matchType(t.child(u).type);
  return !l || !l.validEnd ? null : o;
}
function q_(n, e, t) {
  let r = re.empty;
  for (let o = t.length - 1; o >= 0; o--) {
    if (r.size) {
      let a = t[o].type.contentMatch.matchFragment(r);
      if (!a || !a.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = re.from(t[o].type.create(t[o].attrs, r));
  }
  let i = e.start, s = e.end;
  n.step(new $t(i, s, i, s, new de(r, 0, 0), t.length, !0));
}
function K_(n, e, t, r, i) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let s = n.steps.length;
  n.doc.nodesBetween(e, t, (o, a) => {
    let l = typeof i == "function" ? i(o) : i;
    if (o.isTextblock && !o.hasMarkup(r, l) && G_(n.doc, n.mapping.slice(s).map(a), r)) {
      let u = null;
      if (r.schema.linebreakReplacement) {
        let p = r.whitespace == "pre", h = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        p && !h ? u = !1 : !p && h && (u = !0);
      }
      u === !1 && rh(n, o, a, s), S1(n, n.mapping.slice(s).map(a, 1), r, void 0, u === null);
      let d = n.mapping.slice(s), c = d.map(a, 1), f = d.map(a + o.nodeSize, 1);
      return n.step(new $t(c, f, c + 1, f - 1, new de(re.from(r.create(l, null, o.marks)), 0, 0), 1, !0)), u === !0 && nh(n, o, a, s), !1;
    }
  });
}
function nh(n, e, t, r) {
  e.forEach((i, s) => {
    if (i.isText) {
      let o, a = /\r?\n|\r/g;
      for (; o = a.exec(i.text); ) {
        let l = n.mapping.slice(r).map(t + 1 + s + o.index);
        n.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function rh(n, e, t, r) {
  e.forEach((i, s) => {
    if (i.type == i.type.schema.linebreakReplacement) {
      let o = n.mapping.slice(r).map(t + 1 + s);
      n.replaceWith(o, o + 1, e.type.schema.text(`
`));
    }
  });
}
function G_(n, e, t) {
  let r = n.resolve(e), i = r.index();
  return r.parent.canReplaceWith(i, i + 1, t);
}
function Y_(n, e, t, r, i) {
  let s = n.doc.nodeAt(e);
  if (!s)
    throw new RangeError("No node at given position");
  t || (t = s.type);
  let o = t.create(r, null, i || s.marks);
  if (s.isLeaf)
    return n.replaceWith(e, e + s.nodeSize, o);
  if (!t.validContent(s.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new $t(e, e + s.nodeSize, e + 1, e + s.nodeSize - 1, new de(re.from(o), 0, 0), 1, !0));
}
function es(n, e, t = 1, r) {
  let i = n.resolve(e), s = i.depth - t, o = r && r[r.length - 1] || i.parent;
  if (s < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !o.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let u = i.depth - 1, d = t - 2; u > s; u--, d--) {
    let c = i.node(u), f = i.index(u);
    if (c.type.spec.isolating)
      return !1;
    let p = c.content.cutByIndex(f, c.childCount), h = r && r[d + 1];
    h && (p = p.replaceChild(0, h.type.create(h.attrs)));
    let y = r && r[d] || c;
    if (!c.canReplace(f + 1, c.childCount) || !y.type.validContent(p))
      return !1;
  }
  let a = i.indexAfter(s), l = r && r[0];
  return i.node(s).canReplaceWith(a, a, l ? l.type : i.node(s + 1).type);
}
function J_(n, e, t = 1, r) {
  let i = n.doc.resolve(e), s = re.empty, o = re.empty;
  for (let a = i.depth, l = i.depth - t, u = t - 1; a > l; a--, u--) {
    s = re.from(i.node(a).copy(s));
    let d = r && r[u];
    o = re.from(d ? d.type.create(d.attrs, o) : i.node(a).copy(o));
  }
  n.step(new vt(e, e, new de(s.append(o), t, t), !0));
}
function Yr(n, e) {
  let t = n.resolve(e), r = t.index();
  return ih(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(r, r + 1);
}
function Z_(n, e) {
  e.content.size || n.type.compatibleContent(e.type);
  let t = n.contentMatchAt(n.childCount), { linebreakReplacement: r } = n.type.schema;
  for (let i = 0; i < e.childCount; i++) {
    let s = e.child(i), o = s.type == r ? n.type.schema.nodes.text : s.type;
    if (t = t.matchType(o), !t || !n.type.allowsMarks(s.marks))
      return !1;
  }
  return t.validEnd;
}
function ih(n, e) {
  return !!(n && e && !n.isLeaf && Z_(n, e));
}
function Ol(n, e, t = -1) {
  let r = n.resolve(e);
  for (let i = r.depth; ; i--) {
    let s, o, a = r.index(i);
    if (i == r.depth ? (s = r.nodeBefore, o = r.nodeAfter) : t > 0 ? (s = r.node(i + 1), a++, o = r.node(i).maybeChild(a)) : (s = r.node(i).maybeChild(a - 1), o = r.node(i + 1)), s && !s.isTextblock && ih(s, o) && r.node(i).canReplace(a, a + 1))
      return e;
    if (i == 0)
      break;
    e = t < 0 ? r.before(i) : r.after(i);
  }
}
function X_(n, e, t) {
  let r = null, { linebreakReplacement: i } = n.doc.type.schema, s = n.doc.resolve(e - t), o = s.node().type;
  if (i && o.inlineContent) {
    let d = o.whitespace == "pre", c = !!o.contentMatch.matchType(i);
    d && !c ? r = !1 : !d && c && (r = !0);
  }
  let a = n.steps.length;
  if (r === !1) {
    let d = n.doc.resolve(e + t);
    rh(n, d.node(), d.before(), a);
  }
  o.inlineContent && S1(n, e + t - 1, o, s.node().contentMatchAt(s.index()), r == null);
  let l = n.mapping.slice(a), u = l.map(e - t);
  if (n.step(new vt(u, l.map(e + t, -1), de.empty, !0)), r === !0) {
    let d = n.doc.resolve(u);
    nh(n, d.node(), d.before(), n.steps.length);
  }
  return n;
}
function Q_(n, e, t) {
  let r = n.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), t))
    return e;
  if (r.parentOffset == 0)
    for (let i = r.depth - 1; i >= 0; i--) {
      let s = r.index(i);
      if (r.node(i).canReplaceWith(s, s, t))
        return r.before(i + 1);
      if (s > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let i = r.depth - 1; i >= 0; i--) {
      let s = r.indexAfter(i);
      if (r.node(i).canReplaceWith(s, s, t))
        return r.after(i + 1);
      if (s < r.node(i).childCount)
        return null;
    }
  return null;
}
function sh(n, e, t) {
  let r = n.resolve(e);
  if (!t.content.size)
    return e;
  let i = t.content;
  for (let s = 0; s < t.openStart; s++)
    i = i.firstChild.content;
  for (let s = 1; s <= (t.openStart == 0 && t.size ? 2 : 1); s++)
    for (let o = r.depth; o >= 0; o--) {
      let a = o == r.depth ? 0 : r.pos <= (r.start(o + 1) + r.end(o + 1)) / 2 ? -1 : 1, l = r.index(o) + (a > 0 ? 1 : 0), u = r.node(o), d = !1;
      if (s == 1)
        d = u.canReplace(l, l, i);
      else {
        let c = u.contentMatchAt(l).findWrapping(i.firstChild.type);
        d = c && u.canReplaceWith(l, l, c[0]);
      }
      if (d)
        return a == 0 ? r.pos : a < 0 ? r.before(o + 1) : r.after(o + 1);
    }
  return null;
}
function Ml(n, e, t = e, r = de.empty) {
  if (e == t && !r.size)
    return null;
  let i = n.resolve(e), s = n.resolve(t);
  return oh(i, s, r) ? new vt(e, t, r) : new e$(i, s, r).fit();
}
function oh(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
class e$ {
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.unplaced = r, this.frontier = [], this.placed = re.empty;
    for (let i = 0; i <= e.depth; i++) {
      let s = e.node(i);
      this.frontier.push({
        type: s.type,
        match: s.contentMatchAt(e.indexAfter(i))
      });
    }
    for (let i = e.depth; i > 0; i--)
      this.placed = re.from(e.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let u = this.findFittable();
      u ? this.placeNodes(u) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, r = this.$from, i = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!i)
      return null;
    let s = this.placed, o = r.depth, a = i.depth;
    for (; o && a && s.childCount == 1; )
      s = s.firstChild.content, o--, a--;
    let l = new de(s, o, a);
    return e > -1 ? new $t(r.pos, e, this.$to.pos, this.$to.end(), l, t) : l.size || r.pos != this.$to.pos ? new vt(r.pos, i.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, r = 0, i = this.unplaced.openEnd; r < e; r++) {
      let s = t.firstChild;
      if (t.childCount > 1 && (i = 0), s.type.spec.isolating && i <= r) {
        e = r;
        break;
      }
      t = s.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let r = t == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let i, s = null;
        r ? (s = hu(this.unplaced.content, r - 1).firstChild, i = s.content) : i = this.unplaced.content;
        let o = i.firstChild;
        for (let a = this.depth; a >= 0; a--) {
          let { type: l, match: u } = this.frontier[a], d, c = null;
          if (t == 1 && (o ? u.matchType(o.type) || (c = u.fillBefore(re.from(o), !1)) : s && l.compatibleContent(s.type)))
            return { sliceDepth: r, frontierDepth: a, parent: s, inject: c };
          if (t == 2 && o && (d = u.findWrapping(o.type)))
            return { sliceDepth: r, frontierDepth: a, parent: s, wrap: d };
          if (s && u.matchType(s.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, i = hu(e, t);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new de(e, t + 1, Math.max(r, i.size + t >= e.size - r ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, i = hu(e, t);
    if (i.childCount <= 1 && t > 0) {
      let s = e.size - t <= t + i.size;
      this.unplaced = new de(Vs(e, t - 1, 1), t - 1, s ? t - 1 : r);
    } else
      this.unplaced = new de(Vs(e, t, 1), t, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: r, inject: i, wrap: s }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (s)
      for (let y = 0; y < s.length; y++)
        this.openFrontierNode(s[y]);
    let o = this.unplaced, a = r ? r.content : o.content, l = o.openStart - e, u = 0, d = [], { match: c, type: f } = this.frontier[t];
    if (i) {
      for (let y = 0; y < i.childCount; y++)
        d.push(i.child(y));
      c = c.matchFragment(i);
    }
    let p = a.size + e - (o.content.size - o.openEnd);
    for (; u < a.childCount; ) {
      let y = a.child(u), g = c.matchType(y.type);
      if (!g)
        break;
      u++, (u > 1 || l == 0 || y.content.size) && (c = g, d.push(ah(y.mark(f.allowedMarks(y.marks)), u == 1 ? l : 0, u == a.childCount ? p : -1)));
    }
    let h = u == a.childCount;
    h || (p = -1), this.placed = Fs(this.placed, t, re.from(d)), this.frontier[t].match = c, h && p < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let y = 0, g = a; y < p; y++) {
      let m = g.lastChild;
      this.frontier.push({ type: m.type, match: m.contentMatchAt(m.childCount) }), g = m.content;
    }
    this.unplaced = h ? e == 0 ? de.empty : new de(Vs(o.content, e - 1, 1), e - 1, p < 0 ? o.openEnd : e - 1) : new de(Vs(o.content, e, u), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !mu(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, i = this.$to.after(r);
    for (; r > 1 && i == this.$to.end(--r); )
      ++i;
    return i;
  }
  findCloseLevel(e) {
    e: for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
      let { match: r, type: i } = this.frontier[t], s = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), o = mu(e, t, i, r, s);
      if (o) {
        for (let a = t - 1; a >= 0; a--) {
          let { match: l, type: u } = this.frontier[a], d = mu(e, a, u, l, !0);
          if (!d || d.childCount)
            continue e;
        }
        return { depth: t, fit: o, move: s ? e.doc.resolve(e.after(t + 1)) : e };
      }
    }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = Fs(this.placed, t.depth, t.fit)), e = t.move;
    for (let r = t.depth + 1; r <= e.depth; r++) {
      let i = e.node(r), s = i.type.contentMatch.fillBefore(i.content, !0, e.index(r));
      this.openFrontierNode(i.type, i.attrs, s);
    }
    return e;
  }
  openFrontierNode(e, t = null, r) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(e), this.placed = Fs(this.placed, this.depth, re.from(e.create(t, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(re.empty, !0);
    t.childCount && (this.placed = Fs(this.placed, this.frontier.length, t));
  }
}
function Vs(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(Vs(n.firstChild.content, e - 1, t)));
}
function Fs(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(Fs(n.lastChild.content, e - 1, t)));
}
function hu(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function ah(n, e, t) {
  if (e <= 0)
    return n;
  let r = n.content;
  return e > 1 && (r = r.replaceChild(0, ah(r.firstChild, e - 1, r.childCount == 1 ? t - 1 : 0))), e > 0 && (r = n.type.contentMatch.fillBefore(r).append(r), t <= 0 && (r = r.append(n.type.contentMatch.matchFragment(r).fillBefore(re.empty, !0)))), n.copy(r);
}
function mu(n, e, t, r, i) {
  let s = n.node(e), o = i ? n.indexAfter(e) : n.index(e);
  if (o == s.childCount && !t.compatibleContent(s.type))
    return null;
  let a = r.fillBefore(s.content, !0, o);
  return a && !t$(t, s.content, o) ? a : null;
}
function t$(n, e, t) {
  for (let r = t; r < e.childCount; r++)
    if (!n.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function n$(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function r$(n, e, t, r) {
  if (!r.size)
    return n.deleteRange(e, t);
  let i = n.doc.resolve(e), s = n.doc.resolve(t);
  if (oh(i, s, r))
    return n.step(new vt(e, t, r));
  let o = uh(i, n.doc.resolve(t));
  o[o.length - 1] == 0 && o.pop();
  let a = -(i.depth + 1);
  o.unshift(a);
  for (let f = i.depth, p = i.pos - 1; f > 0; f--, p--) {
    let h = i.node(f).type.spec;
    if (h.defining || h.definingAsContext || h.isolating)
      break;
    o.indexOf(f) > -1 ? a = f : i.before(f) == p && o.splice(1, 0, -f);
  }
  let l = o.indexOf(a), u = [], d = r.openStart;
  for (let f = r.content, p = 0; ; p++) {
    let h = f.firstChild;
    if (u.push(h), p == r.openStart)
      break;
    f = h.content;
  }
  for (let f = d - 1; f >= 0; f--) {
    let p = u[f], h = n$(p.type);
    if (h && !p.sameMarkup(i.node(Math.abs(a) - 1)))
      d = f;
    else if (h || !p.type.isTextblock)
      break;
  }
  for (let f = r.openStart; f >= 0; f--) {
    let p = (f + d + 1) % (r.openStart + 1), h = u[p];
    if (h)
      for (let y = 0; y < o.length; y++) {
        let g = o[(y + l) % o.length], m = !0;
        g < 0 && (m = !1, g = -g);
        let $ = i.node(g - 1), w = i.index(g - 1);
        if ($.canReplaceWith(w, w, h.type, h.marks))
          return n.replace(i.before(g), m ? s.after(g) : t, new de(lh(r.content, 0, r.openStart, p), p, r.openEnd));
      }
  }
  let c = n.steps.length;
  for (let f = o.length - 1; f >= 0 && (n.replace(e, t, r), !(n.steps.length > c)); f--) {
    let p = o[f];
    p < 0 || (e = i.before(p), t = s.after(p));
  }
}
function lh(n, e, t, r, i) {
  if (e < t) {
    let s = n.firstChild;
    n = n.replaceChild(0, s.copy(lh(s.content, e + 1, t, r, s)));
  }
  if (e > r) {
    let s = i.contentMatchAt(0), o = s.fillBefore(n).append(n);
    n = o.append(s.matchFragment(o).fillBefore(re.empty, !0));
  }
  return n;
}
function i$(n, e, t, r) {
  if (!r.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let i = Q_(n.doc, e, r.type);
    i != null && (e = t = i);
  }
  n.replaceRange(e, t, new de(re.from(r), 0, 0));
}
function s$(n, e, t) {
  let r = n.doc.resolve(e), i = n.doc.resolve(t), s = uh(r, i);
  for (let o = 0; o < s.length; o++) {
    let a = s[o], l = o == s.length - 1;
    if (l && a == 0 || r.node(a).type.contentMatch.validEnd)
      return n.delete(r.start(a), i.end(a));
    if (a > 0 && (l || r.node(a - 1).canReplace(r.index(a - 1), i.indexAfter(a - 1))))
      return n.delete(r.before(a), i.after(a));
  }
  for (let o = 1; o <= r.depth && o <= i.depth; o++)
    if (e - r.start(o) == r.depth - o && t > r.end(o) && i.end(o) - t != i.depth - o && r.start(o - 1) == i.start(o - 1) && r.node(o - 1).canReplace(r.index(o - 1), i.index(o - 1)))
      return n.delete(r.before(o), t);
  n.delete(e, t);
}
function uh(n, e) {
  let t = [], r = Math.min(n.depth, e.depth);
  for (let i = r; i >= 0; i--) {
    let s = n.start(i);
    if (s < n.pos - (n.depth - i) || e.end(i) > e.pos + (e.depth - i) || n.node(i).type.spec.isolating || e.node(i).type.spec.isolating)
      break;
    (s == e.start(i) || i == n.depth && i == e.depth && n.parent.inlineContent && e.parent.inlineContent && i && e.start(i - 1) == s - 1) && t.push(i);
  }
  return t;
}
class ts extends Vt {
  /**
  Construct an attribute step.
  */
  constructor(e, t, r) {
    super(), this.pos = e, this.attr = t, this.value = r;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return dt.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let s in t.attrs)
      r[s] = t.attrs[s];
    r[this.attr] = this.value;
    let i = t.type.create(r, null, t.marks);
    return dt.fromReplace(e, this.pos, this.pos + 1, new de(re.from(i), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return cn.empty;
  }
  invert(e) {
    return new ts(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new ts(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new ts(t.pos, t.attr, t.value);
  }
}
Vt.jsonID("attr", ts);
class vo extends Vt {
  /**
  Construct an attribute step.
  */
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let i in e.attrs)
      t[i] = e.attrs[i];
    t[this.attr] = this.value;
    let r = e.type.create(t, e.content, e.marks);
    return dt.ok(r);
  }
  getMap() {
    return cn.empty;
  }
  invert(e) {
    return new vo(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new vo(t.attr, t.value);
  }
}
Vt.jsonID("docAttr", vo);
let us = class extends Error {
};
us = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
us.prototype = Object.create(Error.prototype);
us.prototype.constructor = us;
us.prototype.name = "TransformError";
class dh {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new yo();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new us(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, r = de.empty) {
    let i = Ml(this.doc, e, t, r);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, r) {
    return this.replace(e, t, new de(re.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, de.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, r) {
    return r$(this, e, t, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, r) {
    return i$(this, e, t, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return s$(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return H_(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return X_(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return q_(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, r, i = null) {
    return K_(this, e, t, r, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, r = null, i) {
    return Y_(this, e, t, r, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, t, r) {
    return this.step(new ts(e, t, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, t) {
    return this.step(new vo(e, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new Ir(e, t)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    let r = this.doc.nodeAt(e);
    if (!r)
      throw new RangeError("No node at position " + e);
    if (t instanceof Ge)
      t.isInSet(r.marks) && this.step(new Ci(e, t));
    else {
      let i = r.marks, s, o = [];
      for (; s = t.isInSet(i); )
        o.push(new Ci(e, s)), i = s.removeFromSet(i);
      for (let a = o.length - 1; a >= 0; a--)
        this.step(o[a]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, t = 1, r) {
    return J_(this, e, t, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, r) {
    return V_(this, e, t, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, r) {
    return F_(this, e, t, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, r) {
    return S1(this, e, t, r), this;
  }
}
const gu = /* @__PURE__ */ Object.create(null);
class Oe {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, t, r) {
    this.$anchor = e, this.$head = t, this.ranges = r || [new o$(e.min(t), e.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, t = de.empty) {
    let r = t.content.lastChild, i = null;
    for (let a = 0; a < t.openEnd; a++)
      i = r, r = r.lastChild;
    let s = e.steps.length, o = this.ranges;
    for (let a = 0; a < o.length; a++) {
      let { $from: l, $to: u } = o[a], d = e.mapping.slice(s);
      e.replaceRange(d.map(l.pos), d.map(u.pos), a ? de.empty : t), a == 0 && Ac(e, s, (r ? r.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, t) {
    let r = e.steps.length, i = this.ranges;
    for (let s = 0; s < i.length; s++) {
      let { $from: o, $to: a } = i[s], l = e.mapping.slice(r), u = l.map(o.pos), d = l.map(a.pos);
      s ? e.deleteRange(u, d) : (e.replaceRangeWith(u, d, t), Ac(e, r, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, t, r = !1) {
    let i = e.parent.inlineContent ? new Ce(e) : zi(e.node(0), e.parent, e.pos, e.index(), t, r);
    if (i)
      return i;
    for (let s = e.depth - 1; s >= 0; s--) {
      let o = t < 0 ? zi(e.node(0), e.node(s), e.before(s + 1), e.index(s), t, r) : zi(e.node(0), e.node(s), e.after(s + 1), e.index(s) + 1, t, r);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new Cn(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return zi(e, e, 0, 0, 1) || new Cn(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return zi(e, e, e.content.size, e.childCount, -1) || new Cn(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = gu[t.type];
    if (!r)
      throw new RangeError(`No selection type ${t.type} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, t) {
    if (e in gu)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return gu[e] = t, t.prototype.jsonID = e, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Ce.between(this.$anchor, this.$head).getBookmark();
  }
}
Oe.prototype.visible = !0;
class o$ {
  /**
  Create a range.
  */
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let Oc = !1;
function Mc(n) {
  !Oc && !n.parent.inlineContent && (Oc = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class Ce extends Oe {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, t = e) {
    Mc(e), Mc(t), super(e, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    if (!r.parent.inlineContent)
      return Oe.near(r);
    let i = e.resolve(t.map(this.anchor));
    return new Ce(i.parent.inlineContent ? i : r, r);
  }
  replace(e, t = de.empty) {
    if (super.replace(e, t), t == de.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof Ce && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Al(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Ce(e.resolve(t.anchor), e.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, t, r = t) {
    let i = e.resolve(t);
    return new this(i, r == t ? i : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, t, r) {
    let i = e.pos - t.pos;
    if ((!r || i) && (r = i >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let s = Oe.findFrom(t, r, !0) || Oe.findFrom(t, -r, !0);
      if (s)
        t = s.$head;
      else
        return Oe.near(t, r);
    }
    return e.parent.inlineContent || (i == 0 ? e = t : (e = (Oe.findFrom(e, -r, !0) || Oe.findFrom(e, r, !0)).$anchor, e.pos < t.pos != i < 0 && (e = t))), new Ce(e, t);
  }
}
Oe.jsonID("text", Ce);
class Al {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new Al(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Ce.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class ve extends Oe {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let t = e.nodeAfter, r = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, r), this.node = t;
  }
  map(e, t) {
    let { deleted: r, pos: i } = t.mapResult(this.anchor), s = e.resolve(i);
    return r ? Oe.near(s) : new ve(s);
  }
  content() {
    return new de(re.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof ve && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new T1(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new ve(e.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, t) {
    return new ve(e.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
ve.prototype.visible = !1;
Oe.jsonID("node", ve);
class T1 {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: r } = e.mapResult(this.anchor);
    return t ? new Al(r, r) : new T1(r);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), r = t.nodeAfter;
    return r && ve.isSelectable(r) ? new ve(t) : Oe.near(t);
  }
}
class Cn extends Oe {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = de.empty) {
    if (t == de.empty) {
      e.delete(0, e.doc.content.size);
      let r = Oe.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new Cn(e);
  }
  map(e) {
    return new Cn(e);
  }
  eq(e) {
    return e instanceof Cn;
  }
  getBookmark() {
    return a$;
  }
}
Oe.jsonID("all", Cn);
const a$ = {
  map() {
    return this;
  },
  resolve(n) {
    return new Cn(n);
  }
};
function zi(n, e, t, r, i, s = !1) {
  if (e.inlineContent)
    return Ce.create(n, t);
  for (let o = r - (i > 0 ? 0 : 1); i > 0 ? o < e.childCount : o >= 0; o += i) {
    let a = e.child(o);
    if (a.isAtom) {
      if (!s && ve.isSelectable(a))
        return ve.create(n, t - (i < 0 ? a.nodeSize : 0));
    } else {
      let l = zi(n, a, t + i, i < 0 ? a.childCount : 0, i, s);
      if (l)
        return l;
    }
    t += a.nodeSize * i;
  }
  return null;
}
function Ac(n, e, t) {
  let r = n.steps.length - 1;
  if (r < e)
    return;
  let i = n.steps[r];
  if (!(i instanceof vt || i instanceof $t))
    return;
  let s = n.mapping.maps[r], o;
  s.forEach((a, l, u, d) => {
    o == null && (o = d);
  }), n.setSelection(Oe.near(n.doc.resolve(o), t));
}
const Nc = 1, Jo = 2, Dc = 4;
class l$ extends dh {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | Nc) & ~Jo, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & Nc) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= Jo, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return Ge.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Jo) > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~Jo, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, t = !0) {
    let r = this.selection;
    return t && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || Ge.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, t, r) {
    let i = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(i.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = t), r = r ?? t, !e)
        return this.deleteRange(t, r);
      let s = this.storedMarks;
      if (!s) {
        let o = this.doc.resolve(t);
        s = r == t ? o.marks() : o.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(t, r, i.text(e, s)), this.selection.empty || this.setSelection(Oe.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= Dc, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & Dc) > 0;
  }
}
function Lc(n, e) {
  return !e || !n ? n : n.bind(e);
}
class js {
  constructor(e, t, r) {
    this.name = e, this.init = Lc(t.init, r), this.apply = Lc(t.apply, r);
  }
}
const u$ = [
  new js("doc", {
    init(n) {
      return n.doc || n.schema.topNodeType.createAndFill();
    },
    apply(n) {
      return n.doc;
    }
  }),
  new js("selection", {
    init(n, e) {
      return n.selection || Oe.atStart(e.doc);
    },
    apply(n) {
      return n.selection;
    }
  }),
  new js("storedMarks", {
    init(n) {
      return n.storedMarks || null;
    },
    apply(n, e, t, r) {
      return r.selection.$cursor ? n.storedMarks : null;
    }
  }),
  new js("scrollToSelection", {
    init() {
      return 0;
    },
    apply(n, e) {
      return n.scrolledIntoView ? e + 1 : e;
    }
  })
];
class bu {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = u$.slice(), t && t.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new js(r.key, r.spec.state, r));
    });
  }
}
class Ki {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, t = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != t) {
        let i = this.config.plugins[r];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], r = this.applyInner(e), i = null;
    for (; ; ) {
      let s = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let a = this.config.plugins[o];
        if (a.spec.appendTransaction) {
          let l = i ? i[o].n : 0, u = i ? i[o].state : this, d = l < t.length && a.spec.appendTransaction.call(a, l ? t.slice(l) : t, u, r);
          if (d && r.filterTransaction(d, o)) {
            if (d.setMeta("appendedTransaction", e), !i) {
              i = [];
              for (let c = 0; c < this.config.plugins.length; c++)
                i.push(c < o ? { state: r, n: t.length } : { state: this, n: 0 });
            }
            t.push(d), r = r.applyInner(d), s = !0;
          }
          i && (i[o] = { state: r, n: t.length });
        }
      }
      if (!s)
        return { state: r, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new Ki(this.config), r = this.config.fields;
    for (let i = 0; i < r.length; i++) {
      let s = r[i];
      t[s.name] = s.apply(e, this[s.name], this, t);
    }
    return t;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new l$(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let t = new bu(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new Ki(t);
    for (let i = 0; i < t.fields.length; i++)
      r[t.fields[i].name] = t.fields[i].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let t = new bu(this.schema, e.plugins), r = t.fields, i = new Ki(t);
    for (let s = 0; s < r.length; s++) {
      let o = r[s].name;
      i[o] = this.hasOwnProperty(o) ? this[o] : r[s].init(e, i);
    }
    return i;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = e[r], s = i.spec.state;
        s && s.toJSON && (t[r] = s.toJSON.call(i, this[i.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, t, r) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new bu(e.schema, e.plugins), s = new Ki(i);
    return i.fields.forEach((o) => {
      if (o.name == "doc")
        s.doc = Kn.fromJSON(e.schema, t.doc);
      else if (o.name == "selection")
        s.selection = Oe.fromJSON(s.doc, t.selection);
      else if (o.name == "storedMarks")
        t.storedMarks && (s.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let a in r) {
            let l = r[a], u = l.spec.state;
            if (l.key == o.name && u && u.fromJSON && Object.prototype.hasOwnProperty.call(t, a)) {
              s[o.name] = u.fromJSON.call(l, e, t[a], s);
              return;
            }
          }
        s[o.name] = o.init(e, s);
      }
    }), s;
  }
}
function ch(n, e, t) {
  for (let r in n) {
    let i = n[r];
    i instanceof Function ? i = i.bind(e) : r == "handleDOMEvents" && (i = ch(i, e, {})), t[r] = i;
  }
  return t;
}
class bt {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && ch(e.props, this, this.props), this.key = e.key ? e.key.key : fh("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const yu = /* @__PURE__ */ Object.create(null);
function fh(n) {
  return n in yu ? n + "$" + ++yu[n] : (yu[n] = 0, n + "$");
}
class Jt {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = fh(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const At = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, ds = function(n) {
  let e = n.assignedSlot || n.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let xd = null;
const ar = function(n, e, t) {
  let r = xd || (xd = document.createRange());
  return r.setEnd(n, t ?? n.nodeValue.length), r.setStart(n, e || 0), r;
}, d$ = function() {
  xd = null;
}, Si = function(n, e, t, r) {
  return t && (Rc(n, e, t, r, -1) || Rc(n, e, t, r, 1));
}, c$ = /^(img|br|input|textarea|hr)$/i;
function Rc(n, e, t, r, i) {
  for (; ; ) {
    if (n == t && e == r)
      return !0;
    if (e == (i < 0 ? 0 : wn(n))) {
      let s = n.parentNode;
      if (!s || s.nodeType != 1 || Ro(n) || c$.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = At(n) + (i < 0 ? 0 : 1), n = s;
    } else if (n.nodeType == 1) {
      if (n = n.childNodes[e + (i < 0 ? -1 : 0)], n.contentEditable == "false")
        return !1;
      e = i < 0 ? wn(n) : 0;
    } else
      return !1;
  }
}
function wn(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function f$(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e)
      return n;
    if (n.nodeType == 1 && e > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e - 1], e = wn(n);
    } else if (n.parentNode && !Ro(n))
      e = At(n), n = n.parentNode;
    else
      return null;
  }
}
function p$(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e < n.nodeValue.length)
      return n;
    if (n.nodeType == 1 && e < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e], e = 0;
    } else if (n.parentNode && !Ro(n))
      e = At(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
function h$(n, e, t) {
  for (let r = e == 0, i = e == wn(n); r || i; ) {
    if (n == t)
      return !0;
    let s = At(n);
    if (n = n.parentNode, !n)
      return !1;
    r = r && s == 0, i = i && s == wn(n);
  }
}
function Ro(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const Nl = function(n) {
  return n.focusNode && Si(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function si(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
function m$(n) {
  let e = n.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function g$(n, e, t) {
  if (n.caretPositionFromPoint)
    try {
      let r = n.caretPositionFromPoint(e, t);
      if (r)
        return { node: r.offsetNode, offset: Math.min(wn(r.offsetNode), r.offset) };
    } catch {
    }
  if (n.caretRangeFromPoint) {
    let r = n.caretRangeFromPoint(e, t);
    if (r)
      return { node: r.startContainer, offset: Math.min(wn(r.startContainer), r.startOffset) };
  }
}
const Jn = typeof navigator < "u" ? navigator : null, Pc = typeof document < "u" ? document : null, Jr = Jn && Jn.userAgent || "", wd = /Edge\/(\d+)/.exec(Jr), ph = /MSIE \d/.exec(Jr), kd = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Jr), en = !!(ph || kd || wd), Hr = ph ? document.documentMode : kd ? +kd[1] : wd ? +wd[1] : 0, Pn = !en && /gecko\/(\d+)/i.test(Jr);
Pn && +(/Firefox\/(\d+)/.exec(Jr) || [0, 0])[1];
const Cd = !en && /Chrome\/(\d+)/.exec(Jr), Bt = !!Cd, hh = Cd ? +Cd[1] : 0, qt = !en && !!Jn && /Apple Computer/.test(Jn.vendor), cs = qt && (/Mobile\/\w+/.test(Jr) || !!Jn && Jn.maxTouchPoints > 2), $n = cs || (Jn ? /Mac/.test(Jn.platform) : !1), b$ = Jn ? /Win/.test(Jn.platform) : !1, ur = /Android \d/.test(Jr), Po = !!Pc && "webkitFontSmoothing" in Pc.documentElement.style, y$ = Po ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function v$(n) {
  let e = n.defaultView && n.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: n.documentElement.clientWidth,
    top: 0,
    bottom: n.documentElement.clientHeight
  };
}
function rr(n, e) {
  return typeof n == "number" ? n : n[e];
}
function _$(n) {
  let e = n.getBoundingClientRect(), t = e.width / n.offsetWidth || 1, r = e.height / n.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + n.clientWidth * t,
    top: e.top,
    bottom: e.top + n.clientHeight * r
  };
}
function Ic(n, e, t) {
  let r = n.someProp("scrollThreshold") || 0, i = n.someProp("scrollMargin") || 5, s = n.dom.ownerDocument;
  for (let o = t || n.dom; o; ) {
    if (o.nodeType != 1) {
      o = ds(o);
      continue;
    }
    let a = o, l = a == s.body, u = l ? v$(s) : _$(a), d = 0, c = 0;
    if (e.top < u.top + rr(r, "top") ? c = -(u.top - e.top + rr(i, "top")) : e.bottom > u.bottom - rr(r, "bottom") && (c = e.bottom - e.top > u.bottom - u.top ? e.top + rr(i, "top") - u.top : e.bottom - u.bottom + rr(i, "bottom")), e.left < u.left + rr(r, "left") ? d = -(u.left - e.left + rr(i, "left")) : e.right > u.right - rr(r, "right") && (d = e.right - u.right + rr(i, "right")), d || c)
      if (l)
        s.defaultView.scrollBy(d, c);
      else {
        let p = a.scrollLeft, h = a.scrollTop;
        c && (a.scrollTop += c), d && (a.scrollLeft += d);
        let y = a.scrollLeft - p, g = a.scrollTop - h;
        e = { left: e.left - y, top: e.top - g, right: e.right - y, bottom: e.bottom - g };
      }
    let f = l ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(f))
      break;
    o = f == "absolute" ? o.offsetParent : ds(o);
  }
}
function $$(n) {
  let e = n.dom.getBoundingClientRect(), t = Math.max(0, e.top), r, i;
  for (let s = (e.left + e.right) / 2, o = t + 1; o < Math.min(innerHeight, e.bottom); o += 5) {
    let a = n.root.elementFromPoint(s, o);
    if (!a || a == n.dom || !n.dom.contains(a))
      continue;
    let l = a.getBoundingClientRect();
    if (l.top >= t - 20) {
      r = a, i = l.top;
      break;
    }
  }
  return { refDOM: r, refTop: i, stack: mh(n.dom) };
}
function mh(n) {
  let e = [], t = n.ownerDocument;
  for (let r = n; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), n != t); r = ds(r))
    ;
  return e;
}
function x$({ refDOM: n, refTop: e, stack: t }) {
  let r = n ? n.getBoundingClientRect().top : 0;
  gh(t, r == 0 ? 0 : r - e);
}
function gh(n, e) {
  for (let t = 0; t < n.length; t++) {
    let { dom: r, top: i, left: s } = n[t];
    r.scrollTop != i + e && (r.scrollTop = i + e), r.scrollLeft != s && (r.scrollLeft = s);
  }
}
let Li = null;
function w$(n) {
  if (n.setActive)
    return n.setActive();
  if (Li)
    return n.focus(Li);
  let e = mh(n);
  n.focus(Li == null ? {
    get preventScroll() {
      return Li = { preventScroll: !0 }, !0;
    }
  } : void 0), Li || (Li = !1, gh(e, 0));
}
function bh(n, e) {
  let t, r = 2e8, i, s = 0, o = e.top, a = e.top, l, u;
  for (let d = n.firstChild, c = 0; d; d = d.nextSibling, c++) {
    let f;
    if (d.nodeType == 1)
      f = d.getClientRects();
    else if (d.nodeType == 3)
      f = ar(d).getClientRects();
    else
      continue;
    for (let p = 0; p < f.length; p++) {
      let h = f[p];
      if (h.top <= o && h.bottom >= a) {
        o = Math.max(h.bottom, o), a = Math.min(h.top, a);
        let y = h.left > e.left ? h.left - e.left : h.right < e.left ? e.left - h.right : 0;
        if (y < r) {
          t = d, r = y, i = y && t.nodeType == 3 ? {
            left: h.right < e.left ? h.right : h.left,
            top: e.top
          } : e, d.nodeType == 1 && y && (s = c + (e.left >= (h.left + h.right) / 2 ? 1 : 0));
          continue;
        }
      } else h.top > e.top && !l && h.left <= e.left && h.right >= e.left && (l = d, u = { left: Math.max(h.left, Math.min(h.right, e.left)), top: h.top });
      !t && (e.left >= h.right && e.top >= h.top || e.left >= h.left && e.top >= h.bottom) && (s = c + 1);
    }
  }
  return !t && l && (t = l, i = u, r = 0), t && t.nodeType == 3 ? k$(t, i) : !t || r && t.nodeType == 1 ? { node: n, offset: s } : bh(t, i);
}
function k$(n, e) {
  let t = n.nodeValue.length, r = document.createRange();
  for (let i = 0; i < t; i++) {
    r.setEnd(n, i + 1), r.setStart(n, i);
    let s = Er(r, 1);
    if (s.top != s.bottom && O1(e, s))
      return { node: n, offset: i + (e.left >= (s.left + s.right) / 2 ? 1 : 0) };
  }
  return { node: n, offset: 0 };
}
function O1(n, e) {
  return n.left >= e.left - 1 && n.left <= e.right + 1 && n.top >= e.top - 1 && n.top <= e.bottom + 1;
}
function C$(n, e) {
  let t = n.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < n.getBoundingClientRect().left ? t : n;
}
function S$(n, e, t) {
  let { node: r, offset: i } = bh(e, t), s = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let o = r.getBoundingClientRect();
    s = o.left != o.right && t.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return n.docView.posFromDOM(r, i, s);
}
function E$(n, e, t, r) {
  let i = -1;
  for (let s = e, o = !1; s != n.dom; ) {
    let a = n.docView.nearestDesc(s, !0), l;
    if (!a)
      return null;
    if (a.dom.nodeType == 1 && (a.node.isBlock && a.parent || !a.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = a.dom.getBoundingClientRect()).width || l.height) && (a.node.isBlock && a.parent && (!o && l.left > r.left || l.top > r.top ? i = a.posBefore : (!o && l.right < r.left || l.bottom < r.top) && (i = a.posAfter), o = !0), !a.contentDOM && i < 0 && !a.node.isText))
      return (a.node.isBlock ? r.top < (l.top + l.bottom) / 2 : r.left < (l.left + l.right) / 2) ? a.posBefore : a.posAfter;
    s = a.dom.parentNode;
  }
  return i > -1 ? i : n.docView.posFromDOM(e, t, -1);
}
function yh(n, e, t) {
  let r = n.childNodes.length;
  if (r && t.top < t.bottom)
    for (let i = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - t.top) / (t.bottom - t.top)) - 2)), s = i; ; ) {
      let o = n.childNodes[s];
      if (o.nodeType == 1) {
        let a = o.getClientRects();
        for (let l = 0; l < a.length; l++) {
          let u = a[l];
          if (O1(e, u))
            return yh(o, e, u);
        }
      }
      if ((s = (s + 1) % r) == i)
        break;
    }
  return n;
}
function T$(n, e) {
  let t = n.dom.ownerDocument, r, i = 0, s = g$(t, e.left, e.top);
  s && ({ node: r, offset: i } = s);
  let o = (n.root.elementFromPoint ? n.root : t).elementFromPoint(e.left, e.top), a;
  if (!o || !n.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let u = n.dom.getBoundingClientRect();
    if (!O1(e, u) || (o = yh(n.dom, e, u), !o))
      return null;
  }
  if (qt)
    for (let u = o; r && u; u = ds(u))
      u.draggable && (r = void 0);
  if (o = C$(o, e), r) {
    if (Pn && r.nodeType == 1 && (i = Math.min(i, r.childNodes.length), i < r.childNodes.length)) {
      let d = r.childNodes[i], c;
      d.nodeName == "IMG" && (c = d.getBoundingClientRect()).right <= e.left && c.bottom > e.top && i++;
    }
    let u;
    Po && i && r.nodeType == 1 && (u = r.childNodes[i - 1]).nodeType == 1 && u.contentEditable == "false" && u.getBoundingClientRect().top >= e.top && i--, r == n.dom && i == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? a = n.state.doc.content.size : (i == 0 || r.nodeType != 1 || r.childNodes[i - 1].nodeName != "BR") && (a = E$(n, r, i, e));
  }
  a == null && (a = S$(n, o, e));
  let l = n.docView.nearestDesc(o, !0);
  return { pos: a, inside: l ? l.posAtStart - l.border : -1 };
}
function Bc(n) {
  return n.top < n.bottom || n.left < n.right;
}
function Er(n, e) {
  let t = n.getClientRects();
  if (t.length) {
    let r = t[e < 0 ? 0 : t.length - 1];
    if (Bc(r))
      return r;
  }
  return Array.prototype.find.call(t, Bc) || n.getBoundingClientRect();
}
const O$ = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function vh(n, e, t) {
  let { node: r, offset: i, atom: s } = n.docView.domFromPos(e, t < 0 ? -1 : 1), o = Po || Pn;
  if (r.nodeType == 3)
    if (o && (O$.test(r.nodeValue) || (t < 0 ? !i : i == r.nodeValue.length))) {
      let l = Er(ar(r, i, i), t);
      if (Pn && i && /\s/.test(r.nodeValue[i - 1]) && i < r.nodeValue.length) {
        let u = Er(ar(r, i - 1, i - 1), -1);
        if (u.top == l.top) {
          let d = Er(ar(r, i, i + 1), -1);
          if (d.top != l.top)
            return Ms(d, d.left < u.left);
        }
      }
      return l;
    } else {
      let l = i, u = i, d = t < 0 ? 1 : -1;
      return t < 0 && !i ? (u++, d = -1) : t >= 0 && i == r.nodeValue.length ? (l--, d = 1) : t < 0 ? l-- : u++, Ms(Er(ar(r, l, u), d), d < 0);
    }
  if (!n.state.doc.resolve(e - (s || 0)).parent.inlineContent) {
    if (s == null && i && (t < 0 || i == wn(r))) {
      let l = r.childNodes[i - 1];
      if (l.nodeType == 1)
        return vu(l.getBoundingClientRect(), !1);
    }
    if (s == null && i < wn(r)) {
      let l = r.childNodes[i];
      if (l.nodeType == 1)
        return vu(l.getBoundingClientRect(), !0);
    }
    return vu(r.getBoundingClientRect(), t >= 0);
  }
  if (s == null && i && (t < 0 || i == wn(r))) {
    let l = r.childNodes[i - 1], u = l.nodeType == 3 ? ar(l, wn(l) - (o ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (u)
      return Ms(Er(u, 1), !1);
  }
  if (s == null && i < wn(r)) {
    let l = r.childNodes[i];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let u = l ? l.nodeType == 3 ? ar(l, 0, o ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (u)
      return Ms(Er(u, -1), !0);
  }
  return Ms(Er(r.nodeType == 3 ? ar(r) : r, -t), t >= 0);
}
function Ms(n, e) {
  if (n.width == 0)
    return n;
  let t = e ? n.left : n.right;
  return { top: n.top, bottom: n.bottom, left: t, right: t };
}
function vu(n, e) {
  if (n.height == 0)
    return n;
  let t = e ? n.top : n.bottom;
  return { top: t, bottom: t, left: n.left, right: n.right };
}
function _h(n, e, t) {
  let r = n.state, i = n.root.activeElement;
  r != e && n.updateState(e), i != n.dom && n.focus();
  try {
    return t();
  } finally {
    r != e && n.updateState(r), i != n.dom && i && i.focus();
  }
}
function M$(n, e, t) {
  let r = e.selection, i = t == "up" ? r.$from : r.$to;
  return _h(n, e, () => {
    let { node: s } = n.docView.domFromPos(i.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let a = n.docView.nearestDesc(s, !0);
      if (!a)
        break;
      if (a.node.isBlock) {
        s = a.contentDOM || a.dom;
        break;
      }
      s = a.dom.parentNode;
    }
    let o = vh(n, i.pos, 1);
    for (let a = s.firstChild; a; a = a.nextSibling) {
      let l;
      if (a.nodeType == 1)
        l = a.getClientRects();
      else if (a.nodeType == 3)
        l = ar(a, 0, a.nodeValue.length).getClientRects();
      else
        continue;
      for (let u = 0; u < l.length; u++) {
        let d = l[u];
        if (d.bottom > d.top + 1 && (t == "up" ? o.top - d.top > (d.bottom - o.top) * 2 : d.bottom - o.bottom > (o.bottom - d.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const A$ = /[\u0590-\u08ac]/;
function N$(n, e, t) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let i = r.parentOffset, s = !i, o = i == r.parent.content.size, a = n.domSelection();
  return a ? !A$.test(r.parent.textContent) || !a.modify ? t == "left" || t == "backward" ? s : o : _h(n, e, () => {
    let { focusNode: l, focusOffset: u, anchorNode: d, anchorOffset: c } = n.domSelectionRange(), f = a.caretBidiLevel;
    a.modify("move", t, "character");
    let p = r.depth ? n.docView.domAfterPos(r.before()) : n.dom, { focusNode: h, focusOffset: y } = n.domSelectionRange(), g = h && !p.contains(h.nodeType == 1 ? h : h.parentNode) || l == h && u == y;
    try {
      a.collapse(d, c), l && (l != d || u != c) && a.extend && a.extend(l, u);
    } catch {
    }
    return f != null && (a.caretBidiLevel = f), g;
  }) : r.pos == r.start() || r.pos == r.end();
}
let zc = null, Vc = null, Fc = !1;
function D$(n, e, t) {
  return zc == e && Vc == t ? Fc : (zc = e, Vc = t, Fc = t == "up" || t == "down" ? M$(n, e, t) : N$(n, e, t));
}
const Sn = 0, jc = 1, ai = 2, Zn = 3;
class Io {
  constructor(e, t, r, i) {
    this.parent = e, this.children = t, this.dom = r, this.contentDOM = i, this.dirty = Sn, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, r = this.posAtStart; ; t++) {
      let i = this.children[t];
      if (i == e)
        return r;
      r += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.previousSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.previousSibling;
        return s ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.nextSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.nextSibling;
        return s ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let i;
    if (e == this.dom && this.contentDOM)
      i = t > At(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            i = !1;
            break;
          }
          if (s.previousSibling)
            break;
        }
      if (i == null && t == e.childNodes.length)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            i = !0;
            break;
          }
          if (s.nextSibling)
            break;
        }
    }
    return i ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let r = !0, i = e; i; i = i.parentNode) {
      let s = this.getDesc(i), o;
      if (s && (!t || s.node))
        if (r && (o = s.nodeDOM) && !(o.nodeType == 1 ? o.contains(e.nodeType == 1 ? e : e.parentNode) : o == e))
          r = !1;
        else
          return s;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let r = t; r; r = r.parent)
      if (r == this)
        return t;
  }
  posFromDOM(e, t, r) {
    for (let i = e; i; i = i.parentNode) {
      let s = this.getDesc(i);
      if (s)
        return s.localPosFromDOM(e, t, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let t = 0, r = 0; t < this.children.length; t++) {
      let i = this.children[t], s = r + i.size;
      if (r == e && s != r) {
        for (; !i.border && i.children.length; )
          for (let o = 0; o < i.children.length; o++) {
            let a = i.children[o];
            if (a.size) {
              i = a;
              break;
            }
          }
        return i;
      }
      if (e < s)
        return i.descAt(e - r - i.border);
      r = s;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, i = 0;
    for (let s = 0; r < this.children.length; r++) {
      let o = this.children[r], a = s + o.size;
      if (a > e || o instanceof xh) {
        i = e - s;
        break;
      }
      s = a;
    }
    if (i)
      return this.children[r].domFromPos(i - this.children[r].border, t);
    for (let s; r && !(s = this.children[r - 1]).size && s instanceof $h && s.side >= 0; r--)
      ;
    if (t <= 0) {
      let s, o = !0;
      for (; s = r ? this.children[r - 1] : null, !(!s || s.dom.parentNode == this.contentDOM); r--, o = !1)
        ;
      return s && t && o && !s.border && !s.domAtom ? s.domFromPos(s.size, t) : { node: this.contentDOM, offset: s ? At(s.dom) + 1 : 0 };
    } else {
      let s, o = !0;
      for (; s = r < this.children.length ? this.children[r] : null, !(!s || s.dom.parentNode == this.contentDOM); r++, o = !1)
        ;
      return s && o && !s.border && !s.domAtom ? s.domFromPos(0, t) : { node: this.contentDOM, offset: s ? At(s.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, t, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, s = -1;
    for (let o = r, a = 0; ; a++) {
      let l = this.children[a], u = o + l.size;
      if (i == -1 && e <= u) {
        let d = o + l.border;
        if (e >= d && t <= u - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, t, d);
        e = o;
        for (let c = a; c > 0; c--) {
          let f = this.children[c - 1];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(1)) {
            i = At(f.dom) + 1;
            break;
          }
          e -= f.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (u > t || a == this.children.length - 1)) {
        t = u;
        for (let d = a + 1; d < this.children.length; d++) {
          let c = this.children[d];
          if (c.size && c.dom.parentNode == this.contentDOM && !c.emptyChildAt(-1)) {
            s = At(c.dom);
            break;
          }
          t += c.size;
        }
        s == -1 && (s = this.contentDOM.childNodes.length);
        break;
      }
      o = u;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: i, toOffset: s };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: r } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || r == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, t, r, i = !1) {
    let s = Math.min(e, t), o = Math.max(e, t);
    for (let p = 0, h = 0; p < this.children.length; p++) {
      let y = this.children[p], g = h + y.size;
      if (s > h && o < g)
        return y.setSelection(e - h - y.border, t - h - y.border, r, i);
      h = g;
    }
    let a = this.domFromPos(e, e ? -1 : 1), l = t == e ? a : this.domFromPos(t, t ? -1 : 1), u = r.root.getSelection(), d = r.domSelectionRange(), c = !1;
    if ((Pn || qt) && e == t) {
      let { node: p, offset: h } = a;
      if (p.nodeType == 3) {
        if (c = !!(h && p.nodeValue[h - 1] == `
`), c && h == p.nodeValue.length)
          for (let y = p, g; y; y = y.parentNode) {
            if (g = y.nextSibling) {
              g.nodeName == "BR" && (a = l = { node: g.parentNode, offset: At(g) + 1 });
              break;
            }
            let m = y.pmViewDesc;
            if (m && m.node && m.node.isBlock)
              break;
          }
      } else {
        let y = p.childNodes[h - 1];
        c = y && (y.nodeName == "BR" || y.contentEditable == "false");
      }
    }
    if (Pn && d.focusNode && d.focusNode != l.node && d.focusNode.nodeType == 1) {
      let p = d.focusNode.childNodes[d.focusOffset];
      p && p.contentEditable == "false" && (i = !0);
    }
    if (!(i || c && qt) && Si(a.node, a.offset, d.anchorNode, d.anchorOffset) && Si(l.node, l.offset, d.focusNode, d.focusOffset))
      return;
    let f = !1;
    if ((u.extend || e == t) && !c) {
      u.collapse(a.node, a.offset);
      try {
        e != t && u.extend(l.node, l.offset), f = !0;
      } catch {
      }
    }
    if (!f) {
      if (e > t) {
        let h = a;
        a = l, l = h;
      }
      let p = document.createRange();
      p.setEnd(l.node, l.offset), p.setStart(a.node, a.offset), u.removeAllRanges(), u.addRange(p);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, t) {
    for (let r = 0, i = 0; i < this.children.length; i++) {
      let s = this.children[i], o = r + s.size;
      if (r == o ? e <= o && t >= r : e < o && t > r) {
        let a = r + s.border, l = o - s.border;
        if (e >= a && t <= l) {
          this.dirty = e == r || t == o ? ai : jc, e == a && t == l && (s.contentLost || s.dom.parentNode != this.contentDOM) ? s.dirty = Zn : s.markDirty(e - a, t - a);
          return;
        } else
          s.dirty = s.dom == s.contentDOM && s.dom.parentNode == this.contentDOM && !s.children.length ? ai : Zn;
      }
      r = o;
    }
    this.dirty = ai;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let r = e == 1 ? ai : jc;
      t.dirty < r && (t.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class $h extends Io {
  constructor(e, t, r, i) {
    let s, o = t.type.toDOM;
    if (typeof o == "function" && (o = o(r, () => {
      if (!s)
        return i;
      if (s.parent)
        return s.parent.posBeforeChild(s);
    })), !t.type.spec.raw) {
      if (o.nodeType != 1) {
        let a = document.createElement("span");
        a.appendChild(o), o = a;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(e, [], o, null), this.widget = t, this.widget = t, s = this;
  }
  matchesWidget(e) {
    return this.dirty == Sn && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class L$ extends Io {
  constructor(e, t, r, i) {
    super(e, [], t, null), this.textDOM = r, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class Ei extends Io {
  constructor(e, t, r, i, s) {
    super(e, [], r, i), this.mark = t, this.spec = s;
  }
  static create(e, t, r, i) {
    let s = i.nodeViews[t.type.name], o = s && s(t, i, r);
    return (!o || !o.dom) && (o = Gr.renderSpec(document, t.type.spec.toDOM(t, r), null, t.attrs)), new Ei(e, t, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & Zn || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != Zn && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != Sn) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = Sn;
    }
  }
  slice(e, t, r) {
    let i = Ei.create(this.parent, this.mark, !0, r), s = this.children, o = this.size;
    t < o && (s = Ed(s, t, o, r)), e > 0 && (s = Ed(s, 0, e, r));
    for (let a = 0; a < s.length; a++)
      s[a].parent = i;
    return i.children = s, i;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class Ur extends Io {
  constructor(e, t, r, i, s, o, a, l, u) {
    super(e, [], s, o), this.node = t, this.outerDeco = r, this.innerDeco = i, this.nodeDOM = a;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, t, r, i, s, o) {
    let a = s.nodeViews[t.type.name], l, u = a && a(t, s, () => {
      if (!l)
        return o;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, r, i), d = u && u.dom, c = u && u.contentDOM;
    if (t.isText) {
      if (!d)
        d = document.createTextNode(t.text);
      else if (d.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else d || ({ dom: d, contentDOM: c } = Gr.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !c && !t.isText && d.nodeName != "BR" && (d.hasAttribute("contenteditable") || (d.contentEditable = "false"), t.type.spec.draggable && (d.draggable = !0));
    let f = d;
    return d = Ch(d, r, t), u ? l = new R$(e, t, r, i, d, c || null, f, u, s, o + 1) : t.isText ? new Dl(e, t, r, i, d, f, s) : new Ur(e, t, r, i, d, c || null, f, s, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let r = this.children[t];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => re.empty);
    }
    return e;
  }
  matchesNode(e, t, r) {
    return this.dirty == Sn && e.eq(this.node) && Ra(t, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, t) {
    let r = this.node.inlineContent, i = t, s = e.composing ? this.localCompositionInfo(e, t) : null, o = s && s.pos > -1 ? s : null, a = s && s.pos < 0, l = new I$(this, o && o.node, e);
    V$(this.node, this.innerDeco, (u, d, c) => {
      u.spec.marks ? l.syncToMarks(u.spec.marks, r, e) : u.type.side >= 0 && !c && l.syncToMarks(d == this.node.childCount ? Ge.none : this.node.child(d).marks, r, e), l.placeWidget(u, e, i);
    }, (u, d, c, f) => {
      l.syncToMarks(u.marks, r, e);
      let p;
      l.findNodeMatch(u, d, c, f) || a && e.state.selection.from > i && e.state.selection.to < i + u.nodeSize && (p = l.findIndexWithChild(s.node)) > -1 && l.updateNodeAt(u, d, c, p, e) || l.updateNextNode(u, d, c, e, f, i) || l.addNode(u, d, c, e, i), i += u.nodeSize;
    }), l.syncToMarks([], r, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == ai) && (o && this.protectLocalComposition(e, o), wh(this.contentDOM, this.children, e), cs && F$(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: r, to: i } = e.state.selection;
    if (!(e.state.selection instanceof Ce) || r < t || i > t + this.node.content.size)
      return null;
    let s = e.input.compositionNode;
    if (!s || !this.dom.contains(s.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = s.nodeValue, a = j$(this.node.content, o, r - t, i - t);
      return a < 0 ? null : { node: s, pos: a, text: o };
    } else
      return { node: s, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: r, text: i }) {
    if (this.getDesc(t))
      return;
    let s = t;
    for (; s.parentNode != this.contentDOM; s = s.parentNode) {
      for (; s.previousSibling; )
        s.parentNode.removeChild(s.previousSibling);
      for (; s.nextSibling; )
        s.parentNode.removeChild(s.nextSibling);
      s.pmViewDesc && (s.pmViewDesc = void 0);
    }
    let o = new L$(this, s, t, i);
    e.input.compositionNodes.push(o), this.children = Ed(this.children, r, r + i.length, e, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, t, r, i) {
    return this.dirty == Zn || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, r, i), !0);
  }
  updateInner(e, t, r, i) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = Sn;
  }
  updateOuterDeco(e) {
    if (Ra(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = kh(this.dom, this.nodeDOM, Sd(this.outerDeco, this.node, t), Sd(e, this.node, t)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function Hc(n, e, t, r, i) {
  Ch(r, e, n);
  let s = new Ur(void 0, n, e, t, r, r, r, i, 0);
  return s.contentDOM && s.updateChildren(i, 0), s;
}
class Dl extends Ur {
  constructor(e, t, r, i, s, o, a) {
    super(e, t, r, i, s, null, o, a, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, r, i) {
    return this.dirty == Zn || this.dirty != Sn && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != Sn || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = e, this.dirty = Sn, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, r) {
    let i = this.node.cut(e, t), s = document.createTextNode(i.text);
    return new Dl(this.parent, i, this.outerDeco, this.innerDeco, s, s, r);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = Zn);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class xh extends Io {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == Sn && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class R$ extends Ur {
  constructor(e, t, r, i, s, o, a, l, u, d) {
    super(e, t, r, i, s, o, a, u, d), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, t, r, i) {
    if (this.dirty == Zn)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let s = this.spec.update(e, t, r);
      return s && this.updateInner(e, t, r, i), s;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, r, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, r, i) {
    this.spec.setSelection ? this.spec.setSelection(e, t, r.root) : super.setSelection(e, t, r, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function wh(n, e, t) {
  let r = n.firstChild, i = !1;
  for (let s = 0; s < e.length; s++) {
    let o = e[s], a = o.dom;
    if (a.parentNode == n) {
      for (; a != r; )
        r = Uc(r), i = !0;
      r = r.nextSibling;
    } else
      i = !0, n.insertBefore(a, r);
    if (o instanceof Ei) {
      let l = r ? r.previousSibling : n.lastChild;
      wh(o.contentDOM, o.children, t), r = l ? l.nextSibling : n.firstChild;
    }
  }
  for (; r; )
    r = Uc(r), i = !0;
  i && t.trackWrites == n && (t.trackWrites = null);
}
const Gs = function(n) {
  n && (this.nodeName = n);
};
Gs.prototype = /* @__PURE__ */ Object.create(null);
const li = [new Gs()];
function Sd(n, e, t) {
  if (n.length == 0)
    return li;
  let r = t ? li[0] : new Gs(), i = [r];
  for (let s = 0; s < n.length; s++) {
    let o = n[s].type.attrs;
    if (o) {
      o.nodeName && i.push(r = new Gs(o.nodeName));
      for (let a in o) {
        let l = o[a];
        l != null && (t && i.length == 1 && i.push(r = new Gs(e.isInline ? "span" : "div")), a == "class" ? r.class = (r.class ? r.class + " " : "") + l : a == "style" ? r.style = (r.style ? r.style + ";" : "") + l : a != "nodeName" && (r[a] = l));
      }
    }
  }
  return i;
}
function kh(n, e, t, r) {
  if (t == li && r == li)
    return e;
  let i = e;
  for (let s = 0; s < r.length; s++) {
    let o = r[s], a = t[s];
    if (s) {
      let l;
      a && a.nodeName == o.nodeName && i != n && (l = i.parentNode) && l.nodeName.toLowerCase() == o.nodeName || (l = document.createElement(o.nodeName), l.pmIsDeco = !0, l.appendChild(i), a = li[0]), i = l;
    }
    P$(i, a || li[0], o);
  }
  return i;
}
function P$(n, e, t) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in t) && n.removeAttribute(r);
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && t[r] != e[r] && n.setAttribute(r, t[r]);
  if (e.class != t.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], i = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let s = 0; s < r.length; s++)
      i.indexOf(r[s]) == -1 && n.classList.remove(r[s]);
    for (let s = 0; s < i.length; s++)
      r.indexOf(i[s]) == -1 && n.classList.add(i[s]);
    n.classList.length == 0 && n.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = r.exec(e.style); )
        n.style.removeProperty(i[1]);
    }
    t.style && (n.style.cssText += t.style);
  }
}
function Ch(n, e, t) {
  return kh(n, n, li, Sd(e, t, n.nodeType != 1));
}
function Ra(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function Uc(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class I$ {
  constructor(e, t, r) {
    this.lock = t, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = B$(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, t) {
    if (e != t) {
      for (let r = e; r < t; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, t, r) {
    let i = 0, s = this.stack.length >> 1, o = Math.min(s, e.length);
    for (; i < o && (i == s - 1 ? this.top : this.stack[i + 1 << 1]).matchesMark(e[i]) && e[i].type.spec.spanning !== !1; )
      i++;
    for (; i < s; )
      this.destroyRest(), this.top.dirty = Sn, this.index = this.stack.pop(), this.top = this.stack.pop(), s--;
    for (; s < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let a = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let u = this.top.children[l];
        if (u.matchesMark(e[s]) && !this.isLocked(u.dom)) {
          a = l;
          break;
        }
      }
      if (a > -1)
        a > this.index && (this.changed = !0, this.destroyBetween(this.index, a)), this.top = this.top.children[this.index];
      else {
        let l = Ei.create(this.top, e[s], t, r);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, s++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, t, r, i) {
    let s = -1, o;
    if (i >= this.preMatch.index && (o = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && o.matchesNode(e, t, r))
      s = this.top.children.indexOf(o, this.index);
    else
      for (let a = this.index, l = Math.min(this.top.children.length, a + 5); a < l; a++) {
        let u = this.top.children[a];
        if (u.matchesNode(e, t, r) && !this.preMatch.matched.has(u)) {
          s = a;
          break;
        }
      }
    return s < 0 ? !1 : (this.destroyBetween(this.index, s), this.index++, !0);
  }
  updateNodeAt(e, t, r, i, s) {
    let o = this.top.children[i];
    return o.dirty == Zn && o.dom == o.contentDOM && (o.dirty = ai), o.update(e, t, r, s) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == r)
              return i;
        }
        return -1;
      }
      e = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, t, r, i, s, o) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let l = this.top.children[a];
      if (l instanceof Ur) {
        let u = this.preMatch.matched.get(l);
        if (u != null && u != s)
          return !1;
        let d = l.dom, c, f = this.isLocked(d) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != Zn && Ra(t, l.outerDeco));
        if (!f && l.update(e, t, r, i))
          return this.destroyBetween(this.index, a), l.dom != d && (this.changed = !0), this.index++, !0;
        if (!f && (c = this.recreateWrapper(l, e, t, r, i, o)))
          return this.destroyBetween(this.index, a), this.top.children[this.index] = c, c.contentDOM && (c.dirty = ai, c.updateChildren(i, o + 1), c.dirty = Sn), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, t, r, i, s, o) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content) || !Ra(r, e.outerDeco) || !i.eq(e.innerDeco))
      return null;
    let a = Ur.create(this.top, t, r, i, s, o);
    if (a.contentDOM) {
      a.children = e.children, e.children = [];
      for (let l of a.children)
        l.parent = a;
    }
    return e.destroy(), a;
  }
  // Insert the node as a newly created node desc.
  addNode(e, t, r, i, s) {
    let o = Ur.create(this.top, e, t, r, i, s);
    o.contentDOM && o.updateChildren(i, s + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(e, t, r) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(e) && (e == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let s = new $h(this.top, e, t, r);
      this.top.children.splice(this.index++, 0, s), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof Ei; )
      t = e, e = t.children[t.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof Dl) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((qt || Bt) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let i = new xh(this.top, [], r, null);
      t != this.top ? t.children.push(i) : t.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function B$(n, e) {
  let t = e, r = t.children.length, i = n.childCount, s = /* @__PURE__ */ new Map(), o = [];
  e: for (; i > 0; ) {
    let a;
    for (; ; )
      if (r) {
        let u = t.children[r - 1];
        if (u instanceof Ei)
          t = u, r = u.children.length;
        else {
          a = u, r--;
          break;
        }
      } else {
        if (t == e)
          break e;
        r = t.parent.children.indexOf(t), t = t.parent;
      }
    let l = a.node;
    if (l) {
      if (l != n.child(i - 1))
        break;
      --i, s.set(a, i), o.push(a);
    }
  }
  return { index: i, matched: s, matches: o.reverse() };
}
function z$(n, e) {
  return n.type.side - e.type.side;
}
function V$(n, e, t, r) {
  let i = e.locals(n), s = 0;
  if (i.length == 0) {
    for (let u = 0; u < n.childCount; u++) {
      let d = n.child(u);
      r(d, i, e.forChild(s, d), u), s += d.nodeSize;
    }
    return;
  }
  let o = 0, a = [], l = null;
  for (let u = 0; ; ) {
    let d, c;
    for (; o < i.length && i[o].to == s; ) {
      let g = i[o++];
      g.widget && (d ? (c || (c = [d])).push(g) : d = g);
    }
    if (d)
      if (c) {
        c.sort(z$);
        for (let g = 0; g < c.length; g++)
          t(c[g], u, !!l);
      } else
        t(d, u, !!l);
    let f, p;
    if (l)
      p = -1, f = l, l = null;
    else if (u < n.childCount)
      p = u, f = n.child(u++);
    else
      break;
    for (let g = 0; g < a.length; g++)
      a[g].to <= s && a.splice(g--, 1);
    for (; o < i.length && i[o].from <= s && i[o].to > s; )
      a.push(i[o++]);
    let h = s + f.nodeSize;
    if (f.isText) {
      let g = h;
      o < i.length && i[o].from < g && (g = i[o].from);
      for (let m = 0; m < a.length; m++)
        a[m].to < g && (g = a[m].to);
      g < h && (l = f.cut(g - s), f = f.cut(0, g - s), h = g, p = -1);
    } else
      for (; o < i.length && i[o].to < h; )
        o++;
    let y = f.isInline && !f.isLeaf ? a.filter((g) => !g.inline) : a.slice();
    r(f, y, e.forChild(s, f), p), s = h;
  }
}
function F$(n) {
  if (n.nodeName == "UL" || n.nodeName == "OL") {
    let e = n.style.cssText;
    n.style.cssText = e + "; list-style: square !important", window.getComputedStyle(n).listStyle, n.style.cssText = e;
  }
}
function j$(n, e, t, r) {
  for (let i = 0, s = 0; i < n.childCount && s <= r; ) {
    let o = n.child(i++), a = s;
    if (s += o.nodeSize, !o.isText)
      continue;
    let l = o.text;
    for (; i < n.childCount; ) {
      let u = n.child(i++);
      if (s += u.nodeSize, !u.isText)
        break;
      l += u.text;
    }
    if (s >= t) {
      if (s >= r && l.slice(r - e.length - a, r - a) == e)
        return r - e.length;
      let u = a < r ? l.lastIndexOf(e, r - a - 1) : -1;
      if (u >= 0 && u + e.length + a >= t)
        return a + u;
      if (t == r && l.length >= r + e.length - a && l.slice(r - a, r - a + e.length) == e)
        return r;
    }
  }
  return -1;
}
function Ed(n, e, t, r, i) {
  let s = [];
  for (let o = 0, a = 0; o < n.length; o++) {
    let l = n[o], u = a, d = a += l.size;
    u >= t || d <= e ? s.push(l) : (u < e && s.push(l.slice(0, e - u, r)), i && (s.push(i), i = void 0), d > t && s.push(l.slice(t - u, l.size, r)));
  }
  return s;
}
function M1(n, e = null) {
  let t = n.domSelectionRange(), r = n.state.doc;
  if (!t.focusNode)
    return null;
  let i = n.docView.nearestDesc(t.focusNode), s = i && i.size == 0, o = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (o < 0)
    return null;
  let a = r.resolve(o), l, u;
  if (Nl(t)) {
    for (l = o; i && !i.node; )
      i = i.parent;
    let c = i.node;
    if (i && c.isAtom && ve.isSelectable(c) && i.parent && !(c.isInline && h$(t.focusNode, t.focusOffset, i.dom))) {
      let f = i.posBefore;
      u = new ve(o == f ? a : r.resolve(f));
    }
  } else {
    if (t instanceof n.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let c = o, f = o;
      for (let p = 0; p < t.rangeCount; p++) {
        let h = t.getRangeAt(p);
        c = Math.min(c, n.docView.posFromDOM(h.startContainer, h.startOffset, 1)), f = Math.max(f, n.docView.posFromDOM(h.endContainer, h.endOffset, -1));
      }
      if (c < 0)
        return null;
      [l, o] = f == n.state.selection.anchor ? [f, c] : [c, f], a = r.resolve(o);
    } else
      l = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let d = r.resolve(l);
  if (!u) {
    let c = e == "pointer" || n.state.selection.head < a.pos && !s ? 1 : -1;
    u = A1(n, d, a, c);
  }
  return u;
}
function Sh(n) {
  return n.editable ? n.hasFocus() : Th(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function cr(n, e = !1) {
  let t = n.state.selection;
  if (Eh(n, t), !!Sh(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && Bt) {
      let r = n.domSelectionRange(), i = n.domObserver.currentSelection;
      if (r.anchorNode && i.anchorNode && Si(r.anchorNode, r.anchorOffset, i.anchorNode, i.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      U$(n);
    else {
      let { anchor: r, head: i } = t, s, o;
      Wc && !(t instanceof Ce) && (t.$from.parent.inlineContent || (s = qc(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (o = qc(n, t.to))), n.docView.setSelection(r, i, n, e), Wc && (s && Kc(s), o && Kc(o)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && H$(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const Wc = qt || Bt && hh < 63;
function qc(n, e) {
  let { node: t, offset: r } = n.docView.domFromPos(e, 0), i = r < t.childNodes.length ? t.childNodes[r] : null, s = r ? t.childNodes[r - 1] : null;
  if (qt && i && i.contentEditable == "false")
    return _u(i);
  if ((!i || i.contentEditable == "false") && (!s || s.contentEditable == "false")) {
    if (i)
      return _u(i);
    if (s)
      return _u(s);
  }
}
function _u(n) {
  return n.contentEditable = "true", qt && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function Kc(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function H$(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), r = t.anchorNode, i = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != r || t.anchorOffset != i) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!Sh(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function U$(n) {
  let e = n.domSelection(), t = document.createRange();
  if (!e)
    return;
  let r = n.cursorWrapper.dom, i = r.nodeName == "IMG";
  i ? t.setStart(r.parentNode, At(r) + 1) : t.setStart(r, 0), t.collapse(!0), e.removeAllRanges(), e.addRange(t), !i && !n.state.selection.visible && en && Hr <= 11 && (r.disabled = !0, r.disabled = !1);
}
function Eh(n, e) {
  if (e instanceof ve) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (Gc(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    Gc(n);
}
function Gc(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function A1(n, e, t, r) {
  return n.someProp("createSelectionBetween", (i) => i(n, e, t)) || Ce.between(e, t, r);
}
function Yc(n) {
  return n.editable && !n.hasFocus() ? !1 : Th(n);
}
function Th(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function W$(n) {
  let e = n.docView.domFromPos(n.state.selection.anchor, 0), t = n.domSelectionRange();
  return Si(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function Td(n, e) {
  let { $anchor: t, $head: r } = n.selection, i = e > 0 ? t.max(r) : t.min(r), s = i.parent.inlineContent ? i.depth ? n.doc.resolve(e > 0 ? i.after() : i.before()) : null : i;
  return s && Oe.findFrom(s, e);
}
function Mr(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function Jc(n, e, t) {
  let r = n.state.selection;
  if (r instanceof Ce)
    if (t.indexOf("s") > -1) {
      let { $head: i } = r, s = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter;
      if (!s || s.isText || !s.isLeaf)
        return !1;
      let o = n.state.doc.resolve(i.pos + s.nodeSize * (e < 0 ? -1 : 1));
      return Mr(n, new Ce(r.$anchor, o));
    } else if (r.empty) {
      if (n.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let i = Td(n.state, e);
        return i && i instanceof ve ? Mr(n, i) : !1;
      } else if (!($n && t.indexOf("m") > -1)) {
        let i = r.$head, s = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter, o;
        if (!s || s.isText)
          return !1;
        let a = e < 0 ? i.pos - s.nodeSize : i.pos;
        return s.isAtom || (o = n.docView.descAt(a)) && !o.contentDOM ? ve.isSelectable(s) ? Mr(n, new ve(e < 0 ? n.state.doc.resolve(i.pos - s.nodeSize) : i)) : Po ? Mr(n, new Ce(n.state.doc.resolve(e < 0 ? a : a + s.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof ve && r.node.isInline)
      return Mr(n, new Ce(e > 0 ? r.$to : r.$from));
    {
      let i = Td(n.state, e);
      return i ? Mr(n, i) : !1;
    }
  }
}
function Pa(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function Ys(n, e) {
  let t = n.pmViewDesc;
  return t && t.size == 0 && (e < 0 || n.nextSibling || n.nodeName != "BR");
}
function Ri(n, e) {
  return e < 0 ? q$(n) : K$(n);
}
function q$(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let i, s, o = !1;
  for (Pn && t.nodeType == 1 && r < Pa(t) && Ys(t.childNodes[r], -1) && (o = !0); ; )
    if (r > 0) {
      if (t.nodeType != 1)
        break;
      {
        let a = t.childNodes[r - 1];
        if (Ys(a, -1))
          i = t, s = --r;
        else if (a.nodeType == 3)
          t = a, r = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (Oh(t))
        break;
      {
        let a = t.previousSibling;
        for (; a && Ys(a, -1); )
          i = t.parentNode, s = At(a), a = a.previousSibling;
        if (a)
          t = a, r = Pa(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = 0;
        }
      }
    }
  o ? Od(n, t, r) : i && Od(n, i, s);
}
function K$(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let i = Pa(t), s, o;
  for (; ; )
    if (r < i) {
      if (t.nodeType != 1)
        break;
      let a = t.childNodes[r];
      if (Ys(a, 1))
        s = t, o = ++r;
      else
        break;
    } else {
      if (Oh(t))
        break;
      {
        let a = t.nextSibling;
        for (; a && Ys(a, 1); )
          s = a.parentNode, o = At(a) + 1, a = a.nextSibling;
        if (a)
          t = a, r = 0, i = Pa(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = i = 0;
        }
      }
    }
  s && Od(n, s, o);
}
function Oh(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function G$(n, e) {
  for (; n && e == n.childNodes.length && !Ro(n); )
    e = At(n) + 1, n = n.parentNode;
  for (; n && e < n.childNodes.length; ) {
    let t = n.childNodes[e];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = 0;
  }
}
function Y$(n, e) {
  for (; n && !e && !Ro(n); )
    e = At(n), n = n.parentNode;
  for (; n && e; ) {
    let t = n.childNodes[e - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = n.childNodes.length;
  }
}
function Od(n, e, t) {
  if (e.nodeType != 3) {
    let s, o;
    (o = G$(e, t)) ? (e = o, t = 0) : (s = Y$(e, t)) && (e = s, t = s.nodeValue.length);
  }
  let r = n.domSelection();
  if (!r)
    return;
  if (Nl(r)) {
    let s = document.createRange();
    s.setEnd(e, t), s.setStart(e, t), r.removeAllRanges(), r.addRange(s);
  } else r.extend && r.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: i } = n;
  setTimeout(() => {
    n.state == i && cr(n);
  }, 50);
}
function Zc(n, e) {
  let t = n.state.doc.resolve(e);
  if (!(Bt || b$) && t.parent.inlineContent) {
    let i = n.coordsAtPos(e);
    if (e > t.start()) {
      let s = n.coordsAtPos(e - 1), o = (s.top + s.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(s.left - i.left) > 1)
        return s.left < i.left ? "ltr" : "rtl";
    }
    if (e < t.end()) {
      let s = n.coordsAtPos(e + 1), o = (s.top + s.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(s.left - i.left) > 1)
        return s.left > i.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(n.dom).direction == "rtl" ? "rtl" : "ltr";
}
function Xc(n, e, t) {
  let r = n.state.selection;
  if (r instanceof Ce && !r.empty || t.indexOf("s") > -1 || $n && t.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: s } = r;
  if (!i.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let o = Td(n.state, e);
    if (o && o instanceof ve)
      return Mr(n, o);
  }
  if (!i.parent.inlineContent) {
    let o = e < 0 ? i : s, a = r instanceof Cn ? Oe.near(o, e) : Oe.findFrom(o, e);
    return a ? Mr(n, a) : !1;
  }
  return !1;
}
function Qc(n, e) {
  if (!(n.state.selection instanceof Ce))
    return !0;
  let { $head: t, $anchor: r, empty: i } = n.state.selection;
  if (!t.sameParent(r))
    return !0;
  if (!i)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let s = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (s && !s.isText) {
    let o = n.state.tr;
    return e < 0 ? o.delete(t.pos - s.nodeSize, t.pos) : o.delete(t.pos, t.pos + s.nodeSize), n.dispatch(o), !0;
  }
  return !1;
}
function ef(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function J$(n) {
  if (!qt || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    ef(n, r, "true"), setTimeout(() => ef(n, r, "false"), 20);
  }
  return !1;
}
function Z$(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function X$(n, e) {
  let t = e.keyCode, r = Z$(e);
  if (t == 8 || $n && t == 72 && r == "c")
    return Qc(n, -1) || Ri(n, -1);
  if (t == 46 && !e.shiftKey || $n && t == 68 && r == "c")
    return Qc(n, 1) || Ri(n, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || $n && t == 66 && r == "c") {
    let i = t == 37 ? Zc(n, n.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return Jc(n, i, r) || Ri(n, i);
  } else if (t == 39 || $n && t == 70 && r == "c") {
    let i = t == 39 ? Zc(n, n.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return Jc(n, i, r) || Ri(n, i);
  } else {
    if (t == 38 || $n && t == 80 && r == "c")
      return Xc(n, -1, r) || Ri(n, -1);
    if (t == 40 || $n && t == 78 && r == "c")
      return J$(n) || Xc(n, 1, r) || Ri(n, 1);
    if (r == ($n ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function N1(n, e) {
  n.someProp("transformCopied", (p) => {
    e = p(e, n);
  });
  let t = [], { content: r, openStart: i, openEnd: s } = e;
  for (; i > 1 && s > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    i--, s--;
    let p = r.firstChild;
    t.push(p.type.name, p.attrs != p.type.defaultAttrs ? p.attrs : null), r = p.content;
  }
  let o = n.someProp("clipboardSerializer") || Gr.fromSchema(n.state.schema), a = Rh(), l = a.createElement("div");
  l.appendChild(o.serializeFragment(r, { document: a }));
  let u = l.firstChild, d, c = 0;
  for (; u && u.nodeType == 1 && (d = Lh[u.nodeName.toLowerCase()]); ) {
    for (let p = d.length - 1; p >= 0; p--) {
      let h = a.createElement(d[p]);
      for (; l.firstChild; )
        h.appendChild(l.firstChild);
      l.appendChild(h), c++;
    }
    u = l.firstChild;
  }
  u && u.nodeType == 1 && u.setAttribute("data-pm-slice", `${i} ${s}${c ? ` -${c}` : ""} ${JSON.stringify(t)}`);
  let f = n.someProp("clipboardTextSerializer", (p) => p(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: f, slice: e };
}
function Mh(n, e, t, r, i) {
  let s = i.parent.type.spec.code, o, a;
  if (!t && !e)
    return null;
  let l = e && (r || s || !t);
  if (l) {
    if (n.someProp("transformPastedText", (f) => {
      e = f(e, s || r, n);
    }), s)
      return e ? new de(re.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : de.empty;
    let c = n.someProp("clipboardTextParser", (f) => f(e, i, r, n));
    if (c)
      a = c;
    else {
      let f = i.marks(), { schema: p } = n.state, h = Gr.fromSchema(p);
      o = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((y) => {
        let g = o.appendChild(document.createElement("p"));
        y && g.appendChild(h.serializeNode(p.text(y, f)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (c) => {
      t = c(t, n);
    }), o = nx(t), Po && rx(o);
  let u = o && o.querySelector("[data-pm-slice]"), d = u && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(u.getAttribute("data-pm-slice") || "");
  if (d && d[3])
    for (let c = +d[3]; c > 0; c--) {
      let f = o.firstChild;
      for (; f && f.nodeType != 1; )
        f = f.nextSibling;
      if (!f)
        break;
      o = f;
    }
  if (a || (a = (n.someProp("clipboardParser") || n.someProp("domParser") || jr.fromSchema(n.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(l || d),
    context: i,
    ruleFromNode(f) {
      return f.nodeName == "BR" && !f.nextSibling && f.parentNode && !Q$.test(f.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), d)
    a = ix(tf(a, +d[1], +d[2]), d[4]);
  else if (a = de.maxOpen(ex(a.content, i), !0), a.openStart || a.openEnd) {
    let c = 0, f = 0;
    for (let p = a.content.firstChild; c < a.openStart && !p.type.spec.isolating; c++, p = p.firstChild)
      ;
    for (let p = a.content.lastChild; f < a.openEnd && !p.type.spec.isolating; f++, p = p.lastChild)
      ;
    a = tf(a, c, f);
  }
  return n.someProp("transformPasted", (c) => {
    a = c(a, n);
  }), a;
}
const Q$ = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function ex(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let i = e.node(t).contentMatchAt(e.index(t)), s, o = [];
    if (n.forEach((a) => {
      if (!o)
        return;
      let l = i.findWrapping(a.type), u;
      if (!l)
        return o = null;
      if (u = o.length && s.length && Nh(l, s, a, o[o.length - 1], 0))
        o[o.length - 1] = u;
      else {
        o.length && (o[o.length - 1] = Dh(o[o.length - 1], s.length));
        let d = Ah(a, l);
        o.push(d), i = i.matchType(d.type), s = l;
      }
    }), o)
      return re.from(o);
  }
  return n;
}
function Ah(n, e, t = 0) {
  for (let r = e.length - 1; r >= t; r--)
    n = e[r].create(null, re.from(n));
  return n;
}
function Nh(n, e, t, r, i) {
  if (i < n.length && i < e.length && n[i] == e[i]) {
    let s = Nh(n, e, t, r.lastChild, i + 1);
    if (s)
      return r.copy(r.content.replaceChild(r.childCount - 1, s));
    if (r.contentMatchAt(r.childCount).matchType(i == n.length - 1 ? t.type : n[i + 1]))
      return r.copy(r.content.append(re.from(Ah(t, n, i + 1))));
  }
}
function Dh(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, Dh(n.lastChild, e - 1)), r = n.contentMatchAt(n.childCount).fillBefore(re.empty, !0);
  return n.copy(t.append(r));
}
function Md(n, e, t, r, i, s) {
  let o = e < 0 ? n.firstChild : n.lastChild, a = o.content;
  return n.childCount > 1 && (s = 0), i < r - 1 && (a = Md(a, e, t, r, i + 1, s)), i >= t && (a = e < 0 ? o.contentMatchAt(0).fillBefore(a, s <= i).append(a) : a.append(o.contentMatchAt(o.childCount).fillBefore(re.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, o.copy(a));
}
function tf(n, e, t) {
  return e < n.openStart && (n = new de(Md(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new de(Md(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const Lh = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let nf = null;
function Rh() {
  return nf || (nf = document.implementation.createHTMLDocument("title"));
}
let $u = null;
function tx(n) {
  let e = window.trustedTypes;
  return e ? ($u || ($u = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), $u.createHTML(n)) : n;
}
function nx(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = Rh().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(n), i;
  if ((i = r && Lh[r[1].toLowerCase()]) && (n = i.map((s) => "<" + s + ">").join("") + n + i.map((s) => "</" + s + ">").reverse().join("")), t.innerHTML = tx(n), i)
    for (let s = 0; s < i.length; s++)
      t = t.querySelector(i[s]) || t;
  return t;
}
function rx(n) {
  let e = n.querySelectorAll(Bt ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), r);
  }
}
function ix(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: i, openStart: s, openEnd: o } = n;
  for (let a = r.length - 2; a >= 0; a -= 2) {
    let l = t.nodes[r[a]];
    if (!l || l.hasRequiredAttrs())
      break;
    i = re.from(l.create(r[a + 1], i)), s++, o++;
  }
  return new de(i, s, o);
}
const Kt = {}, Gt = {}, sx = { touchstart: !0, touchmove: !0 };
class ox {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function ax(n) {
  for (let e in Kt) {
    let t = Kt[e];
    n.dom.addEventListener(e, n.input.eventHandlers[e] = (r) => {
      ux(n, r) && !D1(n, r) && (n.editable || !(r.type in Gt)) && t(n, r);
    }, sx[e] ? { passive: !0 } : void 0);
  }
  qt && n.dom.addEventListener("input", () => null), Ad(n);
}
function Br(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
function lx(n) {
  n.domObserver.stop();
  for (let e in n.input.eventHandlers)
    n.dom.removeEventListener(e, n.input.eventHandlers[e]);
  clearTimeout(n.input.composingTimeout), clearTimeout(n.input.lastIOSEnterFallbackTimeout);
}
function Ad(n) {
  n.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      n.input.eventHandlers[t] || n.dom.addEventListener(t, n.input.eventHandlers[t] = (r) => D1(n, r));
  });
}
function D1(n, e) {
  return n.someProp("handleDOMEvents", (t) => {
    let r = t[e.type];
    return r ? r(n, e) || e.defaultPrevented : !1;
  });
}
function ux(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != n.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function dx(n, e) {
  !D1(n, e) && Kt[e.type] && (n.editable || !(e.type in Gt)) && Kt[e.type](n, e);
}
Gt.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !Ih(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(ur && Bt && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), cs && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let r = Date.now();
      n.input.lastIOSEnter = r, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == r && (n.someProp("handleKeyDown", (i) => i(n, si(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else n.someProp("handleKeyDown", (r) => r(n, t)) || X$(n, t) ? t.preventDefault() : Br(n, "key");
};
Gt.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
Gt.keypress = (n, e) => {
  let t = e;
  if (Ih(n, t) || !t.charCode || t.ctrlKey && !t.altKey || $n && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (i) => i(n, t))) {
    t.preventDefault();
    return;
  }
  let r = n.state.selection;
  if (!(r instanceof Ce) || !r.$from.sameParent(r.$to)) {
    let i = String.fromCharCode(t.charCode);
    !/[\r\n]/.test(i) && !n.someProp("handleTextInput", (s) => s(n, r.$from.pos, r.$to.pos, i)) && n.dispatch(n.state.tr.insertText(i).scrollIntoView()), t.preventDefault();
  }
};
function Ll(n) {
  return { left: n.clientX, top: n.clientY };
}
function cx(n, e) {
  let t = e.x - n.clientX, r = e.y - n.clientY;
  return t * t + r * r < 100;
}
function L1(n, e, t, r, i) {
  if (r == -1)
    return !1;
  let s = n.state.doc.resolve(r);
  for (let o = s.depth + 1; o > 0; o--)
    if (n.someProp(e, (a) => o > s.depth ? a(n, t, s.nodeAfter, s.before(o), i, !0) : a(n, t, s.node(o), s.before(o), i, !1)))
      return !0;
  return !1;
}
function ns(n, e, t) {
  if (n.focused || n.focus(), n.state.selection.eq(e))
    return;
  let r = n.state.tr.setSelection(e);
  r.setMeta("pointer", !0), n.dispatch(r);
}
function fx(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), r = t.nodeAfter;
  return r && r.isAtom && ve.isSelectable(r) ? (ns(n, new ve(t)), !0) : !1;
}
function px(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, r, i;
  t instanceof ve && (r = t.node);
  let s = n.state.doc.resolve(e);
  for (let o = s.depth + 1; o > 0; o--) {
    let a = o > s.depth ? s.nodeAfter : s.node(o);
    if (ve.isSelectable(a)) {
      r && t.$from.depth > 0 && o >= t.$from.depth && s.before(t.$from.depth + 1) == t.$from.pos ? i = s.before(t.$from.depth) : i = s.before(o);
      break;
    }
  }
  return i != null ? (ns(n, ve.create(n.state.doc, i)), !0) : !1;
}
function hx(n, e, t, r, i) {
  return L1(n, "handleClickOn", e, t, r) || n.someProp("handleClick", (s) => s(n, e, r)) || (i ? px(n, t) : fx(n, t));
}
function mx(n, e, t, r) {
  return L1(n, "handleDoubleClickOn", e, t, r) || n.someProp("handleDoubleClick", (i) => i(n, e, r));
}
function gx(n, e, t, r) {
  return L1(n, "handleTripleClickOn", e, t, r) || n.someProp("handleTripleClick", (i) => i(n, e, r)) || bx(n, t, r);
}
function bx(n, e, t) {
  if (t.button != 0)
    return !1;
  let r = n.state.doc;
  if (e == -1)
    return r.inlineContent ? (ns(n, Ce.create(r, 0, r.content.size)), !0) : !1;
  let i = r.resolve(e);
  for (let s = i.depth + 1; s > 0; s--) {
    let o = s > i.depth ? i.nodeAfter : i.node(s), a = i.before(s);
    if (o.inlineContent)
      ns(n, Ce.create(r, a + 1, a + 1 + o.content.size));
    else if (ve.isSelectable(o))
      ns(n, ve.create(r, a));
    else
      continue;
    return !0;
  }
}
function R1(n) {
  return Ia(n);
}
const Ph = $n ? "metaKey" : "ctrlKey";
Kt.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let r = R1(n), i = Date.now(), s = "singleClick";
  i - n.input.lastClick.time < 500 && cx(t, n.input.lastClick) && !t[Ph] && (n.input.lastClick.type == "singleClick" ? s = "doubleClick" : n.input.lastClick.type == "doubleClick" && (s = "tripleClick")), n.input.lastClick = { time: i, x: t.clientX, y: t.clientY, type: s };
  let o = n.posAtCoords(Ll(t));
  o && (s == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new yx(n, o, t, !!r)) : (s == "doubleClick" ? mx : gx)(n, o.pos, o.inside, t) ? t.preventDefault() : Br(n, "pointer"));
};
class yx {
  constructor(e, t, r, i) {
    this.view = e, this.pos = t, this.event = r, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[Ph], this.allowDefault = r.shiftKey;
    let s, o;
    if (t.inside > -1)
      s = e.state.doc.nodeAt(t.inside), o = t.inside;
    else {
      let d = e.state.doc.resolve(t.pos);
      s = d.parent, o = d.depth ? d.before() : 0;
    }
    const a = i ? null : r.target, l = a ? e.docView.nearestDesc(a, !0) : null;
    this.target = l && l.dom.nodeType == 1 ? l.dom : null;
    let { selection: u } = e.state;
    (r.button == 0 && s.type.spec.draggable && s.type.spec.selectable !== !1 || u instanceof ve && u.from <= o && u.to > o) && (this.mightDrag = {
      node: s,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Pn && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), Br(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => cr(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(Ll(e))), this.updateAllowDefault(e), this.allowDefault || !t ? Br(this.view, "pointer") : hx(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    qt && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Bt && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (ns(this.view, Oe.near(this.view.state.doc.resolve(t.pos))), e.preventDefault()) : Br(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), Br(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
Kt.touchstart = (n) => {
  n.input.lastTouch = Date.now(), R1(n), Br(n, "pointer");
};
Kt.touchmove = (n) => {
  n.input.lastTouch = Date.now(), Br(n, "pointer");
};
Kt.contextmenu = (n) => R1(n);
function Ih(n, e) {
  return n.composing ? !0 : qt && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const vx = ur ? 5e3 : -1;
Gt.compositionstart = Gt.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$to;
    if (e.selection instanceof Ce && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      n.markCursor = n.state.storedMarks || t.marks(), Ia(n, !0), n.markCursor = null;
    else if (Ia(n, !e.selection.empty), Pn && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let r = n.domSelectionRange();
      for (let i = r.focusNode, s = r.focusOffset; i && i.nodeType == 1 && s != 0; ) {
        let o = s < 0 ? i.lastChild : i.childNodes[s - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let a = n.domSelection();
          a && a.collapse(o, o.nodeValue.length);
          break;
        } else
          i = o, s = -1;
      }
    }
    n.input.composing = !0;
  }
  Bh(n, vx);
};
Gt.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, n.input.compositionPendingChanges = n.domObserver.pendingRecords().length ? n.input.compositionID : 0, n.input.compositionNode = null, n.input.compositionPendingChanges && Promise.resolve().then(() => n.domObserver.flush()), n.input.compositionID++, Bh(n, 20));
};
function Bh(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => Ia(n), e));
}
function zh(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = $x()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function _x(n) {
  let e = n.domSelectionRange();
  if (!e.focusNode)
    return null;
  let t = f$(e.focusNode, e.focusOffset), r = p$(e.focusNode, e.focusOffset);
  if (t && r && t != r) {
    let i = r.pmViewDesc, s = n.domObserver.lastChangedTextNode;
    if (t == s || r == s)
      return s;
    if (!i || !i.isText(r.nodeValue))
      return r;
    if (n.input.compositionNode == r) {
      let o = t.pmViewDesc;
      if (!(!o || !o.isText(t.nodeValue)))
        return r;
    }
  }
  return t || r;
}
function $x() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function Ia(n, e = !1) {
  if (!(ur && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), zh(n), e || n.docView && n.docView.dirty) {
      let t = M1(n);
      return t && !t.eq(n.state.selection) ? n.dispatch(n.state.tr.setSelection(t)) : (n.markCursor || e) && !n.state.selection.empty ? n.dispatch(n.state.tr.deleteSelection()) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function xx(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), i = document.createRange();
  i.selectNodeContents(e), n.dom.blur(), r.removeAllRanges(), r.addRange(i), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const _o = en && Hr < 15 || cs && y$ < 604;
Kt.copy = Gt.cut = (n, e) => {
  let t = e, r = n.state.selection, i = t.type == "cut";
  if (r.empty)
    return;
  let s = _o ? null : t.clipboardData, o = r.content(), { dom: a, text: l } = N1(n, o);
  s ? (t.preventDefault(), s.clearData(), s.setData("text/html", a.innerHTML), s.setData("text/plain", l)) : xx(n, a), i && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function wx(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function kx(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, r = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let i = n.input.shiftKey && n.input.lastKeyCode != 45;
  setTimeout(() => {
    n.focus(), r.parentNode && r.parentNode.removeChild(r), t ? $o(n, r.value, null, i, e) : $o(n, r.textContent, r.innerHTML, i, e);
  }, 50);
}
function $o(n, e, t, r, i) {
  let s = Mh(n, e, t, r, n.state.selection.$from);
  if (n.someProp("handlePaste", (l) => l(n, i, s || de.empty)))
    return !0;
  if (!s)
    return !1;
  let o = wx(s), a = o ? n.state.tr.replaceSelectionWith(o, r) : n.state.tr.replaceSelection(s);
  return n.dispatch(a.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Vh(n) {
  let e = n.getData("text/plain") || n.getData("Text");
  if (e)
    return e;
  let t = n.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
Gt.paste = (n, e) => {
  let t = e;
  if (n.composing && !ur)
    return;
  let r = _o ? null : t.clipboardData, i = n.input.shiftKey && n.input.lastKeyCode != 45;
  r && $o(n, Vh(r), r.getData("text/html"), i, t) ? t.preventDefault() : kx(n, t);
};
class Fh {
  constructor(e, t, r) {
    this.slice = e, this.move = t, this.node = r;
  }
}
const Cx = $n ? "altKey" : "ctrlKey";
function jh(n, e) {
  let t = n.someProp("dragCopies", (r) => !r(e));
  return t ?? !e[Cx];
}
Kt.dragstart = (n, e) => {
  let t = e, r = n.input.mouseDown;
  if (r && r.done(), !t.dataTransfer)
    return;
  let i = n.state.selection, s = i.empty ? null : n.posAtCoords(Ll(t)), o;
  if (!(s && s.pos >= i.from && s.pos <= (i instanceof ve ? i.to - 1 : i.to))) {
    if (r && r.mightDrag)
      o = ve.create(n.state.doc, r.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let c = n.docView.nearestDesc(t.target, !0);
      c && c.node.type.spec.draggable && c != n.docView && (o = ve.create(n.state.doc, c.posBefore));
    }
  }
  let a = (o || n.state.selection).content(), { dom: l, text: u, slice: d } = N1(n, a);
  (!t.dataTransfer.files.length || !Bt || hh > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(_o ? "Text" : "text/html", l.innerHTML), t.dataTransfer.effectAllowed = "copyMove", _o || t.dataTransfer.setData("text/plain", u), n.dragging = new Fh(d, jh(n, t), o);
};
Kt.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
Gt.dragover = Gt.dragenter = (n, e) => e.preventDefault();
Gt.drop = (n, e) => {
  let t = e, r = n.dragging;
  if (n.dragging = null, !t.dataTransfer)
    return;
  let i = n.posAtCoords(Ll(t));
  if (!i)
    return;
  let s = n.state.doc.resolve(i.pos), o = r && r.slice;
  o ? n.someProp("transformPasted", (h) => {
    o = h(o, n);
  }) : o = Mh(n, Vh(t.dataTransfer), _o ? null : t.dataTransfer.getData("text/html"), !1, s);
  let a = !!(r && jh(n, t));
  if (n.someProp("handleDrop", (h) => h(n, t, o || de.empty, a))) {
    t.preventDefault();
    return;
  }
  if (!o)
    return;
  t.preventDefault();
  let l = o ? sh(n.state.doc, s.pos, o) : s.pos;
  l == null && (l = s.pos);
  let u = n.state.tr;
  if (a) {
    let { node: h } = r;
    h ? h.replace(u) : u.deleteSelection();
  }
  let d = u.mapping.map(l), c = o.openStart == 0 && o.openEnd == 0 && o.content.childCount == 1, f = u.doc;
  if (c ? u.replaceRangeWith(d, d, o.content.firstChild) : u.replaceRange(d, d, o), u.doc.eq(f))
    return;
  let p = u.doc.resolve(d);
  if (c && ve.isSelectable(o.content.firstChild) && p.nodeAfter && p.nodeAfter.sameMarkup(o.content.firstChild))
    u.setSelection(new ve(p));
  else {
    let h = u.mapping.map(l);
    u.mapping.maps[u.mapping.maps.length - 1].forEach((y, g, m, $) => h = $), u.setSelection(A1(n, p, u.doc.resolve(h)));
  }
  n.focus(), n.dispatch(u.setMeta("uiEvent", "drop"));
};
Kt.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && cr(n);
  }, 20));
};
Kt.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
Kt.beforeinput = (n, e) => {
  if (Bt && ur && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: r } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != r || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (s) => s(n, si(8, "Backspace")))))
        return;
      let { $cursor: i } = n.state.selection;
      i && i.pos > 0 && n.dispatch(n.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in Gt)
  Kt[n] = Gt[n];
function xo(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
class Ba {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || gi, this.side = this.spec.side || 0;
  }
  map(e, t, r, i) {
    let { pos: s, deleted: o } = e.mapResult(t.from + i, this.side < 0 ? -1 : 1);
    return o ? null : new kn(s - r, s - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof Ba && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && xo(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class Wr {
  constructor(e, t) {
    this.attrs = e, this.spec = t || gi;
  }
  map(e, t, r, i) {
    let s = e.map(t.from + i, this.spec.inclusiveStart ? -1 : 1) - r, o = e.map(t.to + i, this.spec.inclusiveEnd ? 1 : -1) - r;
    return s >= o ? null : new kn(s, o, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof Wr && xo(this.attrs, e.attrs) && xo(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof Wr;
  }
  destroy() {
  }
}
class P1 {
  constructor(e, t) {
    this.attrs = e, this.spec = t || gi;
  }
  map(e, t, r, i) {
    let s = e.mapResult(t.from + i, 1);
    if (s.deleted)
      return null;
    let o = e.mapResult(t.to + i, -1);
    return o.deleted || o.pos <= s.pos ? null : new kn(s.pos - r, o.pos - r, this);
  }
  valid(e, t) {
    let { index: r, offset: i } = e.content.findIndex(t.from), s;
    return i == t.from && !(s = e.child(r)).isText && i + s.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof P1 && xo(this.attrs, e.attrs) && xo(this.spec, e.spec);
  }
  destroy() {
  }
}
class kn {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.from = e, this.to = t, this.type = r;
  }
  /**
  @internal
  */
  copy(e, t) {
    return new kn(e, t, this.type);
  }
  /**
  @internal
  */
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  /**
  @internal
  */
  map(e, t, r) {
    return this.type.map(e, this, t, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, t, r) {
    return new kn(e, e, new Ba(t, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, t, r, i) {
    return new kn(e, t, new Wr(r, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, t, r, i) {
    return new kn(e, t, new P1(r, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Wr;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Ba;
  }
}
const Vi = [], gi = {};
class ht {
  /**
  @internal
  */
  constructor(e, t) {
    this.local = e.length ? e : Vi, this.children = t.length ? t : Vi;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, t) {
    return t.length ? za(t, e, 0, gi) : It;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, t, r) {
    let i = [];
    return this.findInner(e ?? 0, t ?? 1e9, i, 0, r), i;
  }
  findInner(e, t, r, i, s) {
    for (let o = 0; o < this.local.length; o++) {
      let a = this.local[o];
      a.from <= t && a.to >= e && (!s || s(a.spec)) && r.push(a.copy(a.from + i, a.to + i));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < t && this.children[o + 1] > e) {
        let a = this.children[o] + 1;
        this.children[o + 2].findInner(e - a, t - a, r, i + a, s);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, t, r) {
    return this == It || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, r || gi);
  }
  /**
  @internal
  */
  mapInner(e, t, r, i, s) {
    let o;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a].map(e, r, i);
      l && l.type.valid(t, l) ? (o || (o = [])).push(l) : s.onRemove && s.onRemove(this.local[a].spec);
    }
    return this.children.length ? Sx(this.children, o || [], e, t, r, i, s) : o ? new ht(o.sort(bi), Vi) : It;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, t) {
    return t.length ? this == It ? ht.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, r) {
    let i, s = 0;
    e.forEach((a, l) => {
      let u = l + r, d;
      if (d = Uh(t, a, u)) {
        for (i || (i = this.children.slice()); s < i.length && i[s] < l; )
          s += 3;
        i[s] == l ? i[s + 2] = i[s + 2].addInner(a, d, u + 1) : i.splice(s, 0, l, l + a.nodeSize, za(d, a, u + 1, gi)), s += 3;
      }
    });
    let o = Hh(s ? Wh(t) : t, -r);
    for (let a = 0; a < o.length; a++)
      o[a].type.valid(e, o[a]) || o.splice(a--, 1);
    return new ht(o.length ? this.local.concat(o).sort(bi) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == It ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let r = this.children, i = this.local;
    for (let s = 0; s < r.length; s += 3) {
      let o, a = r[s] + t, l = r[s + 1] + t;
      for (let d = 0, c; d < e.length; d++)
        (c = e[d]) && c.from > a && c.to < l && (e[d] = null, (o || (o = [])).push(c));
      if (!o)
        continue;
      r == this.children && (r = this.children.slice());
      let u = r[s + 2].removeInner(o, a + 1);
      u != It ? r[s + 2] = u : (r.splice(s, 3), s -= 3);
    }
    if (i.length) {
      for (let s = 0, o; s < e.length; s++)
        if (o = e[s])
          for (let a = 0; a < i.length; a++)
            i[a].eq(o, t) && (i == this.local && (i = this.local.slice()), i.splice(a--, 1));
    }
    return r == this.children && i == this.local ? this : i.length || r.length ? new ht(i, r) : It;
  }
  forChild(e, t) {
    if (this == It)
      return this;
    if (t.isLeaf)
      return ht.empty;
    let r, i;
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] >= e) {
        this.children[a] == e && (r = this.children[a + 2]);
        break;
      }
    let s = e + 1, o = s + t.content.size;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a];
      if (l.from < o && l.to > s && l.type instanceof Wr) {
        let u = Math.max(s, l.from) - s, d = Math.min(o, l.to) - s;
        u < d && (i || (i = [])).push(l.copy(u, d));
      }
    }
    if (i) {
      let a = new ht(i.sort(bi), Vi);
      return r ? new Dr([a, r]) : a;
    }
    return r || It;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof ht) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return I1(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == It)
      return Vi;
    if (e.inlineContent || !this.local.some(Wr.is))
      return this.local;
    let t = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof Wr || t.push(this.local[r]);
    return t;
  }
  forEachSet(e) {
    e(this);
  }
}
ht.empty = new ht([], []);
ht.removeOverlap = I1;
const It = ht.empty;
class Dr {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const r = this.members.map((i) => i.map(e, t, gi));
    return Dr.from(r);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return ht.empty;
    let r = [];
    for (let i = 0; i < this.members.length; i++) {
      let s = this.members[i].forChild(e, t);
      s != It && (s instanceof Dr ? r = r.concat(s.members) : r.push(s));
    }
    return Dr.from(r);
  }
  eq(e) {
    if (!(e instanceof Dr) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, r = !0;
    for (let i = 0; i < this.members.length; i++) {
      let s = this.members[i].localsInner(e);
      if (s.length)
        if (!t)
          t = s;
        else {
          r && (t = t.slice(), r = !1);
          for (let o = 0; o < s.length; o++)
            t.push(s[o]);
        }
    }
    return t ? I1(r ? t : t.sort(bi)) : Vi;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return It;
      case 1:
        return e[0];
      default:
        return new Dr(e.every((t) => t instanceof ht) ? e : e.reduce((t, r) => t.concat(r instanceof ht ? r : r.members), []));
    }
  }
  forEachSet(e) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(e);
  }
}
function Sx(n, e, t, r, i, s, o) {
  let a = n.slice();
  for (let u = 0, d = s; u < t.maps.length; u++) {
    let c = 0;
    t.maps[u].forEach((f, p, h, y) => {
      let g = y - h - (p - f);
      for (let m = 0; m < a.length; m += 3) {
        let $ = a[m + 1];
        if ($ < 0 || f > $ + d - c)
          continue;
        let w = a[m] + d - c;
        p >= w ? a[m + 1] = f <= w ? -2 : -1 : f >= d && g && (a[m] += g, a[m + 1] += g);
      }
      c += g;
    }), d = t.maps[u].map(d, -1);
  }
  let l = !1;
  for (let u = 0; u < a.length; u += 3)
    if (a[u + 1] < 0) {
      if (a[u + 1] == -2) {
        l = !0, a[u + 1] = -1;
        continue;
      }
      let d = t.map(n[u] + s), c = d - i;
      if (c < 0 || c >= r.content.size) {
        l = !0;
        continue;
      }
      let f = t.map(n[u + 1] + s, -1), p = f - i, { index: h, offset: y } = r.content.findIndex(c), g = r.maybeChild(h);
      if (g && y == c && y + g.nodeSize == p) {
        let m = a[u + 2].mapInner(t, g, d + 1, n[u] + s + 1, o);
        m != It ? (a[u] = c, a[u + 1] = p, a[u + 2] = m) : (a[u + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let u = Ex(a, n, e, t, i, s, o), d = za(u, r, 0, o);
    e = d.local;
    for (let c = 0; c < a.length; c += 3)
      a[c + 1] < 0 && (a.splice(c, 3), c -= 3);
    for (let c = 0, f = 0; c < d.children.length; c += 3) {
      let p = d.children[c];
      for (; f < a.length && a[f] < p; )
        f += 3;
      a.splice(f, 0, d.children[c], d.children[c + 1], d.children[c + 2]);
    }
  }
  return new ht(e.sort(bi), a);
}
function Hh(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let r = 0; r < n.length; r++) {
    let i = n[r];
    t.push(new kn(i.from + e, i.to + e, i.type));
  }
  return t;
}
function Ex(n, e, t, r, i, s, o) {
  function a(l, u) {
    for (let d = 0; d < l.local.length; d++) {
      let c = l.local[d].map(r, i, u);
      c ? t.push(c) : o.onRemove && o.onRemove(l.local[d].spec);
    }
    for (let d = 0; d < l.children.length; d += 3)
      a(l.children[d + 2], l.children[d] + u + 1);
  }
  for (let l = 0; l < n.length; l += 3)
    n[l + 1] == -1 && a(n[l + 2], e[l] + s + 1);
  return t;
}
function Uh(n, e, t) {
  if (e.isLeaf)
    return null;
  let r = t + e.nodeSize, i = null;
  for (let s = 0, o; s < n.length; s++)
    (o = n[s]) && o.from > t && o.to < r && ((i || (i = [])).push(o), n[s] = null);
  return i;
}
function Wh(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function za(n, e, t, r) {
  let i = [], s = !1;
  e.forEach((a, l) => {
    let u = Uh(n, a, l + t);
    if (u) {
      s = !0;
      let d = za(u, a, t + l + 1, r);
      d != It && i.push(l, l + a.nodeSize, d);
    }
  });
  let o = Hh(s ? Wh(n) : n, -t).sort(bi);
  for (let a = 0; a < o.length; a++)
    o[a].type.valid(e, o[a]) || (r.onRemove && r.onRemove(o[a].spec), o.splice(a--, 1));
  return o.length || i.length ? new ht(o, i) : It;
}
function bi(n, e) {
  return n.from - e.from || n.to - e.to;
}
function I1(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let r = e[t];
    if (r.from != r.to)
      for (let i = t + 1; i < e.length; i++) {
        let s = e[i];
        if (s.from == r.from) {
          s.to != r.to && (e == n && (e = n.slice()), e[i] = s.copy(s.from, r.to), rf(e, i + 1, s.copy(r.to, s.to)));
          continue;
        } else {
          s.from < r.to && (e == n && (e = n.slice()), e[t] = r.copy(r.from, s.from), rf(e, i, r.copy(s.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function rf(n, e, t) {
  for (; e < n.length && bi(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
function xu(n) {
  let e = [];
  return n.someProp("decorations", (t) => {
    let r = t(n.state);
    r && r != It && e.push(r);
  }), n.cursorWrapper && e.push(ht.create(n.state.doc, [n.cursorWrapper.deco])), Dr.from(e);
}
const Tx = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, Ox = en && Hr <= 11;
class Mx {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class Ax {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new Mx(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let i = 0; i < r.length; i++)
        this.queue.push(r[i]);
      en && Hr <= 11 && r.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), Ox && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, Tx)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (Yc(this.view)) {
      if (this.suppressingSelectionUpdates)
        return cr(this.view);
      if (en && Hr <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && Si(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), r;
    for (let s = e.focusNode; s; s = ds(s))
      t.add(s);
    for (let s = e.anchorNode; s; s = ds(s))
      if (t.has(s)) {
        r = s;
        break;
      }
    let i = r && this.view.docView.nearestDesc(r);
    if (i && i.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let r = e.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && Yc(e) && !this.ignoreSelectionChange(r), s = -1, o = -1, a = !1, l = [];
    if (e.editable)
      for (let d = 0; d < t.length; d++) {
        let c = this.registerMutation(t[d], l);
        c && (s = s < 0 ? c.from : Math.min(c.from, s), o = o < 0 ? c.to : Math.max(c.to, o), c.typeOver && (a = !0));
      }
    if (Pn && l.length) {
      let d = l.filter((c) => c.nodeName == "BR");
      if (d.length == 2) {
        let [c, f] = d;
        c.parentNode && c.parentNode.parentNode == f.parentNode ? f.remove() : c.remove();
      } else {
        let { focusNode: c } = this.currentSelection;
        for (let f of d) {
          let p = f.parentNode;
          p && p.nodeName == "LI" && (!c || Lx(e, c) != p) && f.remove();
        }
      }
    }
    let u = null;
    s < 0 && i && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && Nl(r) && (u = M1(e)) && u.eq(Oe.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, cr(e), this.currentSelection.set(r), e.scrollToSelection()) : (s > -1 || i) && (s > -1 && (e.docView.markDirty(s, o), Nx(e)), this.handleDOMChange(s, o, a, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || cr(e), this.currentSelection.set(r));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let d = 0; d < e.addedNodes.length; d++) {
        let c = e.addedNodes[d];
        t.push(c), c.nodeType == 3 && (this.lastChangedTextNode = c);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let i = e.previousSibling, s = e.nextSibling;
      if (en && Hr <= 11 && e.addedNodes.length)
        for (let d = 0; d < e.addedNodes.length; d++) {
          let { previousSibling: c, nextSibling: f } = e.addedNodes[d];
          (!c || Array.prototype.indexOf.call(e.addedNodes, c) < 0) && (i = c), (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (s = f);
        }
      let o = i && i.parentNode == e.target ? At(i) + 1 : 0, a = r.localPosFromDOM(e.target, o, -1), l = s && s.parentNode == e.target ? At(s) : e.target.childNodes.length, u = r.localPosFromDOM(e.target, l, 1);
      return { from: a, to: u };
    } else return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = e.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let sf = /* @__PURE__ */ new WeakMap(), of = !1;
function Nx(n) {
  if (!sf.has(n) && (sf.set(n, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(n.dom).whiteSpace) !== -1)) {
    if (n.requiresGeckoHackNode = Pn, of)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), of = !0;
  }
}
function af(n, e) {
  let t = e.startContainer, r = e.startOffset, i = e.endContainer, s = e.endOffset, o = n.domAtPos(n.state.selection.anchor);
  return Si(o.node, o.offset, i, s) && ([t, r, i, s] = [i, s, t, r]), { anchorNode: t, anchorOffset: r, focusNode: i, focusOffset: s };
}
function Dx(n, e) {
  if (e.getComposedRanges) {
    let i = e.getComposedRanges(n.root)[0];
    if (i)
      return af(n, i);
  }
  let t;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), t = i.getTargetRanges()[0];
  }
  return n.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), n.dom.removeEventListener("beforeinput", r, !0), t ? af(n, t) : null;
}
function Lx(n, e) {
  for (let t = e.parentNode; t && t != n.dom; t = t.parentNode) {
    let r = n.docView.nearestDesc(t, !0);
    if (r && r.node.isBlock)
      return t;
  }
  return null;
}
function Rx(n, e, t) {
  let { node: r, fromOffset: i, toOffset: s, from: o, to: a } = n.docView.parseRange(e, t), l = n.domSelectionRange(), u, d = l.anchorNode;
  if (d && n.dom.contains(d.nodeType == 1 ? d : d.parentNode) && (u = [{ node: d, offset: l.anchorOffset }], Nl(l) || u.push({ node: l.focusNode, offset: l.focusOffset })), Bt && n.input.lastKeyCode === 8)
    for (let g = s; g > i; g--) {
      let m = r.childNodes[g - 1], $ = m.pmViewDesc;
      if (m.nodeName == "BR" && !$) {
        s = g;
        break;
      }
      if (!$ || $.size)
        break;
    }
  let c = n.state.doc, f = n.someProp("domParser") || jr.fromSchema(n.state.schema), p = c.resolve(o), h = null, y = f.parse(r, {
    topNode: p.parent,
    topMatch: p.parent.contentMatchAt(p.index()),
    topOpen: !0,
    from: i,
    to: s,
    preserveWhitespace: p.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: u,
    ruleFromNode: Px,
    context: p
  });
  if (u && u[0].pos != null) {
    let g = u[0].pos, m = u[1] && u[1].pos;
    m == null && (m = g), h = { anchor: g + o, head: m + o };
  }
  return { doc: y, sel: h, from: o, to: a };
}
function Px(n) {
  let e = n.pmViewDesc;
  if (e)
    return e.parseRule();
  if (n.nodeName == "BR" && n.parentNode) {
    if (qt && /^(ul|ol)$/i.test(n.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (n.parentNode.lastChild == n || qt && /^(tr|table)$/i.test(n.parentNode.nodeName))
      return { ignore: !0 };
  } else if (n.nodeName == "IMG" && n.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const Ix = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function Bx(n, e, t, r, i) {
  let s = n.input.compositionPendingChanges || (n.composing ? n.input.compositionID : 0);
  if (n.input.compositionPendingChanges = 0, e < 0) {
    let I = n.input.lastSelectionTime > Date.now() - 50 ? n.input.lastSelectionOrigin : null, x = M1(n, I);
    if (x && !n.state.selection.eq(x)) {
      if (Bt && ur && n.input.lastKeyCode === 13 && Date.now() - 100 < n.input.lastKeyCodeTime && n.someProp("handleKeyDown", (D) => D(n, si(13, "Enter"))))
        return;
      let M = n.state.tr.setSelection(x);
      I == "pointer" ? M.setMeta("pointer", !0) : I == "key" && M.scrollIntoView(), s && M.setMeta("composition", s), n.dispatch(M);
    }
    return;
  }
  let o = n.state.doc.resolve(e), a = o.sharedDepth(t);
  e = o.before(a + 1), t = n.state.doc.resolve(t).after(a + 1);
  let l = n.state.selection, u = Rx(n, e, t), d = n.state.doc, c = d.slice(u.from, u.to), f, p;
  n.input.lastKeyCode === 8 && Date.now() - 100 < n.input.lastKeyCodeTime ? (f = n.state.selection.to, p = "end") : (f = n.state.selection.from, p = "start"), n.input.lastKeyCode = null;
  let h = Fx(c.content, u.doc.content, u.from, f, p);
  if (h && n.input.domChangeCount++, (cs && n.input.lastIOSEnter > Date.now() - 225 || ur) && i.some((I) => I.nodeType == 1 && !Ix.test(I.nodeName)) && (!h || h.endA >= h.endB) && n.someProp("handleKeyDown", (I) => I(n, si(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (!h)
    if (r && l instanceof Ce && !l.empty && l.$head.sameParent(l.$anchor) && !n.composing && !(u.sel && u.sel.anchor != u.sel.head))
      h = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (u.sel) {
        let I = lf(n, n.state.doc, u.sel);
        if (I && !I.eq(n.state.selection)) {
          let x = n.state.tr.setSelection(I);
          s && x.setMeta("composition", s), n.dispatch(x);
        }
      }
      return;
    }
  n.state.selection.from < n.state.selection.to && h.start == h.endB && n.state.selection instanceof Ce && (h.start > n.state.selection.from && h.start <= n.state.selection.from + 2 && n.state.selection.from >= u.from ? h.start = n.state.selection.from : h.endA < n.state.selection.to && h.endA >= n.state.selection.to - 2 && n.state.selection.to <= u.to && (h.endB += n.state.selection.to - h.endA, h.endA = n.state.selection.to)), en && Hr <= 11 && h.endB == h.start + 1 && h.endA == h.start && h.start > u.from && u.doc.textBetween(h.start - u.from - 1, h.start - u.from + 1) == "  " && (h.start--, h.endA--, h.endB--);
  let y = u.doc.resolveNoCache(h.start - u.from), g = u.doc.resolveNoCache(h.endB - u.from), m = d.resolve(h.start), $ = y.sameParent(g) && y.parent.inlineContent && m.end() >= h.endA, w;
  if ((cs && n.input.lastIOSEnter > Date.now() - 225 && (!$ || i.some((I) => I.nodeName == "DIV" || I.nodeName == "P")) || !$ && y.pos < u.doc.content.size && (!y.sameParent(g) || !y.parent.inlineContent) && !/\S/.test(u.doc.textBetween(y.pos, g.pos, "", "")) && (w = Oe.findFrom(u.doc.resolve(y.pos + 1), 1, !0)) && w.head > y.pos) && n.someProp("handleKeyDown", (I) => I(n, si(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (n.state.selection.anchor > h.start && Vx(d, h.start, h.endA, y, g) && n.someProp("handleKeyDown", (I) => I(n, si(8, "Backspace")))) {
    ur && Bt && n.domObserver.suppressSelectionUpdates();
    return;
  }
  Bt && h.endB == h.start && (n.input.lastChromeDelete = Date.now()), ur && !$ && y.start() != g.start() && g.parentOffset == 0 && y.depth == g.depth && u.sel && u.sel.anchor == u.sel.head && u.sel.head == h.endA && (h.endB -= 2, g = u.doc.resolveNoCache(h.endB - u.from), setTimeout(() => {
    n.someProp("handleKeyDown", function(I) {
      return I(n, si(13, "Enter"));
    });
  }, 20));
  let _ = h.start, L = h.endA, S, R, O;
  if ($) {
    if (y.pos == g.pos)
      en && Hr <= 11 && y.parentOffset == 0 && (n.domObserver.suppressSelectionUpdates(), setTimeout(() => cr(n), 20)), S = n.state.tr.delete(_, L), R = d.resolve(h.start).marksAcross(d.resolve(h.endA));
    else if (
      // Adding or removing a mark
      h.endA == h.endB && (O = zx(y.parent.content.cut(y.parentOffset, g.parentOffset), m.parent.content.cut(m.parentOffset, h.endA - m.start())))
    )
      S = n.state.tr, O.type == "add" ? S.addMark(_, L, O.mark) : S.removeMark(_, L, O.mark);
    else if (y.parent.child(y.index()).isText && y.index() == g.index() - (g.textOffset ? 0 : 1)) {
      let I = y.parent.textBetween(y.parentOffset, g.parentOffset);
      if (n.someProp("handleTextInput", (x) => x(n, _, L, I)))
        return;
      S = n.state.tr.insertText(I, _, L);
    }
  }
  if (S || (S = n.state.tr.replace(_, L, u.doc.slice(h.start - u.from, h.endB - u.from))), u.sel) {
    let I = lf(n, S.doc, u.sel);
    I && !(Bt && n.composing && I.empty && (h.start != h.endB || n.input.lastChromeDelete < Date.now() - 100) && (I.head == _ || I.head == S.mapping.map(L) - 1) || en && I.empty && I.head == _) && S.setSelection(I);
  }
  R && S.ensureMarks(R), s && S.setMeta("composition", s), n.dispatch(S.scrollIntoView());
}
function lf(n, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : A1(n, e.resolve(t.anchor), e.resolve(t.head));
}
function zx(n, e) {
  let t = n.firstChild.marks, r = e.firstChild.marks, i = t, s = r, o, a, l;
  for (let d = 0; d < r.length; d++)
    i = r[d].removeFromSet(i);
  for (let d = 0; d < t.length; d++)
    s = t[d].removeFromSet(s);
  if (i.length == 1 && s.length == 0)
    a = i[0], o = "add", l = (d) => d.mark(a.addToSet(d.marks));
  else if (i.length == 0 && s.length == 1)
    a = s[0], o = "remove", l = (d) => d.mark(a.removeFromSet(d.marks));
  else
    return null;
  let u = [];
  for (let d = 0; d < e.childCount; d++)
    u.push(l(e.child(d)));
  if (re.from(u).eq(n))
    return { mark: a, type: o };
}
function Vx(n, e, t, r, i) {
  if (
    // The content must have shrunk
    t - e <= i.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    wu(r, !0, !1) < i.pos
  )
    return !1;
  let s = n.resolve(e);
  if (!r.parent.isTextblock) {
    let a = s.nodeAfter;
    return a != null && t == e + a.nodeSize;
  }
  if (s.parentOffset < s.parent.content.size || !s.parent.isTextblock)
    return !1;
  let o = n.resolve(wu(s, !0, !0));
  return !o.parent.isTextblock || o.pos > t || wu(o, !0, !1) < t ? !1 : r.parent.content.cut(r.parentOffset).eq(o.parent.content);
}
function wu(n, e, t) {
  let r = n.depth, i = e ? n.end() : n.pos;
  for (; r > 0 && (e || n.indexAfter(r) == n.node(r).childCount); )
    r--, i++, e = !1;
  if (t) {
    let s = n.node(r).maybeChild(n.indexAfter(r));
    for (; s && !s.isLeaf; )
      s = s.firstChild, i++;
  }
  return i;
}
function Fx(n, e, t, r, i) {
  let s = n.findDiffStart(e, t);
  if (s == null)
    return null;
  let { a: o, b: a } = n.findDiffEnd(e, t + n.size, t + e.size);
  if (i == "end") {
    let l = Math.max(0, s - Math.min(o, a));
    r -= o + l - s;
  }
  if (o < s && n.size < e.size) {
    let l = r <= s && r >= o ? s - r : 0;
    s -= l, s && s < e.size && uf(e.textBetween(s - 1, s + 1)) && (s += l ? 1 : -1), a = s + (a - o), o = s;
  } else if (a < s) {
    let l = r <= s && r >= a ? s - r : 0;
    s -= l, s && s < n.size && uf(n.textBetween(s - 1, s + 1)) && (s += l ? 1 : -1), o = s + (o - a), a = s;
  }
  return { start: s, endA: o, endB: a };
}
function uf(n) {
  if (n.length != 2)
    return !1;
  let e = n.charCodeAt(0), t = n.charCodeAt(1);
  return e >= 56320 && e <= 57343 && t >= 55296 && t <= 56319;
}
class jx {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new ox(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(hf), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = ff(this), cf(this), this.nodeViews = pf(this), this.docView = Hc(this.state.doc, df(this), xu(this), this.dom, this), this.domObserver = new Ax(this, (r, i, s, o) => Bx(this, r, i, s, o)), this.domObserver.start(), ax(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Ad(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(hf), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let t = {};
    for (let r in this._props)
      t[r] = this._props[r];
    t.state = this.state;
    for (let r in e)
      t[r] = e[r];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var r;
    let i = this.state, s = !1, o = !1;
    e.storedMarks && this.composing && (zh(this), o = !0), this.state = e;
    let a = i.plugins != e.plugins || this._props.plugins != t.plugins;
    if (a || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let p = pf(this);
      Ux(p, this.nodeViews) && (this.nodeViews = p, s = !0);
    }
    (a || t.handleDOMEvents != this._props.handleDOMEvents) && Ad(this), this.editable = ff(this), cf(this);
    let l = xu(this), u = df(this), d = i.plugins != e.plugins && !i.doc.eq(e.doc) ? "reset" : e.scrollToSelection > i.scrollToSelection ? "to selection" : "preserve", c = s || !this.docView.matchesNode(e.doc, u, l);
    (c || !e.selection.eq(i.selection)) && (o = !0);
    let f = d == "preserve" && o && this.dom.style.overflowAnchor == null && $$(this);
    if (o) {
      this.domObserver.stop();
      let p = c && (en || Bt) && !this.composing && !i.selection.empty && !e.selection.empty && Hx(i.selection, e.selection);
      if (c) {
        let h = Bt ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = _x(this)), (s || !this.docView.update(e.doc, u, l, this)) && (this.docView.updateOuterDeco(u), this.docView.destroy(), this.docView = Hc(e.doc, u, l, this.dom, this)), h && !this.trackWrites && (p = !0);
      }
      p || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && W$(this)) ? cr(this, p) : (Eh(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(i), !((r = this.dragging) === null || r === void 0) && r.node && !i.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, i), d == "reset" ? this.dom.scrollTop = 0 : d == "to selection" ? this.scrollToSelection() : f && x$(f);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof ve) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && Ic(this, t.getBoundingClientRect(), e);
      } else
        Ic(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let r = this.directPlugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let r = this.state.plugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let r = this.pluginViews[t];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, t) {
    let r = e.node, i = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      i = r.from;
    else {
      let s = r.from + (this.state.doc.content.size - t.doc.content.size);
      (s > 0 && this.state.doc.nodeAt(s)) == r.node && (i = s);
    }
    this.dragging = new Fh(e.slice, e.move, i < 0 ? void 0 : ve.create(this.state.doc, i));
  }
  someProp(e, t) {
    let r = this._props && this._props[e], i;
    if (r != null && (i = t ? t(r) : r))
      return i;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let a = this.directPlugins[o].props[e];
      if (a != null && (i = t ? t(a) : a))
        return i;
    }
    let s = this.state.plugins;
    if (s)
      for (let o = 0; o < s.length; o++) {
        let a = s[o].props[e];
        if (a != null && (i = t ? t(a) : a))
          return i;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (en) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && w$(this.dom), cr(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return T$(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, t = 1) {
    return vh(this, e, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, t, r = -1) {
    let i = this.docView.posFromDOM(e, t, r);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, t) {
    return D$(this, t || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, t) {
    return $o(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, t) {
    return $o(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return N1(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (lx(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], xu(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, d$());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return dx(this, e);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(e) {
    let t = this._props.dispatchTransaction;
    t ? t.call(this, e) : this.updateState(this.state.apply(e));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? qt && this.root.nodeType === 11 && m$(this.dom.ownerDocument) == this.dom && Dx(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function df(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(n.editable), n.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(n.state)), t)
      for (let r in t)
        r == "class" ? e.class += " " + t[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + t[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(t[r]));
  }), e.translate || (e.translate = "no"), [kn.node(0, n.state.doc.content.size, e)];
}
function cf(n) {
  if (n.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), n.cursorWrapper = { dom: e, deco: kn.widget(n.state.selection.from, e, { raw: !0, marks: n.markCursor }) };
  } else
    n.cursorWrapper = null;
}
function ff(n) {
  return !n.someProp("editable", (e) => e(n.state) === !1);
}
function Hx(n, e) {
  let t = Math.min(n.$anchor.sharedDepth(n.head), e.$anchor.sharedDepth(e.head));
  return n.$anchor.start(t) != e.$anchor.start(t);
}
function pf(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(r) {
    for (let i in r)
      Object.prototype.hasOwnProperty.call(e, i) || (e[i] = r[i]);
  }
  return n.someProp("nodeViews", t), n.someProp("markViews", t), e;
}
function Ux(n, e) {
  let t = 0, r = 0;
  for (let i in n) {
    if (n[i] != e[i])
      return !0;
    t++;
  }
  for (let i in e)
    r++;
  return t != r;
}
function hf(n) {
  if (n.spec.state || n.spec.filterTransaction || n.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var qr = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Va = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, Wx = typeof navigator < "u" && /Mac/.test(navigator.platform), qx = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Nt = 0; Nt < 10; Nt++) qr[48 + Nt] = qr[96 + Nt] = String(Nt);
for (var Nt = 1; Nt <= 24; Nt++) qr[Nt + 111] = "F" + Nt;
for (var Nt = 65; Nt <= 90; Nt++)
  qr[Nt] = String.fromCharCode(Nt + 32), Va[Nt] = String.fromCharCode(Nt);
for (var ku in qr) Va.hasOwnProperty(ku) || (Va[ku] = qr[ku]);
function Kx(n) {
  var e = Wx && n.metaKey && n.shiftKey && !n.ctrlKey && !n.altKey || qx && n.shiftKey && n.key && n.key.length == 1 || n.key == "Unidentified", t = !e && n.key || (n.shiftKey ? Va : qr)[n.keyCode] || n.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const Gx = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function Yx(n) {
  let e = n.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let r, i, s, o;
  for (let a = 0; a < e.length - 1; a++) {
    let l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      s = !0;
    else if (/^mod$/i.test(l))
      Gx ? o = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return r && (t = "Alt-" + t), i && (t = "Ctrl-" + t), o && (t = "Meta-" + t), s && (t = "Shift-" + t), t;
}
function Jx(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n)
    e[Yx(t)] = n[t];
  return e;
}
function Cu(n, e, t = !0) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t && e.shiftKey && (n = "Shift-" + n), n;
}
function Zx(n) {
  return new bt({ props: { handleKeyDown: qh(n) } });
}
function qh(n) {
  let e = Jx(n);
  return function(t, r) {
    let i = Kx(r), s, o = e[Cu(i, r)];
    if (o && o(t.state, t.dispatch, t))
      return !0;
    if (i.length == 1 && i != " ") {
      if (r.shiftKey) {
        let a = e[Cu(i, r, !1)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
      if ((r.shiftKey || r.altKey || r.metaKey || i.charCodeAt(0) > 127) && (s = qr[r.keyCode]) && s != i) {
        let a = e[Cu(s, r)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
const Xx = (n, e) => n.selection.empty ? !1 : (e && e(n.tr.deleteSelection().scrollIntoView()), !0);
function Kh(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("backward", n) : t.parentOffset > 0) ? null : t;
}
const Qx = (n, e, t) => {
  let r = Kh(n, t);
  if (!r)
    return !1;
  let i = B1(r);
  if (!i) {
    let o = r.blockRange(), a = o && xs(o);
    return a == null ? !1 : (e && e(n.tr.lift(o, a).scrollIntoView()), !0);
  }
  let s = i.nodeBefore;
  if (Zh(n, i, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (fs(s, "end") || ve.isSelectable(s)))
    for (let o = r.depth; ; o--) {
      let a = Ml(n.doc, r.before(o), r.after(o), de.empty);
      if (a && a.slice.size < a.to - a.from) {
        if (e) {
          let l = n.tr.step(a);
          l.setSelection(fs(s, "end") ? Oe.findFrom(l.doc.resolve(l.mapping.map(i.pos, -1)), -1) : ve.create(l.doc, i.pos - s.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || r.node(o - 1).childCount > 1)
        break;
    }
  return s.isAtom && i.depth == r.depth - 1 ? (e && e(n.tr.delete(i.pos - s.nodeSize, i.pos).scrollIntoView()), !0) : !1;
}, ew = (n, e, t) => {
  let r = Kh(n, t);
  if (!r)
    return !1;
  let i = B1(r);
  return i ? Gh(n, i, e) : !1;
}, tw = (n, e, t) => {
  let r = Yh(n, t);
  if (!r)
    return !1;
  let i = z1(r);
  return i ? Gh(n, i, e) : !1;
};
function Gh(n, e, t) {
  let r = e.nodeBefore, i = r, s = e.pos - 1;
  for (; !i.isTextblock; s--) {
    if (i.type.spec.isolating)
      return !1;
    let d = i.lastChild;
    if (!d)
      return !1;
    i = d;
  }
  let o = e.nodeAfter, a = o, l = e.pos + 1;
  for (; !a.isTextblock; l++) {
    if (a.type.spec.isolating)
      return !1;
    let d = a.firstChild;
    if (!d)
      return !1;
    a = d;
  }
  let u = Ml(n.doc, s, l, de.empty);
  if (!u || u.from != s || u instanceof vt && u.slice.size >= l - s)
    return !1;
  if (t) {
    let d = n.tr.step(u);
    d.setSelection(Ce.create(d.doc, s)), t(d.scrollIntoView());
  }
  return !0;
}
function fs(n, e, t = !1) {
  for (let r = n; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (t && r.childCount != 1)
      return !1;
  }
  return !1;
}
const nw = (n, e, t) => {
  let { $head: r, empty: i } = n.selection, s = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", n) : r.parentOffset > 0)
      return !1;
    s = B1(r);
  }
  let o = s && s.nodeBefore;
  return !o || !ve.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(ve.create(n.doc, s.pos - o.nodeSize)).scrollIntoView()), !0);
};
function B1(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      if (n.index(e) > 0)
        return n.doc.resolve(n.before(e + 1));
      if (n.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function Yh(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("forward", n) : t.parentOffset < t.parent.content.size) ? null : t;
}
const rw = (n, e, t) => {
  let r = Yh(n, t);
  if (!r)
    return !1;
  let i = z1(r);
  if (!i)
    return !1;
  let s = i.nodeAfter;
  if (Zh(n, i, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (fs(s, "start") || ve.isSelectable(s))) {
    let o = Ml(n.doc, r.before(), r.after(), de.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let a = n.tr.step(o);
        a.setSelection(fs(s, "start") ? Oe.findFrom(a.doc.resolve(a.mapping.map(i.pos)), 1) : ve.create(a.doc, a.mapping.map(i.pos))), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return s.isAtom && i.depth == r.depth - 1 ? (e && e(n.tr.delete(i.pos, i.pos + s.nodeSize).scrollIntoView()), !0) : !1;
}, iw = (n, e, t) => {
  let { $head: r, empty: i } = n.selection, s = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", n) : r.parentOffset < r.parent.content.size)
      return !1;
    s = z1(r);
  }
  let o = s && s.nodeAfter;
  return !o || !ve.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(ve.create(n.doc, s.pos)).scrollIntoView()), !0);
};
function z1(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      let t = n.node(e);
      if (n.index(e) + 1 < t.childCount)
        return n.doc.resolve(n.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const sw = (n, e) => {
  let t = n.selection, r = t instanceof ve, i;
  if (r) {
    if (t.node.isTextblock || !Yr(n.doc, t.from))
      return !1;
    i = t.from;
  } else if (i = Ol(n.doc, t.from, -1), i == null)
    return !1;
  if (e) {
    let s = n.tr.join(i);
    r && s.setSelection(ve.create(s.doc, i - n.doc.resolve(i).nodeBefore.nodeSize)), e(s.scrollIntoView());
  }
  return !0;
}, ow = (n, e) => {
  let t = n.selection, r;
  if (t instanceof ve) {
    if (t.node.isTextblock || !Yr(n.doc, t.to))
      return !1;
    r = t.to;
  } else if (r = Ol(n.doc, t.to, 1), r == null)
    return !1;
  return e && e(n.tr.join(r).scrollIntoView()), !0;
}, aw = (n, e) => {
  let { $from: t, $to: r } = n.selection, i = t.blockRange(r), s = i && xs(i);
  return s == null ? !1 : (e && e(n.tr.lift(i, s).scrollIntoView()), !0);
}, lw = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  return !t.parent.type.spec.code || !t.sameParent(r) ? !1 : (e && e(n.tr.insertText(`
`).scrollIntoView()), !0);
};
function Jh(n) {
  for (let e = 0; e < n.edgeCount; e++) {
    let { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const uw = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  if (!t.parent.type.spec.code || !t.sameParent(r))
    return !1;
  let i = t.node(-1), s = t.indexAfter(-1), o = Jh(i.contentMatchAt(s));
  if (!o || !i.canReplaceWith(s, s, o))
    return !1;
  if (e) {
    let a = t.after(), l = n.tr.replaceWith(a, a, o.createAndFill());
    l.setSelection(Oe.near(l.doc.resolve(a), 1)), e(l.scrollIntoView());
  }
  return !0;
}, dw = (n, e) => {
  let t = n.selection, { $from: r, $to: i } = t;
  if (t instanceof Cn || r.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let s = Jh(i.parent.contentMatchAt(i.indexAfter()));
  if (!s || !s.isTextblock)
    return !1;
  if (e) {
    let o = (!r.parentOffset && i.index() < i.parent.childCount ? r : i).pos, a = n.tr.insert(o, s.createAndFill());
    a.setSelection(Ce.create(a.doc, o + 1)), e(a.scrollIntoView());
  }
  return !0;
}, cw = (n, e) => {
  let { $cursor: t } = n.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let s = t.before();
    if (es(n.doc, s))
      return e && e(n.tr.split(s).scrollIntoView()), !0;
  }
  let r = t.blockRange(), i = r && xs(r);
  return i == null ? !1 : (e && e(n.tr.lift(r, i).scrollIntoView()), !0);
}, fw = (n, e) => {
  let { $from: t, to: r } = n.selection, i, s = t.sharedDepth(r);
  return s == 0 ? !1 : (i = t.before(s), e && e(n.tr.setSelection(ve.create(n.doc, i))), !0);
};
function pw(n, e, t) {
  let r = e.nodeBefore, i = e.nodeAfter, s = e.index();
  return !r || !i || !r.type.compatibleContent(i.type) ? !1 : !r.content.size && e.parent.canReplace(s - 1, s) ? (t && t(n.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(s, s + 1) || !(i.isTextblock || Yr(n.doc, e.pos)) ? !1 : (t && t(n.tr.join(e.pos).scrollIntoView()), !0);
}
function Zh(n, e, t, r) {
  let i = e.nodeBefore, s = e.nodeAfter, o, a, l = i.type.spec.isolating || s.type.spec.isolating;
  if (!l && pw(n, e, t))
    return !0;
  let u = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (u && (o = (a = i.contentMatchAt(i.childCount)).findWrapping(s.type)) && a.matchType(o[0] || s.type).validEnd) {
    if (t) {
      let p = e.pos + s.nodeSize, h = re.empty;
      for (let m = o.length - 1; m >= 0; m--)
        h = re.from(o[m].create(null, h));
      h = re.from(i.copy(h));
      let y = n.tr.step(new $t(e.pos - 1, p, e.pos, p, new de(h, 1, 0), o.length, !0)), g = y.doc.resolve(p + 2 * o.length);
      g.nodeAfter && g.nodeAfter.type == i.type && Yr(y.doc, g.pos) && y.join(g.pos), t(y.scrollIntoView());
    }
    return !0;
  }
  let d = s.type.spec.isolating || r > 0 && l ? null : Oe.findFrom(e, 1), c = d && d.$from.blockRange(d.$to), f = c && xs(c);
  if (f != null && f >= e.depth)
    return t && t(n.tr.lift(c, f).scrollIntoView()), !0;
  if (u && fs(s, "start", !0) && fs(i, "end")) {
    let p = i, h = [];
    for (; h.push(p), !p.isTextblock; )
      p = p.lastChild;
    let y = s, g = 1;
    for (; !y.isTextblock; y = y.firstChild)
      g++;
    if (p.canReplace(p.childCount, p.childCount, y.content)) {
      if (t) {
        let m = re.empty;
        for (let w = h.length - 1; w >= 0; w--)
          m = re.from(h[w].copy(m));
        let $ = n.tr.step(new $t(e.pos - h.length, e.pos + s.nodeSize, e.pos + g, e.pos + s.nodeSize - g, new de(m, h.length, 0), 0, !0));
        t($.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Xh(n) {
  return function(e, t) {
    let r = e.selection, i = n < 0 ? r.$from : r.$to, s = i.depth;
    for (; i.node(s).isInline; ) {
      if (!s)
        return !1;
      s--;
    }
    return i.node(s).isTextblock ? (t && t(e.tr.setSelection(Ce.create(e.doc, n < 0 ? i.start(s) : i.end(s)))), !0) : !1;
  };
}
const hw = Xh(-1), mw = Xh(1);
function gw(n, e = null) {
  return function(t, r) {
    let { $from: i, $to: s } = t.selection, o = i.blockRange(s), a = o && E1(o, n, e);
    return a ? (r && r(t.tr.wrap(o, a).scrollIntoView()), !0) : !1;
  };
}
function mf(n, e = null) {
  return function(t, r) {
    let i = !1;
    for (let s = 0; s < t.selection.ranges.length && !i; s++) {
      let { $from: { pos: o }, $to: { pos: a } } = t.selection.ranges[s];
      t.doc.nodesBetween(o, a, (l, u) => {
        if (i)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(n, e)))
          if (l.type == n)
            i = !0;
          else {
            let d = t.doc.resolve(u), c = d.index();
            i = d.parent.canReplaceWith(c, c + 1, n);
          }
      });
    }
    if (!i)
      return !1;
    if (r) {
      let s = t.tr;
      for (let o = 0; o < t.selection.ranges.length; o++) {
        let { $from: { pos: a }, $to: { pos: l } } = t.selection.ranges[o];
        s.setBlockType(a, l, n, e);
      }
      r(s.scrollIntoView());
    }
    return !0;
  };
}
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function bw(n, e = null) {
  return function(t, r) {
    let { $from: i, $to: s } = t.selection, o = i.blockRange(s);
    if (!o)
      return !1;
    let a = r ? t.tr : null;
    return yw(a, o, n, e) ? (r && r(a.scrollIntoView()), !0) : !1;
  };
}
function yw(n, e, t, r = null) {
  let i = !1, s = e, o = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(t) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = o.resolve(e.start - 2);
    s = new Da(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new Da(e.$from, o.resolve(e.$to.end(e.depth)), e.depth)), i = !0;
  }
  let a = E1(s, t, r, e);
  return a ? (n && vw(n, e, a, i, t), !0) : !1;
}
function vw(n, e, t, r, i) {
  let s = re.empty;
  for (let d = t.length - 1; d >= 0; d--)
    s = re.from(t[d].type.create(t[d].attrs, s));
  n.step(new $t(e.start - (r ? 2 : 0), e.end, e.start, e.end, new de(s, 0, 0), t.length, !0));
  let o = 0;
  for (let d = 0; d < t.length; d++)
    t[d].type == i && (o = d + 1);
  let a = t.length - o, l = e.start + t.length - (r ? 2 : 0), u = e.parent;
  for (let d = e.startIndex, c = e.endIndex, f = !0; d < c; d++, f = !1)
    !f && es(n.doc, l, a) && (n.split(l, a), l += 2 * a), l += u.child(d).nodeSize;
  return n;
}
function _w(n) {
  return function(e, t) {
    let { $from: r, $to: i } = e.selection, s = r.blockRange(i, (o) => o.childCount > 0 && o.firstChild.type == n);
    return s ? t ? r.node(s.depth - 1).type == n ? $w(e, t, n, s) : xw(e, t, s) : !0 : !1;
  };
}
function $w(n, e, t, r) {
  let i = n.tr, s = r.end, o = r.$to.end(r.depth);
  s < o && (i.step(new $t(s - 1, o, s, o, new de(re.from(t.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new Da(i.doc.resolve(r.$from.pos), i.doc.resolve(o), r.depth));
  const a = xs(r);
  if (a == null)
    return !1;
  i.lift(r, a);
  let l = i.doc.resolve(i.mapping.map(s, -1) - 1);
  return Yr(i.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && i.join(l.pos), e(i.scrollIntoView()), !0;
}
function xw(n, e, t) {
  let r = n.tr, i = t.parent;
  for (let p = t.end, h = t.endIndex - 1, y = t.startIndex; h > y; h--)
    p -= i.child(h).nodeSize, r.delete(p - 1, p + 1);
  let s = r.doc.resolve(t.start), o = s.nodeAfter;
  if (r.mapping.map(t.end) != t.start + s.nodeAfter.nodeSize)
    return !1;
  let a = t.startIndex == 0, l = t.endIndex == i.childCount, u = s.node(-1), d = s.index(-1);
  if (!u.canReplace(d + (a ? 0 : 1), d + 1, o.content.append(l ? re.empty : re.from(i))))
    return !1;
  let c = s.pos, f = c + o.nodeSize;
  return r.step(new $t(c - (a ? 1 : 0), f + (l ? 1 : 0), c + 1, f - 1, new de((a ? re.empty : re.from(i.copy(re.empty))).append(l ? re.empty : re.from(i.copy(re.empty))), a ? 0 : 1, l ? 0 : 1), a ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function ww(n) {
  return function(e, t) {
    let { $from: r, $to: i } = e.selection, s = r.blockRange(i, (u) => u.childCount > 0 && u.firstChild.type == n);
    if (!s)
      return !1;
    let o = s.startIndex;
    if (o == 0)
      return !1;
    let a = s.parent, l = a.child(o - 1);
    if (l.type != n)
      return !1;
    if (t) {
      let u = l.lastChild && l.lastChild.type == a.type, d = re.from(u ? n.create() : null), c = new de(re.from(n.create(null, re.from(a.type.create(null, d)))), u ? 3 : 1, 0), f = s.start, p = s.end;
      t(e.tr.step(new $t(f - (u ? 3 : 1), p, f, p, c, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function Rl(n) {
  const { state: e, transaction: t } = n;
  let { selection: r } = t, { doc: i } = t, { storedMarks: s } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return s;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = t.selection, i = t.doc, s = t.storedMarks, t;
    }
  };
}
class Pl {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: t, state: r } = this, { view: i } = t, { tr: s } = r, o = this.buildProps(s);
    return Object.fromEntries(Object.entries(e).map(([a, l]) => [a, (...d) => {
      const c = l(...d)(o);
      return !s.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(s), c;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, t = !0) {
    const { rawCommands: r, editor: i, state: s } = this, { view: o } = i, a = [], l = !!e, u = e || s.tr, d = () => (!l && t && !u.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(u), a.every((f) => f === !0)), c = {
      ...Object.fromEntries(Object.entries(r).map(([f, p]) => [f, (...y) => {
        const g = this.buildProps(u, t), m = p(...y)(g);
        return a.push(m), c;
      }])),
      run: d
    };
    return c;
  }
  createCan(e) {
    const { rawCommands: t, state: r } = this, i = !1, s = e || r.tr, o = this.buildProps(s, i);
    return {
      ...Object.fromEntries(Object.entries(t).map(([l, u]) => [l, (...d) => u(...d)({ ...o, dispatch: void 0 })])),
      chain: () => this.createChain(s, i)
    };
  }
  buildProps(e, t = !0) {
    const { rawCommands: r, editor: i, state: s } = this, { view: o } = i, a = {
      tr: e,
      editor: i,
      view: o,
      state: Rl({
        state: s,
        transaction: e
      }),
      dispatch: t ? () => {
      } : void 0,
      chain: () => this.createChain(e, t),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([l, u]) => [l, (...d) => u(...d)(a)]));
      }
    };
    return a;
  }
}
class kw {
  constructor() {
    this.callbacks = {};
  }
  on(e, t) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), this;
  }
  emit(e, ...t) {
    const r = this.callbacks[e];
    return r && r.forEach((i) => i.apply(this, t)), this;
  }
  off(e, t) {
    const r = this.callbacks[e];
    return r && (t ? this.callbacks[e] = r.filter((i) => i !== t) : delete this.callbacks[e]), this;
  }
  once(e, t) {
    const r = (...i) => {
      this.off(e, r), t.apply(this, i);
    };
    return this.on(e, r);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function me(n, e, t) {
  return n.config[e] === void 0 && n.parent ? me(n.parent, e, t) : typeof n.config[e] == "function" ? n.config[e].bind({
    ...t,
    parent: n.parent ? me(n.parent, e, t) : null
  }) : n.config[e];
}
function Il(n) {
  const e = n.filter((i) => i.type === "extension"), t = n.filter((i) => i.type === "node"), r = n.filter((i) => i.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: r
  };
}
function Qh(n) {
  const e = [], { nodeExtensions: t, markExtensions: r } = Il(n), i = [...t, ...r], s = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return n.forEach((o) => {
    const a = {
      name: o.name,
      options: o.options,
      storage: o.storage,
      extensions: i
    }, l = me(o, "addGlobalAttributes", a);
    if (!l)
      return;
    l().forEach((d) => {
      d.types.forEach((c) => {
        Object.entries(d.attributes).forEach(([f, p]) => {
          e.push({
            type: c,
            name: f,
            attribute: {
              ...s,
              ...p
            }
          });
        });
      });
    });
  }), i.forEach((o) => {
    const a = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, l = me(o, "addAttributes", a);
    if (!l)
      return;
    const u = l();
    Object.entries(u).forEach(([d, c]) => {
      const f = {
        ...s,
        ...c
      };
      typeof (f == null ? void 0 : f.default) == "function" && (f.default = f.default()), f != null && f.isRequired && (f == null ? void 0 : f.default) === void 0 && delete f.default, e.push({
        type: o.name,
        name: d,
        attribute: f
      });
    });
  }), e;
}
function Ct(n, e) {
  if (typeof n == "string") {
    if (!e.nodes[n])
      throw Error(`There is no node type named '${n}'. Maybe you forgot to add the extension?`);
    return e.nodes[n];
  }
  return n;
}
function gt(...n) {
  return n.filter((e) => !!e).reduce((e, t) => {
    const r = { ...e };
    return Object.entries(t).forEach(([i, s]) => {
      if (!r[i]) {
        r[i] = s;
        return;
      }
      if (i === "class") {
        const a = s ? String(s).split(" ") : [], l = r[i] ? r[i].split(" ") : [], u = a.filter((d) => !l.includes(d));
        r[i] = [...l, ...u].join(" ");
      } else if (i === "style") {
        const a = s ? s.split(";").map((d) => d.trim()).filter(Boolean) : [], l = r[i] ? r[i].split(";").map((d) => d.trim()).filter(Boolean) : [], u = /* @__PURE__ */ new Map();
        l.forEach((d) => {
          const [c, f] = d.split(":").map((p) => p.trim());
          u.set(c, f);
        }), a.forEach((d) => {
          const [c, f] = d.split(":").map((p) => p.trim());
          u.set(c, f);
        }), r[i] = Array.from(u.entries()).map(([d, c]) => `${d}: ${c}`).join("; ");
      } else
        r[i] = s;
    }), r;
  }, {});
}
function Nd(n, e) {
  return e.filter((t) => t.type === n.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(n.attrs) || {} : {
    [t.name]: n.attrs[t.name]
  }).reduce((t, r) => gt(t, r), {});
}
function e3(n) {
  return typeof n == "function";
}
function Ne(n, e = void 0, ...t) {
  return e3(n) ? e ? n.bind(e)(...t) : n(...t) : n;
}
function Cw(n = {}) {
  return Object.keys(n).length === 0 && n.constructor === Object;
}
function Sw(n) {
  return typeof n != "string" ? n : n.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(n) : n === "true" ? !0 : n === "false" ? !1 : n;
}
function gf(n, e) {
  return "style" in n ? n : {
    ...n,
    getAttrs: (t) => {
      const r = n.getAttrs ? n.getAttrs(t) : n.attrs;
      if (r === !1)
        return !1;
      const i = e.reduce((s, o) => {
        const a = o.attribute.parseHTML ? o.attribute.parseHTML(t) : Sw(t.getAttribute(o.name));
        return a == null ? s : {
          ...s,
          [o.name]: a
        };
      }, {});
      return { ...r, ...i };
    }
  };
}
function bf(n) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(n).filter(([e, t]) => e === "attrs" && Cw(t) ? !1 : t != null)
  );
}
function t3(n, e) {
  var t;
  const r = Qh(n), { nodeExtensions: i, markExtensions: s } = Il(n), o = (t = i.find((u) => me(u, "topNode"))) === null || t === void 0 ? void 0 : t.name, a = Object.fromEntries(i.map((u) => {
    const d = r.filter((m) => m.type === u.name), c = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      editor: e
    }, f = n.reduce((m, $) => {
      const w = me($, "extendNodeSchema", c);
      return {
        ...m,
        ...w ? w(u) : {}
      };
    }, {}), p = bf({
      ...f,
      content: Ne(me(u, "content", c)),
      marks: Ne(me(u, "marks", c)),
      group: Ne(me(u, "group", c)),
      inline: Ne(me(u, "inline", c)),
      atom: Ne(me(u, "atom", c)),
      selectable: Ne(me(u, "selectable", c)),
      draggable: Ne(me(u, "draggable", c)),
      code: Ne(me(u, "code", c)),
      whitespace: Ne(me(u, "whitespace", c)),
      linebreakReplacement: Ne(me(u, "linebreakReplacement", c)),
      defining: Ne(me(u, "defining", c)),
      isolating: Ne(me(u, "isolating", c)),
      attrs: Object.fromEntries(d.map((m) => {
        var $;
        return [m.name, { default: ($ = m == null ? void 0 : m.attribute) === null || $ === void 0 ? void 0 : $.default }];
      }))
    }), h = Ne(me(u, "parseHTML", c));
    h && (p.parseDOM = h.map((m) => gf(m, d)));
    const y = me(u, "renderHTML", c);
    y && (p.toDOM = (m) => y({
      node: m,
      HTMLAttributes: Nd(m, d)
    }));
    const g = me(u, "renderText", c);
    return g && (p.toText = g), [u.name, p];
  })), l = Object.fromEntries(s.map((u) => {
    const d = r.filter((g) => g.type === u.name), c = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      editor: e
    }, f = n.reduce((g, m) => {
      const $ = me(m, "extendMarkSchema", c);
      return {
        ...g,
        ...$ ? $(u) : {}
      };
    }, {}), p = bf({
      ...f,
      inclusive: Ne(me(u, "inclusive", c)),
      excludes: Ne(me(u, "excludes", c)),
      group: Ne(me(u, "group", c)),
      spanning: Ne(me(u, "spanning", c)),
      code: Ne(me(u, "code", c)),
      attrs: Object.fromEntries(d.map((g) => {
        var m;
        return [g.name, { default: (m = g == null ? void 0 : g.attribute) === null || m === void 0 ? void 0 : m.default }];
      }))
    }), h = Ne(me(u, "parseHTML", c));
    h && (p.parseDOM = h.map((g) => gf(g, d)));
    const y = me(u, "renderHTML", c);
    return y && (p.toDOM = (g) => y({
      mark: g,
      HTMLAttributes: Nd(g, d)
    })), [u.name, p];
  }));
  return new Gp({
    topNode: o,
    nodes: a,
    marks: l
  });
}
function Su(n, e) {
  return e.nodes[n] || e.marks[n] || null;
}
function yf(n, e) {
  return Array.isArray(e) ? e.some((t) => (typeof t == "string" ? t : t.name) === n.name) : e;
}
function Bl(n, e) {
  const t = Gr.fromSchema(e).serializeFragment(n), i = document.implementation.createHTMLDocument().createElement("div");
  return i.appendChild(t), i.innerHTML;
}
const Ew = (n, e = 500) => {
  let t = "";
  const r = n.parentOffset;
  return n.parent.nodesBetween(Math.max(0, r - e), r, (i, s, o, a) => {
    var l, u;
    const d = ((u = (l = i.type.spec).toText) === null || u === void 0 ? void 0 : u.call(l, {
      node: i,
      pos: s,
      parent: o,
      index: a
    })) || i.textContent || "%leaf%";
    t += i.isAtom && !i.isText ? d : d.slice(0, Math.max(0, r - s));
  }), t;
};
function V1(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
class zl {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const Tw = (n, e) => {
  if (V1(e))
    return e.exec(n);
  const t = e(n);
  if (!t)
    return null;
  const r = [t.text];
  return r.index = t.index, r.input = n, r.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(t.replaceWith)), r;
};
function Zo(n) {
  var e;
  const { editor: t, from: r, to: i, text: s, rules: o, plugin: a } = n, { view: l } = t;
  if (l.composing)
    return !1;
  const u = l.state.doc.resolve(r);
  if (
    // check for code node
    u.parent.type.spec.code || !((e = u.nodeBefore || u.nodeAfter) === null || e === void 0) && e.marks.find((f) => f.type.spec.code)
  )
    return !1;
  let d = !1;
  const c = Ew(u) + s;
  return o.forEach((f) => {
    if (d)
      return;
    const p = Tw(c, f.find);
    if (!p)
      return;
    const h = l.state.tr, y = Rl({
      state: l.state,
      transaction: h
    }), g = {
      from: r - (p[0].length - s.length),
      to: i
    }, { commands: m, chain: $, can: w } = new Pl({
      editor: t,
      state: y
    });
    f.handler({
      state: y,
      range: g,
      match: p,
      commands: m,
      chain: $,
      can: w
    }) === null || !h.steps.length || (h.setMeta(a, {
      transform: h,
      from: r,
      to: i,
      text: s
    }), l.dispatch(h), d = !0);
  }), d;
}
function Ow(n) {
  const { editor: e, rules: t } = n, r = new bt({
    state: {
      init() {
        return null;
      },
      apply(i, s, o) {
        const a = i.getMeta(r);
        if (a)
          return a;
        const l = i.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: d } = l;
          typeof d == "string" ? d = d : d = Bl(re.from(d), o.schema);
          const { from: c } = l, f = c + d.length;
          Zo({
            editor: e,
            from: c,
            to: f,
            text: d,
            rules: t,
            plugin: r
          });
        }), i.selectionSet || i.docChanged ? null : s;
      }
    },
    props: {
      handleTextInput(i, s, o, a) {
        return Zo({
          editor: e,
          from: s,
          to: o,
          text: a,
          rules: t,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (i) => (setTimeout(() => {
          const { $cursor: s } = i.state.selection;
          s && Zo({
            editor: e,
            from: s.pos,
            to: s.pos,
            text: "",
            rules: t,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(i, s) {
        if (s.key !== "Enter")
          return !1;
        const { $cursor: o } = i.state.selection;
        return o ? Zo({
          editor: e,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: t,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function Mw(n) {
  return Object.prototype.toString.call(n).slice(8, -1);
}
function Xo(n) {
  return Mw(n) !== "Object" ? !1 : n.constructor === Object && Object.getPrototypeOf(n) === Object.prototype;
}
function Vl(n, e) {
  const t = { ...n };
  return Xo(n) && Xo(e) && Object.keys(e).forEach((r) => {
    Xo(e[r]) && Xo(n[r]) ? t[r] = Vl(n[r], e[r]) : t[r] = e[r];
  }), t;
}
class In {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ne(me(this, "addOptions", {
      name: this.name
    }))), this.storage = Ne(me(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new In(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => Vl(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new In(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = Ne(me(t, "addOptions", {
      name: t.name
    })), t.storage = Ne(me(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  static handleExit({ editor: e, mark: t }) {
    const { tr: r } = e.state, i = e.state.selection.$from;
    if (i.pos === i.end()) {
      const o = i.marks();
      if (!!!o.find((u) => (u == null ? void 0 : u.type.name) === t.name))
        return !1;
      const l = o.find((u) => (u == null ? void 0 : u.type.name) === t.name);
      return l && r.removeStoredMark(l), r.insertText(" ", i.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
}
function Aw(n) {
  return typeof n == "number";
}
class Nw {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const Dw = (n, e, t) => {
  if (V1(e))
    return [...n.matchAll(e)];
  const r = e(n, t);
  return r ? r.map((i) => {
    const s = [i.text];
    return s.index = i.index, s.input = n, s.data = i.data, i.replaceWith && (i.text.includes(i.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), s.push(i.replaceWith)), s;
  }) : [];
};
function Lw(n) {
  const { editor: e, state: t, from: r, to: i, rule: s, pasteEvent: o, dropEvent: a } = n, { commands: l, chain: u, can: d } = new Pl({
    editor: e,
    state: t
  }), c = [];
  return t.doc.nodesBetween(r, i, (p, h) => {
    if (!p.isTextblock || p.type.spec.code)
      return;
    const y = Math.max(r, h), g = Math.min(i, h + p.content.size), m = p.textBetween(y - h, g - h, void 0, "￼");
    Dw(m, s.find, o).forEach((w) => {
      if (w.index === void 0)
        return;
      const _ = y + w.index + 1, L = _ + w[0].length, S = {
        from: t.tr.mapping.map(_),
        to: t.tr.mapping.map(L)
      }, R = s.handler({
        state: t,
        range: S,
        match: w,
        commands: l,
        chain: u,
        can: d,
        pasteEvent: o,
        dropEvent: a
      });
      c.push(R);
    });
  }), c.every((p) => p !== null);
}
let Qo = null;
const Rw = (n) => {
  var e;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = t.clipboardData) === null || e === void 0 || e.setData("text/html", n), t;
};
function Pw(n) {
  const { editor: e, rules: t } = n;
  let r = null, i = !1, s = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, a;
  try {
    a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    a = null;
  }
  const l = ({ state: d, from: c, to: f, rule: p, pasteEvt: h }) => {
    const y = d.tr, g = Rl({
      state: d,
      transaction: y
    });
    if (!(!Lw({
      editor: e,
      state: g,
      from: Math.max(c - 1, 0),
      to: f.b - 1,
      rule: p,
      pasteEvent: h,
      dropEvent: a
    }) || !y.steps.length)) {
      try {
        a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        a = null;
      }
      return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, y;
    }
  };
  return t.map((d) => new bt({
    // we register a global drag handler to track the current drag source element
    view(c) {
      const f = (h) => {
        var y;
        r = !((y = c.dom.parentElement) === null || y === void 0) && y.contains(h.target) ? c.dom.parentElement : null, r && (Qo = e);
      }, p = () => {
        Qo && (Qo = null);
      };
      return window.addEventListener("dragstart", f), window.addEventListener("dragend", p), {
        destroy() {
          window.removeEventListener("dragstart", f), window.removeEventListener("dragend", p);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (c, f) => {
          if (s = r === c.dom.parentElement, a = f, !s) {
            const p = Qo;
            p && setTimeout(() => {
              const h = p.state.selection;
              h && p.commands.deleteRange({ from: h.from, to: h.to });
            }, 10);
          }
          return !1;
        },
        paste: (c, f) => {
          var p;
          const h = (p = f.clipboardData) === null || p === void 0 ? void 0 : p.getData("text/html");
          return o = f, i = !!(h != null && h.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (c, f, p) => {
      const h = c[0], y = h.getMeta("uiEvent") === "paste" && !i, g = h.getMeta("uiEvent") === "drop" && !s, m = h.getMeta("applyPasteRules"), $ = !!m;
      if (!y && !g && !$)
        return;
      if ($) {
        let { text: L } = m;
        typeof L == "string" ? L = L : L = Bl(re.from(L), p.schema);
        const { from: S } = m, R = S + L.length, O = Rw(L);
        return l({
          rule: d,
          state: p,
          from: S,
          to: { b: R },
          pasteEvt: O
        });
      }
      const w = f.doc.content.findDiffStart(p.doc.content), _ = f.doc.content.findDiffEnd(p.doc.content);
      if (!(!Aw(w) || !_ || w === _.b))
        return l({
          rule: d,
          state: p,
          from: w,
          to: _,
          pasteEvt: o
        });
    }
  }));
}
function Iw(n) {
  const e = n.filter((t, r) => n.indexOf(t) !== r);
  return Array.from(new Set(e));
}
class ui {
  constructor(e, t) {
    this.splittableMarks = [], this.editor = t, this.extensions = ui.resolve(e), this.schema = t3(this.extensions, t), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const t = ui.sort(ui.flatten(e)), r = Iw(t.map((i) => i.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((i) => `'${i}'`).join(", ")}]. This can lead to issues.`), t;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((t) => {
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage
      }, i = me(t, "addExtensions", r);
      return i ? [t, ...this.flatten(i())] : t;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((r, i) => {
      const s = me(r, "priority") || 100, o = me(i, "priority") || 100;
      return s > o ? -1 : s < o ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, t) => {
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: Su(t.name, this.schema)
      }, i = me(t, "addCommands", r);
      return i ? {
        ...e,
        ...i()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, t = ui.sort([...this.extensions].reverse()), r = [], i = [], s = t.map((o) => {
      const a = {
        name: o.name,
        options: o.options,
        storage: o.storage,
        editor: e,
        type: Su(o.name, this.schema)
      }, l = [], u = me(o, "addKeyboardShortcuts", a);
      let d = {};
      if (o.type === "mark" && me(o, "exitable", a) && (d.ArrowRight = () => In.handleExit({ editor: e, mark: o })), u) {
        const y = Object.fromEntries(Object.entries(u()).map(([g, m]) => [g, () => m({ editor: e })]));
        d = { ...d, ...y };
      }
      const c = Zx(d);
      l.push(c);
      const f = me(o, "addInputRules", a);
      yf(o, e.options.enableInputRules) && f && r.push(...f());
      const p = me(o, "addPasteRules", a);
      yf(o, e.options.enablePasteRules) && p && i.push(...p());
      const h = me(o, "addProseMirrorPlugins", a);
      if (h) {
        const y = h();
        l.push(...y);
      }
      return l;
    }).flat();
    return [
      Ow({
        editor: e,
        rules: r
      }),
      ...Pw({
        editor: e,
        rules: i
      }),
      ...s
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Qh(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: t } = Il(this.extensions);
    return Object.fromEntries(t.filter((r) => !!me(r, "addNodeView")).map((r) => {
      const i = this.attributes.filter((l) => l.type === r.name), s = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: e,
        type: Ct(r.name, this.schema)
      }, o = me(r, "addNodeView", s);
      if (!o)
        return [];
      const a = (l, u, d, c, f) => {
        const p = Nd(l, i);
        return o()({
          // pass-through
          node: l,
          view: u,
          getPos: d,
          decorations: c,
          innerDecorations: f,
          // tiptap-specific
          editor: e,
          extension: r,
          HTMLAttributes: p
        });
      };
      return [r.name, a];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var t;
      this.editor.extensionStorage[e.name] = e.storage;
      const r = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: Su(e.name, this.schema)
      };
      e.type === "mark" && (!((t = Ne(me(e, "keepOnSplit", r))) !== null && t !== void 0) || t) && this.splittableMarks.push(e.name);
      const i = me(e, "onBeforeCreate", r), s = me(e, "onCreate", r), o = me(e, "onUpdate", r), a = me(e, "onSelectionUpdate", r), l = me(e, "onTransaction", r), u = me(e, "onFocus", r), d = me(e, "onBlur", r), c = me(e, "onDestroy", r);
      i && this.editor.on("beforeCreate", i), s && this.editor.on("create", s), o && this.editor.on("update", o), a && this.editor.on("selectionUpdate", a), l && this.editor.on("transaction", l), u && this.editor.on("focus", u), d && this.editor.on("blur", d), c && this.editor.on("destroy", c);
    });
  }
}
class St {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ne(me(this, "addOptions", {
      name: this.name
    }))), this.storage = Ne(me(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new St(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => Vl(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new St({ ...this.config, ...e });
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = Ne(me(t, "addOptions", {
      name: t.name
    })), t.storage = Ne(me(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function n3(n, e, t) {
  const { from: r, to: i } = e, { blockSeparator: s = `

`, textSerializers: o = {} } = t || {};
  let a = "";
  return n.nodesBetween(r, i, (l, u, d, c) => {
    var f;
    l.isBlock && u > r && (a += s);
    const p = o == null ? void 0 : o[l.type.name];
    if (p)
      return d && (a += p({
        node: l,
        pos: u,
        parent: d,
        index: c,
        range: e
      })), !1;
    l.isText && (a += (f = l == null ? void 0 : l.text) === null || f === void 0 ? void 0 : f.slice(Math.max(r, u) - u, i - u));
  }), a;
}
function F1(n) {
  return Object.fromEntries(Object.entries(n.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText]));
}
const Bw = St.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new bt({
        key: new Jt("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: n } = this, { state: e, schema: t } = n, { doc: r, selection: i } = e, { ranges: s } = i, o = Math.min(...s.map((d) => d.$from.pos)), a = Math.max(...s.map((d) => d.$to.pos)), l = F1(t);
            return n3(r, { from: o, to: a }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), zw = () => ({ editor: n, view: e }) => (requestAnimationFrame(() => {
  var t;
  n.isDestroyed || (e.dom.blur(), (t = window == null ? void 0 : window.getSelection()) === null || t === void 0 || t.removeAllRanges());
}), !0), Vw = (n = !1) => ({ commands: e }) => e.setContent("", n), Fw = () => ({ state: n, tr: e, dispatch: t }) => {
  const { selection: r } = e, { ranges: i } = r;
  return t && i.forEach(({ $from: s, $to: o }) => {
    n.doc.nodesBetween(s.pos, o.pos, (a, l) => {
      if (a.type.isText)
        return;
      const { doc: u, mapping: d } = e, c = u.resolve(d.map(l)), f = u.resolve(d.map(l + a.nodeSize)), p = c.blockRange(f);
      if (!p)
        return;
      const h = xs(p);
      if (a.type.isTextblock) {
        const { defaultType: y } = c.parent.contentMatchAt(c.index());
        e.setNodeMarkup(p.start, y);
      }
      (h || h === 0) && e.lift(p, h);
    });
  }), !0;
}, jw = (n) => (e) => n(e), Hw = () => ({ state: n, dispatch: e }) => dw(n, e), Uw = (n, e) => ({ editor: t, tr: r }) => {
  const { state: i } = t, s = i.doc.slice(n.from, n.to);
  r.deleteRange(n.from, n.to);
  const o = r.mapping.map(e);
  return r.insert(o, s.content), r.setSelection(new Ce(r.doc.resolve(o - 1))), !0;
}, Ww = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, r = t.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = n.selection.$anchor;
  for (let s = i.depth; s > 0; s -= 1)
    if (i.node(s).type === r.type) {
      if (e) {
        const a = i.before(s), l = i.after(s);
        n.delete(a, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, qw = (n) => ({ tr: e, state: t, dispatch: r }) => {
  const i = Ct(n, t.schema), s = e.selection.$anchor;
  for (let o = s.depth; o > 0; o -= 1)
    if (s.node(o).type === i) {
      if (r) {
        const l = s.before(o), u = s.after(o);
        e.delete(l, u).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Kw = (n) => ({ tr: e, dispatch: t }) => {
  const { from: r, to: i } = n;
  return t && e.delete(r, i), !0;
}, Gw = () => ({ state: n, dispatch: e }) => Xx(n, e), Yw = () => ({ commands: n }) => n.keyboardShortcut("Enter"), Jw = () => ({ state: n, dispatch: e }) => uw(n, e);
function Fa(n, e, t = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((i) => t.strict ? e[i] === n[i] : V1(e[i]) ? e[i].test(n[i]) : e[i] === n[i]) : !0;
}
function r3(n, e, t = {}) {
  return n.find((r) => r.type === e && Fa(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((i) => [i, r.attrs[i]])),
    t
  ));
}
function vf(n, e, t = {}) {
  return !!r3(n, e, t);
}
function j1(n, e, t) {
  var r;
  if (!n || !e)
    return;
  let i = n.parent.childAfter(n.parentOffset);
  if ((!i.node || !i.node.marks.some((d) => d.type === e)) && (i = n.parent.childBefore(n.parentOffset)), !i.node || !i.node.marks.some((d) => d.type === e) || (t = t || ((r = i.node.marks[0]) === null || r === void 0 ? void 0 : r.attrs), !r3([...i.node.marks], e, t)))
    return;
  let o = i.index, a = n.start() + i.offset, l = o + 1, u = a + i.node.nodeSize;
  for (; o > 0 && vf([...n.parent.child(o - 1).marks], e, t); )
    o -= 1, a -= n.parent.child(o).nodeSize;
  for (; l < n.parent.childCount && vf([...n.parent.child(l).marks], e, t); )
    u += n.parent.child(l).nodeSize, l += 1;
  return {
    from: a,
    to: u
  };
}
function Zr(n, e) {
  if (typeof n == "string") {
    if (!e.marks[n])
      throw Error(`There is no mark type named '${n}'. Maybe you forgot to add the extension?`);
    return e.marks[n];
  }
  return n;
}
const Zw = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  const s = Zr(n, r.schema), { doc: o, selection: a } = t, { $from: l, from: u, to: d } = a;
  if (i) {
    const c = j1(l, s, e);
    if (c && c.from <= u && c.to >= d) {
      const f = Ce.create(o, c.from, c.to);
      t.setSelection(f);
    }
  }
  return !0;
}, Xw = (n) => (e) => {
  const t = typeof n == "function" ? n(e) : n;
  for (let r = 0; r < t.length; r += 1)
    if (t[r](e))
      return !0;
  return !1;
};
function H1(n) {
  return n instanceof Ce;
}
function dr(n = 0, e = 0, t = 0) {
  return Math.min(Math.max(n, e), t);
}
function i3(n, e = null) {
  if (!e)
    return null;
  const t = Oe.atStart(n), r = Oe.atEnd(n);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return r;
  const i = t.from, s = r.to;
  return e === "all" ? Ce.create(n, dr(0, i, s), dr(n.content.size, i, s)) : Ce.create(n, dr(e, i, s), dr(e, i, s));
}
function Qw() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function U1() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const ek = (n = null, e = {}) => ({ editor: t, view: r, tr: i, dispatch: s }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    (U1() || Qw()) && r.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (r.focus(), e != null && e.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && n === null || n === !1)
    return !0;
  if (s && n === null && !H1(t.state.selection))
    return o(), !0;
  const a = i3(i.doc, n) || t.state.selection, l = t.state.selection.eq(a);
  return s && (l || i.setSelection(a), l && i.storedMarks && i.setStoredMarks(i.storedMarks), o()), !0;
}, tk = (n, e) => (t) => n.every((r, i) => e(r, { ...t, index: i })), nk = (n, e) => ({ tr: t, commands: r }) => r.insertContentAt({ from: t.selection.from, to: t.selection.to }, n, e), s3 = (n) => {
  const e = n.childNodes;
  for (let t = e.length - 1; t >= 0; t -= 1) {
    const r = e[t];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? n.removeChild(r) : r.nodeType === 1 && s3(r);
  }
  return n;
};
function ea(n) {
  const e = `<body>${n}</body>`, t = new window.DOMParser().parseFromString(e, "text/html").body;
  return s3(t);
}
function ja(n, e, t) {
  if (n instanceof Kn || n instanceof re)
    return n;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const r = typeof n == "object" && n !== null, i = typeof n == "string";
  if (r)
    try {
      if (Array.isArray(n) && n.length > 0)
        return re.fromArray(n.map((a) => e.nodeFromJSON(a)));
      const o = e.nodeFromJSON(n);
      return t.errorOnInvalidContent && o.check(), o;
    } catch (s) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: s });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", n, "Error:", s), ja("", e, t);
    }
  if (i) {
    if (t.errorOnInvalidContent) {
      let o = !1, a = "";
      const l = new Gp({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (u) => (o = !0, a = typeof u == "string" ? u : u.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? jr.fromSchema(l).parseSlice(ea(n), t.parseOptions) : jr.fromSchema(l).parse(ea(n), t.parseOptions), t.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${a}`) });
    }
    const s = jr.fromSchema(e);
    return t.slice ? s.parseSlice(ea(n), t.parseOptions).content : s.parse(ea(n), t.parseOptions);
  }
  return ja("", e, t);
}
function rk(n, e, t) {
  const r = n.steps.length - 1;
  if (r < e)
    return;
  const i = n.steps[r];
  if (!(i instanceof vt || i instanceof $t))
    return;
  const s = n.mapping.maps[r];
  let o = 0;
  s.forEach((a, l, u, d) => {
    o === 0 && (o = d);
  }), n.setSelection(Oe.near(n.doc.resolve(o), t));
}
const ik = (n) => !("type" in n), sk = (n, e, t) => ({ tr: r, dispatch: i, editor: s }) => {
  var o;
  if (i) {
    t = {
      parseOptions: s.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let a;
    try {
      a = ja(e, s.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...t.parseOptions
        },
        errorOnInvalidContent: (o = t.errorOnInvalidContent) !== null && o !== void 0 ? o : s.options.enableContentCheck
      });
    } catch (h) {
      return s.emit("contentError", {
        editor: s,
        error: h,
        disableCollaboration: () => {
          s.storage.collaboration && (s.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: l, to: u } = typeof n == "number" ? { from: n, to: n } : { from: n.from, to: n.to }, d = !0, c = !0;
    if ((ik(a) ? a : [a]).forEach((h) => {
      h.check(), d = d ? h.isText && h.marks.length === 0 : !1, c = c ? h.isBlock : !1;
    }), l === u && c) {
      const { parent: h } = r.doc.resolve(l);
      h.isTextblock && !h.type.spec.code && !h.childCount && (l -= 1, u += 1);
    }
    let p;
    if (d) {
      if (Array.isArray(e))
        p = e.map((h) => h.text || "").join("");
      else if (e instanceof re) {
        let h = "";
        e.forEach((y) => {
          y.text && (h += y.text);
        }), p = h;
      } else typeof e == "object" && e && e.text ? p = e.text : p = e;
      r.insertText(p, l, u);
    } else
      p = a, r.replaceWith(l, u, p);
    t.updateSelection && rk(r, r.steps.length - 1, -1), t.applyInputRules && r.setMeta("applyInputRules", { from: l, text: p }), t.applyPasteRules && r.setMeta("applyPasteRules", { from: l, text: p });
  }
  return !0;
}, ok = () => ({ state: n, dispatch: e }) => sw(n, e), ak = () => ({ state: n, dispatch: e }) => ow(n, e), lk = () => ({ state: n, dispatch: e }) => Qx(n, e), uk = () => ({ state: n, dispatch: e }) => rw(n, e), dk = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = Ol(n.doc, n.selection.$from.pos, -1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, ck = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = Ol(n.doc, n.selection.$from.pos, 1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, fk = () => ({ state: n, dispatch: e }) => ew(n, e), pk = () => ({ state: n, dispatch: e }) => tw(n, e);
function o3() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function hk(n) {
  const e = n.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let r, i, s, o;
  for (let a = 0; a < e.length - 1; a += 1) {
    const l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      s = !0;
    else if (/^mod$/i.test(l))
      U1() || o3() ? o = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (t = `Alt-${t}`), i && (t = `Ctrl-${t}`), o && (t = `Meta-${t}`), s && (t = `Shift-${t}`), t;
}
const mk = (n) => ({ editor: e, view: t, tr: r, dispatch: i }) => {
  const s = hk(n).split(/-(?!$)/), o = s.find((u) => !["Alt", "Ctrl", "Meta", "Shift"].includes(u)), a = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: s.includes("Alt"),
    ctrlKey: s.includes("Ctrl"),
    metaKey: s.includes("Meta"),
    shiftKey: s.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (u) => u(t, a));
  });
  return l == null || l.steps.forEach((u) => {
    const d = u.map(r.mapping);
    d && i && r.maybeStep(d);
  }), !0;
};
function wo(n, e, t = {}) {
  const { from: r, to: i, empty: s } = n.selection, o = e ? Ct(e, n.schema) : null, a = [];
  n.doc.nodesBetween(r, i, (c, f) => {
    if (c.isText)
      return;
    const p = Math.max(r, f), h = Math.min(i, f + c.nodeSize);
    a.push({
      node: c,
      from: p,
      to: h
    });
  });
  const l = i - r, u = a.filter((c) => o ? o.name === c.node.type.name : !0).filter((c) => Fa(c.node.attrs, t, { strict: !1 }));
  return s ? !!u.length : u.reduce((c, f) => c + f.to - f.from, 0) >= l;
}
const gk = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = Ct(n, t.schema);
  return wo(t, i, e) ? aw(t, r) : !1;
}, bk = () => ({ state: n, dispatch: e }) => cw(n, e), yk = (n) => ({ state: e, dispatch: t }) => {
  const r = Ct(n, e.schema);
  return _w(r)(e, t);
}, vk = () => ({ state: n, dispatch: e }) => lw(n, e);
function Fl(n, e) {
  return e.nodes[n] ? "node" : e.marks[n] ? "mark" : null;
}
function _f(n, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(n).reduce((r, i) => (t.includes(i) || (r[i] = n[i]), r), {});
}
const _k = (n, e) => ({ tr: t, state: r, dispatch: i }) => {
  let s = null, o = null;
  const a = Fl(typeof n == "string" ? n : n.name, r.schema);
  return a ? (a === "node" && (s = Ct(n, r.schema)), a === "mark" && (o = Zr(n, r.schema)), i && t.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (u, d) => {
      s && s === u.type && t.setNodeMarkup(d, void 0, _f(u.attrs, e)), o && u.marks.length && u.marks.forEach((c) => {
        o === c.type && t.addMark(d, d + u.nodeSize, o.create(_f(c.attrs, e)));
      });
    });
  }), !0) : !1;
}, $k = () => ({ tr: n, dispatch: e }) => (e && n.scrollIntoView(), !0), xk = () => ({ tr: n, dispatch: e }) => {
  if (e) {
    const t = new Cn(n.doc);
    n.setSelection(t);
  }
  return !0;
}, wk = () => ({ state: n, dispatch: e }) => nw(n, e), kk = () => ({ state: n, dispatch: e }) => iw(n, e), Ck = () => ({ state: n, dispatch: e }) => fw(n, e), Sk = () => ({ state: n, dispatch: e }) => mw(n, e), Ek = () => ({ state: n, dispatch: e }) => hw(n, e);
function Dd(n, e, t = {}, r = {}) {
  return ja(n, e, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const Tk = (n, e = !1, t = {}, r = {}) => ({ editor: i, tr: s, dispatch: o, commands: a }) => {
  var l, u;
  const { doc: d } = s;
  if (t.preserveWhitespace !== "full") {
    const c = Dd(n, i.schema, t, {
      errorOnInvalidContent: (l = r.errorOnInvalidContent) !== null && l !== void 0 ? l : i.options.enableContentCheck
    });
    return o && s.replaceWith(0, d.content.size, c).setMeta("preventUpdate", !e), !0;
  }
  return o && s.setMeta("preventUpdate", !e), a.insertContentAt({ from: 0, to: d.content.size }, n, {
    parseOptions: t,
    errorOnInvalidContent: (u = r.errorOnInvalidContent) !== null && u !== void 0 ? u : i.options.enableContentCheck
  });
};
function a3(n, e) {
  const t = Zr(e, n.schema), { from: r, to: i, empty: s } = n.selection, o = [];
  s ? (n.storedMarks && o.push(...n.storedMarks), o.push(...n.selection.$head.marks())) : n.doc.nodesBetween(r, i, (l) => {
    o.push(...l.marks);
  });
  const a = o.find((l) => l.type.name === t.name);
  return a ? { ...a.attrs } : {};
}
function Ok(n, e) {
  const t = new dh(n);
  return e.forEach((r) => {
    r.steps.forEach((i) => {
      t.step(i);
    });
  }), t;
}
function Mk(n) {
  for (let e = 0; e < n.edgeCount; e += 1) {
    const { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function Ak(n, e, t) {
  const r = [];
  return n.nodesBetween(e.from, e.to, (i, s) => {
    t(i) && r.push({
      node: i,
      pos: s
    });
  }), r;
}
function Nk(n, e) {
  for (let t = n.depth; t > 0; t -= 1) {
    const r = n.node(t);
    if (e(r))
      return {
        pos: t > 0 ? n.before(t) : 0,
        start: n.start(t),
        depth: t,
        node: r
      };
  }
}
function W1(n) {
  return (e) => Nk(e.$from, n);
}
function l3(n, e) {
  const t = ui.resolve(n);
  return t3(t, e);
}
function Dk(n, e) {
  const t = l3(e), r = Kn.fromJSON(t, n);
  return Bl(r.content, t);
}
function u3(n, e) {
  const t = {
    from: 0,
    to: n.content.size
  };
  return n3(n, t, e);
}
function Lk(n, e) {
  const t = Ct(e, n.schema), { from: r, to: i } = n.selection, s = [];
  n.doc.nodesBetween(r, i, (a) => {
    s.push(a);
  });
  const o = s.reverse().find((a) => a.type.name === t.name);
  return o ? { ...o.attrs } : {};
}
function d3(n, e) {
  const t = Fl(typeof e == "string" ? e : e.name, n.schema);
  return t === "node" ? Lk(n, e) : t === "mark" ? a3(n, e) : {};
}
function Rk(n, e = JSON.stringify) {
  const t = {};
  return n.filter((r) => {
    const i = e(r);
    return Object.prototype.hasOwnProperty.call(t, i) ? !1 : t[i] = !0;
  });
}
function Pk(n) {
  const e = Rk(n);
  return e.length === 1 ? e : e.filter((t, r) => !e.filter((s, o) => o !== r).some((s) => t.oldRange.from >= s.oldRange.from && t.oldRange.to <= s.oldRange.to && t.newRange.from >= s.newRange.from && t.newRange.to <= s.newRange.to));
}
function Ik(n) {
  const { mapping: e, steps: t } = n, r = [];
  return e.maps.forEach((i, s) => {
    const o = [];
    if (i.ranges.length)
      i.forEach((a, l) => {
        o.push({ from: a, to: l });
      });
    else {
      const { from: a, to: l } = t[s];
      if (a === void 0 || l === void 0)
        return;
      o.push({ from: a, to: l });
    }
    o.forEach(({ from: a, to: l }) => {
      const u = e.slice(s).map(a, -1), d = e.slice(s).map(l), c = e.invert().map(u, -1), f = e.invert().map(d);
      r.push({
        oldRange: {
          from: c,
          to: f
        },
        newRange: {
          from: u,
          to: d
        }
      });
    });
  }), Pk(r);
}
function q1(n, e, t) {
  const r = [];
  return n === e ? t.resolve(n).marks().forEach((i) => {
    const s = t.resolve(n), o = j1(s, i.type);
    o && r.push({
      mark: i,
      ...o
    });
  }) : t.nodesBetween(n, e, (i, s) => {
    !i || (i == null ? void 0 : i.nodeSize) === void 0 || r.push(...i.marks.map((o) => ({
      from: s,
      to: s + i.nodeSize,
      mark: o
    })));
  }), r;
}
function va(n, e, t) {
  return Object.fromEntries(Object.entries(t).filter(([r]) => {
    const i = n.find((s) => s.type === e && s.name === r);
    return i ? i.attribute.keepOnSplit : !1;
  }));
}
function Ld(n, e, t = {}) {
  const { empty: r, ranges: i } = n.selection, s = e ? Zr(e, n.schema) : null;
  if (r)
    return !!(n.storedMarks || n.selection.$from.marks()).filter((c) => s ? s.name === c.type.name : !0).find((c) => Fa(c.attrs, t, { strict: !1 }));
  let o = 0;
  const a = [];
  if (i.forEach(({ $from: c, $to: f }) => {
    const p = c.pos, h = f.pos;
    n.doc.nodesBetween(p, h, (y, g) => {
      if (!y.isText && !y.marks.length)
        return;
      const m = Math.max(p, g), $ = Math.min(h, g + y.nodeSize), w = $ - m;
      o += w, a.push(...y.marks.map((_) => ({
        mark: _,
        from: m,
        to: $
      })));
    });
  }), o === 0)
    return !1;
  const l = a.filter((c) => s ? s.name === c.mark.type.name : !0).filter((c) => Fa(c.mark.attrs, t, { strict: !1 })).reduce((c, f) => c + f.to - f.from, 0), u = a.filter((c) => s ? c.mark.type !== s && c.mark.type.excludes(s) : !0).reduce((c, f) => c + f.to - f.from, 0);
  return (l > 0 ? l + u : l) >= o;
}
function Bk(n, e, t = {}) {
  if (!e)
    return wo(n, null, t) || Ld(n, null, t);
  const r = Fl(e, n.schema);
  return r === "node" ? wo(n, e, t) : r === "mark" ? Ld(n, e, t) : !1;
}
function $f(n, e) {
  const { nodeExtensions: t } = Il(e), r = t.find((o) => o.name === n);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, s = Ne(me(r, "group", i));
  return typeof s != "string" ? !1 : s.split(" ").includes("list");
}
function K1(n, { checkChildren: e = !0, ignoreWhitespace: t = !1 } = {}) {
  var r;
  if (t) {
    if (n.type.name === "hardBreak")
      return !0;
    if (n.isText)
      return /^\s*$/m.test((r = n.text) !== null && r !== void 0 ? r : "");
  }
  if (n.isText)
    return !n.text;
  if (n.isAtom || n.isLeaf)
    return !1;
  if (n.content.childCount === 0)
    return !0;
  if (e) {
    let i = !0;
    return n.content.forEach((s) => {
      i !== !1 && (K1(s, { ignoreWhitespace: t, checkChildren: e }) || (i = !1));
    }), i;
  }
  return !1;
}
function c3(n) {
  return n instanceof ve;
}
function f3(n, e, t) {
  const i = n.state.doc.content.size, s = dr(e, 0, i), o = dr(t, 0, i), a = n.coordsAtPos(s), l = n.coordsAtPos(o, -1), u = Math.min(a.top, l.top), d = Math.max(a.bottom, l.bottom), c = Math.min(a.left, l.left), f = Math.max(a.right, l.right), p = f - c, h = d - u, m = {
    top: u,
    bottom: d,
    left: c,
    right: f,
    width: p,
    height: h,
    x: c,
    y: u
  };
  return {
    ...m,
    toJSON: () => m
  };
}
function zk(n, e, t) {
  var r;
  const { selection: i } = e;
  let s = null;
  if (H1(i) && (s = i.$cursor), s) {
    const a = (r = n.storedMarks) !== null && r !== void 0 ? r : s.marks();
    return !!t.isInSet(a) || !a.some((l) => l.type.excludes(t));
  }
  const { ranges: o } = i;
  return o.some(({ $from: a, $to: l }) => {
    let u = a.depth === 0 ? n.doc.inlineContent && n.doc.type.allowsMarkType(t) : !1;
    return n.doc.nodesBetween(a.pos, l.pos, (d, c, f) => {
      if (u)
        return !1;
      if (d.isInline) {
        const p = !f || f.type.allowsMarkType(t), h = !!t.isInSet(d.marks) || !d.marks.some((y) => y.type.excludes(t));
        u = p && h;
      }
      return !u;
    }), u;
  });
}
const Vk = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  const { selection: s } = t, { empty: o, ranges: a } = s, l = Zr(n, r.schema);
  if (i)
    if (o) {
      const u = a3(r, l);
      t.addStoredMark(l.create({
        ...u,
        ...e
      }));
    } else
      a.forEach((u) => {
        const d = u.$from.pos, c = u.$to.pos;
        r.doc.nodesBetween(d, c, (f, p) => {
          const h = Math.max(p, d), y = Math.min(p + f.nodeSize, c);
          f.marks.find((m) => m.type === l) ? f.marks.forEach((m) => {
            l === m.type && t.addMark(h, y, l.create({
              ...m.attrs,
              ...e
            }));
          }) : t.addMark(h, y, l.create(e));
        });
      });
  return zk(r, t, l);
}, Fk = (n, e) => ({ tr: t }) => (t.setMeta(n, e), !0), jk = (n, e = {}) => ({ state: t, dispatch: r, chain: i }) => {
  const s = Ct(n, t.schema);
  let o;
  return t.selection.$anchor.sameParent(t.selection.$head) && (o = t.selection.$anchor.parent.attrs), s.isTextblock ? i().command(({ commands: a }) => mf(s, { ...o, ...e })(t) ? !0 : a.clearNodes()).command(({ state: a }) => mf(s, { ...o, ...e })(a, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, Hk = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, i = dr(n, 0, r.content.size), s = ve.create(r, i);
    e.setSelection(s);
  }
  return !0;
}, Uk = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, { from: i, to: s } = typeof n == "number" ? { from: n, to: n } : n, o = Ce.atStart(r).from, a = Ce.atEnd(r).to, l = dr(i, o, a), u = dr(s, o, a), d = Ce.create(r, l, u);
    e.setSelection(d);
  }
  return !0;
}, Wk = (n) => ({ state: e, dispatch: t }) => {
  const r = Ct(n, e.schema);
  return ww(r)(e, t);
};
function xf(n, e) {
  const t = n.storedMarks || n.selection.$to.parentOffset && n.selection.$from.marks();
  if (t) {
    const r = t.filter((i) => e == null ? void 0 : e.includes(i.type.name));
    n.tr.ensureMarks(r);
  }
}
const qk = ({ keepMarks: n = !0 } = {}) => ({ tr: e, state: t, dispatch: r, editor: i }) => {
  const { selection: s, doc: o } = e, { $from: a, $to: l } = s, u = i.extensionManager.attributes, d = va(u, a.node().type.name, a.node().attrs);
  if (s instanceof ve && s.node.isBlock)
    return !a.parentOffset || !es(o, a.pos) ? !1 : (r && (n && xf(t, i.extensionManager.splittableMarks), e.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  const c = l.parentOffset === l.parent.content.size, f = a.depth === 0 ? void 0 : Mk(a.node(-1).contentMatchAt(a.indexAfter(-1)));
  let p = c && f ? [
    {
      type: f,
      attrs: d
    }
  ] : void 0, h = es(e.doc, e.mapping.map(a.pos), 1, p);
  if (!p && !h && es(e.doc, e.mapping.map(a.pos), 1, f ? [{ type: f }] : void 0) && (h = !0, p = f ? [
    {
      type: f,
      attrs: d
    }
  ] : void 0), r) {
    if (h && (s instanceof Ce && e.deleteSelection(), e.split(e.mapping.map(a.pos), 1, p), f && !c && !a.parentOffset && a.parent.type !== f)) {
      const y = e.mapping.map(a.before()), g = e.doc.resolve(y);
      a.node(-1).canReplaceWith(g.index(), g.index() + 1, f) && e.setNodeMarkup(e.mapping.map(a.before()), f);
    }
    n && xf(t, i.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return h;
}, Kk = (n, e = {}) => ({ tr: t, state: r, dispatch: i, editor: s }) => {
  var o;
  const a = Ct(n, r.schema), { $from: l, $to: u } = r.selection, d = r.selection.node;
  if (d && d.isBlock || l.depth < 2 || !l.sameParent(u))
    return !1;
  const c = l.node(-1);
  if (c.type !== a)
    return !1;
  const f = s.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== a || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (i) {
      let m = re.empty;
      const $ = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let O = l.depth - $; O >= l.depth - 3; O -= 1)
        m = re.from(l.node(O).copy(m));
      const w = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, _ = {
        ...va(f, l.node().type.name, l.node().attrs),
        ...e
      }, L = ((o = a.contentMatch.defaultType) === null || o === void 0 ? void 0 : o.createAndFill(_)) || void 0;
      m = m.append(re.from(a.createAndFill(null, L) || void 0));
      const S = l.before(l.depth - ($ - 1));
      t.replace(S, l.after(-w), new de(m, 4 - $, 0));
      let R = -1;
      t.doc.nodesBetween(S, t.doc.content.size, (O, I) => {
        if (R > -1)
          return !1;
        O.isTextblock && O.content.size === 0 && (R = I + 1);
      }), R > -1 && t.setSelection(Ce.near(t.doc.resolve(R))), t.scrollIntoView();
    }
    return !0;
  }
  const p = u.pos === l.end() ? c.contentMatchAt(0).defaultType : null, h = {
    ...va(f, c.type.name, c.attrs),
    ...e
  }, y = {
    ...va(f, l.node().type.name, l.node().attrs),
    ...e
  };
  t.delete(l.pos, u.pos);
  const g = p ? [
    { type: a, attrs: h },
    { type: p, attrs: y }
  ] : [{ type: a, attrs: h }];
  if (!es(t.doc, l.pos, 2))
    return !1;
  if (i) {
    const { selection: m, storedMarks: $ } = r, { splittableMarks: w } = s.extensionManager, _ = $ || m.$to.parentOffset && m.$from.marks();
    if (t.split(l.pos, 2, g).scrollIntoView(), !_ || !i)
      return !0;
    const L = _.filter((S) => w.includes(S.type.name));
    t.ensureMarks(L);
  }
  return !0;
}, Eu = (n, e) => {
  const t = W1((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (r === void 0)
    return !0;
  const i = n.doc.nodeAt(r);
  return t.node.type === (i == null ? void 0 : i.type) && Yr(n.doc, t.pos) && n.join(t.pos), !0;
}, Tu = (n, e) => {
  const t = W1((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(t.start).after(t.depth);
  if (r === void 0)
    return !0;
  const i = n.doc.nodeAt(r);
  return t.node.type === (i == null ? void 0 : i.type) && Yr(n.doc, r) && n.join(r), !0;
}, Gk = (n, e, t, r = {}) => ({ editor: i, tr: s, state: o, dispatch: a, chain: l, commands: u, can: d }) => {
  const { extensions: c, splittableMarks: f } = i.extensionManager, p = Ct(n, o.schema), h = Ct(e, o.schema), { selection: y, storedMarks: g } = o, { $from: m, $to: $ } = y, w = m.blockRange($), _ = g || y.$to.parentOffset && y.$from.marks();
  if (!w)
    return !1;
  const L = W1((S) => $f(S.type.name, c))(y);
  if (w.depth >= 1 && L && w.depth - L.depth <= 1) {
    if (L.node.type === p)
      return u.liftListItem(h);
    if ($f(L.node.type.name, c) && p.validContent(L.node.content) && a)
      return l().command(() => (s.setNodeMarkup(L.pos, p), !0)).command(() => Eu(s, p)).command(() => Tu(s, p)).run();
  }
  return !t || !_ || !a ? l().command(() => d().wrapInList(p, r) ? !0 : u.clearNodes()).wrapInList(p, r).command(() => Eu(s, p)).command(() => Tu(s, p)).run() : l().command(() => {
    const S = d().wrapInList(p, r), R = _.filter((O) => f.includes(O.type.name));
    return s.ensureMarks(R), S ? !0 : u.clearNodes();
  }).wrapInList(p, r).command(() => Eu(s, p)).command(() => Tu(s, p)).run();
}, Yk = (n, e = {}, t = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: s = !1 } = t, o = Zr(n, r.schema);
  return Ld(r, o, e) ? i.unsetMark(o, { extendEmptyMarkRange: s }) : i.setMark(o, e);
}, Jk = (n, e, t = {}) => ({ state: r, commands: i }) => {
  const s = Ct(n, r.schema), o = Ct(e, r.schema), a = wo(r, s, t);
  let l;
  return r.selection.$anchor.sameParent(r.selection.$head) && (l = r.selection.$anchor.parent.attrs), a ? i.setNode(o, l) : i.setNode(s, { ...l, ...t });
}, Zk = (n, e = {}) => ({ state: t, commands: r }) => {
  const i = Ct(n, t.schema);
  return wo(t, i, e) ? r.lift(i) : r.wrapIn(i, e);
}, Xk = () => ({ state: n, dispatch: e }) => {
  const t = n.plugins;
  for (let r = 0; r < t.length; r += 1) {
    const i = t[r];
    let s;
    if (i.spec.isInputRules && (s = i.getState(n))) {
      if (e) {
        const o = n.tr, a = s.transform;
        for (let l = a.steps.length - 1; l >= 0; l -= 1)
          o.step(a.steps[l].invert(a.docs[l]));
        if (s.text) {
          const l = o.doc.resolve(s.from).marks();
          o.replaceWith(s.from, s.to, n.schema.text(s.text, l));
        } else
          o.delete(s.from, s.to);
      }
      return !0;
    }
  }
  return !1;
}, Qk = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, { empty: r, ranges: i } = t;
  return r || e && i.forEach((s) => {
    n.removeMark(s.$from.pos, s.$to.pos);
  }), !0;
}, eC = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  var s;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: a } = t, l = Zr(n, r.schema), { $from: u, empty: d, ranges: c } = a;
  if (!i)
    return !0;
  if (d && o) {
    let { from: f, to: p } = a;
    const h = (s = u.marks().find((g) => g.type === l)) === null || s === void 0 ? void 0 : s.attrs, y = j1(u, l, h);
    y && (f = y.from, p = y.to), t.removeMark(f, p, l);
  } else
    c.forEach((f) => {
      t.removeMark(f.$from.pos, f.$to.pos, l);
    });
  return t.removeStoredMark(l), !0;
}, tC = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  let s = null, o = null;
  const a = Fl(typeof n == "string" ? n : n.name, r.schema);
  return a ? (a === "node" && (s = Ct(n, r.schema)), a === "mark" && (o = Zr(n, r.schema)), i && t.selection.ranges.forEach((l) => {
    const u = l.$from.pos, d = l.$to.pos;
    let c, f, p, h;
    t.selection.empty ? r.doc.nodesBetween(u, d, (y, g) => {
      s && s === y.type && (p = Math.max(g, u), h = Math.min(g + y.nodeSize, d), c = g, f = y);
    }) : r.doc.nodesBetween(u, d, (y, g) => {
      g < u && s && s === y.type && (p = Math.max(g, u), h = Math.min(g + y.nodeSize, d), c = g, f = y), g >= u && g <= d && (s && s === y.type && t.setNodeMarkup(g, void 0, {
        ...y.attrs,
        ...e
      }), o && y.marks.length && y.marks.forEach((m) => {
        if (o === m.type) {
          const $ = Math.max(g, u), w = Math.min(g + y.nodeSize, d);
          t.addMark($, w, o.create({
            ...m.attrs,
            ...e
          }));
        }
      }));
    }), f && (c !== void 0 && t.setNodeMarkup(c, void 0, {
      ...f.attrs,
      ...e
    }), o && f.marks.length && f.marks.forEach((y) => {
      o === y.type && t.addMark(p, h, o.create({
        ...y.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, nC = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = Ct(n, t.schema);
  return gw(i, e)(t, r);
}, rC = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = Ct(n, t.schema);
  return bw(i, e)(t, r);
};
var iC = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: zw,
  clearContent: Vw,
  clearNodes: Fw,
  command: jw,
  createParagraphNear: Hw,
  cut: Uw,
  deleteCurrentNode: Ww,
  deleteNode: qw,
  deleteRange: Kw,
  deleteSelection: Gw,
  enter: Yw,
  exitCode: Jw,
  extendMarkRange: Zw,
  first: Xw,
  focus: ek,
  forEach: tk,
  insertContent: nk,
  insertContentAt: sk,
  joinBackward: lk,
  joinDown: ak,
  joinForward: uk,
  joinItemBackward: dk,
  joinItemForward: ck,
  joinTextblockBackward: fk,
  joinTextblockForward: pk,
  joinUp: ok,
  keyboardShortcut: mk,
  lift: gk,
  liftEmptyBlock: bk,
  liftListItem: yk,
  newlineInCode: vk,
  resetAttributes: _k,
  scrollIntoView: $k,
  selectAll: xk,
  selectNodeBackward: wk,
  selectNodeForward: kk,
  selectParentNode: Ck,
  selectTextblockEnd: Sk,
  selectTextblockStart: Ek,
  setContent: Tk,
  setMark: Vk,
  setMeta: Fk,
  setNode: jk,
  setNodeSelection: Hk,
  setTextSelection: Uk,
  sinkListItem: Wk,
  splitBlock: qk,
  splitListItem: Kk,
  toggleList: Gk,
  toggleMark: Yk,
  toggleNode: Jk,
  toggleWrap: Zk,
  undoInputRule: Xk,
  unsetAllMarks: Qk,
  unsetMark: eC,
  updateAttributes: tC,
  wrapIn: nC,
  wrapInList: rC
});
const sC = St.create({
  name: "commands",
  addCommands() {
    return {
      ...iC
    };
  }
}), oC = St.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new bt({
        key: new Jt("tiptapDrop"),
        props: {
          handleDrop: (n, e, t, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: t,
              moved: r
            });
          }
        }
      })
    ];
  }
}), aC = St.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new bt({
        key: new Jt("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), lC = new Jt("focusEvents"), uC = St.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: n } = this;
    return [
      new bt({
        key: lC,
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              n.isFocused = !0;
              const r = n.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, t) => {
              n.isFocused = !1;
              const r = n.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), dC = St.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: a }) => {
        const { selection: l, doc: u } = a, { empty: d, $anchor: c } = l, { pos: f, parent: p } = c, h = c.parent.isTextblock && f > 0 ? a.doc.resolve(f - 1) : c, y = h.parent.type.spec.isolating, g = c.pos - c.parentOffset, m = y && h.parent.childCount === 1 ? g === c.pos : Oe.atStart(u).from === f;
        return !d || !p.type.isTextblock || p.textContent.length || !m || m && c.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: n,
      "Mod-Backspace": n,
      "Shift-Backspace": n,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, s = {
      ...r,
      "Ctrl-h": n,
      "Alt-Backspace": n,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return U1() || o3() ? s : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new bt({
        key: new Jt("clearDocument"),
        appendTransaction: (n, e, t) => {
          if (n.some((y) => y.getMeta("composition")))
            return;
          const r = n.some((y) => y.docChanged) && !e.doc.eq(t.doc), i = n.some((y) => y.getMeta("preventClearDocument"));
          if (!r || i)
            return;
          const { empty: s, from: o, to: a } = e.selection, l = Oe.atStart(e.doc).from, u = Oe.atEnd(e.doc).to;
          if (s || !(o === l && a === u) || !K1(t.doc))
            return;
          const f = t.tr, p = Rl({
            state: t,
            transaction: f
          }), { commands: h } = new Pl({
            editor: this.editor,
            state: p
          });
          if (h.clearNodes(), !!f.steps.length)
            return f;
        }
      })
    ];
  }
}), cC = St.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new bt({
        key: new Jt("tiptapPaste"),
        props: {
          handlePaste: (n, e, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: t
            });
          }
        }
      })
    ];
  }
}), fC = St.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new bt({
        key: new Jt("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class oi {
  get name() {
    return this.node.type.name;
  }
  constructor(e, t, r = !1, i = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = t, this.currentNode = i;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let t = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(e);
    return new oi(t, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new oi(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new oi(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((t, r) => {
      const i = t.isBlock && !t.isTextblock, s = t.isAtom && !t.isText, o = this.pos + r + (s ? 0 : 1), a = this.resolvedPos.doc.resolve(o);
      if (!i && a.depth <= this.depth)
        return;
      const l = new oi(a, this.editor, i, i ? t : null);
      i && (l.actualDepth = this.depth + 1), e.push(new oi(a, this.editor, i, i ? t : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, t = {}) {
    let r = null, i = this.parent;
    for (; i && !r; ) {
      if (i.node.type.name === e)
        if (Object.keys(t).length > 0) {
          const s = i.node.attrs, o = Object.keys(t);
          for (let a = 0; a < o.length; a += 1) {
            const l = o[a];
            if (s[l] !== t[l])
              break;
          }
        } else
          r = i;
      i = i.parent;
    }
    return r;
  }
  querySelector(e, t = {}) {
    return this.querySelectorAll(e, t, !0)[0] || null;
  }
  querySelectorAll(e, t = {}, r = !1) {
    let i = [];
    if (!this.children || this.children.length === 0)
      return i;
    const s = Object.keys(t);
    return this.children.forEach((o) => {
      r && i.length > 0 || (o.node.type.name === e && s.every((l) => t[l] === o.node.attrs[l]) && i.push(o), !(r && i.length > 0) && (i = i.concat(o.querySelectorAll(e, t, r))));
    }), i;
  }
  setAttribute(e) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(t);
  }
}
const pC = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function hC(n, e, t) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const i = document.createElement("style");
  return e && i.setAttribute("nonce", e), i.setAttribute("data-tiptap-style", ""), i.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(i), i;
}
let mC = class extends kw {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: t }) => {
        throw t;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: t, slice: r, moved: i }) => this.options.onDrop(t, r, i)), this.on("paste", ({ event: t, slice: r }) => this.options.onPaste(t, r)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = hC(pC, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, t = !0) {
    this.setOptions({ editable: e }), t && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, t) {
    const r = e3(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e], i = this.state.reconfigure({ plugins: r });
    return this.view.updateState(i), i;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let r = t;
    if ([].concat(e).forEach((s) => {
      const o = typeof s == "string" ? `${s}$` : s.key;
      r = t.filter((a) => !a.key.startsWith(o));
    }), t.length === r.length)
      return;
    const i = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(i), i;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, t;
    const i = [...this.options.enableCoreExtensions ? [
      aC,
      Bw.configure({
        blockSeparator: (t = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || t === void 0 ? void 0 : t.blockSeparator
      }),
      sC,
      uC,
      dC,
      fC,
      oC,
      cC
    ].filter((s) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[s.name] !== !1 : !0) : [], ...this.options.extensions].filter((s) => ["extension", "node", "mark"].includes(s == null ? void 0 : s.type));
    this.extensionManager = new ui(i, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new Pl({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var e;
    let t;
    try {
      t = Dd(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (o) {
      if (!(o instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(o.message))
        throw o;
      this.emit("contentError", {
        editor: this,
        error: o,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((a) => a.name !== "collaboration"), this.createExtensionManager();
        }
      }), t = Dd(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const r = i3(t, this.options.autofocus);
    this.view = new jx(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) === null || e === void 0 ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: Ki.create({
        doc: t,
        selection: r || void 0
      })
    });
    const i = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(i), this.createNodeViews(), this.prependClass();
    const s = this.view.dom;
    s.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((o) => {
        var a;
        return (a = this.capturedTransaction) === null || a === void 0 ? void 0 : a.step(o);
      });
      return;
    }
    const t = this.state.apply(e), r = !this.state.selection.eq(t.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: t
    }), this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: e
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const i = e.getMeta("focus"), s = e.getMeta("blur");
    i && this.emit("focus", {
      editor: this,
      event: i.event,
      transaction: e
    }), s && this.emit("blur", {
      editor: this,
      event: s.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return d3(this.state, e);
  }
  isActive(e, t) {
    const r = typeof e == "string" ? e : null, i = typeof e == "string" ? t : e;
    return Bk(this.state, r, i);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return Bl(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: t = `

`, textSerializers: r = {} } = e || {};
    return u3(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...F1(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return K1(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, t) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(e, t)) || null;
  }
  $nodes(e, t) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(e, t)) || null;
  }
  $pos(e) {
    const t = this.state.doc.resolve(e);
    return new oi(t, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function ps(n) {
  return new zl({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = Ne(n.getAttributes, void 0, r);
      if (i === !1 || i === null)
        return null;
      const { tr: s } = e, o = r[r.length - 1], a = r[0];
      if (o) {
        const l = a.search(/\S/), u = t.from + a.indexOf(o), d = u + o.length;
        if (q1(t.from, t.to, e.doc).filter((p) => p.mark.type.excluded.find((y) => y === n.type && y !== p.mark.type)).filter((p) => p.to > u).length)
          return null;
        d < t.to && s.delete(d, t.to), u > t.from && s.delete(t.from + l, u);
        const f = t.from + l + o.length;
        s.addMark(t.from + l, f, n.type.create(i || {})), s.removeStoredMark(n.type);
      }
    }
  });
}
function gC(n) {
  return new zl({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = Ne(n.getAttributes, void 0, r) || {}, { tr: s } = e, o = t.from;
      let a = t.to;
      const l = n.type.create(i);
      if (r[1]) {
        const u = r[0].lastIndexOf(r[1]);
        let d = o + u;
        d > a ? d = a : a = d + r[1].length;
        const c = r[0][r[0].length - 1];
        s.insertText(c, o + r[0].length - 1), s.replaceWith(d, a, l);
      } else if (r[0]) {
        const u = n.type.isInline ? o : o - 1;
        s.insert(u, n.type.create(i)).delete(s.mapping.map(o), s.mapping.map(a));
      }
      s.scrollIntoView();
    }
  });
}
function Rd(n) {
  return new zl({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = e.doc.resolve(t.from), s = Ne(n.getAttributes, void 0, r) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), n.type))
        return null;
      e.tr.delete(t.from, t.to).setBlockType(t.from, t.from, n.type, s);
    }
  });
}
function ko(n) {
  return new zl({
    find: n.find,
    handler: ({ state: e, range: t, match: r, chain: i }) => {
      const s = Ne(n.getAttributes, void 0, r) || {}, o = e.tr.delete(t.from, t.to), l = o.doc.resolve(t.from).blockRange(), u = l && E1(l, n.type, s);
      if (!u)
        return null;
      if (o.wrap(l, u), n.keepMarks && n.editor) {
        const { selection: c, storedMarks: f } = e, { splittableMarks: p } = n.editor.extensionManager, h = f || c.$to.parentOffset && c.$from.marks();
        if (h) {
          const y = h.filter((g) => p.includes(g.type.name));
          o.ensureMarks(y);
        }
      }
      if (n.keepAttributes) {
        const c = n.type.name === "bulletList" || n.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(c, s).run();
      }
      const d = o.doc.resolve(t.from - 1).nodeBefore;
      d && d.type === n.type && Yr(o.doc, t.from - 1) && (!n.joinPredicate || n.joinPredicate(r, d)) && o.join(t.from - 1);
    }
  });
}
class rn {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ne(me(this, "addOptions", {
      name: this.name
    }))), this.storage = Ne(me(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new rn(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => Vl(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new rn(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = Ne(me(t, "addOptions", {
      name: t.name
    })), t.storage = Ne(me(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function Ti(n) {
  return new Nw({
    find: n.find,
    handler: ({ state: e, range: t, match: r, pasteEvent: i }) => {
      const s = Ne(n.getAttributes, void 0, r, i);
      if (s === !1 || s === null)
        return null;
      const { tr: o } = e, a = r[r.length - 1], l = r[0];
      let u = t.to;
      if (a) {
        const d = l.search(/\S/), c = t.from + l.indexOf(a), f = c + a.length;
        if (q1(t.from, t.to, e.doc).filter((h) => h.mark.type.excluded.find((g) => g === n.type && g !== h.mark.type)).filter((h) => h.to > c).length)
          return null;
        f < t.to && o.delete(f, t.to), c > t.from && o.delete(t.from + d, c), u = t.from + d + a.length, o.addMark(t.from + d, u, n.type.create(s || {})), o.removeStoredMark(n.type);
      }
    }
  });
}
const bC = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", yC = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", hs = (n, e) => {
  for (const t in e)
    n[t] = e[t];
  return n;
}, Pd = "numeric", Id = "ascii", Bd = "alpha", Js = "asciinumeric", Hs = "alphanumeric", zd = "domain", p3 = "emoji", vC = "scheme", _C = "slashscheme", Ou = "whitespace";
function $C(n, e) {
  return n in e || (e[n] = []), e[n];
}
function di(n, e, t) {
  e[Pd] && (e[Js] = !0, e[Hs] = !0), e[Id] && (e[Js] = !0, e[Bd] = !0), e[Js] && (e[Hs] = !0), e[Bd] && (e[Hs] = !0), e[Hs] && (e[zd] = !0), e[p3] && (e[zd] = !0);
  for (const r in e) {
    const i = $C(r, t);
    i.indexOf(n) < 0 && i.push(n);
  }
}
function xC(n, e) {
  const t = {};
  for (const r in e)
    e[r].indexOf(n) >= 0 && (t[r] = !0);
  return t;
}
function Xt(n = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = n;
}
Xt.groups = {};
Xt.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(n) {
    const e = this, t = e.j[n];
    if (t)
      return t;
    for (let r = 0; r < e.jr.length; r++) {
      const i = e.jr[r][0], s = e.jr[r][1];
      if (s && i.test(n))
        return s;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(n, e = !1) {
    return e ? n in this.j : !!this.go(n);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(n, e, t, r) {
    for (let i = 0; i < n.length; i++)
      this.tt(n[i], e, t, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(n, e, t, r) {
    r = r || Xt.groups;
    let i;
    return e && e.j ? i = e : (i = new Xt(e), t && r && di(e, t, r)), this.jr.push([n, i]), i;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(n, e, t, r) {
    let i = this;
    const s = n.length;
    if (!s)
      return i;
    for (let o = 0; o < s - 1; o++)
      i = i.tt(n[o]);
    return i.tt(n[s - 1], e, t, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(n, e, t, r) {
    r = r || Xt.groups;
    const i = this;
    if (e && e.j)
      return i.j[n] = e, e;
    const s = e;
    let o, a = i.go(n);
    if (a ? (o = new Xt(), hs(o.j, a.j), o.jr.push.apply(o.jr, a.jr), o.jd = a.jd, o.t = a.t) : o = new Xt(), s) {
      if (r)
        if (o.t && typeof o.t == "string") {
          const l = hs(xC(o.t, r), t);
          di(s, l, r);
        } else t && di(s, t, r);
      o.t = s;
    }
    return i.j[n] = o, o;
  }
};
const Me = (n, e, t, r, i) => n.ta(e, t, r, i), it = (n, e, t, r, i) => n.tr(e, t, r, i), wf = (n, e, t, r, i) => n.ts(e, t, r, i), ie = (n, e, t, r, i) => n.tt(e, t, r, i), or = "WORD", Vd = "UWORD", h3 = "ASCIINUMERICAL", m3 = "ALPHANUMERICAL", Co = "LOCALHOST", Fd = "TLD", jd = "UTLD", _a = "SCHEME", Fi = "SLASH_SCHEME", G1 = "NUM", Hd = "WS", Y1 = "NL", Zs = "OPENBRACE", Xs = "CLOSEBRACE", Ha = "OPENBRACKET", Ua = "CLOSEBRACKET", Wa = "OPENPAREN", qa = "CLOSEPAREN", Ka = "OPENANGLEBRACKET", Ga = "CLOSEANGLEBRACKET", Ya = "FULLWIDTHLEFTPAREN", Ja = "FULLWIDTHRIGHTPAREN", Za = "LEFTCORNERBRACKET", Xa = "RIGHTCORNERBRACKET", Qa = "LEFTWHITECORNERBRACKET", el = "RIGHTWHITECORNERBRACKET", tl = "FULLWIDTHLESSTHAN", nl = "FULLWIDTHGREATERTHAN", rl = "AMPERSAND", J1 = "APOSTROPHE", il = "ASTERISK", Ar = "AT", sl = "BACKSLASH", ol = "BACKTICK", al = "CARET", Lr = "COLON", Z1 = "COMMA", ll = "DOLLAR", jn = "DOT", ul = "EQUALS", X1 = "EXCLAMATION", _n = "HYPHEN", Qs = "PERCENT", dl = "PIPE", cl = "PLUS", fl = "POUND", eo = "QUERY", Q1 = "QUOTE", g3 = "FULLWIDTHMIDDLEDOT", e0 = "SEMI", Hn = "SLASH", to = "TILDE", pl = "UNDERSCORE", b3 = "EMOJI", hl = "SYM";
var y3 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: or,
  UWORD: Vd,
  ASCIINUMERICAL: h3,
  ALPHANUMERICAL: m3,
  LOCALHOST: Co,
  TLD: Fd,
  UTLD: jd,
  SCHEME: _a,
  SLASH_SCHEME: Fi,
  NUM: G1,
  WS: Hd,
  NL: Y1,
  OPENBRACE: Zs,
  CLOSEBRACE: Xs,
  OPENBRACKET: Ha,
  CLOSEBRACKET: Ua,
  OPENPAREN: Wa,
  CLOSEPAREN: qa,
  OPENANGLEBRACKET: Ka,
  CLOSEANGLEBRACKET: Ga,
  FULLWIDTHLEFTPAREN: Ya,
  FULLWIDTHRIGHTPAREN: Ja,
  LEFTCORNERBRACKET: Za,
  RIGHTCORNERBRACKET: Xa,
  LEFTWHITECORNERBRACKET: Qa,
  RIGHTWHITECORNERBRACKET: el,
  FULLWIDTHLESSTHAN: tl,
  FULLWIDTHGREATERTHAN: nl,
  AMPERSAND: rl,
  APOSTROPHE: J1,
  ASTERISK: il,
  AT: Ar,
  BACKSLASH: sl,
  BACKTICK: ol,
  CARET: al,
  COLON: Lr,
  COMMA: Z1,
  DOLLAR: ll,
  DOT: jn,
  EQUALS: ul,
  EXCLAMATION: X1,
  HYPHEN: _n,
  PERCENT: Qs,
  PIPE: dl,
  PLUS: cl,
  POUND: fl,
  QUERY: eo,
  QUOTE: Q1,
  FULLWIDTHMIDDLEDOT: g3,
  SEMI: e0,
  SLASH: Hn,
  TILDE: to,
  UNDERSCORE: pl,
  EMOJI: b3,
  SYM: hl
});
const ir = /[a-z]/, As = new RegExp("\\p{L}", "u"), Mu = new RegExp("\\p{Emoji}", "u"), sr = /\d/, Au = /\s/, kf = "\r", Nu = `
`, wC = "️", kC = "‍", Du = "￼";
let ta = null, na = null;
function CC(n = []) {
  const e = {};
  Xt.groups = e;
  const t = new Xt();
  ta == null && (ta = Cf(bC)), na == null && (na = Cf(yC)), ie(t, "'", J1), ie(t, "{", Zs), ie(t, "}", Xs), ie(t, "[", Ha), ie(t, "]", Ua), ie(t, "(", Wa), ie(t, ")", qa), ie(t, "<", Ka), ie(t, ">", Ga), ie(t, "（", Ya), ie(t, "）", Ja), ie(t, "「", Za), ie(t, "」", Xa), ie(t, "『", Qa), ie(t, "』", el), ie(t, "＜", tl), ie(t, "＞", nl), ie(t, "&", rl), ie(t, "*", il), ie(t, "@", Ar), ie(t, "`", ol), ie(t, "^", al), ie(t, ":", Lr), ie(t, ",", Z1), ie(t, "$", ll), ie(t, ".", jn), ie(t, "=", ul), ie(t, "!", X1), ie(t, "-", _n), ie(t, "%", Qs), ie(t, "|", dl), ie(t, "+", cl), ie(t, "#", fl), ie(t, "?", eo), ie(t, '"', Q1), ie(t, "/", Hn), ie(t, ";", e0), ie(t, "~", to), ie(t, "_", pl), ie(t, "\\", sl), ie(t, "・", g3);
  const r = it(t, sr, G1, {
    [Pd]: !0
  });
  it(r, sr, r);
  const i = it(r, ir, h3, {
    [Js]: !0
  }), s = it(r, As, m3, {
    [Hs]: !0
  }), o = it(t, ir, or, {
    [Id]: !0
  });
  it(o, sr, i), it(o, ir, o), it(i, sr, i), it(i, ir, i);
  const a = it(t, As, Vd, {
    [Bd]: !0
  });
  it(a, ir), it(a, sr, s), it(a, As, a), it(s, sr, s), it(s, ir), it(s, As, s);
  const l = ie(t, Nu, Y1, {
    [Ou]: !0
  }), u = ie(t, kf, Hd, {
    [Ou]: !0
  }), d = it(t, Au, Hd, {
    [Ou]: !0
  });
  ie(t, Du, d), ie(u, Nu, l), ie(u, Du, d), it(u, Au, d), ie(d, kf), ie(d, Nu), it(d, Au, d), ie(d, Du, d);
  const c = it(t, Mu, b3, {
    [p3]: !0
  });
  ie(c, "#"), it(c, Mu, c), ie(c, wC, c);
  const f = ie(c, kC);
  ie(f, "#"), it(f, Mu, c);
  const p = [[ir, o], [sr, i]], h = [[ir, null], [As, a], [sr, s]];
  for (let y = 0; y < ta.length; y++)
    Sr(t, ta[y], Fd, or, p);
  for (let y = 0; y < na.length; y++)
    Sr(t, na[y], jd, Vd, h);
  di(Fd, {
    tld: !0,
    ascii: !0
  }, e), di(jd, {
    utld: !0,
    alpha: !0
  }, e), Sr(t, "file", _a, or, p), Sr(t, "mailto", _a, or, p), Sr(t, "http", Fi, or, p), Sr(t, "https", Fi, or, p), Sr(t, "ftp", Fi, or, p), Sr(t, "ftps", Fi, or, p), di(_a, {
    scheme: !0,
    ascii: !0
  }, e), di(Fi, {
    slashscheme: !0,
    ascii: !0
  }, e), n = n.sort((y, g) => y[0] > g[0] ? 1 : -1);
  for (let y = 0; y < n.length; y++) {
    const g = n[y][0], $ = n[y][1] ? {
      [vC]: !0
    } : {
      [_C]: !0
    };
    g.indexOf("-") >= 0 ? $[zd] = !0 : ir.test(g) ? sr.test(g) ? $[Js] = !0 : $[Id] = !0 : $[Pd] = !0, wf(t, g, g, $);
  }
  return wf(t, "localhost", Co, {
    ascii: !0
  }), t.jd = new Xt(hl), {
    start: t,
    tokens: hs({
      groups: e
    }, y3)
  };
}
function v3(n, e) {
  const t = SC(e.replace(/[A-Z]/g, (a) => a.toLowerCase())), r = t.length, i = [];
  let s = 0, o = 0;
  for (; o < r; ) {
    let a = n, l = null, u = 0, d = null, c = -1, f = -1;
    for (; o < r && (l = a.go(t[o])); )
      a = l, a.accepts() ? (c = 0, f = 0, d = a) : c >= 0 && (c += t[o].length, f++), u += t[o].length, s += t[o].length, o++;
    s -= c, o -= f, u -= c, i.push({
      t: d.t,
      // token type/name
      v: e.slice(s - u, s),
      // string value
      s: s - u,
      // start index
      e: s
      // end index (excluding)
    });
  }
  return i;
}
function SC(n) {
  const e = [], t = n.length;
  let r = 0;
  for (; r < t; ) {
    let i = n.charCodeAt(r), s, o = i < 55296 || i > 56319 || r + 1 === t || (s = n.charCodeAt(r + 1)) < 56320 || s > 57343 ? n[r] : n.slice(r, r + 2);
    e.push(o), r += o.length;
  }
  return e;
}
function Sr(n, e, t, r, i) {
  let s;
  const o = e.length;
  for (let a = 0; a < o - 1; a++) {
    const l = e[a];
    n.j[l] ? s = n.j[l] : (s = new Xt(r), s.jr = i.slice(), n.j[l] = s), n = s;
  }
  return s = new Xt(t), s.jr = i.slice(), n.j[e[o - 1]] = s, s;
}
function Cf(n) {
  const e = [], t = [];
  let r = 0, i = "0123456789";
  for (; r < n.length; ) {
    let s = 0;
    for (; i.indexOf(n[r + s]) >= 0; )
      s++;
    if (s > 0) {
      e.push(t.join(""));
      for (let o = parseInt(n.substring(r, r + s), 10); o > 0; o--)
        t.pop();
      r += s;
    } else
      t.push(n[r]), r++;
  }
  return e;
}
const So = {
  defaultProtocol: "http",
  events: null,
  format: Sf,
  formatHref: Sf,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function t0(n, e = null) {
  let t = hs({}, So);
  n && (t = hs(t, n instanceof t0 ? n.o : n));
  const r = t.ignoreTags, i = [];
  for (let s = 0; s < r.length; s++)
    i.push(r[s].toUpperCase());
  this.o = t, e && (this.defaultRender = e), this.ignoreTags = i;
}
t0.prototype = {
  o: So,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(n) {
    return n;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(n) {
    return this.get("validate", n.toString(), n);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(n, e, t) {
    const r = e != null;
    let i = this.o[n];
    return i && (typeof i == "object" ? (i = t.t in i ? i[t.t] : So[n], typeof i == "function" && r && (i = i(e, t))) : typeof i == "function" && r && (i = i(e, t.t, t)), i);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(n, e, t) {
    let r = this.o[n];
    return typeof r == "function" && e != null && (r = r(e, t.t, t)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(n) {
    const e = n.render(this);
    return (this.get("render", null, n) || this.defaultRender)(e, n.t, n);
  }
};
function Sf(n) {
  return n;
}
function _3(n, e) {
  this.t = "token", this.v = n, this.tk = e;
}
_3.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(n) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(n) {
    const e = this.toString(), t = n.get("truncate", e, this), r = n.get("format", e, this);
    return t && r.length > t ? r.substring(0, t) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(n) {
    return n.get("formatHref", this.toHref(n.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(n = So.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(n) {
    return {
      type: this.t,
      value: this.toFormattedString(n),
      isLink: this.isLink,
      href: this.toFormattedHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(n) {
    return n.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(n) {
    const e = this, t = this.toHref(n.get("defaultProtocol")), r = n.get("formatHref", t, this), i = n.get("tagName", t, e), s = this.toFormattedString(n), o = {}, a = n.get("className", t, e), l = n.get("target", t, e), u = n.get("rel", t, e), d = n.getObj("attributes", t, e), c = n.getObj("events", t, e);
    return o.href = r, a && (o.class = a), l && (o.target = l), u && (o.rel = u), d && hs(o, d), {
      tagName: i,
      attributes: o,
      content: s,
      eventListeners: c
    };
  }
};
function jl(n, e) {
  class t extends _3 {
    constructor(i, s) {
      super(i, s), this.t = n;
    }
  }
  for (const r in e)
    t.prototype[r] = e[r];
  return t.t = n, t;
}
const Ef = jl("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Tf = jl("text"), EC = jl("nl"), ra = jl("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(n = So.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${n}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const n = this.tk;
    return n.length >= 2 && n[0].t !== Co && n[1].t === Lr;
  }
}), vn = (n) => new Xt(n);
function TC({
  groups: n
}) {
  const e = n.domain.concat([rl, il, Ar, sl, ol, al, ll, ul, _n, G1, Qs, dl, cl, fl, Hn, hl, to, pl]), t = [Lr, Z1, jn, X1, Qs, eo, Q1, e0, Ka, Ga, Zs, Xs, Ua, Ha, Wa, qa, Ya, Ja, Za, Xa, Qa, el, tl, nl], r = [rl, J1, il, sl, ol, al, ll, ul, _n, Zs, Xs, Qs, dl, cl, fl, eo, Hn, hl, to, pl], i = vn(), s = ie(i, to);
  Me(s, r, s), Me(s, n.domain, s);
  const o = vn(), a = vn(), l = vn();
  Me(i, n.domain, o), Me(i, n.scheme, a), Me(i, n.slashscheme, l), Me(o, r, s), Me(o, n.domain, o);
  const u = ie(o, Ar);
  ie(s, Ar, u), ie(a, Ar, u), ie(l, Ar, u);
  const d = ie(s, jn);
  Me(d, r, s), Me(d, n.domain, s);
  const c = vn();
  Me(u, n.domain, c), Me(c, n.domain, c);
  const f = ie(c, jn);
  Me(f, n.domain, c);
  const p = vn(Ef);
  Me(f, n.tld, p), Me(f, n.utld, p), ie(u, Co, p);
  const h = ie(c, _n);
  ie(h, _n, h), Me(h, n.domain, c), Me(p, n.domain, c), ie(p, jn, f), ie(p, _n, h);
  const y = ie(p, Lr);
  Me(y, n.numeric, Ef);
  const g = ie(o, _n), m = ie(o, jn);
  ie(g, _n, g), Me(g, n.domain, o), Me(m, r, s), Me(m, n.domain, o);
  const $ = vn(ra);
  Me(m, n.tld, $), Me(m, n.utld, $), Me($, n.domain, o), Me($, r, s), ie($, jn, m), ie($, _n, g), ie($, Ar, u);
  const w = ie($, Lr), _ = vn(ra);
  Me(w, n.numeric, _);
  const L = vn(ra), S = vn();
  Me(L, e, L), Me(L, t, S), Me(S, e, L), Me(S, t, S), ie($, Hn, L), ie(_, Hn, L);
  const R = ie(a, Lr), O = ie(l, Lr), I = ie(O, Hn), x = ie(I, Hn);
  Me(a, n.domain, o), ie(a, jn, m), ie(a, _n, g), Me(l, n.domain, o), ie(l, jn, m), ie(l, _n, g), Me(R, n.domain, L), ie(R, Hn, L), ie(R, eo, L), Me(x, n.domain, L), Me(x, e, L), ie(x, Hn, L);
  const M = [
    [Zs, Xs],
    // {}
    [Ha, Ua],
    // []
    [Wa, qa],
    // ()
    [Ka, Ga],
    // <>
    [Ya, Ja],
    // （）
    [Za, Xa],
    // 「」
    [Qa, el],
    // 『』
    [tl, nl]
    // ＜＞
  ];
  for (let D = 0; D < M.length; D++) {
    const [j, U] = M[D], J = ie(L, j);
    ie(S, j, J), ie(J, U, L);
    const ne = vn(ra);
    Me(J, e, ne);
    const Y = vn();
    Me(J, t), Me(ne, e, ne), Me(ne, t, Y), Me(Y, e, ne), Me(Y, t, Y), ie(ne, U, L), ie(Y, U, L);
  }
  return ie(i, Co, $), ie(i, Y1, EC), {
    start: i,
    tokens: y3
  };
}
function OC(n, e, t) {
  let r = t.length, i = 0, s = [], o = [];
  for (; i < r; ) {
    let a = n, l = null, u = null, d = 0, c = null, f = -1;
    for (; i < r && !(l = a.go(t[i].t)); )
      o.push(t[i++]);
    for (; i < r && (u = l || a.go(t[i].t)); )
      l = null, a = u, a.accepts() ? (f = 0, c = a) : f >= 0 && f++, i++, d++;
    if (f < 0)
      i -= d, i < r && (o.push(t[i]), i++);
    else {
      o.length > 0 && (s.push(Lu(Tf, e, o)), o = []), i -= f, d -= f;
      const p = c.t, h = t.slice(i - d, i);
      s.push(Lu(p, e, h));
    }
  }
  return o.length > 0 && s.push(Lu(Tf, e, o)), s;
}
function Lu(n, e, t) {
  const r = t[0].s, i = t[t.length - 1].e, s = e.slice(r, i);
  return new n(s, t);
}
const MC = typeof console < "u" && console && console.warn || (() => {
}), AC = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", Ze = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function NC() {
  return Xt.groups = {}, Ze.scanner = null, Ze.parser = null, Ze.tokenQueue = [], Ze.pluginQueue = [], Ze.customSchemes = [], Ze.initialized = !1, Ze;
}
function Of(n, e = !1) {
  if (Ze.initialized && MC(`linkifyjs: already initialized - will not register custom scheme "${n}" ${AC}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(n))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  Ze.customSchemes.push([n, e]);
}
function DC() {
  Ze.scanner = CC(Ze.customSchemes);
  for (let n = 0; n < Ze.tokenQueue.length; n++)
    Ze.tokenQueue[n][1]({
      scanner: Ze.scanner
    });
  Ze.parser = TC(Ze.scanner.tokens);
  for (let n = 0; n < Ze.pluginQueue.length; n++)
    Ze.pluginQueue[n][1]({
      scanner: Ze.scanner,
      parser: Ze.parser
    });
  return Ze.initialized = !0, Ze;
}
function n0(n) {
  return Ze.initialized || DC(), OC(Ze.parser.start, n, v3(Ze.scanner.start, n));
}
n0.scan = v3;
function $3(n, e = null, t = null) {
  if (e && typeof e == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    t = e, e = null;
  }
  const r = new t0(t), i = n0(n), s = [];
  for (let o = 0; o < i.length; o++) {
    const a = i[o];
    a.isLink && (!e || a.t === e) && r.check(a) && s.push(a.toFormattedObject(r));
  }
  return s;
}
function LC(n) {
  return n.length === 1 ? n[0].isLink : n.length === 3 && n[1].isLink ? ["()", "[]"].includes(n[0].value + n[2].value) : !1;
}
function RC(n) {
  return new bt({
    key: new Jt("autolink"),
    appendTransaction: (e, t, r) => {
      const i = e.some((u) => u.docChanged) && !t.doc.eq(r.doc), s = e.some((u) => u.getMeta("preventAutolink"));
      if (!i || s)
        return;
      const { tr: o } = r, a = Ok(t.doc, [...e]);
      if (Ik(a).forEach(({ newRange: u }) => {
        const d = Ak(r.doc, u, (p) => p.isTextblock);
        let c, f;
        if (d.length > 1 ? (c = d[0], f = r.doc.textBetween(c.pos, c.pos + c.node.nodeSize, void 0, " ")) : d.length && r.doc.textBetween(u.from, u.to, " ", " ").endsWith(" ") && (c = d[0], f = r.doc.textBetween(c.pos, u.to, void 0, " ")), c && f) {
          const p = f.split(" ").filter((m) => m !== "");
          if (p.length <= 0)
            return !1;
          const h = p[p.length - 1], y = c.pos + f.lastIndexOf(h);
          if (!h)
            return !1;
          const g = n0(h).map((m) => m.toObject(n.defaultProtocol));
          if (!LC(g))
            return !1;
          g.filter((m) => m.isLink).map((m) => ({
            ...m,
            from: y + m.start + 1,
            to: y + m.end + 1
          })).filter((m) => r.schema.marks.code ? !r.doc.rangeHasMark(m.from, m.to, r.schema.marks.code) : !0).filter((m) => n.validate(m.value)).filter((m) => n.shouldAutoLink(m.value)).forEach((m) => {
            q1(m.from, m.to, r.doc).some(($) => $.mark.type === n.type) || o.addMark(m.from, m.to, n.type.create({
              href: m.href
            }));
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function PC(n) {
  return new bt({
    key: new Jt("handleClickLink"),
    props: {
      handleClick: (e, t, r) => {
        var i, s;
        if (r.button !== 0 || !e.editable)
          return !1;
        let o = r.target;
        const a = [];
        for (; o.nodeName !== "DIV"; )
          a.push(o), o = o.parentNode;
        if (!a.find((f) => f.nodeName === "A"))
          return !1;
        const l = d3(e.state, n.type.name), u = r.target, d = (i = u == null ? void 0 : u.href) !== null && i !== void 0 ? i : l.href, c = (s = u == null ? void 0 : u.target) !== null && s !== void 0 ? s : l.target;
        return u && d ? (window.open(d, c), !0) : !1;
      }
    }
  });
}
function IC(n) {
  return new bt({
    key: new Jt("handlePasteLink"),
    props: {
      handlePaste: (e, t, r) => {
        const { state: i } = e, { selection: s } = i, { empty: o } = s;
        if (o)
          return !1;
        let a = "";
        r.content.forEach((u) => {
          a += u.textContent;
        });
        const l = $3(a, { defaultProtocol: n.defaultProtocol }).find((u) => u.isLink && u.value === a);
        return !a || !l ? !1 : n.editor.commands.setMark(n.type, {
          href: l.href
        });
      }
    }
  });
}
const BC = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g;
function ni(n, e) {
  const t = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp"
  ];
  return e && e.forEach((r) => {
    const i = typeof r == "string" ? r : r.scheme;
    i && t.push(i);
  }), !n || n.replace(BC, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
    "i"
  ));
}
const zC = In.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((n) => {
      if (typeof n == "string") {
        Of(n);
        return;
      }
      Of(n.scheme, n.optionalSlashes);
    });
  },
  onDestroy() {
    NC();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (n, e) => !!ni(n, e.protocols),
      validate: (n) => !!n,
      shouldAutoLink: (n) => !!n
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(n) {
          return n.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (n) => {
          const e = n.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (t) => !!ni(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return this.options.isAllowedUri(n.href, {
      defaultValidate: (e) => !!ni(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", gt(this.options.HTMLAttributes, n), 0] : [
      "a",
      gt(this.options.HTMLAttributes, { ...n, href: "" }),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (r) => !!ni(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, n).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (r) => !!ni(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().toggleMark(this.name, n, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run() : !1;
      },
      unsetLink: () => ({ chain: n }) => n().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Ti({
        find: (n) => {
          const e = [];
          if (n) {
            const { protocols: t, defaultProtocol: r } = this.options, i = $3(n).filter((s) => s.isLink && this.options.isAllowedUri(s.value, {
              defaultValidate: (o) => !!ni(o, t),
              protocols: t,
              defaultProtocol: r
            }));
            i.length && i.forEach((s) => e.push({
              text: s.value,
              data: {
                href: s.href
              },
              index: s.start
            }));
          }
          return e;
        },
        type: this.type,
        getAttributes: (n) => {
          var e;
          return {
            href: (e = n.data) === null || e === void 0 ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const n = [], { protocols: e, defaultProtocol: t } = this.options;
    return this.options.autolink && n.push(RC({
      type: this.type,
      defaultProtocol: this.options.defaultProtocol,
      validate: (r) => this.options.isAllowedUri(r, {
        defaultValidate: (i) => !!ni(i, e),
        protocols: e,
        defaultProtocol: t
      }),
      shouldAutoLink: this.options.shouldAutoLink
    })), this.options.openOnClick === !0 && n.push(PC({
      type: this.type
    })), this.options.linkOnPaste && n.push(IC({
      editor: this.editor,
      defaultProtocol: this.options.defaultProtocol,
      type: this.type
    })), n;
  }
}), Ud = rn.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", gt(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), VC = St.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (n) => {
              const e = n.style.textAlign;
              return this.options.alignments.includes(e) ? e : this.options.defaultAlignment;
            },
            renderHTML: (n) => n.textAlign ? { style: `text-align: ${n.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (n) => ({ commands: e }) => this.options.alignments.includes(n) ? this.options.types.map((t) => e.updateAttributes(t, { textAlign: n })).every((t) => t) : !1,
      unsetTextAlign: () => ({ commands: n }) => this.options.types.map((e) => n.resetAttributes(e, "textAlign")).every((e) => e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), FC = (n) => {
  if (!n.children.length)
    return;
  const e = n.querySelectorAll("span");
  e && e.forEach((t) => {
    var r, i;
    const s = t.getAttribute("style"), o = (i = (r = t.parentElement) === null || r === void 0 ? void 0 : r.closest("span")) === null || i === void 0 ? void 0 : i.getAttribute("style");
    t.setAttribute("style", `${o};${s}`);
  });
}, jC = In.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !1
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (n) => n.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && FC(n), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", gt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ tr: n }) => {
        const { selection: e } = n;
        return n.doc.nodesBetween(e.from, e.to, (t, r) => {
          if (t.isTextblock)
            return !0;
          t.marks.filter((i) => i.type === this.type).some((i) => Object.values(i.attrs).some((s) => !!s)) || n.removeMark(r, r + t.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), HC = In.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["u", gt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: n }) => n.setMark(this.name),
      toggleUnderline: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetUnderline: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), UC = /^\s*>\s$/, WC = rn.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["blockquote", gt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: n }) => n.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: n }) => n.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: n }) => n.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      ko({
        find: UC,
        type: this.type
      })
    ];
  }
}), qC = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, KC = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, GC = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, YC = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, JC = In.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (n) => n.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (n) => /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["strong", gt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: n }) => n.setMark(this.name),
      toggleBold: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetBold: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      ps({
        find: qC,
        type: this.type
      }),
      ps({
        find: GC,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ti({
        find: KC,
        type: this.type
      }),
      Ti({
        find: YC,
        type: this.type
      })
    ];
  }
}), ZC = "listItem", Mf = "textStyle", Af = /^\s*([-+*])\s$/, XC = rn.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", gt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(ZC, this.editor.getAttributes(Mf)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let n = ko({
      find: Af,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = ko({
      find: Af,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(Mf),
      editor: this.editor
    })), [
      n
    ];
  }
}), QC = /(^|[^`])`([^`]+)`(?!`)/, eS = /(^|[^`])`([^`]+)`(?!`)/g, tS = In.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["code", gt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: n }) => n.setMark(this.name),
      toggleCode: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetCode: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      ps({
        find: QC,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ti({
        find: eS,
        type: this.type
      })
    ];
  }
}), nS = /^```([a-z]+)?[\s\n]$/, rS = /^~~~([a-z]+)?[\s\n]$/, iS = rn.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (n) => {
          var e;
          const { languageClassPrefix: t } = this.options, s = [...((e = n.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((o) => o.startsWith(t)).map((o) => o.replace(t, ""))[0];
          return s || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "pre",
      gt(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: n.attrs.language ? this.options.languageClassPrefix + n.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (n) => ({ commands: e }) => e.setNode(this.name, n),
      toggleCodeBlock: (n) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", n)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: n, $anchor: e } = this.editor.state.selection, t = e.pos === 1;
        return !n || e.parent.type.name !== this.name ? !1 : t || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: n }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = n, { selection: t } = e, { $from: r, empty: i } = t;
        if (!i || r.parent.type !== this.type)
          return !1;
        const s = r.parentOffset === r.parent.nodeSize - 2, o = r.parent.textContent.endsWith(`

`);
        return !s || !o ? !1 : n.chain().command(({ tr: a }) => (a.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: n }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = n, { selection: t, doc: r } = e, { $from: i, empty: s } = t;
        if (!s || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const a = i.after();
        return a === void 0 ? !1 : r.nodeAt(a) ? n.commands.command(({ tr: u }) => (u.setSelection(Oe.near(r.resolve(a))), !0)) : n.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      Rd({
        find: nS,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      }),
      Rd({
        find: rS,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new bt({
        key: new Jt("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (n, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), i = r ? JSON.parse(r) : void 0, s = i == null ? void 0 : i.mode;
            if (!t || !s)
              return !1;
            const { tr: o, schema: a } = n.state, l = a.text(t.replace(/\r\n?/g, `
`));
            return o.replaceSelectionWith(this.type.create({ language: s }, l)), o.selection.$from.parent.type !== this.type && o.setSelection(Ce.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.setMeta("paste", !0), n.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), sS = rn.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function oS(n = {}) {
  return new bt({
    view(e) {
      return new aS(e, n);
    }
  });
}
class aS {
  constructor(e, t) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = t.width) !== null && r !== void 0 ? r : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let s = (o) => {
        this[i](o);
      };
      return e.dom.addEventListener(i, s), { name: i, handler: s };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, r, i = this.editorView.dom, s = i.getBoundingClientRect(), o = s.width / i.offsetWidth, a = s.height / i.offsetHeight;
    if (t) {
      let c = e.nodeBefore, f = e.nodeAfter;
      if (c || f) {
        let p = this.editorView.nodeDOM(this.cursorPos - (c ? c.nodeSize : 0));
        if (p) {
          let h = p.getBoundingClientRect(), y = c ? h.bottom : h.top;
          c && f && (y = (y + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let g = this.width / 2 * a;
          r = { left: h.left, right: h.right, top: y - g, bottom: y + g };
        }
      }
    }
    if (!r) {
      let c = this.editorView.coordsAtPos(this.cursorPos), f = this.width / 2 * o;
      r = { left: c.left - f, right: c.left + f, top: c.top, bottom: c.bottom };
    }
    let l = this.editorView.dom.offsetParent;
    this.element || (this.element = l.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let u, d;
    if (!l || l == document.body && getComputedStyle(l).position == "static")
      u = -pageXOffset, d = -pageYOffset;
    else {
      let c = l.getBoundingClientRect(), f = c.width / l.offsetWidth, p = c.height / l.offsetHeight;
      u = c.left - l.scrollLeft * f, d = c.top - l.scrollTop * p;
    }
    this.element.style.left = (r.left - u) / o + "px", this.element.style.top = (r.top - d) / a + "px", this.element.style.width = (r.right - r.left) / o + "px", this.element.style.height = (r.bottom - r.top) / a + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), i = r && r.type.spec.disableDropCursor, s = typeof i == "function" ? i(this.editorView, t, e) : i;
    if (t && !s) {
      let o = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let a = sh(this.editorView.state.doc, o, this.editorView.dragging.slice);
        a != null && (o = a);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
const lS = St.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      oS(this.options)
    ];
  }
});
class st extends Oe {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    return st.valid(r) ? new st(r) : Oe.near(r);
  }
  content() {
    return de.empty;
  }
  eq(e) {
    return e instanceof st && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new st(e.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new r0(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let t = e.parent;
    if (t.isTextblock || !uS(e) || !dS(e))
      return !1;
    let r = t.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let i = t.contentMatchAt(e.index()).defaultType;
    return i && i.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, t, r = !1) {
    e: for (; ; ) {
      if (!r && st.valid(e))
        return e;
      let i = e.pos, s = null;
      for (let o = e.depth; ; o--) {
        let a = e.node(o);
        if (t > 0 ? e.indexAfter(o) < a.childCount : e.index(o) > 0) {
          s = a.child(t > 0 ? e.indexAfter(o) : e.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        i += t;
        let l = e.doc.resolve(i);
        if (st.valid(l))
          return l;
      }
      for (; ; ) {
        let o = t > 0 ? s.firstChild : s.lastChild;
        if (!o) {
          if (s.isAtom && !s.isText && !ve.isSelectable(s)) {
            e = e.doc.resolve(i + s.nodeSize * t), r = !1;
            continue e;
          }
          break;
        }
        s = o, i += t;
        let a = e.doc.resolve(i);
        if (st.valid(a))
          return a;
      }
      return null;
    }
  }
}
st.prototype.visible = !1;
st.findFrom = st.findGapCursorFrom;
Oe.jsonID("gapcursor", st);
class r0 {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new r0(e.map(this.pos));
  }
  resolve(e) {
    let t = e.resolve(this.pos);
    return st.valid(t) ? new st(t) : Oe.near(t);
  }
}
function uS(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.index(e), r = n.node(e);
    if (t == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(t - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function dS(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.indexAfter(e), r = n.node(e);
    if (t == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(t); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function cS() {
  return new bt({
    props: {
      decorations: mS,
      createSelectionBetween(n, e, t) {
        return e.pos == t.pos && st.valid(t) ? new st(t) : null;
      },
      handleClick: pS,
      handleKeyDown: fS,
      handleDOMEvents: { beforeinput: hS }
    }
  });
}
const fS = qh({
  ArrowLeft: ia("horiz", -1),
  ArrowRight: ia("horiz", 1),
  ArrowUp: ia("vert", -1),
  ArrowDown: ia("vert", 1)
});
function ia(n, e) {
  const t = n == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, i, s) {
    let o = r.selection, a = e > 0 ? o.$to : o.$from, l = o.empty;
    if (o instanceof Ce) {
      if (!s.endOfTextblock(t) || a.depth == 0)
        return !1;
      l = !1, a = r.doc.resolve(e > 0 ? a.after() : a.before());
    }
    let u = st.findGapCursorFrom(a, e, l);
    return u ? (i && i(r.tr.setSelection(new st(u))), !0) : !1;
  };
}
function pS(n, e, t) {
  if (!n || !n.editable)
    return !1;
  let r = n.state.doc.resolve(e);
  if (!st.valid(r))
    return !1;
  let i = n.posAtCoords({ left: t.clientX, top: t.clientY });
  return i && i.inside > -1 && ve.isSelectable(n.state.doc.nodeAt(i.inside)) ? !1 : (n.dispatch(n.state.tr.setSelection(new st(r))), !0);
}
function hS(n, e) {
  if (e.inputType != "insertCompositionText" || !(n.state.selection instanceof st))
    return !1;
  let { $from: t } = n.state.selection, r = t.parent.contentMatchAt(t.index()).findWrapping(n.state.schema.nodes.text);
  if (!r)
    return !1;
  let i = re.empty;
  for (let o = r.length - 1; o >= 0; o--)
    i = re.from(r[o].createAndFill(null, i));
  let s = n.state.tr.replace(t.pos, t.pos, new de(i, 0, 0));
  return s.setSelection(Ce.near(s.doc.resolve(t.pos + 1))), n.dispatch(s), !1;
}
function mS(n) {
  if (!(n.selection instanceof st))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", ht.create(n.doc, [kn.widget(n.selection.head, e, { key: "gapcursor" })]);
}
const gS = St.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      cS()
    ];
  },
  extendNodeSchema(n) {
    var e;
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    };
    return {
      allowGapCursor: (e = Ne(me(n, "allowGapCursor", t))) !== null && e !== void 0 ? e : null
    };
  }
}), bS = rn.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", gt(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: n, chain: e, state: t, editor: r }) => n.first([
        () => n.exitCode(),
        () => n.command(() => {
          const { selection: i, storedMarks: s } = t;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: a } = r.extensionManager, l = s || i.$to.parentOffset && i.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: u, dispatch: d }) => {
            if (d && l && o) {
              const c = l.filter((f) => a.includes(f.type.name));
              u.ensureMarks(c);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), yS = rn.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((n) => ({
      tag: `h${n}`,
      attrs: { level: n }
    }));
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(n.attrs.level) ? n.attrs.level : this.options.levels[0]}`, gt(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.setNode(this.name, n) : !1,
      toggleHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.toggleNode(this.name, "paragraph", n) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((n, e) => ({
      ...n,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((n) => Rd({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${n}})\\s$`),
      type: this.type,
      getAttributes: {
        level: n
      }
    }));
  }
});
var ml = 200, xt = function() {
};
xt.prototype.append = function(e) {
  return e.length ? (e = xt.from(e), !this.length && e || e.length < ml && this.leafAppend(e) || this.length < ml && e.leafPrepend(this) || this.appendInner(e)) : this;
};
xt.prototype.prepend = function(e) {
  return e.length ? xt.from(e).append(this) : this;
};
xt.prototype.appendInner = function(e) {
  return new vS(this, e);
};
xt.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? xt.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
xt.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
xt.prototype.forEach = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length), t <= r ? this.forEachInner(e, t, r, 0) : this.forEachInvertedInner(e, t, r, 0);
};
xt.prototype.map = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length);
  var i = [];
  return this.forEach(function(s, o) {
    return i.push(e(s, o));
  }, t, r), i;
};
xt.from = function(e) {
  return e instanceof xt ? e : e && e.length ? new x3(e) : xt.empty;
};
var x3 = /* @__PURE__ */ function(n) {
  function e(r) {
    n.call(this), this.values = r;
  }
  n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(i, s) {
    return i == 0 && s == this.length ? this : new e(this.values.slice(i, s));
  }, e.prototype.getInner = function(i) {
    return this.values[i];
  }, e.prototype.forEachInner = function(i, s, o, a) {
    for (var l = s; l < o; l++)
      if (i(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(i, s, o, a) {
    for (var l = s - 1; l >= o; l--)
      if (i(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(i) {
    if (this.length + i.length <= ml)
      return new e(this.values.concat(i.flatten()));
  }, e.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= ml)
      return new e(i.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
}(xt);
xt.empty = new x3([]);
var vS = /* @__PURE__ */ function(n) {
  function e(t, r) {
    n.call(this), this.left = t, this.right = r, this.length = t.length + r.length, this.depth = Math.max(t.depth, r.depth) + 1;
  }
  return n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, i, s, o) {
    var a = this.left.length;
    if (i < a && this.left.forEachInner(r, i, Math.min(s, a), o) === !1 || s > a && this.right.forEachInner(r, Math.max(i - a, 0), Math.min(this.length, s) - a, o + a) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, i, s, o) {
    var a = this.left.length;
    if (i > a && this.right.forEachInvertedInner(r, i - a, Math.max(s, a) - a, o + a) === !1 || s < a && this.left.forEachInvertedInner(r, Math.min(i, a), s, o) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, i) {
    if (r == 0 && i == this.length)
      return this;
    var s = this.left.length;
    return i <= s ? this.left.slice(r, i) : r >= s ? this.right.slice(r - s, i - s) : this.left.slice(r, s).append(this.right.slice(0, i - s));
  }, e.prototype.leafAppend = function(r) {
    var i = this.right.leafAppend(r);
    if (i)
      return new e(this.left, i);
  }, e.prototype.leafPrepend = function(r) {
    var i = this.left.leafPrepend(r);
    if (i)
      return new e(i, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
}(xt);
const _S = 500;
class Dn {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let i, s;
    t && (i = this.remapping(r, this.items.length), s = i.maps.length);
    let o = e.tr, a, l, u = [], d = [];
    return this.items.forEach((c, f) => {
      if (!c.step) {
        i || (i = this.remapping(r, f + 1), s = i.maps.length), s--, d.push(c);
        return;
      }
      if (i) {
        d.push(new Un(c.map));
        let p = c.step.map(i.slice(s)), h;
        p && o.maybeStep(p).doc && (h = o.mapping.maps[o.mapping.maps.length - 1], u.push(new Un(h, void 0, void 0, u.length + d.length))), s--, h && i.appendMap(h, s);
      } else
        o.maybeStep(c.step);
      if (c.selection)
        return a = i ? c.selection.map(i.slice(s)) : c.selection, l = new Dn(this.items.slice(0, r).append(d.reverse().concat(u)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: o, selection: a };
  }
  // Create a new branch with the given transform added.
  addTransform(e, t, r, i) {
    let s = [], o = this.eventCount, a = this.items, l = !i && a.length ? a.get(a.length - 1) : null;
    for (let d = 0; d < e.steps.length; d++) {
      let c = e.steps[d].invert(e.docs[d]), f = new Un(e.mapping.maps[d], c, t), p;
      (p = l && l.merge(f)) && (f = p, d ? s.pop() : a = a.slice(0, a.length - 1)), s.push(f), t && (o++, t = void 0), i || (l = f);
    }
    let u = o - r.depth;
    return u > xS && (a = $S(a, u), o -= u), new Dn(a.append(s), o);
  }
  remapping(e, t) {
    let r = new yo();
    return this.items.forEach((i, s) => {
      let o = i.mirrorOffset != null && s - i.mirrorOffset >= e ? r.maps.length - i.mirrorOffset : void 0;
      r.appendMap(i.map, o);
    }, e, t), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Dn(this.items.append(e.map((t) => new Un(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let r = [], i = Math.max(0, this.items.length - t), s = e.mapping, o = e.steps.length, a = this.eventCount;
    this.items.forEach((f) => {
      f.selection && a--;
    }, i);
    let l = t;
    this.items.forEach((f) => {
      let p = s.getMirror(--l);
      if (p == null)
        return;
      o = Math.min(o, p);
      let h = s.maps[p];
      if (f.step) {
        let y = e.steps[p].invert(e.docs[p]), g = f.selection && f.selection.map(s.slice(l + 1, p));
        g && a++, r.push(new Un(h, y, g));
      } else
        r.push(new Un(h));
    }, i);
    let u = [];
    for (let f = t; f < o; f++)
      u.push(new Un(s.maps[f]));
    let d = this.items.slice(0, i).append(u).append(r), c = new Dn(d, a);
    return c.emptyItemCount() > _S && (c = c.compress(this.items.length - r.length)), c;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let t = this.remapping(0, e), r = t.maps.length, i = [], s = 0;
    return this.items.forEach((o, a) => {
      if (a >= e)
        i.push(o), o.selection && s++;
      else if (o.step) {
        let l = o.step.map(t.slice(r)), u = l && l.getMap();
        if (r--, u && t.appendMap(u, r), l) {
          let d = o.selection && o.selection.map(t.slice(r));
          d && s++;
          let c = new Un(u.invert(), l, d), f, p = i.length - 1;
          (f = i.length && i[p].merge(c)) ? i[p] = f : i.push(c);
        }
      } else o.map && r--;
    }, this.items.length, 0), new Dn(xt.from(i.reverse()), s);
  }
}
Dn.empty = new Dn(xt.empty, 0);
function $S(n, e) {
  let t;
  return n.forEach((r, i) => {
    if (r.selection && e-- == 0)
      return t = i, !1;
  }), n.slice(t);
}
class Un {
  constructor(e, t, r, i) {
    this.map = e, this.step = t, this.selection = r, this.mirrorOffset = i;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new Un(t.getMap().invert(), t, this.selection);
    }
  }
}
class Nr {
  constructor(e, t, r, i, s) {
    this.done = e, this.undone = t, this.prevRanges = r, this.prevTime = i, this.prevComposition = s;
  }
}
const xS = 20;
function wS(n, e, t, r) {
  let i = t.getMeta(yi), s;
  if (i)
    return i.historyState;
  t.getMeta(SS) && (n = new Nr(n.done, n.undone, null, 0, -1));
  let o = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return n;
  if (o && o.getMeta(yi))
    return o.getMeta(yi).redo ? new Nr(n.done.addTransform(t, void 0, r, $a(e)), n.undone, Nf(t.mapping.maps), n.prevTime, n.prevComposition) : new Nr(n.done, n.undone.addTransform(t, void 0, r, $a(e)), null, n.prevTime, n.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let a = t.getMeta("composition"), l = n.prevTime == 0 || !o && n.prevComposition != a && (n.prevTime < (t.time || 0) - r.newGroupDelay || !kS(t, n.prevRanges)), u = o ? Ru(n.prevRanges, t.mapping) : Nf(t.mapping.maps);
    return new Nr(n.done.addTransform(t, l ? e.selection.getBookmark() : void 0, r, $a(e)), Dn.empty, u, t.time, a ?? n.prevComposition);
  } else return (s = t.getMeta("rebased")) ? new Nr(n.done.rebased(t, s), n.undone.rebased(t, s), Ru(n.prevRanges, t.mapping), n.prevTime, n.prevComposition) : new Nr(n.done.addMaps(t.mapping.maps), n.undone.addMaps(t.mapping.maps), Ru(n.prevRanges, t.mapping), n.prevTime, n.prevComposition);
}
function kS(n, e) {
  if (!e)
    return !1;
  if (!n.docChanged)
    return !0;
  let t = !1;
  return n.mapping.maps[0].forEach((r, i) => {
    for (let s = 0; s < e.length; s += 2)
      r <= e[s + 1] && i >= e[s] && (t = !0);
  }), t;
}
function Nf(n) {
  let e = [];
  for (let t = n.length - 1; t >= 0 && e.length == 0; t--)
    n[t].forEach((r, i, s, o) => e.push(s, o));
  return e;
}
function Ru(n, e) {
  if (!n)
    return null;
  let t = [];
  for (let r = 0; r < n.length; r += 2) {
    let i = e.map(n[r], 1), s = e.map(n[r + 1], -1);
    i <= s && t.push(i, s);
  }
  return t;
}
function CS(n, e, t) {
  let r = $a(e), i = yi.get(e).spec.config, s = (t ? n.undone : n.done).popEvent(e, r);
  if (!s)
    return null;
  let o = s.selection.resolve(s.transform.doc), a = (t ? n.done : n.undone).addTransform(s.transform, e.selection.getBookmark(), i, r), l = new Nr(t ? a : s.remaining, t ? s.remaining : a, null, 0, -1);
  return s.transform.setSelection(o).setMeta(yi, { redo: t, historyState: l });
}
let Pu = !1, Df = null;
function $a(n) {
  let e = n.plugins;
  if (Df != e) {
    Pu = !1, Df = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        Pu = !0;
        break;
      }
  }
  return Pu;
}
const yi = new Jt("history"), SS = new Jt("closeHistory");
function ES(n = {}) {
  return n = {
    depth: n.depth || 100,
    newGroupDelay: n.newGroupDelay || 500
  }, new bt({
    key: yi,
    state: {
      init() {
        return new Nr(Dn.empty, Dn.empty, null, 0, -1);
      },
      apply(e, t, r) {
        return wS(t, r, e, n);
      }
    },
    config: n,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let r = t.inputType, i = r == "historyUndo" ? k3 : r == "historyRedo" ? C3 : null;
          return i ? (t.preventDefault(), i(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function w3(n, e) {
  return (t, r) => {
    let i = yi.getState(t);
    if (!i || (n ? i.undone : i.done).eventCount == 0)
      return !1;
    if (r) {
      let s = CS(i, t, n);
      s && r(e ? s.scrollIntoView() : s);
    }
    return !0;
  };
}
const k3 = w3(!1, !0), C3 = w3(!0, !0), TS = St.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: n, dispatch: e }) => k3(n, e),
      redo: () => ({ state: n, dispatch: e }) => C3(n, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      ES(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), OS = rn.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["hr", gt(this.options.HTMLAttributes, n)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: n, state: e }) => {
        const { selection: t } = e, { $from: r, $to: i } = t, s = n();
        return r.parentOffset === 0 ? s.insertContentAt({
          from: Math.max(r.pos - 1, 0),
          to: i.pos
        }, {
          type: this.name
        }) : c3(t) ? s.insertContentAt(i.pos, {
          type: this.name
        }) : s.insertContent({ type: this.name }), s.command(({ tr: o, dispatch: a }) => {
          var l;
          if (a) {
            const { $to: u } = o.selection, d = u.end();
            if (u.nodeAfter)
              u.nodeAfter.isTextblock ? o.setSelection(Ce.create(o.doc, u.pos + 1)) : u.nodeAfter.isBlock ? o.setSelection(ve.create(o.doc, u.pos)) : o.setSelection(Ce.create(o.doc, u.pos));
            else {
              const c = (l = u.parent.type.contentMatch.defaultType) === null || l === void 0 ? void 0 : l.create();
              c && (o.insert(d, c), o.setSelection(Ce.create(o.doc, d + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      gC({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), MS = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, AS = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, NS = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, DS = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, LS = In.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (n) => n.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["em", gt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: n }) => n.setMark(this.name),
      toggleItalic: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetItalic: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      ps({
        find: MS,
        type: this.type
      }),
      ps({
        find: NS,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ti({
        find: AS,
        type: this.type
      }),
      Ti({
        find: DS,
        type: this.type
      })
    ];
  }
}), RS = "listItem", Lf = "textStyle", Rf = /^(\d+)\.\s$/, PS = rn.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (n) => n.hasAttribute("start") ? parseInt(n.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (n) => n.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { start: e, ...t } = n;
    return e === 1 ? ["ol", gt(this.options.HTMLAttributes, t), 0] : ["ol", gt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(RS, this.editor.getAttributes(Lf)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let n = ko({
      find: Rf,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = ko({
      find: Rf,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(Lf) }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
      editor: this.editor
    })), [
      n
    ];
  }
}), IS = rn.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["p", gt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), BS = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, zS = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, VS = In.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["s", gt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: n }) => n.setMark(this.name),
      toggleStrike: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetStrike: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      ps({
        find: BS,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ti({
        find: zS,
        type: this.type
      })
    ];
  }
}), FS = rn.create({
  name: "text",
  group: "inline"
}), jS = St.create({
  name: "starterKit",
  addExtensions() {
    const n = [];
    return this.options.bold !== !1 && n.push(JC.configure(this.options.bold)), this.options.blockquote !== !1 && n.push(WC.configure(this.options.blockquote)), this.options.bulletList !== !1 && n.push(XC.configure(this.options.bulletList)), this.options.code !== !1 && n.push(tS.configure(this.options.code)), this.options.codeBlock !== !1 && n.push(iS.configure(this.options.codeBlock)), this.options.document !== !1 && n.push(sS.configure(this.options.document)), this.options.dropcursor !== !1 && n.push(lS.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && n.push(gS.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && n.push(bS.configure(this.options.hardBreak)), this.options.heading !== !1 && n.push(yS.configure(this.options.heading)), this.options.history !== !1 && n.push(TS.configure(this.options.history)), this.options.horizontalRule !== !1 && n.push(OS.configure(this.options.horizontalRule)), this.options.italic !== !1 && n.push(LS.configure(this.options.italic)), this.options.listItem !== !1 && n.push(Ud.configure(this.options.listItem)), this.options.orderedList !== !1 && n.push(PS.configure(this.options.orderedList)), this.options.paragraph !== !1 && n.push(IS.configure(this.options.paragraph)), this.options.strike !== !1 && n.push(VS.configure(this.options.strike)), this.options.text !== !1 && n.push(FS.configure(this.options.text)), n;
  }
});
var tn = "top", Tn = "bottom", On = "right", nn = "left", i0 = "auto", Bo = [tn, Tn, On, nn], ms = "start", Eo = "end", HS = "clippingParents", S3 = "viewport", Ns = "popper", US = "reference", Pf = /* @__PURE__ */ Bo.reduce(function(n, e) {
  return n.concat([e + "-" + ms, e + "-" + Eo]);
}, []), E3 = /* @__PURE__ */ [].concat(Bo, [i0]).reduce(function(n, e) {
  return n.concat([e, e + "-" + ms, e + "-" + Eo]);
}, []), WS = "beforeRead", qS = "read", KS = "afterRead", GS = "beforeMain", YS = "main", JS = "afterMain", ZS = "beforeWrite", XS = "write", QS = "afterWrite", eE = [WS, qS, KS, GS, YS, JS, ZS, XS, QS];
function Xn(n) {
  return n ? (n.nodeName || "").toLowerCase() : null;
}
function hn(n) {
  if (n == null)
    return window;
  if (n.toString() !== "[object Window]") {
    var e = n.ownerDocument;
    return e && e.defaultView || window;
  }
  return n;
}
function Oi(n) {
  var e = hn(n).Element;
  return n instanceof e || n instanceof Element;
}
function En(n) {
  var e = hn(n).HTMLElement;
  return n instanceof e || n instanceof HTMLElement;
}
function s0(n) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = hn(n).ShadowRoot;
  return n instanceof e || n instanceof ShadowRoot;
}
function tE(n) {
  var e = n.state;
  Object.keys(e.elements).forEach(function(t) {
    var r = e.styles[t] || {}, i = e.attributes[t] || {}, s = e.elements[t];
    !En(s) || !Xn(s) || (Object.assign(s.style, r), Object.keys(i).forEach(function(o) {
      var a = i[o];
      a === !1 ? s.removeAttribute(o) : s.setAttribute(o, a === !0 ? "" : a);
    }));
  });
}
function nE(n) {
  var e = n.state, t = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, t.popper), e.styles = t, e.elements.arrow && Object.assign(e.elements.arrow.style, t.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var i = e.elements[r], s = e.attributes[r] || {}, o = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : t[r]), a = o.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !En(i) || !Xn(i) || (Object.assign(i.style, a), Object.keys(s).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const T3 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: tE,
  effect: nE,
  requires: ["computeStyles"]
};
function Gn(n) {
  return n.split("-")[0];
}
var vi = Math.max, gl = Math.min, gs = Math.round;
function Wd() {
  var n = navigator.userAgentData;
  return n != null && n.brands && Array.isArray(n.brands) ? n.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function O3() {
  return !/^((?!chrome|android).)*safari/i.test(Wd());
}
function bs(n, e, t) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  var r = n.getBoundingClientRect(), i = 1, s = 1;
  e && En(n) && (i = n.offsetWidth > 0 && gs(r.width) / n.offsetWidth || 1, s = n.offsetHeight > 0 && gs(r.height) / n.offsetHeight || 1);
  var o = Oi(n) ? hn(n) : window, a = o.visualViewport, l = !O3() && t, u = (r.left + (l && a ? a.offsetLeft : 0)) / i, d = (r.top + (l && a ? a.offsetTop : 0)) / s, c = r.width / i, f = r.height / s;
  return {
    width: c,
    height: f,
    top: d,
    right: u + c,
    bottom: d + f,
    left: u,
    x: u,
    y: d
  };
}
function o0(n) {
  var e = bs(n), t = n.offsetWidth, r = n.offsetHeight;
  return Math.abs(e.width - t) <= 1 && (t = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: n.offsetLeft,
    y: n.offsetTop,
    width: t,
    height: r
  };
}
function M3(n, e) {
  var t = e.getRootNode && e.getRootNode();
  if (n.contains(e))
    return !0;
  if (t && s0(t)) {
    var r = e;
    do {
      if (r && n.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function mr(n) {
  return hn(n).getComputedStyle(n);
}
function rE(n) {
  return ["table", "td", "th"].indexOf(Xn(n)) >= 0;
}
function Xr(n) {
  return ((Oi(n) ? n.ownerDocument : (
    // $FlowFixMe[prop-missing]
    n.document
  )) || window.document).documentElement;
}
function Hl(n) {
  return Xn(n) === "html" ? n : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    n.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    n.parentNode || // DOM Element detected
    (s0(n) ? n.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Xr(n)
  );
}
function If(n) {
  return !En(n) || // https://github.com/popperjs/popper-core/issues/837
  mr(n).position === "fixed" ? null : n.offsetParent;
}
function iE(n) {
  var e = /firefox/i.test(Wd()), t = /Trident/i.test(Wd());
  if (t && En(n)) {
    var r = mr(n);
    if (r.position === "fixed")
      return null;
  }
  var i = Hl(n);
  for (s0(i) && (i = i.host); En(i) && ["html", "body"].indexOf(Xn(i)) < 0; ) {
    var s = mr(i);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || e && s.willChange === "filter" || e && s.filter && s.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function zo(n) {
  for (var e = hn(n), t = If(n); t && rE(t) && mr(t).position === "static"; )
    t = If(t);
  return t && (Xn(t) === "html" || Xn(t) === "body" && mr(t).position === "static") ? e : t || iE(n) || e;
}
function a0(n) {
  return ["top", "bottom"].indexOf(n) >= 0 ? "x" : "y";
}
function no(n, e, t) {
  return vi(n, gl(e, t));
}
function sE(n, e, t) {
  var r = no(n, e, t);
  return r > t ? t : r;
}
function A3() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function N3(n) {
  return Object.assign({}, A3(), n);
}
function D3(n, e) {
  return e.reduce(function(t, r) {
    return t[r] = n, t;
  }, {});
}
var oE = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, N3(typeof e != "number" ? e : D3(e, Bo));
};
function aE(n) {
  var e, t = n.state, r = n.name, i = n.options, s = t.elements.arrow, o = t.modifiersData.popperOffsets, a = Gn(t.placement), l = a0(a), u = [nn, On].indexOf(a) >= 0, d = u ? "height" : "width";
  if (!(!s || !o)) {
    var c = oE(i.padding, t), f = o0(s), p = l === "y" ? tn : nn, h = l === "y" ? Tn : On, y = t.rects.reference[d] + t.rects.reference[l] - o[l] - t.rects.popper[d], g = o[l] - t.rects.reference[l], m = zo(s), $ = m ? l === "y" ? m.clientHeight || 0 : m.clientWidth || 0 : 0, w = y / 2 - g / 2, _ = c[p], L = $ - f[d] - c[h], S = $ / 2 - f[d] / 2 + w, R = no(_, S, L), O = l;
    t.modifiersData[r] = (e = {}, e[O] = R, e.centerOffset = R - S, e);
  }
}
function lE(n) {
  var e = n.state, t = n.options, r = t.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = e.elements.popper.querySelector(i), !i) || M3(e.elements.popper, i) && (e.elements.arrow = i));
}
const uE = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: aE,
  effect: lE,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ys(n) {
  return n.split("-")[1];
}
var dE = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function cE(n, e) {
  var t = n.x, r = n.y, i = e.devicePixelRatio || 1;
  return {
    x: gs(t * i) / i || 0,
    y: gs(r * i) / i || 0
  };
}
function Bf(n) {
  var e, t = n.popper, r = n.popperRect, i = n.placement, s = n.variation, o = n.offsets, a = n.position, l = n.gpuAcceleration, u = n.adaptive, d = n.roundOffsets, c = n.isFixed, f = o.x, p = f === void 0 ? 0 : f, h = o.y, y = h === void 0 ? 0 : h, g = typeof d == "function" ? d({
    x: p,
    y
  }) : {
    x: p,
    y
  };
  p = g.x, y = g.y;
  var m = o.hasOwnProperty("x"), $ = o.hasOwnProperty("y"), w = nn, _ = tn, L = window;
  if (u) {
    var S = zo(t), R = "clientHeight", O = "clientWidth";
    if (S === hn(t) && (S = Xr(t), mr(S).position !== "static" && a === "absolute" && (R = "scrollHeight", O = "scrollWidth")), S = S, i === tn || (i === nn || i === On) && s === Eo) {
      _ = Tn;
      var I = c && S === L && L.visualViewport ? L.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        S[R]
      );
      y -= I - r.height, y *= l ? 1 : -1;
    }
    if (i === nn || (i === tn || i === Tn) && s === Eo) {
      w = On;
      var x = c && S === L && L.visualViewport ? L.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        S[O]
      );
      p -= x - r.width, p *= l ? 1 : -1;
    }
  }
  var M = Object.assign({
    position: a
  }, u && dE), D = d === !0 ? cE({
    x: p,
    y
  }, hn(t)) : {
    x: p,
    y
  };
  if (p = D.x, y = D.y, l) {
    var j;
    return Object.assign({}, M, (j = {}, j[_] = $ ? "0" : "", j[w] = m ? "0" : "", j.transform = (L.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + y + "px)" : "translate3d(" + p + "px, " + y + "px, 0)", j));
  }
  return Object.assign({}, M, (e = {}, e[_] = $ ? y + "px" : "", e[w] = m ? p + "px" : "", e.transform = "", e));
}
function fE(n) {
  var e = n.state, t = n.options, r = t.gpuAcceleration, i = r === void 0 ? !0 : r, s = t.adaptive, o = s === void 0 ? !0 : s, a = t.roundOffsets, l = a === void 0 ? !0 : a, u = {
    placement: Gn(e.placement),
    variation: ys(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: i,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Bf(Object.assign({}, u, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Bf(Object.assign({}, u, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const pE = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: fE,
  data: {}
};
var sa = {
  passive: !0
};
function hE(n) {
  var e = n.state, t = n.instance, r = n.options, i = r.scroll, s = i === void 0 ? !0 : i, o = r.resize, a = o === void 0 ? !0 : o, l = hn(e.elements.popper), u = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return s && u.forEach(function(d) {
    d.addEventListener("scroll", t.update, sa);
  }), a && l.addEventListener("resize", t.update, sa), function() {
    s && u.forEach(function(d) {
      d.removeEventListener("scroll", t.update, sa);
    }), a && l.removeEventListener("resize", t.update, sa);
  };
}
const mE = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: hE,
  data: {}
};
var gE = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function xa(n) {
  return n.replace(/left|right|bottom|top/g, function(e) {
    return gE[e];
  });
}
var bE = {
  start: "end",
  end: "start"
};
function zf(n) {
  return n.replace(/start|end/g, function(e) {
    return bE[e];
  });
}
function l0(n) {
  var e = hn(n), t = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: r
  };
}
function u0(n) {
  return bs(Xr(n)).left + l0(n).scrollLeft;
}
function yE(n, e) {
  var t = hn(n), r = Xr(n), i = t.visualViewport, s = r.clientWidth, o = r.clientHeight, a = 0, l = 0;
  if (i) {
    s = i.width, o = i.height;
    var u = O3();
    (u || !u && e === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: s,
    height: o,
    x: a + u0(n),
    y: l
  };
}
function vE(n) {
  var e, t = Xr(n), r = l0(n), i = (e = n.ownerDocument) == null ? void 0 : e.body, s = vi(t.scrollWidth, t.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), o = vi(t.scrollHeight, t.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), a = -r.scrollLeft + u0(n), l = -r.scrollTop;
  return mr(i || t).direction === "rtl" && (a += vi(t.clientWidth, i ? i.clientWidth : 0) - s), {
    width: s,
    height: o,
    x: a,
    y: l
  };
}
function d0(n) {
  var e = mr(n), t = e.overflow, r = e.overflowX, i = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + i + r);
}
function L3(n) {
  return ["html", "body", "#document"].indexOf(Xn(n)) >= 0 ? n.ownerDocument.body : En(n) && d0(n) ? n : L3(Hl(n));
}
function ro(n, e) {
  var t;
  e === void 0 && (e = []);
  var r = L3(n), i = r === ((t = n.ownerDocument) == null ? void 0 : t.body), s = hn(r), o = i ? [s].concat(s.visualViewport || [], d0(r) ? r : []) : r, a = e.concat(o);
  return i ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(ro(Hl(o)))
  );
}
function qd(n) {
  return Object.assign({}, n, {
    left: n.x,
    top: n.y,
    right: n.x + n.width,
    bottom: n.y + n.height
  });
}
function _E(n, e) {
  var t = bs(n, !1, e === "fixed");
  return t.top = t.top + n.clientTop, t.left = t.left + n.clientLeft, t.bottom = t.top + n.clientHeight, t.right = t.left + n.clientWidth, t.width = n.clientWidth, t.height = n.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Vf(n, e, t) {
  return e === S3 ? qd(yE(n, t)) : Oi(e) ? _E(e, t) : qd(vE(Xr(n)));
}
function $E(n) {
  var e = ro(Hl(n)), t = ["absolute", "fixed"].indexOf(mr(n).position) >= 0, r = t && En(n) ? zo(n) : n;
  return Oi(r) ? e.filter(function(i) {
    return Oi(i) && M3(i, r) && Xn(i) !== "body";
  }) : [];
}
function xE(n, e, t, r) {
  var i = e === "clippingParents" ? $E(n) : [].concat(e), s = [].concat(i, [t]), o = s[0], a = s.reduce(function(l, u) {
    var d = Vf(n, u, r);
    return l.top = vi(d.top, l.top), l.right = gl(d.right, l.right), l.bottom = gl(d.bottom, l.bottom), l.left = vi(d.left, l.left), l;
  }, Vf(n, o, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function R3(n) {
  var e = n.reference, t = n.element, r = n.placement, i = r ? Gn(r) : null, s = r ? ys(r) : null, o = e.x + e.width / 2 - t.width / 2, a = e.y + e.height / 2 - t.height / 2, l;
  switch (i) {
    case tn:
      l = {
        x: o,
        y: e.y - t.height
      };
      break;
    case Tn:
      l = {
        x: o,
        y: e.y + e.height
      };
      break;
    case On:
      l = {
        x: e.x + e.width,
        y: a
      };
      break;
    case nn:
      l = {
        x: e.x - t.width,
        y: a
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var u = i ? a0(i) : null;
  if (u != null) {
    var d = u === "y" ? "height" : "width";
    switch (s) {
      case ms:
        l[u] = l[u] - (e[d] / 2 - t[d] / 2);
        break;
      case Eo:
        l[u] = l[u] + (e[d] / 2 - t[d] / 2);
        break;
    }
  }
  return l;
}
function To(n, e) {
  e === void 0 && (e = {});
  var t = e, r = t.placement, i = r === void 0 ? n.placement : r, s = t.strategy, o = s === void 0 ? n.strategy : s, a = t.boundary, l = a === void 0 ? HS : a, u = t.rootBoundary, d = u === void 0 ? S3 : u, c = t.elementContext, f = c === void 0 ? Ns : c, p = t.altBoundary, h = p === void 0 ? !1 : p, y = t.padding, g = y === void 0 ? 0 : y, m = N3(typeof g != "number" ? g : D3(g, Bo)), $ = f === Ns ? US : Ns, w = n.rects.popper, _ = n.elements[h ? $ : f], L = xE(Oi(_) ? _ : _.contextElement || Xr(n.elements.popper), l, d, o), S = bs(n.elements.reference), R = R3({
    reference: S,
    element: w,
    strategy: "absolute",
    placement: i
  }), O = qd(Object.assign({}, w, R)), I = f === Ns ? O : S, x = {
    top: L.top - I.top + m.top,
    bottom: I.bottom - L.bottom + m.bottom,
    left: L.left - I.left + m.left,
    right: I.right - L.right + m.right
  }, M = n.modifiersData.offset;
  if (f === Ns && M) {
    var D = M[i];
    Object.keys(x).forEach(function(j) {
      var U = [On, Tn].indexOf(j) >= 0 ? 1 : -1, J = [tn, Tn].indexOf(j) >= 0 ? "y" : "x";
      x[j] += D[J] * U;
    });
  }
  return x;
}
function wE(n, e) {
  e === void 0 && (e = {});
  var t = e, r = t.placement, i = t.boundary, s = t.rootBoundary, o = t.padding, a = t.flipVariations, l = t.allowedAutoPlacements, u = l === void 0 ? E3 : l, d = ys(r), c = d ? a ? Pf : Pf.filter(function(h) {
    return ys(h) === d;
  }) : Bo, f = c.filter(function(h) {
    return u.indexOf(h) >= 0;
  });
  f.length === 0 && (f = c);
  var p = f.reduce(function(h, y) {
    return h[y] = To(n, {
      placement: y,
      boundary: i,
      rootBoundary: s,
      padding: o
    })[Gn(y)], h;
  }, {});
  return Object.keys(p).sort(function(h, y) {
    return p[h] - p[y];
  });
}
function kE(n) {
  if (Gn(n) === i0)
    return [];
  var e = xa(n);
  return [zf(n), e, zf(e)];
}
function CE(n) {
  var e = n.state, t = n.options, r = n.name;
  if (!e.modifiersData[r]._skip) {
    for (var i = t.mainAxis, s = i === void 0 ? !0 : i, o = t.altAxis, a = o === void 0 ? !0 : o, l = t.fallbackPlacements, u = t.padding, d = t.boundary, c = t.rootBoundary, f = t.altBoundary, p = t.flipVariations, h = p === void 0 ? !0 : p, y = t.allowedAutoPlacements, g = e.options.placement, m = Gn(g), $ = m === g, w = l || ($ || !h ? [xa(g)] : kE(g)), _ = [g].concat(w).reduce(function(xe, Le) {
      return xe.concat(Gn(Le) === i0 ? wE(e, {
        placement: Le,
        boundary: d,
        rootBoundary: c,
        padding: u,
        flipVariations: h,
        allowedAutoPlacements: y
      }) : Le);
    }, []), L = e.rects.reference, S = e.rects.popper, R = /* @__PURE__ */ new Map(), O = !0, I = _[0], x = 0; x < _.length; x++) {
      var M = _[x], D = Gn(M), j = ys(M) === ms, U = [tn, Tn].indexOf(D) >= 0, J = U ? "width" : "height", ne = To(e, {
        placement: M,
        boundary: d,
        rootBoundary: c,
        altBoundary: f,
        padding: u
      }), Y = U ? j ? On : nn : j ? Tn : tn;
      L[J] > S[J] && (Y = xa(Y));
      var oe = xa(Y), le = [];
      if (s && le.push(ne[D] <= 0), a && le.push(ne[Y] <= 0, ne[oe] <= 0), le.every(function(xe) {
        return xe;
      })) {
        I = M, O = !1;
        break;
      }
      R.set(M, le);
    }
    if (O)
      for (var ge = h ? 3 : 1, he = function(Le) {
        var be = _.find(function(He) {
          var Re = R.get(He);
          if (Re)
            return Re.slice(0, Le).every(function(rt) {
              return rt;
            });
        });
        if (be)
          return I = be, "break";
      }, _e = ge; _e > 0; _e--) {
        var ue = he(_e);
        if (ue === "break") break;
      }
    e.placement !== I && (e.modifiersData[r]._skip = !0, e.placement = I, e.reset = !0);
  }
}
const SE = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: CE,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ff(n, e, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: n.top - e.height - t.y,
    right: n.right - e.width + t.x,
    bottom: n.bottom - e.height + t.y,
    left: n.left - e.width - t.x
  };
}
function jf(n) {
  return [tn, On, Tn, nn].some(function(e) {
    return n[e] >= 0;
  });
}
function EE(n) {
  var e = n.state, t = n.name, r = e.rects.reference, i = e.rects.popper, s = e.modifiersData.preventOverflow, o = To(e, {
    elementContext: "reference"
  }), a = To(e, {
    altBoundary: !0
  }), l = Ff(o, r), u = Ff(a, i, s), d = jf(l), c = jf(u);
  e.modifiersData[t] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: d,
    hasPopperEscaped: c
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": c
  });
}
const TE = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: EE
};
function OE(n, e, t) {
  var r = Gn(n), i = [nn, tn].indexOf(r) >= 0 ? -1 : 1, s = typeof t == "function" ? t(Object.assign({}, e, {
    placement: n
  })) : t, o = s[0], a = s[1];
  return o = o || 0, a = (a || 0) * i, [nn, On].indexOf(r) >= 0 ? {
    x: a,
    y: o
  } : {
    x: o,
    y: a
  };
}
function ME(n) {
  var e = n.state, t = n.options, r = n.name, i = t.offset, s = i === void 0 ? [0, 0] : i, o = E3.reduce(function(d, c) {
    return d[c] = OE(c, e.rects, s), d;
  }, {}), a = o[e.placement], l = a.x, u = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += u), e.modifiersData[r] = o;
}
const AE = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: ME
};
function NE(n) {
  var e = n.state, t = n.name;
  e.modifiersData[t] = R3({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const DE = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: NE,
  data: {}
};
function LE(n) {
  return n === "x" ? "y" : "x";
}
function RE(n) {
  var e = n.state, t = n.options, r = n.name, i = t.mainAxis, s = i === void 0 ? !0 : i, o = t.altAxis, a = o === void 0 ? !1 : o, l = t.boundary, u = t.rootBoundary, d = t.altBoundary, c = t.padding, f = t.tether, p = f === void 0 ? !0 : f, h = t.tetherOffset, y = h === void 0 ? 0 : h, g = To(e, {
    boundary: l,
    rootBoundary: u,
    padding: c,
    altBoundary: d
  }), m = Gn(e.placement), $ = ys(e.placement), w = !$, _ = a0(m), L = LE(_), S = e.modifiersData.popperOffsets, R = e.rects.reference, O = e.rects.popper, I = typeof y == "function" ? y(Object.assign({}, e.rects, {
    placement: e.placement
  })) : y, x = typeof I == "number" ? {
    mainAxis: I,
    altAxis: I
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, I), M = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, D = {
    x: 0,
    y: 0
  };
  if (S) {
    if (s) {
      var j, U = _ === "y" ? tn : nn, J = _ === "y" ? Tn : On, ne = _ === "y" ? "height" : "width", Y = S[_], oe = Y + g[U], le = Y - g[J], ge = p ? -O[ne] / 2 : 0, he = $ === ms ? R[ne] : O[ne], _e = $ === ms ? -O[ne] : -R[ne], ue = e.elements.arrow, xe = p && ue ? o0(ue) : {
        width: 0,
        height: 0
      }, Le = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : A3(), be = Le[U], He = Le[J], Re = no(0, R[ne], xe[ne]), rt = w ? R[ne] / 2 - ge - Re - be - x.mainAxis : he - Re - be - x.mainAxis, ze = w ? -R[ne] / 2 + ge + Re + He + x.mainAxis : _e + Re + He + x.mainAxis, Pe = e.elements.arrow && zo(e.elements.arrow), fe = Pe ? _ === "y" ? Pe.clientTop || 0 : Pe.clientLeft || 0 : 0, we = (j = M == null ? void 0 : M[_]) != null ? j : 0, Be = Y + rt - we - fe, Fe = Y + ze - we, Xe = no(p ? gl(oe, Be) : oe, Y, p ? vi(le, Fe) : le);
      S[_] = Xe, D[_] = Xe - Y;
    }
    if (a) {
      var ot, ct = _ === "x" ? tn : nn, ft = _ === "x" ? Tn : On, lt = S[L], ut = L === "y" ? "height" : "width", gn = lt + g[ct], sn = lt - g[ft], zn = [tn, nn].indexOf(m) !== -1, Qn = (ot = M == null ? void 0 : M[L]) != null ? ot : 0, br = zn ? gn : lt - R[ut] - O[ut] - Qn + x.altAxis, er = zn ? lt + R[ut] + O[ut] - Qn - x.altAxis : sn, yr = p && zn ? sE(br, lt, er) : no(p ? br : gn, lt, p ? er : sn);
      S[L] = yr, D[L] = yr - lt;
    }
    e.modifiersData[r] = D;
  }
}
const PE = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: RE,
  requiresIfExists: ["offset"]
};
function IE(n) {
  return {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  };
}
function BE(n) {
  return n === hn(n) || !En(n) ? l0(n) : IE(n);
}
function zE(n) {
  var e = n.getBoundingClientRect(), t = gs(e.width) / n.offsetWidth || 1, r = gs(e.height) / n.offsetHeight || 1;
  return t !== 1 || r !== 1;
}
function VE(n, e, t) {
  t === void 0 && (t = !1);
  var r = En(e), i = En(e) && zE(e), s = Xr(e), o = bs(n, i, t), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !t) && ((Xn(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  d0(s)) && (a = BE(e)), En(e) ? (l = bs(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : s && (l.x = u0(s))), {
    x: o.left + a.scrollLeft - l.x,
    y: o.top + a.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function FE(n) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), r = [];
  n.forEach(function(s) {
    e.set(s.name, s);
  });
  function i(s) {
    t.add(s.name);
    var o = [].concat(s.requires || [], s.requiresIfExists || []);
    o.forEach(function(a) {
      if (!t.has(a)) {
        var l = e.get(a);
        l && i(l);
      }
    }), r.push(s);
  }
  return n.forEach(function(s) {
    t.has(s.name) || i(s);
  }), r;
}
function jE(n) {
  var e = FE(n);
  return eE.reduce(function(t, r) {
    return t.concat(e.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function HE(n) {
  var e;
  return function() {
    return e || (e = new Promise(function(t) {
      Promise.resolve().then(function() {
        e = void 0, t(n());
      });
    })), e;
  };
}
function UE(n) {
  var e = n.reduce(function(t, r) {
    var i = t[r.name];
    return t[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, t;
  }, {});
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
var Hf = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Uf() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function WE(n) {
  n === void 0 && (n = {});
  var e = n, t = e.defaultModifiers, r = t === void 0 ? [] : t, i = e.defaultOptions, s = i === void 0 ? Hf : i;
  return function(a, l, u) {
    u === void 0 && (u = s);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Hf, s),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, c = [], f = !1, p = {
      state: d,
      setOptions: function(m) {
        var $ = typeof m == "function" ? m(d.options) : m;
        y(), d.options = Object.assign({}, s, d.options, $), d.scrollParents = {
          reference: Oi(a) ? ro(a) : a.contextElement ? ro(a.contextElement) : [],
          popper: ro(l)
        };
        var w = jE(UE([].concat(r, d.options.modifiers)));
        return d.orderedModifiers = w.filter(function(_) {
          return _.enabled;
        }), h(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var m = d.elements, $ = m.reference, w = m.popper;
          if (Uf($, w)) {
            d.rects = {
              reference: VE($, zo(w), d.options.strategy === "fixed"),
              popper: o0(w)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(x) {
              return d.modifiersData[x.name] = Object.assign({}, x.data);
            });
            for (var _ = 0; _ < d.orderedModifiers.length; _++) {
              if (d.reset === !0) {
                d.reset = !1, _ = -1;
                continue;
              }
              var L = d.orderedModifiers[_], S = L.fn, R = L.options, O = R === void 0 ? {} : R, I = L.name;
              typeof S == "function" && (d = S({
                state: d,
                options: O,
                name: I,
                instance: p
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: HE(function() {
        return new Promise(function(g) {
          p.forceUpdate(), g(d);
        });
      }),
      destroy: function() {
        y(), f = !0;
      }
    };
    if (!Uf(a, l))
      return p;
    p.setOptions(u).then(function(g) {
      !f && u.onFirstUpdate && u.onFirstUpdate(g);
    });
    function h() {
      d.orderedModifiers.forEach(function(g) {
        var m = g.name, $ = g.options, w = $ === void 0 ? {} : $, _ = g.effect;
        if (typeof _ == "function") {
          var L = _({
            state: d,
            name: m,
            instance: p,
            options: w
          }), S = function() {
          };
          c.push(L || S);
        }
      });
    }
    function y() {
      c.forEach(function(g) {
        return g();
      }), c = [];
    }
    return p;
  };
}
var qE = [mE, DE, pE, T3, AE, SE, PE, uE, TE], KE = /* @__PURE__ */ WE({
  defaultModifiers: qE
}), GE = "tippy-box", P3 = "tippy-content", YE = "tippy-backdrop", I3 = "tippy-arrow", B3 = "tippy-svg-arrow", ii = {
  passive: !0,
  capture: !0
}, z3 = function() {
  return document.body;
};
function JE(n, e) {
  return {}.hasOwnProperty.call(n, e);
}
function Iu(n, e, t) {
  if (Array.isArray(n)) {
    var r = n[e];
    return r ?? (Array.isArray(t) ? t[e] : t);
  }
  return n;
}
function c0(n, e) {
  var t = {}.toString.call(n);
  return t.indexOf("[object") === 0 && t.indexOf(e + "]") > -1;
}
function V3(n, e) {
  return typeof n == "function" ? n.apply(void 0, e) : n;
}
function Wf(n, e) {
  if (e === 0)
    return n;
  var t;
  return function(r) {
    clearTimeout(t), t = setTimeout(function() {
      n(r);
    }, e);
  };
}
function ZE(n, e) {
  var t = Object.assign({}, n);
  return e.forEach(function(r) {
    delete t[r];
  }), t;
}
function XE(n) {
  return n.split(/\s+/).filter(Boolean);
}
function ji(n) {
  return [].concat(n);
}
function qf(n, e) {
  n.indexOf(e) === -1 && n.push(e);
}
function QE(n) {
  return n.filter(function(e, t) {
    return n.indexOf(e) === t;
  });
}
function eT(n) {
  return n.split("-")[0];
}
function bl(n) {
  return [].slice.call(n);
}
function Kf(n) {
  return Object.keys(n).reduce(function(e, t) {
    return n[t] !== void 0 && (e[t] = n[t]), e;
  }, {});
}
function io() {
  return document.createElement("div");
}
function Oo(n) {
  return ["Element", "Fragment"].some(function(e) {
    return c0(n, e);
  });
}
function tT(n) {
  return c0(n, "NodeList");
}
function nT(n) {
  return c0(n, "MouseEvent");
}
function rT(n) {
  return !!(n && n._tippy && n._tippy.reference === n);
}
function iT(n) {
  return Oo(n) ? [n] : tT(n) ? bl(n) : Array.isArray(n) ? n : bl(document.querySelectorAll(n));
}
function Bu(n, e) {
  n.forEach(function(t) {
    t && (t.style.transitionDuration = e + "ms");
  });
}
function Gf(n, e) {
  n.forEach(function(t) {
    t && t.setAttribute("data-state", e);
  });
}
function sT(n) {
  var e, t = ji(n), r = t[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function oT(n, e) {
  var t = e.clientX, r = e.clientY;
  return n.every(function(i) {
    var s = i.popperRect, o = i.popperState, a = i.props, l = a.interactiveBorder, u = eT(o.placement), d = o.modifiersData.offset;
    if (!d)
      return !0;
    var c = u === "bottom" ? d.top.y : 0, f = u === "top" ? d.bottom.y : 0, p = u === "right" ? d.left.x : 0, h = u === "left" ? d.right.x : 0, y = s.top - r + c > l, g = r - s.bottom - f > l, m = s.left - t + p > l, $ = t - s.right - h > l;
    return y || g || m || $;
  });
}
function zu(n, e, t) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(i) {
    n[r](i, t);
  });
}
function Yf(n, e) {
  for (var t = e; t; ) {
    var r;
    if (n.contains(t))
      return !0;
    t = t.getRootNode == null || (r = t.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var Wn = {
  isTouch: !1
}, Jf = 0;
function aT() {
  Wn.isTouch || (Wn.isTouch = !0, window.performance && document.addEventListener("mousemove", F3));
}
function F3() {
  var n = performance.now();
  n - Jf < 20 && (Wn.isTouch = !1, document.removeEventListener("mousemove", F3)), Jf = n;
}
function lT() {
  var n = document.activeElement;
  if (rT(n)) {
    var e = n._tippy;
    n.blur && !e.state.isVisible && n.blur();
  }
}
function uT() {
  document.addEventListener("touchstart", aT, ii), window.addEventListener("blur", lT);
}
var dT = typeof window < "u" && typeof document < "u", cT = dT ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function Pi(n) {
  var e = n === "destroy" ? "n already-" : " ";
  return [n + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function Zf(n) {
  var e = /[ \t]{2,}/g, t = /^[ \t]*/gm;
  return n.replace(e, " ").replace(t, "").trim();
}
function fT(n) {
  return Zf(`
  %ctippy.js

  %c` + Zf(n) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function j3(n) {
  return [
    fT(n),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Mo;
process.env.NODE_ENV !== "production" && pT();
function pT() {
  Mo = /* @__PURE__ */ new Set();
}
function lr(n, e) {
  if (n && !Mo.has(e)) {
    var t;
    Mo.add(e), (t = console).warn.apply(t, j3(e));
  }
}
function Kd(n, e) {
  if (n && !Mo.has(e)) {
    var t;
    Mo.add(e), (t = console).error.apply(t, j3(e));
  }
}
function hT(n) {
  var e = !n, t = Object.prototype.toString.call(n) === "[object Object]" && !n.addEventListener;
  Kd(e, ["tippy() was passed", "`" + String(n) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), Kd(t, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var H3 = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, mT = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, fn = Object.assign({
  appendTo: z3,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, H3, mT), gT = Object.keys(fn), bT = function(e) {
  process.env.NODE_ENV !== "production" && W3(e, []);
  var t = Object.keys(e);
  t.forEach(function(r) {
    fn[r] = e[r];
  });
};
function U3(n) {
  var e = n.plugins || [], t = e.reduce(function(r, i) {
    var s = i.name, o = i.defaultValue;
    if (s) {
      var a;
      r[s] = n[s] !== void 0 ? n[s] : (a = fn[s]) != null ? a : o;
    }
    return r;
  }, {});
  return Object.assign({}, n, t);
}
function yT(n, e) {
  var t = e ? Object.keys(U3(Object.assign({}, fn, {
    plugins: e
  }))) : gT, r = t.reduce(function(i, s) {
    var o = (n.getAttribute("data-tippy-" + s) || "").trim();
    if (!o)
      return i;
    if (s === "content")
      i[s] = o;
    else
      try {
        i[s] = JSON.parse(o);
      } catch {
        i[s] = o;
      }
    return i;
  }, {});
  return r;
}
function Xf(n, e) {
  var t = Object.assign({}, e, {
    content: V3(e.content, [n])
  }, e.ignoreAttributes ? {} : yT(n, e.plugins));
  return t.aria = Object.assign({}, fn.aria, t.aria), t.aria = {
    expanded: t.aria.expanded === "auto" ? e.interactive : t.aria.expanded,
    content: t.aria.content === "auto" ? e.interactive ? null : "describedby" : t.aria.content
  }, t;
}
function W3(n, e) {
  n === void 0 && (n = {}), e === void 0 && (e = []);
  var t = Object.keys(n);
  t.forEach(function(r) {
    var i = ZE(fn, Object.keys(H3)), s = !JE(i, r);
    s && (s = e.filter(function(o) {
      return o.name === r;
    }).length === 0), lr(s, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var vT = function() {
  return "innerHTML";
};
function Gd(n, e) {
  n[vT()] = e;
}
function Qf(n) {
  var e = io();
  return n === !0 ? e.className = I3 : (e.className = B3, Oo(n) ? e.appendChild(n) : Gd(e, n)), e;
}
function e2(n, e) {
  Oo(e.content) ? (Gd(n, ""), n.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? Gd(n, e.content) : n.textContent = e.content);
}
function Yd(n) {
  var e = n.firstElementChild, t = bl(e.children);
  return {
    box: e,
    content: t.find(function(r) {
      return r.classList.contains(P3);
    }),
    arrow: t.find(function(r) {
      return r.classList.contains(I3) || r.classList.contains(B3);
    }),
    backdrop: t.find(function(r) {
      return r.classList.contains(YE);
    })
  };
}
function q3(n) {
  var e = io(), t = io();
  t.className = GE, t.setAttribute("data-state", "hidden"), t.setAttribute("tabindex", "-1");
  var r = io();
  r.className = P3, r.setAttribute("data-state", "hidden"), e2(r, n.props), e.appendChild(t), t.appendChild(r), i(n.props, n.props);
  function i(s, o) {
    var a = Yd(e), l = a.box, u = a.content, d = a.arrow;
    o.theme ? l.setAttribute("data-theme", o.theme) : l.removeAttribute("data-theme"), typeof o.animation == "string" ? l.setAttribute("data-animation", o.animation) : l.removeAttribute("data-animation"), o.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof o.maxWidth == "number" ? o.maxWidth + "px" : o.maxWidth, o.role ? l.setAttribute("role", o.role) : l.removeAttribute("role"), (s.content !== o.content || s.allowHTML !== o.allowHTML) && e2(u, n.props), o.arrow ? d ? s.arrow !== o.arrow && (l.removeChild(d), l.appendChild(Qf(o.arrow))) : l.appendChild(Qf(o.arrow)) : d && l.removeChild(d);
  }
  return {
    popper: e,
    onUpdate: i
  };
}
q3.$$tippy = !0;
var _T = 1, oa = [], Vu = [];
function $T(n, e) {
  var t = Xf(n, Object.assign({}, fn, U3(Kf(e)))), r, i, s, o = !1, a = !1, l = !1, u = !1, d, c, f, p = [], h = Wf(Be, t.interactiveDebounce), y, g = _T++, m = null, $ = QE(t.plugins), w = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, _ = {
    // properties
    id: g,
    reference: n,
    popper: io(),
    popperInstance: m,
    props: t,
    state: w,
    plugins: $,
    // methods
    clearDelayTimeouts: br,
    setProps: er,
    setContent: yr,
    show: bn,
    hide: on,
    hideWithInteractivity: vr,
    enable: zn,
    disable: Qn,
    unmount: Qr,
    destroy: _r
  };
  if (!t.render)
    return process.env.NODE_ENV !== "production" && Kd(!0, "render() function has not been supplied."), _;
  var L = t.render(_), S = L.popper, R = L.onUpdate;
  S.setAttribute("data-tippy-root", ""), S.id = "tippy-" + _.id, _.popper = S, n._tippy = _, S._tippy = _;
  var O = $.map(function(Q) {
    return Q.fn(_);
  }), I = n.hasAttribute("aria-expanded");
  return Pe(), ge(), Y(), oe("onCreate", [_]), t.showOnCreate && gn(), S.addEventListener("mouseenter", function() {
    _.props.interactive && _.state.isVisible && _.clearDelayTimeouts();
  }), S.addEventListener("mouseleave", function() {
    _.props.interactive && _.props.trigger.indexOf("mouseenter") >= 0 && U().addEventListener("mousemove", h);
  }), _;
  function x() {
    var Q = _.props.touch;
    return Array.isArray(Q) ? Q : [Q, 0];
  }
  function M() {
    return x()[0] === "hold";
  }
  function D() {
    var Q;
    return !!((Q = _.props.render) != null && Q.$$tippy);
  }
  function j() {
    return y || n;
  }
  function U() {
    var Q = j().parentNode;
    return Q ? sT(Q) : document;
  }
  function J() {
    return Yd(S);
  }
  function ne(Q) {
    return _.state.isMounted && !_.state.isVisible || Wn.isTouch || d && d.type === "focus" ? 0 : Iu(_.props.delay, Q ? 0 : 1, fn.delay);
  }
  function Y(Q) {
    Q === void 0 && (Q = !1), S.style.pointerEvents = _.props.interactive && !Q ? "" : "none", S.style.zIndex = "" + _.props.zIndex;
  }
  function oe(Q, pe, ye) {
    if (ye === void 0 && (ye = !0), O.forEach(function(De) {
      De[Q] && De[Q].apply(De, pe);
    }), ye) {
      var Ve;
      (Ve = _.props)[Q].apply(Ve, pe);
    }
  }
  function le() {
    var Q = _.props.aria;
    if (Q.content) {
      var pe = "aria-" + Q.content, ye = S.id, Ve = ji(_.props.triggerTarget || n);
      Ve.forEach(function(De) {
        var pt = De.getAttribute(pe);
        if (_.state.isVisible)
          De.setAttribute(pe, pt ? pt + " " + ye : ye);
        else {
          var Et = pt && pt.replace(ye, "").trim();
          Et ? De.setAttribute(pe, Et) : De.removeAttribute(pe);
        }
      });
    }
  }
  function ge() {
    if (!(I || !_.props.aria.expanded)) {
      var Q = ji(_.props.triggerTarget || n);
      Q.forEach(function(pe) {
        _.props.interactive ? pe.setAttribute("aria-expanded", _.state.isVisible && pe === j() ? "true" : "false") : pe.removeAttribute("aria-expanded");
      });
    }
  }
  function he() {
    U().removeEventListener("mousemove", h), oa = oa.filter(function(Q) {
      return Q !== h;
    });
  }
  function _e(Q) {
    if (!(Wn.isTouch && (l || Q.type === "mousedown"))) {
      var pe = Q.composedPath && Q.composedPath()[0] || Q.target;
      if (!(_.props.interactive && Yf(S, pe))) {
        if (ji(_.props.triggerTarget || n).some(function(ye) {
          return Yf(ye, pe);
        })) {
          if (Wn.isTouch || _.state.isVisible && _.props.trigger.indexOf("click") >= 0)
            return;
        } else
          oe("onClickOutside", [_, Q]);
        _.props.hideOnClick === !0 && (_.clearDelayTimeouts(), _.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), _.state.isMounted || be());
      }
    }
  }
  function ue() {
    l = !0;
  }
  function xe() {
    l = !1;
  }
  function Le() {
    var Q = U();
    Q.addEventListener("mousedown", _e, !0), Q.addEventListener("touchend", _e, ii), Q.addEventListener("touchstart", xe, ii), Q.addEventListener("touchmove", ue, ii);
  }
  function be() {
    var Q = U();
    Q.removeEventListener("mousedown", _e, !0), Q.removeEventListener("touchend", _e, ii), Q.removeEventListener("touchstart", xe, ii), Q.removeEventListener("touchmove", ue, ii);
  }
  function He(Q, pe) {
    rt(Q, function() {
      !_.state.isVisible && S.parentNode && S.parentNode.contains(S) && pe();
    });
  }
  function Re(Q, pe) {
    rt(Q, pe);
  }
  function rt(Q, pe) {
    var ye = J().box;
    function Ve(De) {
      De.target === ye && (zu(ye, "remove", Ve), pe());
    }
    if (Q === 0)
      return pe();
    zu(ye, "remove", c), zu(ye, "add", Ve), c = Ve;
  }
  function ze(Q, pe, ye) {
    ye === void 0 && (ye = !1);
    var Ve = ji(_.props.triggerTarget || n);
    Ve.forEach(function(De) {
      De.addEventListener(Q, pe, ye), p.push({
        node: De,
        eventType: Q,
        handler: pe,
        options: ye
      });
    });
  }
  function Pe() {
    M() && (ze("touchstart", we, {
      passive: !0
    }), ze("touchend", Fe, {
      passive: !0
    })), XE(_.props.trigger).forEach(function(Q) {
      if (Q !== "manual")
        switch (ze(Q, we), Q) {
          case "mouseenter":
            ze("mouseleave", Fe);
            break;
          case "focus":
            ze(cT ? "focusout" : "blur", Xe);
            break;
          case "focusin":
            ze("focusout", Xe);
            break;
        }
    });
  }
  function fe() {
    p.forEach(function(Q) {
      var pe = Q.node, ye = Q.eventType, Ve = Q.handler, De = Q.options;
      pe.removeEventListener(ye, Ve, De);
    }), p = [];
  }
  function we(Q) {
    var pe, ye = !1;
    if (!(!_.state.isEnabled || ot(Q) || a)) {
      var Ve = ((pe = d) == null ? void 0 : pe.type) === "focus";
      d = Q, y = Q.currentTarget, ge(), !_.state.isVisible && nT(Q) && oa.forEach(function(De) {
        return De(Q);
      }), Q.type === "click" && (_.props.trigger.indexOf("mouseenter") < 0 || o) && _.props.hideOnClick !== !1 && _.state.isVisible ? ye = !0 : gn(Q), Q.type === "click" && (o = !ye), ye && !Ve && sn(Q);
    }
  }
  function Be(Q) {
    var pe = Q.target, ye = j().contains(pe) || S.contains(pe);
    if (!(Q.type === "mousemove" && ye)) {
      var Ve = ut().concat(S).map(function(De) {
        var pt, Et = De._tippy, Zt = (pt = Et.popperInstance) == null ? void 0 : pt.state;
        return Zt ? {
          popperRect: De.getBoundingClientRect(),
          popperState: Zt,
          props: t
        } : null;
      }).filter(Boolean);
      oT(Ve, Q) && (he(), sn(Q));
    }
  }
  function Fe(Q) {
    var pe = ot(Q) || _.props.trigger.indexOf("click") >= 0 && o;
    if (!pe) {
      if (_.props.interactive) {
        _.hideWithInteractivity(Q);
        return;
      }
      sn(Q);
    }
  }
  function Xe(Q) {
    _.props.trigger.indexOf("focusin") < 0 && Q.target !== j() || _.props.interactive && Q.relatedTarget && S.contains(Q.relatedTarget) || sn(Q);
  }
  function ot(Q) {
    return Wn.isTouch ? M() !== Q.type.indexOf("touch") >= 0 : !1;
  }
  function ct() {
    ft();
    var Q = _.props, pe = Q.popperOptions, ye = Q.placement, Ve = Q.offset, De = Q.getReferenceClientRect, pt = Q.moveTransition, Et = D() ? Yd(S).arrow : null, Zt = De ? {
      getBoundingClientRect: De,
      contextElement: De.contextElement || j()
    } : n, $r = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(xr) {
        var Ft = xr.state;
        if (D()) {
          var ks = J(), Ni = ks.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(ei) {
            ei === "placement" ? Ni.setAttribute("data-placement", Ft.placement) : Ft.attributes.popper["data-popper-" + ei] ? Ni.setAttribute("data-" + ei, "") : Ni.removeAttribute("data-" + ei);
          }), Ft.attributes.popper = {};
        }
      }
    }, Lt = [{
      name: "offset",
      options: {
        offset: Ve
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !pt
      }
    }, $r];
    D() && Et && Lt.push({
      name: "arrow",
      options: {
        element: Et,
        padding: 3
      }
    }), Lt.push.apply(Lt, (pe == null ? void 0 : pe.modifiers) || []), _.popperInstance = KE(Zt, S, Object.assign({}, pe, {
      placement: ye,
      onFirstUpdate: f,
      modifiers: Lt
    }));
  }
  function ft() {
    _.popperInstance && (_.popperInstance.destroy(), _.popperInstance = null);
  }
  function lt() {
    var Q = _.props.appendTo, pe, ye = j();
    _.props.interactive && Q === z3 || Q === "parent" ? pe = ye.parentNode : pe = V3(Q, [ye]), pe.contains(S) || pe.appendChild(S), _.state.isMounted = !0, ct(), process.env.NODE_ENV !== "production" && lr(_.props.interactive && Q === fn.appendTo && ye.nextElementSibling !== S, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function ut() {
    return bl(S.querySelectorAll("[data-tippy-root]"));
  }
  function gn(Q) {
    _.clearDelayTimeouts(), Q && oe("onTrigger", [_, Q]), Le();
    var pe = ne(!0), ye = x(), Ve = ye[0], De = ye[1];
    Wn.isTouch && Ve === "hold" && De && (pe = De), pe ? r = setTimeout(function() {
      _.show();
    }, pe) : _.show();
  }
  function sn(Q) {
    if (_.clearDelayTimeouts(), oe("onUntrigger", [_, Q]), !_.state.isVisible) {
      be();
      return;
    }
    if (!(_.props.trigger.indexOf("mouseenter") >= 0 && _.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(Q.type) >= 0 && o)) {
      var pe = ne(!1);
      pe ? i = setTimeout(function() {
        _.state.isVisible && _.hide();
      }, pe) : s = requestAnimationFrame(function() {
        _.hide();
      });
    }
  }
  function zn() {
    _.state.isEnabled = !0;
  }
  function Qn() {
    _.hide(), _.state.isEnabled = !1;
  }
  function br() {
    clearTimeout(r), clearTimeout(i), cancelAnimationFrame(s);
  }
  function er(Q) {
    if (process.env.NODE_ENV !== "production" && lr(_.state.isDestroyed, Pi("setProps")), !_.state.isDestroyed) {
      oe("onBeforeUpdate", [_, Q]), fe();
      var pe = _.props, ye = Xf(n, Object.assign({}, pe, Kf(Q), {
        ignoreAttributes: !0
      }));
      _.props = ye, Pe(), pe.interactiveDebounce !== ye.interactiveDebounce && (he(), h = Wf(Be, ye.interactiveDebounce)), pe.triggerTarget && !ye.triggerTarget ? ji(pe.triggerTarget).forEach(function(Ve) {
        Ve.removeAttribute("aria-expanded");
      }) : ye.triggerTarget && n.removeAttribute("aria-expanded"), ge(), Y(), R && R(pe, ye), _.popperInstance && (ct(), ut().forEach(function(Ve) {
        requestAnimationFrame(Ve._tippy.popperInstance.forceUpdate);
      })), oe("onAfterUpdate", [_, Q]);
    }
  }
  function yr(Q) {
    _.setProps({
      content: Q
    });
  }
  function bn() {
    process.env.NODE_ENV !== "production" && lr(_.state.isDestroyed, Pi("show"));
    var Q = _.state.isVisible, pe = _.state.isDestroyed, ye = !_.state.isEnabled, Ve = Wn.isTouch && !_.props.touch, De = Iu(_.props.duration, 0, fn.duration);
    if (!(Q || pe || ye || Ve) && !j().hasAttribute("disabled") && (oe("onShow", [_], !1), _.props.onShow(_) !== !1)) {
      if (_.state.isVisible = !0, D() && (S.style.visibility = "visible"), Y(), Le(), _.state.isMounted || (S.style.transition = "none"), D()) {
        var pt = J(), Et = pt.box, Zt = pt.content;
        Bu([Et, Zt], 0);
      }
      f = function() {
        var Lt;
        if (!(!_.state.isVisible || u)) {
          if (u = !0, S.offsetHeight, S.style.transition = _.props.moveTransition, D() && _.props.animation) {
            var an = J(), xr = an.box, Ft = an.content;
            Bu([xr, Ft], De), Gf([xr, Ft], "visible");
          }
          le(), ge(), qf(Vu, _), (Lt = _.popperInstance) == null || Lt.forceUpdate(), oe("onMount", [_]), _.props.animation && D() && Re(De, function() {
            _.state.isShown = !0, oe("onShown", [_]);
          });
        }
      }, lt();
    }
  }
  function on() {
    process.env.NODE_ENV !== "production" && lr(_.state.isDestroyed, Pi("hide"));
    var Q = !_.state.isVisible, pe = _.state.isDestroyed, ye = !_.state.isEnabled, Ve = Iu(_.props.duration, 1, fn.duration);
    if (!(Q || pe || ye) && (oe("onHide", [_], !1), _.props.onHide(_) !== !1)) {
      if (_.state.isVisible = !1, _.state.isShown = !1, u = !1, o = !1, D() && (S.style.visibility = "hidden"), he(), be(), Y(!0), D()) {
        var De = J(), pt = De.box, Et = De.content;
        _.props.animation && (Bu([pt, Et], Ve), Gf([pt, Et], "hidden"));
      }
      le(), ge(), _.props.animation ? D() && He(Ve, _.unmount) : _.unmount();
    }
  }
  function vr(Q) {
    process.env.NODE_ENV !== "production" && lr(_.state.isDestroyed, Pi("hideWithInteractivity")), U().addEventListener("mousemove", h), qf(oa, h), h(Q);
  }
  function Qr() {
    process.env.NODE_ENV !== "production" && lr(_.state.isDestroyed, Pi("unmount")), _.state.isVisible && _.hide(), _.state.isMounted && (ft(), ut().forEach(function(Q) {
      Q._tippy.unmount();
    }), S.parentNode && S.parentNode.removeChild(S), Vu = Vu.filter(function(Q) {
      return Q !== _;
    }), _.state.isMounted = !1, oe("onHidden", [_]));
  }
  function _r() {
    process.env.NODE_ENV !== "production" && lr(_.state.isDestroyed, Pi("destroy")), !_.state.isDestroyed && (_.clearDelayTimeouts(), _.unmount(), fe(), delete n._tippy, _.state.isDestroyed = !0, oe("onDestroy", [_]));
  }
}
function ws(n, e) {
  e === void 0 && (e = {});
  var t = fn.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (hT(n), W3(e, t)), uT();
  var r = Object.assign({}, e, {
    plugins: t
  }), i = iT(n);
  if (process.env.NODE_ENV !== "production") {
    var s = Oo(r.content), o = i.length > 1;
    lr(s && o, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var a = i.reduce(function(l, u) {
    var d = u && $T(u, r);
    return d && l.push(d), l;
  }, []);
  return Oo(n) ? a[0] : a;
}
ws.defaultProps = fn;
ws.setDefaultProps = bT;
ws.currentInput = Wn;
Object.assign({}, T3, {
  effect: function(e) {
    var t = e.state, r = {
      popper: {
        position: t.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow);
  }
});
ws.setDefaultProps({
  render: q3
});
class xT {
  constructor({ editor: e, element: t, view: r, tippyOptions: i = {}, updateDelay: s = 250, shouldShow: o }) {
    this.preventHide = !1, this.shouldShow = ({ view: a, state: l, from: u, to: d }) => {
      const { doc: c, selection: f } = l, { empty: p } = f, h = !c.textBetween(u, d).length && H1(l.selection), y = this.element.contains(document.activeElement);
      return !(!(a.hasFocus() || y) || p || h || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: a }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      a != null && a.relatedTarget && (!((l = this.element.parentNode) === null || l === void 0) && l.contains(a.relatedTarget)) || (a == null ? void 0 : a.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (a) => {
      this.blurHandler({ event: a });
    }, this.handleDebouncedUpdate = (a, l) => {
      const u = !(l != null && l.selection.eq(a.state.selection)), d = !(l != null && l.doc.eq(a.state.doc));
      !u && !d || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(a, u, d, l);
      }, this.updateDelay));
    }, this.updateHandler = (a, l, u, d) => {
      var c, f, p;
      const { state: h, composing: y } = a, { selection: g } = h;
      if (y || !l && !u)
        return;
      this.createTooltip();
      const { ranges: $ } = g, w = Math.min(...$.map((S) => S.$from.pos)), _ = Math.max(...$.map((S) => S.$to.pos));
      if (!((c = this.shouldShow) === null || c === void 0 ? void 0 : c.call(this, {
        editor: this.editor,
        element: this.element,
        view: a,
        state: h,
        oldState: d,
        from: w,
        to: _
      }))) {
        this.hide();
        return;
      }
      (f = this.tippy) === null || f === void 0 || f.setProps({
        getReferenceClientRect: ((p = this.tippyOptions) === null || p === void 0 ? void 0 : p.getReferenceClientRect) || (() => {
          if (c3(h.selection)) {
            let S = a.nodeDOM(w);
            if (S) {
              const R = S.dataset.nodeViewWrapper ? S : S.querySelector("[data-node-view-wrapper]");
              if (R && (S = R.firstChild), S)
                return S.getBoundingClientRect();
            }
          }
          return f3(a, w, _);
        })
      }), this.show();
    }, this.editor = e, this.element = t, this.view = r, this.updateDelay = s, o && (this.shouldShow = o), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = i, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, t = !!e.parentElement;
    this.tippy || !t || (this.tippy = ws(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, t) {
    const { state: r } = e, i = r.selection.from !== r.selection.to;
    if (this.updateDelay > 0 && i) {
      this.handleDebouncedUpdate(e, t);
      return;
    }
    const s = !(t != null && t.selection.eq(e.state.selection)), o = !(t != null && t.doc.eq(e.state.doc));
    this.updateHandler(e, s, o, t);
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, t;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (t = this.tippy) === null || t === void 0 || t.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const K3 = (n) => new bt({
  key: typeof n.pluginKey == "string" ? new Jt(n.pluginKey) : n.pluginKey,
  view: (e) => new xT({ view: e, ...n })
});
St.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      K3({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
class wT {
  getTextContent(e) {
    return u3(e, { textSerializers: F1(this.editor.schema) });
  }
  constructor({ editor: e, element: t, view: r, tippyOptions: i = {}, shouldShow: s }) {
    this.preventHide = !1, this.shouldShow = ({ view: o, state: a }) => {
      const { selection: l } = a, { $anchor: u, empty: d } = l, c = u.depth === 1, f = u.parent.isTextblock && !u.parent.type.spec.code && !u.parent.textContent && u.parent.childCount === 0 && !this.getTextContent(u.parent);
      return !(!o.hasFocus() || !d || !c || !f || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: o }) => {
      var a;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      o != null && o.relatedTarget && (!((a = this.element.parentNode) === null || a === void 0) && a.contains(o.relatedTarget)) || (o == null ? void 0 : o.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (o) => {
      this.blurHandler({ event: o });
    }, this.editor = e, this.element = t, this.view = r, s && (this.shouldShow = s), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = i, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, t = !!e.parentElement;
    this.tippy || !t || (this.tippy = ws(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "right",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, t) {
    var r, i, s;
    const { state: o } = e, { doc: a, selection: l } = o, { from: u, to: d } = l;
    if (t && t.doc.eq(a) && t.selection.eq(l))
      return;
    if (this.createTooltip(), !((r = this.shouldShow) === null || r === void 0 ? void 0 : r.call(this, {
      editor: this.editor,
      view: e,
      state: o,
      oldState: t
    }))) {
      this.hide();
      return;
    }
    (i = this.tippy) === null || i === void 0 || i.setProps({
      getReferenceClientRect: ((s = this.tippyOptions) === null || s === void 0 ? void 0 : s.getReferenceClientRect) || (() => f3(e, u, d))
    }), this.show();
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, t;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (t = this.tippy) === null || t === void 0 || t.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const G3 = (n) => new bt({
  key: typeof n.pluginKey == "string" ? new Jt(n.pluginKey) : n.pluginKey,
  view: (e) => new wT({ view: e, ...n })
});
St.create({
  name: "floatingMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "floatingMenu",
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      G3({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
X({
  name: "BubbleMenu",
  props: {
    pluginKey: {
      type: [String, Object],
      default: "bubbleMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number,
      default: void 0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(n, { slots: e }) {
    const t = ae(null);
    return Dt(() => {
      const { updateDelay: r, editor: i, pluginKey: s, shouldShow: o, tippyOptions: a } = n;
      i.registerPlugin(K3({
        updateDelay: r,
        editor: i,
        element: t.value,
        pluginKey: s,
        shouldShow: o,
        tippyOptions: a
      }));
    }), Mi(() => {
      const { pluginKey: r, editor: i } = n;
      i.unregisterPlugin(r);
    }), () => {
      var r;
      return Ao("div", { ref: t }, (r = e.default) === null || r === void 0 ? void 0 : r.call(e));
    };
  }
});
function t2(n) {
  return O4((e, t) => ({
    get() {
      return e(), n;
    },
    set(r) {
      n = r, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t();
        });
      });
    }
  }));
}
class kT extends mC {
  constructor(e = {}) {
    return super(e), this.contentComponent = null, this.appContext = null, this.reactiveState = t2(this.view.state), this.reactiveExtensionStorage = t2(this.extensionStorage), this.on("beforeTransaction", ({ nextState: t }) => {
      this.reactiveState.value = t, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), T4(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(e, t) {
    const r = super.registerPlugin(e, t);
    return this.reactiveState && (this.reactiveState.value = r), r;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(e) {
    const t = super.unregisterPlugin(e);
    return this.reactiveState && t && (this.reactiveState.value = t), t;
  }
}
const CT = X({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(n) {
    const e = ae(), t = E4();
    return t1(() => {
      const r = n.editor;
      r && r.options.element && e.value && Vr(() => {
        if (!e.value || !r.options.element.firstChild)
          return;
        const i = v(e.value);
        e.value.append(...r.options.element.childNodes), r.contentComponent = t.ctx._, t && (r.appContext = {
          ...t.appContext,
          // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
          // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
          // @ts-expect-error forward instance's 'provides' into appContext
          provides: t.provides
        }), r.setOptions({
          element: i
        }), r.createNodeViews();
      });
    }), Mi(() => {
      const r = n.editor;
      r && (r.contentComponent = null, r.appContext = null);
    }), { rootEl: e };
  },
  render() {
    return Ao("div", {
      ref: (n) => {
        this.rootEl = n;
      }
    });
  }
});
X({
  name: "FloatingMenu",
  props: {
    pluginKey: {
      // TODO: TypeScript breaks :(
      // type: [String, Object as PropType<Exclude<FloatingMenuPluginProps['pluginKey'], string>>],
      type: null,
      default: "floatingMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(n, { slots: e }) {
    const t = ae(null);
    return Dt(() => {
      const { pluginKey: r, editor: i, tippyOptions: s, shouldShow: o } = n;
      i.registerPlugin(G3({
        pluginKey: r,
        editor: i,
        element: t.value,
        tippyOptions: s,
        shouldShow: o
      }));
    }), Mi(() => {
      const { pluginKey: r, editor: i } = n;
      i.unregisterPlugin(r);
    }), () => {
      var r;
      return Ao("div", { ref: t }, (r = e.default) === null || r === void 0 ? void 0 : r.call(e));
    };
  }
});
X({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return Ao(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
X({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var n, e;
    return Ao(this.as, {
      // @ts-ignore
      class: this.decorationClasses,
      style: {
        whiteSpace: "normal"
      },
      "data-node-view-wrapper": "",
      // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
      onDragstart: this.onDragStart
    }, (e = (n = this.$slots).default) === null || e === void 0 ? void 0 : e.call(n));
  }
});
const wa = [
  jS.configure({
    textStyle: !1,
    bulletList: {
      item: Ud
    },
    orderedList: {
      item: Ud
    }
  }),
  jC,
  HC,
  zC.configure({
    openOnClick: !1,
    autolink: !0,
    defaultProtocol: "https"
  }),
  VC.configure({
    types: ["heading", "paragraph"]
  })
];
function ST(n = ae()) {
  const e = ae({
    type: "doc",
    content: [
      {
        type: "paragraph",
        attrs: {
          textAlign: null
        }
      }
    ]
  }), t = new kT({
    content: n.value ?? "",
    extensions: wa,
    editorProps: {
      attributes: {
        class: "format focus:outline-none max-w-none"
      }
    },
    onUpdate({ editor: r }) {
      n.value = r.getHTML(), e.value = r.getJSON();
    }
  });
  return Ie(n, (r) => {
    fr(r, t.getHTML()) || (t.commands.setContent(r ?? "", !1), e.value = t.getJSON());
  }), Ie(e, (r) => {
    if (fr(r, t.getJSON()) || JSON.stringify(r) === "{}")
      return;
    const i = Dk(r, wa);
    t.commands.setContent(i ?? "", !1), n.value = i;
  }), {
    editor: t,
    extensions: wa,
    jsonContent: e,
    modelValue: n
  };
}
var Y3 = { exports: {} }, Ds = {}, aa = { exports: {} }, Fu = {}, ju = {}, n2;
function f0() {
  if (n2) return ju;
  n2 = 1;
  function n(r) {
    this.__parent = r, this.__character_count = 0, this.__indent_count = -1, this.__alignment_count = 0, this.__wrap_point_index = 0, this.__wrap_point_character_count = 0, this.__wrap_point_indent_count = -1, this.__wrap_point_alignment_count = 0, this.__items = [];
  }
  n.prototype.clone_empty = function() {
    var r = new n(this.__parent);
    return r.set_indent(this.__indent_count, this.__alignment_count), r;
  }, n.prototype.item = function(r) {
    return r < 0 ? this.__items[this.__items.length + r] : this.__items[r];
  }, n.prototype.has_match = function(r) {
    for (var i = this.__items.length - 1; i >= 0; i--)
      if (this.__items[i].match(r))
        return !0;
    return !1;
  }, n.prototype.set_indent = function(r, i) {
    this.is_empty() && (this.__indent_count = r || 0, this.__alignment_count = i || 0, this.__character_count = this.__parent.get_indent_size(this.__indent_count, this.__alignment_count));
  }, n.prototype._set_wrap_point = function() {
    this.__parent.wrap_line_length && (this.__wrap_point_index = this.__items.length, this.__wrap_point_character_count = this.__character_count, this.__wrap_point_indent_count = this.__parent.next_line.__indent_count, this.__wrap_point_alignment_count = this.__parent.next_line.__alignment_count);
  }, n.prototype._should_wrap = function() {
    return this.__wrap_point_index && this.__character_count > this.__parent.wrap_line_length && this.__wrap_point_character_count > this.__parent.next_line.__character_count;
  }, n.prototype._allow_wrap = function() {
    if (this._should_wrap()) {
      this.__parent.add_new_line();
      var r = this.__parent.current_line;
      return r.set_indent(this.__wrap_point_indent_count, this.__wrap_point_alignment_count), r.__items = this.__items.slice(this.__wrap_point_index), this.__items = this.__items.slice(0, this.__wrap_point_index), r.__character_count += this.__character_count - this.__wrap_point_character_count, this.__character_count = this.__wrap_point_character_count, r.__items[0] === " " && (r.__items.splice(0, 1), r.__character_count -= 1), !0;
    }
    return !1;
  }, n.prototype.is_empty = function() {
    return this.__items.length === 0;
  }, n.prototype.last = function() {
    return this.is_empty() ? null : this.__items[this.__items.length - 1];
  }, n.prototype.push = function(r) {
    this.__items.push(r);
    var i = r.lastIndexOf(`
`);
    i !== -1 ? this.__character_count = r.length - i : this.__character_count += r.length;
  }, n.prototype.pop = function() {
    var r = null;
    return this.is_empty() || (r = this.__items.pop(), this.__character_count -= r.length), r;
  }, n.prototype._remove_indent = function() {
    this.__indent_count > 0 && (this.__indent_count -= 1, this.__character_count -= this.__parent.indent_size);
  }, n.prototype._remove_wrap_indent = function() {
    this.__wrap_point_indent_count > 0 && (this.__wrap_point_indent_count -= 1);
  }, n.prototype.trim = function() {
    for (; this.last() === " "; )
      this.__items.pop(), this.__character_count -= 1;
  }, n.prototype.toString = function() {
    var r = "";
    return this.is_empty() ? this.__parent.indent_empty_lines && (r = this.__parent.get_indent_string(this.__indent_count)) : (r = this.__parent.get_indent_string(this.__indent_count, this.__alignment_count), r += this.__items.join("")), r;
  };
  function e(r, i) {
    this.__cache = [""], this.__indent_size = r.indent_size, this.__indent_string = r.indent_char, r.indent_with_tabs || (this.__indent_string = new Array(r.indent_size + 1).join(r.indent_char)), i = i || "", r.indent_level > 0 && (i = new Array(r.indent_level + 1).join(this.__indent_string)), this.__base_string = i, this.__base_string_length = i.length;
  }
  e.prototype.get_indent_size = function(r, i) {
    var s = this.__base_string_length;
    return i = i || 0, r < 0 && (s = 0), s += r * this.__indent_size, s += i, s;
  }, e.prototype.get_indent_string = function(r, i) {
    var s = this.__base_string;
    return i = i || 0, r < 0 && (r = 0, s = ""), i += r * this.__indent_size, this.__ensure_cache(i), s += this.__cache[i], s;
  }, e.prototype.__ensure_cache = function(r) {
    for (; r >= this.__cache.length; )
      this.__add_column();
  }, e.prototype.__add_column = function() {
    var r = this.__cache.length, i = 0, s = "";
    this.__indent_size && r >= this.__indent_size && (i = Math.floor(r / this.__indent_size), r -= i * this.__indent_size, s = new Array(i + 1).join(this.__indent_string)), r && (s += new Array(r + 1).join(" ")), this.__cache.push(s);
  };
  function t(r, i) {
    this.__indent_cache = new e(r, i), this.raw = !1, this._end_with_newline = r.end_with_newline, this.indent_size = r.indent_size, this.wrap_line_length = r.wrap_line_length, this.indent_empty_lines = r.indent_empty_lines, this.__lines = [], this.previous_line = null, this.current_line = null, this.next_line = new n(this), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = !1, this.__add_outputline();
  }
  return t.prototype.__add_outputline = function() {
    this.previous_line = this.current_line, this.current_line = this.next_line.clone_empty(), this.__lines.push(this.current_line);
  }, t.prototype.get_line_number = function() {
    return this.__lines.length;
  }, t.prototype.get_indent_string = function(r, i) {
    return this.__indent_cache.get_indent_string(r, i);
  }, t.prototype.get_indent_size = function(r, i) {
    return this.__indent_cache.get_indent_size(r, i);
  }, t.prototype.is_empty = function() {
    return !this.previous_line && this.current_line.is_empty();
  }, t.prototype.add_new_line = function(r) {
    return this.is_empty() || !r && this.just_added_newline() ? !1 : (this.raw || this.__add_outputline(), !0);
  }, t.prototype.get_code = function(r) {
    this.trim(!0);
    var i = this.current_line.pop();
    i && (i[i.length - 1] === `
` && (i = i.replace(/\n+$/g, "")), this.current_line.push(i)), this._end_with_newline && this.__add_outputline();
    var s = this.__lines.join(`
`);
    return r !== `
` && (s = s.replace(/[\n]/g, r)), s;
  }, t.prototype.set_wrap_point = function() {
    this.current_line._set_wrap_point();
  }, t.prototype.set_indent = function(r, i) {
    return r = r || 0, i = i || 0, this.next_line.set_indent(r, i), this.__lines.length > 1 ? (this.current_line.set_indent(r, i), !0) : (this.current_line.set_indent(), !1);
  }, t.prototype.add_raw_token = function(r) {
    for (var i = 0; i < r.newlines; i++)
      this.__add_outputline();
    this.current_line.set_indent(-1), this.current_line.push(r.whitespace_before), this.current_line.push(r.text), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = !1;
  }, t.prototype.add_token = function(r) {
    this.__add_space_before_token(), this.current_line.push(r), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = this.current_line._allow_wrap();
  }, t.prototype.__add_space_before_token = function() {
    this.space_before_token && !this.just_added_newline() && (this.non_breaking_space || this.set_wrap_point(), this.current_line.push(" "));
  }, t.prototype.remove_indent = function(r) {
    for (var i = this.__lines.length; r < i; )
      this.__lines[r]._remove_indent(), r++;
    this.current_line._remove_wrap_indent();
  }, t.prototype.trim = function(r) {
    for (r = r === void 0 ? !1 : r, this.current_line.trim(); r && this.__lines.length > 1 && this.current_line.is_empty(); )
      this.__lines.pop(), this.current_line = this.__lines[this.__lines.length - 1], this.current_line.trim();
    this.previous_line = this.__lines.length > 1 ? this.__lines[this.__lines.length - 2] : null;
  }, t.prototype.just_added_newline = function() {
    return this.current_line.is_empty();
  }, t.prototype.just_added_blankline = function() {
    return this.is_empty() || this.current_line.is_empty() && this.previous_line.is_empty();
  }, t.prototype.ensure_empty_line_above = function(r, i) {
    for (var s = this.__lines.length - 2; s >= 0; ) {
      var o = this.__lines[s];
      if (o.is_empty())
        break;
      if (o.item(0).indexOf(r) !== 0 && o.item(-1) !== i) {
        this.__lines.splice(s + 1, 0, new n(this)), this.previous_line = this.__lines[this.__lines.length - 2];
        break;
      }
      s--;
    }
  }, ju.Output = t, ju;
}
var Hu = {}, r2;
function J3() {
  if (r2) return Hu;
  r2 = 1;
  function n(e, t, r, i) {
    this.type = e, this.text = t, this.comments_before = null, this.newlines = r || 0, this.whitespace_before = i || "", this.parent = null, this.next = null, this.previous = null, this.opened = null, this.closed = null, this.directives = null;
  }
  return Hu.Token = n, Hu;
}
var Uu = {}, i2;
function Z3() {
  return i2 || (i2 = 1, function(n) {
    var e = "\\x23\\x24\\x40\\x41-\\x5a\\x5f\\x61-\\x7a", t = "\\x24\\x30-\\x39\\x41-\\x5a\\x5f\\x61-\\x7a", r = "\\xaa\\xb5\\xba\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u02c1\\u02c6-\\u02d1\\u02e0-\\u02e4\\u02ec\\u02ee\\u0370-\\u0374\\u0376\\u0377\\u037a-\\u037d\\u0386\\u0388-\\u038a\\u038c\\u038e-\\u03a1\\u03a3-\\u03f5\\u03f7-\\u0481\\u048a-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05d0-\\u05ea\\u05f0-\\u05f2\\u0620-\\u064a\\u066e\\u066f\\u0671-\\u06d3\\u06d5\\u06e5\\u06e6\\u06ee\\u06ef\\u06fa-\\u06fc\\u06ff\\u0710\\u0712-\\u072f\\u074d-\\u07a5\\u07b1\\u07ca-\\u07ea\\u07f4\\u07f5\\u07fa\\u0800-\\u0815\\u081a\\u0824\\u0828\\u0840-\\u0858\\u08a0\\u08a2-\\u08ac\\u0904-\\u0939\\u093d\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097f\\u0985-\\u098c\\u098f\\u0990\\u0993-\\u09a8\\u09aa-\\u09b0\\u09b2\\u09b6-\\u09b9\\u09bd\\u09ce\\u09dc\\u09dd\\u09df-\\u09e1\\u09f0\\u09f1\\u0a05-\\u0a0a\\u0a0f\\u0a10\\u0a13-\\u0a28\\u0a2a-\\u0a30\\u0a32\\u0a33\\u0a35\\u0a36\\u0a38\\u0a39\\u0a59-\\u0a5c\\u0a5e\\u0a72-\\u0a74\\u0a85-\\u0a8d\\u0a8f-\\u0a91\\u0a93-\\u0aa8\\u0aaa-\\u0ab0\\u0ab2\\u0ab3\\u0ab5-\\u0ab9\\u0abd\\u0ad0\\u0ae0\\u0ae1\\u0b05-\\u0b0c\\u0b0f\\u0b10\\u0b13-\\u0b28\\u0b2a-\\u0b30\\u0b32\\u0b33\\u0b35-\\u0b39\\u0b3d\\u0b5c\\u0b5d\\u0b5f-\\u0b61\\u0b71\\u0b83\\u0b85-\\u0b8a\\u0b8e-\\u0b90\\u0b92-\\u0b95\\u0b99\\u0b9a\\u0b9c\\u0b9e\\u0b9f\\u0ba3\\u0ba4\\u0ba8-\\u0baa\\u0bae-\\u0bb9\\u0bd0\\u0c05-\\u0c0c\\u0c0e-\\u0c10\\u0c12-\\u0c28\\u0c2a-\\u0c33\\u0c35-\\u0c39\\u0c3d\\u0c58\\u0c59\\u0c60\\u0c61\\u0c85-\\u0c8c\\u0c8e-\\u0c90\\u0c92-\\u0ca8\\u0caa-\\u0cb3\\u0cb5-\\u0cb9\\u0cbd\\u0cde\\u0ce0\\u0ce1\\u0cf1\\u0cf2\\u0d05-\\u0d0c\\u0d0e-\\u0d10\\u0d12-\\u0d3a\\u0d3d\\u0d4e\\u0d60\\u0d61\\u0d7a-\\u0d7f\\u0d85-\\u0d96\\u0d9a-\\u0db1\\u0db3-\\u0dbb\\u0dbd\\u0dc0-\\u0dc6\\u0e01-\\u0e30\\u0e32\\u0e33\\u0e40-\\u0e46\\u0e81\\u0e82\\u0e84\\u0e87\\u0e88\\u0e8a\\u0e8d\\u0e94-\\u0e97\\u0e99-\\u0e9f\\u0ea1-\\u0ea3\\u0ea5\\u0ea7\\u0eaa\\u0eab\\u0ead-\\u0eb0\\u0eb2\\u0eb3\\u0ebd\\u0ec0-\\u0ec4\\u0ec6\\u0edc-\\u0edf\\u0f00\\u0f40-\\u0f47\\u0f49-\\u0f6c\\u0f88-\\u0f8c\\u1000-\\u102a\\u103f\\u1050-\\u1055\\u105a-\\u105d\\u1061\\u1065\\u1066\\u106e-\\u1070\\u1075-\\u1081\\u108e\\u10a0-\\u10c5\\u10c7\\u10cd\\u10d0-\\u10fa\\u10fc-\\u1248\\u124a-\\u124d\\u1250-\\u1256\\u1258\\u125a-\\u125d\\u1260-\\u1288\\u128a-\\u128d\\u1290-\\u12b0\\u12b2-\\u12b5\\u12b8-\\u12be\\u12c0\\u12c2-\\u12c5\\u12c8-\\u12d6\\u12d8-\\u1310\\u1312-\\u1315\\u1318-\\u135a\\u1380-\\u138f\\u13a0-\\u13f4\\u1401-\\u166c\\u166f-\\u167f\\u1681-\\u169a\\u16a0-\\u16ea\\u16ee-\\u16f0\\u1700-\\u170c\\u170e-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176c\\u176e-\\u1770\\u1780-\\u17b3\\u17d7\\u17dc\\u1820-\\u1877\\u1880-\\u18a8\\u18aa\\u18b0-\\u18f5\\u1900-\\u191c\\u1950-\\u196d\\u1970-\\u1974\\u1980-\\u19ab\\u19c1-\\u19c7\\u1a00-\\u1a16\\u1a20-\\u1a54\\u1aa7\\u1b05-\\u1b33\\u1b45-\\u1b4b\\u1b83-\\u1ba0\\u1bae\\u1baf\\u1bba-\\u1be5\\u1c00-\\u1c23\\u1c4d-\\u1c4f\\u1c5a-\\u1c7d\\u1ce9-\\u1cec\\u1cee-\\u1cf1\\u1cf5\\u1cf6\\u1d00-\\u1dbf\\u1e00-\\u1f15\\u1f18-\\u1f1d\\u1f20-\\u1f45\\u1f48-\\u1f4d\\u1f50-\\u1f57\\u1f59\\u1f5b\\u1f5d\\u1f5f-\\u1f7d\\u1f80-\\u1fb4\\u1fb6-\\u1fbc\\u1fbe\\u1fc2-\\u1fc4\\u1fc6-\\u1fcc\\u1fd0-\\u1fd3\\u1fd6-\\u1fdb\\u1fe0-\\u1fec\\u1ff2-\\u1ff4\\u1ff6-\\u1ffc\\u2071\\u207f\\u2090-\\u209c\\u2102\\u2107\\u210a-\\u2113\\u2115\\u2119-\\u211d\\u2124\\u2126\\u2128\\u212a-\\u212d\\u212f-\\u2139\\u213c-\\u213f\\u2145-\\u2149\\u214e\\u2160-\\u2188\\u2c00-\\u2c2e\\u2c30-\\u2c5e\\u2c60-\\u2ce4\\u2ceb-\\u2cee\\u2cf2\\u2cf3\\u2d00-\\u2d25\\u2d27\\u2d2d\\u2d30-\\u2d67\\u2d6f\\u2d80-\\u2d96\\u2da0-\\u2da6\\u2da8-\\u2dae\\u2db0-\\u2db6\\u2db8-\\u2dbe\\u2dc0-\\u2dc6\\u2dc8-\\u2dce\\u2dd0-\\u2dd6\\u2dd8-\\u2dde\\u2e2f\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303c\\u3041-\\u3096\\u309d-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312d\\u3131-\\u318e\\u31a0-\\u31ba\\u31f0-\\u31ff\\u3400-\\u4db5\\u4e00-\\u9fcc\\ua000-\\ua48c\\ua4d0-\\ua4fd\\ua500-\\ua60c\\ua610-\\ua61f\\ua62a\\ua62b\\ua640-\\ua66e\\ua67f-\\ua697\\ua6a0-\\ua6ef\\ua717-\\ua71f\\ua722-\\ua788\\ua78b-\\ua78e\\ua790-\\ua793\\ua7a0-\\ua7aa\\ua7f8-\\ua801\\ua803-\\ua805\\ua807-\\ua80a\\ua80c-\\ua822\\ua840-\\ua873\\ua882-\\ua8b3\\ua8f2-\\ua8f7\\ua8fb\\ua90a-\\ua925\\ua930-\\ua946\\ua960-\\ua97c\\ua984-\\ua9b2\\ua9cf\\uaa00-\\uaa28\\uaa40-\\uaa42\\uaa44-\\uaa4b\\uaa60-\\uaa76\\uaa7a\\uaa80-\\uaaaf\\uaab1\\uaab5\\uaab6\\uaab9-\\uaabd\\uaac0\\uaac2\\uaadb-\\uaadd\\uaae0-\\uaaea\\uaaf2-\\uaaf4\\uab01-\\uab06\\uab09-\\uab0e\\uab11-\\uab16\\uab20-\\uab26\\uab28-\\uab2e\\uabc0-\\uabe2\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufb00-\\ufb06\\ufb13-\\ufb17\\ufb1d\\ufb1f-\\ufb28\\ufb2a-\\ufb36\\ufb38-\\ufb3c\\ufb3e\\ufb40\\ufb41\\ufb43\\ufb44\\ufb46-\\ufbb1\\ufbd3-\\ufd3d\\ufd50-\\ufd8f\\ufd92-\\ufdc7\\ufdf0-\\ufdfb\\ufe70-\\ufe74\\ufe76-\\ufefc\\uff21-\\uff3a\\uff41-\\uff5a\\uff66-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc", i = "\\u0300-\\u036f\\u0483-\\u0487\\u0591-\\u05bd\\u05bf\\u05c1\\u05c2\\u05c4\\u05c5\\u05c7\\u0610-\\u061a\\u0620-\\u0649\\u0672-\\u06d3\\u06e7-\\u06e8\\u06fb-\\u06fc\\u0730-\\u074a\\u0800-\\u0814\\u081b-\\u0823\\u0825-\\u0827\\u0829-\\u082d\\u0840-\\u0857\\u08e4-\\u08fe\\u0900-\\u0903\\u093a-\\u093c\\u093e-\\u094f\\u0951-\\u0957\\u0962-\\u0963\\u0966-\\u096f\\u0981-\\u0983\\u09bc\\u09be-\\u09c4\\u09c7\\u09c8\\u09d7\\u09df-\\u09e0\\u0a01-\\u0a03\\u0a3c\\u0a3e-\\u0a42\\u0a47\\u0a48\\u0a4b-\\u0a4d\\u0a51\\u0a66-\\u0a71\\u0a75\\u0a81-\\u0a83\\u0abc\\u0abe-\\u0ac5\\u0ac7-\\u0ac9\\u0acb-\\u0acd\\u0ae2-\\u0ae3\\u0ae6-\\u0aef\\u0b01-\\u0b03\\u0b3c\\u0b3e-\\u0b44\\u0b47\\u0b48\\u0b4b-\\u0b4d\\u0b56\\u0b57\\u0b5f-\\u0b60\\u0b66-\\u0b6f\\u0b82\\u0bbe-\\u0bc2\\u0bc6-\\u0bc8\\u0bca-\\u0bcd\\u0bd7\\u0be6-\\u0bef\\u0c01-\\u0c03\\u0c46-\\u0c48\\u0c4a-\\u0c4d\\u0c55\\u0c56\\u0c62-\\u0c63\\u0c66-\\u0c6f\\u0c82\\u0c83\\u0cbc\\u0cbe-\\u0cc4\\u0cc6-\\u0cc8\\u0cca-\\u0ccd\\u0cd5\\u0cd6\\u0ce2-\\u0ce3\\u0ce6-\\u0cef\\u0d02\\u0d03\\u0d46-\\u0d48\\u0d57\\u0d62-\\u0d63\\u0d66-\\u0d6f\\u0d82\\u0d83\\u0dca\\u0dcf-\\u0dd4\\u0dd6\\u0dd8-\\u0ddf\\u0df2\\u0df3\\u0e34-\\u0e3a\\u0e40-\\u0e45\\u0e50-\\u0e59\\u0eb4-\\u0eb9\\u0ec8-\\u0ecd\\u0ed0-\\u0ed9\\u0f18\\u0f19\\u0f20-\\u0f29\\u0f35\\u0f37\\u0f39\\u0f41-\\u0f47\\u0f71-\\u0f84\\u0f86-\\u0f87\\u0f8d-\\u0f97\\u0f99-\\u0fbc\\u0fc6\\u1000-\\u1029\\u1040-\\u1049\\u1067-\\u106d\\u1071-\\u1074\\u1082-\\u108d\\u108f-\\u109d\\u135d-\\u135f\\u170e-\\u1710\\u1720-\\u1730\\u1740-\\u1750\\u1772\\u1773\\u1780-\\u17b2\\u17dd\\u17e0-\\u17e9\\u180b-\\u180d\\u1810-\\u1819\\u1920-\\u192b\\u1930-\\u193b\\u1951-\\u196d\\u19b0-\\u19c0\\u19c8-\\u19c9\\u19d0-\\u19d9\\u1a00-\\u1a15\\u1a20-\\u1a53\\u1a60-\\u1a7c\\u1a7f-\\u1a89\\u1a90-\\u1a99\\u1b46-\\u1b4b\\u1b50-\\u1b59\\u1b6b-\\u1b73\\u1bb0-\\u1bb9\\u1be6-\\u1bf3\\u1c00-\\u1c22\\u1c40-\\u1c49\\u1c5b-\\u1c7d\\u1cd0-\\u1cd2\\u1d00-\\u1dbe\\u1e01-\\u1f15\\u200c\\u200d\\u203f\\u2040\\u2054\\u20d0-\\u20dc\\u20e1\\u20e5-\\u20f0\\u2d81-\\u2d96\\u2de0-\\u2dff\\u3021-\\u3028\\u3099\\u309a\\ua640-\\ua66d\\ua674-\\ua67d\\ua69f\\ua6f0-\\ua6f1\\ua7f8-\\ua800\\ua806\\ua80b\\ua823-\\ua827\\ua880-\\ua881\\ua8b4-\\ua8c4\\ua8d0-\\ua8d9\\ua8f3-\\ua8f7\\ua900-\\ua909\\ua926-\\ua92d\\ua930-\\ua945\\ua980-\\ua983\\ua9b3-\\ua9c0\\uaa00-\\uaa27\\uaa40-\\uaa41\\uaa4c-\\uaa4d\\uaa50-\\uaa59\\uaa7b\\uaae0-\\uaae9\\uaaf2-\\uaaf3\\uabc0-\\uabe1\\uabec\\uabed\\uabf0-\\uabf9\\ufb20-\\ufb28\\ufe00-\\ufe0f\\ufe20-\\ufe26\\ufe33\\ufe34\\ufe4d-\\ufe4f\\uff10-\\uff19\\uff3f", s = "\\\\u[0-9a-fA-F]{4}|\\\\u\\{[0-9a-fA-F]+\\}", o = "(?:" + s + "|[" + e + r + "])", a = "(?:" + s + "|[" + t + r + i + "])*";
    n.identifier = new RegExp(o + a, "g"), n.identifierStart = new RegExp(o), n.identifierMatch = new RegExp("(?:" + s + "|[" + t + r + i + "])+"), n.newline = /[\n\r\u2028\u2029]/, n.lineBreak = new RegExp(`\r
|` + n.newline.source), n.allLineBreaks = new RegExp(n.lineBreak.source, "g");
  }(Uu)), Uu;
}
var Wu = {}, Ls = {}, s2;
function p0() {
  if (s2) return Ls;
  s2 = 1;
  function n(r, i) {
    this.raw_options = e(r, i), this.disabled = this._get_boolean("disabled"), this.eol = this._get_characters("eol", "auto"), this.end_with_newline = this._get_boolean("end_with_newline"), this.indent_size = this._get_number("indent_size", 4), this.indent_char = this._get_characters("indent_char", " "), this.indent_level = this._get_number("indent_level"), this.preserve_newlines = this._get_boolean("preserve_newlines", !0), this.max_preserve_newlines = this._get_number("max_preserve_newlines", 32786), this.preserve_newlines || (this.max_preserve_newlines = 0), this.indent_with_tabs = this._get_boolean("indent_with_tabs", this.indent_char === "	"), this.indent_with_tabs && (this.indent_char = "	", this.indent_size === 1 && (this.indent_size = 4)), this.wrap_line_length = this._get_number("wrap_line_length", this._get_number("max_char")), this.indent_empty_lines = this._get_boolean("indent_empty_lines"), this.templating = this._get_selection_list("templating", ["auto", "none", "angular", "django", "erb", "handlebars", "php", "smarty"], ["auto"]);
  }
  n.prototype._get_array = function(r, i) {
    var s = this.raw_options[r], o = i || [];
    return typeof s == "object" ? s !== null && typeof s.concat == "function" && (o = s.concat()) : typeof s == "string" && (o = s.split(/[^a-zA-Z0-9_\/\-]+/)), o;
  }, n.prototype._get_boolean = function(r, i) {
    var s = this.raw_options[r], o = s === void 0 ? !!i : !!s;
    return o;
  }, n.prototype._get_characters = function(r, i) {
    var s = this.raw_options[r], o = i || "";
    return typeof s == "string" && (o = s.replace(/\\r/, "\r").replace(/\\n/, `
`).replace(/\\t/, "	")), o;
  }, n.prototype._get_number = function(r, i) {
    var s = this.raw_options[r];
    i = parseInt(i, 10), isNaN(i) && (i = 0);
    var o = parseInt(s, 10);
    return isNaN(o) && (o = i), o;
  }, n.prototype._get_selection = function(r, i, s) {
    var o = this._get_selection_list(r, i, s);
    if (o.length !== 1)
      throw new Error(
        "Invalid Option Value: The option '" + r + `' can only be one of the following values:
` + i + `
You passed in: '` + this.raw_options[r] + "'"
      );
    return o[0];
  }, n.prototype._get_selection_list = function(r, i, s) {
    if (!i || i.length === 0)
      throw new Error("Selection list cannot be empty.");
    if (s = s || [i[0]], !this._is_valid_selection(s, i))
      throw new Error("Invalid Default Value!");
    var o = this._get_array(r, s);
    if (!this._is_valid_selection(o, i))
      throw new Error(
        "Invalid Option Value: The option '" + r + `' can contain only the following values:
` + i + `
You passed in: '` + this.raw_options[r] + "'"
      );
    return o;
  }, n.prototype._is_valid_selection = function(r, i) {
    return r.length && i.length && !r.some(function(s) {
      return i.indexOf(s) === -1;
    });
  };
  function e(r, i) {
    var s = {};
    r = t(r);
    var o;
    for (o in r)
      o !== i && (s[o] = r[o]);
    if (i && r[i])
      for (o in r[i])
        s[o] = r[i][o];
    return s;
  }
  function t(r) {
    var i = {}, s;
    for (s in r) {
      var o = s.replace(/-/g, "_");
      i[o] = r[s];
    }
    return i;
  }
  return Ls.Options = n, Ls.normalizeOpts = t, Ls.mergeOpts = e, Ls;
}
var o2;
function X3() {
  if (o2) return Wu;
  o2 = 1;
  var n = p0().Options, e = ["before-newline", "after-newline", "preserve-newline"];
  function t(r) {
    n.call(this, r, "js");
    var i = this.raw_options.brace_style || null;
    i === "expand-strict" ? this.raw_options.brace_style = "expand" : i === "collapse-preserve-inline" ? this.raw_options.brace_style = "collapse,preserve-inline" : this.raw_options.braces_on_own_line !== void 0 && (this.raw_options.brace_style = this.raw_options.braces_on_own_line ? "expand" : "collapse");
    var s = this._get_selection_list("brace_style", ["collapse", "expand", "end-expand", "none", "preserve-inline"]);
    this.brace_preserve_inline = !1, this.brace_style = "collapse";
    for (var o = 0; o < s.length; o++)
      s[o] === "preserve-inline" ? this.brace_preserve_inline = !0 : this.brace_style = s[o];
    this.unindent_chained_methods = this._get_boolean("unindent_chained_methods"), this.break_chained_methods = this._get_boolean("break_chained_methods"), this.space_in_paren = this._get_boolean("space_in_paren"), this.space_in_empty_paren = this._get_boolean("space_in_empty_paren"), this.jslint_happy = this._get_boolean("jslint_happy"), this.space_after_anon_function = this._get_boolean("space_after_anon_function"), this.space_after_named_function = this._get_boolean("space_after_named_function"), this.keep_array_indentation = this._get_boolean("keep_array_indentation"), this.space_before_conditional = this._get_boolean("space_before_conditional", !0), this.unescape_strings = this._get_boolean("unescape_strings"), this.e4x = this._get_boolean("e4x"), this.comma_first = this._get_boolean("comma_first"), this.operator_position = this._get_selection("operator_position", e), this.test_output_raw = this._get_boolean("test_output_raw"), this.jslint_happy && (this.space_after_anon_function = !0);
  }
  return t.prototype = new n(), Wu.Options = t, Wu;
}
var Ii = {}, qu = {}, a2;
function h0() {
  if (a2) return qu;
  a2 = 1;
  var n = RegExp.prototype.hasOwnProperty("sticky");
  function e(t) {
    this.__input = t || "", this.__input_length = this.__input.length, this.__position = 0;
  }
  return e.prototype.restart = function() {
    this.__position = 0;
  }, e.prototype.back = function() {
    this.__position > 0 && (this.__position -= 1);
  }, e.prototype.hasNext = function() {
    return this.__position < this.__input_length;
  }, e.prototype.next = function() {
    var t = null;
    return this.hasNext() && (t = this.__input.charAt(this.__position), this.__position += 1), t;
  }, e.prototype.peek = function(t) {
    var r = null;
    return t = t || 0, t += this.__position, t >= 0 && t < this.__input_length && (r = this.__input.charAt(t)), r;
  }, e.prototype.__match = function(t, r) {
    t.lastIndex = r;
    var i = t.exec(this.__input);
    return i && !(n && t.sticky) && i.index !== r && (i = null), i;
  }, e.prototype.test = function(t, r) {
    return r = r || 0, r += this.__position, r >= 0 && r < this.__input_length ? !!this.__match(t, r) : !1;
  }, e.prototype.testChar = function(t, r) {
    var i = this.peek(r);
    return t.lastIndex = 0, i !== null && t.test(i);
  }, e.prototype.match = function(t) {
    var r = this.__match(t, this.__position);
    return r ? this.__position += r[0].length : r = null, r;
  }, e.prototype.read = function(t, r, i) {
    var s = "", o;
    return t && (o = this.match(t), o && (s += o[0])), r && (o || !t) && (s += this.readUntil(r, i)), s;
  }, e.prototype.readUntil = function(t, r) {
    var i = "", s = this.__position;
    t.lastIndex = this.__position;
    var o = t.exec(this.__input);
    return o ? (s = o.index, r && (s += o[0].length)) : s = this.__input_length, i = this.__input.substring(this.__position, s), this.__position = s, i;
  }, e.prototype.readUntilAfter = function(t) {
    return this.readUntil(t, !0);
  }, e.prototype.get_regexp = function(t, r) {
    var i = null, s = "g";
    return r && n && (s = "y"), typeof t == "string" && t !== "" ? i = new RegExp(t, s) : t && (i = new RegExp(t.source, s)), i;
  }, e.prototype.get_literal_regexp = function(t) {
    return RegExp(t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"));
  }, e.prototype.peekUntilAfter = function(t) {
    var r = this.__position, i = this.readUntilAfter(t);
    return this.__position = r, i;
  }, e.prototype.lookBack = function(t) {
    var r = this.__position - 1;
    return r >= t.length && this.__input.substring(r - t.length, r).toLowerCase() === t;
  }, qu.InputScanner = e, qu;
}
var la = {}, Ku = {}, l2;
function ET() {
  if (l2) return Ku;
  l2 = 1;
  function n(e) {
    this.__tokens = [], this.__tokens_length = this.__tokens.length, this.__position = 0, this.__parent_token = e;
  }
  return n.prototype.restart = function() {
    this.__position = 0;
  }, n.prototype.isEmpty = function() {
    return this.__tokens_length === 0;
  }, n.prototype.hasNext = function() {
    return this.__position < this.__tokens_length;
  }, n.prototype.next = function() {
    var e = null;
    return this.hasNext() && (e = this.__tokens[this.__position], this.__position += 1), e;
  }, n.prototype.peek = function(e) {
    var t = null;
    return e = e || 0, e += this.__position, e >= 0 && e < this.__tokens_length && (t = this.__tokens[e]), t;
  }, n.prototype.add = function(e) {
    this.__parent_token && (e.parent = this.__parent_token), this.__tokens.push(e), this.__tokens_length += 1;
  }, Ku.TokenStream = n, Ku;
}
var Gu = {}, Yu = {}, u2;
function Ul() {
  if (u2) return Yu;
  u2 = 1;
  function n(e, t) {
    this._input = e, this._starting_pattern = null, this._match_pattern = null, this._until_pattern = null, this._until_after = !1, t && (this._starting_pattern = this._input.get_regexp(t._starting_pattern, !0), this._match_pattern = this._input.get_regexp(t._match_pattern, !0), this._until_pattern = this._input.get_regexp(t._until_pattern), this._until_after = t._until_after);
  }
  return n.prototype.read = function() {
    var e = this._input.read(this._starting_pattern);
    return (!this._starting_pattern || e) && (e += this._input.read(this._match_pattern, this._until_pattern, this._until_after)), e;
  }, n.prototype.read_match = function() {
    return this._input.match(this._match_pattern);
  }, n.prototype.until_after = function(e) {
    var t = this._create();
    return t._until_after = !0, t._until_pattern = this._input.get_regexp(e), t._update(), t;
  }, n.prototype.until = function(e) {
    var t = this._create();
    return t._until_after = !1, t._until_pattern = this._input.get_regexp(e), t._update(), t;
  }, n.prototype.starting_with = function(e) {
    var t = this._create();
    return t._starting_pattern = this._input.get_regexp(e, !0), t._update(), t;
  }, n.prototype.matching = function(e) {
    var t = this._create();
    return t._match_pattern = this._input.get_regexp(e, !0), t._update(), t;
  }, n.prototype._create = function() {
    return new n(this._input, this);
  }, n.prototype._update = function() {
  }, Yu.Pattern = n, Yu;
}
var d2;
function TT() {
  if (d2) return Gu;
  d2 = 1;
  var n = Ul().Pattern;
  function e(t, r) {
    n.call(this, t, r), r ? this._line_regexp = this._input.get_regexp(r._line_regexp) : this.__set_whitespace_patterns("", ""), this.newline_count = 0, this.whitespace_before_token = "";
  }
  return e.prototype = new n(), e.prototype.__set_whitespace_patterns = function(t, r) {
    t += "\\t ", r += "\\n\\r", this._match_pattern = this._input.get_regexp(
      "[" + t + r + "]+",
      !0
    ), this._newline_regexp = this._input.get_regexp(
      "\\r\\n|[" + r + "]"
    );
  }, e.prototype.read = function() {
    this.newline_count = 0, this.whitespace_before_token = "";
    var t = this._input.read(this._match_pattern);
    if (t === " ")
      this.whitespace_before_token = " ";
    else if (t) {
      var r = this.__split(this._newline_regexp, t);
      this.newline_count = r.length - 1, this.whitespace_before_token = r[this.newline_count];
    }
    return t;
  }, e.prototype.matching = function(t, r) {
    var i = this._create();
    return i.__set_whitespace_patterns(t, r), i._update(), i;
  }, e.prototype._create = function() {
    return new e(this._input, this);
  }, e.prototype.__split = function(t, r) {
    t.lastIndex = 0;
    for (var i = 0, s = [], o = t.exec(r); o; )
      s.push(r.substring(i, o.index)), i = o.index + o[0].length, o = t.exec(r);
    return i < r.length ? s.push(r.substring(i, r.length)) : s.push(""), s;
  }, Gu.WhitespacePattern = e, Gu;
}
var c2;
function yl() {
  if (c2) return la;
  c2 = 1;
  var n = h0().InputScanner, e = J3().Token, t = ET().TokenStream, r = TT().WhitespacePattern, i = {
    START: "TK_START",
    RAW: "TK_RAW",
    EOF: "TK_EOF"
  }, s = function(o, a) {
    this._input = new n(o), this._options = a || {}, this.__tokens = null, this._patterns = {}, this._patterns.whitespace = new r(this._input);
  };
  return s.prototype.tokenize = function() {
    this._input.restart(), this.__tokens = new t(), this._reset();
    for (var o, a = new e(i.START, ""), l = null, u = [], d = new t(); a.type !== i.EOF; ) {
      for (o = this._get_next_token(a, l); this._is_comment(o); )
        d.add(o), o = this._get_next_token(a, l);
      d.isEmpty() || (o.comments_before = d, d = new t()), o.parent = l, this._is_opening(o) ? (u.push(l), l = o) : l && this._is_closing(o, l) && (o.opened = l, l.closed = o, l = u.pop(), o.parent = l), o.previous = a, a.next = o, this.__tokens.add(o), a = o;
    }
    return this.__tokens;
  }, s.prototype._is_first_token = function() {
    return this.__tokens.isEmpty();
  }, s.prototype._reset = function() {
  }, s.prototype._get_next_token = function(o, a) {
    this._readWhitespace();
    var l = this._input.read(/.+/g);
    return l ? this._create_token(i.RAW, l) : this._create_token(i.EOF, "");
  }, s.prototype._is_comment = function(o) {
    return !1;
  }, s.prototype._is_opening = function(o) {
    return !1;
  }, s.prototype._is_closing = function(o, a) {
    return !1;
  }, s.prototype._create_token = function(o, a) {
    var l = new e(
      o,
      a,
      this._patterns.whitespace.newline_count,
      this._patterns.whitespace.whitespace_before_token
    );
    return l;
  }, s.prototype._readWhitespace = function() {
    return this._patterns.whitespace.read();
  }, la.Tokenizer = s, la.TOKEN = i, la;
}
var Ju = {}, f2;
function m0() {
  if (f2) return Ju;
  f2 = 1;
  function n(e, t) {
    e = typeof e == "string" ? e : e.source, t = typeof t == "string" ? t : t.source, this.__directives_block_pattern = new RegExp(e + / beautify( \w+[:]\w+)+ /.source + t, "g"), this.__directive_pattern = / (\w+)[:](\w+)/g, this.__directives_end_ignore_pattern = new RegExp(e + /\sbeautify\signore:end\s/.source + t, "g");
  }
  return n.prototype.get_directives = function(e) {
    if (!e.match(this.__directives_block_pattern))
      return null;
    var t = {};
    this.__directive_pattern.lastIndex = 0;
    for (var r = this.__directive_pattern.exec(e); r; )
      t[r[1]] = r[2], r = this.__directive_pattern.exec(e);
    return t;
  }, n.prototype.readIgnored = function(e) {
    return e.readUntilAfter(this.__directives_end_ignore_pattern);
  }, Ju.Directives = n, Ju;
}
var Zu = {}, p2;
function Q3() {
  if (p2) return Zu;
  p2 = 1;
  var n = Ul().Pattern, e = {
    django: !1,
    erb: !1,
    handlebars: !1,
    php: !1,
    smarty: !1,
    angular: !1
  };
  function t(r, i) {
    n.call(this, r, i), this.__template_pattern = null, this._disabled = Object.assign({}, e), this._excluded = Object.assign({}, e), i && (this.__template_pattern = this._input.get_regexp(i.__template_pattern), this._excluded = Object.assign(this._excluded, i._excluded), this._disabled = Object.assign(this._disabled, i._disabled));
    var s = new n(r);
    this.__patterns = {
      handlebars_comment: s.starting_with(/{{!--/).until_after(/--}}/),
      handlebars_unescaped: s.starting_with(/{{{/).until_after(/}}}/),
      handlebars: s.starting_with(/{{/).until_after(/}}/),
      php: s.starting_with(/<\?(?:[= ]|php)/).until_after(/\?>/),
      erb: s.starting_with(/<%[^%]/).until_after(/[^%]%>/),
      // django coflicts with handlebars a bit.
      django: s.starting_with(/{%/).until_after(/%}/),
      django_value: s.starting_with(/{{/).until_after(/}}/),
      django_comment: s.starting_with(/{#/).until_after(/#}/),
      smarty: s.starting_with(/{(?=[^}{\s\n])/).until_after(/[^\s\n]}/),
      smarty_comment: s.starting_with(/{\*/).until_after(/\*}/),
      smarty_literal: s.starting_with(/{literal}/).until_after(/{\/literal}/)
    };
  }
  return t.prototype = new n(), t.prototype._create = function() {
    return new t(this._input, this);
  }, t.prototype._update = function() {
    this.__set_templated_pattern();
  }, t.prototype.disable = function(r) {
    var i = this._create();
    return i._disabled[r] = !0, i._update(), i;
  }, t.prototype.read_options = function(r) {
    var i = this._create();
    for (var s in e)
      i._disabled[s] = r.templating.indexOf(s) === -1;
    return i._update(), i;
  }, t.prototype.exclude = function(r) {
    var i = this._create();
    return i._excluded[r] = !0, i._update(), i;
  }, t.prototype.read = function() {
    var r = "";
    this._match_pattern ? r = this._input.read(this._starting_pattern) : r = this._input.read(this._starting_pattern, this.__template_pattern);
    for (var i = this._read_template(); i; )
      this._match_pattern ? i += this._input.read(this._match_pattern) : i += this._input.readUntil(this.__template_pattern), r += i, i = this._read_template();
    return this._until_after && (r += this._input.readUntilAfter(this._until_pattern)), r;
  }, t.prototype.__set_templated_pattern = function() {
    var r = [];
    this._disabled.php || r.push(this.__patterns.php._starting_pattern.source), this._disabled.handlebars || r.push(this.__patterns.handlebars._starting_pattern.source), this._disabled.angular || r.push(this.__patterns.handlebars._starting_pattern.source), this._disabled.erb || r.push(this.__patterns.erb._starting_pattern.source), this._disabled.django || (r.push(this.__patterns.django._starting_pattern.source), r.push(this.__patterns.django_value._starting_pattern.source), r.push(this.__patterns.django_comment._starting_pattern.source)), this._disabled.smarty || r.push(this.__patterns.smarty._starting_pattern.source), this._until_pattern && r.push(this._until_pattern.source), this.__template_pattern = this._input.get_regexp("(?:" + r.join("|") + ")");
  }, t.prototype._read_template = function() {
    var r = "", i = this._input.peek();
    if (i === "<") {
      var s = this._input.peek(1);
      !this._disabled.php && !this._excluded.php && s === "?" && (r = r || this.__patterns.php.read()), !this._disabled.erb && !this._excluded.erb && s === "%" && (r = r || this.__patterns.erb.read());
    } else i === "{" && (!this._disabled.handlebars && !this._excluded.handlebars && (r = r || this.__patterns.handlebars_comment.read(), r = r || this.__patterns.handlebars_unescaped.read(), r = r || this.__patterns.handlebars.read()), this._disabled.django || (!this._excluded.django && !this._excluded.handlebars && (r = r || this.__patterns.django_value.read()), this._excluded.django || (r = r || this.__patterns.django_comment.read(), r = r || this.__patterns.django.read())), this._disabled.smarty || this._disabled.django && this._disabled.handlebars && (r = r || this.__patterns.smarty_comment.read(), r = r || this.__patterns.smarty_literal.read(), r = r || this.__patterns.smarty.read()));
    return r;
  }, Zu.TemplatablePattern = t, Zu;
}
var h2;
function ua() {
  if (h2) return Ii;
  h2 = 1;
  var n = h0().InputScanner, e = yl().Tokenizer, t = yl().TOKEN, r = m0().Directives, i = Z3(), s = Ul().Pattern, o = Q3().TemplatablePattern;
  function a(S, R) {
    return R.indexOf(S) !== -1;
  }
  var l = {
    START_EXPR: "TK_START_EXPR",
    END_EXPR: "TK_END_EXPR",
    START_BLOCK: "TK_START_BLOCK",
    END_BLOCK: "TK_END_BLOCK",
    WORD: "TK_WORD",
    RESERVED: "TK_RESERVED",
    SEMICOLON: "TK_SEMICOLON",
    STRING: "TK_STRING",
    EQUALS: "TK_EQUALS",
    OPERATOR: "TK_OPERATOR",
    COMMA: "TK_COMMA",
    BLOCK_COMMENT: "TK_BLOCK_COMMENT",
    COMMENT: "TK_COMMENT",
    DOT: "TK_DOT",
    UNKNOWN: "TK_UNKNOWN",
    START: t.START,
    RAW: t.RAW,
    EOF: t.EOF
  }, u = new r(/\/\*/, /\*\//), d = /0[xX][0123456789abcdefABCDEF_]*n?|0[oO][01234567_]*n?|0[bB][01_]*n?|\d[\d_]*n|(?:\.\d[\d_]*|\d[\d_]*\.?[\d_]*)(?:[eE][+-]?[\d_]+)?/, c = /[0-9]/, f = /[^\d\.]/, p = ">>> === !== &&= ??= ||= << && >= ** != == <= >> || ?? |> < / - + > : & % ? ^ | *".split(" "), h = ">>>= ... >>= <<= === >>> !== **= &&= ??= ||= => ^= :: /= << <= == && -= >= >> != -- += ** || ?? ++ %= &= *= |= |> = ! ? > < : / ^ - + * & % ~ |";
  h = h.replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&"), h = "\\?\\.(?!\\d) " + h, h = h.replace(/ /g, "|");
  var y = new RegExp(h), g = "continue,try,throw,return,var,let,const,if,switch,case,default,for,while,break,function,import,export".split(","), m = g.concat(["do", "in", "of", "else", "get", "set", "new", "catch", "finally", "typeof", "yield", "async", "await", "from", "as", "class", "extends"]), $ = new RegExp("^(?:" + m.join("|") + ")$"), w, _ = function(S, R) {
    e.call(this, S, R), this._patterns.whitespace = this._patterns.whitespace.matching(
      /\u00A0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff/.source,
      /\u2028\u2029/.source
    );
    var O = new s(this._input), I = new o(this._input).read_options(this._options);
    this.__patterns = {
      template: I,
      identifier: I.starting_with(i.identifier).matching(i.identifierMatch),
      number: O.matching(d),
      punct: O.matching(y),
      // comment ends just before nearest linefeed or end of file
      comment: O.starting_with(/\/\//).until(/[\n\r\u2028\u2029]/),
      //  /* ... */ comment ends with nearest */ or end of file
      block_comment: O.starting_with(/\/\*/).until_after(/\*\//),
      html_comment_start: O.matching(/<!--/),
      html_comment_end: O.matching(/-->/),
      include: O.starting_with(/#include/).until_after(i.lineBreak),
      shebang: O.starting_with(/#!/).until_after(i.lineBreak),
      xml: O.matching(/[\s\S]*?<(\/?)([-a-zA-Z:0-9_.]+|{[^}]+?}|!\[CDATA\[[^\]]*?\]\]|)(\s*{[^}]+?}|\s+[-a-zA-Z:0-9_.]+|\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{([^{}]|{[^}]+?})+?}))*\s*(\/?)\s*>/),
      single_quote: I.until(/['\\\n\r\u2028\u2029]/),
      double_quote: I.until(/["\\\n\r\u2028\u2029]/),
      template_text: I.until(/[`\\$]/),
      template_expression: I.until(/[`}\\]/)
    };
  };
  _.prototype = new e(), _.prototype._is_comment = function(S) {
    return S.type === l.COMMENT || S.type === l.BLOCK_COMMENT || S.type === l.UNKNOWN;
  }, _.prototype._is_opening = function(S) {
    return S.type === l.START_BLOCK || S.type === l.START_EXPR;
  }, _.prototype._is_closing = function(S, R) {
    return (S.type === l.END_BLOCK || S.type === l.END_EXPR) && R && (S.text === "]" && R.text === "[" || S.text === ")" && R.text === "(" || S.text === "}" && R.text === "{");
  }, _.prototype._reset = function() {
    w = !1;
  }, _.prototype._get_next_token = function(S, R) {
    var O = null;
    this._readWhitespace();
    var I = this._input.peek();
    return I === null ? this._create_token(l.EOF, "") : (O = O || this._read_non_javascript(I), O = O || this._read_string(I), O = O || this._read_pair(I, this._input.peek(1)), O = O || this._read_word(S), O = O || this._read_singles(I), O = O || this._read_comment(I), O = O || this._read_regexp(I, S), O = O || this._read_xml(I, S), O = O || this._read_punctuation(), O = O || this._create_token(l.UNKNOWN, this._input.next()), O);
  }, _.prototype._read_word = function(S) {
    var R;
    if (R = this.__patterns.identifier.read(), R !== "")
      return R = R.replace(i.allLineBreaks, `
`), !(S.type === l.DOT || S.type === l.RESERVED && (S.text === "set" || S.text === "get")) && $.test(R) ? (R === "in" || R === "of") && (S.type === l.WORD || S.type === l.STRING) ? this._create_token(l.OPERATOR, R) : this._create_token(l.RESERVED, R) : this._create_token(l.WORD, R);
    if (R = this.__patterns.number.read(), R !== "")
      return this._create_token(l.WORD, R);
  }, _.prototype._read_singles = function(S) {
    var R = null;
    return S === "(" || S === "[" ? R = this._create_token(l.START_EXPR, S) : S === ")" || S === "]" ? R = this._create_token(l.END_EXPR, S) : S === "{" ? R = this._create_token(l.START_BLOCK, S) : S === "}" ? R = this._create_token(l.END_BLOCK, S) : S === ";" ? R = this._create_token(l.SEMICOLON, S) : S === "." && f.test(this._input.peek(1)) ? R = this._create_token(l.DOT, S) : S === "," && (R = this._create_token(l.COMMA, S)), R && this._input.next(), R;
  }, _.prototype._read_pair = function(S, R) {
    var O = null;
    return S === "#" && R === "{" && (O = this._create_token(l.START_BLOCK, S + R)), O && (this._input.next(), this._input.next()), O;
  }, _.prototype._read_punctuation = function() {
    var S = this.__patterns.punct.read();
    if (S !== "")
      return S === "=" ? this._create_token(l.EQUALS, S) : S === "?." ? this._create_token(l.DOT, S) : this._create_token(l.OPERATOR, S);
  }, _.prototype._read_non_javascript = function(S) {
    var R = "";
    if (S === "#") {
      if (this._is_first_token() && (R = this.__patterns.shebang.read(), R))
        return this._create_token(l.UNKNOWN, R.trim() + `
`);
      if (R = this.__patterns.include.read(), R)
        return this._create_token(l.UNKNOWN, R.trim() + `
`);
      S = this._input.next();
      var O = "#";
      if (this._input.hasNext() && this._input.testChar(c)) {
        do
          S = this._input.next(), O += S;
        while (this._input.hasNext() && S !== "#" && S !== "=");
        return S === "#" || (this._input.peek() === "[" && this._input.peek(1) === "]" ? (O += "[]", this._input.next(), this._input.next()) : this._input.peek() === "{" && this._input.peek(1) === "}" && (O += "{}", this._input.next(), this._input.next())), this._create_token(l.WORD, O);
      }
      this._input.back();
    } else if (S === "<" && this._is_first_token()) {
      if (R = this.__patterns.html_comment_start.read(), R) {
        for (; this._input.hasNext() && !this._input.testChar(i.newline); )
          R += this._input.next();
        return w = !0, this._create_token(l.COMMENT, R);
      }
    } else if (w && S === "-" && (R = this.__patterns.html_comment_end.read(), R))
      return w = !1, this._create_token(l.COMMENT, R);
    return null;
  }, _.prototype._read_comment = function(S) {
    var R = null;
    if (S === "/") {
      var O = "";
      if (this._input.peek(1) === "*") {
        O = this.__patterns.block_comment.read();
        var I = u.get_directives(O);
        I && I.ignore === "start" && (O += u.readIgnored(this._input)), O = O.replace(i.allLineBreaks, `
`), R = this._create_token(l.BLOCK_COMMENT, O), R.directives = I;
      } else this._input.peek(1) === "/" && (O = this.__patterns.comment.read(), R = this._create_token(l.COMMENT, O));
    }
    return R;
  }, _.prototype._read_string = function(S) {
    if (S === "`" || S === "'" || S === '"') {
      var R = this._input.next();
      return this.has_char_escapes = !1, S === "`" ? R += this._read_string_recursive("`", !0, "${") : R += this._read_string_recursive(S), this.has_char_escapes && this._options.unescape_strings && (R = L(R)), this._input.peek() === S && (R += this._input.next()), R = R.replace(i.allLineBreaks, `
`), this._create_token(l.STRING, R);
    }
    return null;
  }, _.prototype._allow_regexp_or_xml = function(S) {
    return S.type === l.RESERVED && a(S.text, ["return", "case", "throw", "else", "do", "typeof", "yield"]) || S.type === l.END_EXPR && S.text === ")" && S.opened.previous.type === l.RESERVED && a(S.opened.previous.text, ["if", "while", "for"]) || a(S.type, [
      l.COMMENT,
      l.START_EXPR,
      l.START_BLOCK,
      l.START,
      l.END_BLOCK,
      l.OPERATOR,
      l.EQUALS,
      l.EOF,
      l.SEMICOLON,
      l.COMMA
    ]);
  }, _.prototype._read_regexp = function(S, R) {
    if (S === "/" && this._allow_regexp_or_xml(R)) {
      for (var O = this._input.next(), I = !1, x = !1; this._input.hasNext() && (I || x || this._input.peek() !== S) && !this._input.testChar(i.newline); )
        O += this._input.peek(), I ? I = !1 : (I = this._input.peek() === "\\", this._input.peek() === "[" ? x = !0 : this._input.peek() === "]" && (x = !1)), this._input.next();
      return this._input.peek() === S && (O += this._input.next(), O += this._input.read(i.identifier)), this._create_token(l.STRING, O);
    }
    return null;
  }, _.prototype._read_xml = function(S, R) {
    if (this._options.e4x && S === "<" && this._allow_regexp_or_xml(R)) {
      var O = "", I = this.__patterns.xml.read_match();
      if (I) {
        for (var x = I[2].replace(/^{\s+/, "{").replace(/\s+}$/, "}"), M = x.indexOf("{") === 0, D = 0; I; ) {
          var j = !!I[1], U = I[2], J = !!I[I.length - 1] || U.slice(0, 8) === "![CDATA[";
          if (!J && (U === x || M && U.replace(/^{\s+/, "{").replace(/\s+}$/, "}")) && (j ? --D : ++D), O += I[0], D <= 0)
            break;
          I = this.__patterns.xml.read_match();
        }
        return I || (O += this._input.match(/[\s\S]*/g)[0]), O = O.replace(i.allLineBreaks, `
`), this._create_token(l.STRING, O);
      }
    }
    return null;
  };
  function L(S) {
    for (var R = "", O = 0, I = new n(S), x = null; I.hasNext(); )
      if (x = I.match(/([\s]|[^\\]|\\\\)+/g), x && (R += x[0]), I.peek() === "\\") {
        if (I.next(), I.peek() === "x")
          x = I.match(/x([0-9A-Fa-f]{2})/g);
        else if (I.peek() === "u")
          x = I.match(/u([0-9A-Fa-f]{4})/g), x || (x = I.match(/u\{([0-9A-Fa-f]+)\}/g));
        else {
          R += "\\", I.hasNext() && (R += I.next());
          continue;
        }
        if (!x || (O = parseInt(x[1], 16), O > 126 && O <= 255 && x[0].indexOf("x") === 0))
          return S;
        O >= 0 && O < 32 || O > 1114111 ? R += "\\" + x[0] : O === 34 || O === 39 || O === 92 ? R += "\\" + String.fromCharCode(O) : R += String.fromCharCode(O);
      }
    return R;
  }
  return _.prototype._read_string_recursive = function(S, R, O) {
    var I, x;
    S === "'" ? x = this.__patterns.single_quote : S === '"' ? x = this.__patterns.double_quote : S === "`" ? x = this.__patterns.template_text : S === "}" && (x = this.__patterns.template_expression);
    for (var M = x.read(), D = ""; this._input.hasNext(); ) {
      if (D = this._input.next(), D === S || !R && i.newline.test(D)) {
        this._input.back();
        break;
      } else D === "\\" && this._input.hasNext() ? (I = this._input.peek(), I === "x" || I === "u" ? this.has_char_escapes = !0 : I === "\r" && this._input.peek(1) === `
` && this._input.next(), D += this._input.next()) : O && (O === "${" && D === "$" && this._input.peek() === "{" && (D += this._input.next()), O === D && (S === "`" ? D += this._read_string_recursive("}", R, "`") : D += this._read_string_recursive("`", R, "${"), this._input.hasNext() && (D += this._input.next())));
      D += x.read(), M += D;
    }
    return M;
  }, Ii.Tokenizer = _, Ii.TOKEN = l, Ii.positionable_operators = p.slice(), Ii.line_starters = g.slice(), Ii;
}
var m2;
function OT() {
  if (m2) return Fu;
  m2 = 1;
  var n = f0().Output, e = J3().Token, t = Z3(), r = X3().Options, i = ua().Tokenizer, s = ua().line_starters, o = ua().positionable_operators, a = ua().TOKEN;
  function l(x, M) {
    return M.indexOf(x) !== -1;
  }
  function u(x) {
    return x.replace(/^\s+/g, "");
  }
  function d(x) {
    for (var M = {}, D = 0; D < x.length; D++)
      M[x[D].replace(/-/g, "_")] = x[D];
    return M;
  }
  function c(x, M) {
    return x && x.type === a.RESERVED && x.text === M;
  }
  function f(x, M) {
    return x && x.type === a.RESERVED && l(x.text, M);
  }
  var p = ["case", "return", "do", "if", "throw", "else", "await", "break", "continue", "async"], h = ["before-newline", "after-newline", "preserve-newline"], y = d(h), g = [y.before_newline, y.preserve_newline], m = {
    BlockStatement: "BlockStatement",
    // 'BLOCK'
    Statement: "Statement",
    // 'STATEMENT'
    ObjectLiteral: "ObjectLiteral",
    // 'OBJECT',
    ArrayLiteral: "ArrayLiteral",
    //'[EXPRESSION]',
    ForInitializer: "ForInitializer",
    //'(FOR-EXPRESSION)',
    Conditional: "Conditional",
    //'(COND-EXPRESSION)',
    Expression: "Expression"
    //'(EXPRESSION)'
  };
  function $(x, M) {
    M.multiline_frame || M.mode === m.ForInitializer || M.mode === m.Conditional || x.remove_indent(M.start_line_index);
  }
  function w(x) {
    x = x.replace(t.allLineBreaks, `
`);
    for (var M = [], D = x.indexOf(`
`); D !== -1; )
      M.push(x.substring(0, D)), x = x.substring(D + 1), D = x.indexOf(`
`);
    return x.length && M.push(x), M;
  }
  function _(x) {
    return x === m.ArrayLiteral;
  }
  function L(x) {
    return l(x, [m.Expression, m.ForInitializer, m.Conditional]);
  }
  function S(x, M) {
    for (var D = 0; D < x.length; D++) {
      var j = x[D].trim();
      if (j.charAt(0) !== M)
        return !1;
    }
    return !0;
  }
  function R(x, M) {
    for (var D = 0, j = x.length, U; D < j; D++)
      if (U = x[D], U && U.indexOf(M) !== 0)
        return !1;
    return !0;
  }
  function O(x, M) {
    M = M || {}, this._source_text = x || "", this._output = null, this._tokens = null, this._last_last_text = null, this._flags = null, this._previous_flags = null, this._flag_store = null, this._options = new r(M);
  }
  O.prototype.create_flags = function(x, M) {
    var D = 0;
    x && (D = x.indentation_level, !this._output.just_added_newline() && x.line_indent_level > D && (D = x.line_indent_level));
    var j = {
      mode: M,
      parent: x,
      last_token: x ? x.last_token : new e(a.START_BLOCK, ""),
      // last token text
      last_word: x ? x.last_word : "",
      // last TOKEN.WORD passed
      declaration_statement: !1,
      declaration_assignment: !1,
      multiline_frame: !1,
      inline_frame: !1,
      if_block: !1,
      else_block: !1,
      class_start_block: !1,
      // class A { INSIDE HERE } or class B extends C { INSIDE HERE }
      do_block: !1,
      do_while: !1,
      import_block: !1,
      in_case_statement: !1,
      // switch(..){ INSIDE HERE }
      in_case: !1,
      // we're on the exact line with "case 0:"
      case_body: !1,
      // the indented case-action block
      case_block: !1,
      // the indented case-action block is wrapped with {}
      indentation_level: D,
      alignment: 0,
      line_indent_level: x ? x.line_indent_level : D,
      start_line_index: this._output.get_line_number(),
      ternary_depth: 0
    };
    return j;
  }, O.prototype._reset = function(x) {
    var M = x.match(/^[\t ]*/)[0];
    this._last_last_text = "", this._output = new n(this._options, M), this._output.raw = this._options.test_output_raw, this._flag_store = [], this.set_mode(m.BlockStatement);
    var D = new i(x, this._options);
    return this._tokens = D.tokenize(), x;
  }, O.prototype.beautify = function() {
    if (this._options.disabled)
      return this._source_text;
    var x, M = this._reset(this._source_text), D = this._options.eol;
    this._options.eol === "auto" && (D = `
`, M && t.lineBreak.test(M || "") && (D = M.match(t.lineBreak)[0]));
    for (var j = this._tokens.next(); j; )
      this.handle_token(j), this._last_last_text = this._flags.last_token.text, this._flags.last_token = j, j = this._tokens.next();
    return x = this._output.get_code(D), x;
  }, O.prototype.handle_token = function(x, M) {
    x.type === a.START_EXPR ? this.handle_start_expr(x) : x.type === a.END_EXPR ? this.handle_end_expr(x) : x.type === a.START_BLOCK ? this.handle_start_block(x) : x.type === a.END_BLOCK ? this.handle_end_block(x) : x.type === a.WORD ? this.handle_word(x) : x.type === a.RESERVED ? this.handle_word(x) : x.type === a.SEMICOLON ? this.handle_semicolon(x) : x.type === a.STRING ? this.handle_string(x) : x.type === a.EQUALS ? this.handle_equals(x) : x.type === a.OPERATOR ? this.handle_operator(x) : x.type === a.COMMA ? this.handle_comma(x) : x.type === a.BLOCK_COMMENT ? this.handle_block_comment(x, M) : x.type === a.COMMENT ? this.handle_comment(x, M) : x.type === a.DOT ? this.handle_dot(x) : x.type === a.EOF ? this.handle_eof(x) : x.type === a.UNKNOWN ? this.handle_unknown(x, M) : this.handle_unknown(x, M);
  }, O.prototype.handle_whitespace_and_comments = function(x, M) {
    var D = x.newlines, j = this._options.keep_array_indentation && _(this._flags.mode);
    if (x.comments_before)
      for (var U = x.comments_before.next(); U; )
        this.handle_whitespace_and_comments(U, M), this.handle_token(U, M), U = x.comments_before.next();
    if (j)
      for (var J = 0; J < D; J += 1)
        this.print_newline(J > 0, M);
    else if (this._options.max_preserve_newlines && D > this._options.max_preserve_newlines && (D = this._options.max_preserve_newlines), this._options.preserve_newlines && D > 1) {
      this.print_newline(!1, M);
      for (var ne = 1; ne < D; ne += 1)
        this.print_newline(!0, M);
    }
  };
  var I = ["async", "break", "continue", "return", "throw", "yield"];
  return O.prototype.allow_wrap_or_preserved_newline = function(x, M) {
    if (M = M === void 0 ? !1 : M, !this._output.just_added_newline()) {
      var D = this._options.preserve_newlines && x.newlines || M, j = l(this._flags.last_token.text, o) || l(x.text, o);
      if (j) {
        var U = l(this._flags.last_token.text, o) && l(this._options.operator_position, g) || l(x.text, o);
        D = D && U;
      }
      if (D)
        this.print_newline(!1, !0);
      else if (this._options.wrap_line_length) {
        if (f(this._flags.last_token, I))
          return;
        this._output.set_wrap_point();
      }
    }
  }, O.prototype.print_newline = function(x, M) {
    if (!M && this._flags.last_token.text !== ";" && this._flags.last_token.text !== "," && this._flags.last_token.text !== "=" && (this._flags.last_token.type !== a.OPERATOR || this._flags.last_token.text === "--" || this._flags.last_token.text === "++"))
      for (var D = this._tokens.peek(); this._flags.mode === m.Statement && !(this._flags.if_block && c(D, "else")) && !this._flags.do_block; )
        this.restore_mode();
    this._output.add_new_line(x) && (this._flags.multiline_frame = !0);
  }, O.prototype.print_token_line_indentation = function(x) {
    this._output.just_added_newline() && (this._options.keep_array_indentation && x.newlines && (x.text === "[" || _(this._flags.mode)) ? (this._output.current_line.set_indent(-1), this._output.current_line.push(x.whitespace_before), this._output.space_before_token = !1) : this._output.set_indent(this._flags.indentation_level, this._flags.alignment) && (this._flags.line_indent_level = this._flags.indentation_level));
  }, O.prototype.print_token = function(x) {
    if (this._output.raw) {
      this._output.add_raw_token(x);
      return;
    }
    if (this._options.comma_first && x.previous && x.previous.type === a.COMMA && this._output.just_added_newline() && this._output.previous_line.last() === ",") {
      var M = this._output.previous_line.pop();
      this._output.previous_line.is_empty() && (this._output.previous_line.push(M), this._output.trim(!0), this._output.current_line.pop(), this._output.trim()), this.print_token_line_indentation(x), this._output.add_token(","), this._output.space_before_token = !0;
    }
    this.print_token_line_indentation(x), this._output.non_breaking_space = !0, this._output.add_token(x.text), this._output.previous_token_wrapped && (this._flags.multiline_frame = !0);
  }, O.prototype.indent = function() {
    this._flags.indentation_level += 1, this._output.set_indent(this._flags.indentation_level, this._flags.alignment);
  }, O.prototype.deindent = function() {
    this._flags.indentation_level > 0 && (!this._flags.parent || this._flags.indentation_level > this._flags.parent.indentation_level) && (this._flags.indentation_level -= 1, this._output.set_indent(this._flags.indentation_level, this._flags.alignment));
  }, O.prototype.set_mode = function(x) {
    this._flags ? (this._flag_store.push(this._flags), this._previous_flags = this._flags) : this._previous_flags = this.create_flags(null, x), this._flags = this.create_flags(this._previous_flags, x), this._output.set_indent(this._flags.indentation_level, this._flags.alignment);
  }, O.prototype.restore_mode = function() {
    this._flag_store.length > 0 && (this._previous_flags = this._flags, this._flags = this._flag_store.pop(), this._previous_flags.mode === m.Statement && $(this._output, this._previous_flags), this._output.set_indent(this._flags.indentation_level, this._flags.alignment));
  }, O.prototype.start_of_object_property = function() {
    return this._flags.parent.mode === m.ObjectLiteral && this._flags.mode === m.Statement && (this._flags.last_token.text === ":" && this._flags.ternary_depth === 0 || f(this._flags.last_token, ["get", "set"]));
  }, O.prototype.start_of_statement = function(x) {
    var M = !1;
    return M = M || f(this._flags.last_token, ["var", "let", "const"]) && x.type === a.WORD, M = M || c(this._flags.last_token, "do"), M = M || !(this._flags.parent.mode === m.ObjectLiteral && this._flags.mode === m.Statement) && f(this._flags.last_token, I) && !x.newlines, M = M || c(this._flags.last_token, "else") && !(c(x, "if") && !x.comments_before), M = M || this._flags.last_token.type === a.END_EXPR && (this._previous_flags.mode === m.ForInitializer || this._previous_flags.mode === m.Conditional), M = M || this._flags.last_token.type === a.WORD && this._flags.mode === m.BlockStatement && !this._flags.in_case && !(x.text === "--" || x.text === "++") && this._last_last_text !== "function" && x.type !== a.WORD && x.type !== a.RESERVED, M = M || this._flags.mode === m.ObjectLiteral && (this._flags.last_token.text === ":" && this._flags.ternary_depth === 0 || f(this._flags.last_token, ["get", "set"])), M ? (this.set_mode(m.Statement), this.indent(), this.handle_whitespace_and_comments(x, !0), this.start_of_object_property() || this.allow_wrap_or_preserved_newline(
      x,
      f(x, ["do", "for", "if", "while"])
    ), !0) : !1;
  }, O.prototype.handle_start_expr = function(x) {
    this.start_of_statement(x) || this.handle_whitespace_and_comments(x);
    var M = m.Expression;
    if (x.text === "[") {
      if (this._flags.last_token.type === a.WORD || this._flags.last_token.text === ")") {
        f(this._flags.last_token, s) && (this._output.space_before_token = !0), this.print_token(x), this.set_mode(M), this.indent(), this._options.space_in_paren && (this._output.space_before_token = !0);
        return;
      }
      M = m.ArrayLiteral, _(this._flags.mode) && (this._flags.last_token.text === "[" || this._flags.last_token.text === "," && (this._last_last_text === "]" || this._last_last_text === "}")) && (this._options.keep_array_indentation || this.print_newline()), l(this._flags.last_token.type, [a.START_EXPR, a.END_EXPR, a.WORD, a.OPERATOR, a.DOT]) || (this._output.space_before_token = !0);
    } else {
      if (this._flags.last_token.type === a.RESERVED)
        this._flags.last_token.text === "for" ? (this._output.space_before_token = this._options.space_before_conditional, M = m.ForInitializer) : l(this._flags.last_token.text, ["if", "while", "switch"]) ? (this._output.space_before_token = this._options.space_before_conditional, M = m.Conditional) : l(this._flags.last_word, ["await", "async"]) ? this._output.space_before_token = !0 : this._flags.last_token.text === "import" && x.whitespace_before === "" ? this._output.space_before_token = !1 : (l(this._flags.last_token.text, s) || this._flags.last_token.text === "catch") && (this._output.space_before_token = !0);
      else if (this._flags.last_token.type === a.EQUALS || this._flags.last_token.type === a.OPERATOR)
        this.start_of_object_property() || this.allow_wrap_or_preserved_newline(x);
      else if (this._flags.last_token.type === a.WORD) {
        this._output.space_before_token = !1;
        var D = this._tokens.peek(-3);
        if (this._options.space_after_named_function && D) {
          var j = this._tokens.peek(-4);
          f(D, ["async", "function"]) || D.text === "*" && f(j, ["async", "function"]) ? this._output.space_before_token = !0 : this._flags.mode === m.ObjectLiteral ? (D.text === "{" || D.text === "," || D.text === "*" && (j.text === "{" || j.text === ",")) && (this._output.space_before_token = !0) : this._flags.parent && this._flags.parent.class_start_block && (this._output.space_before_token = !0);
        }
      } else
        this.allow_wrap_or_preserved_newline(x);
      (this._flags.last_token.type === a.RESERVED && (this._flags.last_word === "function" || this._flags.last_word === "typeof") || this._flags.last_token.text === "*" && (l(this._last_last_text, ["function", "yield"]) || this._flags.mode === m.ObjectLiteral && l(this._last_last_text, ["{", ","]))) && (this._output.space_before_token = this._options.space_after_anon_function);
    }
    this._flags.last_token.text === ";" || this._flags.last_token.type === a.START_BLOCK ? this.print_newline() : (this._flags.last_token.type === a.END_EXPR || this._flags.last_token.type === a.START_EXPR || this._flags.last_token.type === a.END_BLOCK || this._flags.last_token.text === "." || this._flags.last_token.type === a.COMMA) && this.allow_wrap_or_preserved_newline(x, x.newlines), this.print_token(x), this.set_mode(M), this._options.space_in_paren && (this._output.space_before_token = !0), this.indent();
  }, O.prototype.handle_end_expr = function(x) {
    for (; this._flags.mode === m.Statement; )
      this.restore_mode();
    this.handle_whitespace_and_comments(x), this._flags.multiline_frame && this.allow_wrap_or_preserved_newline(
      x,
      x.text === "]" && _(this._flags.mode) && !this._options.keep_array_indentation
    ), this._options.space_in_paren && (this._flags.last_token.type === a.START_EXPR && !this._options.space_in_empty_paren ? (this._output.trim(), this._output.space_before_token = !1) : this._output.space_before_token = !0), this.deindent(), this.print_token(x), this.restore_mode(), $(this._output, this._previous_flags), this._flags.do_while && this._previous_flags.mode === m.Conditional && (this._previous_flags.mode = m.Expression, this._flags.do_block = !1, this._flags.do_while = !1);
  }, O.prototype.handle_start_block = function(x) {
    this.handle_whitespace_and_comments(x);
    var M = this._tokens.peek(), D = this._tokens.peek(1);
    this._flags.last_word === "switch" && this._flags.last_token.type === a.END_EXPR ? (this.set_mode(m.BlockStatement), this._flags.in_case_statement = !0) : this._flags.case_body ? this.set_mode(m.BlockStatement) : D && (l(D.text, [":", ","]) && l(M.type, [a.STRING, a.WORD, a.RESERVED]) || l(M.text, ["get", "set", "..."]) && l(D.type, [a.WORD, a.RESERVED])) ? l(this._last_last_text, ["class", "interface"]) && !l(D.text, [":", ","]) ? this.set_mode(m.BlockStatement) : this.set_mode(m.ObjectLiteral) : this._flags.last_token.type === a.OPERATOR && this._flags.last_token.text === "=>" ? this.set_mode(m.BlockStatement) : l(this._flags.last_token.type, [a.EQUALS, a.START_EXPR, a.COMMA, a.OPERATOR]) || f(this._flags.last_token, ["return", "throw", "import", "default"]) ? this.set_mode(m.ObjectLiteral) : this.set_mode(m.BlockStatement), this._flags.last_token && f(this._flags.last_token.previous, ["class", "extends"]) && (this._flags.class_start_block = !0);
    var j = !M.comments_before && M.text === "}", U = j && this._flags.last_word === "function" && this._flags.last_token.type === a.END_EXPR;
    if (this._options.brace_preserve_inline) {
      var J = 0, ne = null;
      this._flags.inline_frame = !0;
      do
        if (J += 1, ne = this._tokens.peek(J - 1), ne.newlines) {
          this._flags.inline_frame = !1;
          break;
        }
      while (ne.type !== a.EOF && !(ne.type === a.END_BLOCK && ne.opened === x));
    }
    (this._options.brace_style === "expand" || this._options.brace_style === "none" && x.newlines) && !this._flags.inline_frame ? this._flags.last_token.type !== a.OPERATOR && (U || this._flags.last_token.type === a.EQUALS || f(this._flags.last_token, p) && this._flags.last_token.text !== "else") ? this._output.space_before_token = !0 : this.print_newline(!1, !0) : (_(this._previous_flags.mode) && (this._flags.last_token.type === a.START_EXPR || this._flags.last_token.type === a.COMMA) && ((this._flags.last_token.type === a.COMMA || this._options.space_in_paren) && (this._output.space_before_token = !0), (this._flags.last_token.type === a.COMMA || this._flags.last_token.type === a.START_EXPR && this._flags.inline_frame) && (this.allow_wrap_or_preserved_newline(x), this._previous_flags.multiline_frame = this._previous_flags.multiline_frame || this._flags.multiline_frame, this._flags.multiline_frame = !1)), this._flags.last_token.type !== a.OPERATOR && this._flags.last_token.type !== a.START_EXPR && (l(this._flags.last_token.type, [a.START_BLOCK, a.SEMICOLON]) && !this._flags.inline_frame ? this.print_newline() : this._output.space_before_token = !0)), this.print_token(x), this.indent(), !j && !(this._options.brace_preserve_inline && this._flags.inline_frame) && this.print_newline();
  }, O.prototype.handle_end_block = function(x) {
    for (this.handle_whitespace_and_comments(x); this._flags.mode === m.Statement; )
      this.restore_mode();
    var M = this._flags.last_token.type === a.START_BLOCK;
    this._flags.inline_frame && !M ? this._output.space_before_token = !0 : this._options.brace_style === "expand" ? M || this.print_newline() : M || (_(this._flags.mode) && this._options.keep_array_indentation ? (this._options.keep_array_indentation = !1, this.print_newline(), this._options.keep_array_indentation = !0) : this.print_newline()), this.restore_mode(), this.print_token(x);
  }, O.prototype.handle_word = function(x) {
    if (x.type === a.RESERVED) {
      if (l(x.text, ["set", "get"]) && this._flags.mode !== m.ObjectLiteral)
        x.type = a.WORD;
      else if (x.text === "import" && l(this._tokens.peek().text, ["(", "."]))
        x.type = a.WORD;
      else if (l(x.text, ["as", "from"]) && !this._flags.import_block)
        x.type = a.WORD;
      else if (this._flags.mode === m.ObjectLiteral) {
        var M = this._tokens.peek();
        M.text === ":" && (x.type = a.WORD);
      }
    }
    if (this.start_of_statement(x) ? f(this._flags.last_token, ["var", "let", "const"]) && x.type === a.WORD && (this._flags.declaration_statement = !0) : x.newlines && !L(this._flags.mode) && (this._flags.last_token.type !== a.OPERATOR || this._flags.last_token.text === "--" || this._flags.last_token.text === "++") && this._flags.last_token.type !== a.EQUALS && (this._options.preserve_newlines || !f(this._flags.last_token, ["var", "let", "const", "set", "get"])) ? (this.handle_whitespace_and_comments(x), this.print_newline()) : this.handle_whitespace_and_comments(x), this._flags.do_block && !this._flags.do_while)
      if (c(x, "while")) {
        this._output.space_before_token = !0, this.print_token(x), this._output.space_before_token = !0, this._flags.do_while = !0;
        return;
      } else
        this.print_newline(), this._flags.do_block = !1;
    if (this._flags.if_block)
      if (!this._flags.else_block && c(x, "else"))
        this._flags.else_block = !0;
      else {
        for (; this._flags.mode === m.Statement; )
          this.restore_mode();
        this._flags.if_block = !1, this._flags.else_block = !1;
      }
    if (this._flags.in_case_statement && f(x, ["case", "default"])) {
      this.print_newline(), !this._flags.case_block && (this._flags.case_body || this._options.jslint_happy) && this.deindent(), this._flags.case_body = !1, this.print_token(x), this._flags.in_case = !0;
      return;
    }
    if ((this._flags.last_token.type === a.COMMA || this._flags.last_token.type === a.START_EXPR || this._flags.last_token.type === a.EQUALS || this._flags.last_token.type === a.OPERATOR) && !this.start_of_object_property() && !// start of object property is different for numeric values with +/- prefix operators
    (l(this._flags.last_token.text, ["+", "-"]) && this._last_last_text === ":" && this._flags.parent.mode === m.ObjectLiteral) && this.allow_wrap_or_preserved_newline(x), c(x, "function")) {
      (l(this._flags.last_token.text, ["}", ";"]) || this._output.just_added_newline() && !(l(this._flags.last_token.text, ["(", "[", "{", ":", "=", ","]) || this._flags.last_token.type === a.OPERATOR)) && !this._output.just_added_blankline() && !x.comments_before && (this.print_newline(), this.print_newline(!0)), this._flags.last_token.type === a.RESERVED || this._flags.last_token.type === a.WORD ? f(this._flags.last_token, ["get", "set", "new", "export"]) || f(this._flags.last_token, I) ? this._output.space_before_token = !0 : c(this._flags.last_token, "default") && this._last_last_text === "export" ? this._output.space_before_token = !0 : this._flags.last_token.text === "declare" ? this._output.space_before_token = !0 : this.print_newline() : this._flags.last_token.type === a.OPERATOR || this._flags.last_token.text === "=" ? this._output.space_before_token = !0 : !this._flags.multiline_frame && (L(this._flags.mode) || _(this._flags.mode)) || this.print_newline(), this.print_token(x), this._flags.last_word = x.text;
      return;
    }
    var D = "NONE";
    if (this._flags.last_token.type === a.END_BLOCK ? this._previous_flags.inline_frame ? D = "SPACE" : f(x, ["else", "catch", "finally", "from"]) ? this._options.brace_style === "expand" || this._options.brace_style === "end-expand" || this._options.brace_style === "none" && x.newlines ? D = "NEWLINE" : (D = "SPACE", this._output.space_before_token = !0) : D = "NEWLINE" : this._flags.last_token.type === a.SEMICOLON && this._flags.mode === m.BlockStatement ? D = "NEWLINE" : this._flags.last_token.type === a.SEMICOLON && L(this._flags.mode) ? D = "SPACE" : this._flags.last_token.type === a.STRING ? D = "NEWLINE" : this._flags.last_token.type === a.RESERVED || this._flags.last_token.type === a.WORD || this._flags.last_token.text === "*" && (l(this._last_last_text, ["function", "yield"]) || this._flags.mode === m.ObjectLiteral && l(this._last_last_text, ["{", ","])) ? D = "SPACE" : this._flags.last_token.type === a.START_BLOCK ? this._flags.inline_frame ? D = "SPACE" : D = "NEWLINE" : this._flags.last_token.type === a.END_EXPR && (this._output.space_before_token = !0, D = "NEWLINE"), f(x, s) && this._flags.last_token.text !== ")" && (this._flags.inline_frame || this._flags.last_token.text === "else" || this._flags.last_token.text === "export" ? D = "SPACE" : D = "NEWLINE"), f(x, ["else", "catch", "finally"]))
      if ((!(this._flags.last_token.type === a.END_BLOCK && this._previous_flags.mode === m.BlockStatement) || this._options.brace_style === "expand" || this._options.brace_style === "end-expand" || this._options.brace_style === "none" && x.newlines) && !this._flags.inline_frame)
        this.print_newline();
      else {
        this._output.trim(!0);
        var j = this._output.current_line;
        j.last() !== "}" && this.print_newline(), this._output.space_before_token = !0;
      }
    else D === "NEWLINE" ? f(this._flags.last_token, p) ? this._output.space_before_token = !0 : this._flags.last_token.text === "declare" && f(x, ["var", "let", "const"]) ? this._output.space_before_token = !0 : this._flags.last_token.type !== a.END_EXPR ? (this._flags.last_token.type !== a.START_EXPR || !f(x, ["var", "let", "const"])) && this._flags.last_token.text !== ":" && (c(x, "if") && c(x.previous, "else") ? this._output.space_before_token = !0 : this.print_newline()) : f(x, s) && this._flags.last_token.text !== ")" && this.print_newline() : this._flags.multiline_frame && _(this._flags.mode) && this._flags.last_token.text === "," && this._last_last_text === "}" ? this.print_newline() : D === "SPACE" && (this._output.space_before_token = !0);
    x.previous && (x.previous.type === a.WORD || x.previous.type === a.RESERVED) && (this._output.space_before_token = !0), this.print_token(x), this._flags.last_word = x.text, x.type === a.RESERVED && (x.text === "do" ? this._flags.do_block = !0 : x.text === "if" ? this._flags.if_block = !0 : x.text === "import" ? this._flags.import_block = !0 : this._flags.import_block && c(x, "from") && (this._flags.import_block = !1));
  }, O.prototype.handle_semicolon = function(x) {
    this.start_of_statement(x) ? this._output.space_before_token = !1 : this.handle_whitespace_and_comments(x);
    for (var M = this._tokens.peek(); this._flags.mode === m.Statement && !(this._flags.if_block && c(M, "else")) && !this._flags.do_block; )
      this.restore_mode();
    this._flags.import_block && (this._flags.import_block = !1), this.print_token(x);
  }, O.prototype.handle_string = function(x) {
    x.text.startsWith("`") && x.newlines === 0 && x.whitespace_before === "" && (x.previous.text === ")" || this._flags.last_token.type === a.WORD) || (this.start_of_statement(x) ? this._output.space_before_token = !0 : (this.handle_whitespace_and_comments(x), this._flags.last_token.type === a.RESERVED || this._flags.last_token.type === a.WORD || this._flags.inline_frame ? this._output.space_before_token = !0 : this._flags.last_token.type === a.COMMA || this._flags.last_token.type === a.START_EXPR || this._flags.last_token.type === a.EQUALS || this._flags.last_token.type === a.OPERATOR ? this.start_of_object_property() || this.allow_wrap_or_preserved_newline(x) : x.text.startsWith("`") && this._flags.last_token.type === a.END_EXPR && (x.previous.text === "]" || x.previous.text === ")") && x.newlines === 0 ? this._output.space_before_token = !0 : this.print_newline())), this.print_token(x);
  }, O.prototype.handle_equals = function(x) {
    this.start_of_statement(x) || this.handle_whitespace_and_comments(x), this._flags.declaration_statement && (this._flags.declaration_assignment = !0), this._output.space_before_token = !0, this.print_token(x), this._output.space_before_token = !0;
  }, O.prototype.handle_comma = function(x) {
    this.handle_whitespace_and_comments(x, !0), this.print_token(x), this._output.space_before_token = !0, this._flags.declaration_statement ? (L(this._flags.parent.mode) && (this._flags.declaration_assignment = !1), this._flags.declaration_assignment ? (this._flags.declaration_assignment = !1, this.print_newline(!1, !0)) : this._options.comma_first && this.allow_wrap_or_preserved_newline(x)) : this._flags.mode === m.ObjectLiteral || this._flags.mode === m.Statement && this._flags.parent.mode === m.ObjectLiteral ? (this._flags.mode === m.Statement && this.restore_mode(), this._flags.inline_frame || this.print_newline()) : this._options.comma_first && this.allow_wrap_or_preserved_newline(x);
  }, O.prototype.handle_operator = function(x) {
    var M = x.text === "*" && (f(this._flags.last_token, ["function", "yield"]) || l(this._flags.last_token.type, [a.START_BLOCK, a.COMMA, a.END_BLOCK, a.SEMICOLON])), D = l(x.text, ["-", "+"]) && (l(this._flags.last_token.type, [a.START_BLOCK, a.START_EXPR, a.EQUALS, a.OPERATOR]) || l(this._flags.last_token.text, s) || this._flags.last_token.text === ",");
    if (!this.start_of_statement(x)) {
      var j = !M;
      this.handle_whitespace_and_comments(x, j);
    }
    if (x.text === "*" && this._flags.last_token.type === a.DOT) {
      this.print_token(x);
      return;
    }
    if (x.text === "::") {
      this.print_token(x);
      return;
    }
    if (l(x.text, ["-", "+"]) && this.start_of_object_property()) {
      this.print_token(x);
      return;
    }
    if (this._flags.last_token.type === a.OPERATOR && l(this._options.operator_position, g) && this.allow_wrap_or_preserved_newline(x), x.text === ":" && this._flags.in_case) {
      this.print_token(x), this._flags.in_case = !1, this._flags.case_body = !0, this._tokens.peek().type !== a.START_BLOCK ? (this.indent(), this.print_newline(), this._flags.case_block = !1) : (this._flags.case_block = !0, this._output.space_before_token = !0);
      return;
    }
    var U = !0, J = !0, ne = !1;
    if (x.text === ":" ? this._flags.ternary_depth === 0 ? U = !1 : (this._flags.ternary_depth -= 1, ne = !0) : x.text === "?" && (this._flags.ternary_depth += 1), !D && !M && this._options.preserve_newlines && l(x.text, o)) {
      var Y = x.text === ":", oe = Y && ne, le = Y && !ne;
      switch (this._options.operator_position) {
        case y.before_newline:
          this._output.space_before_token = !le, this.print_token(x), (!Y || oe) && this.allow_wrap_or_preserved_newline(x), this._output.space_before_token = !0;
          return;
        case y.after_newline:
          this._output.space_before_token = !0, !Y || oe ? this._tokens.peek().newlines ? this.print_newline(!1, !0) : this.allow_wrap_or_preserved_newline(x) : this._output.space_before_token = !1, this.print_token(x), this._output.space_before_token = !0;
          return;
        case y.preserve_newline:
          le || this.allow_wrap_or_preserved_newline(x), U = !(this._output.just_added_newline() || le), this._output.space_before_token = U, this.print_token(x), this._output.space_before_token = !0;
          return;
      }
    }
    if (M) {
      this.allow_wrap_or_preserved_newline(x), U = !1;
      var ge = this._tokens.peek();
      J = ge && l(ge.type, [a.WORD, a.RESERVED]);
    } else if (x.text === "...")
      this.allow_wrap_or_preserved_newline(x), U = this._flags.last_token.type === a.START_BLOCK, J = !1;
    else if (l(x.text, ["--", "++", "!", "~"]) || D) {
      if ((this._flags.last_token.type === a.COMMA || this._flags.last_token.type === a.START_EXPR) && this.allow_wrap_or_preserved_newline(x), U = !1, J = !1, x.newlines && (x.text === "--" || x.text === "++" || x.text === "~")) {
        var he = f(this._flags.last_token, p) && x.newlines;
        he && (this._previous_flags.if_block || this._previous_flags.else_block) && this.restore_mode(), this.print_newline(he, !0);
      }
      this._flags.last_token.text === ";" && L(this._flags.mode) && (U = !0), this._flags.last_token.type === a.RESERVED ? U = !0 : this._flags.last_token.type === a.END_EXPR ? U = !(this._flags.last_token.text === "]" && (x.text === "--" || x.text === "++")) : this._flags.last_token.type === a.OPERATOR && (U = l(x.text, ["--", "-", "++", "+"]) && l(this._flags.last_token.text, ["--", "-", "++", "+"]), l(x.text, ["+", "-"]) && l(this._flags.last_token.text, ["--", "++"]) && (J = !0)), (this._flags.mode === m.BlockStatement && !this._flags.inline_frame || this._flags.mode === m.Statement) && (this._flags.last_token.text === "{" || this._flags.last_token.text === ";") && this.print_newline();
    }
    this._output.space_before_token = this._output.space_before_token || U, this.print_token(x), this._output.space_before_token = J;
  }, O.prototype.handle_block_comment = function(x, M) {
    if (this._output.raw) {
      this._output.add_raw_token(x), x.directives && x.directives.preserve === "end" && (this._output.raw = this._options.test_output_raw);
      return;
    }
    if (x.directives) {
      this.print_newline(!1, M), this.print_token(x), x.directives.preserve === "start" && (this._output.raw = !0), this.print_newline(!1, !0);
      return;
    }
    if (!t.newline.test(x.text) && !x.newlines) {
      this._output.space_before_token = !0, this.print_token(x), this._output.space_before_token = !0;
      return;
    } else
      this.print_block_commment(x, M);
  }, O.prototype.print_block_commment = function(x, M) {
    var D = w(x.text), j, U = !1, J = !1, ne = x.whitespace_before, Y = ne.length;
    if (this.print_newline(!1, M), this.print_token_line_indentation(x), this._output.add_token(D[0]), this.print_newline(!1, M), D.length > 1) {
      for (D = D.slice(1), U = S(D, "*"), J = R(D, ne), U && (this._flags.alignment = 1), j = 0; j < D.length; j++)
        U ? (this.print_token_line_indentation(x), this._output.add_token(u(D[j]))) : J && D[j] ? (this.print_token_line_indentation(x), this._output.add_token(D[j].substring(Y))) : (this._output.current_line.set_indent(-1), this._output.add_token(D[j])), this.print_newline(!1, M);
      this._flags.alignment = 0;
    }
  }, O.prototype.handle_comment = function(x, M) {
    x.newlines ? this.print_newline(!1, M) : this._output.trim(!0), this._output.space_before_token = !0, this.print_token(x), this.print_newline(!1, M);
  }, O.prototype.handle_dot = function(x) {
    this.start_of_statement(x) || this.handle_whitespace_and_comments(x, !0), this._flags.last_token.text.match("^[0-9]+$") && (this._output.space_before_token = !0), f(this._flags.last_token, p) ? this._output.space_before_token = !1 : this.allow_wrap_or_preserved_newline(
      x,
      this._flags.last_token.text === ")" && this._options.break_chained_methods
    ), this._options.unindent_chained_methods && this._output.just_added_newline() && this.deindent(), this.print_token(x);
  }, O.prototype.handle_unknown = function(x, M) {
    this.print_token(x), x.text[x.text.length - 1] === `
` && this.print_newline(!1, M);
  }, O.prototype.handle_eof = function(x) {
    for (; this._flags.mode === m.Statement; )
      this.restore_mode();
    this.handle_whitespace_and_comments(x);
  }, Fu.Beautifier = O, Fu;
}
var g2;
function MT() {
  if (g2) return aa.exports;
  g2 = 1;
  var n = OT().Beautifier, e = X3().Options;
  function t(r, i) {
    var s = new n(r, i);
    return s.beautify();
  }
  return aa.exports = t, aa.exports.defaultOptions = function() {
    return new e();
  }, aa.exports;
}
var da = { exports: {} }, Xu = {}, Qu = {}, b2;
function e4() {
  if (b2) return Qu;
  b2 = 1;
  var n = p0().Options;
  function e(t) {
    n.call(this, t, "css"), this.selector_separator_newline = this._get_boolean("selector_separator_newline", !0), this.newline_between_rules = this._get_boolean("newline_between_rules", !0);
    var r = this._get_boolean("space_around_selector_separator");
    this.space_around_combinator = this._get_boolean("space_around_combinator") || r;
    var i = this._get_selection_list("brace_style", ["collapse", "expand", "end-expand", "none", "preserve-inline"]);
    this.brace_style = "collapse";
    for (var s = 0; s < i.length; s++)
      i[s] !== "expand" ? this.brace_style = "collapse" : this.brace_style = i[s];
  }
  return e.prototype = new n(), Qu.Options = e, Qu;
}
var y2;
function AT() {
  if (y2) return Xu;
  y2 = 1;
  var n = e4().Options, e = f0().Output, t = h0().InputScanner, r = m0().Directives, i = new r(/\/\*/, /\*\//), s = /\r\n|[\r\n]/, o = /\r\n|[\r\n]/g, a = /\s/, l = /(?:\s|\n)+/g, u = /\/\*(?:[\s\S]*?)((?:\*\/)|$)/g, d = /\/\/(?:[^\n\r\u2028\u2029]*)/g;
  function c(f, p) {
    this._source_text = f || "", this._options = new n(p), this._ch = null, this._input = null, this.NESTED_AT_RULE = {
      page: !0,
      "font-face": !0,
      keyframes: !0,
      // also in CONDITIONAL_GROUP_RULE below
      media: !0,
      supports: !0,
      document: !0
    }, this.CONDITIONAL_GROUP_RULE = {
      media: !0,
      supports: !0,
      document: !0
    }, this.NON_SEMICOLON_NEWLINE_PROPERTY = [
      "grid-template-areas",
      "grid-template"
    ];
  }
  return c.prototype.eatString = function(f) {
    var p = "";
    for (this._ch = this._input.next(); this._ch; ) {
      if (p += this._ch, this._ch === "\\")
        p += this._input.next();
      else if (f.indexOf(this._ch) !== -1 || this._ch === `
`)
        break;
      this._ch = this._input.next();
    }
    return p;
  }, c.prototype.eatWhitespace = function(f) {
    for (var p = a.test(this._input.peek()), h = 0; a.test(this._input.peek()); )
      this._ch = this._input.next(), f && this._ch === `
` && (h === 0 || h < this._options.max_preserve_newlines) && (h++, this._output.add_new_line(!0));
    return p;
  }, c.prototype.foundNestedPseudoClass = function() {
    for (var f = 0, p = 1, h = this._input.peek(p); h; ) {
      if (h === "{")
        return !0;
      if (h === "(")
        f += 1;
      else if (h === ")") {
        if (f === 0)
          return !1;
        f -= 1;
      } else if (h === ";" || h === "}")
        return !1;
      p++, h = this._input.peek(p);
    }
    return !1;
  }, c.prototype.print_string = function(f) {
    this._output.set_indent(this._indentLevel), this._output.non_breaking_space = !0, this._output.add_token(f);
  }, c.prototype.preserveSingleSpace = function(f) {
    f && (this._output.space_before_token = !0);
  }, c.prototype.indent = function() {
    this._indentLevel++;
  }, c.prototype.outdent = function() {
    this._indentLevel > 0 && this._indentLevel--;
  }, c.prototype.beautify = function() {
    if (this._options.disabled)
      return this._source_text;
    var f = this._source_text, p = this._options.eol;
    p === "auto" && (p = `
`, f && s.test(f || "") && (p = f.match(s)[0])), f = f.replace(o, `
`);
    var h = f.match(/^[\t ]*/)[0];
    this._output = new e(this._options, h), this._input = new t(f), this._indentLevel = 0, this._nestedLevel = 0, this._ch = null;
    for (var y = 0, g = !1, m = !1, $ = !1, w = !1, _ = !1, L = this._ch, S = !1, R, O, I; R = this._input.read(l), O = R !== "", I = L, this._ch = this._input.next(), this._ch === "\\" && this._input.hasNext() && (this._ch += this._input.next()), L = this._ch, this._ch; )
      if (this._ch === "/" && this._input.peek() === "*") {
        this._output.add_new_line(), this._input.back();
        var x = this._input.read(u), M = i.get_directives(x);
        M && M.ignore === "start" && (x += i.readIgnored(this._input)), this.print_string(x), this.eatWhitespace(!0), this._output.add_new_line();
      } else if (this._ch === "/" && this._input.peek() === "/")
        this._output.space_before_token = !0, this._input.back(), this.print_string(this._input.read(d)), this.eatWhitespace(!0);
      else if (this._ch === "$") {
        this.preserveSingleSpace(O), this.print_string(this._ch);
        var D = this._input.peekUntilAfter(/[: ,;{}()[\]\/='"]/g);
        D.match(/[ :]$/) && (D = this.eatString(": ").replace(/\s+$/, ""), this.print_string(D), this._output.space_before_token = !0), y === 0 && D.indexOf(":") !== -1 && (m = !0, this.indent());
      } else if (this._ch === "@")
        if (this.preserveSingleSpace(O), this._input.peek() === "{")
          this.print_string(this._ch + this.eatString("}"));
        else {
          this.print_string(this._ch);
          var j = this._input.peekUntilAfter(/[: ,;{}()[\]\/='"]/g);
          j.match(/[ :]$/) && (j = this.eatString(": ").replace(/\s+$/, ""), this.print_string(j), this._output.space_before_token = !0), y === 0 && j.indexOf(":") !== -1 ? (m = !0, this.indent()) : j in this.NESTED_AT_RULE ? (this._nestedLevel += 1, j in this.CONDITIONAL_GROUP_RULE && ($ = !0)) : y === 0 && !m && (w = !0);
        }
      else if (this._ch === "#" && this._input.peek() === "{")
        this.preserveSingleSpace(O), this.print_string(this._ch + this.eatString("}"));
      else if (this._ch === "{")
        m && (m = !1, this.outdent()), w = !1, $ ? ($ = !1, g = this._indentLevel >= this._nestedLevel) : g = this._indentLevel >= this._nestedLevel - 1, this._options.newline_between_rules && g && this._output.previous_line && this._output.previous_line.item(-1) !== "{" && this._output.ensure_empty_line_above("/", ","), this._output.space_before_token = !0, this._options.brace_style === "expand" ? (this._output.add_new_line(), this.print_string(this._ch), this.indent(), this._output.set_indent(this._indentLevel)) : (I === "(" ? this._output.space_before_token = !1 : I !== "," && this.indent(), this.print_string(this._ch)), this.eatWhitespace(!0), this._output.add_new_line();
      else if (this._ch === "}")
        this.outdent(), this._output.add_new_line(), I === "{" && this._output.trim(!0), m && (this.outdent(), m = !1), this.print_string(this._ch), g = !1, this._nestedLevel && this._nestedLevel--, this.eatWhitespace(!0), this._output.add_new_line(), this._options.newline_between_rules && !this._output.just_added_blankline() && this._input.peek() !== "}" && this._output.add_new_line(!0), this._input.peek() === ")" && (this._output.trim(!0), this._options.brace_style === "expand" && this._output.add_new_line(!0));
      else if (this._ch === ":") {
        for (var U = 0; U < this.NON_SEMICOLON_NEWLINE_PROPERTY.length; U++)
          if (this._input.lookBack(this.NON_SEMICOLON_NEWLINE_PROPERTY[U])) {
            S = !0;
            break;
          }
        (g || $) && !(this._input.lookBack("&") || this.foundNestedPseudoClass()) && !this._input.lookBack("(") && !w && y === 0 ? (this.print_string(":"), m || (m = !0, this._output.space_before_token = !0, this.eatWhitespace(!0), this.indent())) : (this._input.lookBack(" ") && (this._output.space_before_token = !0), this._input.peek() === ":" ? (this._ch = this._input.next(), this.print_string("::")) : this.print_string(":"));
      } else if (this._ch === '"' || this._ch === "'") {
        var J = I === '"' || I === "'";
        this.preserveSingleSpace(J || O), this.print_string(this._ch + this.eatString(this._ch)), this.eatWhitespace(!0);
      } else if (this._ch === ";")
        S = !1, y === 0 ? (m && (this.outdent(), m = !1), w = !1, this.print_string(this._ch), this.eatWhitespace(!0), this._input.peek() !== "/" && this._output.add_new_line()) : (this.print_string(this._ch), this.eatWhitespace(!0), this._output.space_before_token = !0);
      else if (this._ch === "(")
        if (this._input.lookBack("url"))
          this.print_string(this._ch), this.eatWhitespace(), y++, this.indent(), this._ch = this._input.next(), this._ch === ")" || this._ch === '"' || this._ch === "'" ? this._input.back() : this._ch && (this.print_string(this._ch + this.eatString(")")), y && (y--, this.outdent()));
        else {
          var ne = !1;
          this._input.lookBack("with") && (ne = !0), this.preserveSingleSpace(O || ne), this.print_string(this._ch), m && I === "$" && this._options.selector_separator_newline ? (this._output.add_new_line(), _ = !0) : (this.eatWhitespace(), y++, this.indent());
        }
      else if (this._ch === ")")
        y && (y--, this.outdent()), _ && this._input.peek() === ";" && this._options.selector_separator_newline && (_ = !1, this.outdent(), this._output.add_new_line()), this.print_string(this._ch);
      else if (this._ch === ",")
        this.print_string(this._ch), this.eatWhitespace(!0), this._options.selector_separator_newline && (!m || _) && y === 0 && !w ? this._output.add_new_line() : this._output.space_before_token = !0;
      else if ((this._ch === ">" || this._ch === "+" || this._ch === "~") && !m && y === 0)
        this._options.space_around_combinator ? (this._output.space_before_token = !0, this.print_string(this._ch), this._output.space_before_token = !0) : (this.print_string(this._ch), this.eatWhitespace(), this._ch && a.test(this._ch) && (this._ch = ""));
      else if (this._ch === "]")
        this.print_string(this._ch);
      else if (this._ch === "[")
        this.preserveSingleSpace(O), this.print_string(this._ch);
      else if (this._ch === "=")
        this.eatWhitespace(), this.print_string("="), a.test(this._ch) && (this._ch = "");
      else if (this._ch === "!" && !this._input.lookBack("\\"))
        this._output.space_before_token = !0, this.print_string(this._ch);
      else {
        var Y = I === '"' || I === "'";
        this.preserveSingleSpace(Y || O), this.print_string(this._ch), !this._output.just_added_newline() && this._input.peek() === `
` && S && this._output.add_new_line();
      }
    var oe = this._output.get_code(p);
    return oe;
  }, Xu.Beautifier = c, Xu;
}
var v2;
function NT() {
  if (v2) return da.exports;
  v2 = 1;
  var n = AT().Beautifier, e = e4().Options;
  function t(r, i) {
    var s = new n(r, i);
    return s.beautify();
  }
  return da.exports = t, da.exports.defaultOptions = function() {
    return new e();
  }, da.exports;
}
var ca = { exports: {} }, ed = {}, td = {}, _2;
function t4() {
  if (_2) return td;
  _2 = 1;
  var n = p0().Options;
  function e(t) {
    n.call(this, t, "html"), this.templating.length === 1 && this.templating[0] === "auto" && (this.templating = ["django", "erb", "handlebars", "php"]), this.indent_inner_html = this._get_boolean("indent_inner_html"), this.indent_body_inner_html = this._get_boolean("indent_body_inner_html", !0), this.indent_head_inner_html = this._get_boolean("indent_head_inner_html", !0), this.indent_handlebars = this._get_boolean("indent_handlebars", !0), this.wrap_attributes = this._get_selection(
      "wrap_attributes",
      ["auto", "force", "force-aligned", "force-expand-multiline", "aligned-multiple", "preserve", "preserve-aligned"]
    ), this.wrap_attributes_min_attrs = this._get_number("wrap_attributes_min_attrs", 2), this.wrap_attributes_indent_size = this._get_number("wrap_attributes_indent_size", this.indent_size), this.extra_liners = this._get_array("extra_liners", ["head", "body", "/html"]), this.inline = this._get_array("inline", [
      "a",
      "abbr",
      "area",
      "audio",
      "b",
      "bdi",
      "bdo",
      "br",
      "button",
      "canvas",
      "cite",
      "code",
      "data",
      "datalist",
      "del",
      "dfn",
      "em",
      "embed",
      "i",
      "iframe",
      "img",
      "input",
      "ins",
      "kbd",
      "keygen",
      "label",
      "map",
      "mark",
      "math",
      "meter",
      "noscript",
      "object",
      "output",
      "progress",
      "q",
      "ruby",
      "s",
      "samp",
      /* 'script', */
      "select",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "svg",
      "template",
      "textarea",
      "time",
      "u",
      "var",
      "video",
      "wbr",
      "text",
      // obsolete inline tags
      "acronym",
      "big",
      "strike",
      "tt"
    ]), this.inline_custom_elements = this._get_boolean("inline_custom_elements", !0), this.void_elements = this._get_array("void_elements", [
      // HTLM void elements - aka self-closing tags - aka singletons
      // https://www.w3.org/html/wg/drafts/html/master/syntax.html#void-elements
      "area",
      "base",
      "br",
      "col",
      "embed",
      "hr",
      "img",
      "input",
      "keygen",
      "link",
      "menuitem",
      "meta",
      "param",
      "source",
      "track",
      "wbr",
      // NOTE: Optional tags are too complex for a simple list
      // they are hard coded in _do_optional_end_element
      // Doctype and xml elements
      "!doctype",
      "?xml",
      // obsolete tags
      // basefont: https://www.computerhope.com/jargon/h/html-basefont-tag.htm
      // isndex: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/isindex
      "basefont",
      "isindex"
    ]), this.unformatted = this._get_array("unformatted", []), this.content_unformatted = this._get_array("content_unformatted", [
      "pre",
      "textarea"
    ]), this.unformatted_content_delimiter = this._get_characters("unformatted_content_delimiter"), this.indent_scripts = this._get_selection("indent_scripts", ["normal", "keep", "separate"]);
  }
  return e.prototype = new n(), td.Options = e, td;
}
var fa = {}, $2;
function x2() {
  if ($2) return fa;
  $2 = 1;
  var n = yl().Tokenizer, e = yl().TOKEN, t = m0().Directives, r = Q3().TemplatablePattern, i = Ul().Pattern, s = {
    TAG_OPEN: "TK_TAG_OPEN",
    TAG_CLOSE: "TK_TAG_CLOSE",
    CONTROL_FLOW_OPEN: "TK_CONTROL_FLOW_OPEN",
    CONTROL_FLOW_CLOSE: "TK_CONTROL_FLOW_CLOSE",
    ATTRIBUTE: "TK_ATTRIBUTE",
    EQUALS: "TK_EQUALS",
    VALUE: "TK_VALUE",
    COMMENT: "TK_COMMENT",
    TEXT: "TK_TEXT",
    UNKNOWN: "TK_UNKNOWN",
    START: e.START,
    RAW: e.RAW,
    EOF: e.EOF
  }, o = new t(/<\!--/, /-->/), a = function(l, u) {
    n.call(this, l, u), this._current_tag_name = "";
    var d = new r(this._input).read_options(this._options), c = new i(this._input);
    if (this.__patterns = {
      word: d.until(/[\n\r\t <]/),
      word_control_flow_close_excluded: d.until(/[\n\r\t <}]/),
      single_quote: d.until_after(/'/),
      double_quote: d.until_after(/"/),
      attribute: d.until(/[\n\r\t =>]|\/>/),
      element_name: d.until(/[\n\r\t >\/]/),
      angular_control_flow_start: c.matching(/\@[a-zA-Z]+[^({]*[({]/),
      handlebars_comment: c.starting_with(/{{!--/).until_after(/--}}/),
      handlebars: c.starting_with(/{{/).until_after(/}}/),
      handlebars_open: c.until(/[\n\r\t }]/),
      handlebars_raw_close: c.until(/}}/),
      comment: c.starting_with(/<!--/).until_after(/-->/),
      cdata: c.starting_with(/<!\[CDATA\[/).until_after(/]]>/),
      // https://en.wikipedia.org/wiki/Conditional_comment
      conditional_comment: c.starting_with(/<!\[/).until_after(/]>/),
      processing: c.starting_with(/<\?/).until_after(/\?>/)
    }, this._options.indent_handlebars && (this.__patterns.word = this.__patterns.word.exclude("handlebars"), this.__patterns.word_control_flow_close_excluded = this.__patterns.word_control_flow_close_excluded.exclude("handlebars")), this._unformatted_content_delimiter = null, this._options.unformatted_content_delimiter) {
      var f = this._input.get_literal_regexp(this._options.unformatted_content_delimiter);
      this.__patterns.unformatted_content_delimiter = c.matching(f).until_after(f);
    }
  };
  return a.prototype = new n(), a.prototype._is_comment = function(l) {
    return !1;
  }, a.prototype._is_opening = function(l) {
    return l.type === s.TAG_OPEN || l.type === s.CONTROL_FLOW_OPEN;
  }, a.prototype._is_closing = function(l, u) {
    return l.type === s.TAG_CLOSE && u && ((l.text === ">" || l.text === "/>") && u.text[0] === "<" || l.text === "}}" && u.text[0] === "{" && u.text[1] === "{") || l.type === s.CONTROL_FLOW_CLOSE && l.text === "}" && u.text.endsWith("{");
  }, a.prototype._reset = function() {
    this._current_tag_name = "";
  }, a.prototype._get_next_token = function(l, u) {
    var d = null;
    this._readWhitespace();
    var c = this._input.peek();
    return c === null ? this._create_token(s.EOF, "") : (d = d || this._read_open_handlebars(c, u), d = d || this._read_attribute(c, l, u), d = d || this._read_close(c, u), d = d || this._read_script_and_style(c, l), d = d || this._read_control_flows(c, u), d = d || this._read_raw_content(c, l, u), d = d || this._read_content_word(c, u), d = d || this._read_comment_or_cdata(c), d = d || this._read_processing(c), d = d || this._read_open(c, u), d = d || this._create_token(s.UNKNOWN, this._input.next()), d);
  }, a.prototype._read_comment_or_cdata = function(l) {
    var u = null, d = null, c = null;
    if (l === "<") {
      var f = this._input.peek(1);
      f === "!" && (d = this.__patterns.comment.read(), d ? (c = o.get_directives(d), c && c.ignore === "start" && (d += o.readIgnored(this._input))) : d = this.__patterns.cdata.read()), d && (u = this._create_token(s.COMMENT, d), u.directives = c);
    }
    return u;
  }, a.prototype._read_processing = function(l) {
    var u = null, d = null, c = null;
    if (l === "<") {
      var f = this._input.peek(1);
      (f === "!" || f === "?") && (d = this.__patterns.conditional_comment.read(), d = d || this.__patterns.processing.read()), d && (u = this._create_token(s.COMMENT, d), u.directives = c);
    }
    return u;
  }, a.prototype._read_open = function(l, u) {
    var d = null, c = null;
    return (!u || u.type === s.CONTROL_FLOW_OPEN) && l === "<" && (d = this._input.next(), this._input.peek() === "/" && (d += this._input.next()), d += this.__patterns.element_name.read(), c = this._create_token(s.TAG_OPEN, d)), c;
  }, a.prototype._read_open_handlebars = function(l, u) {
    var d = null, c = null;
    return (!u || u.type === s.CONTROL_FLOW_OPEN) && (this._options.templating.includes("angular") || this._options.indent_handlebars) && l === "{" && this._input.peek(1) === "{" && (this._options.indent_handlebars && this._input.peek(2) === "!" ? (d = this.__patterns.handlebars_comment.read(), d = d || this.__patterns.handlebars.read(), c = this._create_token(s.COMMENT, d)) : (d = this.__patterns.handlebars_open.read(), c = this._create_token(s.TAG_OPEN, d))), c;
  }, a.prototype._read_control_flows = function(l, u) {
    var d = "", c = null;
    if (!this._options.templating.includes("angular"))
      return c;
    if (l === "@") {
      if (d = this.__patterns.angular_control_flow_start.read(), d === "")
        return c;
      for (var f = d.endsWith("(") ? 1 : 0, p = 0; !(d.endsWith("{") && f === p); ) {
        var h = this._input.next();
        if (h === null)
          break;
        h === "(" ? f++ : h === ")" && p++, d += h;
      }
      c = this._create_token(s.CONTROL_FLOW_OPEN, d);
    } else l === "}" && u && u.type === s.CONTROL_FLOW_OPEN && (d = this._input.next(), c = this._create_token(s.CONTROL_FLOW_CLOSE, d));
    return c;
  }, a.prototype._read_close = function(l, u) {
    var d = null, c = null;
    return u && u.type === s.TAG_OPEN && (u.text[0] === "<" && (l === ">" || l === "/" && this._input.peek(1) === ">") ? (d = this._input.next(), l === "/" && (d += this._input.next()), c = this._create_token(s.TAG_CLOSE, d)) : u.text[0] === "{" && l === "}" && this._input.peek(1) === "}" && (this._input.next(), this._input.next(), c = this._create_token(s.TAG_CLOSE, "}}"))), c;
  }, a.prototype._read_attribute = function(l, u, d) {
    var c = null, f = "";
    if (d && d.text[0] === "<")
      if (l === "=")
        c = this._create_token(s.EQUALS, this._input.next());
      else if (l === '"' || l === "'") {
        var p = this._input.next();
        l === '"' ? p += this.__patterns.double_quote.read() : p += this.__patterns.single_quote.read(), c = this._create_token(s.VALUE, p);
      } else
        f = this.__patterns.attribute.read(), f && (u.type === s.EQUALS ? c = this._create_token(s.VALUE, f) : c = this._create_token(s.ATTRIBUTE, f));
    return c;
  }, a.prototype._is_content_unformatted = function(l) {
    return this._options.void_elements.indexOf(l) === -1 && (this._options.content_unformatted.indexOf(l) !== -1 || this._options.unformatted.indexOf(l) !== -1);
  }, a.prototype._read_raw_content = function(l, u, d) {
    var c = "";
    if (d && d.text[0] === "{")
      c = this.__patterns.handlebars_raw_close.read();
    else if (u.type === s.TAG_CLOSE && u.opened.text[0] === "<" && u.text[0] !== "/") {
      var f = u.opened.text.substr(1).toLowerCase();
      this._is_content_unformatted(f) && (c = this._input.readUntil(new RegExp("</" + f + "[\\n\\r\\t ]*?>", "ig")));
    }
    return c ? this._create_token(s.TEXT, c) : null;
  }, a.prototype._read_script_and_style = function(l, u) {
    if (u.type === s.TAG_CLOSE && u.opened.text[0] === "<" && u.text[0] !== "/") {
      var d = u.opened.text.substr(1).toLowerCase();
      if (d === "script" || d === "style") {
        var c = this._read_comment_or_cdata(l);
        if (c)
          return c.type = s.TEXT, c;
        var f = this._input.readUntil(new RegExp("</" + d + "[\\n\\r\\t ]*?>", "ig"));
        if (f)
          return this._create_token(s.TEXT, f);
      }
    }
    return null;
  }, a.prototype._read_content_word = function(l, u) {
    var d = "";
    return this._options.unformatted_content_delimiter && l === this._options.unformatted_content_delimiter[0] && (d = this.__patterns.unformatted_content_delimiter.read()), d || (d = u && u.type === s.CONTROL_FLOW_OPEN ? this.__patterns.word_control_flow_close_excluded.read() : this.__patterns.word.read()), d ? this._create_token(s.TEXT, d) : null;
  }, fa.Tokenizer = a, fa.TOKEN = s, fa;
}
var w2;
function DT() {
  if (w2) return ed;
  w2 = 1;
  var n = t4().Options, e = f0().Output, t = x2().Tokenizer, r = x2().TOKEN, i = /\r\n|[\r\n]/, s = /\r\n|[\r\n]/g, o = function(g, m) {
    this.indent_level = 0, this.alignment_size = 0, this.max_preserve_newlines = g.max_preserve_newlines, this.preserve_newlines = g.preserve_newlines, this._output = new e(g, m);
  };
  o.prototype.current_line_has_match = function(g) {
    return this._output.current_line.has_match(g);
  }, o.prototype.set_space_before_token = function(g, m) {
    this._output.space_before_token = g, this._output.non_breaking_space = m;
  }, o.prototype.set_wrap_point = function() {
    this._output.set_indent(this.indent_level, this.alignment_size), this._output.set_wrap_point();
  }, o.prototype.add_raw_token = function(g) {
    this._output.add_raw_token(g);
  }, o.prototype.print_preserved_newlines = function(g) {
    var m = 0;
    g.type !== r.TEXT && g.previous.type !== r.TEXT && (m = g.newlines ? 1 : 0), this.preserve_newlines && (m = g.newlines < this.max_preserve_newlines + 1 ? g.newlines : this.max_preserve_newlines + 1);
    for (var $ = 0; $ < m; $++)
      this.print_newline($ > 0);
    return m !== 0;
  }, o.prototype.traverse_whitespace = function(g) {
    return g.whitespace_before || g.newlines ? (this.print_preserved_newlines(g) || (this._output.space_before_token = !0), !0) : !1;
  }, o.prototype.previous_token_wrapped = function() {
    return this._output.previous_token_wrapped;
  }, o.prototype.print_newline = function(g) {
    this._output.add_new_line(g);
  }, o.prototype.print_token = function(g) {
    g.text && (this._output.set_indent(this.indent_level, this.alignment_size), this._output.add_token(g.text));
  }, o.prototype.indent = function() {
    this.indent_level++;
  }, o.prototype.deindent = function() {
    this.indent_level > 0 && (this.indent_level--, this._output.set_indent(this.indent_level, this.alignment_size));
  }, o.prototype.get_full_indent = function(g) {
    return g = this.indent_level + (g || 0), g < 1 ? "" : this._output.get_indent_string(g);
  };
  var a = function(g) {
    for (var m = null, $ = g.next; $.type !== r.EOF && g.closed !== $; ) {
      if ($.type === r.ATTRIBUTE && $.text === "type") {
        $.next && $.next.type === r.EQUALS && $.next.next && $.next.next.type === r.VALUE && (m = $.next.next.text);
        break;
      }
      $ = $.next;
    }
    return m;
  }, l = function(g, m) {
    var $ = null, w = null;
    return m.closed ? (g === "script" ? $ = "text/javascript" : g === "style" && ($ = "text/css"), $ = a(m) || $, $.search("text/css") > -1 ? w = "css" : $.search(/module|((text|application|dojo)\/(x-)?(javascript|ecmascript|jscript|livescript|(ld\+)?json|method|aspect))/) > -1 ? w = "javascript" : $.search(/(text|application|dojo)\/(x-)?(html)/) > -1 ? w = "html" : $.search(/test\/null/) > -1 && (w = "null"), w) : null;
  };
  function u(g, m) {
    return m.indexOf(g) !== -1;
  }
  function d(g, m, $) {
    this.parent = g || null, this.tag = m ? m.tag_name : "", this.indent_level = $ || 0, this.parser_token = m || null;
  }
  function c(g) {
    this._printer = g, this._current_frame = null;
  }
  c.prototype.get_parser_token = function() {
    return this._current_frame ? this._current_frame.parser_token : null;
  }, c.prototype.record_tag = function(g) {
    var m = new d(this._current_frame, g, this._printer.indent_level);
    this._current_frame = m;
  }, c.prototype._try_pop_frame = function(g) {
    var m = null;
    return g && (m = g.parser_token, this._printer.indent_level = g.indent_level, this._current_frame = g.parent), m;
  }, c.prototype._get_frame = function(g, m) {
    for (var $ = this._current_frame; $ && g.indexOf($.tag) === -1; ) {
      if (m && m.indexOf($.tag) !== -1) {
        $ = null;
        break;
      }
      $ = $.parent;
    }
    return $;
  }, c.prototype.try_pop = function(g, m) {
    var $ = this._get_frame([g], m);
    return this._try_pop_frame($);
  }, c.prototype.indent_to_tag = function(g) {
    var m = this._get_frame(g);
    m && (this._printer.indent_level = m.indent_level);
  };
  function f(g, m, $, w) {
    this._source_text = g || "", m = m || {}, this._js_beautify = $, this._css_beautify = w, this._tag_stack = null;
    var _ = new n(m, "html");
    this._options = _, this._is_wrap_attributes_force = this._options.wrap_attributes.substr(0, 5) === "force", this._is_wrap_attributes_force_expand_multiline = this._options.wrap_attributes === "force-expand-multiline", this._is_wrap_attributes_force_aligned = this._options.wrap_attributes === "force-aligned", this._is_wrap_attributes_aligned_multiple = this._options.wrap_attributes === "aligned-multiple", this._is_wrap_attributes_preserve = this._options.wrap_attributes.substr(0, 8) === "preserve", this._is_wrap_attributes_preserve_aligned = this._options.wrap_attributes === "preserve-aligned";
  }
  f.prototype.beautify = function() {
    if (this._options.disabled)
      return this._source_text;
    var g = this._source_text, m = this._options.eol;
    this._options.eol === "auto" && (m = `
`, g && i.test(g) && (m = g.match(i)[0])), g = g.replace(s, `
`);
    var $ = g.match(/^[\t ]*/)[0], w = {
      text: "",
      type: ""
    }, _ = new p(this._options), L = new o(this._options, $), S = new t(g, this._options).tokenize();
    this._tag_stack = new c(L);
    for (var R = null, O = S.next(); O.type !== r.EOF; )
      O.type === r.TAG_OPEN || O.type === r.COMMENT ? (R = this._handle_tag_open(L, O, _, w, S), _ = R) : O.type === r.ATTRIBUTE || O.type === r.EQUALS || O.type === r.VALUE || O.type === r.TEXT && !_.tag_complete ? R = this._handle_inside_tag(L, O, _, w) : O.type === r.TAG_CLOSE ? R = this._handle_tag_close(L, O, _) : O.type === r.TEXT ? R = this._handle_text(L, O, _) : O.type === r.CONTROL_FLOW_OPEN ? R = this._handle_control_flow_open(L, O) : O.type === r.CONTROL_FLOW_CLOSE ? R = this._handle_control_flow_close(L, O) : L.add_raw_token(O), w = R, O = S.next();
    var I = L._output.get_code(m);
    return I;
  }, f.prototype._handle_control_flow_open = function(g, m) {
    var $ = {
      text: m.text,
      type: m.type
    };
    return g.set_space_before_token(m.newlines || m.whitespace_before !== "", !0), m.newlines ? g.print_preserved_newlines(m) : g.set_space_before_token(m.newlines || m.whitespace_before !== "", !0), g.print_token(m), g.indent(), $;
  }, f.prototype._handle_control_flow_close = function(g, m) {
    var $ = {
      text: m.text,
      type: m.type
    };
    return g.deindent(), m.newlines ? g.print_preserved_newlines(m) : g.set_space_before_token(m.newlines || m.whitespace_before !== "", !0), g.print_token(m), $;
  }, f.prototype._handle_tag_close = function(g, m, $) {
    var w = {
      text: m.text,
      type: m.type
    };
    return g.alignment_size = 0, $.tag_complete = !0, g.set_space_before_token(m.newlines || m.whitespace_before !== "", !0), $.is_unformatted ? g.add_raw_token(m) : ($.tag_start_char === "<" && (g.set_space_before_token(m.text[0] === "/", !0), this._is_wrap_attributes_force_expand_multiline && $.has_wrapped_attrs && g.print_newline(!1)), g.print_token(m)), $.indent_content && !($.is_unformatted || $.is_content_unformatted) && (g.indent(), $.indent_content = !1), !$.is_inline_element && !($.is_unformatted || $.is_content_unformatted) && g.set_wrap_point(), w;
  }, f.prototype._handle_inside_tag = function(g, m, $, w) {
    var _ = $.has_wrapped_attrs, L = {
      text: m.text,
      type: m.type
    };
    return g.set_space_before_token(m.newlines || m.whitespace_before !== "", !0), $.is_unformatted ? g.add_raw_token(m) : $.tag_start_char === "{" && m.type === r.TEXT ? g.print_preserved_newlines(m) ? (m.newlines = 0, g.add_raw_token(m)) : g.print_token(m) : (m.type === r.ATTRIBUTE ? g.set_space_before_token(!0) : (m.type === r.EQUALS || m.type === r.VALUE && m.previous.type === r.EQUALS) && g.set_space_before_token(!1), m.type === r.ATTRIBUTE && $.tag_start_char === "<" && ((this._is_wrap_attributes_preserve || this._is_wrap_attributes_preserve_aligned) && (g.traverse_whitespace(m), _ = _ || m.newlines !== 0), this._is_wrap_attributes_force && $.attr_count >= this._options.wrap_attributes_min_attrs && (w.type !== r.TAG_OPEN || // ie. second attribute and beyond
    this._is_wrap_attributes_force_expand_multiline) && (g.print_newline(!1), _ = !0)), g.print_token(m), _ = _ || g.previous_token_wrapped(), $.has_wrapped_attrs = _), L;
  }, f.prototype._handle_text = function(g, m, $) {
    var w = {
      text: m.text,
      type: "TK_CONTENT"
    };
    return $.custom_beautifier_name ? this._print_custom_beatifier_text(g, m, $) : $.is_unformatted || $.is_content_unformatted ? g.add_raw_token(m) : (g.traverse_whitespace(m), g.print_token(m)), w;
  }, f.prototype._print_custom_beatifier_text = function(g, m, $) {
    var w = this;
    if (m.text !== "") {
      var _ = m.text, L, S = 1, R = "", O = "";
      $.custom_beautifier_name === "javascript" && typeof this._js_beautify == "function" ? L = this._js_beautify : $.custom_beautifier_name === "css" && typeof this._css_beautify == "function" ? L = this._css_beautify : $.custom_beautifier_name === "html" && (L = function(U, J) {
        var ne = new f(U, J, w._js_beautify, w._css_beautify);
        return ne.beautify();
      }), this._options.indent_scripts === "keep" ? S = 0 : this._options.indent_scripts === "separate" && (S = -g.indent_level);
      var I = g.get_full_indent(S);
      if (_ = _.replace(/\n[ \t]*$/, ""), $.custom_beautifier_name !== "html" && _[0] === "<" && _.match(/^(<!--|<!\[CDATA\[)/)) {
        var x = /^(<!--[^\n]*|<!\[CDATA\[)(\n?)([ \t\n]*)([\s\S]*)(-->|]]>)$/.exec(_);
        if (!x) {
          g.add_raw_token(m);
          return;
        }
        R = I + x[1] + `
`, _ = x[4], x[5] && (O = I + x[5]), _ = _.replace(/\n[ \t]*$/, ""), (x[2] || x[3].indexOf(`
`) !== -1) && (x = x[3].match(/[ \t]+$/), x && (m.whitespace_before = x[0]));
      }
      if (_)
        if (L) {
          var M = function() {
            this.eol = `
`;
          };
          M.prototype = this._options.raw_options;
          var D = new M();
          _ = L(I + _, D);
        } else {
          var j = m.whitespace_before;
          j && (_ = _.replace(new RegExp(`
(` + j + ")?", "g"), `
`)), _ = I + _.replace(/\n/g, `
` + I);
        }
      R && (_ ? _ = R + _ + `
` + O : _ = R + O), g.print_newline(!1), _ && (m.text = _, m.whitespace_before = "", m.newlines = 0, g.add_raw_token(m), g.print_newline(!0));
    }
  }, f.prototype._handle_tag_open = function(g, m, $, w, _) {
    var L = this._get_tag_open_token(m);
    if (($.is_unformatted || $.is_content_unformatted) && !$.is_empty_element && m.type === r.TAG_OPEN && !L.is_start_tag ? (g.add_raw_token(m), L.start_tag_token = this._tag_stack.try_pop(L.tag_name)) : (g.traverse_whitespace(m), this._set_tag_position(g, m, L, $, w), L.is_inline_element || g.set_wrap_point(), g.print_token(m)), L.is_start_tag && this._is_wrap_attributes_force) {
      var S = 0, R;
      do
        R = _.peek(S), R.type === r.ATTRIBUTE && (L.attr_count += 1), S += 1;
      while (R.type !== r.EOF && R.type !== r.TAG_CLOSE);
    }
    return (this._is_wrap_attributes_force_aligned || this._is_wrap_attributes_aligned_multiple || this._is_wrap_attributes_preserve_aligned) && (L.alignment_size = m.text.length + 1), !L.tag_complete && !L.is_unformatted && (g.alignment_size = L.alignment_size), L;
  };
  var p = function(g, m, $) {
    if (this.parent = m || null, this.text = "", this.type = "TK_TAG_OPEN", this.tag_name = "", this.is_inline_element = !1, this.is_unformatted = !1, this.is_content_unformatted = !1, this.is_empty_element = !1, this.is_start_tag = !1, this.is_end_tag = !1, this.indent_content = !1, this.multiline_content = !1, this.custom_beautifier_name = null, this.start_tag_token = null, this.attr_count = 0, this.has_wrapped_attrs = !1, this.alignment_size = 0, this.tag_complete = !1, this.tag_start_char = "", this.tag_check = "", !$)
      this.tag_complete = !0;
    else {
      var w;
      this.tag_start_char = $.text[0], this.text = $.text, this.tag_start_char === "<" ? (w = $.text.match(/^<([^\s>]*)/), this.tag_check = w ? w[1] : "") : (w = $.text.match(/^{{~?(?:[\^]|#\*?)?([^\s}]+)/), this.tag_check = w ? w[1] : "", ($.text.startsWith("{{#>") || $.text.startsWith("{{~#>")) && this.tag_check[0] === ">" && (this.tag_check === ">" && $.next !== null ? this.tag_check = $.next.text.split(" ")[0] : this.tag_check = $.text.split(">")[1])), this.tag_check = this.tag_check.toLowerCase(), $.type === r.COMMENT && (this.tag_complete = !0), this.is_start_tag = this.tag_check.charAt(0) !== "/", this.tag_name = this.is_start_tag ? this.tag_check : this.tag_check.substr(1), this.is_end_tag = !this.is_start_tag || $.closed && $.closed.text === "/>";
      var _ = 2;
      this.tag_start_char === "{" && this.text.length >= 3 && this.text.charAt(2) === "~" && (_ = 3), this.is_end_tag = this.is_end_tag || this.tag_start_char === "{" && (!g.indent_handlebars || this.text.length < 3 || /[^#\^]/.test(this.text.charAt(_)));
    }
  };
  f.prototype._get_tag_open_token = function(g) {
    var m = new p(this._options, this._tag_stack.get_parser_token(), g);
    return m.alignment_size = this._options.wrap_attributes_indent_size, m.is_end_tag = m.is_end_tag || u(m.tag_check, this._options.void_elements), m.is_empty_element = m.tag_complete || m.is_start_tag && m.is_end_tag, m.is_unformatted = !m.tag_complete && u(m.tag_check, this._options.unformatted), m.is_content_unformatted = !m.is_empty_element && u(m.tag_check, this._options.content_unformatted), m.is_inline_element = u(m.tag_name, this._options.inline) || this._options.inline_custom_elements && m.tag_name.includes("-") || m.tag_start_char === "{", m;
  }, f.prototype._set_tag_position = function(g, m, $, w, _) {
    if ($.is_empty_element || ($.is_end_tag ? $.start_tag_token = this._tag_stack.try_pop($.tag_name) : (this._do_optional_end_element($) && ($.is_inline_element || g.print_newline(!1)), this._tag_stack.record_tag($), ($.tag_name === "script" || $.tag_name === "style") && !($.is_unformatted || $.is_content_unformatted) && ($.custom_beautifier_name = l($.tag_check, m)))), u($.tag_check, this._options.extra_liners) && (g.print_newline(!1), g._output.just_added_blankline() || g.print_newline(!0)), $.is_empty_element) {
      if ($.tag_start_char === "{" && $.tag_check === "else") {
        this._tag_stack.indent_to_tag(["if", "unless", "each"]), $.indent_content = !0;
        var L = g.current_line_has_match(/{{#if/);
        L || g.print_newline(!1);
      }
      $.tag_name === "!--" && _.type === r.TAG_CLOSE && w.is_end_tag && $.text.indexOf(`
`) === -1 || ($.is_inline_element || $.is_unformatted || g.print_newline(!1), this._calcluate_parent_multiline(g, $));
    } else if ($.is_end_tag) {
      var S = !1;
      S = $.start_tag_token && $.start_tag_token.multiline_content, S = S || !$.is_inline_element && !(w.is_inline_element || w.is_unformatted) && !(_.type === r.TAG_CLOSE && $.start_tag_token === w) && _.type !== "TK_CONTENT", ($.is_content_unformatted || $.is_unformatted) && (S = !1), S && g.print_newline(!1);
    } else
      $.indent_content = !$.custom_beautifier_name, $.tag_start_char === "<" && ($.tag_name === "html" ? $.indent_content = this._options.indent_inner_html : $.tag_name === "head" ? $.indent_content = this._options.indent_head_inner_html : $.tag_name === "body" && ($.indent_content = this._options.indent_body_inner_html)), !($.is_inline_element || $.is_unformatted) && (_.type !== "TK_CONTENT" || $.is_content_unformatted) && g.print_newline(!1), this._calcluate_parent_multiline(g, $);
  }, f.prototype._calcluate_parent_multiline = function(g, m) {
    m.parent && g._output.just_added_newline() && !((m.is_inline_element || m.is_unformatted) && m.parent.is_inline_element) && (m.parent.multiline_content = !0);
  };
  var h = ["address", "article", "aside", "blockquote", "details", "div", "dl", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hr", "main", "menu", "nav", "ol", "p", "pre", "section", "table", "ul"], y = ["a", "audio", "del", "ins", "map", "noscript", "video"];
  return f.prototype._do_optional_end_element = function(g) {
    var m = null;
    if (!(g.is_empty_element || !g.is_start_tag || !g.parent)) {
      if (g.tag_name === "body")
        m = m || this._tag_stack.try_pop("head");
      else if (g.tag_name === "li")
        m = m || this._tag_stack.try_pop("li", ["ol", "ul", "menu"]);
      else if (g.tag_name === "dd" || g.tag_name === "dt")
        m = m || this._tag_stack.try_pop("dt", ["dl"]), m = m || this._tag_stack.try_pop("dd", ["dl"]);
      else if (g.parent.tag_name === "p" && h.indexOf(g.tag_name) !== -1) {
        var $ = g.parent.parent;
        (!$ || y.indexOf($.tag_name) === -1) && (m = m || this._tag_stack.try_pop("p"));
      } else g.tag_name === "rp" || g.tag_name === "rt" ? (m = m || this._tag_stack.try_pop("rt", ["ruby", "rtc"]), m = m || this._tag_stack.try_pop("rp", ["ruby", "rtc"])) : g.tag_name === "optgroup" ? m = m || this._tag_stack.try_pop("optgroup", ["select"]) : g.tag_name === "option" ? m = m || this._tag_stack.try_pop("option", ["select", "datalist", "optgroup"]) : g.tag_name === "colgroup" ? m = m || this._tag_stack.try_pop("caption", ["table"]) : g.tag_name === "thead" ? (m = m || this._tag_stack.try_pop("caption", ["table"]), m = m || this._tag_stack.try_pop("colgroup", ["table"])) : g.tag_name === "tbody" || g.tag_name === "tfoot" ? (m = m || this._tag_stack.try_pop("caption", ["table"]), m = m || this._tag_stack.try_pop("colgroup", ["table"]), m = m || this._tag_stack.try_pop("thead", ["table"]), m = m || this._tag_stack.try_pop("tbody", ["table"])) : g.tag_name === "tr" ? (m = m || this._tag_stack.try_pop("caption", ["table"]), m = m || this._tag_stack.try_pop("colgroup", ["table"]), m = m || this._tag_stack.try_pop("tr", ["table", "thead", "tbody", "tfoot"])) : (g.tag_name === "th" || g.tag_name === "td") && (m = m || this._tag_stack.try_pop("td", ["table", "thead", "tbody", "tfoot", "tr"]), m = m || this._tag_stack.try_pop("th", ["table", "thead", "tbody", "tfoot", "tr"]));
      return g.parent = this._tag_stack.get_parser_token(), m;
    }
  }, ed.Beautifier = f, ed;
}
var k2;
function LT() {
  if (k2) return ca.exports;
  k2 = 1;
  var n = DT().Beautifier, e = t4().Options;
  function t(r, i, s, o) {
    var a = new n(r, i, s, o);
    return a.beautify();
  }
  return ca.exports = t, ca.exports.defaultOptions = function() {
    return new e();
  }, ca.exports;
}
var C2;
function RT() {
  if (C2) return Ds;
  C2 = 1;
  var n = MT(), e = NT(), t = LT();
  function r(i, s, o, a) {
    return o = o || n, a = a || e, t(i, s, o, a);
  }
  return r.defaultOptions = t.defaultOptions, Ds.js = n, Ds.css = e, Ds.html = r, Ds;
}
(function(n) {
  function e(t, r, i) {
    var s = function(o, a) {
      return t.js_beautify(o, a);
    };
    return s.js = t.js_beautify, s.css = r.css_beautify, s.html = i.html_beautify, s.js_beautify = t.js_beautify, s.css_beautify = r.css_beautify, s.html_beautify = i.html_beautify, s;
  }
  (function(t) {
    var r = RT();
    r.js_beautify = r.js, r.css_beautify = r.css, r.html_beautify = r.html, t.exports = e(r, r, r);
  })(n);
})(Y3);
var PT = Y3.exports;
const IT = /* @__PURE__ */ $p(PT), BT = {
  key: 0,
  class: "mr-2"
}, zT = ["fill"], wt = /* @__PURE__ */ X({
  __name: "FormatButton",
  props: {
    active: { type: Boolean },
    label: {},
    showLabel: {},
    fill: { type: Boolean }
  },
  emits: ["click"],
  setup(n) {
    return (e, t) => (k(), T("button", {
      class: B(["text-gray-500 hover:text-gray-900 hover:bg-gray-100 flex cursor-pointer items-center justify-center rounded-md p-1.5", {
        "bg-grey-500/30 hover:bg-grey-500/40": e.active,
        "bg-grey-500/10 hover:bg-grey-500/20": !e.active
      }]),
      onClick: t[0] || (t[0] = (r) => e.$emit("click"))
    }, [
      e.showLabel === "start" ? (k(), T("span", BT, z(e.label), 1)) : V("", !0),
      (k(), T("svg", {
        "aria-hidden": "true",
        class: "size-5",
        fill: e.fill ? "currentColor" : "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        te(e.$slots, "path")
      ], 8, zT)),
      E("span", {
        class: B(e.showLabel === "end" ? "" : "sr-only")
      }, z(e.label), 3)
    ], 2));
  }
}), VT = { class: "relative" }, FT = {
  key: 0,
  class: "shadow-sm absolute z-10 w-72 rounded-sm border border-grey-stroke bg-white p-2"
}, jT = { class: "space-y-1 text-sm font-medium" }, HT = ["onClick"], UT = /* @__PURE__ */ X({
  __name: "BlockControl",
  setup(n) {
    const e = zt("editor"), t = [1, 2, 3, 4, 5, 6], r = ae(!1);
    return (i, s) => (k(), T("div", VT, [
      A(wt, {
        label: "Format",
        "show-label": "start",
        onClick: s[0] || (s[0] = (o) => r.value = !r.value)
      }, {
        path: N(() => s[2] || (s[2] = [
          E("path", {
            d: "m19 9-7 7-7-7",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, -1)
        ])),
        _: 1
      }),
      r.value ? (k(), T("div", FT, [
        E("ul", jT, [
          E("li", null, [
            E("button", {
              class: B(["text-base text-gray-900 hover:bg-gray-100 flex w-full items-center justify-between rounded-sm px-3 py-2", { "bg-gray-100 ": v(e).isActive("paragraph") }]),
              onClick: s[1] || (s[1] = (o) => {
                v(e).chain().focus().setParagraph().run(), r.value = !1;
              })
            }, " Paragraph ", 2)
          ]),
          (k(), T(ce, null, $e(t, (o) => E("li", { key: o }, [
            E("button", {
              class: B(["text-base text-gray-900 hover:bg-gray-100 flex w-full items-center justify-between rounded-sm px-3 py-2", { "bg-gray-100": v(e).isActive("heading", { level: o }) }]),
              onClick: (a) => {
                v(e).chain().focus().toggleHeading({ level: o }).run(), r.value = !1;
              }
            }, " Heading " + z(o), 11, HT)
          ])), 64))
        ])
      ])) : V("", !0)
    ]));
  }
}), WT = /* @__PURE__ */ X({
  __name: "BlockquoteControl",
  setup(n) {
    const e = zt("editor");
    return (t, r) => (k(), q(wt, {
      active: v(e).isActive("blockquote"),
      fill: "",
      label: "Blockquote",
      onClick: r[0] || (r[0] = (i) => v(e).chain().focus().toggleBlockquote().run())
    }, {
      path: N(() => r[1] || (r[1] = [
        E("path", {
          "clip-rule": "evenodd",
          d: "M6 6a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a3 3 0 0 1-3 3H5a1 1 0 1 0 0 2h1a5 5 0 0 0 5-5V8a2 2 0 0 0-2-2H6Zm9 0a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a3 3 0 0 1-3 3h-1a1 1 0 1 0 0 2h1a5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3Z",
          "fill-rule": "evenodd"
        }, null, -1)
      ])),
      _: 1
    }, 8, ["active"]));
  }
}), qT = /* @__PURE__ */ X({
  __name: "HorizontalRuleControl",
  setup(n) {
    const e = zt("editor");
    return (t, r) => (k(), q(wt, {
      label: "Horizontal Rule",
      onClick: r[0] || (r[0] = (i) => v(e).chain().focus().setHorizontalRule().run())
    }, {
      path: N(() => r[1] || (r[1] = [
        E("path", {
          d: "M5 12h14",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-width": "2"
        }, null, -1),
        E("path", {
          d: "M6 9.5h12m-12 9h12M6 7.5h12m-12 9h12M6 5.5h12m-12 9h12",
          stroke: "currentColor",
          "stroke-linecap": "round"
        }, null, -1)
      ])),
      _: 1
    }));
  }
}), KT = /* @__PURE__ */ X({
  __name: "OrderedListControl",
  setup(n) {
    const e = zt("editor");
    return (t, r) => (k(), q(wt, {
      active: v(e).isActive("orderedList"),
      label: "Ordered list",
      onClick: r[0] || (r[0] = (i) => v(e).chain().focus().toggleOrderedList().run())
    }, {
      path: N(() => r[1] || (r[1] = [
        E("path", {
          d: "M12 6h8m-8 6h8m-8 6h8M4 16a2 2 0 1 1 3.321 1.5L4 20h5M4 5l2-1v6m-2 0h4",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, -1)
      ])),
      _: 1
    }, 8, ["active"]));
  }
}), GT = /* @__PURE__ */ X({
  __name: "RedoControl",
  setup(n) {
    const e = zt("editor");
    return (t, r) => (k(), q(wt, {
      label: "Redo",
      onClick: r[0] || (r[0] = (i) => v(e).commands.redo())
    }, {
      path: N(() => r[1] || (r[1] = [
        E("path", {
          "clip-rule": "evenodd",
          d: "M15.7071 2.29289C15.3166 1.90237 14.6834 1.90237 14.2929 2.29289C13.9024 2.68342 13.9024 3.31658 14.2929 3.70711L17.5858 7H9.5C7.77609 7 6.12279 7.68482 4.90381 8.90381C3.68482 10.1228 3 11.7761 3 13.5C3 14.3536 3.16813 15.1988 3.49478 15.9874C3.82144 16.7761 4.30023 17.4926 4.90381 18.0962C6.12279 19.3152 7.77609 20 9.5 20H13C13.5523 20 14 19.5523 14 19C14 18.4477 13.5523 18 13 18H9.5C8.30653 18 7.16193 17.5259 6.31802 16.682C5.90016 16.2641 5.56869 15.768 5.34254 15.2221C5.1164 14.6761 5 14.0909 5 13.5C5 12.3065 5.47411 11.1619 6.31802 10.318C7.16193 9.47411 8.30653 9 9.5 9H17.5858L14.2929 12.2929C13.9024 12.6834 13.9024 13.3166 14.2929 13.7071C14.6834 14.0976 15.3166 14.0976 15.7071 13.7071L20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.29289L15.7071 2.29289Z",
          fill: "currentColor",
          "fill-rule": "evenodd",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)
      ])),
      _: 1
    }));
  }
}), YT = /* @__PURE__ */ X({
  __name: "UndoControl",
  setup(n) {
    const e = zt("editor");
    return (t, r) => (k(), q(wt, {
      label: "Undo",
      onClick: r[0] || (r[0] = (i) => v(e).commands.undo())
    }, {
      path: N(() => r[1] || (r[1] = [
        E("path", {
          "clip-rule": "evenodd",
          d: "M9.70711 3.70711C10.0976 3.31658 10.0976 2.68342 9.70711 2.29289C9.31658 1.90237 8.68342 1.90237 8.29289 2.29289L3.29289 7.29289C2.90237 7.68342 2.90237 8.31658 3.29289 8.70711L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071C10.0976 13.3166 10.0976 12.6834 9.70711 12.2929L6.41421 9H14.5C15.0909 9 15.6761 9.1164 16.2221 9.34254C16.768 9.56869 17.2641 9.90016 17.682 10.318C18.0998 10.7359 18.4313 11.232 18.6575 11.7779C18.8836 12.3239 19 12.9091 19 13.5C19 14.0909 18.8836 14.6761 18.6575 15.2221C18.4313 15.768 18.0998 16.2641 17.682 16.682C17.2641 17.0998 16.768 17.4313 16.2221 17.6575C15.6761 17.8836 15.0909 18 14.5 18H11C10.4477 18 10 18.4477 10 19C10 19.5523 10.4477 20 11 20H14.5C15.3536 20 16.1988 19.8319 16.9874 19.5052C17.7761 19.1786 18.4926 18.6998 19.0962 18.0962C19.6998 17.4926 20.1786 16.7761 20.5052 15.9874C20.8319 15.1988 21 14.3536 21 13.5C21 12.6464 20.8319 11.8012 20.5052 11.0126C20.1786 10.2239 19.6998 9.50739 19.0962 8.90381C18.4926 8.30022 17.7761 7.82144 16.9874 7.49478C16.1988 7.16813 15.3536 7 14.5 7H6.41421L9.70711 3.70711Z",
          fill: "currentColor",
          "fill-rule": "evenodd",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)
      ])),
      _: 1
    }));
  }
}), JT = /* @__PURE__ */ X({
  __name: "UnorderedListControl",
  setup(n) {
    const e = zt("editor");
    return (t, r) => (k(), q(wt, {
      active: v(e).isActive("bulletList"),
      label: "Bullet list",
      onClick: r[0] || (r[0] = (i) => v(e).chain().focus().toggleBulletList().run())
    }, {
      path: N(() => r[1] || (r[1] = [
        E("path", {
          d: "M9 8h10M9 12h10M9 16h10M4.99 8H5m-.02 4h.01m0 4H5",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-width": "2"
        }, null, -1)
      ])),
      _: 1
    }, 8, ["active"]));
  }
}), ZT = {}, XT = { class: "px-1.5" };
function QT(n, e) {
  return k(), T("div", XT, e[0] || (e[0] = [
    E("span", { class: "block h-4 w-px bg-grey-stroke" }, null, -1)
  ]));
}
const Jd = /* @__PURE__ */ Bn(ZT, [["render", QT]]), eO = { class: "flex flex-wrap items-center gap-2" }, tO = /* @__PURE__ */ X({
  __name: "FormatControls",
  setup(n) {
    return (e, t) => (k(), T("div", eO, [
      A(UT),
      A(Jd),
      A(JT),
      A(KT),
      A(WT),
      A(qT),
      A(Jd),
      A(YT),
      A(GT),
      te(e.$slots, "default")
    ]));
  }
}), nO = /* @__PURE__ */ X({
  __name: "BoldControl",
  setup(n) {
    const e = zt("editor");
    return (t, r) => (k(), q(wt, {
      active: v(e).isActive("bold"),
      label: "Bold",
      onClick: r[0] || (r[0] = (i) => v(e).chain().focus().toggleBold().run())
    }, {
      path: N(() => r[1] || (r[1] = [
        E("path", {
          d: "M8 5h4.5a3.5 3.5 0 1 1 0 7H8m0-7v7m0-7H6m2 7h6.5a3.5 3.5 0 1 1 0 7H8m0-7v7m0 0H6",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, -1)
      ])),
      _: 1
    }, 8, ["active"]));
  }
}), rO = /* @__PURE__ */ X({
  __name: "LinkControl",
  setup(n) {
    const e = zt("editor");
    function t() {
      const r = prompt("Enter URL", "https://");
      r && e.chain().focus().setLink({ href: r }).run();
    }
    return (r, i) => (k(), q(wt, {
      active: v(e).isActive("link"),
      label: "Link",
      onClick: t
    }, {
      path: N(() => i[0] || (i[0] = [
        E("path", {
          d: "M13.213 9.787a3.391 3.391 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-width": "2"
        }, null, -1)
      ])),
      _: 1
    }, 8, ["active"]));
  }
}), iO = /* @__PURE__ */ X({
  __name: "RemoveLinkControl",
  setup(n) {
    const e = zt("editor");
    return (t, r) => (k(), q(wt, {
      label: "Remove Link",
      onClick: r[0] || (r[0] = (i) => v(e).chain().focus().unsetLink().run())
    }, {
      path: N(() => r[1] || (r[1] = [
        E("path", {
          d: "M13.2 9.8a3.4 3.4 0 0 0-4.8 0L5 13.2A3.4 3.4 0 0 0 9.8 18l.3-.3m-.3-4.5a3.4 3.4 0 0 0 4.8 0L18 9.8A3.4 3.4 0 0 0 13.2 5l-1 1m7.4 14-1.8-1.8m0 0L16 16.4m1.8 1.8l1.8-1.8m-1.8 1.8L16 20",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-width": "2"
        }, null, -1)
      ])),
      _: 1
    }));
  }
}), sO = /* @__PURE__ */ X({
  __name: "StrikeControl",
  setup(n) {
    const e = zt("editor");
    return (t, r) => (k(), q(wt, {
      active: v(e).isActive("strike"),
      label: "Strike",
      onClick: r[0] || (r[0] = (i) => v(e).chain().focus().toggleStrike().run())
    }, {
      path: N(() => r[1] || (r[1] = [
        E("path", {
          d: "M7 6.2V5h12v1.2M7 19h6m.2-14-1.677 6.523M9.6 19l1.029-4M5 5l6.523 6.523M19 19l-7.477-7.477",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, -1)
      ])),
      _: 1
    }, 8, ["active"]));
  }
}), oO = /* @__PURE__ */ X({
  __name: "TextAlignControl",
  setup(n) {
    const e = zt("editor");
    return (t, r) => (k(), T(ce, null, [
      A(wt, {
        active: v(e).isActive({ textAlign: "left" }),
        label: "Align Left",
        onClick: r[0] || (r[0] = (i) => v(e).chain().focus().setTextAlign("left").run())
      }, {
        path: N(() => r[3] || (r[3] = [
          E("path", {
            d: "M6 6h8m-8 4h12M6 14h8m-8 4h12",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, -1)
        ])),
        _: 1
      }, 8, ["active"]),
      A(wt, {
        active: v(e).isActive({ textAlign: "center" }),
        label: "Align Center",
        onClick: r[1] || (r[1] = (i) => v(e).chain().focus().setTextAlign("center").run())
      }, {
        path: N(() => r[4] || (r[4] = [
          E("path", {
            d: "M8 6h8M6 10h12M8 14h8M6 18h12",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, -1)
        ])),
        _: 1
      }, 8, ["active"]),
      A(wt, {
        active: v(e).isActive({ textAlign: "right" }),
        label: "Align Right",
        onClick: r[2] || (r[2] = (i) => v(e).chain().focus().setTextAlign("right").run())
      }, {
        path: N(() => r[5] || (r[5] = [
          E("path", {
            d: "M18 6h-8m8 4H6m12 4h-8m8 4H6",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, -1)
        ])),
        _: 1
      }, 8, ["active"])
    ], 64));
  }
}), aO = { class: "relative" }, lO = {
  key: 0,
  class: "absolute z-10 w-48 rounded-sm border border-grey-stroke bg-white p-2 shadow-card"
}, uO = { class: "hover:bg-gray-100 group mb-3 grid grid-cols-6 items-center gap-2 rounded-lg p-1.5" }, dO = { class: "mb-3 grid grid-cols-6 gap-1" }, cO = ["onClick"], fO = { class: "sr-only" }, pO = /* @__PURE__ */ X({
  __name: "TextColorControl",
  setup(n) {
    const e = zt("editor"), t = [
      { color: "#46B7B2", label: "Blue" },
      { color: "#F8641E", label: "Orange" }
    ], r = ae("#000000");
    function i(a) {
      r.value = a, e.chain().focus().setColor(a).run();
    }
    function s() {
      e.chain().focus().unsetColor().run();
    }
    const o = ae(!1);
    return (a, l) => (k(), T("div", aO, [
      A(wt, {
        label: "Text Color",
        onClick: l[0] || (l[0] = (u) => o.value = !o.value)
      }, {
        path: N(() => l[4] || (l[4] = [
          E("path", {
            d: "m6.532 15.982 1.573-4m-1.573 4h-1.1m1.1 0h1.65m-.077-4 2.725-6.93a.11.11 0 0 1 .204 0l2.725 6.93m-5.654 0H8.1m.006 0h5.654m0 0 .617 1.569m5.11 4.453c0 1.102-.854 1.996-1.908 1.996-1.053 0-1.907-.894-1.907-1.996 0-1.103 1.907-4.128 1.907-4.128s1.909 3.025 1.909 4.128Z",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-width": "2"
          }, null, -1)
        ])),
        _: 1
      }),
      o.value ? (k(), T("div", lO, [
        E("div", uO, [
          nt(E("input", {
            "onUpdate:modelValue": l[1] || (l[1] = (u) => r.value = u),
            class: "border-gray-200 bg-gray-50 hover:bg-gray-50 group-hover:bg-gray-50 col-span-3 h-8 w-full rounded-md border p-px px-1",
            type: "color",
            onInput: l[2] || (l[2] = (u) => i(r.value))
          }, null, 544), [
            [I2, r.value]
          ]),
          l[5] || (l[5] = E("label", { class: "text-gray-500 group-hover:text-gray-900 col-span-3 text-sm font-medium" }, "Pick a color", -1))
        ]),
        E("div", dO, [
          (k(), T(ce, null, $e(t, ({ color: u, label: d }) => E("button", {
            key: u,
            class: "size-6 rounded-md",
            style: mt({ backgroundColor: u }),
            onClick: (c) => i(u)
          }, [
            E("span", fO, z(d), 1)
          ], 12, cO)), 64))
        ]),
        E("button", {
          class: "text-gray-500 hover:bg-gray-100 hover:text-gray-900 focus:ring-gray-100 rounded-lg bg-white py-1.5 text-sm font-medium focus:z-10 focus:outline-none focus:ring-4",
          onClick: l[3] || (l[3] = (u) => {
            s(), o.value = !1;
          })
        }, " Reset color ")
      ])) : V("", !0)
    ]));
  }
}), hO = /* @__PURE__ */ X({
  __name: "UnderlineControl",
  setup(n) {
    const e = zt("editor");
    return (t, r) => (k(), q(wt, {
      active: v(e).isActive("underline"),
      label: "Underline",
      onClick: r[0] || (r[0] = (i) => v(e).chain().focus().toggleUnderline().run())
    }, {
      path: N(() => r[1] || (r[1] = [
        E("path", {
          d: "M6 19h12M8 5v9a4 4 0 0 0 8 0V5M6 5h4m4 0h4",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-width": "2"
        }, null, -1)
      ])),
      _: 1
    }, 8, ["active"]));
  }
}), mO = { class: "flex flex-wrap items-center gap-2" }, gO = /* @__PURE__ */ X({
  __name: "TextFormatControls",
  setup(n) {
    return (e, t) => (k(), T("div", mO, [
      A(nO),
      A(hO),
      A(sO),
      A(rO),
      A(iO),
      A(pO),
      A(Jd),
      A(oO),
      te(e.$slots, "default")
    ]));
  }
}), bO = {
  key: 0,
  class: "w-full"
}, yO = {
  key: 0,
  class: "mb-2 flex items-center text-sm font-highlighted"
}, vO = {
  key: 0,
  class: "ml-1 text-red"
}, _O = { class: "sticky top-0 z-10 border-b border-grey-stroke bg-white shadow-card" }, $O = { class: "border-b border-grey-stroke px-3 py-2" }, xO = { class: "px-3 py-2" }, wO = { class: "ml-auto flex items-center gap-2" }, kO = { class: "flex grow flex-col bg-white" }, CO = {
  key: 1,
  class: "block max-w-full pt-1 text-red"
}, SO = ["innerHTML"], DA = /* @__PURE__ */ X({
  __name: "CfgRichEditor",
  props: /* @__PURE__ */ Ae({
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    caption: {
      type: String,
      default: ""
    }
  }, {
    modelValue: {},
    modelModifiers: {},
    htmlValue: {},
    htmlValueModifiers: {}
  }),
  emits: ["update:modelValue", "update:htmlValue"],
  setup(n) {
    const e = je(n, "modelValue"), t = je(n, "htmlValue"), {
      editor: r,
      jsonContent: i
    } = ST(t);
    Ie(
      e,
      (u) => {
        !u || Object.keys(u).length === 0 || (i.value = u);
      },
      { immediate: !0 }
    ), Ie(
      i,
      (u) => {
        !u || Object.keys(u).length === 0 || (e.value = u);
      }
    ), sd("editor", r);
    const s = ae(""), o = ae(!1);
    function a() {
      if (o.value = !0, o.value) {
        const u = r.getHTML();
        s.value = IT.html(u, {
          wrap_line_length: 80
        });
      }
    }
    function l() {
      r.commands.setContent(s.value), r.commands.focus("end"), o.value = !1, s.value = "";
    }
    return (u, d) => v(r) ? (k(), T("div", bO, [
      n.label ? (k(), T("div", yO, [
        W(z(n.label) + " ", 1),
        n.required ? (k(), T("span", vO, "*")) : V("", !0)
      ])) : V("", !0),
      E("div", {
        class: B(["flex min-h-96 w-full flex-col overflow-y-auto rounded-xl border border-stroke-gray lg:max-h-screen", { "border-red": n.error }])
      }, [
        E("div", _O, [
          E("div", $O, [
            A(gO)
          ]),
          E("div", xO, [
            A(tO, null, {
              default: N(() => [
                E("div", wO, [
                  o.value ? (k(), q(wt, {
                    key: 1,
                    label: "Show document",
                    onClick: l
                  }, {
                    path: N(() => d[2] || (d[2] = [
                      E("path", {
                        d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z",
                        stroke: "currentColor",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2"
                      }, null, -1)
                    ])),
                    _: 1
                  })) : (k(), q(wt, {
                    key: 0,
                    label: "Show source",
                    onClick: a
                  }, {
                    path: N(() => d[1] || (d[1] = [
                      E("path", {
                        d: "M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5",
                        stroke: "currentColor",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2"
                      }, null, -1)
                    ])),
                    _: 1
                  }))
                ])
              ]),
              _: 1
            })
          ])
        ]),
        E("div", kO, [
          o.value ? nt((k(), T("textarea", {
            key: 1,
            "onUpdate:modelValue": d[0] || (d[0] = (c) => s.value = c),
            class: "font-mono text-gray-800 size-full grow whitespace-pre border-0 bg-white p-2 font-[Courier,monospace] text-sm focus:ring-0",
            placeholder: "Enter HTML content here..."
          }, null, 512)), [
            [I2, s.value]
          ]) : (k(), q(v(CT), {
            key: 0,
            class: "text-gray-800 flex min-h-full w-full grow flex-col bg-white px-4 py-2 text-sm focus:ring-0 [&>div]:grow",
            editor: v(r)
          }, null, 8, ["editor"]))
        ])
      ], 2),
      n.error && n.errorMessage ? (k(), T("small", CO, z(n.errorMessage), 1)) : V("", !0),
      !(n.errorMessage && n.error) && n.caption ? (k(), T("small", {
        key: 2,
        class: "block max-w-full pt-1 text-grey-300",
        innerHTML: n.caption
      }, null, 8, SO)) : V("", !0)
    ])) : V("", !0);
  }
}), EO = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((n) => n.charCodeAt(0))
), TO = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((n) => n.charCodeAt(0))
);
var nd;
const OO = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), MO = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, n/no-unsupported-features/es-builtins
  (nd = String.fromCodePoint) !== null && nd !== void 0 ? nd : function(n) {
    let e = "";
    return n > 65535 && (n -= 65536, e += String.fromCharCode(n >>> 10 & 1023 | 55296), n = 56320 | n & 1023), e += String.fromCharCode(n), e;
  }
);
function AO(n) {
  var e;
  return n >= 55296 && n <= 57343 || n > 1114111 ? 65533 : (e = OO.get(n)) !== null && e !== void 0 ? e : n;
}
var _t;
(function(n) {
  n[n.NUM = 35] = "NUM", n[n.SEMI = 59] = "SEMI", n[n.EQUALS = 61] = "EQUALS", n[n.ZERO = 48] = "ZERO", n[n.NINE = 57] = "NINE", n[n.LOWER_A = 97] = "LOWER_A", n[n.LOWER_F = 102] = "LOWER_F", n[n.LOWER_X = 120] = "LOWER_X", n[n.LOWER_Z = 122] = "LOWER_Z", n[n.UPPER_A = 65] = "UPPER_A", n[n.UPPER_F = 70] = "UPPER_F", n[n.UPPER_Z = 90] = "UPPER_Z";
})(_t || (_t = {}));
const NO = 32;
var zr;
(function(n) {
  n[n.VALUE_LENGTH = 49152] = "VALUE_LENGTH", n[n.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", n[n.JUMP_TABLE = 127] = "JUMP_TABLE";
})(zr || (zr = {}));
function Zd(n) {
  return n >= _t.ZERO && n <= _t.NINE;
}
function DO(n) {
  return n >= _t.UPPER_A && n <= _t.UPPER_F || n >= _t.LOWER_A && n <= _t.LOWER_F;
}
function LO(n) {
  return n >= _t.UPPER_A && n <= _t.UPPER_Z || n >= _t.LOWER_A && n <= _t.LOWER_Z || Zd(n);
}
function RO(n) {
  return n === _t.EQUALS || LO(n);
}
var yt;
(function(n) {
  n[n.EntityStart = 0] = "EntityStart", n[n.NumericStart = 1] = "NumericStart", n[n.NumericDecimal = 2] = "NumericDecimal", n[n.NumericHex = 3] = "NumericHex", n[n.NamedEntity = 4] = "NamedEntity";
})(yt || (yt = {}));
var Rr;
(function(n) {
  n[n.Legacy = 0] = "Legacy", n[n.Strict = 1] = "Strict", n[n.Attribute = 2] = "Attribute";
})(Rr || (Rr = {}));
class PO {
  constructor(e, t, r) {
    this.decodeTree = e, this.emitCodePoint = t, this.errors = r, this.state = yt.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Rr.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(e) {
    this.decodeMode = e, this.state = yt.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(e, t) {
    switch (this.state) {
      case yt.EntityStart:
        return e.charCodeAt(t) === _t.NUM ? (this.state = yt.NumericStart, this.consumed += 1, this.stateNumericStart(e, t + 1)) : (this.state = yt.NamedEntity, this.stateNamedEntity(e, t));
      case yt.NumericStart:
        return this.stateNumericStart(e, t);
      case yt.NumericDecimal:
        return this.stateNumericDecimal(e, t);
      case yt.NumericHex:
        return this.stateNumericHex(e, t);
      case yt.NamedEntity:
        return this.stateNamedEntity(e, t);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(e, t) {
    return t >= e.length ? -1 : (e.charCodeAt(t) | NO) === _t.LOWER_X ? (this.state = yt.NumericHex, this.consumed += 1, this.stateNumericHex(e, t + 1)) : (this.state = yt.NumericDecimal, this.stateNumericDecimal(e, t));
  }
  addToNumericResult(e, t, r, i) {
    if (t !== r) {
      const s = r - t;
      this.result = this.result * Math.pow(i, s) + Number.parseInt(e.substr(t, s), i), this.consumed += s;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(e, t) {
    const r = t;
    for (; t < e.length; ) {
      const i = e.charCodeAt(t);
      if (Zd(i) || DO(i))
        t += 1;
      else
        return this.addToNumericResult(e, r, t, 16), this.emitNumericEntity(i, 3);
    }
    return this.addToNumericResult(e, r, t, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(e, t) {
    const r = t;
    for (; t < e.length; ) {
      const i = e.charCodeAt(t);
      if (Zd(i))
        t += 1;
      else
        return this.addToNumericResult(e, r, t, 10), this.emitNumericEntity(i, 2);
    }
    return this.addToNumericResult(e, r, t, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(e, t) {
    var r;
    if (this.consumed <= t)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (e === _t.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Rr.Strict)
      return 0;
    return this.emitCodePoint(AO(this.result), this.consumed), this.errors && (e !== _t.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(e, t) {
    const { decodeTree: r } = this;
    let i = r[this.treeIndex], s = (i & zr.VALUE_LENGTH) >> 14;
    for (; t < e.length; t++, this.excess++) {
      const o = e.charCodeAt(t);
      if (this.treeIndex = IO(r, i, this.treeIndex + Math.max(1, s), o), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Rr.Attribute && // We shouldn't have consumed any characters after the entity,
        (s === 0 || // And there should be no invalid characters.
        RO(o)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (i = r[this.treeIndex], s = (i & zr.VALUE_LENGTH) >> 14, s !== 0) {
        if (o === _t.SEMI)
          return this.emitNamedEntityData(this.treeIndex, s, this.consumed + this.excess);
        this.decodeMode !== Rr.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var e;
    const { result: t, decodeTree: r } = this, i = (r[t] & zr.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(t, i, this.consumed), (e = this.errors) === null || e === void 0 || e.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(e, t, r) {
    const { decodeTree: i } = this;
    return this.emitCodePoint(t === 1 ? i[e] & ~zr.VALUE_LENGTH : i[e + 1], r), t === 3 && this.emitCodePoint(i[e + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var e;
    switch (this.state) {
      case yt.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Rr.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case yt.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case yt.NumericHex:
        return this.emitNumericEntity(0, 3);
      case yt.NumericStart:
        return (e = this.errors) === null || e === void 0 || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case yt.EntityStart:
        return 0;
    }
  }
}
function n4(n) {
  let e = "";
  const t = new PO(n, (r) => e += MO(r));
  return function(i, s) {
    let o = 0, a = 0;
    for (; (a = i.indexOf("&", a)) >= 0; ) {
      e += i.slice(o, a), t.startEntity(s);
      const u = t.write(
        i,
        // Skip the "&"
        a + 1
      );
      if (u < 0) {
        o = a + t.end();
        break;
      }
      o = a + u, a = u === 0 ? o + 1 : o;
    }
    const l = e + i.slice(o);
    return e = "", l;
  };
}
function IO(n, e, t, r) {
  const i = (e & zr.BRANCH_LENGTH) >> 7, s = e & zr.JUMP_TABLE;
  if (i === 0)
    return s !== 0 && r === s ? t : -1;
  if (s) {
    const l = r - s;
    return l < 0 || l >= i ? -1 : n[t + l] - 1;
  }
  let o = t, a = o + i - 1;
  for (; o <= a; ) {
    const l = o + a >>> 1, u = n[l];
    if (u < r)
      o = l + 1;
    else if (u > r)
      a = l - 1;
    else
      return n[l + i];
  }
  return -1;
}
const BO = n4(EO);
n4(TO);
function zO(n, e = Rr.Legacy) {
  return BO(n, e);
}
var et;
(function(n) {
  n.Attribute = "attribute", n.Pseudo = "pseudo", n.PseudoElement = "pseudo-element", n.Tag = "tag", n.Universal = "universal", n.Adjacent = "adjacent", n.Child = "child", n.Descendant = "descendant", n.Parent = "parent", n.Sibling = "sibling", n.ColumnCombinator = "column-combinator";
})(et || (et = {}));
var xn;
(function(n) {
  n.Any = "any", n.Element = "element", n.End = "end", n.Equals = "equals", n.Exists = "exists", n.Hyphen = "hyphen", n.Not = "not", n.Start = "start";
})(xn || (xn = {}));
const S2 = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/, VO = /\\([\da-f]{1,6}\s?|(\s)|.)/gi, FO = /* @__PURE__ */ new Map([
  [126, xn.Element],
  [94, xn.Start],
  [36, xn.End],
  [42, xn.Any],
  [33, xn.Not],
  [124, xn.Hyphen]
]), jO = /* @__PURE__ */ new Set([
  "has",
  "not",
  "matches",
  "is",
  "where",
  "host",
  "host-context"
]);
function HO(n) {
  switch (n.type) {
    case et.Adjacent:
    case et.Child:
    case et.Descendant:
    case et.Parent:
    case et.Sibling:
    case et.ColumnCombinator:
      return !0;
    default:
      return !1;
  }
}
const UO = /* @__PURE__ */ new Set(["contains", "icontains"]);
function WO(n, e, t) {
  const r = parseInt(e, 16) - 65536;
  return r !== r || t ? e : r < 0 ? (
    // BMP codepoint
    String.fromCharCode(r + 65536)
  ) : (
    // Supplemental Plane codepoint (surrogate pair)
    String.fromCharCode(r >> 10 | 55296, r & 1023 | 56320)
  );
}
function Rs(n) {
  return n.replace(VO, WO);
}
function rd(n) {
  return n === 39 || n === 34;
}
function E2(n) {
  return n === 32 || n === 9 || n === 10 || n === 12 || n === 13;
}
function qO(n) {
  const e = [], t = r4(e, `${n}`, 0);
  if (t < n.length)
    throw new Error(`Unmatched selector: ${n.slice(t)}`);
  return e;
}
function r4(n, e, t) {
  let r = [];
  function i(f) {
    const p = e.slice(t + f).match(S2);
    if (!p)
      throw new Error(`Expected name, found ${e.slice(t)}`);
    const [h] = p;
    return t += f + h.length, Rs(h);
  }
  function s(f) {
    for (t += f; t < e.length && E2(e.charCodeAt(t)); )
      t++;
  }
  function o() {
    t += 1;
    const f = t;
    let p = 1;
    for (; p > 0 && t < e.length; t++)
      e.charCodeAt(t) === 40 && !a(t) ? p++ : e.charCodeAt(t) === 41 && !a(t) && p--;
    if (p)
      throw new Error("Parenthesis not matched");
    return Rs(e.slice(f, t - 1));
  }
  function a(f) {
    let p = 0;
    for (; e.charCodeAt(--f) === 92; )
      p++;
    return (p & 1) === 1;
  }
  function l() {
    if (r.length > 0 && HO(r[r.length - 1]))
      throw new Error("Did not expect successive traversals.");
  }
  function u(f) {
    if (r.length > 0 && r[r.length - 1].type === et.Descendant) {
      r[r.length - 1].type = f;
      return;
    }
    l(), r.push({ type: f });
  }
  function d(f, p) {
    r.push({
      type: et.Attribute,
      name: f,
      action: p,
      value: i(1),
      namespace: null,
      ignoreCase: "quirks"
    });
  }
  function c() {
    if (r.length && r[r.length - 1].type === et.Descendant && r.pop(), r.length === 0)
      throw new Error("Empty sub-selector");
    n.push(r);
  }
  if (s(0), e.length === t)
    return t;
  e: for (; t < e.length; ) {
    const f = e.charCodeAt(t);
    switch (f) {
      case 32:
      case 9:
      case 10:
      case 12:
      case 13: {
        (r.length === 0 || r[0].type !== et.Descendant) && (l(), r.push({ type: et.Descendant })), s(1);
        break;
      }
      case 62: {
        u(et.Child), s(1);
        break;
      }
      case 60: {
        u(et.Parent), s(1);
        break;
      }
      case 126: {
        u(et.Sibling), s(1);
        break;
      }
      case 43: {
        u(et.Adjacent), s(1);
        break;
      }
      case 46: {
        d("class", xn.Element);
        break;
      }
      case 35: {
        d("id", xn.Equals);
        break;
      }
      case 91: {
        s(1);
        let p, h = null;
        e.charCodeAt(t) === 124 ? p = i(1) : e.startsWith("*|", t) ? (h = "*", p = i(2)) : (p = i(0), e.charCodeAt(t) === 124 && e.charCodeAt(t + 1) !== 61 && (h = p, p = i(1))), s(0);
        let y = xn.Exists;
        const g = FO.get(e.charCodeAt(t));
        if (g) {
          if (y = g, e.charCodeAt(t + 1) !== 61)
            throw new Error("Expected `=`");
          s(2);
        } else e.charCodeAt(t) === 61 && (y = xn.Equals, s(1));
        let m = "", $ = null;
        if (y !== "exists") {
          if (rd(e.charCodeAt(t))) {
            const L = e.charCodeAt(t);
            let S = t + 1;
            for (; S < e.length && (e.charCodeAt(S) !== L || a(S)); )
              S += 1;
            if (e.charCodeAt(S) !== L)
              throw new Error("Attribute value didn't end");
            m = Rs(e.slice(t + 1, S)), t = S + 1;
          } else {
            const L = t;
            for (; t < e.length && (!E2(e.charCodeAt(t)) && e.charCodeAt(t) !== 93 || a(t)); )
              t += 1;
            m = Rs(e.slice(L, t));
          }
          s(0);
          const _ = e.charCodeAt(t) | 32;
          _ === 115 ? ($ = !1, s(1)) : _ === 105 && ($ = !0, s(1));
        }
        if (e.charCodeAt(t) !== 93)
          throw new Error("Attribute selector didn't terminate");
        t += 1;
        const w = {
          type: et.Attribute,
          name: p,
          action: y,
          value: m,
          namespace: h,
          ignoreCase: $
        };
        r.push(w);
        break;
      }
      case 58: {
        if (e.charCodeAt(t + 1) === 58) {
          r.push({
            type: et.PseudoElement,
            name: i(2).toLowerCase(),
            data: e.charCodeAt(t) === 40 ? o() : null
          });
          continue;
        }
        const p = i(1).toLowerCase();
        let h = null;
        if (e.charCodeAt(t) === 40)
          if (jO.has(p)) {
            if (rd(e.charCodeAt(t + 1)))
              throw new Error(`Pseudo-selector ${p} cannot be quoted`);
            if (h = [], t = r4(h, e, t + 1), e.charCodeAt(t) !== 41)
              throw new Error(`Missing closing parenthesis in :${p} (${e})`);
            t += 1;
          } else {
            if (h = o(), UO.has(p)) {
              const y = h.charCodeAt(0);
              y === h.charCodeAt(h.length - 1) && rd(y) && (h = h.slice(1, -1));
            }
            h = Rs(h);
          }
        r.push({ type: et.Pseudo, name: p, data: h });
        break;
      }
      case 44: {
        c(), r = [], s(1);
        break;
      }
      default: {
        if (e.startsWith("/*", t)) {
          const y = e.indexOf("*/", t + 2);
          if (y < 0)
            throw new Error("Comment was not terminated");
          t = y + 2, r.length === 0 && s(0);
          break;
        }
        let p = null, h;
        if (f === 42)
          t += 1, h = "*";
        else if (f === 124) {
          if (h = "", e.charCodeAt(t + 1) === 124) {
            u(et.ColumnCombinator), s(2);
            break;
          }
        } else if (S2.test(e.slice(t)))
          h = i(0);
        else
          break e;
        e.charCodeAt(t) === 124 && e.charCodeAt(t + 1) !== 124 && (p = h, e.charCodeAt(t + 1) === 42 ? (h = "*", t += 2) : h = i(1)), r.push(h === "*" ? { type: et.Universal, namespace: p } : { type: et.Tag, name: h, namespace: p });
      }
    }
  }
  return c(), t;
}
function Xd(n) {
  return n.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&apos;").replace(/"/g, "&quot;").replace(/\xA0/g, "&nbsp;").replace(/\xAD/g, "&shy;");
}
var T2 = (n) => zO(n);
function KO(n, e, t, r) {
  if (typeof e == "function")
    return e({
      props: { ...t, children: r },
      attrs: t,
      children: r,
      h: n.h,
      context: n
    });
  {
    let i = !0, s;
    if (e ? e.toLowerCase() === "fragment" ? (s = n.document.createDocumentFragment(), i = !1) : s = n.document.createElement(e) : s = n.document.createElement("div"), t && i) {
      const o = s;
      for (let [a, l] of Object.entries(t)) {
        a = a.toString();
        const u = a.toLowerCase();
        u === "classname" ? o.className = l : u === "on" ? Object.entries(l).forEach(([d, c]) => {
          o.setAttribute(`on${d}`, String(c));
        }) : l !== !1 && l != null && (l === !0 ? o.setAttribute(a, a) : o.setAttribute(a, l.toString()));
      }
    }
    if (r)
      for (const o of r) {
        const a = Array.isArray(o) ? [...o] : [o];
        for (const l of a)
          l && l !== !1 && l != null && (typeof l != "object" ? s.appendChild(
            n.document.createTextNode(l.toString())
          ) : s.appendChild(l));
      }
    return s;
  }
}
function i4(n, e, ...t) {
  return typeof n == "object" && (n = "fragment", t = n.children, e = n.attrs), Array.isArray(e) ? (t = [e], e = {}) : e ? e.attrs && (e = { ...e.attrs, ...e }, delete e.attrs) : e = {}, {
    tag: n,
    attrs: e,
    children: typeof t[0] == "string" ? t : t.flat(Number.POSITIVE_INFINITY)
  };
}
function GO(n) {
  return n.h = function(t, r, ...i) {
    const { tag: s, attrs: o, children: a } = i4(t, r, i);
    return KO(n, s, o, a);
  }, n.h;
}
var O2 = {};
function YO(n) {
  let e = O2[n];
  return e == null && (e = qO(n), O2[n] = e), e;
}
function JO(n, e, { debug: t = !1 } = {}) {
  for (const r of YO(n)) {
    const i = (s, o) => {
      var l, u, d, c;
      let a = !1;
      for (const f of o) {
        const { type: p, name: h, action: y, value: g, _ignoreCase: m = !0, data: $ } = f;
        if (p === "attribute")
          y === "equals" ? a = s.getAttribute(h) === g : y === "start" ? a = !!((l = s.getAttribute(h)) != null && l.startsWith(g)) : y === "end" ? a = !!((u = s.getAttribute(h)) != null && u.endsWith(g)) : y === "element" ? h === "class" ? a = s.classList.contains(g) : a = !!((d = s.getAttribute(h)) != null && d.includes(g)) : y === "exists" ? a = s.hasAttribute(h) : y === "any" ? a = !!((c = s.getAttribute(h)) != null && c.includes(g)) : console.warn("Unknown CSS selector action", y);
        else if (p === "tag")
          a = s.tagName === h.toUpperCase();
        else if (p === "universal")
          a = !0;
        else if (p === "pseudo") {
          if (h === "not") {
            let w = !0;
            $.forEach((_) => {
              i(s, _) || (w = !1);
            }), a = !w;
          }
        } else
          console.warn("Unknown CSS selector type", p, n, o);
        if (!a)
          break;
      }
      return a;
    };
    if (i(e, r))
      return !0;
  }
  return !1;
}
var ZO = Symbol.for("nodejs.util.inspect.custom"), M2 = { fontWeight: "bold" }, A2 = { fontStyle: "italic" }, N2 = { backgroundColor: "rgb(255, 250, 165)" }, D2 = { textDecorations: "underline" }, id = { textDecorations: "line-through" }, XO = {
  b: M2,
  strong: M2,
  em: A2,
  i: A2,
  mark: N2,
  u: D2,
  a: D2,
  s: id,
  del: id,
  ins: N2,
  strike: id
  // 'code': C,
  // 'tt': C
};
function L2(n) {
  return n.toLowerCase().replace(/[^a-z0-9]+(.)/gi, (e, t) => t.toUpperCase());
}
var gr = class ka {
  constructor() {
    this.append = this.appendChild, this._parentNode = null, this._childNodes = [];
  }
  get nodeType() {
    return console.error("Subclasses should define nodeType!"), 0;
  }
  get nodeName() {
    return console.error("Subclasses should define nodeName!"), "";
  }
  get nodeValue() {
    return null;
  }
  cloneNode(e = !1) {
    const t = new this.constructor();
    return e && (t._childNodes = this._childNodes.map((r) => r.cloneNode(!0)), t._fixChildNodesParent()), t;
  }
  _fixChildNodesParent() {
    this._childNodes.forEach((e) => e._parentNode = this);
  }
  insertBefore(e, t) {
    if (e !== t) {
      let r = t ? this._childNodes.indexOf(t) : 0;
      r < 0 && (r = 0), this._childNodes.splice(r, 0, e), this._fixChildNodesParent();
    }
  }
  appendChild(e) {
    if (e != null) {
      if (e === this) {
        console.warn("Cannot appendChild to self");
        return;
      }
      if (e instanceof b0 && console.warn("No defined how to append a document to a node!", e), e instanceof g0)
        for (const t of [...e._childNodes])
          this.appendChild(t);
      else if (Array.isArray(e))
        for (const t of [...e])
          this.appendChild(t);
      else if (e instanceof ka)
        e.remove(), this._childNodes.push(e);
      else
        try {
          const t = typeof e == "string" ? e : JSON.stringify(e, null, 2);
          this._childNodes.push(new Gi(t));
        } catch (t) {
          console.error(`The data ${e} to be added to ${this.render()} is problematic: ${t}`);
        }
      this._fixChildNodesParent();
    }
  }
  removeChild(e) {
    const t = this._childNodes.indexOf(e);
    t >= 0 && (e._parentNode = null, this._childNodes.splice(t, 1), this._fixChildNodesParent());
  }
  /** Remove node */
  remove() {
    var e;
    return (e = this == null ? void 0 : this.parentNode) == null || e.removeChild(this), this;
  }
  /** Replace content of node with text or nodes */
  replaceChildren(...e) {
    this._childNodes = e.map(
      (t) => typeof t == "string" ? new Gi(t) : t.remove()
    ), this._fixChildNodesParent();
  }
  /** Replace node itself with nodes */
  replaceWith(...e) {
    const t = this._parentNode;
    if (t) {
      const r = this._indexInParent();
      r >= 0 && (e = e.map(
        (i) => typeof i == "string" ? new Gi(i) : i.remove()
      ), t._childNodes.splice(r, 1, ...e), this._parentNode = null, t._fixChildNodesParent());
    }
  }
  _indexInParent() {
    return this._parentNode ? this._parentNode.childNodes.indexOf(this) : -1;
  }
  get parentNode() {
    return this._parentNode;
  }
  get childNodes() {
    return this._childNodes || [];
  }
  get children() {
    return this._childNodes || [];
  }
  get firstChild() {
    return this._childNodes[0];
  }
  get lastChild() {
    return this._childNodes[this._childNodes.length - 1];
  }
  get nextSibling() {
    const e = this._indexInParent();
    return e != null && this.parentNode.childNodes[e + 1] || null;
  }
  get previousSibling() {
    const e = this._indexInParent();
    return e > 0 && this.parentNode.childNodes[e - 1] || null;
  }
  flatten() {
    const e = [];
    this instanceof An && e.push(this);
    for (const t of this._childNodes)
      e.push(...t.flatten());
    return e;
  }
  flattenNodes() {
    const e = [];
    e.push(this);
    for (const t of this._childNodes)
      e.push(...t.flattenNodes());
    return e;
  }
  render() {
    return "";
  }
  get textContent() {
    return this._childNodes.map((e) => e.textContent).join("");
  }
  set textContent(e) {
    this._childNodes = [], e && this.appendChild(new Gi(e.toString()));
  }
  contains(e) {
    return e === this ? !0 : this._childNodes.some((t) => t.contains(e));
  }
  get ownerDocument() {
    var e;
    return this.nodeType === ka.DOCUMENT_NODE || this.nodeType === ka.DOCUMENT_FRAGMENT_NODE ? this : (e = this == null ? void 0 : this._parentNode) == null ? void 0 : e.ownerDocument;
  }
  toString() {
    return `${this.nodeName}`;
  }
  [ZO]() {
    return `${this.constructor.name} "${this.render()}"`;
  }
};
gr.ELEMENT_NODE = 1;
gr.TEXT_NODE = 3;
gr.CDATA_SECTION_NODE = 4;
gr.PROCESSING_INSTRUCTION_NODE = 7;
gr.COMMENT_NODE = 8;
gr.DOCUMENT_NODE = 9;
gr.DOCUMENT_TYPE_NODE = 10;
gr.DOCUMENT_FRAGMENT_NODE = 11;
var Kr = gr, Gi = class extends Kr {
  get nodeType() {
    return Kr.TEXT_NODE;
  }
  get nodeName() {
    return "#text";
  }
  get nodeValue() {
    return this._text || "";
  }
  get textContent() {
    return this.nodeValue;
  }
  constructor(n = "") {
    super(), this._text = n;
  }
  render() {
    var e;
    const n = (e = this.parentNode) == null ? void 0 : e.tagName;
    return n === "SCRIPT" || n === "STYLE" ? this._text : Xd(this._text);
  }
  cloneNode(n = !1) {
    const e = super.cloneNode(n);
    return e._text = this._text, e;
  }
}, s4 = class extends Kr {
  getElementById(n) {
    return this.flatten().find((e) => e._attributes.id === n);
  }
  getElementsByClassName(n) {
    return this.flatten().filter((e) => e.classList.contains(n));
  }
  matches(n) {
    return JO(n, this);
  }
  querySelectorAll(n) {
    return this.flatten().filter((e) => e.matches(n));
  }
  querySelector(n) {
    return this.flatten().find((e) => e.matches(n));
  }
  //
  parent(n) {
    var e;
    return this.matches(n) ? this : this.parentNode == null ? null : (e = this.parentNode) == null ? void 0 : e.parent(n);
  }
  handle(n, e) {
    let t = 0;
    for (const r of this.querySelectorAll(n))
      e(r, t++);
  }
}, An = class extends s4 {
  get nodeType() {
    return Kr.ELEMENT_NODE;
  }
  get nodeName() {
    return this._nodeName;
  }
  constructor(n = "div", e = {}) {
    super(), this._originalTagName = n, this._nodeName = (n || "").toUpperCase(), this._attributes = e || {};
  }
  cloneNode(n = !1) {
    const e = super.cloneNode(n);
    return e._originalTagName = this._originalTagName, e._nodeName = this._nodeName, e._attributes = Object.assign({}, this._attributes), e;
  }
  get attributes() {
    return Object.entries(this._attributes).map(([n, e]) => ({ name: n, value: e }));
  }
  get attributesObject() {
    return { ...this._attributes };
  }
  _findAttributeName(n) {
    const e = n.toLowerCase();
    return Object.keys(this._attributes).find(
      (t) => e === t.toLowerCase()
    ) || null;
  }
  setAttribute(n, e) {
    this.removeAttribute(n), this._attributes[n] = e, this._styles = void 0, this._dataset = void 0;
  }
  getAttribute(n) {
    const e = this._findAttributeName(n), t = e ? this._attributes[e] : null;
    return t == null ? null : typeof t == "string" ? t : "";
  }
  removeAttribute(n) {
    this._findAttributeName(String(n)) && delete this._attributes[n];
  }
  hasAttribute(n) {
    const e = this._findAttributeName(n);
    return e ? this._attributes[e] != null : !1;
  }
  /// See https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style
  get style() {
    if (this._styles == null) {
      const n = {};
      let e = 0;
      const t = this.getAttribute("style");
      if (t) {
        let r;
        const i = /\s*([\w-]+)\s*:\s*((url\(.*?\)[^;]*|[^;]+))/gi;
        for (; r = i.exec(t); ) {
          ++e;
          const s = r[1], o = r[2].trim();
          n[s] = o, n[L2(s)] = o;
        }
      }
      this._styles = {
        get length() {
          return e;
        },
        getPropertyValue(r) {
          return n[r];
        },
        ...XO[this.tagName.toLowerCase()],
        ...n
      };
    }
    return this._styles;
  }
  /// See https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dataset
  get dataset() {
    if (this._dataset == null) {
      const n = {};
      for (const [e, t] of Object.entries(this._attributes))
        e.startsWith("data-") && (n[e.slice(5)] = t, n[L2(e.slice(5))] = t);
      this._dataset = n;
    }
    return this._dataset;
  }
  get tagName() {
    return this._nodeName;
  }
  /** Private function to easily change the tagName */
  setTagName(n) {
    this._nodeName = n.toUpperCase();
  }
  get id() {
    return this._attributes.id || null;
  }
  set id(n) {
    n == null ? delete this._attributes.id : this._attributes.id = n;
  }
  get src() {
    return this._attributes.src;
  }
  set src(n) {
    n == null ? delete this._attributes.src : this._attributes.src = n;
  }
  //
  getElementsByTagName(n) {
    n = n.toUpperCase();
    const e = this.flatten();
    return n !== "*" ? e.filter((t) => t.tagName === n) : e;
  }
  // html
  setInnerHTML(n) {
  }
  get innerHTML() {
    return this._childNodes.map((n) => n.render(Wl)).join("");
  }
  set innerHTML(n) {
    this.setInnerHTML(n);
  }
  get outerHTML() {
    return this.render(vl);
  }
  // class
  get className() {
    return this._attributes.class || "";
  }
  set className(n) {
    Array.isArray(n) ? n = n.filter((e) => !!e).join(" ") : typeof n == "object" && (n = Object.entries(n).filter(([e, t]) => !!t).map(([e, t]) => e).join(" ")), this._attributes.class = n;
  }
  get classList() {
    const n = String(this.className ?? "").trim().split(/\s+/g) || [];
    return {
      contains(e) {
        return n.includes(e);
      },
      add: (e) => {
        n.includes(e) || (n.push(e), this.className = n);
      },
      remove: (e) => {
        const t = n.indexOf(e);
        t >= 0 && (n.splice(t, 1), this.className = n);
      }
    };
  }
  //
  render(n = vl) {
    return n(
      this._originalTagName || this.tagName,
      this._attributes,
      this._childNodes.map((e) => e.render(n)).join("")
      // children:string is not escaped again
    );
  }
}, o4 = class a4 extends Kr {
  get nodeName() {
    return super.nodeName;
  }
  get nodeValue() {
    return super.nodeValue;
  }
  get nodeType() {
    return a4.DOCUMENT_TYPE_NODE;
  }
  render() {
    return "<!DOCTYPE html>";
  }
}, g0 = class l4 extends s4 {
  get nodeType() {
    return Kr.DOCUMENT_FRAGMENT_NODE;
  }
  get nodeName() {
    return "#document-fragment";
  }
  render(e = vl) {
    return this._childNodes.map((t) => t.render(e) || []).join("");
  }
  get innerHTML() {
    return this._childNodes.map((e) => e.render(Wl)).join("");
  }
  createElement(e, t = {}) {
    return new An(e, t);
  }
  createDocumentFragment() {
    return new l4();
  }
  createTextNode(e) {
    return new Gi(e);
  }
}, b0 = class extends g0 {
  get nodeType() {
    return Kr.DOCUMENT_NODE;
  }
  get nodeName() {
    return "#document";
  }
  get documentElement() {
    return this.firstChild;
  }
  render(n = vl) {
    let e = super.render(n);
    return this.docType && (e = this.docType.render() + e), e;
  }
}, u4 = class extends b0 {
  constructor(n = !1) {
    if (super(), this.docType = new o4(), !n) {
      const e = new An("html"), t = new An("body"), r = new An("head"), i = new An("title");
      e.appendChild(r), r.appendChild(i), e.appendChild(t), this.appendChild(e);
    }
  }
  get body() {
    let n = this.querySelector("body");
    if (!n) {
      let e = this.querySelector("html");
      e || (e = new An("html"), this.appendChild(e)), n = new An("body"), e.appendChild(e);
    }
    return n;
  }
  get title() {
    var n;
    return ((n = this.querySelector("title")) == null ? void 0 : n.textContent) || "";
  }
  set title(n) {
    const e = this.querySelector("title");
    e && (e.textContent = n);
  }
  get head() {
    let n = this.querySelector("head");
    if (!n) {
      let e = this.querySelector("html");
      e || (e = new An("html"), this.appendChild(e)), n = new An("head"), e.insertBefore(e);
    }
    return n;
  }
};
function QO() {
  return new b0();
}
function eM() {
  return new u4();
}
var d4 = QO();
GO({ document: d4 });
var tM = {}, nM = tM.hasOwnProperty;
function c4(n, e) {
  return nM.call(n, e);
}
var f4 = [
  "area",
  "base",
  "br",
  "col",
  "embed",
  "hr",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr",
  "command"
];
function p4(n, e, t = {}, r) {
  const i = !(typeof r == "string" && r === "" || Array.isArray(r) && (r.length === 0 || r.length === 1 && r[0] === "") || r == null), s = [];
  if (e = e.replace(/__/g, ":"), e !== "noop" && e !== "") {
    e !== "cdata" ? s.push(`<${e}`) : s.push("<![CDATA[");
    for (let o in t)
      if (o && c4(t, o)) {
        const a = t[o];
        if (o === "html")
          continue;
        o.toLowerCase() === "classname" && (o = "class"), o = o.replace(/__/g, ":"), a === !0 ? s.push(` ${o}`) : o === "style" && typeof a == "object" ? s.push(
          ` ${o}="${Object.keys(a).filter((l) => a[l] != null).map((l) => {
            let u = a[l];
            return u = typeof u == "number" ? `${u}px` : u, `${l.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}:${u}`;
          }).join(";")}"`
        ) : a !== !1 && a != null && s.push(` ${o}="${Xd(a.toString())}"`);
      }
    if (e !== "cdata") {
      if (n && !i)
        return s.push(" />"), s.join("");
      s.push(">");
    }
    if (!n && f4.includes(e))
      return s.join("");
  }
  if (i) {
    if (typeof r == "string")
      s.push(r);
    else if (r && r.length > 0) {
      for (let o of r)
        if (o != null && o !== !1) {
          Array.isArray(o) || (o = [o]);
          for (const a of o)
            a.startsWith("<") && a.endsWith(">") || e === "script" || e === "style" ? s.push(a) : s.push(Xd(a.toString()));
        }
    }
  }
  return t.html && s.push(t.html), e !== "noop" && e !== "" && (e !== "cdata" ? s.push(`</${e}>`) : s.push("]]>")), s.join("");
}
function Wl(n, e, ...t) {
  const { tag: r, attrs: i, children: s } = i4(n, e, t);
  return p4(!1, r, i, s);
}
var vl = p4.bind(null, !1);
Wl.firstLine = "<!DOCTYPE html>";
Wl.html = !0;
var rM = /([^=\s]+)(\s*=\s*(("([^"]*)")|('([^']*)')|[^>\s]+))?/g, iM = /^<\/([^>\s]+)[^>]*>/m, sM = /^<([^>\s/]+)((\s+[^=>\s]+(\s*=\s*(("[^"]*")|('[^']*')|[^>\s]+))?)*)\s*(?:\/\s*)?>/m, oM = /\s*\/\s*>\s*$/m, aM = class {
  constructor(n = {}) {
    this.attrRe = rM, this.endTagRe = iM, this.startTagRe = sM, this.defaults = { ignoreWhitespaceText: !1 }, n.scanner && (this.scanner = n.scanner), this.options = Object.assign({}, this.defaults, n);
  }
  parse(n) {
    let e = !1, t, r, i;
    for (; n.length; ) {
      if (n.substring(0, 4) === "<!--")
        t = n.indexOf("-->"), t !== -1 ? (this.scanner.comment(n.substring(4, t)), n = n.substring(t + 3), e = !1) : e = !0;
      else if (n.substring(0, 2) === "</")
        r = this.endTagRe.exec(n), r ? (n = RegExp.rightContext, e = !1, this.parseEndTag(RegExp.lastMatch, r[1])) : e = !0;
      else if (n.charAt(0) === "<")
        if (r = this.startTagRe.exec(n), r) {
          n = RegExp.rightContext, e = !1;
          const s = this.parseStartTag(RegExp.lastMatch, r[1], r);
          (s === "script" || s === "style") && (t = n.search(new RegExp(`</${s}`, "i")), t !== -1 ? (this.scanner.characters(n.substring(0, t)), n = n.substring(t), e = !1) : e = !0);
        } else
          e = !0;
      if (e) {
        t = n.indexOf("<");
        let s = t;
        t === 0 && (t = n.substring(1).indexOf("<"), s = s + 1), t === -1 ? (i = n, n = "") : (i = n.substring(0, s), n = n.substring(s)), (!this.options.ignoreWhitespaceText || !/^\s*$/.test(i)) && this.scanner.characters(i);
      }
      e = !0, r = null;
    }
  }
  parseStartTag(n, e, t) {
    const r = oM.test(n);
    let i = t[2];
    r && (i = i.replace(/\s*\/\s*$/, ""));
    const s = this.parseAttributes(e, i);
    return this.scanner.startElement(e, s, r, t[0]), e.toLocaleLowerCase();
  }
  parseEndTag(n, e) {
    this.scanner.endElement(e);
  }
  parseAttributes(n, e) {
    const t = {};
    return e.replace(this.attrRe, (...r) => {
      const [i, s, o, a, l, u, d, c] = r;
      t[s] = c ?? u ?? a ?? !0;
    }), t;
  }
};
function lM(n) {
  if (typeof n != "string")
    throw console.error("parseHTML requires string, found", n), new Error("parseHTML requires string");
  const e = n.indexOf("<!") === 0 ? new u4(!0) : new g0(), t = [e];
  return new aM({
    // the for methods must be implemented yourself
    scanner: {
      startElement(i, s, o) {
        if (i.toLowerCase() === "!doctype") {
          e.docType = new o4();
          return;
        }
        for (const u in s)
          if (c4(s, u)) {
            const d = s[u];
            typeof d == "string" && (s[u] = T2(d));
          }
        const l = t[t.length - 1];
        if (l) {
          const u = d4.createElement(i, s);
          l.appendChild(u), f4.includes(i.toLowerCase()) || o || t.push(u);
        }
      },
      endElement(i) {
        t.pop();
      },
      characters(i) {
        var o;
        i = T2(i);
        const s = t[t.length - 1];
        ((o = s == null ? void 0 : s.lastChild) == null ? void 0 : o.nodeType) === Kr.TEXT_NODE ? s.lastChild._text += i : s && s.appendChild(new Gi(i));
      },
      comment(i) {
      }
    }
  }).parse(n), e;
}
An.prototype.setInnerHTML = function(n) {
  const e = lM(n);
  this._childNodes = e._childNodes, this._fixChildNodesParent();
};
function uM(n, e, t) {
  return Gr.fromSchema(e).serializeFragment(n.content, {
    document: eM()
  }).render();
}
function dM(n, e) {
  const t = l3(e), r = Kn.fromJSON(t, n);
  return uM(r, t);
}
const cM = ["innerHTML"], Ln = /* @__PURE__ */ X({
  __name: "CfgRichRenderer",
  props: {
    content: {}
  },
  setup(n) {
    const e = ae();
    return Ie(
      () => n.content,
      () => {
        e.value = dM(n.content, wa);
      },
      { immediate: !0 }
    ), (t, r) => (k(), T("div", {
      class: "format",
      innerHTML: e.value
    }, null, 8, cM));
  }
}), fM = {
  ...Wt,
  ..._1,
  observerSlotEvents: {
    type: Object,
    required: !0
  }
}, LA = /* @__PURE__ */ X({
  __name: "CfgValidatedField",
  props: /* @__PURE__ */ Ae(fM, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = n, t = je(n, "modelValue"), r = Z(() => pr(e, Object.keys(Wt))), i = Z(() => pr(e, Object.keys(_1)));
    return (s, o) => (k(), q(up, Te({
      modelValue: t.value,
      "onUpdate:modelValue": o[0] || (o[0] = (a) => t.value = a),
      required: r.value.required,
      validators: i.value.validators
    }, oo(s.observerSlotEvents || {})), {
      default: N(({ on: a, attrs: l }) => [
        A(pn, Te({ ...s.$attrs, ...r.value, ...l }, {
          "model-value": l.modelValue
        }, oo(a)), {
          icon: N(() => [
            te(s.$slots, "icon")
          ]),
          _: 2
        }, 1040, ["model-value"])
      ]),
      _: 3
    }, 16, ["modelValue", "required", "validators"]));
  }
});
function RA(n) {
  const e = {
    color: "#FFFFFF4D",
    duration: 900,
    ...n
  };
  return {
    mounted(t, r) {
      var a, l, u, d, c, f;
      const i = {
        color: ((a = r.value) == null ? void 0 : a.color) || e.color,
        duration: ((l = r.value) == null ? void 0 : l.duration) || e.duration,
        scale: {
          x: ((d = (u = r.value) == null ? void 0 : u.scale) == null ? void 0 : d.x) || 1,
          y: ((f = (c = r.value) == null ? void 0 : c.scale) == null ? void 0 : f.y) || 1
        }
      };
      if (typeof window > "u")
        return;
      ["static", "fixed", "absolute", "relative", "sticky"].some((p) => t.classList.contains(p)) || t.classList.add("relative");
      const o = r.dir;
      o.handleOnClick = (p) => {
        const h = document.createElement("div");
        h.style.position = "absolute", h.style.top = "50%", h.style.left = "50%", h.style.width = "100%", h.style.height = "100%", h.style.overflow = "hidden", h.style.pointerEvents = "none", h.style.zIndex = "0", h.style.transform = `translate(-50%, -50%) scale(${i.scale.x}, ${i.scale.y})`, t.classList.forEach((_) => {
          /^rounded(?:-[trbl]{1,2})?(?:-[a-z]+)?$/.test(_) && h.classList.add(_);
        }), t.appendChild(h);
        const y = t.getBoundingClientRect(), g = Math.max(y.width, y.height), m = p.clientX - y.left - g / 2, $ = p.clientY - y.top - g / 2, w = document.createElement("span");
        w.className = "ripple-animation rounded-full pointer-events-none opacity-30", w.style.position = "absolute", w.style.width = `${g}px`, w.style.height = `${g}px`, w.style.top = `${$}px`, w.style.left = `${m}px`, w.style.backgroundColor = i.color, w.style.animationDuration = `${i.duration}ms`, w.style.transform = "scale(0)", h.appendChild(w), setTimeout(() => {
          h.contains(w) && (h.removeChild(w), t.removeChild(h));
        }, i.duration);
      }, t.addEventListener("click", o.handleOnClick);
    },
    unmounted(t, r) {
      if (typeof window > "u")
        return;
      const i = r.dir;
      t.removeEventListener("click", i.handleOnClick);
    }
  };
}
export {
  _A as $,
  pp as A,
  nA as B,
  Bi as C,
  rA as D,
  Nb as E,
  Bb as F,
  Wb as G,
  iA as H,
  sA as I,
  oA as J,
  aA as K,
  lA as L,
  uA as M,
  dA as N,
  Ay as O,
  Py as P,
  cA as Q,
  fA as R,
  pA as S,
  hA as T,
  mA as U,
  gA as V,
  bA as W,
  by as X,
  yA as Y,
  vA as Z,
  LM as _,
  RM as a,
  $A as a0,
  xA as a1,
  Xi as a2,
  wA as a3,
  AA as a4,
  DA as a5,
  Ln as a6,
  LA as a7,
  tA as a8,
  ri as a9,
  ap as aA,
  AM as aB,
  NM as aC,
  xm as aD,
  K as aE,
  G as aF,
  kt as aG,
  v1 as aH,
  RA as aI,
  DM as aJ,
  p8 as aK,
  up as aL,
  Sg as aM,
  v7 as aN,
  QM as aO,
  Lo as aP,
  w1 as aQ,
  eA as aR,
  Qe as aS,
  g7 as aT,
  fp as aU,
  Qt as aV,
  wa as aW,
  ST as aX,
  Di as aa,
  $b as ab,
  xb as ac,
  wM as ad,
  kM as ae,
  Pt as af,
  CM as ag,
  hr as ah,
  W5 as ai,
  SM as aj,
  EM as ak,
  Ta as al,
  un as am,
  y1 as an,
  Q6 as ao,
  J2 as ap,
  ec as aq,
  $m as ar,
  TM as as,
  OM as at,
  pn as au,
  MM as av,
  qm as aw,
  No as ax,
  Qm as ay,
  t8 as az,
  PM as b,
  IM as c,
  BM as d,
  dp as e,
  Zi as f,
  zM as g,
  VM as h,
  x1 as i,
  FM as j,
  jM as k,
  HM as l,
  UM as m,
  WM as n,
  at as o,
  o7 as p,
  dn as q,
  qM as r,
  KM as s,
  GM as t,
  YM as u,
  JM as v,
  M7 as w,
  ZM as x,
  I7 as y,
  XM as z
};
